/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		16: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + ({"0":"land","1":"singlechat","2":"ims","3":"giftmain","4":"friendapply","5":"friendlist","6":"project","7":"im-common-module","8":"profile","9":"earnings","10":"leaderboard","11":"blockchain","12":"giftshow","13":"login","14":"wallet","15":"photo-edit"}[chunkId]||chunkId) + "." + {"0":"68485","1":"02187","2":"07082","3":"4cbf7","4":"ca558","5":"6d207","6":"6a12c","7":"4c048","8":"b435d","9":"e1a79","10":"a9521","11":"aa78b","12":"90c54","13":"9d033","14":"4630b","15":"623cc"}[chunkId] + ".chunk.js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "//h.cdn.pengpengla.com/up/ugift2/1.6.0/assets/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 141);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(55);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports) {



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var url = {
    scope: 'search',
    paramReg: /^(?:([A-Za-z]+):(\/{0,3}))?([0-9.\-A-Za-z]+\.[0-9A-Za-z]+)?(?::(\d+))?(?:\/([^?#]*))?(?:\?([^#]*))?(?:#(.*))?$/,

    names: ['url', 'scheme', 'slash', 'host', 'port', 'path', 'query', 'hash'],

    query: function query(name, scope) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"),
            scope = scope || this.scope,
            r = location[scope].substr(1).match(reg);
        if (r != null) {
            return decodeURIComponent(r[2]);
        }
        return null;
    },

    addParam: function addParam(url, data) {
        if (typeof data === 'undefined') {
            return;
        }

        var hashReg = /#.*$/gi,
            hashMatch = url.match(hashReg),
            hash = '';

        if (hashMatch) {
            hash = hashMatch[0];
        }

        // 去除hash值的url
        var preUrl = url.replace(hash, '');

        var searchReg = /\?(.*?)$/gi;
        var result = searchReg.exec(preUrl);
        var query, newUrl;
        if (result) {
            query = result[1].split('#')[0];
        }

        var id = !query ? '' : '&';

        return preUrl + (query && query.length > 0 ? '' : '?') + (id + $.param(data)) + hash;
    },

    delQuery: function delQuery(url, key) {
        var path = '',
            param = '',
            hash = '';
        if (url.indexOf('?') == -1) {
            path = url;
        } else {
            path = url.substr(0, url.indexOf('?'));
            param = url.substr(url.indexOf('?') + 1);
            if (param.indexOf('#') != -1) {
                hash = param.substr(param.indexOf('#') + 1);
                param = param.substr(0, param.indexOf('#'));
            }
        }
        var params = param.split('&');
        for (var i = params.length - 1; i >= 0; i--) {
            if (params[i].indexOf(key + '=') > -1) {
                params.splice(i, 1);
                break;
            }
        }

        return path + (params.join('&') ? '?' + params.join('&') : '') + (hash ? '#' + hash : '');
    },
    /**
     * 将URL query的字符串解析成对象
     */
    parseQuery: function parseQuery(query) {
        var ret = {},
            qs,
            q,
            _qs;
        if ((typeof query === 'undefined' ? 'undefined' : _typeof(query)) == 'object') {
            for (var p in query) {
                if (query.hasOwnProperty(p) && query[p] !== null) {
                    ret[p] = query[p];
                }
            }
        } else {
            qs = query.split('&');
            for (var i = 0; i < qs.length; i++) {
                if ((q = qs[i]) && (_qs = q.split('=')) && _qs[0]) {
                    ret[_qs[0]] = _qs[1] ? decodeURIComponent(_qs[1]) : '';
                }
            }
        }

        return ret;
    },
    /**
     * 将URL解析为对象
     * @name parse
     * @return {
     *      url: '',
     *      hash: '',
     *      query: '',
     *      host: ''
     *      ...
     * }
     */
    parse: function parse(url) {
        var results = this.paramReg.exec(url),
            names = this.names,
            ret = {},
            key;

        for (var i = 0, len = names.length; i < len; i += 1) {
            key = names[i];
            ret[key] = (key == 'path' ? '/' : '') + (results[i] || '');
        }

        return ret;
    },
    /**
     * 将对象解析为URL字符串
     */
    stringify: function stringify(data) {
        var ret = '';
        var names = this.names;
        for (var i = 1; i < names.length; i++) {
            var key = names[i],
                value = data[key];
            if (typeof value != 'undefined') {
                ret += function (key, value) {
                    if (key == 'scheme') {
                        return value + ':';
                    }
                    if (key == 'port') {
                        return value ? ':' + value : '';
                    }
                    if (key == 'host') {
                        return value;
                    }

                    if (key == 'query') {
                        return value ? '?' + value : '';
                    }
                    if (key == 'hash') {
                        return value ? '#' + value : '';
                    }

                    return value;
                }(key, value);
            }
        }
        return ret;
    }
};

module.exports = url;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(146)();
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(59)('wks');
var uid = __webpack_require__(45);
var Symbol = __webpack_require__(9).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["default"] = _;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VERSION", function() { return VERSION; });
/* harmony export (immutable) */ __webpack_exports__["iteratee"] = iteratee;
/* harmony export (immutable) */ __webpack_exports__["restArguments"] = restArguments;
/* harmony export (immutable) */ __webpack_exports__["each"] = each;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "forEach", function() { return each; });
/* harmony export (immutable) */ __webpack_exports__["map"] = map;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "collect", function() { return map; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reduce", function() { return reduce; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "foldl", function() { return reduce; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "inject", function() { return reduce; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reduceRight", function() { return reduceRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "foldr", function() { return reduceRight; });
/* harmony export (immutable) */ __webpack_exports__["find"] = find;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "detect", function() { return find; });
/* harmony export (immutable) */ __webpack_exports__["filter"] = filter;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "select", function() { return filter; });
/* harmony export (immutable) */ __webpack_exports__["reject"] = reject;
/* harmony export (immutable) */ __webpack_exports__["every"] = every;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "all", function() { return every; });
/* harmony export (immutable) */ __webpack_exports__["some"] = some;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "any", function() { return some; });
/* harmony export (immutable) */ __webpack_exports__["contains"] = contains;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "includes", function() { return contains; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "include", function() { return contains; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "invoke", function() { return invoke; });
/* harmony export (immutable) */ __webpack_exports__["pluck"] = pluck;
/* harmony export (immutable) */ __webpack_exports__["where"] = where;
/* harmony export (immutable) */ __webpack_exports__["findWhere"] = findWhere;
/* harmony export (immutable) */ __webpack_exports__["max"] = max;
/* harmony export (immutable) */ __webpack_exports__["min"] = min;
/* harmony export (immutable) */ __webpack_exports__["shuffle"] = shuffle;
/* harmony export (immutable) */ __webpack_exports__["sample"] = sample;
/* harmony export (immutable) */ __webpack_exports__["sortBy"] = sortBy;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "groupBy", function() { return groupBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "indexBy", function() { return indexBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "countBy", function() { return countBy; });
/* harmony export (immutable) */ __webpack_exports__["toArray"] = toArray;
/* harmony export (immutable) */ __webpack_exports__["size"] = size;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "partition", function() { return partition; });
/* harmony export (immutable) */ __webpack_exports__["first"] = first;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "head", function() { return first; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "take", function() { return first; });
/* harmony export (immutable) */ __webpack_exports__["initial"] = initial;
/* harmony export (immutable) */ __webpack_exports__["last"] = last;
/* harmony export (immutable) */ __webpack_exports__["rest"] = rest;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tail", function() { return rest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "drop", function() { return rest; });
/* harmony export (immutable) */ __webpack_exports__["compact"] = compact;
/* harmony export (immutable) */ __webpack_exports__["flatten"] = flatten;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "without", function() { return without; });
/* harmony export (immutable) */ __webpack_exports__["uniq"] = uniq;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unique", function() { return uniq; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "union", function() { return union; });
/* harmony export (immutable) */ __webpack_exports__["intersection"] = intersection;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "difference", function() { return difference; });
/* harmony export (immutable) */ __webpack_exports__["unzip"] = unzip;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "zip", function() { return zip; });
/* harmony export (immutable) */ __webpack_exports__["object"] = object;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findIndex", function() { return findIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findLastIndex", function() { return findLastIndex; });
/* harmony export (immutable) */ __webpack_exports__["sortedIndex"] = sortedIndex;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "indexOf", function() { return indexOf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lastIndexOf", function() { return lastIndexOf; });
/* harmony export (immutable) */ __webpack_exports__["range"] = range;
/* harmony export (immutable) */ __webpack_exports__["chunk"] = chunk;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bind", function() { return bind; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "partial", function() { return partial; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bindAll", function() { return bindAll; });
/* harmony export (immutable) */ __webpack_exports__["memoize"] = memoize;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "delay", function() { return delay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defer", function() { return defer; });
/* harmony export (immutable) */ __webpack_exports__["throttle"] = throttle;
/* harmony export (immutable) */ __webpack_exports__["debounce"] = debounce;
/* harmony export (immutable) */ __webpack_exports__["wrap"] = wrap;
/* harmony export (immutable) */ __webpack_exports__["negate"] = negate;
/* harmony export (immutable) */ __webpack_exports__["compose"] = compose;
/* harmony export (immutable) */ __webpack_exports__["after"] = after;
/* harmony export (immutable) */ __webpack_exports__["before"] = before;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "once", function() { return once; });
/* harmony export (immutable) */ __webpack_exports__["keys"] = keys;
/* harmony export (immutable) */ __webpack_exports__["allKeys"] = allKeys;
/* harmony export (immutable) */ __webpack_exports__["values"] = values;
/* harmony export (immutable) */ __webpack_exports__["mapObject"] = mapObject;
/* harmony export (immutable) */ __webpack_exports__["pairs"] = pairs;
/* harmony export (immutable) */ __webpack_exports__["invert"] = invert;
/* harmony export (immutable) */ __webpack_exports__["functions"] = functions;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "methods", function() { return functions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "extend", function() { return extend; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "extendOwn", function() { return extendOwn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "assign", function() { return extendOwn; });
/* harmony export (immutable) */ __webpack_exports__["findKey"] = findKey;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pick", function() { return pick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "omit", function() { return omit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaults", function() { return defaults; });
/* harmony export (immutable) */ __webpack_exports__["create"] = create;
/* harmony export (immutable) */ __webpack_exports__["clone"] = clone;
/* harmony export (immutable) */ __webpack_exports__["tap"] = tap;
/* harmony export (immutable) */ __webpack_exports__["isMatch"] = isMatch;
/* harmony export (immutable) */ __webpack_exports__["isEqual"] = isEqual;
/* harmony export (immutable) */ __webpack_exports__["isEmpty"] = isEmpty;
/* harmony export (immutable) */ __webpack_exports__["isElement"] = isElement;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isArray", function() { return isArray; });
/* harmony export (immutable) */ __webpack_exports__["isObject"] = isObject;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isArguments", function() { return isArguments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isFunction", function() { return isFunction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isString", function() { return isString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isNumber", function() { return isNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isDate", function() { return isDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isRegExp", function() { return isRegExp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isError", function() { return isError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isSymbol", function() { return isSymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isMap", function() { return isMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isWeakMap", function() { return isWeakMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isSet", function() { return isSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isWeakSet", function() { return isWeakSet; });
/* harmony export (immutable) */ __webpack_exports__["isFinite"] = isFinite;
/* harmony export (immutable) */ __webpack_exports__["isNaN"] = isNaN;
/* harmony export (immutable) */ __webpack_exports__["isBoolean"] = isBoolean;
/* harmony export (immutable) */ __webpack_exports__["isNull"] = isNull;
/* harmony export (immutable) */ __webpack_exports__["isUndefined"] = isUndefined;
/* harmony export (immutable) */ __webpack_exports__["has"] = has;
/* harmony export (immutable) */ __webpack_exports__["identity"] = identity;
/* harmony export (immutable) */ __webpack_exports__["constant"] = constant;
/* harmony export (immutable) */ __webpack_exports__["noop"] = noop;
/* harmony export (immutable) */ __webpack_exports__["property"] = property;
/* harmony export (immutable) */ __webpack_exports__["propertyOf"] = propertyOf;
/* harmony export (immutable) */ __webpack_exports__["matcher"] = matcher;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "matches", function() { return matcher; });
/* harmony export (immutable) */ __webpack_exports__["times"] = times;
/* harmony export (immutable) */ __webpack_exports__["random"] = random;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "now", function() { return now; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "escape", function() { return escape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unescape", function() { return unescape; });
/* harmony export (immutable) */ __webpack_exports__["result"] = result;
/* harmony export (immutable) */ __webpack_exports__["uniqueId"] = uniqueId;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "templateSettings", function() { return templateSettings; });
/* harmony export (immutable) */ __webpack_exports__["template"] = template;
/* harmony export (immutable) */ __webpack_exports__["chain"] = chain;
/* harmony export (immutable) */ __webpack_exports__["mixin"] = mixin;
//     Underscore.js 1.10.2
//     https://underscorejs.org
//     (c) 2009-2020 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

// Baseline setup
// --------------

// Establish the root object, `window` (`self`) in the browser, `global`
// on the server, or `this` in some virtual machines. We use `self`
// instead of `window` for `WebWorker` support.
var root = typeof self == 'object' && self.self === self && self ||
          typeof global == 'object' && global.global === global && global ||
          Function('return this')() ||
          {};

// Save bytes in the minified (but not gzipped) version:
var ArrayProto = Array.prototype, ObjProto = Object.prototype;
var SymbolProto = typeof Symbol !== 'undefined' ? Symbol.prototype : null;

// Create quick reference variables for speed access to core prototypes.
var push = ArrayProto.push,
    slice = ArrayProto.slice,
    toString = ObjProto.toString,
    hasOwnProperty = ObjProto.hasOwnProperty;

// All **ECMAScript 5** native function implementations that we hope to use
// are declared here.
var nativeIsArray = Array.isArray,
    nativeKeys = Object.keys,
    nativeCreate = Object.create;

// Create references to these builtin functions because we override them.
var _isNaN = root.isNaN,
    _isFinite = root.isFinite;

// Naked function reference for surrogate-prototype-swapping.
var Ctor = function(){};

// The Underscore object. All exported functions below are added to it in the
// modules/index-all.js using the mixin function.
function _(obj) {
  if (obj instanceof _) return obj;
  if (!(this instanceof _)) return new _(obj);
  this._wrapped = obj;
}

// Current version.
var VERSION = _.VERSION = '1.10.2';

// Internal function that returns an efficient (for current engines) version
// of the passed-in callback, to be repeatedly applied in other Underscore
// functions.
function optimizeCb(func, context, argCount) {
  if (context === void 0) return func;
  switch (argCount == null ? 3 : argCount) {
    case 1: return function(value) {
      return func.call(context, value);
    };
    // The 2-argument case is omitted because we’re not using it.
    case 3: return function(value, index, collection) {
      return func.call(context, value, index, collection);
    };
    case 4: return function(accumulator, value, index, collection) {
      return func.call(context, accumulator, value, index, collection);
    };
  }
  return function() {
    return func.apply(context, arguments);
  };
}

// An internal function to generate callbacks that can be applied to each
// element in a collection, returning the desired result — either `identity`,
// an arbitrary callback, a property matcher, or a property accessor.
function baseIteratee(value, context, argCount) {
  if (value == null) return identity;
  if (isFunction(value)) return optimizeCb(value, context, argCount);
  if (isObject(value) && !isArray(value)) return matcher(value);
  return property(value);
}

// External wrapper for our callback generator. Users may customize
// `_.iteratee` if they want additional predicate/iteratee shorthand styles.
// This abstraction hides the internal-only argCount argument.
_.iteratee = iteratee;
function iteratee(value, context) {
  return baseIteratee(value, context, Infinity);
}

// The function we actually call internally. It invokes _.iteratee if
// overridden, otherwise baseIteratee.
function cb(value, context, argCount) {
  if (_.iteratee !== iteratee) return _.iteratee(value, context);
  return baseIteratee(value, context, argCount);
}

// Some functions take a variable number of arguments, or a few expected
// arguments at the beginning and then a variable number of values to operate
// on. This helper accumulates all remaining arguments past the function’s
// argument length (or an explicit `startIndex`), into an array that becomes
// the last argument. Similar to ES6’s "rest parameter".
function restArguments(func, startIndex) {
  startIndex = startIndex == null ? func.length - 1 : +startIndex;
  return function() {
    var length = Math.max(arguments.length - startIndex, 0),
        rest = Array(length),
        index = 0;
    for (; index < length; index++) {
      rest[index] = arguments[index + startIndex];
    }
    switch (startIndex) {
      case 0: return func.call(this, rest);
      case 1: return func.call(this, arguments[0], rest);
      case 2: return func.call(this, arguments[0], arguments[1], rest);
    }
    var args = Array(startIndex + 1);
    for (index = 0; index < startIndex; index++) {
      args[index] = arguments[index];
    }
    args[startIndex] = rest;
    return func.apply(this, args);
  };
}

// An internal function for creating a new object that inherits from another.
function baseCreate(prototype) {
  if (!isObject(prototype)) return {};
  if (nativeCreate) return nativeCreate(prototype);
  Ctor.prototype = prototype;
  var result = new Ctor;
  Ctor.prototype = null;
  return result;
}

function shallowProperty(key) {
  return function(obj) {
    return obj == null ? void 0 : obj[key];
  };
}

function _has(obj, path) {
  return obj != null && hasOwnProperty.call(obj, path);
}

function deepGet(obj, path) {
  var length = path.length;
  for (var i = 0; i < length; i++) {
    if (obj == null) return void 0;
    obj = obj[path[i]];
  }
  return length ? obj : void 0;
}

// Helper for collection methods to determine whether a collection
// should be iterated as an array or as an object.
// Related: https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
// Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
var getLength = shallowProperty('length');
function isArrayLike(collection) {
  var length = getLength(collection);
  return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
}

// Collection Functions
// --------------------

// The cornerstone, an `each` implementation, aka `forEach`.
// Handles raw objects in addition to array-likes. Treats all
// sparse array-likes as if they were dense.
function each(obj, iteratee, context) {
  iteratee = optimizeCb(iteratee, context);
  var i, length;
  if (isArrayLike(obj)) {
    for (i = 0, length = obj.length; i < length; i++) {
      iteratee(obj[i], i, obj);
    }
  } else {
    var _keys = keys(obj);
    for (i = 0, length = _keys.length; i < length; i++) {
      iteratee(obj[_keys[i]], _keys[i], obj);
    }
  }
  return obj;
}


// Return the results of applying the iteratee to each element.
function map(obj, iteratee, context) {
  iteratee = cb(iteratee, context);
  var _keys = !isArrayLike(obj) && keys(obj),
      length = (_keys || obj).length,
      results = Array(length);
  for (var index = 0; index < length; index++) {
    var currentKey = _keys ? _keys[index] : index;
    results[index] = iteratee(obj[currentKey], currentKey, obj);
  }
  return results;
}


// Create a reducing function iterating left or right.
function createReduce(dir) {
  // Wrap code that reassigns argument variables in a separate function than
  // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
  var reducer = function(obj, iteratee, memo, initial) {
    var _keys = !isArrayLike(obj) && keys(obj),
        length = (_keys || obj).length,
        index = dir > 0 ? 0 : length - 1;
    if (!initial) {
      memo = obj[_keys ? _keys[index] : index];
      index += dir;
    }
    for (; index >= 0 && index < length; index += dir) {
      var currentKey = _keys ? _keys[index] : index;
      memo = iteratee(memo, obj[currentKey], currentKey, obj);
    }
    return memo;
  };

  return function(obj, iteratee, memo, context) {
    var initial = arguments.length >= 3;
    return reducer(obj, optimizeCb(iteratee, context, 4), memo, initial);
  };
}

// **Reduce** builds up a single result from a list of values, aka `inject`,
// or `foldl`.
var reduce = createReduce(1);


// The right-associative version of reduce, also known as `foldr`.
var reduceRight = createReduce(-1);


// Return the first value which passes a truth test.
function find(obj, predicate, context) {
  var keyFinder = isArrayLike(obj) ? findIndex : findKey;
  var key = keyFinder(obj, predicate, context);
  if (key !== void 0 && key !== -1) return obj[key];
}


// Return all the elements that pass a truth test.
function filter(obj, predicate, context) {
  var results = [];
  predicate = cb(predicate, context);
  each(obj, function(value, index, list) {
    if (predicate(value, index, list)) results.push(value);
  });
  return results;
}


// Return all the elements for which a truth test fails.
function reject(obj, predicate, context) {
  return filter(obj, negate(cb(predicate)), context);
}

// Determine whether all of the elements match a truth test.
function every(obj, predicate, context) {
  predicate = cb(predicate, context);
  var _keys = !isArrayLike(obj) && keys(obj),
      length = (_keys || obj).length;
  for (var index = 0; index < length; index++) {
    var currentKey = _keys ? _keys[index] : index;
    if (!predicate(obj[currentKey], currentKey, obj)) return false;
  }
  return true;
}


// Determine if at least one element in the object matches a truth test.
function some(obj, predicate, context) {
  predicate = cb(predicate, context);
  var _keys = !isArrayLike(obj) && keys(obj),
      length = (_keys || obj).length;
  for (var index = 0; index < length; index++) {
    var currentKey = _keys ? _keys[index] : index;
    if (predicate(obj[currentKey], currentKey, obj)) return true;
  }
  return false;
}


// Determine if the array or object contains a given item (using `===`).
function contains(obj, item, fromIndex, guard) {
  if (!isArrayLike(obj)) obj = values(obj);
  if (typeof fromIndex != 'number' || guard) fromIndex = 0;
  return indexOf(obj, item, fromIndex) >= 0;
}


// Invoke a method (with arguments) on every item in a collection.
var invoke = restArguments(function(obj, path, args) {
  var contextPath, func;
  if (isFunction(path)) {
    func = path;
  } else if (isArray(path)) {
    contextPath = path.slice(0, -1);
    path = path[path.length - 1];
  }
  return map(obj, function(context) {
    var method = func;
    if (!method) {
      if (contextPath && contextPath.length) {
        context = deepGet(context, contextPath);
      }
      if (context == null) return void 0;
      method = context[path];
    }
    return method == null ? method : method.apply(context, args);
  });
});

// Convenience version of a common use case of `map`: fetching a property.
function pluck(obj, key) {
  return map(obj, property(key));
}

// Convenience version of a common use case of `filter`: selecting only objects
// containing specific `key:value` pairs.
function where(obj, attrs) {
  return filter(obj, matcher(attrs));
}

// Convenience version of a common use case of `find`: getting the first object
// containing specific `key:value` pairs.
function findWhere(obj, attrs) {
  return find(obj, matcher(attrs));
}

// Return the maximum element (or element-based computation).
function max(obj, iteratee, context) {
  var result = -Infinity, lastComputed = -Infinity,
      value, computed;
  if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
    obj = isArrayLike(obj) ? obj : values(obj);
    for (var i = 0, length = obj.length; i < length; i++) {
      value = obj[i];
      if (value != null && value > result) {
        result = value;
      }
    }
  } else {
    iteratee = cb(iteratee, context);
    each(obj, function(v, index, list) {
      computed = iteratee(v, index, list);
      if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
        result = v;
        lastComputed = computed;
      }
    });
  }
  return result;
}

// Return the minimum element (or element-based computation).
function min(obj, iteratee, context) {
  var result = Infinity, lastComputed = Infinity,
      value, computed;
  if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
    obj = isArrayLike(obj) ? obj : values(obj);
    for (var i = 0, length = obj.length; i < length; i++) {
      value = obj[i];
      if (value != null && value < result) {
        result = value;
      }
    }
  } else {
    iteratee = cb(iteratee, context);
    each(obj, function(v, index, list) {
      computed = iteratee(v, index, list);
      if (computed < lastComputed || computed === Infinity && result === Infinity) {
        result = v;
        lastComputed = computed;
      }
    });
  }
  return result;
}

// Shuffle a collection.
function shuffle(obj) {
  return sample(obj, Infinity);
}

// Sample **n** random values from a collection using the modern version of the
// [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
// If **n** is not specified, returns a single random element.
// The internal `guard` argument allows it to work with `map`.
function sample(obj, n, guard) {
  if (n == null || guard) {
    if (!isArrayLike(obj)) obj = values(obj);
    return obj[random(obj.length - 1)];
  }
  var sample = isArrayLike(obj) ? clone(obj) : values(obj);
  var length = getLength(sample);
  n = Math.max(Math.min(n, length), 0);
  var last = length - 1;
  for (var index = 0; index < n; index++) {
    var rand = random(index, last);
    var temp = sample[index];
    sample[index] = sample[rand];
    sample[rand] = temp;
  }
  return sample.slice(0, n);
}

// Sort the object's values by a criterion produced by an iteratee.
function sortBy(obj, iteratee, context) {
  var index = 0;
  iteratee = cb(iteratee, context);
  return pluck(map(obj, function(value, key, list) {
    return {
      value: value,
      index: index++,
      criteria: iteratee(value, key, list)
    };
  }).sort(function(left, right) {
    var a = left.criteria;
    var b = right.criteria;
    if (a !== b) {
      if (a > b || a === void 0) return 1;
      if (a < b || b === void 0) return -1;
    }
    return left.index - right.index;
  }), 'value');
}

// An internal function used for aggregate "group by" operations.
function group(behavior, partition) {
  return function(obj, iteratee, context) {
    var result = partition ? [[], []] : {};
    iteratee = cb(iteratee, context);
    each(obj, function(value, index) {
      var key = iteratee(value, index, obj);
      behavior(result, value, key);
    });
    return result;
  };
}

// Groups the object's values by a criterion. Pass either a string attribute
// to group by, or a function that returns the criterion.
var groupBy = group(function(result, value, key) {
  if (_has(result, key)) result[key].push(value); else result[key] = [value];
});

// Indexes the object's values by a criterion, similar to `groupBy`, but for
// when you know that your index values will be unique.
var indexBy = group(function(result, value, key) {
  result[key] = value;
});

// Counts instances of an object that group by a certain criterion. Pass
// either a string attribute to count by, or a function that returns the
// criterion.
var countBy = group(function(result, value, key) {
  if (_has(result, key)) result[key]++; else result[key] = 1;
});

var reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
// Safely create a real, live array from anything iterable.
function toArray(obj) {
  if (!obj) return [];
  if (isArray(obj)) return slice.call(obj);
  if (isString(obj)) {
    // Keep surrogate pair characters together
    return obj.match(reStrSymbol);
  }
  if (isArrayLike(obj)) return map(obj, identity);
  return values(obj);
}

// Return the number of elements in an object.
function size(obj) {
  if (obj == null) return 0;
  return isArrayLike(obj) ? obj.length : keys(obj).length;
}

// Split a collection into two arrays: one whose elements all satisfy the given
// predicate, and one whose elements all do not satisfy the predicate.
var partition = group(function(result, value, pass) {
  result[pass ? 0 : 1].push(value);
}, true);

// Array Functions
// ---------------

// Get the first element of an array. Passing **n** will return the first N
// values in the array. The **guard** check allows it to work with `map`.
function first(array, n, guard) {
  if (array == null || array.length < 1) return n == null ? void 0 : [];
  if (n == null || guard) return array[0];
  return initial(array, array.length - n);
}


// Returns everything but the last entry of the array. Especially useful on
// the arguments object. Passing **n** will return all the values in
// the array, excluding the last N.
function initial(array, n, guard) {
  return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
}

// Get the last element of an array. Passing **n** will return the last N
// values in the array.
function last(array, n, guard) {
  if (array == null || array.length < 1) return n == null ? void 0 : [];
  if (n == null || guard) return array[array.length - 1];
  return rest(array, Math.max(0, array.length - n));
}

// Returns everything but the first entry of the array. Especially useful on
// the arguments object. Passing an **n** will return the rest N values in the
// array.
function rest(array, n, guard) {
  return slice.call(array, n == null || guard ? 1 : n);
}


// Trim out all falsy values from an array.
function compact(array) {
  return filter(array, Boolean);
}

// Internal implementation of a recursive `flatten` function.
function _flatten(input, shallow, strict, output) {
  output = output || [];
  var idx = output.length;
  for (var i = 0, length = getLength(input); i < length; i++) {
    var value = input[i];
    if (isArrayLike(value) && (isArray(value) || isArguments(value))) {
      // Flatten current level of array or arguments object.
      if (shallow) {
        var j = 0, len = value.length;
        while (j < len) output[idx++] = value[j++];
      } else {
        _flatten(value, shallow, strict, output);
        idx = output.length;
      }
    } else if (!strict) {
      output[idx++] = value;
    }
  }
  return output;
}

// Flatten out an array, either recursively (by default), or just one level.
function flatten(array, shallow) {
  return _flatten(array, shallow, false);
}

// Return a version of the array that does not contain the specified value(s).
var without = restArguments(function(array, otherArrays) {
  return difference(array, otherArrays);
});

// Produce a duplicate-free version of the array. If the array has already
// been sorted, you have the option of using a faster algorithm.
// The faster algorithm will not work with an iteratee if the iteratee
// is not a one-to-one function, so providing an iteratee will disable
// the faster algorithm.
function uniq(array, isSorted, iteratee, context) {
  if (!isBoolean(isSorted)) {
    context = iteratee;
    iteratee = isSorted;
    isSorted = false;
  }
  if (iteratee != null) iteratee = cb(iteratee, context);
  var result = [];
  var seen = [];
  for (var i = 0, length = getLength(array); i < length; i++) {
    var value = array[i],
        computed = iteratee ? iteratee(value, i, array) : value;
    if (isSorted && !iteratee) {
      if (!i || seen !== computed) result.push(value);
      seen = computed;
    } else if (iteratee) {
      if (!contains(seen, computed)) {
        seen.push(computed);
        result.push(value);
      }
    } else if (!contains(result, value)) {
      result.push(value);
    }
  }
  return result;
}


// Produce an array that contains the union: each distinct element from all of
// the passed-in arrays.
var union = restArguments(function(arrays) {
  return uniq(_flatten(arrays, true, true));
});

// Produce an array that contains every item shared between all the
// passed-in arrays.
function intersection(array) {
  var result = [];
  var argsLength = arguments.length;
  for (var i = 0, length = getLength(array); i < length; i++) {
    var item = array[i];
    if (contains(result, item)) continue;
    var j;
    for (j = 1; j < argsLength; j++) {
      if (!contains(arguments[j], item)) break;
    }
    if (j === argsLength) result.push(item);
  }
  return result;
}

// Take the difference between one array and a number of other arrays.
// Only the elements present in just the first array will remain.
var difference = restArguments(function(array, rest) {
  rest = _flatten(rest, true, true);
  return filter(array, function(value){
    return !contains(rest, value);
  });
});

// Complement of zip. Unzip accepts an array of arrays and groups
// each array's elements on shared indices.
function unzip(array) {
  var length = array && max(array, getLength).length || 0;
  var result = Array(length);

  for (var index = 0; index < length; index++) {
    result[index] = pluck(array, index);
  }
  return result;
}

// Zip together multiple lists into a single array -- elements that share
// an index go together.
var zip = restArguments(unzip);

// Converts lists into objects. Pass either a single array of `[key, value]`
// pairs, or two parallel arrays of the same length -- one of keys, and one of
// the corresponding values. Passing by pairs is the reverse of pairs.
function object(list, values) {
  var result = {};
  for (var i = 0, length = getLength(list); i < length; i++) {
    if (values) {
      result[list[i]] = values[i];
    } else {
      result[list[i][0]] = list[i][1];
    }
  }
  return result;
}

// Generator function to create the findIndex and findLastIndex functions.
function createPredicateIndexFinder(dir) {
  return function(array, predicate, context) {
    predicate = cb(predicate, context);
    var length = getLength(array);
    var index = dir > 0 ? 0 : length - 1;
    for (; index >= 0 && index < length; index += dir) {
      if (predicate(array[index], index, array)) return index;
    }
    return -1;
  };
}

// Returns the first index on an array-like that passes a predicate test.
var findIndex = createPredicateIndexFinder(1);
var findLastIndex = createPredicateIndexFinder(-1);

// Use a comparator function to figure out the smallest index at which
// an object should be inserted so as to maintain order. Uses binary search.
function sortedIndex(array, obj, iteratee, context) {
  iteratee = cb(iteratee, context, 1);
  var value = iteratee(obj);
  var low = 0, high = getLength(array);
  while (low < high) {
    var mid = Math.floor((low + high) / 2);
    if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
  }
  return low;
}

// Generator function to create the indexOf and lastIndexOf functions.
function createIndexFinder(dir, predicateFind, sortedIndex) {
  return function(array, item, idx) {
    var i = 0, length = getLength(array);
    if (typeof idx == 'number') {
      if (dir > 0) {
        i = idx >= 0 ? idx : Math.max(idx + length, i);
      } else {
        length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
      }
    } else if (sortedIndex && idx && length) {
      idx = sortedIndex(array, item);
      return array[idx] === item ? idx : -1;
    }
    if (item !== item) {
      idx = predicateFind(slice.call(array, i, length), isNaN);
      return idx >= 0 ? idx + i : -1;
    }
    for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
      if (array[idx] === item) return idx;
    }
    return -1;
  };
}

// Return the position of the first occurrence of an item in an array,
// or -1 if the item is not included in the array.
// If the array is large and already in sort order, pass `true`
// for **isSorted** to use binary search.
var indexOf = createIndexFinder(1, findIndex, sortedIndex);
var lastIndexOf = createIndexFinder(-1, findLastIndex);

// Generate an integer Array containing an arithmetic progression. A port of
// the native Python `range()` function. See
// [the Python documentation](https://docs.python.org/library/functions.html#range).
function range(start, stop, step) {
  if (stop == null) {
    stop = start || 0;
    start = 0;
  }
  if (!step) {
    step = stop < start ? -1 : 1;
  }

  var length = Math.max(Math.ceil((stop - start) / step), 0);
  var range = Array(length);

  for (var idx = 0; idx < length; idx++, start += step) {
    range[idx] = start;
  }

  return range;
}

// Chunk a single array into multiple arrays, each containing `count` or fewer
// items.
function chunk(array, count) {
  if (count == null || count < 1) return [];
  var result = [];
  var i = 0, length = array.length;
  while (i < length) {
    result.push(slice.call(array, i, i += count));
  }
  return result;
}

// Function (ahem) Functions
// ------------------

// Determines whether to execute a function as a constructor
// or a normal function with the provided arguments.
function executeBound(sourceFunc, boundFunc, context, callingContext, args) {
  if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
  var self = baseCreate(sourceFunc.prototype);
  var result = sourceFunc.apply(self, args);
  if (isObject(result)) return result;
  return self;
}

// Create a function bound to a given object (assigning `this`, and arguments,
// optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
// available.
var bind = restArguments(function(func, context, args) {
  if (!isFunction(func)) throw new TypeError('Bind must be called on a function');
  var bound = restArguments(function(callArgs) {
    return executeBound(func, bound, context, this, args.concat(callArgs));
  });
  return bound;
});

// Partially apply a function by creating a version that has had some of its
// arguments pre-filled, without changing its dynamic `this` context. _ acts
// as a placeholder by default, allowing any combination of arguments to be
// pre-filled. Set `partial.placeholder` for a custom placeholder argument.
var partial = restArguments(function(func, boundArgs) {
  var placeholder = partial.placeholder;
  var bound = function() {
    var position = 0, length = boundArgs.length;
    var args = Array(length);
    for (var i = 0; i < length; i++) {
      args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
    }
    while (position < arguments.length) args.push(arguments[position++]);
    return executeBound(func, bound, this, this, args);
  };
  return bound;
});

partial.placeholder = _;

// Bind a number of an object's methods to that object. Remaining arguments
// are the method names to be bound. Useful for ensuring that all callbacks
// defined on an object belong to it.
var bindAll = restArguments(function(obj, _keys) {
  _keys = _flatten(_keys, false, false);
  var index = _keys.length;
  if (index < 1) throw new Error('bindAll must be passed function names');
  while (index--) {
    var key = _keys[index];
    obj[key] = bind(obj[key], obj);
  }
});

// Memoize an expensive function by storing its results.
function memoize(func, hasher) {
  var memoize = function(key) {
    var cache = memoize.cache;
    var address = '' + (hasher ? hasher.apply(this, arguments) : key);
    if (!_has(cache, address)) cache[address] = func.apply(this, arguments);
    return cache[address];
  };
  memoize.cache = {};
  return memoize;
}

// Delays a function for the given number of milliseconds, and then calls
// it with the arguments supplied.
var delay = restArguments(function(func, wait, args) {
  return setTimeout(function() {
    return func.apply(null, args);
  }, wait);
});

// Defers a function, scheduling it to run after the current call stack has
// cleared.
var defer = partial(delay, _, 1);

// Returns a function, that, when invoked, will only be triggered at most once
// during a given window of time. Normally, the throttled function will run
// as much as it can, without ever going more than once per `wait` duration;
// but if you'd like to disable the execution on the leading edge, pass
// `{leading: false}`. To disable execution on the trailing edge, ditto.
function throttle(func, wait, options) {
  var timeout, context, args, result;
  var previous = 0;
  if (!options) options = {};

  var later = function() {
    previous = options.leading === false ? 0 : now();
    timeout = null;
    result = func.apply(context, args);
    if (!timeout) context = args = null;
  };

  var throttled = function() {
    var _now = now();
    if (!previous && options.leading === false) previous = _now;
    var remaining = wait - (_now - previous);
    context = this;
    args = arguments;
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = _now;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }
    return result;
  };

  throttled.cancel = function() {
    clearTimeout(timeout);
    previous = 0;
    timeout = context = args = null;
  };

  return throttled;
}

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
  var timeout, result;

  var later = function(context, args) {
    timeout = null;
    if (args) result = func.apply(context, args);
  };

  var debounced = restArguments(function(args) {
    if (timeout) clearTimeout(timeout);
    if (immediate) {
      var callNow = !timeout;
      timeout = setTimeout(later, wait);
      if (callNow) result = func.apply(this, args);
    } else {
      timeout = delay(later, wait, this, args);
    }

    return result;
  });

  debounced.cancel = function() {
    clearTimeout(timeout);
    timeout = null;
  };

  return debounced;
}

// Returns the first function passed as an argument to the second,
// allowing you to adjust arguments, run code before and after, and
// conditionally execute the original function.
function wrap(func, wrapper) {
  return partial(wrapper, func);
}

// Returns a negated version of the passed-in predicate.
function negate(predicate) {
  return function() {
    return !predicate.apply(this, arguments);
  };
}

// Returns a function that is the composition of a list of functions, each
// consuming the return value of the function that follows.
function compose() {
  var args = arguments;
  var start = args.length - 1;
  return function() {
    var i = start;
    var result = args[start].apply(this, arguments);
    while (i--) result = args[i].call(this, result);
    return result;
  };
}

// Returns a function that will only be executed on and after the Nth call.
function after(times, func) {
  return function() {
    if (--times < 1) {
      return func.apply(this, arguments);
    }
  };
}

// Returns a function that will only be executed up to (but not including) the Nth call.
function before(times, func) {
  var memo;
  return function() {
    if (--times > 0) {
      memo = func.apply(this, arguments);
    }
    if (times <= 1) func = null;
    return memo;
  };
}

// Returns a function that will be executed at most one time, no matter how
// often you call it. Useful for lazy initialization.
var once = partial(before, 2);

// Object Functions
// ----------------

// Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
  'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

function collectNonEnumProps(obj, _keys) {
  var nonEnumIdx = nonEnumerableProps.length;
  var constructor = obj.constructor;
  var proto = isFunction(constructor) && constructor.prototype || ObjProto;

  // Constructor is a special case.
  var prop = 'constructor';
  if (_has(obj, prop) && !contains(_keys, prop)) _keys.push(prop);

  while (nonEnumIdx--) {
    prop = nonEnumerableProps[nonEnumIdx];
    if (prop in obj && obj[prop] !== proto[prop] && !contains(_keys, prop)) {
      _keys.push(prop);
    }
  }
}

// Retrieve the names of an object's own properties.
// Delegates to **ECMAScript 5**'s native `Object.keys`.
function keys(obj) {
  if (!isObject(obj)) return [];
  if (nativeKeys) return nativeKeys(obj);
  var _keys = [];
  for (var key in obj) if (_has(obj, key)) _keys.push(key);
  // Ahem, IE < 9.
  if (hasEnumBug) collectNonEnumProps(obj, _keys);
  return _keys;
}

// Retrieve all the property names of an object.
function allKeys(obj) {
  if (!isObject(obj)) return [];
  var _keys = [];
  for (var key in obj) _keys.push(key);
  // Ahem, IE < 9.
  if (hasEnumBug) collectNonEnumProps(obj, _keys);
  return _keys;
}

// Retrieve the values of an object's properties.
function values(obj) {
  var _keys = keys(obj);
  var length = _keys.length;
  var values = Array(length);
  for (var i = 0; i < length; i++) {
    values[i] = obj[_keys[i]];
  }
  return values;
}

// Returns the results of applying the iteratee to each element of the object.
// In contrast to map it returns an object.
function mapObject(obj, iteratee, context) {
  iteratee = cb(iteratee, context);
  var _keys = keys(obj),
      length = _keys.length,
      results = {};
  for (var index = 0; index < length; index++) {
    var currentKey = _keys[index];
    results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
  }
  return results;
}

// Convert an object into a list of `[key, value]` pairs.
// The opposite of object.
function pairs(obj) {
  var _keys = keys(obj);
  var length = _keys.length;
  var pairs = Array(length);
  for (var i = 0; i < length; i++) {
    pairs[i] = [_keys[i], obj[_keys[i]]];
  }
  return pairs;
}

// Invert the keys and values of an object. The values must be serializable.
function invert(obj) {
  var result = {};
  var _keys = keys(obj);
  for (var i = 0, length = _keys.length; i < length; i++) {
    result[obj[_keys[i]]] = _keys[i];
  }
  return result;
}

// Return a sorted list of the function names available on the object.
function functions(obj) {
  var names = [];
  for (var key in obj) {
    if (isFunction(obj[key])) names.push(key);
  }
  return names.sort();
}


// An internal function for creating assigner functions.
function createAssigner(keysFunc, defaults) {
  return function(obj) {
    var length = arguments.length;
    if (defaults) obj = Object(obj);
    if (length < 2 || obj == null) return obj;
    for (var index = 1; index < length; index++) {
      var source = arguments[index],
          _keys = keysFunc(source),
          l = _keys.length;
      for (var i = 0; i < l; i++) {
        var key = _keys[i];
        if (!defaults || obj[key] === void 0) obj[key] = source[key];
      }
    }
    return obj;
  };
}

// Extend a given object with all the properties in passed-in object(s).
var extend = createAssigner(allKeys);

// Assigns a given object with all the own properties in the passed-in object(s).
// (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
var extendOwn = createAssigner(keys);


// Returns the first key on an object that passes a predicate test.
function findKey(obj, predicate, context) {
  predicate = cb(predicate, context);
  var _keys = keys(obj), key;
  for (var i = 0, length = _keys.length; i < length; i++) {
    key = _keys[i];
    if (predicate(obj[key], key, obj)) return key;
  }
}

// Internal pick helper function to determine if `obj` has key `key`.
function keyInObj(value, key, obj) {
  return key in obj;
}

// Return a copy of the object only containing the whitelisted properties.
var pick = restArguments(function(obj, _keys) {
  var result = {}, iteratee = _keys[0];
  if (obj == null) return result;
  if (isFunction(iteratee)) {
    if (_keys.length > 1) iteratee = optimizeCb(iteratee, _keys[1]);
    _keys = allKeys(obj);
  } else {
    iteratee = keyInObj;
    _keys = _flatten(_keys, false, false);
    obj = Object(obj);
  }
  for (var i = 0, length = _keys.length; i < length; i++) {
    var key = _keys[i];
    var value = obj[key];
    if (iteratee(value, key, obj)) result[key] = value;
  }
  return result;
});

// Return a copy of the object without the blacklisted properties.
var omit = restArguments(function(obj, _keys) {
  var iteratee = _keys[0], context;
  if (isFunction(iteratee)) {
    iteratee = negate(iteratee);
    if (_keys.length > 1) context = _keys[1];
  } else {
    _keys = map(_flatten(_keys, false, false), String);
    iteratee = function(value, key) {
      return !contains(_keys, key);
    };
  }
  return pick(obj, iteratee, context);
});

// Fill in a given object with default properties.
var defaults = createAssigner(allKeys, true);

// Creates an object that inherits from the given prototype object.
// If additional properties are provided then they will be added to the
// created object.
function create(prototype, props) {
  var result = baseCreate(prototype);
  if (props) extendOwn(result, props);
  return result;
}

// Create a (shallow-cloned) duplicate of an object.
function clone(obj) {
  if (!isObject(obj)) return obj;
  return isArray(obj) ? obj.slice() : extend({}, obj);
}

// Invokes interceptor with the obj, and then returns obj.
// The primary purpose of this method is to "tap into" a method chain, in
// order to perform operations on intermediate results within the chain.
function tap(obj, interceptor) {
  interceptor(obj);
  return obj;
}

// Returns whether an object has a given set of `key:value` pairs.
function isMatch(object, attrs) {
  var _keys = keys(attrs), length = _keys.length;
  if (object == null) return !length;
  var obj = Object(object);
  for (var i = 0; i < length; i++) {
    var key = _keys[i];
    if (attrs[key] !== obj[key] || !(key in obj)) return false;
  }
  return true;
}


// Internal recursive comparison function for `isEqual`.
function eq(a, b, aStack, bStack) {
  // Identical objects are equal. `0 === -0`, but they aren't identical.
  // See the [Harmony `egal` proposal](https://wiki.ecmascript.org/doku.php?id=harmony:egal).
  if (a === b) return a !== 0 || 1 / a === 1 / b;
  // `null` or `undefined` only equal to itself (strict comparison).
  if (a == null || b == null) return false;
  // `NaN`s are equivalent, but non-reflexive.
  if (a !== a) return b !== b;
  // Exhaust primitive checks
  var type = typeof a;
  if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
  return deepEq(a, b, aStack, bStack);
}

// Internal recursive comparison function for `isEqual`.
function deepEq(a, b, aStack, bStack) {
  // Unwrap any wrapped objects.
  if (a instanceof _) a = a._wrapped;
  if (b instanceof _) b = b._wrapped;
  // Compare `[[Class]]` names.
  var className = toString.call(a);
  if (className !== toString.call(b)) return false;
  switch (className) {
    // Strings, numbers, regular expressions, dates, and booleans are compared by value.
    case '[object RegExp]':
    // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
    case '[object String]':
      // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
      // equivalent to `new String("5")`.
      return '' + a === '' + b;
    case '[object Number]':
      // `NaN`s are equivalent, but non-reflexive.
      // Object(NaN) is equivalent to NaN.
      if (+a !== +a) return +b !== +b;
      // An `egal` comparison is performed for other numeric values.
      return +a === 0 ? 1 / +a === 1 / b : +a === +b;
    case '[object Date]':
    case '[object Boolean]':
      // Coerce dates and booleans to numeric primitive values. Dates are compared by their
      // millisecond representations. Note that invalid dates with millisecond representations
      // of `NaN` are not equivalent.
      return +a === +b;
    case '[object Symbol]':
      return SymbolProto.valueOf.call(a) === SymbolProto.valueOf.call(b);
  }

  var areArrays = className === '[object Array]';
  if (!areArrays) {
    if (typeof a != 'object' || typeof b != 'object') return false;

    // Objects with different constructors are not equivalent, but `Object`s or `Array`s
    // from different frames are.
    var aCtor = a.constructor, bCtor = b.constructor;
    if (aCtor !== bCtor && !(isFunction(aCtor) && aCtor instanceof aCtor &&
                             isFunction(bCtor) && bCtor instanceof bCtor)
                        && ('constructor' in a && 'constructor' in b)) {
      return false;
    }
  }
  // Assume equality for cyclic structures. The algorithm for detecting cyclic
  // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

  // Initializing stack of traversed objects.
  // It's done here since we only need them for objects and arrays comparison.
  aStack = aStack || [];
  bStack = bStack || [];
  var length = aStack.length;
  while (length--) {
    // Linear search. Performance is inversely proportional to the number of
    // unique nested structures.
    if (aStack[length] === a) return bStack[length] === b;
  }

  // Add the first object to the stack of traversed objects.
  aStack.push(a);
  bStack.push(b);

  // Recursively compare objects and arrays.
  if (areArrays) {
    // Compare array lengths to determine if a deep comparison is necessary.
    length = a.length;
    if (length !== b.length) return false;
    // Deep compare the contents, ignoring non-numeric properties.
    while (length--) {
      if (!eq(a[length], b[length], aStack, bStack)) return false;
    }
  } else {
    // Deep compare objects.
    var _keys = keys(a), key;
    length = _keys.length;
    // Ensure that both objects contain the same number of properties before comparing deep equality.
    if (keys(b).length !== length) return false;
    while (length--) {
      // Deep compare each member
      key = _keys[length];
      if (!(_has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
    }
  }
  // Remove the first object from the stack of traversed objects.
  aStack.pop();
  bStack.pop();
  return true;
}

// Perform a deep comparison to check if two objects are equal.
function isEqual(a, b) {
  return eq(a, b);
}

// Is a given array, string, or object empty?
// An "empty" object has no enumerable own-properties.
function isEmpty(obj) {
  if (obj == null) return true;
  if (isArrayLike(obj) && (isArray(obj) || isString(obj) || isArguments(obj))) return obj.length === 0;
  return keys(obj).length === 0;
}

// Is a given value a DOM element?
function isElement(obj) {
  return !!(obj && obj.nodeType === 1);
}

// Internal function for creating a toString-based type tester.
function tagTester(name) {
  return function(obj) {
    return toString.call(obj) === '[object ' + name + ']';
  };
}

// Is a given value an array?
// Delegates to ECMA5's native Array.isArray
var isArray = nativeIsArray || tagTester('Array');

// Is a given variable an object?
function isObject(obj) {
  var type = typeof obj;
  return type === 'function' || type === 'object' && !!obj;
}

// Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError, isMap, isWeakMap, isSet, isWeakSet.
var isArguments = tagTester('Arguments');
var isFunction = tagTester('Function');
var isString = tagTester('String');
var isNumber = tagTester('Number');
var isDate = tagTester('Date');
var isRegExp = tagTester('RegExp');
var isError = tagTester('Error');
var isSymbol = tagTester('Symbol');
var isMap = tagTester('Map');
var isWeakMap = tagTester('WeakMap');
var isSet = tagTester('Set');
var isWeakSet = tagTester('WeakSet');

// Define a fallback version of the method in browsers (ahem, IE < 9), where
// there isn't any inspectable "Arguments" type.
(function() {
  if (!isArguments(arguments)) {
    isArguments = function(obj) {
      return _has(obj, 'callee');
    };
  }
}());

// Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
// IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
var nodelist = root.document && root.document.childNodes;
if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof nodelist != 'function') {
  isFunction = function(obj) {
    return typeof obj == 'function' || false;
  };
}

// Is a given object a finite number?
function isFinite(obj) {
  return !isSymbol(obj) && _isFinite(obj) && !_isNaN(parseFloat(obj));
}

// Is the given value `NaN`?
function isNaN(obj) {
  return isNumber(obj) && _isNaN(obj);
}

// Is a given value a boolean?
function isBoolean(obj) {
  return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
}

// Is a given value equal to null?
function isNull(obj) {
  return obj === null;
}

// Is a given variable undefined?
function isUndefined(obj) {
  return obj === void 0;
}

// Shortcut function for checking if an object has a given property directly
// on itself (in other words, not on a prototype).
function has(obj, path) {
  if (!isArray(path)) {
    return _has(obj, path);
  }
  var length = path.length;
  for (var i = 0; i < length; i++) {
    var key = path[i];
    if (obj == null || !hasOwnProperty.call(obj, key)) {
      return false;
    }
    obj = obj[key];
  }
  return !!length;
}

// Utility Functions
// -----------------

// Keep the identity function around for default iteratees.
function identity(value) {
  return value;
}

// Predicate-generating functions. Often useful outside of Underscore.
function constant(value) {
  return function() {
    return value;
  };
}

function noop(){}

// Creates a function that, when passed an object, will traverse that object’s
// properties down the given `path`, specified as an array of keys or indexes.
function property(path) {
  if (!isArray(path)) {
    return shallowProperty(path);
  }
  return function(obj) {
    return deepGet(obj, path);
  };
}

// Generates a function for a given object that returns a given property.
function propertyOf(obj) {
  if (obj == null) {
    return function(){};
  }
  return function(path) {
    return !isArray(path) ? obj[path] : deepGet(obj, path);
  };
}

// Returns a predicate for checking whether an object has a given set of
// `key:value` pairs.
function matcher(attrs) {
  attrs = extendOwn({}, attrs);
  return function(obj) {
    return isMatch(obj, attrs);
  };
}


// Run a function **n** times.
function times(n, iteratee, context) {
  var accum = Array(Math.max(0, n));
  iteratee = optimizeCb(iteratee, context, 1);
  for (var i = 0; i < n; i++) accum[i] = iteratee(i);
  return accum;
}

// Return a random integer between min and max (inclusive).
function random(min, max) {
  if (max == null) {
    max = min;
    min = 0;
  }
  return min + Math.floor(Math.random() * (max - min + 1));
}

// A (possibly faster) way to get the current timestamp as an integer.
var now = Date.now || function() {
  return new Date().getTime();
};

// List of HTML entities for escaping.
var escapeMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#x27;',
  '`': '&#x60;'
};
var unescapeMap = invert(escapeMap);

// Functions for escaping and unescaping strings to/from HTML interpolation.
function createEscaper(map) {
  var escaper = function(match) {
    return map[match];
  };
  // Regexes for identifying a key that needs to be escaped.
  var source = '(?:' + keys(map).join('|') + ')';
  var testRegexp = RegExp(source);
  var replaceRegexp = RegExp(source, 'g');
  return function(string) {
    string = string == null ? '' : '' + string;
    return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
  };
}
var escape = createEscaper(escapeMap);
var unescape = createEscaper(unescapeMap);

// Traverses the children of `obj` along `path`. If a child is a function, it
// is invoked with its parent as context. Returns the value of the final
// child, or `fallback` if any child is undefined.
function result(obj, path, fallback) {
  if (!isArray(path)) path = [path];
  var length = path.length;
  if (!length) {
    return isFunction(fallback) ? fallback.call(obj) : fallback;
  }
  for (var i = 0; i < length; i++) {
    var prop = obj == null ? void 0 : obj[path[i]];
    if (prop === void 0) {
      prop = fallback;
      i = length; // Ensure we don't continue iterating.
    }
    obj = isFunction(prop) ? prop.call(obj) : prop;
  }
  return obj;
}

// Generate a unique integer id (unique within the entire client session).
// Useful for temporary DOM ids.
var idCounter = 0;
function uniqueId(prefix) {
  var id = ++idCounter + '';
  return prefix ? prefix + id : id;
}

// By default, Underscore uses ERB-style template delimiters, change the
// following template settings to use alternative delimiters.
var templateSettings = _.templateSettings = {
  evaluate: /<%([\s\S]+?)%>/g,
  interpolate: /<%=([\s\S]+?)%>/g,
  escape: /<%-([\s\S]+?)%>/g
};

// When customizing `templateSettings`, if you don't want to define an
// interpolation, evaluation or escaping regex, we need one that is
// guaranteed not to match.
var noMatch = /(.)^/;

// Certain characters need to be escaped so that they can be put into a
// string literal.
var escapes = {
  "'": "'",
  '\\': '\\',
  '\r': 'r',
  '\n': 'n',
  '\u2028': 'u2028',
  '\u2029': 'u2029'
};

var escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;

var escapeChar = function(match) {
  return '\\' + escapes[match];
};

// JavaScript micro-templating, similar to John Resig's implementation.
// Underscore templating handles arbitrary delimiters, preserves whitespace,
// and correctly escapes quotes within interpolated code.
// NB: `oldSettings` only exists for backwards compatibility.
function template(text, settings, oldSettings) {
  if (!settings && oldSettings) settings = oldSettings;
  settings = defaults({}, settings, _.templateSettings);

  // Combine delimiters into one regular expression via alternation.
  var matcher = RegExp([
    (settings.escape || noMatch).source,
    (settings.interpolate || noMatch).source,
    (settings.evaluate || noMatch).source
  ].join('|') + '|$', 'g');

  // Compile the template source, escaping string literals appropriately.
  var index = 0;
  var source = "__p+='";
  text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
    source += text.slice(index, offset).replace(escapeRegExp, escapeChar);
    index = offset + match.length;

    if (escape) {
      source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
    } else if (interpolate) {
      source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
    } else if (evaluate) {
      source += "';\n" + evaluate + "\n__p+='";
    }

    // Adobe VMs need the match returned to produce the correct offset.
    return match;
  });
  source += "';\n";

  // If a variable is not specified, place data values in local scope.
  if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

  source = "var __t,__p='',__j=Array.prototype.join," +
    "print=function(){__p+=__j.call(arguments,'');};\n" +
    source + 'return __p;\n';

  var render;
  try {
    render = new Function(settings.variable || 'obj', '_', source);
  } catch (e) {
    e.source = source;
    throw e;
  }

  var template = function(data) {
    return render.call(this, data, _);
  };

  // Provide the compiled source as a convenience for precompilation.
  var argument = settings.variable || 'obj';
  template.source = 'function(' + argument + '){\n' + source + '}';

  return template;
}

// Add a "chain" function. Start chaining a wrapped Underscore object.
function chain(obj) {
  var instance = _(obj);
  instance._chain = true;
  return instance;
}

// OOP
// ---------------
// If Underscore is called as a function, it returns a wrapped object that
// can be used OO-style. This wrapper holds altered versions of all the
// underscore functions. Wrapped objects may be chained.

// Helper function to continue chaining intermediate results.
function chainResult(instance, obj) {
  return instance._chain ? _(obj).chain() : obj;
}

// Add your own custom functions to the Underscore object.
function mixin(obj) {
  each(functions(obj), function(name) {
    var func = _[name] = obj[name];
    _.prototype[name] = function() {
      var args = [this._wrapped];
      push.apply(args, arguments);
      return chainResult(this, func.apply(_, args));
    };
  });
  return _;
}

// Add all mutator Array functions to the wrapper.
each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
  var method = ArrayProto[name];
  _.prototype[name] = function() {
    var obj = this._wrapped;
    method.apply(obj, arguments);
    if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
    return chainResult(this, obj);
  };
});

// Add all accessor Array functions to the wrapper.
each(['concat', 'join', 'slice'], function(name) {
  var method = ArrayProto[name];
  _.prototype[name] = function() {
    return chainResult(this, method.apply(this._wrapped, arguments));
  };
});

// Extracts the result from a wrapped and chained object.
_.prototype.value = function() {
  return this._wrapped;
};

// Provide unwrapping proxy for some methods used in engine operations
// such as arithmetic and JSON stringification.
_.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

_.prototype.toString = function() {
  return String(this._wrapped);
};

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(13)))

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {

    /**
     * @file 合并参数
     * @author 子虔
     * @date    2014-08-15 17:43:36
     * @param  {Object}  to - 源
     * @param  {Object}  from - 要处理的对象
     */

    module.exports = function parseParam(to, from) {
        var key,
            obj = {};

        from = from || {};

        for (key in to) {
            if (to.hasOwnProperty(key)) {
                obj[key] = to[key];
                if (from[key] != null) {
                    if (from.hasOwnProperty(key)) {
                        if ($.isPlainObject(obj[key]) && $.isPlainObject(from[key])) {
                            obj[key] = parseParam(obj[key], from[key]);
                        } else {
                            obj[key] = from[key];
                        }
                    }
                }
            }
        }

        return obj;
    };
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {

    /**
     * @file isEqual(来自underscore)
     * @author 子虔
     * @date    2015-02-15 15:37:47
     */
    module.exports = eq;

    // Internal recursive comparison function for `isEqual`.
    function eq(a, b, aStack, bStack) {
        // Identical objects are equal. `0 === -0`, but they aren't identical.
        // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
        if (a === b) return a !== 0 || 1 / a === 1 / b;
        // A strict comparison is necessary because `null == undefined`.
        if (a == null || b == null) return a === b;

        // Compare `[[Class]]` names.
        var className = Object.prototype.toString.call(a);
        if (className !== Object.prototype.toString.call(b)) return false;

        switch (className) {
            // Strings, numbers, regular expressions, dates, and booleans are compared by value.
            case '[object RegExp]':
            // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
            case '[object String]':
                // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
                // equivalent to `new String("5")`.
                return '' + a === '' + b;
            case '[object Number]':
                // `NaN`s are equivalent, but non-reflexive.
                // Object(NaN) is equivalent to NaN
                if (+a !== +a) return +b !== +b;
                // An `egal` comparison is performed for other numeric values.
                return +a === 0 ? 1 / +a === 1 / b : +a === +b;
            case '[object Date]':
            case '[object Boolean]':
                // Coerce dates and booleans to numeric primitive values. Dates are compared by their
                // millisecond representations. Note that invalid dates with millisecond representations
                // of `NaN` are not equivalent.
                return +a === +b;
        }

        var areArrays = className === '[object Array]';

        if (!areArrays) {
            if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) != 'object' || (typeof b === 'undefined' ? 'undefined' : _typeof(b)) != 'object') return false;

            // Objects with different constructors are not equivalent, but `Object`s or `Array`s
            // from different frames are.
            var aCtor = a.constructor,
                bCtor = b.constructor;
            if (aCtor !== bCtor && !(typeof aCtor == 'function' && aCtor instanceof aCtor && typeof bCtor == 'function' && bCtor instanceof bCtor) && 'constructor' in a && 'constructor' in b) {
                return false;
            }
        }
        // Assume equality for cyclic structures. The algorithm for detecting cyclic
        // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

        // Initializing stack of traversed objects.
        // It's done here since we only need them for objects and arrays comparison.
        aStack = aStack || [];
        bStack = bStack || [];
        var length = aStack.length;
        while (length--) {
            // Linear search. Performance is inversely proportional to the number of
            // unique nested structures.
            if (aStack[length] === a) return bStack[length] === b;
        }

        // Add the first object to the stack of traversed objects.
        aStack.push(a);
        bStack.push(b);

        // Recursively compare objects and arrays.
        if (areArrays) {
            // Compare array lengths to determine if a deep comparison is necessary.
            length = a.length;
            if (length !== b.length) return false;
            // Deep compare the contents, ignoring non-numeric properties.

            while (length--) {
                if (!eq(a[length], b[length], aStack, bStack)) return false;
            }
        } else {
            // Deep compare objects.
            var keys = Object.keys(a),
                key;
            length = keys.length;
            // Ensure that both objects contain the same number of properties before comparing deep equality.
            if (Object.keys(b).length !== length) return false;

            while (length--) {
                // Deep compare each member
                key = keys[length];
                if (!(b.hasOwnProperty(key) && eq(a[key], b[key], aStack, bStack))) return false;
            }
        }
        // Remove the first object from the stack of traversed objects.
        aStack.pop();
        bStack.pop();
        return true;
    }
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 7 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

/**
 * The builder is transfered from SystemPreload.proto which sets the basic format such as 
 * code, msg, data and so on. When you receive buffer from server, you can decode it to json
 * by the special method called 'publicPB.Result.decode'. 
 * All works well until you face to new buffer in data structrue. It will be as follows.
 *      {
 *          code: 1,
 *          data: {
 *              type_url: 'xxx',
 *              value: {
 *                  buffer: [ArrayBuffer],
 *                  limit: 253,
 *                  ...
 *              },
 *              ...
 *          }
 *      }
 * In fact, all the real business data are included in data.value.buffer. So, we have to 
 * decode it into a string by special protobuf api.
 * It's right, the special api is 'preloadPB.System.Preload.Response.decodeDelimited'.
 */
var publicPB = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": null,
    "options": {
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [{
        "name": "Result",
        "fields": [{
            "rule": "optional",
            "type": "Code",
            "name": "code",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "msg",
            "id": 2
        }, {
            "rule": "optional",
            "type": "google.protobuf.Any",
            "name": "data",
            "id": 3
        }]
    }, {
        "name": "google",
        "fields": [],
        "messages": [{
            "name": "protobuf",
            "fields": [],
            "options": {
                "csharp_namespace": "Google.Protobuf.WellKnownTypes",
                "go_package": "github.com/golang/protobuf/ptypes/any",
                "java_package": "com.google.protobuf",
                "java_outer_classname": "AnyProto",
                "java_multiple_files": true,
                "java_generate_equals_and_hash": true,
                "objc_class_prefix": "GPB"
            },
            "messages": [{
                "name": "Any",
                "fields": [{
                    "rule": "optional",
                    "type": "string",
                    "name": "type_url",
                    "id": 1
                }, {
                    "rule": "optional",
                    "type": "bytes",
                    "name": "value",
                    "id": 2
                }]
            }]
        }]
    }],
    "enums": [{
        "name": "Code",
        "values": [{
            "name": "DEFAULT",
            "id": 0
        }, {
            "name": "SC_SUCCESS",
            "id": 1
        }, {
            "name": "SC_THIRD_PARTY_ALREADY_BIND",
            "id": 256
        }, {
            "name": "SC_THIRD_CHECK_USER_NOT_REGISTER",
            "id": 257
        }, {
            "name": "SC_PARAMETER_INVALID",
            "id": 4096
        }, {
            "name": "SC_ACCOUTN_USER_TOKEN_NOTMATCH",
            "id": 8192
        }, {
            "name": "SC_LOGINED_IN_OTHER_DEVICE",
            "id": 8193
        }, {
            "name": "SC_SMS_VERIFY_CODE_NOMOBILE",
            "id": 4097
        }, {
            "name": "SC_SMS_VERIFY_CODE_FAIL",
            "id": 4098
        }, {
            "name": "SC_SMS_VERIFY_CODE_NOTMATCH",
            "id": 4099
        }, {
            "name": "SC_ACCOUNT_MOBILE_PHONE_REPETITION",
            "id": 4100
        }, {
            "name": "SC_ACCOUNT_MOBILE_PHONE_ALLREADY_BIND",
            "id": 4101
        }, {
            "name": "SC_ACCOUTN_USER_NAME_FORBIDDEN",
            "id": 4102
        }, {
            "name": "SC_ACCOUTN_THIRD_CHECK_FAIL",
            "id": 4103
        }, {
            "name": "SC_ACCOUNT_USER_NAME_OVER_LONG",
            "id": 4104
        }, {
            "name": "SC_ACCOUNT_LIVE_CODE_OVER_LONG",
            "id": 4105
        }, {
            "name": "SC_ACCOUNT_LIVE_CODE_NOT_STANDARD",
            "id": 4112
        }, {
            "name": "SC_ACCOUNT_LIVE_CODE_EXIST",
            "id": 4113
        }, {
            "name": "SC_ACCOUNT_LIVE_UPDATE_FAIL",
            "id": 4114
        }, {
            "name": "SC_ACCOUNT_PASSWORD_ERROR",
            "id": 4115
        }, {
            "name": "SC_ACCOUNT_USER_NOT_EXIST",
            "id": 4116
        }, {
            "name": "SC_ACCOUNT_LIVE_CODE_TOO_SHORT",
            "id": 4117
        }, {
            "name": "SC_ACCOUNT_SIGNATURE_OVER_LONG",
            "id": 4118
        }, {
            "name": "SC_ACCOUTN_USER_FORBIDDEN",
            "id": 4119
        }, {
            "name": "SC_SENSITIVE_CONTENT",
            "id": 4609
        }, {
            "name": "SC_MALL_GIFT_NOT_EXIST",
            "id": 12289
        }, {
            "name": "SC_MALL_TRANSACTION_REPEATED",
            "id": 12290
        }, {
            "name": "SC_MALL_MONEY_NOT_ENOUGH",
            "id": 12291
        }, {
            "name": "SC_MALL_TRANSACTION_NOT_EXIST",
            "id": 12292
        }, {
            "name": "SC_MALL_PRODUCT_NOT_AVAILABLE",
            "id": 12293
        }, {
            "name": "SC_MALL_ORDER_NOT_EXIST",
            "id": 12294
        }, {
            "name": "SC_MALL_UNIFIED_ORDER_FAIL",
            "id": 12295
        }, {
            "name": "SC_MALL_PAY_FAIL",
            "id": 12296
        }, {
            "name": "SC_MALL_PAY_QUERY_FAIL",
            "id": 12297
        }, {
            "name": "SC_MALL_IAP_VALIDATE_FAIL",
            "id": 12298
        }, {
            "name": "SC_MALL_ORDER_EXIST_NOT_FINISHED",
            "id": 12299
        }, {
            "name": "SC_MALL_NOT_BIND_WECHAT",
            "id": 12300
        }, {
            "name": "SC_MALL_EXCEED_WITHDRAW_TIMES",
            "id": 12301
        }, {
            "name": "SC_MALL_EXCEED_WITHDRAW_QUOTA",
            "id": 12302
        }, {
            "name": "SC_MALL_WITHDRAW_FAIL",
            "id": 12303
        }, {
            "name": "SC_MALL_WITHDRAW_LESS_THAN_MIN",
            "id": 12304
        }, {
            "name": "SC_MALL_WITHDRAW_GREATER_THAN_MAX",
            "id": 12305
        }, {
            "name": "SC_MALL_WITHDRAW_FREQ_LIMIT",
            "id": 12306
        }, {
            "name": "SC_MALL_WITHDRAW_SENDNUM_LIMIT",
            "id": 12307
        }, {
            "name": "SC_CONTACT_ALREADY_FRIEND",
            "id": 16385
        }, {
            "name": "SC_LIVE_ROOM_NOT_EXIST",
            "id": 20481
        }, {
            "name": "SC_LIVE_ROOM_DISABLED",
            "id": 20482
        }, {
            "name": "SC_LIVE_ROOM_NO_PERMISSION",
            "id": 20483
        }, {
            "name": "SC_LIVE_ROOM_USER_GRADE_NOT_ENOUGH",
            "id": 20484
        }, {
            "name": "SC_SYSTEM_ERROR",
            "id": 16777215
        }]
    }]
}).build();

exports.default = publicPB;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * 将所有node_modules中组件迁移到项目内，统一为请求添加公用的UserAgent
 * @author zhenn
 * @createTime 2017-10-24
 */

var proxyUrl = {
    pro: '//proxy.upliveapps.com/index/index',
    dev: '//awsbj-proxy.xingyunzhi.cn/index/index',
    stage: '//sg-stage-proxy.upliveapp.com/index/index'
};

var PbAajx = function () {
    function PbAajx() {
        _classCallCheck(this, PbAajx);

        this.canceled = 0;
    }

    _createClass(PbAajx, [{
        key: 'do',
        value: function _do(cfg, data) {
            var success = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

            var _this = this;

            var timeout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};
            var fail = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {};

            var prefix = proxyUrl[this.env()];

            if (!cfg.header) {
                cfg.header = {};
            }
            // cfg.header.UserAgent = UP.Global.getGlobalUA();

            var _url = prefix + '?' + $.param(cfg);
            var timer = void 0,
                xhr = void 0;
            timer = setTimeout(function () {
                timeout();
            }, 5000);

            try {
                xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
                xhr.open("POST", _url, true);
                xhr.responseType = "arraybuffer";

                try {
                    xhr.send(data.toArrayBuffer());
                } catch (e) {
                    xhr.send();
                }
            } catch (e) {
                alert('please upgrade your brower, such as chrome!');
            }

            xhr.onreadystatechange = function (data) {

                if (xhr.readyState == 4) {
                    if (xhr.status == 200) {
                        clearTimeout(timer);
                        if (!_this.canceled) {
                            success(xhr.response);
                        }
                    } else {
                        if (typeof fail == 'function') {
                            fail();
                        }
                    }
                }
            };
        }
    }, {
        key: 'env',
        value: function env() {
            return Uplib.url.query('env') || 'pro';
        }
    }, {
        key: 'serializeURI',
        value: function serializeURI(obj) {
            var result = [];
            if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) != 'object') {
                obj = {};
            }
            for (var i in obj) {
                result.push(i + '=' + encodeURIComponent(obj[i]));
            }

            return result.join('&');
        }
    }, {
        key: 'cancel',
        value: function cancel() {
            this.canceled = 1;
        }
    }]);

    return PbAajx;
}();

exports.default = PbAajx;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;

/**
 * 本地缓存组件
 * 本地存储的技术方案：
   1、localStorage
        只考虑localStorage的存储方式，不考虑cookie方式。原因：
        （1）cookie 存储上限只有 4KB，且会加重网络负担，cookie 会被发送到作用域之内的所有http请求，包括js请求，css请求，图片请求，很多异步的请求
        （2）localStorage 存储上线是5MB   
   2、组件规范
        （1）数据存储格式
            旧的游戏：prefix/env/ppuid/gameType/key
            新的游戏：prefix/env/openId/gameType/key
        （2）prefix
            key前缀。默认是ppcache
            如果同一款游戏，后期做推广，gameType或者用户openId(即appid)与自家版相同，推荐prefix改为package name
        （3）key
            存储数据的字段名
            推荐使用驼峰格式（首字母小写其他词首大写），如myFieldName
        （4）expires：-1
            有效期配置
            单位：毫秒
            -1  ：永久保存
            > 0 ：有设置有效期

 * 使用说明
    @method
        检测localstorage是否可用
            isEnable() // ==> true/false
        如果使用规范存储的字段格式，使用方法
            setCache(key, value, expires)
            getCache(key)
            removeCache(key)
        原生的自定义，存储的字段名，不遵循（prefix/env/XXX/gameType/key）格式；try()catch(e){}
            setItem(key, value, expires) // 设置；当存储到达上限之后，该方法不可用
            getItem(key)       // 获取
            removeItem(key)    // 清除
            getAll()           // 获取所有
            clear()            // 清除所有

 * @author 陈立英
 * @example 
 *      var cache = new Cache({
            prefix: 'knowme',
            gameType: 'knowme',
            uid: '123456'
        });

 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {

    var Base = __webpack_require__(14);
    var Url = __webpack_require__(1);
    var win = window;

    var Cache = Base.extend({
        defaults: {
            prefix: 'ppcache', // 数据存储 key 的前缀，默认是ppcache。
            gameType: '', // 游戏类型，例如knowme
            uid: '', // 用户信息，新游戏是openId, 旧游戏是ppuid
            data: {}, // 存储缓存数据 data: {data: value, expires: 0}
            expires: -1 // 有效期，默认则为永久，单位毫秒
        },
        // 浏览器是否支持localStorage
        enable: false,

        /**
         * 初始化入口
         */
        initialize: function initialize() {
            var self = this;
            self.Parent.apply(self, arguments);

            self.isEnable();
        },
        /**
         * 设置本地缓存
         * @name set
         * @param key {String} 存储key
         * @param value {string| JSON Object} 存储内容。value会序列化
         * @param expires {Number} 单位毫秒 内容有效期设置，不设置则为永久缓存
         * @example     
         *      cache.set(key, value, expires);
         */
        setCache: function setCache(key, value, expires) {
            var name = this.getLocalKey(key);
            this.setItem(name, value, expires);
        },
        /**
         * 获取本地缓存
         * @name get
         * @param {string| JSON Object} 数据字段名。
         * @example
         *      cache.get(key);
         */
        getCache: function getCache(key) {
            var name = this.getLocalKey(key);
            return this.getItem(name);
        },
        /**
         * 移除本地缓存的数据'key'
         * @name remove
         */
        removeCache: function removeCache(key) {
            var name = this.getLocalKey(key);
            this.removeItem(name);
        },
        /**
         * 获取本地缓存的key
         */
        getLocalKey: function getLocalKey(key) {
            var prefix = this.get('prefix'),
                ret = [];
            var gameType = this.get('gameType') || '';
            var uid = this.get('uid') || '';
            var env = Url.query('env');

            if (!env || env == 'null') {
                env = 'pro';
            }

            if (prefix !== '') {
                ret.push(prefix);
            }

            if (env !== '') {
                ret.push(env);
            }

            if (uid !== '') {
                ret.push(uid);
            }

            if (gameType !== '') {
                ret.push(gameType);
            }

            if (key !== '') {
                ret.push(key);
            }

            return ret.join('/');
        },
        /**
         * 序列化工具方法
         * @name serialize
         */
        serialize: function serialize(value) {
            return JSON.stringify(value);
        },
        /**
         * 反序列化工具方法
         * @name deserialize
         */
        deserialize: function deserialize(value) {
            if (typeof value != 'string') {
                return undefined;
            }
            try {
                return JSON.parse(value);
            } catch (e) {
                return value || undefined;
            }
        },
        /**
         * 判断key是否失效
         * @return {Boolean}  true 无效； false未失效
         */
        isExpire: function isExpire(time) {
            if (time > 0) {
                return new Date().getTime() > Number(time);
            } else {
                return false;
            }
        },
        /**
         * 设置混存数据
         */
        setItem: function setItem(key, value, expires) {
            var expires = expires || this.get('expires');
            var curStamp = +new Date();
            var newValue;
            try {
                // 存储设置的本地数据
                if (expires > 0) {
                    newValue = {
                        data: value,
                        expires: curStamp + expires
                    };
                } else {
                    newValue = value;
                }
                newValue = this.serialize(newValue);
                localStorage.setItem(key, newValue);
            } catch (e) {
                // this.clear();
            }
        },
        /**
         * 获取缓存数据
         */
        getItem: function getItem(key) {
            var ret = null;

            try {
                var ret = localStorage.getItem(key);
                var opt = this.deserialize(ret);
                var isExpire = this.isExpire(opt.expires);
                // 已经失效
                if (isExpire) {
                    ret = null;
                    this.removeItem(key);
                } else {
                    return opt.expires > 0 ? opt.data : opt;
                }
            } catch (e) {}
        },
        /**
         * 清除全部数据
         */
        clear: function clear() {
            try {
                localStorage.clear();
            } catch (e) {}
        },
        /**
         * 移除数据key
         */
        removeItem: function removeItem(key) {
            try {
                localStorage.removeItem(key);
            } catch (e) {}
        },
        /**
         * 获得所有的本地缓存信息
         */
        getAll: function getAll() {
            var ret = {};
            try {
                for (var i = 0; i < localStorage.length; ++i) {
                    var key = localStorage.key(i);
                    ret[key] = this.getItem(key);
                }
            } catch (e) {}
            return ret;
        },
        /**
         * 浏览器是否支持localStorage。当存储达到上限值后。lcoalStorage.setItem()方法不可用
         * @return { Boolean } 如果浏览器支持 则返回 true, 否则返回 false.
         *  @example
         *      cache.isEnable() => true
         */
        isEnable: function isEnable() {
            var name = '__localStorageTest__';
            try {
                if ('localStorage' in win && win['localStorage'] && localStorage.setItem && localStorage.getItem) {

                    localStorage.setItem(name, name);

                    if (localStorage.getItem(name) == name) {
                        this.enable = true;
                    }
                    localStorage.removeItem(name);
                }
            } catch (e) {}

            return this.enable;
        }
    });

    module.exports = Cache;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 13 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {

    /**
     * @file 组件基类
     * @authors 子虔
     * @date    2014-05-12 17:39:36
     * @example <caption>扩展一个子类</caption>
     *      Base.extend({
     *          defaults: {}, // 设置类的默认参数
     *          constructor: function Widget(){
     *              // 子类的构造函数
     *          },
     *      });
     *
     */
    var Events = __webpack_require__(22),
        extend = __webpack_require__(24),
        attributes = __webpack_require__(26),
        isEqual = __webpack_require__(6),
        parseParam = __webpack_require__(5);

    /**
     * 组件Base类
     * @param {object} [Opts={}] - 入参
     */
    function Base(Opts) {
        // 默认配置
        this.defaults = this.defaults || {};

        // 用户配置
        this.config = Opts || {};

        // 最终配置
        this.attributes = $.extend({}, this.attributes || {}, this.defaults) || {};

        if (_typeof(this.config) == 'object') {
            this.attributes = $.extend(this.attributes, this.config) || {};
        }

        this.initialize.apply(this, arguments);
    }

    // 扩展
    $.extend(Base.prototype, Events, {
        /**
         * @constructs
         */
        constructor: Base,

        initialize: function initialize() {},

        /**
         * 频道
         * @deprecated - 当要被废弃
         */
        channel: Events.channel,

        /**
         * 获取配置
         * @param  {string} name - 名称
         * @return {*}
         */
        get: function get(name) {
            return this.attributes[name];
        },

        /**
         * 设置配置
         * @param {*} name  -属性名
         * @param {*} [value] [属性值]
         * @param {boolean} [silent=false] [变化时是否派发事件，默认派发]
         */
        set: function set(name, value, silent) {
            var lastValue;
            if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) == 'object') {
                silent = value;
                for (var key in name) {
                    if (name.hasOwnProperty(key)) {
                        this.set(key, name[key], silent);
                    }
                }
            } else {
                lastValue = this.attributes[name];
                this.attributes[name] = value;
                if (!silent && !isEqual(lastValue, value)) {
                    this.emit('change:' + name, value, lastValue);
                    this.emit('change');
                }
            }
        },

        /**
         * 重置配置
         * @param  {string[]} [whiteList=[]] - white list,不需要重置的list
         * @param  {boolean} [silent=false] - 是否不不派发事件
         */
        reset: function reset(whiteList, silent) {
            whiteList = whiteList || [];

            if (arguments.length > 1) {
                silent = !!whiteList;
            }

            this.defaults = this.defaults || {};

            for (var key in this.attributes) {
                if (this.attributes.hasOwnProperty(key) && whiteList.indexOf(key) == -1) {
                    this.set(key, this.defaults[key], silent);
                }
            }
        },
        /**
         * 销毁，默认移除事件
         */
        destroy: function destroy() {
            this.off();
        }
    });

    // 生成子类
    Base.extend = extend;

    // 修改原型
    Base.use = function (protoProps) {
        var that = this,
            protoProps = [].concat(protoProps);

        protoProps.forEach(function (proto) {
            for (var name in proto) {
                if (proto.hasOwnProperty(name)) {
                    that.prototype[name] = proto[name];
                }
            }
        });
        return this;
    };

    // 组件过滤参数
    Base.parseParam = function (protoProps) {
        var newBase;

        newBase = this.extend({
            /**
             * 过滤实例时的参数
             * @description 剔除非defaults定义的属性
             */
            initialize: function initialize() {
                this.attributes = parseParam(this.defaults || {}, this.attributes);
                this.Parent(initialize, arguments);
            }
        });

        return protoProps ? newBase.extend(protoProps) : newBase;
    };

    module.exports = Base.extend(attributes);
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TIMEOUT = exports.REQ_ERROR = exports.giftoMallService = exports.userService = exports.serviceFactory = exports.safeAjax = exports.ugMallAjax = exports.giftAjax = exports.baseAjax = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _resultresponse = __webpack_require__(49);

var _resultresponse2 = _interopRequireDefault(_resultresponse);

var _cUpPbajax = __webpack_require__(43);

var _cUpPbajax2 = _interopRequireDefault(_cUpPbajax);

var _errorHandle = __webpack_require__(52);

var _errorHandle2 = _interopRequireDefault(_errorHandle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 在对象中查找key
 * @param obj
 * @param val
 * @returns {*}
 */
function findKey(obj, val) {
    var k = null;
    Object.keys(obj).map(function (item) {
        if (obj[item] === val) {
            k = item;
        }
    });
    return k;
}

/**
 * pb请求数据
 * @param {Object} config pbajax 配置
 * @param {Object} params 参数
 * @param {Object} pbObj 解析加密参数的pd对象
 */
function baseAjax(config, params, pbObj) {
    var data = new pbObj.Request(params);
    var pbajax = new _cUpPbajax2.default();
    console.log('%c\u8BF7\u6C42\u53C2\u6570 ' + config.api, 'color:blue', params);
    return new Promise(function (resolve, reject) {
        pbajax.do($.extend(true, {
            header: {
                userToken: UG.getUser().userToken,
                lang: UG.lang.type,
                'Accept-Language': UG.lang.type
            }
        }, config), data, function (resp) {
            var dataWrapper = _resultresponse2.default.Result.decode(resp);

            console.groupCollapsed('%c \u8FD4\u56DE\u7684\u6570\u636E\u3010' + findKey(Code, dataWrapper.code) + '\u3011 ===>  ' + config.api, 'color:green');
            console.log(dataWrapper);
            console.groupEnd();

            // 标识没有登录，直接去登录就好了
            if (dataWrapper.code === 8192) {
                UG.clearUser();
                UG.router.push('/login');
            } else {
                var _data = null;
                // 不管对不对先解析data吧
                if (dataWrapper.data && dataWrapper.data.value) {
                    _data = pbObj.Response.decode(dataWrapper.data.value);
                    console.groupCollapsed('%c \u89E3\u6790\u540E\u7684\u6570\u636E ' + config.api, 'color:red');
                    console.log(_data);
                    console.groupEnd();
                }
                // 先解析正确的data
                if (dataWrapper.code === 1 || dataWrapper.code === 1064960 || dataWrapper.code === 1069056) {
                    return resolve(_data);
                } else {
                    // 先提示一下错误码
                    (0, _errorHandle2.default)(dataWrapper.code);
                    // 有data就返回data
                    return reject(_data || dataWrapper.code);
                }
            }

            reject(dataWrapper.code);
        }, function () {
            (0, _errorHandle2.default)(_errorHandle.TIMEOUT);
            reject(_errorHandle.TIMEOUT);
        }, function () {
            (0, _errorHandle2.default)(_errorHandle.REQ_ERROR);
            reject(_errorHandle.REQ_ERROR);
        });
    });
}

/**
 * @description 一个使用服务提供的柯里化函数，可以通过下面函数生成不同用途的函数
 * 1、下面创建一个统一的服务
 * const ugMallService = serviceFactory('mall');
 * 2、实例化一个方法
 * const getUgMallRanking = ugMallService('/ug/mall/ranking/list', UgMallRankingPb.UG.Mall.Ranking);
 * 3、开始调用方法
 * getUgMallRanking(params).then(data=>console.log(data)).catch(err=>console.log(err));
 *
 * 这样做的好处就是，每个地方不需要将所有的参数传递一遍，这样做的原因
 * 1、多个接口对应的是同一个服务，所以服务可以缓存
 * 2、定义方法的时候可以将请求参数无关的参数抽离，提取到每个文件的顶部，如果URL或者pb文件有变更，不需要在业务代码中到处找请求去修改
 *
 * @param {Object} service java对应的service名称，一般是php那边配置的
 * @returns {function({config?: *, header?: *, params?: *, pbObj?: *}=): *}
 */
function serviceFactory(service) {
    /**
     * @param {String} api 请求url
     * @param {Object} pbObj 解析数据的pb对象
     * @param {Object} config pbajax中的附加config
     */
    return function (api, pbObj) {
        var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        /**
         * @param {Object} params 请求参数
         */
        return function (params) {
            return baseAjax(
            //  合并配置，注意这个true是深度合并
            $.extend(true, config, { service: service, api: api }),
            //  请求参数
            params,
            //  加密解密的pb对象，包含Request和Response
            pbObj);
        };
    };
}

/**
 * Gift相关接口
 * @param {*} config
 * @param {Object} header
 * @param {*} params
 * @param {*} pbObj
 */
function giftAjax() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$config = _ref.config,
        config = _ref$config === undefined ? {} : _ref$config,
        _ref$header = _ref.header,
        header = _ref$header === undefined ? null : _ref$header,
        _ref$params = _ref.params,
        params = _ref$params === undefined ? {} : _ref$params,
        _ref$pbObj = _ref.pbObj,
        pbObj = _ref$pbObj === undefined ? {} : _ref$pbObj;

    return baseAjax(_extends({
        service: 'universal-gift'
    }, config, {
        header: _extends({}, header)
    }), params, pbObj);
}

/**
 * UGMall相关接口
 * @param {*} config
 * @param {*} header
 * @param {*} params
 * @param {*} pbObj
 */
function ugMallAjax() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref2$config = _ref2.config,
        config = _ref2$config === undefined ? {} : _ref2$config,
        _ref2$header = _ref2.header,
        header = _ref2$header === undefined ? null : _ref2$header,
        _ref2$params = _ref2.params,
        params = _ref2$params === undefined ? {} : _ref2$params,
        _ref2$pbObj = _ref2.pbObj,
        pbObj = _ref2$pbObj === undefined ? {} : _ref2$pbObj;

    return baseAjax(_extends({
        service: 'mall'
    }, config, {
        header: _extends({}, header)
    }), params, pbObj);
}

/**
 * 用户注册相关接口
 * @param {*} config
 * @param {*} header
 * @param {*} params
 * @param {*} pbObj
 */
function safeAjax() {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref3$config = _ref3.config,
        config = _ref3$config === undefined ? {} : _ref3$config,
        _ref3$header = _ref3.header,
        header = _ref3$header === undefined ? null : _ref3$header,
        _ref3$params = _ref3.params,
        params = _ref3$params === undefined ? {} : _ref3$params,
        _ref3$pbObj = _ref3.pbObj,
        pbObj = _ref3$pbObj === undefined ? {} : _ref3$pbObj;

    return baseAjax(_extends({
        service: 'safe'
    }, config, {
        header: _extends({}, header)
    }), params, pbObj);
}

var giftoMallService = serviceFactory('gifto_mall');
var userService = serviceFactory('service');

exports.baseAjax = baseAjax;
exports.giftAjax = giftAjax;
exports.ugMallAjax = ugMallAjax;
exports.safeAjax = safeAjax;
exports.serviceFactory = serviceFactory;
exports.userService = userService;
exports.giftoMallService = giftoMallService;
exports.REQ_ERROR = _errorHandle.REQ_ERROR;
exports.TIMEOUT = _errorHandle.TIMEOUT;

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createBrowserHistory", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createHashHistory", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createMemoryHistory", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createLocation", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "locationsAreEqual", function() { return locationsAreEqual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parsePath", function() { return parsePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createPath", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(152);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["a" /* default */])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(46)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var _underscore = __webpack_require__(20);

var _underscore2 = _interopRequireDefault(_underscore);

var _cUrl = __webpack_require__(1);

var _cUrl2 = _interopRequireDefault(_cUrl);

var _cUpNative = __webpack_require__(21);

var _cUpNative2 = _interopRequireDefault(_cUpNative);

var _pack = __webpack_require__(39);

var _pack2 = _interopRequireDefault(_pack);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 前端多语言解决方案
 */
var lang = _cUrl2.default.query('lang');
var tws = ['zh-SG', 'zh-MO', 'zh-TW', 'zh-HK'];
var ars = ['ar-AE', 'ar-BH', 'ar-DZ', 'ar-EG', 'ar-IQ', 'ar-JO', 'ar-KW', 'ar-LB', 'ar-LY', 'ar-MA', 'ar-OM', 'ar-QA', 'ar-SA', 'ar-SY', 'ar-TN', 'ar-YE'];
if (_cUpNative2.default.getPlatform() !== 'uplive' && !localStorage.getItem('isUplive')) {
    if (!lang) {
        var systemLanguage = navigator.language || navigator.browserLanguage;
        var _systemLanguage = systemLanguage.toLowerCase();

        switch (_systemLanguage) {
            case 'ar':
                systemLanguage = 'ar-EG';
                break;
            case 'vi':
                systemLanguage = 'vi-VN';
                break;
            case 'en':
                systemLanguage = 'en-US';
                break;
            case 'ja':
                systemLanguage = 'ja-JP';
                break;
            case 'zh':
                systemLanguage = 'zh-CN';
                break;
            default:
                break;
        }

        var arr = systemLanguage.split('-');

        if (arr.length > 1) {
            systemLanguage = arr[0] + '-' + arr[1].toUpperCase();
        } else {
            systemLanguage = 'en-US';
        }

        if (systemLanguage == 'zh-CN' || systemLanguage == 'ja-JP' || systemLanguage == 'vi-VN') {
            lang = systemLanguage;
        } else if (tws.indexOf(systemLanguage) >= 0) {
            lang = 'zh-TW';
        } else if (ars.indexOf(systemLanguage) >= 0) {
            lang = 'ar-EG';
        } else {
            lang = 'en-US';
        }
    }
} else {
    lang = lang || 'en-US';
}

var langType = lang.replace('-', '').toLowerCase();
var langPack = _pack2.default[langType] || _pack2.default['enus'];

var _lang = {

    type: lang,

    init: function init() {
        $('html').attr('lang', lang);
        $('body').addClass(langType);
    },

    template: function template(tplStr, data, insertEM) {
        var tpl = langPack[tplStr] || tplStr;
        if (tpl) {
            if (tpl.indexOf('@@@@') > 0) {
                var strArr = [];

                strArr.push('<ul>');
                tpl.split('@@@@').forEach(function (item, index) {
                    item && strArr.push('<li>' + item + '</li>');
                });
                strArr.push('</ul>');
                tpl = strArr.join('');
            }
            if (insertEM) {
                tpl = tpl.replace(/<%=([\s\S]+?)%>/g, function ($0, $1) {
                    return '<em class="' + $1 + '">' + $0 + '</em>';
                });
            }

            var compiled = _underscore2.default.template(tpl);
            return compiled(data);
        } else {
            return _underscore2.default.template(tplStr)(data);
        }
    }
};

_lang.init();
window._lang = _lang;
module.exports = _lang;

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_default_js__ = __webpack_require__(37);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_0__index_default_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_js__ = __webpack_require__(4);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "VERSION", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["VERSION"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "iteratee", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["iteratee"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "restArguments", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["restArguments"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "each", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["each"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "forEach", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["forEach"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "map", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["map"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "collect", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["collect"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "reduce", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["reduce"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "foldl", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["foldl"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "inject", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["inject"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "reduceRight", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["reduceRight"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "foldr", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["foldr"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "find", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["find"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "detect", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["detect"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "filter", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["filter"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "select", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["select"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "reject", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["reject"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "every", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["every"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "all", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["all"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "some", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["some"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "any", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["any"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "contains", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["contains"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "includes", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["includes"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "include", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["include"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "invoke", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["invoke"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "pluck", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["pluck"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "where", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["where"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "findWhere", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["findWhere"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "max", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["max"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "min", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["min"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "shuffle", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["shuffle"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "sample", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["sample"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "sortBy", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["sortBy"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "groupBy", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["groupBy"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "indexBy", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["indexBy"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "countBy", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["countBy"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "toArray", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["toArray"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "size", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["size"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "partition", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["partition"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "first", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["first"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "head", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["head"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "take", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["take"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "initial", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["initial"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "last", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["last"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "rest", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["rest"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "tail", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["tail"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "drop", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["drop"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "compact", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["compact"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "flatten", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["flatten"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "without", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["without"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "uniq", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["uniq"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "unique", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["unique"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "union", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["union"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "intersection", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["intersection"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "difference", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["difference"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "unzip", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["unzip"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "zip", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["zip"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "object", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["object"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "findIndex", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["findIndex"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "findLastIndex", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["findLastIndex"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "sortedIndex", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["sortedIndex"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "indexOf", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["indexOf"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "lastIndexOf", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["lastIndexOf"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "range", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["range"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "chunk", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["chunk"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "bind", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["bind"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "partial", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["partial"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "bindAll", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["bindAll"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "memoize", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["memoize"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "delay", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["delay"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "defer", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["defer"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "throttle", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["throttle"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "debounce", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["debounce"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "wrap", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["wrap"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "negate", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["negate"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["compose"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "after", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["after"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "before", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["before"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "once", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["once"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "keys", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["keys"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "allKeys", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["allKeys"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "values", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["values"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "mapObject", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["mapObject"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "pairs", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["pairs"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "invert", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["invert"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "functions", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["functions"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "methods", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["methods"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "extend", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["extend"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "extendOwn", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["extendOwn"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "assign", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["assign"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "findKey", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["findKey"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "pick", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["pick"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "omit", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["omit"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "defaults", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["defaults"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "create", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["create"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "clone", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["clone"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "tap", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["tap"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isMatch", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isMatch"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isEqual", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isEqual"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isEmpty", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isEmpty"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isElement", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isElement"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isArray", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isArray"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isObject", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isObject"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isArguments", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isArguments"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isFunction", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isFunction"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isString", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isString"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isNumber", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isNumber"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isDate", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isDate"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isRegExp", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isRegExp"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isError", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isError"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isSymbol", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isSymbol"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isMap", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isMap"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isWeakMap", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isWeakMap"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isSet", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isSet"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isWeakSet", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isWeakSet"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isFinite", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isFinite"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isNaN", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isNaN"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isBoolean", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isBoolean"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isNull", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isNull"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isUndefined", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isUndefined"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "has", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["has"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "identity", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["identity"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "constant", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["constant"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "noop", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["noop"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "property", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["property"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "propertyOf", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["propertyOf"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "matcher", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["matcher"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "matches", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["matches"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "times", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["times"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "random", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["random"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "now", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["now"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "escape", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["escape"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "unescape", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["unescape"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "result", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["result"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "uniqueId", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["uniqueId"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "templateSettings", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["templateSettings"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "template", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["template"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "chain", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["chain"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "mixin", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["mixin"]; });




/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * H5与native协议 js文件
 */
(function (win, $, UpSDK) {
    var apiStatus = {};
    var iframe = null;
    var urlPrefixCallAppInAndroid = 'uplivecn://goWindow'; // android调用外部协议
    var urlPrefixCallAppInIos = void 0;

    if (window.isUpVoice) {
        // 声播协议
        urlPrefixCallAppInIos = 'https://voice.upliveapps.com/goWindow'; // ios调用外部协议
    } else {
        urlPrefixCallAppInIos = 'https://ios.upliveapps.com/goWindow'; // ios调用外部协议
    }

    var native = {
        send: function send(url) {
            if (iframe) {
                document.body.removeChild(iframe);
                iframe = null;
            }
            if (!iframe) {
                iframe = document.createElement('iframe');
                iframe.id = 'up_callapp_iframe_' + Date.now();
                iframe.frameborder = '0';
                iframe.style.cssText = 'display:none;border:0;width:0;height:0;';
                document.body.appendChild(iframe);
            }
            iframe.src = url;
        },
        sendUriScheme: function sendUriScheme(url) {
            window.location.href = url;
        },
        query: function query(name, scope) {
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"),
                scope = scope || 'search',
                r = location[scope].substr(1).match(reg);
            if (r != null) {
                return unescape(r[2]);
            }
            return null;
        },


        addParam: function addParam(url, data) {
            if (typeof data === 'undefined') {
                return;
            }

            var hashReg = /#.*$/gi,
                hashMatch = url.match(hashReg),
                hash = '';

            if (hashMatch) {
                hash = hashMatch[0];
            }

            // 去除hash值的url
            var preUrl = url.replace(hash, '');

            var searchReg = /\?(.*?)$/gi;
            var result = searchReg.exec(preUrl);
            var query;
            if (result) {
                query = result[1].split('#')[0];
            }

            var id = !query ? '' : '&';

            return preUrl + (query && query.length > 0 ? '' : '?') + (id + $.param(data)) + hash;
        },
        // 获得平台类型
        // weixin, weibo, qq, uplive，海外版本Android在URL Hash中添加标识 #pl=uplive
        getPlatform: function getPlatform() {
            var _ref = [navigator.userAgent, 'other'],
                ua = _ref[0],
                pl = _ref[1];


            if (ua.match(/uplive/i) || this.query('pl', 'hash') == 'uplive' || localStorage.getItem('__inuplive__') || this.query('pl') == 'uplive') {
                pl = 'uplive';
            } else if (ua.match(/micromessenger/i)) {
                pl = 'wechat';
            } else if (ua.match(/qq\//i)) {
                pl = 'qq';
            } else if (ua.match(/weibo/i)) {
                pl = 'weibo';
            } else if (ua.match(/renren/i)) {
                pl = 'renren';
            } else if (ua.indexOf("FBAN") > -1 || ua.indexOf("FBAV") > -1) {
                pl = 'fb';
            } else if (ua.match(/Line/i)) {
                pl = 'line';
            }

            return pl;
        },


        // 获得当前系统类型
        getSystem: function getSystem() {
            var ua = navigator.userAgent;
            return (/(iPhone|iPad|iPod|iOS)/i.test(ua) ? 'ios' : /[aA]ndroid/i.test(ua) ? 'android' : 'pc'
            );
        },


        // 系统语言
        getLanguage: function getLanguage() {
            var language = navigator.language || navigator.browserLanguage;

            if (language) {
                var arr = language.split('-');
                arr[1] = arr[1].toUpperCase();
                language = arr.join('-');
            }

            return language;
        },


        // 检查api是否可用
        checkAvail: function checkAvail() {
            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                apiname = _ref2.apiname,
                errtip = _ref2.errtip;

            setTimeout(function () {
                if (!apiStatus[apiname] && errtip) {
                    if (typeof errtip == 'function') {
                        errtip();
                    } else {
                        alert(errtip);
                    }
                }
            }, 3000);
        },

        /**
         * 获取配置信息
         * @param cfg {
         *      invalid 0: usertoken失效，重新获取；1：第一次获取
         *      complete: function(){}
         * }
         *
         */
        getConfigs: function getConfigs() {
            var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref3$complete = _ref3.complete,
                complete = _ref3$complete === undefined ? function () {} : _ref3$complete,
                _ref3$invalid = _ref3.invalid,
                invalid = _ref3$invalid === undefined ? 0 : _ref3$invalid,
                _ref3$errtip = _ref3.errtip,
                errtip = _ref3$errtip === undefined ? '不支持' : _ref3$errtip;

            var self = this;
            var url = 'uplive://getConfigs?json=';
            var params = {
                invalid: invalid,
                receive: "$['upliveapp_getConfigs']",
                jsCallback: '$.getConfigsComplete'
            };

            $.getConfigsComplete = function (param) {
                // usertoken: "", uid: "", language: ""
                complete.call(self, JSON.parse(param));
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'getConfigs',
                errtip: errtip
            });
        },


        /**
         * 获取主播信息
         * @param cfg {
         *      complete: function(){}
         * }
         *
         */
        getHostInfo: function getHostInfo() {
            var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref4$complete = _ref4.complete,
                complete = _ref4$complete === undefined ? function () {} : _ref4$complete,
                _ref4$errtip = _ref4.errtip,
                errtip = _ref4$errtip === undefined ? '不支持' : _ref4$errtip;

            var self = this;
            var url = 'uplive://getHostInfo?json=';
            var params = {
                receive: "$['upliveapp_getHostInfo']",
                jsCallback: '$.getHostInfoComplete'
            };

            $.getHostInfoComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'getHostInfo',
                errtip: errtip
            });
        },


        // 上报提现结果给客户端
        acceptAgreement: function acceptAgreement() {
            var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref5$errtip = _ref5.errtip,
                errtip = _ref5$errtip === undefined ? '不支持' : _ref5$errtip;

            var url = 'uplive://acceptAgreement?json=';
            var params = {
                receive: "$['upliveapp_acceptAgreement']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'acceptAgreement',
                errtip: errtip
            });
        },

        /**
         * 跳转个人主页
         * @param cfg {
         *      uid: 10234, // {Number} 整型
                tab: 0：动态 1：关注 2：粉丝 3：守护
         * }
         */
        profile: function profile() {
            var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref6$uid = _ref6.uid,
                uid = _ref6$uid === undefined ? 0 : _ref6$uid,
                _ref6$tab = _ref6.tab,
                tab = _ref6$tab === undefined ? 0 : _ref6$tab,
                _ref6$errtip = _ref6.errtip,
                errtip = _ref6$errtip === undefined ? '' : _ref6$errtip,
                _ref6$action = _ref6.action,
                action = _ref6$action === undefined ? 'callapp' : _ref6$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'profile',
                extend: {
                    uid: parseInt(uid, 10),
                    tab: tab
                },
                receive: "$['upliveapp_profile']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'profile',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },

        /**
         * 跳转到直播间
         * @param cfg {
         *      uid: 10234, // {Number} 整型
         *      roomid: 10234 {Number} 整型
         * }
         */
        goRoom: function goRoom() {
            var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref7$uid = _ref7.uid,
                uid = _ref7$uid === undefined ? 0 : _ref7$uid,
                _ref7$roomid = _ref7.roomid,
                roomid = _ref7$roomid === undefined ? 0 : _ref7$roomid,
                _ref7$errtip = _ref7.errtip,
                errtip = _ref7$errtip === undefined ? '' : _ref7$errtip,
                _ref7$action = _ref7.action,
                action = _ref7$action === undefined ? 'callapp' : _ref7$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'room',
                extend: {
                    uid: parseInt(uid, 10),
                    roomid: parseInt(roomid, 10)
                },
                receive: "$['upliveapp_goRoom']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goRoom',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },
        goRank: function goRank() {
            var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref8$name = _ref8.name,
                name = _ref8$name === undefined ? 1 : _ref8$name,
                _ref8$errtip = _ref8.errtip,
                errtip = _ref8$errtip === undefined ? '' : _ref8$errtip,
                _ref8$action = _ref8.action,
                action = _ref8$action === undefined ? 'callapp' : _ref8$action;

            var url = 'uplive://goWindow?json=';
            var key = void 0;

            switch (parseInt(name, 10)) {
                case 1:
                    key = 'starank';
                    break;
                case 2:
                    key = 'hostrank';
                    break;
                case 3:
                    key = 'wealthrank';
                    break;
                default:
                    key = 'starank';
            }

            var params = {
                key: key,
                receive: "$['upliveapp_goRank']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goRank',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        // 跳转充值界面
        gopay: function gopay() {
            var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref9$errtip = _ref9.errtip,
                errtip = _ref9$errtip === undefined ? '' : _ref9$errtip,
                _ref9$complete = _ref9.complete,
                complete = _ref9$complete === undefined ? function () {} : _ref9$complete,
                _ref9$action = _ref9.action,
                action = _ref9$action === undefined ? 'callapp' : _ref9$action;

            var self = this;
            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'pay',
                receive: "$['upliveapp_gopay']",
                jsCallback: "$['getGopayComplete']"
            };

            $.getGopayComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'gopay',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        // 上报提现结果给客户端
        reportCashResult: function reportCashResult() {
            var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref10$success = _ref10.success,
                success = _ref10$success === undefined ? 1 : _ref10$success,
                errtip = _ref10.errtip;

            var url = 'uplive://h5cash?json=';
            var params = {
                success: success,
                receive: "$['upliveapp_reportCashResult']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'reportCashResult',
                errtip: errtip
            });
        },


        // 上报充值结果给客户端
        reportPayResult: function reportPayResult() {
            var _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref11$success = _ref11.success,
                success = _ref11$success === undefined ? 1 : _ref11$success,
                errtip = _ref11.errtip;

            var url = 'uplive://h5payment?json=';
            var params = {
                success: success,
                receive: "$['upliveapp_reportPayResult']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'reportPayResult',
                errtip: errtip
            });
        },


        // 关闭webview
        closeWindow: function closeWindow() {
            var _ref12 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref12$errtip = _ref12.errtip,
                errtip = _ref12$errtip === undefined ? '' : _ref12$errtip;

            var url = 'uplive://closeWindow?json=';
            var params = {
                receive: "$['upliveapp_closeWindow']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'closeWindow',
                errtip: errtip
            });
        },


        // 浏览器中打开
        openBrowser: function openBrowser() {
            var _ref13 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref13$url = _ref13.url,
                url = _ref13$url === undefined ? '' : _ref13$url,
                _ref13$errtip = _ref13.errtip,
                errtip = _ref13$errtip === undefined ? '' : _ref13$errtip,
                _ref13$action = _ref13.action,
                action = _ref13$action === undefined ? 'callapp' : _ref13$action;

            var _url = 'uplive://openBrowser?json=';
            var params = {
                receive: "$['upliveapp_openBrowser']",
                url: url
            };

            _url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(_url);
                this.checkAvail({
                    apiname: 'openBrowser',
                    errtip: errtip
                });
            } else {
                return _url;
            }
        },

        // 打开新的webview
        openWebView: function openWebView() {
            var _ref14 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref14$url = _ref14.url,
                url = _ref14$url === undefined ? '' : _ref14$url,
                _ref14$errtip = _ref14.errtip,
                errtip = _ref14$errtip === undefined ? '' : _ref14$errtip,
                _ref14$action = _ref14.action,
                action = _ref14$action === undefined ? 'callapp' : _ref14$action;

            var _url = 'uplive://openWebView?json=';
            var params = {
                receive: "$['upliveapp_openWebView']",
                url: url
            };

            _url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(_url);
                this.checkAvail({
                    apiname: 'openWebView',
                    errtip: errtip
                });
            } else {
                return _url;
            }
        },


        // 获取地理位置
        getLocation: function getLocation() {
            var _ref15 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref15$complete = _ref15.complete,
                complete = _ref15$complete === undefined ? function () {} : _ref15$complete,
                _ref15$errtip = _ref15.errtip,
                errtip = _ref15$errtip === undefined ? '不支持' : _ref15$errtip;

            var self = this;
            var url = 'uplive://getLocation?json=';
            var params = {
                receive: "$['upliveapp_getLocation']",
                jsCallback: '$.getLocationComplete'
            };

            $.getLocationComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'getLocation',
                errtip: errtip
            });
        },

        /**
         * 支付调用
         * @param data {object}
         *      - platform 支付平台
         *      - complete {function}
         *      - params 参数
         * @return this
         */
        pay: function pay() {
            var _ref16 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref16$complete = _ref16.complete,
                complete = _ref16$complete === undefined ? function () {} : _ref16$complete,
                _ref16$platform = _ref16.platform,
                platform = _ref16$platform === undefined ? 'wxpay' : _ref16$platform,
                _ref16$productId = _ref16.productId,
                productId = _ref16$productId === undefined ? '' : _ref16$productId,
                _ref16$errtip = _ref16.errtip,
                errtip = _ref16$errtip === undefined ? '不支持支付' : _ref16$errtip;

            var self = this;
            var _url = 'uplive://payment?json=';
            var _params = {
                receive: "$['upliveapp_pay']",
                platform: platform || 'wxpay',
                params: {
                    productId: productId
                },
                jsCallback: '$.payComplete'
            };

            $.payComplete = function (param) {
                // 支付
                complete.call(self, JSON.parse(param));
            };

            this.send(_url + JSON.stringify(_params));
            this.checkAvail({
                apiname: 'pay',
                errtip: errtip
            });
        },

        /**
         * 支付调用,充值U钻最小档
         * @param data {object}
         *      - platform 支付平台
         *      - complete {function}
         *      - params 参数
         * @return this
         */
        rechargeMin: function rechargeMin() {
            var _ref17 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref17$complete = _ref17.complete,
                complete = _ref17$complete === undefined ? function () {} : _ref17$complete,
                _ref17$errtip = _ref17.errtip,
                errtip = _ref17$errtip === undefined ? '不支持支付' : _ref17$errtip;

            var self = this;
            var _url = 'uplive://rechargeMin?json=';
            var _params = {
                receive: "$['upliveapp_rechargeMin']",
                jsCallback: '$.payComplete'
            };

            $.payComplete = function (param) {
                // 支付
                complete.call(self, JSON.parse(param));
            };

            this.send(_url + JSON.stringify(_params));
            this.checkAvail({
                apiname: 'pay',
                errtip: errtip
            });
        },
        ynpay: function ynpay() {
            var _ref18 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref18$complete = _ref18.complete,
                complete = _ref18$complete === undefined ? function () {} : _ref18$complete,
                _ref18$platform = _ref18.platform,
                platform = _ref18$platform === undefined ? 'wxpay' : _ref18$platform,
                _ref18$productId = _ref18.productId,
                productId = _ref18$productId === undefined ? '' : _ref18$productId,
                _ref18$orderStr = _ref18.orderStr,
                orderStr = _ref18$orderStr === undefined ? '' : _ref18$orderStr,
                _ref18$orderId = _ref18.orderId,
                orderId = _ref18$orderId === undefined ? '' : _ref18$orderId,
                _ref18$errtip = _ref18.errtip,
                errtip = _ref18$errtip === undefined ? '不支持支付' : _ref18$errtip;

            var self = this;
            var _url = 'uplive://ynzf?json=';
            var _params = {
                receive: "$['upliveapp_ynpay']",
                platform: platform || 'wxpay',
                params: {
                    orderId: orderId + '',
                    productId: productId + '',
                    orderStr: orderStr
                },
                jsCallback: '$.payComplete'
            };

            $.payComplete = function (param) {
                // 支付
                complete.call(self, JSON.parse(param));
            };

            this.send(_url + JSON.stringify(_params));
            this.checkAvail({
                apiname: 'ynpay',
                errtip: errtip
            });
        },
        checkRepairOrder: function checkRepairOrder() {
            var _ref19 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref19$complete = _ref19.complete,
                complete = _ref19$complete === undefined ? function () {} : _ref19$complete,
                _ref19$errtip = _ref19.errtip,
                errtip = _ref19$errtip === undefined ? '' : _ref19$errtip;

            var self = this;
            var url = 'uplive://checkRepairOrder?json=';
            var params = {
                receive: "$['upliveapp_checkRepairOrder']",
                jsCallback: '$.checkRepairOrderComplete'
            };

            $.checkRepairOrderComplete = function (param) {
                // 支付
                complete.call(self, JSON.parse(param));
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'checkRepairOrder',
                errtip: errtip
            });
        },
        goRepairOrder: function goRepairOrder() {
            var _ref20 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref20$complete = _ref20.complete,
                complete = _ref20$complete === undefined ? function () {} : _ref20$complete,
                _ref20$errtip = _ref20.errtip,
                errtip = _ref20$errtip === undefined ? '' : _ref20$errtip;

            var url = 'uplive://goRepairOrder?json=';
            var params = {
                receive: "$['upliveapp_goRepairOrder']",
                jsCallback: '$.goRepairOrderComplete'
            };

            $.goRepairOrderComplete = function (param) {
                // 支付
                complete.call(self, JSON.parse(param));
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'goRepairOrder',
                errtip: errtip
            });
        },

        // 通过相机获取图片
        getPhotoCamera: function getPhotoCamera() {
            var _ref21 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref21$complete = _ref21.complete,
                complete = _ref21$complete === undefined ? function () {} : _ref21$complete,
                _ref21$type = _ref21.type,
                type = _ref21$type === undefined ? "share" : _ref21$type,
                _ref21$crop = _ref21.crop,
                crop = _ref21$crop === undefined ? 0 : _ref21$crop,
                _ref21$width = _ref21.width,
                width = _ref21$width === undefined ? 640 : _ref21$width,
                _ref21$height = _ref21.height,
                height = _ref21$height === undefined ? 640 : _ref21$height,
                _ref21$errtip = _ref21.errtip,
                errtip = _ref21$errtip === undefined ? '不支持' : _ref21$errtip;

            var self = this;
            var url = 'uplive://getPhoto?json=';
            var params = {
                type: type || 'share',
                sourceType: "camera", //图片来源，照相机
                crop: crop,
                width: width,
                height: height,
                receive: "$['upliveapp_getPhotoCamera']",
                jsCallback: '$.getPhotoCameraComplete'
            };

            $.getPhotoCameraComplete = function (param) {
                // "url":"网络链接"
                complete.call(self, JSON.parse(param));
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'getPhotoCamera',
                errtip: errtip
            });
        },

        // 通过图库获取图片
        getPhotoAlbum: function getPhotoAlbum() {
            var _ref22 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref22$complete = _ref22.complete,
                complete = _ref22$complete === undefined ? function () {} : _ref22$complete,
                _ref22$type = _ref22.type,
                type = _ref22$type === undefined ? "share" : _ref22$type,
                _ref22$crop = _ref22.crop,
                crop = _ref22$crop === undefined ? 0 : _ref22$crop,
                _ref22$width = _ref22.width,
                width = _ref22$width === undefined ? 640 : _ref22$width,
                _ref22$height = _ref22.height,
                height = _ref22$height === undefined ? 640 : _ref22$height,
                _ref22$errtip = _ref22.errtip,
                errtip = _ref22$errtip === undefined ? '不支持' : _ref22$errtip;

            var self = this;
            var url = 'uplive://getPhoto?json=';
            var params = {
                type: type || 'share',
                sourceType: "album", //图片来源，照相机
                crop: crop,
                width: width,
                height: height,
                receive: "$['upliveapp_getPhotoAlbum']",
                jsCallback: '$.getPhotoAlbumComplete'
            };

            $.getPhotoAlbumComplete = function (param) {
                // "url":"网络链接"
                complete.call(self, JSON.parse(param));
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'getPhotoAlbum',
                errtip: errtip
            });
        },


        // 客户端分享
        share: function share() {
            var _ref23 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref23$complete = _ref23.complete,
                complete = _ref23$complete === undefined ? function () {} : _ref23$complete,
                _ref23$title = _ref23.title,
                title = _ref23$title === undefined ? '分享标题' : _ref23$title,
                _ref23$url = _ref23.url,
                url = _ref23$url === undefined ? 'http://www.baidu.com' : _ref23$url,
                _ref23$imageUrl = _ref23.imageUrl,
                imageUrl = _ref23$imageUrl === undefined ? 'https://m.baidu.com/static/index/plus/plus_logo.png' : _ref23$imageUrl,
                _ref23$desc = _ref23.desc,
                desc = _ref23$desc === undefined ? '分享表述' : _ref23$desc,
                _ref23$platform = _ref23.platform,
                platform = _ref23$platform === undefined ? {} : _ref23$platform,
                _ref23$errtip = _ref23.errtip,
                errtip = _ref23$errtip === undefined ? '客户端不支持分享' : _ref23$errtip;

            var self = this;
            var _url = 'uplive://sharePage?json=';
            var pls = ['qq', 'qzone', 'wechat_friends', 'wechat_circle', 'sina', 'fb', 'tw'];
            var oauthtype = { 'fb': 'fb', 'tw': 'twitter', 'sina': 'weibo' };

            var params = {
                receive: "$['upliveapp_share']",
                platform: {},
                jsCallback: '$.upliveShareComplete'
            };

            pls.forEach(function (item, i) {
                params.platform[item] = {
                    url: url,
                    title: title,
                    imageUrl: imageUrl,
                    desc: desc
                };
            });

            if (JSON.stringify(platform) != '{}') {
                params = $.extend(true, params, {
                    platform: platform
                });
            }

            for (var i in params) {
                if (i == 'platform') {
                    for (var j in params[i]) {
                        for (var k in params[i][j]) {
                            if (k == 'title' || k == 'desc') {
                                params[i][j][k] = encodeURIComponent(params[i][j][k]);
                            }
                            if (k == 'url' && params[i][j][k] && oauthtype[j]) {
                                var _url2 = params[i][j][k];

                                params[i][j][k] = this.addParam(_url2, {
                                    oauthtype: oauthtype[j]
                                });
                            }
                        }
                    }
                }
            }

            $.upliveShareComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };
            this.send(_url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'share',
                errtip: errtip
            });
        },


        // 单渠道分享
        singleShare: function singleShare() {
            var _ref24 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref24$complete = _ref24.complete,
                complete = _ref24$complete === undefined ? function () {} : _ref24$complete,
                _ref24$title = _ref24.title,
                title = _ref24$title === undefined ? '分享标题' : _ref24$title,
                _ref24$url = _ref24.url,
                url = _ref24$url === undefined ? 'http://www.baidu.com' : _ref24$url,
                _ref24$imageUrl = _ref24.imageUrl,
                imageUrl = _ref24$imageUrl === undefined ? 'https://m.baidu.com/static/index/plus/plus_logo.png' : _ref24$imageUrl,
                _ref24$desc = _ref24.desc,
                desc = _ref24$desc === undefined ? '分享表述' : _ref24$desc,
                _ref24$type = _ref24.type,
                type = _ref24$type === undefined ? 'fb' : _ref24$type,
                _ref24$errtip = _ref24.errtip,
                errtip = _ref24$errtip === undefined ? '客户端不支持分享' : _ref24$errtip,
                _ref24$action = _ref24.action,
                action = _ref24$action === undefined ? 'callapp' : _ref24$action;

            var self = this;
            var system = this.getSystem();
            var _url = 'uplive://singleShare?json=';
            var pls = ["qq", "qzone", "wechat_friends", "wechat_circle", "sina", "fb", "tw", "messenger", "whatsapp", "ins", "line", "kakao"];
            var oauthtype = { 'fb': 'fb', 'tw': 'twitter', 'sina': 'weibo' };

            if (url && oauthtype[type]) {
                url = this.addParam(url, {
                    oauthtype: oauthtype[type]
                });
            }
            if (type == 'sina') {
                desc += '>>' + url;
            }
            var params = {
                receive: "$['upliveapp_singleShare']",
                platform: {
                    url: url,
                    title: system == 'ios' ? title : encodeURIComponent(title),
                    imageUrl: imageUrl,
                    desc: system == 'ios' ? desc : encodeURIComponent(desc)
                },
                type: type,
                jsCallback: '$.upliveSingleShareComplete'
            };

            $.upliveSingleShareComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };

            _url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(_url);
                this.checkAvail({
                    apiname: 'singleShare',
                    errtip: errtip
                });
            } else {
                return _url;
            }
        },


        // 1.6.5 根据国家码跳转到国家主播列表
        goHotListByArea: function goHotListByArea() {
            var _ref25 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref25$countryCode = _ref25.countryCode,
                countryCode = _ref25$countryCode === undefined ? '' : _ref25$countryCode,
                _ref25$errtip = _ref25.errtip,
                errtip = _ref25$errtip === undefined ? '' : _ref25$errtip;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'hotbyarea',
                extend: {
                    countryCode: countryCode
                },
                receive: "$['upliveapp_goHotListByArea']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'goHotListByArea',
                errtip: errtip
            });
        },

        /*--------------------- V2.0.0 -------------------*/

        // 游客登录
        login: function login() {
            var _ref26 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref26$complete = _ref26.complete,
                complete = _ref26$complete === undefined ? function () {} : _ref26$complete,
                _ref26$errtip = _ref26.errtip,
                errtip = _ref26$errtip === undefined ? '不支持登录' : _ref26$errtip;

            var self = this;
            var url = 'uplive://goLogin?json=';
            var params = {
                receive: "$['upliveapp_login']",
                jsCallback: '$.loginComplete'
            };
            $.loginComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };
            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'login',
                errtip: errtip
            });
        },


        // 刷新用户信息
        refreshProfile: function refreshProfile() {
            var _ref27 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref27$errtip = _ref27.errtip,
                errtip = _ref27$errtip === undefined ? '不支持刷新用户信息' : _ref27$errtip;

            var url = 'uplive://refreshProfile?json=';
            var params = {
                receive: "$['upliveapp_refreshProfile']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'refreshProfile',
                errtip: errtip
            });
        },


        /* -------------------- ios 我的收益 --------------------- */

        goCashRecord: function goCashRecord() {
            var _ref28 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref28$errtip = _ref28.errtip,
                errtip = _ref28$errtip === undefined ? '不支持领取纪录' : _ref28$errtip;

            var url = 'uplive://goCashRecord?json=';
            var params = {
                receive: "$['upliveapp_goCashRecord']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'goCashRecord',
                errtip: errtip
            });
        },
        bindMobilePhone: function bindMobilePhone() {
            var _ref29 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref29$complete = _ref29.complete,
                complete = _ref29$complete === undefined ? function () {} : _ref29$complete,
                _ref29$errtip = _ref29.errtip,
                errtip = _ref29$errtip === undefined ? '不支持手机绑定' : _ref29$errtip;

            var self = this;
            var url = 'uplive://bindMobilePhone?json=';
            var params = {
                receive: "$['upliveapp_bindMobilePhone']",
                jsCallback: '$.bindMobilePhoneComplete'
            };
            $.bindMobilePhoneComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };
            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'bindMobilePhone',
                errtip: errtip
            });
        },
        bindWechat: function bindWechat() {
            var _ref30 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref30$complete = _ref30.complete,
                complete = _ref30$complete === undefined ? function () {} : _ref30$complete,
                _ref30$errtip = _ref30.errtip,
                errtip = _ref30$errtip === undefined ? '不支持微信绑定' : _ref30$errtip;

            var self = this;
            var url = 'uplive://bindWechat?json=';
            var params = {
                receive: "$['upliveapp_bindWechat']",
                jsCallback: '$.bindWechatComplete'
            };
            $.bindWechatComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };
            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'bindWechat',
                errtip: errtip
            });
        },
        setTitle: function setTitle() {
            var _ref31 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref31$title = _ref31.title,
                title = _ref31$title === undefined ? '' : _ref31$title,
                _ref31$errtip = _ref31.errtip,
                errtip = _ref31$errtip === undefined ? function () {} : _ref31$errtip;

            var self = this;
            var system = this.getSystem();
            var _url = 'uplive://setTitle?json=';
            var _params = {
                receive: "$['upliveapp_setTitle']",
                params: {
                    title: title
                }
            };

            if (system == 'android') {
                document.title = title;
            } else {
                this.send(_url + JSON.stringify(_params));
                this.checkAvail({
                    apiname: 'setTitle',
                    errtip: errtip
                });
            }
        },


        /**
         * 设置客户端导航  点击icon支持回调函数,pagePath不去掉是为了兼容之前的其他项目
         */
        setNavBar: function setNavBar() {
            var _ref32 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref32$backgroundColo = _ref32.backgroundColor,
                backgroundColor = _ref32$backgroundColo === undefined ? '#FFFFFF' : _ref32$backgroundColo,
                _ref32$skin = _ref32.skin,
                skin = _ref32$skin === undefined ? 0 : _ref32$skin,
                _ref32$iconPath = _ref32.iconPath,
                iconPath = _ref32$iconPath === undefined ? '' : _ref32$iconPath,
                _ref32$pagePath = _ref32.pagePath,
                pagePath = _ref32$pagePath === undefined ? '' : _ref32$pagePath,
                _ref32$iconCallback = _ref32.iconCallback,
                iconCallback = _ref32$iconCallback === undefined ? null : _ref32$iconCallback,
                _ref32$errtip = _ref32.errtip,
                errtip = _ref32$errtip === undefined ? function () {} : _ref32$errtip;

            var self = this;
            var system = this.getSystem();
            var _url = 'uplive://setNavBar?json=';
            var _params = {
                receive: "$['upliveapp_setNavBar']",
                params: {
                    backgroundColor: backgroundColor, // 十六进制
                    skin: skin, // 0: 默认紫色back + 黑色文本；1: 白色back + 白色文本
                    iconPath: iconPath, // 图片路径
                    pagePath: pagePath // 点击icon的页面路径,

                }
            };
            if (iconCallback && typeof iconCallback === 'function') {
                _params['jsCallback'] = "$.setNavBarComplete";

                $.setNavBarComplete = function () {
                    iconCallback.call(self);
                };
            }

            this.send(_url + JSON.stringify(_params));
            this.checkAvail({
                apiname: 'setNavBar',
                errtip: errtip
            });
        },

        /* ----------------------V 2.6.0 -------------------*/
        /**
         * 跳转到开播准备页面
         * @param cfg {
         * }
         */
        goReadyToLive: function goReadyToLive() {
            var _ref33 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref33$errtip = _ref33.errtip,
                errtip = _ref33$errtip === undefined ? '' : _ref33$errtip,
                _ref33$action = _ref33.action,
                action = _ref33$action === undefined ? 'callapp' : _ref33$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'readyToLive',
                receive: "$['upliveapp_goReadyToLive']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goReadyToLive',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        /**
         * 跳转到我的背包页面
         * @param cfg {
         * }
         */
        goPack: function goPack() {
            var _ref34 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref34$errtip = _ref34.errtip,
                errtip = _ref34$errtip === undefined ? '' : _ref34$errtip,
                _ref34$action = _ref34.action,
                action = _ref34$action === undefined ? 'callapp' : _ref34$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'pack',
                receive: "$['upliveapp_goPack']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goPack',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        /**
         * 跳转到发现列表
         * @param cfg {
         * }
         */
        goFindList: function goFindList() {
            var _ref35 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref35$errtip = _ref35.errtip,
                errtip = _ref35$errtip === undefined ? '' : _ref35$errtip,
                _ref35$action = _ref35.action,
                action = _ref35$action === undefined ? 'callapp' : _ref35$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'findList',
                receive: "$['upliveapp_goFindList']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goFindList',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        /**
         * 跳转到热门列表
         * @param cfg {
         * }
         */
        goHotList: function goHotList() {
            var _ref36 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref36$errtip = _ref36.errtip,
                errtip = _ref36$errtip === undefined ? '' : _ref36$errtip,
                _ref36$action = _ref36.action,
                action = _ref36$action === undefined ? 'callapp' : _ref36$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'hotList',
                receive: "$['upliveapp_goHotList']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goHotList',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        /**
         * 跳转到VIP特权页面
         * @param cfg {
         * }
         */
        goVipPrivileges: function goVipPrivileges() {
            var _ref37 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref37$errtip = _ref37.errtip,
                errtip = _ref37$errtip === undefined ? '' : _ref37$errtip;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'vipPrivileges',
                receive: "$['upliveapp_goVipPrivileges']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'goVipPrivileges',
                errtip: errtip
            });
        },


        /**
        * 跳转到VIP特权设置页面
        * @param cfg {
        * }
        */
        goVipPrivilegesSetting: function goVipPrivilegesSetting() {
            var _ref38 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref38$errtip = _ref38.errtip,
                errtip = _ref38$errtip === undefined ? '' : _ref38$errtip,
                _ref38$action = _ref38.action,
                action = _ref38$action === undefined ? 'callapp' : _ref38$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'vipPrivilegesSetting',
                receive: "$['upliveapp_goVipPrivilegesSetting']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goVipPrivilegesSetting',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        /**
         * 跳转开通守护
         * uid  主播id
         * roomId 直播间id
         * complete 回调方法
         */
        goOpenGuard: function goOpenGuard() {
            var _ref39 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref39$uid = _ref39.uid,
                uid = _ref39$uid === undefined ? 0 : _ref39$uid,
                _ref39$roomId = _ref39.roomId,
                roomId = _ref39$roomId === undefined ? 0 : _ref39$roomId,
                _ref39$complete = _ref39.complete,
                complete = _ref39$complete === undefined ? function () {} : _ref39$complete,
                _ref39$errtip = _ref39.errtip,
                errtip = _ref39$errtip === undefined ? '' : _ref39$errtip,
                _ref39$action = _ref39.action,
                action = _ref39$action === undefined ? 'callapp' : _ref39$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'openGuard',
                extend: {
                    uid: uid,
                    roomid: roomId
                },
                receive: "$['upliveapp_goOpenGuard']",
                "jsCallback": "$.buyOpenGuardComplete"
            };

            $.buyOpenGuardComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goOpenGuard',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        /**
         *
         * 跳转IM聊天
         * uid  主播id
         *
         */

        openChat: function openChat() {
            var _ref40 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref40$uid = _ref40.uid,
                uid = _ref40$uid === undefined ? 10005 : _ref40$uid,
                _ref40$errtip = _ref40.errtip,
                errtip = _ref40$errtip === undefined ? '' : _ref40$errtip,
                _ref40$action = _ref40.action,
                action = _ref40$action === undefined ? 'callapp' : _ref40$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'openChat',
                extend: {
                    uid: uid
                },
                receive: "$['upliveapp_openChat']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'openChat',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        /**
         * 跳转到关注列表
         * @param cfg {
         * }
         */
        goFollowList: function goFollowList() {
            var _ref41 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref41$errtip = _ref41.errtip,
                errtip = _ref41$errtip === undefined ? '' : _ref41$errtip,
                _ref41$action = _ref41.action,
                action = _ref41$action === undefined ? 'callapp' : _ref41$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'followList',
                receive: "$['upliveapp_goFollowList']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goFollowList',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        /**
         * 跳转到短视频录制准备页面；
         * @param cfg {
                topic: 话题,
                topicId: 话题id {int}
         * }
         */
        goReadyToShortVideo: function goReadyToShortVideo() {
            var _ref42 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref42$topic = _ref42.topic,
                topic = _ref42$topic === undefined ? '' : _ref42$topic,
                _ref42$topicId = _ref42.topicId,
                topicId = _ref42$topicId === undefined ? '' : _ref42$topicId,
                _ref42$errtip = _ref42.errtip,
                errtip = _ref42$errtip === undefined ? '' : _ref42$errtip,
                _ref42$action = _ref42.action,
                action = _ref42$action === undefined ? 'callapp' : _ref42$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'readyToShortVideo',
                extend: {
                    topic: topic,
                    topicId: parseInt(topicId, 10)
                },
                receive: "$['upliveapp_goReadyToShortVideo']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goReadyToShortVideo',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        /**
         * 跳转到指定短视频页面&播放视频
         * @param cfg {
                rid: '主帖子ID', ［必须］
                dynamicId: '动态ID',［必须］
                dynamicType: "动态类型",［必须］
                // ［非必须］
                resourceUrls: {}, // 图片或者视频地址
                resourceDesp: "" // 资源描述信息
         * }
         */
        goDynamic: function goDynamic() {
            var _ref43 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref43$rid = _ref43.rid,
                rid = _ref43$rid === undefined ? '' : _ref43$rid,
                _ref43$dynamicId = _ref43.dynamicId,
                dynamicId = _ref43$dynamicId === undefined ? '' : _ref43$dynamicId,
                _ref43$dynamicType = _ref43.dynamicType,
                dynamicType = _ref43$dynamicType === undefined ? '' : _ref43$dynamicType,
                _ref43$resourceUrls = _ref43.resourceUrls,
                resourceUrls = _ref43$resourceUrls === undefined ? null : _ref43$resourceUrls,
                _ref43$resourceDesp = _ref43.resourceDesp,
                resourceDesp = _ref43$resourceDesp === undefined ? '' : _ref43$resourceDesp,
                _ref43$errtip = _ref43.errtip,
                errtip = _ref43$errtip === undefined ? '' : _ref43$errtip;

            var url = 'uplive://goWindow?json=';
            var _params = {
                rid: rid,
                dynamicId: dynamicId,
                dynamicType: dynamicType
            };

            if (resourceUrls) {
                _params.resourceUrls = resourceUrls;
                _params.resourceDesp = resourceDesp;
            }
            var params = {
                key: 'dynamic',
                extend: _params,
                receive: "$['upliveapp_goDynamic']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'goDynamic',
                errtip: errtip
            });
        },


        /* ----------------------V ios 2.5.0 -------------------*/

        /**
         * 跳转到座驾商场 U钻购买
         * @param cfg {
         * }
         */
        goCarMall: function goCarMall() {
            var _ref44 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref44$errtip = _ref44.errtip,
                errtip = _ref44$errtip === undefined ? '' : _ref44$errtip,
                _ref44$action = _ref44.action,
                action = _ref44$action === undefined ? 'callapp' : _ref44$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'carmall',
                receive: "$['upliveapp_goCarMall']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goCarMall',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        /** version 3.8
         * 跳转到座驾商场 U币购买
         * @param cfg {
         * }
         */
        goCarMallUseBill: function goCarMallUseBill() {
            var _ref45 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref45$errtip = _ref45.errtip,
                errtip = _ref45$errtip === undefined ? '' : _ref45$errtip,
                _ref45$action = _ref45.action,
                action = _ref45$action === undefined ? 'callapp' : _ref45$action,
                _ref45$complete = _ref45.complete,
                complete = _ref45$complete === undefined ? function () {} : _ref45$complete;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'carmallUseBill',
                receive: "$['upliveapp_goCarMallUseBill']",
                jsCallback: "$.goCarMallUseBillComplete"
            };
            $.goCarMallUseBillComplete = function (param) {
                complete.call(self, null);
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goCarMallUseBill',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        /**
         * 会员订阅
         **/
        goSubscribeMembership: function goSubscribeMembership() {
            var _ref46 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref46$errtip = _ref46.errtip,
                errtip = _ref46$errtip === undefined ? '' : _ref46$errtip,
                _ref46$action = _ref46.action,
                action = _ref46$action === undefined ? 'callapp' : _ref46$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'subscribeMembership',
                receive: "$['upliveapp_goSubscribeMembership']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goSubscribeMembership',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },

        /**
         * 账号绑定
         **/
        goBindAccount: function goBindAccount() {
            var _ref47 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref47$errtip = _ref47.errtip,
                errtip = _ref47$errtip === undefined ? '' : _ref47$errtip,
                _ref47$action = _ref47.action,
                action = _ref47$action === undefined ? 'callapp' : _ref47$action,
                _ref47$complete = _ref47.complete,
                complete = _ref47$complete === undefined ? function () {} : _ref47$complete;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'bindAccount',
                receive: "$['upliveapp_goBindAccount']",
                jsCallback: "$.bindAccountComplete"
            };
            $.bindAccountComplete = function () {
                complete.call(self, JSON.parse(param));
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goBindAccount',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        /**
         * 跳转到我的座驾
         * @param cfg {
         * }
         */
        goMyCar: function goMyCar() {
            var _ref48 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref48$errtip = _ref48.errtip,
                errtip = _ref48$errtip === undefined ? '' : _ref48$errtip,
                _ref48$action = _ref48.action,
                action = _ref48$action === undefined ? 'callapp' : _ref48$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'mycar',
                receive: "$['upliveapp_goMyCar']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goMyCar',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        /*--------------------- 外部协议 -------------------*/
        // 打开链接
        openUrlCallApp: function openUrlCallApp() {
            var _ref49 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref49$url = _ref49.url,
                url = _ref49$url === undefined ? '' : _ref49$url;

            var system = this.getSystem();
            var _url = urlPrefixCallAppInIos + '?json=';

            if (system == 'android') {
                _url = urlPrefixCallAppInAndroid + '/webview?json=';;
            }

            var params = {
                key: 'webview',
                url: url
            };
            this.sendUriScheme(_url + encodeURIComponent(JSON.stringify(params)));
        },


        // 进入app的资讯详情
        newDetailCallApp: function newDetailCallApp(detail) {
            var system = this.getSystem();
            var _url = urlPrefixCallAppInIos + '?json=';

            if (system == 'android') {
                _url = urlPrefixCallAppInAndroid + '/newdetail?json=';;
            }

            var params = _extends({
                key: 'newdetail'
            }, detail);

            this.sendUriScheme(_url + encodeURIComponent(JSON.stringify(params)));
        },


        // 进入用户主页
        profileCallApp: function profileCallApp() {
            var _ref50 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref50$uid = _ref50.uid,
                uid = _ref50$uid === undefined ? 0 : _ref50$uid;

            var system = this.getSystem();
            var url = urlPrefixCallAppInIos + '?json=';

            if (system == 'android') {
                url = urlPrefixCallAppInAndroid + '/profile?json=';;
            }
            var params = {
                key: 'profile',
                extend: {
                    uid: parseInt(uid, 10)
                }
            };
            this.sendUriScheme(url + encodeURIComponent(JSON.stringify(params)));
        },


        // 进入充值页
        goPayCallApp: function goPayCallApp() {
            var system = this.getSystem();
            var url = urlPrefixCallAppInIos + '?json=';

            if (system == 'android') {
                url = urlPrefixCallAppInAndroid + '/pay?json=';
            }
            var params = {
                key: 'pay'
            };
            this.sendUriScheme(url + encodeURIComponent(JSON.stringify(params)));
        },


        // 直播间
        goRoomCallApp: function goRoomCallApp() {
            var _ref51 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref51$uid = _ref51.uid,
                uid = _ref51$uid === undefined ? 0 : _ref51$uid,
                _ref51$roomid = _ref51.roomid,
                roomid = _ref51$roomid === undefined ? 0 : _ref51$roomid;

            var system = this.getSystem();
            var url = urlPrefixCallAppInIos + '?json=';

            if (system == 'android') {
                url = urlPrefixCallAppInAndroid + '/room?json=';
            }
            var params = {
                key: 'room',
                extend: {
                    uid: parseInt(uid, 10),
                    roomid: parseInt(roomid, 10)
                }
            };
            this.sendUriScheme(url + encodeURIComponent(JSON.stringify(params)));
        },

        // 榜单页 1 星榜，2主播榜，3财富榜
        goRankCallApp: function goRankCallApp() {
            var _ref52 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref52$name = _ref52.name,
                name = _ref52$name === undefined ? 1 : _ref52$name;

            var system = this.getSystem();
            var url = urlPrefixCallAppInIos + '?json=';

            if (system == 'android') {
                url = urlPrefixCallAppInAndroid + '/rank?json=';
            }
            var key = void 0;

            switch (parseInt(name, 10)) {
                case 1:
                    key = 'starank';
                    break;
                case 2:
                    key = 'hostrank';
                    break;
                case 3:
                    key = 'wealthrank';
                    break;
                default:
                    key = 'starank';
            }
            var params = {
                key: key
            };
            this.sendUriScheme(url + encodeURIComponent(JSON.stringify(params)));
        },

        // 1.6.5 根据国家码跳转到国家主播列表
        goHotListByAreaCallApp: function goHotListByAreaCallApp() {
            var _ref53 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref53$countryCode = _ref53.countryCode,
                countryCode = _ref53$countryCode === undefined ? '' : _ref53$countryCode;

            var system = this.getSystem();
            var url = urlPrefixCallAppInIos + '?json=';

            if (system == 'android') {
                url = urlPrefixCallAppInAndroid + '/hotbyarea?json=';
            }
            var params = {
                key: 'hotbyarea',
                extend: {
                    countryCode: countryCode
                }
            };
            this.sendUriScheme(url + encodeURIComponent(JSON.stringify(params)));
        },

        /**
         * 发送GIFTO礼物
         * @param cfg {
         *      data {}；发送礼物的详细信息
         *      complete: function(){}
         * }
         *      uplive://sendGTOGift?json={
         *              "jsCallback": ""
         *              ,receive:""
         *              ,"data":"{
         *                  //接收礼物用户uid
         *                  "sendtoUid":"",
         *                  // 消息内容
         *                  "content": "1";
         *                  //礼物ID 必填
         *                  "giftId": "2";
         *                  //礼物名称
         *                  "giftName" : "3";
         *                  //连发系数
         *                  "giftAmount": "4";
         *                  //是否连续
         *                  "isContinuous": "5";
         *                  //连续次数 必填
         *                  "numContinuous": "6";
         *                  //礼物大图
         *                  "giftBigPicUrl": "6";
         *              }"}
         *
         */
        sendGTOGift: function sendGTOGift() {
            var _ref54 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref54$complete = _ref54.complete,
                complete = _ref54$complete === undefined ? function () {} : _ref54$complete,
                _ref54$data = _ref54.data,
                data = _ref54$data === undefined ? {} : _ref54$data,
                _ref54$errtip = _ref54.errtip,
                errtip = _ref54$errtip === undefined ? '不支持' : _ref54$errtip;

            var self = this;
            var url = 'uplive://sendGTOGift?json=';
            var params = {
                receive: "$['upliveapp_sendGTOGift']",
                jsCallback: '$.sendGiftoGiftComplete',
                data: data
            };

            $.sendGiftoGiftComplete = function (param) {
                // usertoken: "", uid: "", language: ""
                complete.call(self, JSON.parse(param));
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'sendGTOGift',
                errtip: errtip
            });
        },

        /**
         * 通过面板的id和礼物的id选中礼物
         * @param data
         * @param errtip
         */
        selectGift: function selectGift(_ref55) {
            var _ref55$data = _ref55.data,
                data = _ref55$data === undefined ? {} : _ref55$data,
                _ref55$errtip = _ref55.errtip,
                errtip = _ref55$errtip === undefined ? '不支持' : _ref55$errtip;

            var url = 'uplive://selectGift?json=';
            var params = {
                receive: "$['upliveapp_selectGift']",
                params: {
                    giftId: data.giftId,
                    labelId: data.labelId
                }
            };
            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'selectGift',
                errtip: errtip
            });
        },

        /**
         * 发送登录结果
         * @param data
         * @param errtip
         */
        sendLoginResult: function sendLoginResult(_ref56) {
            var _ref56$data = _ref56.data,
                data = _ref56$data === undefined ? {} : _ref56$data,
                _ref56$errtip = _ref56.errtip,
                errtip = _ref56$errtip === undefined ? '不支持' : _ref56$errtip;

            var url = 'uplive://LoginResult?json=';
            var params = {
                receive: "$['upliveapp_loginResult']",
                userInfo: {
                    id: data.id,
                    first_name: data.first_name,
                    last_name: data.last_name,
                    username: data.username, // 首次注册这个值没有
                    photo_url: data.photo_url, // 首次注册这个值没有
                    auth_date: data.auth_date,
                    hash: data.hash,
                    extends: data.extends || ''
                },
                type: data.type || 'telegram',
                result: data.result,
                message: data.errmsg || '',
                jsCallback: '$.sendLoginResultCallback'
            };
            $.sendLoginResultCallback = function () {};
            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'loginResult',
                errtip: errtip
            });
        },

        /**---------------------------------3.3.1新增协议------------------------------------*/
        /**
         * 跳转荣耀挑战赛榜单
         * tab=0 今日上升榜  tab=1 赛季战力榜
         **/
        goPKRank: function goPKRank() {
            var _ref57 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref57$errtip = _ref57.errtip,
                errtip = _ref57$errtip === undefined ? '' : _ref57$errtip,
                _ref57$tab = _ref57.tab,
                tab = _ref57$tab === undefined ? 0 : _ref57$tab,
                _ref57$action = _ref57.action,
                action = _ref57$action === undefined ? 'callapp' : _ref57$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'goPKRank',
                extend: {
                    tab: tab
                },
                receive: "$['upliveapp_goPKRank']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goPKRank',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },

        /**
         * 跳转荣耀挑战赛
         **/
        goPKProfile: function goPKProfile() {
            var _ref58 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref58$errtip = _ref58.errtip,
                errtip = _ref58$errtip === undefined ? '' : _ref58$errtip,
                _ref58$action = _ref58.action,
                action = _ref58$action === undefined ? 'callapp' : _ref58$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'goPKProfile',
                receive: "$['upliveapp_goPKProfile']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goPKProfile',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },

        /**
         * 跳转签到页面
         **/
        goCheckin: function goCheckin() {
            var _ref59 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref59$errtip = _ref59.errtip,
                errtip = _ref59$errtip === undefined ? '不支持' : _ref59$errtip,
                _ref59$action = _ref59.action,
                action = _ref59$action === undefined ? 'callapp' : _ref59$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'openCheckin',
                "receive": "$['upliveapp_goCheckin']"
                // "jsCallback":"$.goCheckinComplete"
            };
            // $.goCheckinComplete = function(param) { // usertoken: "", uid: "", language: ""
            //     complete.call(self, JSON.parse(param));
            // }

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goCheckin',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        /**
         * 跳转游戏列表
         **/
        goGameLivingList: function goGameLivingList() {
            var _ref60 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref60$errtip = _ref60.errtip,
                errtip = _ref60$errtip === undefined ? '' : _ref60$errtip,
                _ref60$action = _ref60.action,
                action = _ref60$action === undefined ? 'callapp' : _ref60$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: "goGameLivingList",
                receive: "$['upliveapp_goGameLivingList']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goGameLivingList',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },

        /**
         * 跳转游戏标签列表
         * labelId 标签id
         **/
        goGameLivingLabel: function goGameLivingLabel() {
            var _ref61 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref61$errtip = _ref61.errtip,
                errtip = _ref61$errtip === undefined ? '' : _ref61$errtip,
                _ref61$labelId = _ref61.labelId,
                labelId = _ref61$labelId === undefined ? 0 : _ref61$labelId,
                _ref61$action = _ref61.action,
                action = _ref61$action === undefined ? 'callapp' : _ref61$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: "goGameLivingLabel",
                extend: {
                    labelId: labelId
                },
                receive: "$['upliveapp_goGameLivingLabel']"
            };
            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goGameLivingLabel',
                    errtip: errtip
                });
            } else {
                return url;
            }
        }
    };

    var _loop = function _loop(i) {
        $['upliveapp_' + i] = function () {
            apiStatus[i] = 1;
        };
    };

    for (var i in native) {
        _loop(i);
    }

    window.UpSDK = native;

    if (typeof module != 'undefined' && module.exports) {
        module.exports = native;
    } else {
        window.UpSDK = native;
    }

    if (window.define && __webpack_require__(38).cmd) {
        !(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {
            module.exports = native;
        }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
})(window, window.Zepto || window.jQuery || (window['$'] = {}));

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {
    /**
     * @file 基础Event
     * @author 子虔
     * @date    2014-08-04 16:11:13
     * @example
     *        * 支持多个事件的添加、移除、派发
     *            this.on('name1,name2,name3',function(){});
     *        * 支持使用层次的方式调用子对象的事件
     *            this.on('parent/child/child/name',function(){}); === this.parent.child.child.on(name,function(){})
     */
    var Callbacks = __webpack_require__(23),
        channelObj = {};

    // 统一事件机制
    var Events = {
        Event: Callbacks,
        /**
         * 添加事件监听
         * @param  {string}   name - 事件名称
         * @param  {function} callback - 事件回调
         */
        on: function on(name, callback) {
            var obj,
                that = this;

            this.events = this.events || {};

            // 逗号隔开，支持多事件
            if (name && name.indexOf(',') != -1) {
                return (name.split(',') || []).forEach(function (item) {
                    if (item) {
                        that.on(item, callback);
                    }
                });
            }

            if (!this.global && name.indexOf('/') != -1) {
                // 频道监听
                if (name.split('/')[0] == 'channel') {
                    return that.channel.on(name.replace(/^channel\//gi, ''), callback);
                }

                obj = getObjectByNames(name, this);
                this.events[name] = this.events[name] || [];
                this.events[name].push(callback);
                return obj ? obj.on(getEventName(name), callback) : this;
            } else {
                obj = this.events[name] || (this.events[name] = this.Event());
            }

            // 如果设置为一起派发，则再次监听时，直接执行
            if (this._alwayEmitSource && this._alwayEmitSource[name]) {
                return callback.apply(name, this._alwayEmitSource[name]);
            }
            obj.add(callback);

            return this;
        },
        /**
         * 移除事件监听
         * @param  {string}   name     事件名称
         * @param  {function} [callback] - 事件回调，为空时，移除所有回调
         */
        off: function off(name, callback) {
            var obj,
                funs,
                that = this;

            this.events = this.events || {};

            // 逗号隔开，支持多事件
            if (name && name.indexOf(',') != -1) {
                return (name.split(',') || []).forEach(function (item) {
                    if (item) {
                        that.off(item, callback);
                    }
                });
            }

            if (!this.global && name && name.indexOf('/') != -1) {
                if (name.split('/')[0] == 'channel') {
                    return that.channel.off(name.replace(/^channel\//gi, ''), callback);
                }

                if (this.events[name]) {
                    obj = getObjectByNames(name, this);
                    if (callback) {
                        return obj ? obj.off(getEventName(name), callback) : this;
                    } else {
                        funs = this.events[name];
                        for (var i = 0; obj && funs && i < funs.length; i++) {
                            obj.off(getEventName(name), funs[i]);
                        }
                        this.events[name] = null;
                    }
                }

                return this;
            }

            if (name && callback && (obj = this.events[name])) {
                obj.remove(callback);
            } else if (name && (obj = this.events[name])) {
                obj.empty();
            } else {

                for (name in this.events) {
                    if (this.events.hasOwnProperty(name) && this.events[name]) {
                        if (!this.global && name.indexOf('/') != -1) {
                            if (name.split('/')[0] == 'channel') {
                                return this.channel.off(name.replace(/^channel\//gi, ''));
                            }
                            this.off(name);
                        } else {
                            this.events[name].empty();
                        }
                    }
                }
            }

            return this;
        },
        ///**
        // * 只监听一次事件
        // * @param name
        // * @param callback
        // */
        //once: function (name, callback) {
        //    var _callback;
        //
        //    this.on(name, _callback = function () {
        //        callback.apply(this, arguments);
        //        this.off(name, _callback);
        //    });
        //},
        /**
         * 默认派发事件
         * @return {object}
         */
        trigger: function trigger() {
            var name = arguments[0],
                obj,
                param,
                that = this;

            this.events = this.events || {};
            param = Array.prototype.slice.call(arguments, 1);

            // 逗号隔开，支持多事件
            if (name && name.indexOf(',') != -1) {
                return (name.split(',') || []).forEach(function (item) {
                    if (item) {
                        that.trigger.apply(this, [item].concat(param));
                    }
                });
            }

            if (!this.global && name && name.indexOf('/') != -1) {
                if (name.split('/')[0] == 'channel') {
                    return that.channel.trigger.apply(that.channel, [name.replace(/^channel\//gi, '')].concat(param));
                }
                obj = getObjectByNames(name, this);
                name = getEventName(name);
                return obj ? obj.trigger.apply(obj, [name].concat(param)) : this;
            }

            if (name && (obj = this.events[name])) {
                obj.fire.apply(this, [].concat(param));
            }

            return {
                event: obj,
                always: function always() {
                    that._alwayEmitSource = that._alwayEmitSource || {};
                    that._alwayEmitSource[name] = [].concat(param);
                }
            };
        },
        /**
         * 派发事件
         * @example
         *        this.emit('ready',args0,args1...);
         */
        emit: function emit() {
            return this.trigger.apply(this, arguments);
        }
    };

    /**
     * 获取context下的name属性
     * @private
     */
    function getObjectByNames(name, context) {
        var that, names, len;

        context = context || {};
        that = context;
        names = name.split('/');
        len = names.length;

        for (var i = 0; len > 1 && i < len - 1; i++) {
            if (that && that[names[i]]) {
                that = that[names[i]];
            } else {
                that = null;
            }
        }

        return that;
    }

    /**
     * 获取事件名称
     * @param  {String} name [description]
     * @return {String}
     */
    function getEventName(name) {
        var names = name.split('/');
        return names[names.length - 1];
    }

    // global single Event
    Events.channel = $.channel || ($.channel = $.extend(channelObj, Events));
    Events.channel.global = Events.channel;

    module.exports = Events;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {

    /**
     * @fileoverview callbacks
     * @author 子虔
     * @date    2014-08-31 12:09:10
     */
    module.exports = function (options) {
        options = $.extend({}, options);

        var memory,
            // Last fire value (for non-forgettable lists)
        _fired,
            // Flag to know if list was already fired
        firing,
            // Flag to know if list is currently firing
        firingStart,
            // First callback to fire (used internally by add and fireWith)
        firingLength,
            // End of the loop when firing
        firingIndex,
            // Index of currently firing callback (modified by remove if needed)
        list = [],
            // Actual callback list
        stack = !options.once && [],
            // Stack of fire calls for repeatable lists
        fire = function fire(data) {
            memory = options.memory && data;
            _fired = true;
            firingIndex = firingStart || 0;
            firingStart = 0;
            firingLength = list.length;
            firing = true;
            for (; list && firingIndex < firingLength; ++firingIndex) {
                if (list[firingIndex].apply(data[0], data[1]) === false && options.stopOnFalse) {
                    memory = false;
                    break;
                }
            }
            firing = false;
            if (list) {
                if (stack) stack.length && fire(stack.shift());else if (memory) list.length = 0;else Callbacks.disable();
            }
        },
            Callbacks = {
            list: list,
            add: function add() {
                if (list) {
                    var start = list.length,
                        add = function add(args) {
                        args = Array.prototype.slice.call(args);
                        args.forEach(function (arg, _) {
                            if (typeof arg === "function") {
                                if (!options.unique || !Callbacks.has(arg)) list.push(arg);
                            } else if (arg && arg.length && typeof arg !== 'string') add(arg);
                        });
                    };
                    add(arguments);
                    if (firing) firingLength = list.length;else if (memory) {
                        firingStart = start;
                        fire(memory);
                    }
                }
                return this;
            },
            remove: function remove() {
                var args = Array.prototype.slice.call(arguments);
                if (list) {
                    args.forEach(function (arg, _) {
                        var index;
                        while ((index = list.indexOf(arg, index)) > -1) {
                            list.splice(index, 1);
                            // Handle firing indexes
                            if (firing) {
                                if (index <= firingLength) --firingLength;
                                if (index <= firingIndex) --firingIndex;
                            }
                        }
                    });
                }
                return this;
            },
            has: function has(fn) {
                return !!(list && (fn ? list.indexOf(fn) > -1 : list.length));
            },
            empty: function empty() {
                firingLength = list.length = 0;
                return this;
            },
            disable: function disable() {
                list = stack = memory = undefined;
                return this;
            },
            disabled: function disabled() {
                return !list;
            },
            lock: function lock() {
                stack = undefined;
                if (!memory) Callbacks.disable();
                return this;
            },
            locked: function locked() {
                return !stack;
            },
            fireWith: function fireWith(context, args) {
                if (list && (!_fired || stack)) {
                    args = args || [];
                    args = [context, args.slice ? args.slice() : args];
                    if (firing) stack.push(args);else fire(args);
                }
                return this;
            },
            fire: function fire() {
                return Callbacks.fireWith(this, arguments);
            },
            fired: function fired() {
                return !!_fired;
            }
        };

        return Callbacks;
    };
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {

    /**
     * @file 继承和扩展
     * @author 子虔
     * @date    2014-08-15 11:24:20
     * @param  {Object} protoProps  子类的prototype
     * @param  {[type]} staticProps 子类的静态方法或属性
     * @return {Class}
     */
    var inherits = __webpack_require__(25);

    module.exports = function (protoProps, staticProps) {
        var parent = this,
            child,
            destroy;

        // The constructor function for the new subclass is either defined by you
        // (the "constructor" property in your `extend` definition), or defaulted
        // by us to simply call the parent's constructor.
        if (protoProps && protoProps.hasOwnProperty('constructor')) {
            child = protoProps.constructor;
        } else {
            child = function child() {
                return parent.apply(this, arguments);
            };
        }

        // inherits
        inherits(child, parent, protoProps, staticProps);

        // 销毁自动继承
        if (protoProps.hasOwnProperty('destroy') && (destroy = protoProps.destroy)) {
            protoProps.destroy = function () {
                try {
                    destroy.apply(this, arguments);
                } catch (e) {}

                try {
                    parent.prototype.destroy.apply(this, arguments);
                } catch (e) {}
            };
        }

        return child;
    };
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {
    /**
     * @file 继承并在原型链中提供`Parent`方法，用于调用父类prototype中的方法
     * @author 子虔
     * @date    2015-02-15 15:11:23
     */
    module.exports = function (child, parent, protoProps, staticProps) {
        // 绑定静态属性
        $.extend(child, parent, staticProps);

        function Prototype() {
            this.constructor = child;
        }

        Prototype.prototype = parent.prototype;

        child.prototype = new Prototype();

        // 绑定新的属性
        if (protoProps) {
            $.extend(child.prototype, protoProps);
        }

        // merge the Class's default's prototype
        child.prototype.defaults = $.extend(true, {}, parent.prototype.defaults, child.prototype.defaults);

        // Set a convenience property in case the parent's prototype is needed
        // later.
        child.__super__ = parent.prototype;
        child.__class__ = [];

        if (!parent.__class__) {
            child.__class__.push(parent, child);
        } else {
            parent.__class__.forEach(function (item) {
                child.__class__.push(item);
            });
            child.__class__.push(child);
        }

        child.prototype.Parent = function Parent() {
            var caller,
                name,
                parent,
                allClass = this.constructor.__class__,
                allClassLength = allClass.length,
                i = allClassLength - 1,
                args = arguments,
                argsLen = args.length;

            if (argsLen == 2 && typeof args[0] == 'function' && isArgsObject(args[1])) {
                caller = args[0];
                args = args[1] || [];
            } else {
                caller = Parent.caller;
                args = arguments;
            }

            if (!caller) return;

            while (i > 0 && !name) {
                var fun = allClass[i],
                    fn = fun.prototype;
                for (var p in fn) {
                    if (fn.hasOwnProperty(p) && fn[p] === caller) {
                        name = p;
                        parent = allClass[i - 1];
                    }
                }
                i--;
            }

            if (name && parent) {
                if (parent.prototype[name]) {
                    return parent.prototype[name].apply(this, args);
                }
            }
        };
    };

    // 判断一个对象是否为arguments对象
    function isArgsObject(obj) {
        var type = Object.prototype.toString.call(obj);
        return type === '[object Arguments]';
    }
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {

    /**
     * @file 类属性相关的扩展
     * @author 子虔
     * @date    2014-08-18 17:41:24
     */

    var parseParam = __webpack_require__(5),
        isEqual = __webpack_require__(6);

    module.exports = {
        /**
         * 设置参数，可通过`a/b/c/d`的方式设置
         * @param {*} name - 名称或对象
         * @param {*} [value] - 属性值
         * @param {boolean} [silent=false] - 设置的值变化时，是否派发事件
         */
        set: function set(name, value, silent) {
            var data,
                names,
                lastValue,
                len,
                that = this;

            if (typeof name == 'string') {
                names = name.split('/');
                len = names.length;
                if (len > 1) {
                    names.forEach(function (item, index) {
                        if (index == len - 1) {
                            lastValue = data[item];
                            data[item] = value;
                            if (!silent && !isEqual(lastValue, value)) {
                                bubbling.call(that, names, value, lastValue);
                            }
                        } else {
                            data = data || that.attributes;
                            data[item] = data[item] || {};
                            data = data[item];
                        }
                    });
                    return;
                }
            }

            function bubbling(names, value, lastValue) {
                var name = names.length == 1 ? names[0] : names.join('/');

                if (names.length > 0) {
                    this.emit('change:' + name, value, lastValue);
                    names.pop();
                    bubbling.call(this, names, value, lastValue);
                }
            }

            return this.Parent(set, arguments);
        },
        /**
         * 获取参数,可通过`a/b/c/d`获取如上`set`例子中的`d`值
         * @param {string} name - 名称
         * @return {*}
         */
        get: function get(name) {
            var that = this,
                names,
                value = '',
                data,
                len;

            if (typeof name == 'string') {
                names = name.split('/');
                len = names.length;

                if (len > 1) {
                    names.forEach(function (item, index) {
                        if (index == len - 1 && data && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) == 'object') {
                            value = data[item];
                        } else {
                            data = data || that.attributes;
                            data[item] = data[item];
                            data = data[item];
                        }
                    });

                    return value;
                }
            }

            return this.Parent(get, arguments);
        }
    };
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 27 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * 授权配置
 * @author chenliying
 */
var Config = {
    /**
     * webapi域名配置
     */
    originMap: {
        dev: '//up-service.xingyunzhi.cn',
        stage: '//sg-service.pengpengla.com',
        pro: '//service.upliveapps.com'
    },
    /**
     * 获取环境。 env=stage => stage环境; env=pro 或无 => pro线上环境
     */
    env: function env() {
        return Uplib.url.query('env') || 'pro';
    },
    /**
     *  根据环境获取对应服务域名
     */
    getPrefix: function getPrefix() {
        var prefix = this.originMap[this.env()];

        return prefix;
    },

    getTwitterRequestTokenPath: function getTwitterRequestTokenPath() {
        var prefix = this.getPrefix();

        return prefix + '/webauth/twitter/requesttoken';
    },

    /**
     * 通过code获取userToken的webapi路径
     */
    getUsertokenPath: function getUsertokenPath() {
        var prefix = this.getPrefix();
        var target = prefix + '/webauth/auth';

        return target;
    },
    /**
     * appid配置
     */
    upInfoInPlatform: {
        // 微信平台
        'wechat': {
            appid: 'wx78a12cd5f3b2a993',
            appid_stage: 'wx78a12cd5f3b2a993'
        },
        'wechatQrcode': {
            appId: 'wxbe95819b0e7499a9',
            appSecret: 'b34144895076ee00a3c2dd5c9bb2f3cb'
        },
        // fb平台
        'fb': {
            appid: '1698316857098420'
        },
        // 微博
        'weibo': {
            appid: '3739970591'
        },
        google: {
            clientId: '810710132118-nhlomv7vpqsm6v2a0c9lsgkhbpd4c2qo.apps.googleusercontent.com'
        }
    }
};

exports.default = Config;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 29 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.11' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var hide = __webpack_require__(31);
var has = __webpack_require__(34);
var SRC = __webpack_require__(45)('src');
var $toString = __webpack_require__(176);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(29).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(32);
var createDesc = __webpack_require__(60);
module.exports = __webpack_require__(18) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(33);
var IE8_DOM_DEFINE = __webpack_require__(110);
var toPrimitive = __webpack_require__(112);
var dP = Object.defineProperty;

exports.f = __webpack_require__(18) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(12);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 34 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.blockChainGiftId = exports.urls = exports.config = exports.giftMallService = exports.ugRankingService = exports.ugMallService = exports.giftService = undefined;

var _cNenv = __webpack_require__(221);

var _api = __webpack_require__(15);

// 配置相关的service
// localStorage.clear();
// UG挂载ajaxBuilder

//  快捷方式
var giftService = exports.giftService = (0, _api.serviceFactory)('universal-gift');
var ugMallService = exports.ugMallService = (0, _api.serviceFactory)('mall');
var ugRankingService = exports.ugRankingService = (0, _api.serviceFactory)('ranking');
var giftMallService = exports.giftMallService = (0, _api.serviceFactory)('gifto_mall');

var config = exports.config = {
    device: _cNenv.device,
    platform: _cNenv.platform,
    isIOS: _cNenv.device.isIOS,
    isAndroid: _cNenv.device.isAndroid,
    // 这个https不支持
    appDownloadPage: 'http://h5.upliveapp.com/uppro/download.html',
    // TODO 看看到底有没有用到的
    appApkDownloadLink: 'https://n.pengpengla.com/android/Uplive_2017.12.29_2.7.2_10523.production_upliveV1UpDomesticLocalDevelop.apk',
    appQqDownloadLink: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.asiainno.uplive',
    publishUrl: location.origin + location.pathname
};

var urls = exports.urls = {
    facebook: 'https://www.facebook.com',
    instagram: 'https://www.instagram.com',
    youtube: 'https://www.youtube.com'
};

var blockChainGiftId = exports.blockChainGiftId = {
    // 2018、11、09修改了@ming
    // stage: 12345678,
    stage: 999999999,
    pro: 999999999
};

/***/ }),
/* 36 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_js__ = __webpack_require__(4);



// Add all of the Underscore functions to the wrapper object.
var _ = Object(__WEBPACK_IMPORTED_MODULE_0__index_js__["mixin"])(__WEBPACK_IMPORTED_MODULE_0__index_js__);
// Legacy Node.js API
_._ = _;
// Export the Underscore API.
/* harmony default export */ __webpack_exports__["a"] = (_);


/***/ }),
/* 38 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 39 */
/***/ (function(module, exports) {

module.exports = {
    "enus": {
        "50 gifts in one Gift Dashboard only.": "50 gifts in one Gift Dashboard only.",
        "<%=username%> sent you <%=count%> <%=name%>, check it out!": "<%=username%> sent you <%=count%> <%=name%>, check it out!",
        "Add a gift link below your Youtube or Facebook post.": "Add a gift link below your Youtube or Facebook post.",
        "Add friend": "Add friend",
        "Add friends and chat it up!": "Add friends and chat it up!",
        "Alipay": "Alipay",
        "Balance": "Balance",
        "Bank Transfer": "Bank Transfer",
        "Cancel": "Cancel",
        "CashCard(THB)": "CashCard(THB)",
        "Check out your revenue record here or in Uplive when you received a gift.": "Check out your revenue record here or in Uplive when you received a gift.",
        "Check revenue": "Check revenue",
        "Confirm": "Confirm",
        "Copied Successfully!": "Copied Successfully!",
        "Copied failed. Please select the link and copy.": "Copied failed. Please select the link and copy.",
        "Copy link": "Copy link",
        "Create Dashboard": "Create Dashboard",
        "Create Dashboard Btn": "Create Dashboard",
        "Create more dashboards": "Create more dashboards",
        "Current edits are not saved yet, jump to edit profile picture now?": "Current edits are not saved yet, jump to edit profile picture now?",
        "Customer Assistant": "Customer Assistant",
        "Customer Service": "Customer Service",
        "Dashboard created!": "Dashboard created!",
        "Dashboard failed to create.": "Dashboard failed to create.",
        "Dashboard failed to update;(": "Dashboard failed to update;(",
        "Dashboard updated!": "Dashboard updated!",
        "Describe this dashboard": "Describe this dashboard",
        "Description": "Description",
        "Edit profile picture": "Edit profile picture",
        "Engrave on Blockchain": "Engrave on Blockchain",
        "Engraving on Blockchain...": "Engraving on Blockchain...",
        "Enter project name": "Enter project name ",
        "Error.": "Service error, please try again later.",
        "Expired userToken.": "Expired userToken.",
        "Facebook": "Facebook",
        "Failed to charge. Please try again.": "Failed to charge. Please try again.",
        "Failed to obtain personal info.": "Failed to obtain personal info.",
        "Failed to set up user\\'s county and area.": "Failed to set up user\\'s county and area.",
        "Friend request": "Friend request",
        "Friend request sent successfully.": "Friend request sent successfully.",
        "Friends": "Friends",
        "GIFTO钱包": "GIFTO Wallet",
        "Gift Dashboards": "Gift Dashboards",
        "Gift assistant": "Gift assistant",
        "Gifts": "Gifts",
        "Go to Uplive": "Go to Uplive",
        "How to get gifts?": "How to get gifts?",
        "I sent you <%=count%> <%=name%> in <%=itemName%>, check it out!": "I sent you <%=count%> <%=name%> in <%=itemName%>, check it out!",
        "Insufficient balance, please recharge.": "Insufficient balance, please recharge.",
        "Invalid data.": "Invalid data.",
        "It takes some time to engrave on blockchain we will seed you message when it’s done!": "It takes some time to engrave on blockchain you will get a message when it’s done!",
        "Last update": "Last update",
        "Leaderboard": "Leaderboard",
        "Limit is Description is 120 characters.": "Limit is Description is 120 characters.",
        "Limit of Name is 30 characters.": "Limit of Name is 30 characters.",
        "Limited to 130 characters": "Limited to 130 characters",
        "Limited to <%=count%> characters": "Limited to <%=count%> characters",
        "Loading": "Loading",
        "Loading...": "Loading...",
        "Log out": "Log out",
        "Login to Send Gift": "Login to Send Gift",
        "Make it Forever...": "Make it Forever...",
        "Message cannot be empty!": "Message cannot be empty!",
        "Messages": "Messages",
        "MyCard": "MyCard",
        "NEXT": "NEXT",
        "Name this Dashboard": "Name this Dashboard",
        "Next Step": "Next Step",
        "No more data": "No more data",
        "OK": "OK",
        "OnlineBank(IDR)": "OnlineBank(IDR)",
        "PayPal": "PayPal",
        "Payment cancelled.": "Payment cancelled.",
        "Payment failed.": "Payment failed.",
        "Payment has been processed.": "Payment has been processed.",
        "Please login to recharge.": "Please recharge after login.",
        "Please name your dashboard.": "Please name your dashboard.",
        "Please recharge": "Please recharge",
        "Please select a valid image format.": "Please select a valid image format.",
        "Please select the link and copy.": "Please select the link and copy.",
        "Please select the sending gift first.": "Please select the sending gift first.",
        "Previous page": "Previous page",
        "QQ": "QQ",
        "Rankings": "Rankings",
        "Received gifts": "Received gifts",
        "Recharge amount": "Recharge amount",
        "Recharge option": "Recharge option",
        "Reselect": "Reselect",
        "Revenue": "Revenue",
        "Save": "Save",
        "Save Dashboard": "Save Dashboard",
        "Say something": "Say something",
        "Say something about yourself": "Say something about yourself",
        "See all >": "See all >",
        "Select from photo": "Select from photo",
        "Send": "Send",
        "Send <%=value%> GTO": "Send <%=value%> GTO",
        "Send thanks!": "Send thanks!",
        "Session timeout.": "Session timeout.",
        "Sign in": "Sign in",
        "Step 1": "Step 1",
        "Step 1: Pick gifts for your new gift dashboard first.": "Step 1: Pick gifts for your new gift dashboard first.",
        "Step 2": "Step 2",
        "Step 2: Copy your new gift dashboard’s link.": "Step 2: Copy your new gift dashboard’s link.",
        "Step 3": "Step 3",
        "Step 3: Paste your new dashboard link under your creative content.": "Step 3: Paste your new dashboard link under your creative content.",
        "Swipe up to load more": "Swipe up to load more",
        "System error.": "System error.",
        "TOTAL REVENUE": "TOTAL REVENUE",
        "This name has been used": "This name has been used",
        "Tip: Resolution of 800x800 is suggested": "Tip: Resolution of 800x800 is suggested",
        "Tips:": "Tips:",
        "Transaction submitted.": "Transaction submitted.",
        "Twitter": "Twitter",
        "USD $ <%=value%>": "USD $ <%=value%>",
        "Universal Gifting": "Universal Gifting",
        "Up ID": "Up ID",
        "Upload a higher resolution profile pic to receive more gifts!": "Upload a higher resolution profile pic to receive more gifts!",
        "Uploading...": "Uploading...",
        "VIP等级不足": "Level up to view",
        "View on Blockchain": "View on Blockchain",
        "Wechat": "Wechat",
        "Weibo": "Weibo",
        "Withdraw": "Withdraw",
        "Withdraw is only supported in Uplive app, please go to Uplive app to withdraw.": "Withdraw is only supported in Uplive app, please go to Uplive app to withdraw.",
        "Xenopay": "Xenopay",
        "You can create a project by Uplive web or app to generate a gift link.": "You can create a project by Uplive web or app to generate a gift link.",
        "You could only create 10 Dashboards.": "You could only create 10 Dashboards.",
        "You have exceeded the daily limit": "You have exceeded the daily limit",
        "You two are friends now.": "You two are friends now.",
        "Your gift is now on blockchain !": "Your gift is now on blockchain!",
        "Your gift is on the way": "Your gift is on the way",
        "Your name": "Your name",
        "agree": "agree",
        "agreed": "agreed",
        "bk_atm": "bk_atm",
        "bk_card": "bk_card",
        "onecard": "onecard",
        "send": "Send",
        "send <%=giftName%>": "send <%=giftName%>",
        "skip": "skip",
        "uDiamonds": "uDiamonds",
        "“篆刻到區塊鏈需要” <%=fee%> GTO": "It needs <%=fee%> GTO to engrave on blockchain.",
        "你还有未完成的交易，请稍后再试": "You have unfinished transactions, please wait.",
        "保存并分享": "Save and Share",
        "分享到Line": "Share to Line",
        "分享到Telegram": "Share to Telegram",
        "创建链接": "Create Link",
        "删除面板不会影响你收到的礼物": "Delete this board will not affect the gifts you've received.",
        "发布到FB!": "Post to Facebook!",
        "取消": "Cancel",
        "同意": "Okay",
        "图片已经成功保存到你的设备上了": "Gift saved on your device!",
        "在Facebook/Instagram/...任何地方都可以用Uplive收礼物啦！": "Facebook/Instagram/...You can start receiving gifts anywhere now!",
        "地址已经成功复制到剪切板了": "Address copied.",
        "复制地址": "Copy",
        "存款到这个账户": "Deposit to this account",
        "完成": "Done",
        "建议至少选择3~5礼物": "Pick at least 3~5 gifts.",
        "开始收礼物吧！": "Start getting gifts now!",
        "得到链接并复制": "Get link and copy",
        "快來看看我精心定制的禮物吧！": "Come check out my customized gifts!",
        "把礼物链接发送到你的Facebook或者Youtube": "Send the gift link to your Facebook or Youtube",
        "收到<%=amount%>个礼物, 价值 <%=value%> GTO": "This dashboard received <span class=\"red\"><%=amount%></span> gifts, worth of <span class=\"red\"><%=value%></span> GTO.",
        "放弃": "Give up",
        "正在加载数据...": "Loading...",
        "没有找到匹配的礼物": "Couldn't find matched gift.",
        "点击查看": "Click to check out on Blockchain!",
        "生成图片...": "Creating the gift...",
        "确认删除": "Delete",
        "确认删除该礼物面板? 删除后将不可恢复": "Delete this board? This board cannot be resumed.",
        "礼物记录不存在": "Gift doesn't exist.",
        "礼物面板删除成功！": "Board deleted",
        "编辑文字": "Edit message",
        "要放弃本次头像修改吗？": "Give up changing profile pic?",
        "试试": "Give it a try",
        "该地区暂未开放": "Not available in this region",
        "该用户的地区暂未支持GIFTO礼物": "The user's region does not currently support GIFTO gifts",
        "该礼物已失效": "This gift has expired. ",
        "跳过的提示文本": "This is your last chance to engrave this message and the gift on blockchain.",
        "输入备注的提示文本": "Write what you want to engrave onto the blockchain here...",
        "送有趣的禮物原來這麽簡單！——GIFTO通用禮物": "Sending fun gifts become so easy!-GIFTO- Universal Gifting",
        "选择礼物": "Pick Gifts",
        "重新播放": "Replay"
    },
    "kokr": {
        "50 gifts in one Gift Dashboard only.": "각 선물함의 선물은 최대 50개까지 지원됩니다!",
        "<%=username%> sent you <%=count%> <%=name%>, check it out!": "<%=username%> 님께서 <%=name%> (을)를 <%=count%> 개 보냈습니다，얼른확인해보세요！",
        "Add a gift link below your Youtube or Facebook post.": "좋은 선물함을 만들어 자신의 유튜브, 페이스북 등 플랫폼의 포스팅 내용을 상세기술 항목에 기입하세요.",
        "Add friend": "친구 추가",
        "Add friends and chat it up!": "친구 추가하세요! 채팅으로 친구들의 관계는 더욱 좋아질 거에요!",
        "Alipay": "알리페이",
        "Balance": "잔액",
        "Bank Transfer": "계좌이체",
        "Cancel": "취소",
        "CashCard(THB)": "CashCard(THB)",
        "Check out your revenue record here or in Uplive when you received a gift.": "언제든 이 함 혹은 Uplive app을 통해서 수익 기록을 확인할 수 있습니다.",
        "Check revenue": "수익확인",
        "Confirm": "확인",
        "Copied Successfully!": "복사 성공!",
        "Copied failed. Please select the link and copy.": "복사 실패, 직접 링크를 선택하고 복사하세요.",
        "Copy link": "링크 복사",
        "Create Dashboard": "선물함 만들기",
        "Create Dashboard Btn": "새로운 선물함 생성",
        "Create more dashboards": "새로운 선물함 만들기",
        "Current edits are not saved yet, jump to edit profile picture now?": "현재 작업이 아직 저장되지 않았습니다, 편집을 중단하고 개인 프로필 사진 함으로 넘어갈까요?",
        "Customer Assistant": "고객 서비스",
        "Customer Service": "고객 서비스",
        "Dashboard created!": "새로운 선물함 생성을 성공했습니다!",
        "Dashboard failed to create.": "선물함 생성을 실패하였습니다.",
        "Dashboard failed to update;(": "업데이트 실패;(",
        "Dashboard updated!": "선물함을 업데이트 했습니다!",
        "Describe this dashboard": "선물함을 설명해 주세요",
        "Description": "상세 설명",
        "Edit profile picture": "프로필 사진 편집",
        "Engrave on Blockchain": "블록체인에 저장되었습니다.",
        "Engraving on Blockchain...": "블록체인에 저장중...",
        "Enter project name": "선물함 이름 입력",
        "Error.": "에러.",
        "Expired userToken.": "만료된 사용자의 정보입니다.",
        "Facebook": "Facebook",
        "Failed to charge. Please try again.": "충전 실패,다시 시도해주세요.",
        "Failed to obtain personal info.": "사용자 소식 받아오기를 실패하였습니다.",
        "Failed to set up user\\'s county and area.": "사용자 지역 받아오기를 실패하였습니다.",
        "Friend request": "친구 신청",
        "Friend request sent successfully.": "친구신청 보내기 성공",
        "Friends": "친구",
        "GIFTO钱包": "GIFTO 지갑",
        "Gift Dashboards": "선물함",
        "Gift assistant": "선물 도우미",
        "Gifts": "선물",
        "Go to Uplive": "Uplive 실행",
        "How to get gifts?": "어떻게 선물을 받을 수 있나요?",
        "I sent you <%=count%> <%=name%> in <%=itemName%>, check it out!": "<%=itemName%> 을(를) <%=name%> 님에게 <%=count%> 개 보냈습니다，얼른 확인 해보세요！",
        "Insufficient balance, please recharge.": "잔액이 부족합니다. 충전해주세요.",
        "Invalid data.": "데이터가 유효하지 않습니다.",
        "It takes some time to engrave on blockchain we will seed you message when it’s done!": "블록체인에 새겨지는데 시간이 소요될 수 있습니다. 완료 후 메시지 알람을 보내드립니다.",
        "Last update": "수정일자",
        "Leaderboard": "순위보드",
        "Limit is Description is 120 characters.": "상세 설명은 120자를 넘을 수 없습니다.",
        "Limit of Name is 30 characters.": "이름은 30자를 넘을 수 없습니다.",
        "Limited to 130 characters": "130자로 제한됩니다.",
        "Limited to <%=count%> characters": "<%=count%> 자로 제한 됩니다.",
        "Loading": "로딩중",
        "Loading...": "로딩중...",
        "Log out": "로그아웃",
        "Login to Send Gift": "로그인하시면 바로 선물을 보낼 수 있습니다.",
        "Make it Forever...": "새겨보세요",
        "Message cannot be empty!": "메시지는 비워둘 수 없습니다.",
        "Messages": "메시지",
        "MyCard": "MyCard",
        "NEXT": "다음",
        "Name this Dashboard": "선물함 이름",
        "Next Step": "다음 단계",
        "No more data": "더 이상 데이터가 없습니다.",
        "OK": "좋아요.",
        "OnlineBank(IDR)": "OnlineBank(IDR)",
        "PayPal": "PayPal",
        "Payment cancelled.": "결제를 취소하였습니다.",
        "Payment failed.": "결제를 실패하였습니다.",
        "Payment has been processed.": "결제 성공!",
        "Please login to recharge.": "로그인 후 충전하십시오.",
        "Please name your dashboard.": "선물함 이름을 만들어주세요.",
        "Please recharge": "충전해주세요.",
        "Please select a valid image format.": "올바른 형식의 사진을 선택해주세요.",
        "Please select the link and copy.": "직접 링크를 선택하고 복사하세요.",
        "Please select the sending gift first.": "보내실 선물을 먼저 선택해주세요.",
        "Previous page": "이전 페이지",
        "QQ": "QQ",
        "Rankings": "순위표",
        "Received gifts": "받은 선물",
        "Recharge amount": "충전금액",
        "Recharge option": "충전선택",
        "Reselect": "다시 선택",
        "Revenue": "수익",
        "Save": "저장",
        "Save Dashboard": "선물함 저장",
        "Say something": "뭐든 말 좀 해봐…",
        "Say something about yourself": "자기소개",
        "See all >": "모두 보기>",
        "Select from photo": "사진첩에서 선택하기",
        "Send": "보내기",
        "Send <%=value%> GTO": "Send <%=value%> GTO",
        "Send thanks!": "감사 인사",
        "Session timeout.": "페이지가 만료되었습니다.",
        "Sign in": "로그인",
        "Step 1": "1단계",
        "Step 1: Pick gifts for your new gift dashboard first.": "1단계: 자신의 새로운 선물함에서 선물을 선택하세요.",
        "Step 2": "2단계",
        "Step 2: Copy your new gift dashboard’s link.": "2단계: 자신의 새로운 선물함 링크를 복사하세요.",
        "Step 3": "3단계",
        "Step 3: Paste your new dashboard link under your creative content.": "3단계: 자신이 포스팅한 선물함 내용의 링크를 붙여넣으세요.",
        "Swipe up to load more": "페이지를 위로 올려 더 많이 불러오세요",
        "System error.": "시스템 에러.",
        "TOTAL REVENUE": "총 수익",
        "This name has been used": "같은 이름이 이미 있습니다",
        "Tip: Resolution of 800x800 is suggested": "팁: 권장 해상도는 800x800 입니다.",
        "Tips:": "팁:",
        "Transaction submitted.": "거래가 처리되었습니다.",
        "Twitter": "Twitter",
        "USD $ <%=value%>": "USD $ <%=value%>",
        "Universal Gifting": "유니버셜 기프팅",
        "Up ID": "Up ID",
        "Upload a higher resolution profile pic to receive more gifts!": "고화질의 프로필 사진을 등록하면 선물 받을 기회가 늘어납니다!",
        "Uploading...": "업로드중…",
        "VIP等级不足": "VIP레벨이 낮습니다.",
        "View on Blockchain": "보러가기",
        "Wechat": "위챗",
        "Weibo": "웨이보",
        "Withdraw": "현금 인출",
        "Withdraw is only supported in Uplive app, please go to Uplive app to withdraw.": "Uplive app 을(를) 통해서만 현금 인출이 가능합니다. Uplive 을(를) 실행시켜주세요.",
        "Xenopay": "Xenopay",
        "You can create a project by Uplive web or app to generate a gift link.": "자신만의 선물함을 만들어 보세요",
        "You could only create 10 Dashboards.": "선물함은 10개까지 만들 수 있습니다.",
        "You have exceeded the daily limit": "당일 충전금액 한도를 초과하였습니다.",
        "You two are friends now.": "서로 친구가 되었습니다.",
        "Your gift is now on blockchain !": "당신의 선물이 블록체인화 되었습니다. ",
        "Your gift is on the way": "선물을 보내는 중입니다",
        "Your name": "당신의 이름은",
        "agree": "수락하였습니다.",
        "agreed": "이미 수락하였습니다.",
        "bk_atm": "bk_atm결제",
        "bk_card": "bk_card결제",
        "onecard": "onecard",
        "send": "보내기",
        "send <%=giftName%>": "<%=giftName%> 을(를)보내기",
        "skip": "넘어가기",
        "uDiamonds": "U다이아몬드",
        "“篆刻到區塊鏈需要” <%=fee%> GTO": "블록체인화 하는데 <%=fee%> GTO가 필요합니다.",
        "你还有未完成的交易，请稍后再试": "거래가 완료되지 않았습니다. 다시 시도해주세요.",
        "保存并分享": "저장 및 공유",
        "分享到Line": "라인으로 공유하기",
        "分享到Telegram": "텔레그램으로 공유하기",
        "创建链接": "링크 생성",
        "删除面板不会影响你收到的礼物": "아이템 패널 삭제는 선물받은 아이템과 무관합니다.",
        "发布到FB!": "페이스북 포스팅",
        "取消": "취소",
        "同意": "확인",
        "图片已经成功保存到你的设备上了": "선물 이미지가 디바이스에 성공적으로 저장되었습니다. ",
        "在Facebook/Instagram/...任何地方都可以用Uplive收礼物啦！": "Facebook/Instagram 등 어디서든 업라이브의 아이템을 받을 수 있어요!",
        "地址已经成功复制到剪切板了": "클립보드에 주소 복사 성공",
        "复制地址": "주소 복사",
        "存款到这个账户": "계좌에 입금 성공",
        "完成": "완료",
        "建议至少选择3~5礼物": "최소 3 ~ 5 선물을 선택하는 것이 좋습니다~",
        "开始收礼物吧！": "아이템 받으러 오세요~",
        "得到链接并复制": "링크 받은 후 복사하기",
        "快來看看我精心定制的禮物吧！": "Come check out my customized gifts!",
        "把礼物链接发送到你的Facebook或者Youtube": "아이템 링크를 페이스북이나 유튜브에 전송하기",
        "收到<%=amount%>个礼物, 价值 <%=value%> GTO": "<%=amount%>개 아이템을 받았습니다. 해당 가치는 <%=value%> GTO입니다.",
        "放弃": "취소",
        "正在加载数据...": "수치입력중...",
        "没有找到匹配的礼物": "매칭하는 아이템을 찾을 수 없습니다.",
        "点击查看": "터치하여 확인하기",
        "生成图片...": "선물이 생성 중입니다...",
        "确认删除": "정말 삭제하시겠습니까?",
        "确认删除该礼物面板? 删除后将不可恢复": "해당 아이템 패널을 삭제하시겠습니까? 삭제 후 복구 불가합니다.",
        "礼物记录不存在": "선물이 없습니다",
        "礼物面板删除成功！": "아이템 패널 삭제 성공!",
        "编辑文字": "메시지 수정",
        "要放弃本次头像修改吗？": "프로필 수정을 취소하시겠습니까?",
        "试试": "미리보기",
        "该地区暂未开放": "해당 지역은 서비스 준비 전입니다.",
        "该礼物已失效": "선물이 만료되었습니다.",
        "跳过的提示文本": "블록체인화는 한 번 밖에 할 수 없습니다.<br/>지금 취소하면 메세지와 선물을 블록체인화 할 수 없습니다.",
        "输入备注的提示文本": "블록체인에 남기고 싶은 메시지를 작성해 주세요...",
        "送有趣的禮物原來這麽簡單！——GIFTO通用禮物": "아이템 선물이 쉬워졌어요!-GIFTO- 유니버셜 기프팅",
        "选择礼物": "아이템 선택",
        "重新播放": "재시도"
    },
    "vivn": {
        "GIFTO钱包": "Ví GTO",
        "Send <%=value%> GTO": "Gửi <%=value%> GTO",
        "USD $ <%=value%>": "USD $ <%=value%>",
        "VIP等级不足": "Level VIP chưa đủ",
        "删除面板不会影响你收到的礼物": "Xóa bảng quà tặng này không ảnh hướng đến việc nhận quà của bạn",
        "取消": "Hủy",
        "地址已经成功复制到剪切板了": "Địa chỉ đã được sao chép đến bảng tạm",
        "复制地址": "Sao chép địa chỉ",
        "存款到这个账户": "Gửi tiền vào tài khoản này",
        "建议至少选择3~5礼物": "Ít nhất chọn từ 3-5 món quà~",
        "收到<%=amount%>个礼物, 价值 <%=value%> GTO": "Nhận được <%=amount%> món quà, trị giá <%=value%> GTO",
        "正在加载数据...": "Đang tải ...",
        "没有找到匹配的礼物": "Chưa tìm được quà phù hợp",
        "确认删除": "Xác nhận",
        "确认删除该礼物面板? 删除后将不可恢复": "Bạn có chắc sẽ xóa bảng quà tặng này? Sau khi xóa không thể khôi phục lại",
        "礼物面板删除成功！": "Đã xóa thành công bảng quà tặng!",
        "要放弃本次头像修改吗？": "Bạn không muốn thay đổi Avatar? ",
        "该地区暂未开放": "Khu vực này hiện chưa ra mắt tính năng",
        "该用户的地区暂未支持GIFTO礼物": "Khu vực này hiên chưa mở tính năng GIFTO"
    },
    "zhcn": {
        "50 gifts in one Gift Dashboard only.": "每个礼物面板只支持选择50个礼物哦！",
        "<%=username%> sent you <%=count%> <%=name%>, check it out!": "<%=username%>给你送了<%=count%>个<%=name%>，快去看看！",
        "Add a gift link below your Youtube or Facebook post.": "将创建好的礼物面板链接贴到你在Youtube、Facebook等平台发布的内容文字描述里。",
        "Add friend": "添加好友",
        "Add friends and chat it up!": "加个好友吧！聊天能让你们的关系更好哦！",
        "Alipay": "支付宝",
        "Balance": "余额",
        "Bank Transfer": "银行转账",
        "Cancel": "取消",
        "Check out your revenue record here or in Uplive when you received a gift.": "随时通过提现页面或者Uplive app查看你的收益记录。",
        "Check revenue": "查看收益",
        "Confirm": "确定",
        "Copied Successfully!": "复制成功！",
        "Copied failed. Please select the link and copy.": "复制失败，请手动选中链接并复制。",
        "Copy link": "复制链接",
        "Create Dashboard": "创建礼物面板",
        "Create Dashboard Btn": "创建新的礼物面板",
        "Create more dashboards": "创建新的礼物面板",
        "Current edits are not saved yet, jump to edit profile picture now?": "当前编辑还未保存，舍弃编辑并跳转到个人头像页面吗？",
        "Customer Assistant": "官方助手",
        "Customer Service": "官方客服",
        "Dashboard created!": "新的礼物面板创建成功！",
        "Dashboard failed to create.": "礼物面板创建失败",
        "Dashboard failed to update;(": "更新失败=(",
        "Dashboard updated!": "礼物面板成功更新！",
        "Describe this dashboard": "该礼物面板的描述",
        "Description": "描述",
        "Edit profile picture": "编辑头像",
        "Engrave on Blockchain": "篆刻到区块链",
        "Engraving on Blockchain...": "正在篆刻到区块链...",
        "Enter project name": "输入礼物面板名称",
        "Error.": "服务出错了。请稍候再试。",
        "Expired userToken.": "过期的用户信息。",
        "Facebook": "Facebook",
        "Failed to charge. Please try again.": "充值失败，请重新尝试。",
        "Failed to obtain personal info.": "获取用户信息失败。",
        "Failed to set up user\\'s county and area.": "获取用户的地区失败。",
        "Friend request": "好友申请",
        "Friend request sent successfully.": "好友申请发送成功",
        "Friends": "朋友",
        "GIFTO钱包": "GIFTO钱包",
        "Gift Dashboards": "礼物面板",
        "Gift assistant": "礼物助手",
        "Gifts": "礼物",
        "Go to Uplive": "打开Uplive",
        "How to get gifts?": "如何获得礼物打赏？",
        "I sent you <%=count%> <%=name%> in <%=itemName%>, check it out!": "我在<%=itemName%>给你送了<%=count%>个<%=name%> ，快看看！",
        "Insufficient balance, please recharge.": "余额不足,请充值",
        "Invalid data.": "无效的数据。",
        "It takes some time to engrave on blockchain we will seed you message when it’s done!": "篆刻到区块链需要一点时间，成功后我们会发消息通知你。",
        "Last update": "更新日期",
        "Leaderboard": "排行榜",
        "Limit is Description is 120 characters.": "项目描述不能超过120字符",
        "Limit of Name is 30 characters.": "项目名字不能超过30字符",
        "Limited to 130 characters": "130字符限制",
        "Limited to <%=count%> characters": "<%=count%>字符限制",
        "Loading": "加载中",
        "Loading...": "加载中...",
        "Log out": "登出",
        "Login to Send Gift": "登录即可送礼",
        "Make it Forever...": "让此刻永驻",
        "Message cannot be empty!": "信息不能为空。",
        "Messages": "信息",
        "MyCard": "MyCard",
        "NEXT": "下一步",
        "Name this Dashboard": "礼物面板名称",
        "Next Step": "下一步",
        "No more data": "没有更多数据了",
        "OK": "好的",
        "PayPal": "PayPal",
        "Payment cancelled.": "支付取消了。",
        "Payment failed.": "支付失败了。",
        "Payment has been processed.": "支付成功！",
        "Please login to recharge.": "请先登录再进行充值。",
        "Please name your dashboard.": "请给你新的礼物面板命名",
        "Please recharge": "请充值。",
        "Please select a valid image format.": "请选择一个正确的图片格式。",
        "Please select the link and copy.": "请手动选择链接并复制。",
        "Please select the sending gift first.": "请先选中要送的礼物。",
        "Previous page": "上一页",
        "QQ": "QQ",
        "Rankings": "排行榜",
        "Received gifts": "收到的礼物",
        "Recharge amount": "充值金额",
        "Recharge option": "充值选项",
        "Reselect": "重新选择",
        "Revenue": "收益",
        "Save": "保存",
        "Save Dashboard": "保存礼物面板",
        "Say something": "说点什么吧……",
        "Say something about yourself": "自我介绍",
        "See all >": "查看所有>",
        "Select from photo": "从相册中选择",
        "Send": "发送",
        "Send <%=value%> GTO": "送出 <%=value%> GTO",
        "Send thanks!": "答谢TA",
        "Session timeout.": "页面超时。",
        "Sign in": "登录",
        "Step 1": "第一步",
        "Step 1: Pick gifts for your new gift dashboard first.": "第一步：为你的全新礼物面板选择礼物",
        "Step 2": "第二步",
        "Step 2: Copy your new gift dashboard’s link.": "第二步：复制你全新礼物面板的超链接。",
        "Step 3": "第三步",
        "Step 3: Paste your new dashboard link under your creative content.": "第三步：在你发布的内容下方粘贴礼物面板链接。",
        "Swipe up to load more": "上划页面可加载更多",
        "System error.": "系统错误。",
        "TOTAL REVENUE": "总收益",
        "This name has been used": "项目名称已存在",
        "Tip: Resolution of 800x800 is suggested": "小贴士：建议清晰度为800x800。",
        "Tips:": "小贴士：",
        "Transaction submitted.": "交易已提交。",
        "Twitter": "Twitter",
        "USD $ <%=value%>": "USD $ <%=value%>",
        "Universal Gifting": "通用礼物",
        "Up ID": "Up ID",
        "Upload a higher resolution profile pic to receive more gifts!": "上传高清的头像可以提高获得礼物的机会哦！",
        "Uploading...": "上传中...",
        "VIP等级不足": "VIP等级不足",
        "View on Blockchain": "去查看",
        "Wechat": "微信",
        "Weibo": "微博",
        "Withdraw": "提现",
        "Withdraw is only supported in Uplive app, please go to Uplive app to withdraw.": "只能通过Uplive app提现，请打开Uplive。",
        "Xenopay": "Xenopay",
        "You can create a project by Uplive web or app to generate a gift link.": "创建你自己的礼物面板",
        "You could only create 10 Dashboards.": "目前只能创建10个不同的礼物面板。",
        "You have exceeded the daily limit": "你超过了每日充值的额度上限。",
        "You two are friends now.": "你们已成为了朋友。",
        "Your gift is now on blockchain !": "你的礼物已发送到区块链!",
        "Your gift is on the way": "您的礼物正在路上",
        "Your name": "你的名字",
        "agree": "同意",
        "agreed": "已同意",
        "bk_atm": "bk_atm支付",
        "bk_card": "bk_card支付",
        "onecard": "onecard",
        "send": "送出",
        "send <%=giftName%>": "送出 <%=giftName%>",
        "skip": "跳过",
        "uDiamonds": "u钻",
        "“篆刻到區塊鏈需要” <%=fee%> GTO": "篆刻到区块链需要<%=fee%> GTO",
        "你还有未完成的交易，请稍后再试": "您还有未完成的交易，请稍后再试",
        "保存并分享": "保存并分享",
        "分享到Line": "分享到Line",
        "分享到Telegram": "分享到Telegram",
        "创建链接": "创建链接",
        "删除面板不会影响你收到的礼物": "删除面板不会影响你收到的礼物",
        "发布到FB!": "发布到FB!",
        "取消": "取消",
        "同意": "同意",
        "图片已经成功保存到你的设备上了": "图片已经成功保存到你的设备上了",
        "在Facebook/Instagram/...任何地方都可以用Uplive收礼物啦！": "在Facebook/Instagram/...任何地方都可以用Uplive收礼物啦！",
        "地址已经成功复制到剪切板了": "已成功复制到剪切板。",
        "复制地址": "复制地址",
        "存款到这个账户": "存款到这个账户",
        "完成": "完成",
        "建议至少选择3~5礼物": "建议至少选择3~5礼物",
        "开始收礼物吧！": "开始收礼物吧！",
        "得到链接并复制": "获得链接并复制",
        "快來看看我精心定制的禮物吧！": "快來看看我精心定制的禮物吧！",
        "把礼物链接发送到你的Facebook或者Youtube": "把礼物链接发送到你的Facebook或者Youtube",
        "收到<%=amount%>个礼物, 价值 <%=value%> GTO": "这个礼物面板收到 <span class=\"red\"><%=amount%></span> 个礼物, 价值 <span class=\"red\"><%=value%></span> GTO",
        "放弃": "放弃",
        "正在加载数据...": "正在加载数据...",
        "没有找到匹配的礼物": "没有找到匹配的礼物",
        "点击查看": "快到区块链上查看吧！",
        "生成图片...": "正在生成礼物...",
        "确认删除": "确认删除",
        "确认删除该礼物面板? 删除后将不可恢复": "确认删除该礼物面板? 删除后将不可恢复",
        "礼物记录不存在": "礼物记录不存在",
        "礼物面板删除成功！": "礼物面板删除成功！",
        "编辑文字": "编辑留言",
        "要放弃本次头像修改吗？": "要放弃本次头像修改吗？",
        "试试": "试一试",
        "该地区暂未开放": "该地区暂未开放",
        "该用户的地区暂未支持GIFTO礼物": "该用户的地区暂未支持GIFTO礼物",
        "该礼物已失效": "该礼物已失效。",
        "跳过的提示文本": "篆刻机会只有一次，现在放弃就会永久失去对这段留言和礼物进行篆刻的机会。",
        "输入备注的提示文本": "你在此的留言将有机会篆刻到区块链上......",
        "送有趣的禮物原來這麽簡單！——GIFTO通用禮物": "送有趣的禮物原來這麽簡單！——GIFTO通用禮物",
        "选择礼物": "选择礼物",
        "重新播放": "重新播放"
    },
    "zhhk": {
        "50 gifts in one Gift Dashboard only.": "每個禮物面板只支援選擇50個禮物哦！",
        "<%=username%> sent you <%=count%> <%=name%>, check it out!": "<%=username%>給你發送了<%=count%>個<%=name%>，快去看看！",
        "Add a gift link below your Youtube or Facebook post.": "將創建好的禮物面板鏈接，貼到你在Youtube、Facebook等平台發布的內容文字描述裏",
        "Add friend": "添加好友",
        "Add friends and chat it up!": "加個好友吧！聊天能讓你們的關係更好哦！",
        "Alipay": "支付寶",
        "Balance": "餘額",
        "Bank Transfer": "銀行轉帳",
        "Cancel": "取消",
        "Check out your revenue record here or in Uplive when you received a gift.": "通過提現頁面或者Uplive app可以隨時查看你的收入記錄。",
        "Check revenue": "查看收益",
        "Confirm": "確定",
        "Copied Successfully!": "複製成功！",
        "Copied failed. Please select the link and copy.": "複製失敗，請手動選中鏈接並複製",
        "Copy link": "複製鏈接",
        "Create Dashboard": "創建禮物面板",
        "Create Dashboard Btn": "創建新的禮物面板",
        "Create more dashboards": "創建新的禮物面板",
        "Current edits are not saved yet, jump to edit profile picture now?": "當前編輯還未保存，捨棄編輯並跳轉到個人頭像頁面嗎？",
        "Customer Assistant": "官方助手",
        "Customer Service": "官方客服",
        "Dashboard created!": "新的禮物面板創建成功！",
        "Dashboard failed to create.": "禮物面板創建失敗",
        "Dashboard failed to update;(": "更新失敗",
        "Dashboard updated!": "禮物面板成功",
        "Describe this dashboard": "該禮物面板的描述",
        "Description": "描述",
        "Edit profile picture": "編輯頭像",
        "Enter project name": "輸入禮物面板名稱",
        "Error.": "服務出錯了。請稍候再試。",
        "Expired userToken.": "過期的用戶訊息",
        "Facebook": "Facebook",
        "Failed to charge. Please try again.": "充值失敗，請重新嘗試",
        "Failed to obtain personal info.": "獲取用戶訊息失敗",
        "Failed to set up user\\'s county and area.": "獲取用戶地區失敗",
        "Friend request": "好友申請",
        "Friend request sent successfully.": "好友申請發送成功",
        "Friends": "朋友",
        "GIFTO钱包": "GIFTO錢包",
        "Gift Dashboards": "禮物面板",
        "Gift assistant": "禮物助手",
        "Gifts": "禮物",
        "Go to Uplive": "開啟Uplive",
        "How to get gifts?": "如何獲得禮物？",
        "I sent you <%=count%> <%=name%> in <%=itemName%>, check it out!": "我在 <%=itemName%>給你發了<%=count%>个<%=name%> ，快看看！",
        "Insufficient balance, please recharge.": "餘額不足請充值",
        "Invalid data.": "無效數據",
        "Last update": "更新日期",
        "Leaderboard": "排行榜",
        "Limit is Description is 120 characters.": "項目描述不能高過120字元",
        "Limit of Name is 30 characters.": "項目名字不能超過30字元",
        "Loading": "加載中",
        "Loading...": "載入中...",
        "Log out": "登出",
        "Login to Send Gift": "登入即可送禮",
        "Message cannot be empty!": "訊息不能為空",
        "Messages": "訊息",
        "MyCard": "MyCard",
        "Name this Dashboard": "禮物面板名稱",
        "Next Step": "下一步",
        "No more data": "沒有更多資料了",
        "OK": "好的",
        "PayPal": "PayPal",
        "Payment cancelled.": "支付取消",
        "Payment failed.": "支付失敗",
        "Payment has been processed.": "支付成功",
        "Please login to recharge.": "請先登錄再進行充值。",
        "Please name your dashboard.": "請給你的新禮物面板命名",
        "Please recharge": "請充值",
        "Please select a valid image format.": "請選擇一個正確的圖片格式",
        "Please select the link and copy.": "請手動選擇鏈接並複製",
        "Please select the sending gift first.": "請先選要送的禮物",
        "Previous page": "上一頁",
        "QQ": "QQ",
        "Rankings": "排行榜",
        "Received gifts": "收到的禮物",
        "Recharge amount": "充值金額",
        "Recharge option": "充值選項",
        "Reselect": "重新選擇",
        "Revenue": "收益",
        "Save": "保存",
        "Save Dashboard": "保存禮物面板",
        "Say something": "說點什麼吧",
        "Say something about yourself": "自我介紹",
        "See all >": "查看所有>",
        "Select from photo": "從相冊中選擇",
        "Send": "發送",
        "Send <%=value%> GTO": "Send <%=value%> GTO",
        "Send thanks!": "感謝他",
        "Session timeout.": "頁面超時",
        "Sign in": "登入",
        "Step 1": "第一步",
        "Step 1: Pick gifts for your new gift dashboard first.": "第一步：為你的全新禮物面板選擇禮物",
        "Step 2": "第二步",
        "Step 2: Copy your new gift dashboard’s link.": "第二步：複製你全新禮物面板的超鏈接",
        "Step 3": "第三步",
        "Step 3: Paste your new dashboard link under your creative content.": "第三步：在你發布的內容下方貼上禮物面板鏈接",
        "Swipe up to load more": "將頁面向上拉來加載更多內容",
        "System error.": "系統錯誤",
        "TOTAL REVENUE": "總收益",
        "This name has been used": "項目名稱已存在",
        "Tip: Resolution of 800x800 is suggested": "溫馨提示：建議清晰度為800X800",
        "Tips:": "提醒：",
        "Twitter": "Twitter",
        "USD $ <%=value%>": "USD $ <%=value%>",
        "Universal Gifting": "通用禮物",
        "Up ID": "Up ID",
        "Upload a higher resolution profile pic to receive more gifts!": "上傳高清的頭像可以提高獲得禮物的機會哦！",
        "Uploading...": "上傳中...",
        "VIP等级不足": "VIP等級不足",
        "Wechat": "微信",
        "Weibo": "微博",
        "Withdraw": "提現",
        "Withdraw is only supported in Uplive app, please go to Uplive app to withdraw.": "只能通過Uplive app提現，請開啟Uplive",
        "Xenopay": "Xenopay",
        "You can create a project by Uplive web or app to generate a gift link.": "創建你自己的禮物面板",
        "You could only create 10 Dashboards.": "目前只能創建10個不同的禮物面板。",
        "You have exceeded the daily limit": "你超過了每日充值的額度上限",
        "You two are friends now.": "你們已經成為朋友",
        "Your gift is on the way": "您的禮物正在路上",
        "Your name": "你的名字",
        "agree": "同意",
        "agreed": "已同意",
        "bk_atm": "bk_atm支付",
        "bk_card": "bk_card支付",
        "onecard": "onecard",
        "send": "送出",
        "send <%=giftName%>": "送出 <%=giftName%>",
        "uDiamonds": "U鑽",
        "你还有未完成的交易，请稍后再试": "您還有未完成的交易，請稍後再試",
        "创建链接": "創建鏈接",
        "删除面板不会影响你收到的礼物": "刪除板面不會影響你收到的禮物",
        "发布到FB!": "發布到FB!",
        "取消": "取消",
        "在Facebook/Instagram/...任何地方都可以用Uplive收礼物啦！": "係Facebook/Instagram/...任何地方都可以用Uplive收禮物啦！",
        "地址已经成功复制到剪切板了": "已成功複製到Clipboard",
        "复制地址": "複製地址",
        "存款到这个账户": "存款到這個帳戶",
        "建议至少选择3~5礼物": "建議至少選擇3~5禮物～",
        "开始收礼物吧！": "開始收禮物吧！",
        "得到链接并复制": "獲得鏈接並複制",
        "快來看看我精心定制的禮物吧！": "快來看看我精心定制的禮物吧！",
        "把礼物链接发送到你的Facebook或者Youtube": "把禮物鏈接發送到你的Facebook或者Youtube",
        "收到<%=amount%>个礼物, 价值 <%=value%> GTO": "收到<%=amount%>個禮物, 價值 <%=value%> GTO",
        "正在加载数据...": "正在載入數據...",
        "没有找到匹配的礼物": "沒有找到匹配的禮物",
        "确认删除": "確認刪除",
        "确认删除该礼物面板? 删除后将不可恢复": "確認刪除該禮物板面？刪除後將不可恢復",
        "礼物面板删除成功！": "禮物板面刪除成功！",
        "要放弃本次头像修改吗？": "要放棄本次頭像修改嗎？",
        "该地区暂未开放": "該地區暫未開放",
        "该用户的地区暂未支持GIFTO礼物": "該用戶的地區暫未支持GIFTO禮物",
        "送有趣的禮物原來這麽簡單！——GIFTO通用禮物": "送有趣的禮物原來這麽簡單！——GIFTO通用禮物",
        "选择礼物": "選擇禮物"
    },
    "zhtw": {
        "50 gifts in one Gift Dashboard only.": "每個禮物面板只支援選擇50個禮物哦！",
        "<%=username%> sent you <%=count%> <%=name%>, check it out!": "<%=username%>給你發送了<%=count%>个<%=name%>，快去看看！",
        "Add a gift link below your Youtube or Facebook post.": "將創建好的禮物面板鏈接貼到你在Youtube、Facebook等平台發布的內容文字描述裡",
        "Add friend": "添加好友",
        "Add friends and chat it up!": "加個好友吧！聊天能讓你們的關係更好哦！",
        "Alipay": "支付寶",
        "Balance": "餘額",
        "Bank Transfer": "銀行轉帳",
        "Cancel": "取消",
        "Check out your revenue record here or in Uplive when you received a gift.": "隨時通過提現頁面或者Uplive app查看你的收益紀錄",
        "Check revenue": "查看收益",
        "Confirm": "確定",
        "Copied Successfully!": "複製成功！",
        "Copied failed. Please select the link and copy.": "複製失敗，請手動選中鏈接並複製",
        "Copy link": "複製鏈接",
        "Create Dashboard": "創建禮物面板",
        "Create Dashboard Btn": "創建新的禮物面板",
        "Create more dashboards": "創建新的禮物面板",
        "Current edits are not saved yet, jump to edit profile picture now?": "當前編輯還未保存，捨棄編輯並跳轉到個人頭像頁面嗎？",
        "Customer Assistant": "官方助手",
        "Customer Service": "官方客服",
        "Dashboard created!": "新的禮物面板創建成功！",
        "Dashboard failed to create.": "禮物面板創建失敗",
        "Dashboard failed to update;(": "更新失敗",
        "Dashboard updated!": "禮物面板成功！",
        "Describe this dashboard": "該禮物面板的描述",
        "Description": "描述",
        "Edit profile picture": "編輯頭像",
        "Engrave on Blockchain": "雕刻到區塊鏈",
        "Engraving on Blockchain...": "正在雕刻到區塊鏈...",
        "Enter project name": "輸入禮物面板名稱",
        "Error.": "服務出錯了。請稍候再試。",
        "Expired userToken.": "過期的用戶訊息",
        "Facebook": "Facebook",
        "Failed to charge. Please try again.": "儲值失敗，請重新嘗試",
        "Failed to obtain personal info.": "獲取用戶訊息失敗",
        "Failed to set up user\\'s county and area.": "獲取用戶地區失敗",
        "Friend request": "好友申請",
        "Friend request sent successfully.": "好友申請發送成功",
        "Friends": "朋友",
        "GIFTO钱包": "GIFTO錢包",
        "Gift Dashboards": "禮物面板",
        "Gift assistant": "禮物助手",
        "Gifts": "禮物",
        "Go to Uplive": "打開Uplive",
        "How to get gifts?": "如何獲得禮物打賞？",
        "I sent you <%=count%> <%=name%> in <%=itemName%>, check it out!": "我在 <%=itemName%>給你發了<%=count%>个<%=name%> ，快看看！",
        "Insufficient balance, please recharge.": "餘額不足請充值",
        "Invalid data.": "無效數據",
        "It takes some time to engrave on blockchain we will seed you message when it’s done!": "雕刻到區塊鏈需要一點時間，成功後我們會發消息通知你。",
        "Last update": "更新日期",
        "Leaderboard": "排行榜",
        "Limit is Description is 120 characters.": "項目描述不能高過120字元",
        "Limit of Name is 30 characters.": "項目名字不能超過30字元",
        "Limited to 130 characters": "130字元限制",
        "Limited to <%=count%> characters": "<%=count%>字元限制",
        "Loading": "載入中",
        "Loading...": "載入中...",
        "Log out": "登出",
        "Login to Send Gift": "登入即可送禮",
        "Make it Forever...": "讓此刻永駐",
        "Message cannot be empty!": "訊息不能為空",
        "Messages": "訊息",
        "MyCard": "MyCard",
        "NEXT": "下一步",
        "Name this Dashboard": "禮物面板名稱",
        "Next Step": "下一步",
        "No more data": "沒有更多資料了",
        "OK": "好的",
        "PayPal": "PayPal",
        "Payment cancelled.": "支付取消",
        "Payment failed.": "支付失敗",
        "Payment has been processed.": "支付成功！",
        "Please login to recharge.": "請先登錄再進行充值。",
        "Please name your dashboard.": "請給你的新禮物面板命名",
        "Please recharge": "請儲值",
        "Please select a valid image format.": "請選擇一個正確的圖片格式",
        "Please select the link and copy.": "請手動選擇鏈接並複製",
        "Please select the sending gift first.": "請先選要送的禮物",
        "Previous page": "上一頁",
        "QQ": "QQ",
        "Rankings": "排行榜",
        "Received gifts": "收到的禮物",
        "Recharge amount": "儲值金額",
        "Recharge option": "儲值選項",
        "Reselect": "重新選擇",
        "Revenue": "收益",
        "Save": "保存",
        "Save Dashboard": "保存禮物面板",
        "Say something": "說點什麼吧",
        "Say something about yourself": "自我介紹",
        "See all >": "查看所有>",
        "Select from photo": "從相冊中選擇",
        "Send": "發送",
        "Send <%=value%> GTO": "Send <%=value%> GTO",
        "Send thanks!": "感謝TA",
        "Session timeout.": "頁面超時",
        "Sign in": "登入",
        "Step 1": "第一步",
        "Step 1: Pick gifts for your new gift dashboard first.": "第一步：為你的全新禮物面板選擇禮物",
        "Step 2": "第二步",
        "Step 2: Copy your new gift dashboard’s link.": "第二步：複製你全心禮物面板的超鏈接",
        "Step 3": "第三步",
        "Step 3: Paste your new dashboard link under your creative content.": "第三步：在你發布的內容下方貼上禮物面板鏈接",
        "Swipe up to load more": "上劃頁面來加載更多",
        "System error.": "系統錯誤",
        "TOTAL REVENUE": "總收益",
        "This name has been used": "項目名稱已存在",
        "Tip: Resolution of 800x800 is suggested": "提醒：建議清晰度為800X800",
        "Tips:": "提醒：",
        "Transaction submitted.": "交易已提交。",
        "Twitter": "Twitter",
        "USD $ <%=value%>": "USD $ <%=value%>",
        "Universal Gifting": "通用禮物",
        "Up ID": "Up ID",
        "Upload a higher resolution profile pic to receive more gifts!": "上傳高清的頭像可以提高獲得禮物的機會哦！",
        "Uploading...": "上傳中...",
        "VIP等级不足": "VIP等級不足",
        "View on Blockchain": "去查看",
        "Wechat": "微信",
        "Weibo": "微博",
        "Withdraw": "提現",
        "Withdraw is only supported in Uplive app, please go to Uplive app to withdraw.": "只能通過Uplive app提現，請打開Uplive",
        "Xenopay": "Xenopay",
        "You can create a project by Uplive web or app to generate a gift link.": "創建你自己的禮物面板",
        "You could only create 10 Dashboards.": "目前只能創建10個不同的禮物面板。",
        "You have exceeded the daily limit": "你超過了每日儲值的額度上限",
        "You two are friends now.": "你們已成為了朋友",
        "Your gift is now on blockchain !": "你的禮物已發送到區塊鏈!",
        "Your gift is on the way": "您的禮物正在路上",
        "Your name": "你的名字",
        "agree": "同意",
        "agreed": "已同意",
        "bk_atm": "bk_atm支付",
        "bk_card": "bk_card支付",
        "onecard": "onecard",
        "send": "送出",
        "send <%=giftName%>": "送出 <%=giftName%>",
        "skip": "跳過",
        "uDiamonds": "U鑽",
        "“篆刻到區塊鏈需要” <%=fee%> GTO": "雕刻到區塊鏈需要<%=fee%> GTO",
        "你还有未完成的交易，请稍后再试": "您還有未完成的交易，請稍後再試",
        "保存并分享": "保存並分享",
        "分享到Line": "分享到Line",
        "分享到Telegram": "分享到Telegram",
        "创建链接": "創建鏈接",
        "删除面板不会影响你收到的礼物": "刪除面板不會影響你收到的禮物",
        "发布到FB!": "發布到FB!",
        "取消": "取消",
        "同意": "同意",
        "图片已经成功保存到你的设备上了": "圖片已經成功保存到你的設備上了",
        "在Facebook/Instagram/...任何地方都可以用Uplive收礼物啦！": "在Facebook/Instagram/...任何地方都可以用Uplive收禮物啦！",
        "地址已经成功复制到剪切板了": "已成功複製到剪貼簿",
        "复制地址": "複製地址",
        "存款到这个账户": "存入這個帳戶",
        "完成": "完成",
        "建议至少选择3~5礼物": "建議至少選擇3~5禮物噢～",
        "开始收礼物吧！": "開始收禮物吧！",
        "得到链接并复制": "獲得鏈接並複制",
        "快來看看我精心定制的禮物吧！": "快來看看我精心定制的禮物吧！",
        "把礼物链接发送到你的Facebook或者Youtube": "把禮物鏈接發送到你的Facebook或者Youtube",
        "收到<%=amount%>个礼物, 价值 <%=value%> GTO": "這個禮物面板收到 <span class=\"red\"><%=amount%></span>個禮物，價值 <span class=\"red\"><%=value%></span> GTO",
        "放弃": "放棄",
        "正在加载数据...": "正在載入數據...",
        "没有找到匹配的礼物": "沒有找到匹配的禮物",
        "点击查看": "快到區塊鏈上查看吧！",
        "生成图片...": "正在生成禮物...",
        "确认删除": "確認刪除",
        "礼物记录不存在": "禮物記錄不存在",
        "礼物面板删除成功！": "確認刪除該禮物面板？刪除後將不可恢復",
        "编辑文字": "編輯留言",
        "要放弃本次头像修改吗？": "要放棄本次頭像修改嗎？",
        "试试": "試一試",
        "该地区暂未开放": "該地區暫未開放",
        "该用户的地区暂未支持GIFTO礼物": "該用戶的地區暫未支持GIFTO禮物",
        "该礼物已失效": "該禮物已失效。",
        "跳过的提示文本": "雕刻機會只有一次，現在放棄就會永久失去對這段留言和禮物進行刻上區塊鏈的機會。",
        "输入备注的提示文本": "你在此的留言將有機會雕刻到區塊鏈上......",
        "送有趣的禮物原來這麽簡單！——GIFTO通用禮物": "送有趣的禮物原來這麽簡單！——GIFTO通用禮物",
        "选择礼物": "選擇禮物",
        "重新播放": "重新播放"
    }
};

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var _underscore = __webpack_require__(20);

var _underscore2 = _interopRequireDefault(_underscore);

var _pack = __webpack_require__(77);

var _pack2 = _interopRequireDefault(_pack);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 前端多语言解决方案
 */
var _lang = {

    tpl: function tpl(tplStr, data, insertEM) {
        var lang = UpSDK.config.language;
        var langType = lang.replace('-', '').toLowerCase();

        var langPack = _pack2.default[langType] || _pack2.default['zhcn'];

        var tpl = langPack[tplStr] || tplStr;

        try {
            if (tpl) {
                if (tpl.indexOf('@@@@') > 0) {
                    var strArr = [];

                    strArr.push('<ul>');
                    tpl.split('@@@@').forEach(function (item, index) {
                        item && strArr.push('<li>' + item + '</li>');
                    });
                    strArr.push('</ul>');
                    tpl = strArr.join('');
                }
                if (insertEM) {
                    tpl = tpl.replace(/<%=([\s\S]+?)%>/g, function ($0, $1) {
                        return '<em class="' + $1 + '">' + $0 + '</em>';
                    });
                }

                var compiled = _underscore2.default.template(tpl);
                return compiled(data);
            } else {
                return _underscore2.default.template(tplStr)(data);
            }
        } catch (e) {
            console.log(e.message);
        }
    }
};

Uplib.tpl = _lang.tpl;

module.exports = _lang;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.google = exports.twitter = exports.fb = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _config = __webpack_require__(27);

var _config2 = _interopRequireDefault(_config);

var _fb = __webpack_require__(51);

var _fb2 = _interopRequireDefault(_fb);

var _twitter = __webpack_require__(83);

var _twitter2 = _interopRequireDefault(_twitter);

var _google = __webpack_require__(85);

var _google2 = _interopRequireDefault(_google);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cache = UpSDK.cache;

var sns = {
    /**
     * 前往sns平台进行授权获取code(统一接口提供给外部调用)
     */
    jumpToSNS: function jumpToSNS(platfrom, scope) {
        this[platfrom + 'JumpForCode'](scope);
    },
    /**
     * 前往微信授权中心
     */
    wechatJumpForCode: function wechatJumpForCode(scope) {
        var self = this;
        var urlForCode = 'https://open.weixin.qq.com/connect/oauth2/authorize?';
        var wechat = _config2.default.upInfoInPlatform.wechat;
        var appid = void 0;

        if (Uplib.url.query('env') == 'stage') {
            appid = wechat['appid_stage'];
        } else {
            appid = wechat.appid;
        }

        var result = {
            appid: appid,
            redirect_uri: self.getRedirectUri(),
            response_type: 'code',
            scope: 'snsapi_base',
            state: '1'
        };

        if (scope == 'snsapi_userinfo') {
            Object.assign(result, {
                scope: scope,
                state: '2'
            });
        }

        self.jump(urlForCode + $.param(result) + '#wechat_redirect');
    },

    qqJumpForCode: function qqJumpForCode() {

        var urlForCode = 'https://graph.qq.com/oauth2.0/authorize?display=mobile&response_type=code&scope=get_user_info';
        var result = {
            client_id: '101402313',
            state: Uplib.url.query('stage'),
            redirect_uri: this.getRedirectUri()
        };

        this.jump(urlForCode + '&' + $.param(result));
    },

    twitterJumpForCode: function twitterJumpForCode(requestToken) {
        var urlForCode = 'https://api.twitter.com/oauth/authenticate?oauth_token=' + requestToken;
        this.jump(urlForCode);
    },

    weiboJumpForCode: function weiboJumpForCode() {
        var urlForCode = 'https://api.weibo.com/oauth2/authorize';

        var result = {
            client_id: _config2.default.upInfoInPlatform.weibo.appid,
            response_type: 'code',
            redirect_uri: this.getRedirectUri()
        };

        this.jump(urlForCode + '?' + $.param(result));
    },

    lineJumpForCode: function lineJumpForCode() {
        var urlForCode = 'https://access.line.me/oauth2/v2.1/authorize?';
        var href = location.href;
        href = Uplib.url.delQuery(href, 'code');
        href = Uplib.url.delQuery(href, 'state');
        href = href.replace(/#.*/, '');

        var result = {
            response_type: 'code',
            // client_id: '1575942563',
            client_id: '1542604681',
            state: +new Date(),
            scope: 'profile openid',
            redirect_uri: href
        };

        this.jump(urlForCode + $.param(result));
    },

    /**
     * 获得重定向URL
     */
    getRedirectUri: function getRedirectUri() {
        var _location$href$split = location.href.split('#'),
            _location$href$split2 = _slicedToArray(_location$href$split, 2),
            baseUrl = _location$href$split2[0],
            hash = _location$href$split2[1];
        // 微信、微博。授权参数code
        // facebook 没有额外授权参数


        baseUrl = Uplib.url.delQuery(baseUrl, 'code');
        baseUrl = Uplib.url.delQuery(baseUrl, 'state');
        // twitter。。授权参数oauth_token，oauth_verifier
        baseUrl = Uplib.url.delQuery(baseUrl, 'oauth_token');
        baseUrl = Uplib.url.delQuery(baseUrl, 'oauth_verifier');

        cache.setCache('redirectHash', hash);

        return baseUrl;
    },

    /**
     * 链接跳转
     */
    jump: function jump(url) {
        cache.setCache('isBackFromSNS', true);
        cache.setCache('bizoauthtype', UpSDK.config.oauthtype);
        location.replace(url);
    }
};

exports.default = sns;
exports.fb = _fb2.default;
exports.twitter = _twitter2.default;
exports.google = _google2.default;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(67);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 43 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * 将所有node_modules中组件迁移到项目内，统一为请求添加公用的UserAgent
 * @author zhenn
 * @createTime 2017-10-24
 */

var proxyUrl = {
    pro: '//proxy.upliveapps.com/index/index',
    dev: '//awsbj-proxy.xingyunzhi.cn/index/index',
    stage: '//sg-stage-proxy.upliveapp.com/index/index'
};

var noop = function noop() {};

var timeout = 5000;

var PbAajx = function () {
    function PbAajx() {
        _classCallCheck(this, PbAajx);

        this.canceled = 0;
    }

    // canceled: 0, // 是否被取消

    _createClass(PbAajx, [{
        key: 'do',
        value: function _do(cfg, data) {
            var success = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : noop;
            var timeoutFn = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;

            var _this = this;

            var fail = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : noop;
            var respType = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'arraybuffer';

            var prefix = proxyUrl[this.env()];

            if (!cfg.header) {
                cfg.header = {};
            }

            cfg.header.UserAgent = UG.getGlobalUA();

            var _url = prefix + '?' + $.param(cfg);
            var timer = void 0,
                xhr = void 0;
            timer = setTimeout(function () {
                timeoutFn();
            }, timeout);

            try {
                xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
                xhr.timeout = timeout;
                xhr.open('POST', _url, true);
                if (respType === 'arraybuffer') {
                    xhr.responseType = respType;
                }
                try {
                    xhr.send(respType === 'arraybuffer' ? data.toArrayBuffer() : data);
                } catch (e) {
                    xhr.send();
                }
            } catch (e) {
                console.log(e);
                UG.simple(UG.lang.template('Current browser doesn\'t support ajax，please upgrade your browser to a newer version'));
            }

            xhr.onreadystatechange = function (data) {

                if (xhr.readyState === 4) {
                    clearTimeout(timer);
                    if (xhr.status === 200) {
                        if (!_this.canceled) {
                            success(xhr.response);
                        }
                    } else {
                        if (typeof fail === 'function') {
                            fail();
                        }
                    }
                }
            };
        }
    }, {
        key: 'query',
        value: function query(name) {
            var scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'search';

            var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i'),
                r = location[scope].substr(1).match(reg);
            if (r != null) {
                return unescape(r[2]);
            }
            return null;
        }
    }, {
        key: 'env',
        value: function env() {
            return this.query('env') || 'pro';
        }
    }, {
        key: 'serializeURI',
        value: function serializeURI(obj) {
            var result = [];
            if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object') {
                obj = {};
            }
            for (var i in obj) {
                result.push(i + '=' + encodeURIComponent(obj[i]));
            }

            return result.join('&');
        }
    }, {
        key: 'cancel',
        value: function cancel() {
            this.canceled = 1;
        }
    }]);

    return PbAajx;
}();

exports.default = PbAajx;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {

    module.exports = function (win) {
        var doc = win.document,
            body = doc.body,
            E_float,
            E_floatMsg,
            E_floatContent,
            E_floatOk,
            E_floatCancel,
            initDom = false,
            flashTimeoutId,
            showTimeoutId,
            hideTimeoutId,
            E_mask;

        E_mask = doc.createElement('div');
        E_mask.className = 'c-float-mask hide';

        E_float = doc.createElement('div');
        E_float.className = 'c-float-popWrap msgMode hide';
        E_float.innerHTML = ['<style type="text/css">', '.c-float-modePop{text-align:center}.c-float-modePop .warnMsg{color:#fff}.c-float-modePop button{padding:0.1875rem 0.28125rem 0.1875rem 0.28125rem;color:#157afb;background:-webkit-gradient(linear,left top,left bottom,color-stop(0,#404040),color-stop(100%,#2e2e2e));border:none}.c-float-shade{width:100%;display:block;position:absolute;z-index:99;background-color:#000;opacity:.5;top:0;left:0}.c-float-mask{position:fixed;top:0;left:0;bottom:0;right:0;height:100%;width:100%;z-index:9998;background:rgba(0,0,0,.7);opacity:0;-webkit-transition:opacity .3s linear 0s}.c-float-shade.hide{display:none}.c-float-mask.hide{display:none}.c-float-popWrap{width:90%; border-radius:0.25rem;-webkit-border-radius:0.25rem;z-index:9999;position:fixed;overflow:hidden;left:50%;top:50%; margin-left: -45%; -webkit-transition:opacity .3s linear 0s}.c-float-popWrap .c-float-modePop{background-color:rgba(0,0,0,.7);-webkit-border-radius:0.25rem;border-radius:0.25rem;overflow:hidden;padding:0.3125rem;}.c-float-popWrap .c-float-modePop .warnMsg{padding:0;font-size:0.46875rem;line-height:0.5625rem;color:#fff;font-weight:400}.c-float-popWrap .c-float-modePop .content{line-height:1.5}.c-float-popWrap.hide{display:none;-webkit-box-shadow:none}.c-float-popWrap.show{display:block}.c-float-popWrap.msgMode .c-float-modePop .content,.c-float-popWrap.msgMode .c-float-modePop .doBtn{display:none}.c-float-popWrap.alertMode .c-float-modePop .content{display:none}.c-float-popWrap.alertMode .c-float-modePop .doBtn .cancel{display:none}.c-float-popWrap.alertMode,.c-float-popWrap.confirmMode{width:90%;}.c-float-popWrap.alertMode .c-float-modePop,.c-float-popWrap.confirmMode .c-float-modePop{background:#fff;padding:0;color:#202325}.c-float-popWrap.alertMode .c-float-modePop .content,.c-float-popWrap.confirmMode .c-float-modePop .content{padding:0.3125rem;border-bottom:0.03125rem solid #d6d9dc}.c-float-popWrap.alertMode .c-float-modePop .warnMsg,.c-float-popWrap.confirmMode .c-float-modePop .warnMsg{padding:0.3125rem;display:-webkit-box;-webkit-box-align:center;-webkit-box-pack:center;text-align:center;font-weight:700}.c-float-popWrap.alertMode .c-float-modePop .doBtn,.c-float-popWrap.alertMode .c-float-modePop .warnMsg,.c-float-popWrap.confirmMode .c-float-modePop .doBtn,.c-float-popWrap.confirmMode .c-float-modePop .warnMsg{border-bottom:0.03125rem solid #d6d9dc;color:#202325}.c-float-popWrap.alertMode .c-float-modePop .doBtn,.c-float-popWrap.confirmMode .c-float-modePop .doBtn{border-bottom:none;display:-webkit-box;-webkit-box-align:center}.c-float-popWrap.alertMode .c-float-modePop .content,.c-float-popWrap.confirmMode .c-float-modePop .content{display:block;color:#202325;padding:0.3125rem;line-height:0.75rem;font-size:0.46875rem;text-align:left;font-weight:700}.c-float-modePop button{-webkit-box-flex:1;color:#157afb;background:#fff;height:1.25rem;font-size:0.5625rem;display:block}.c-float-modePop button.cancel{border-right:0.03125rem solid #b2b2b2}.c-float-modePop button.ok{font-weight:700}', '</style>', '<div class="c-float-modePop">', '<div class="warnMsg"></div>', '<div class="content"></div>', '<div class="doBtn">', '<button class="cancel">取消</button>', '<button class="ok">确定</button>', '</div>', '</div>'].join('');

        E_floatMsg = E_float.querySelector('.warnMsg');
        E_floatContent = E_float.querySelector('.content');
        E_floatOk = E_float.querySelector('.doBtn .ok');
        E_floatCancel = E_float.querySelector('.doBtn .cancel');

        E_floatMsg.addEventListener('click', function () {
            // alert(E_float.className);
        }, false);

        function _extend(a, b) {
            for (var k in b) {
                a[k] = b[k];
            }
            return a;
        }

        function successHandler(e) {
            this.callback && this.callback(e, true);
        }

        function failureHandler(e) {
            this.callback && this.callback(e, false);
        }

        function ModePop(options) {
            this._options = _extend({
                mode: 'msg',
                text: '网页提示',
                useTap: false
            }, options || {});

            this._init();
        }

        _extend(ModePop.prototype, {
            _init: function _init() {
                var that = this,
                    opt = that._options,
                    mode = opt.mode,
                    text = opt.text,
                    okText = opt.okText,
                    cancelText = opt.cancelText,
                    content = opt.content,
                    callback = opt.callback,
                    background = opt.background,
                    clickEvent = opt.useTap ? 'touchend' : 'click';

                // set mode
                var classTxt = E_float.className;
                classTxt = classTxt.replace(/(msg|alert|confirm)Mode/i, mode + 'Mode');
                E_float.className = classTxt;

                // set background
                background && (E_float.style.background = background);

                // set text & content
                if (text) {
                    E_floatMsg.innerHTML = text;
                    E_floatMsg.style.display = 'block';
                } else {
                    E_floatMsg.style.display = 'none';
                }

                if (content) {
                    E_floatContent.innerHTML = content;
                    E_floatContent.style.display = 'block';
                } else {
                    E_floatContent.style.display = 'none';
                }

                E_floatOk.innerHTML = okText || '确定';
                E_floatCancel.innerHTML = cancelText || '取消';

                if (mode == 'alert' || mode == 'confirm') {
                    this.hasMask = true;
                } else {
                    this.hasMask = false;
                }

                // click event
                E_floatOk.removeEventListener('touchend', successHandler);
                E_floatOk.removeEventListener('click', successHandler);
                E_floatCancel.removeEventListener('touchend', successHandler);
                E_floatCancel.removeEventListener('click', successHandler);
                E_floatOk.addEventListener(clickEvent, successHandler, false);
                E_floatCancel.addEventListener(clickEvent, failureHandler, false);
                E_floatOk.callback = E_floatCancel.callback = function () {
                    callback.apply(that, arguments);
                };

                if (!initDom) {
                    initDom = true;
                    doc.body.appendChild(E_mask);
                    doc.body.appendChild(E_float);
                    win.addEventListener('resize', function () {
                        setTimeout(function () {
                            that._pos();
                        }, 500);
                    }, false);
                }
            },

            _pos: function _pos() {
                var rect = E_float.getBoundingClientRect(),
                    eW = rect.width,
                    eH = rect.height;

                E_float.style.marginLeft = -eW / 2 + 'px';
                E_float.style.marginTop = -eH / 2 + 'px';
            },

            isShow: function isShow() {
                return E_float.className.indexOf('show') > -1;
            },

            isHide: function isHide() {
                return E_float.className.indexOf('hide') > -1;
            },

            _cbShow: function _cbShow(pos) {
                var that = this,
                    opt = that._options,
                    onShow = opt.onShow;

                E_float.style.opacity = '1';
                that.hasMask && (E_mask.style.opacity = '1');
                that.hasMask && (E_mask.className = E_mask.className.replace(/hide/g, '').trim());

                if (!that.isShow()) {
                    E_float.className += ' show';
                    that.hasMask && (E_mask.className += ' show');
                }

                pos && that._pos();

                onShow && onShow.call(that);
            },

            show: function show() {
                var that = this;

                if (flashTimeoutId) {
                    clearTimeout(flashTimeoutId);
                    flashTimeoutId = null;
                    this._cbHide();
                }

                if (showTimeoutId) {
                    clearTimeout(showTimeoutId);
                    showTimeoutId = null;
                }

                if (hideTimeoutId) {
                    clearTimeout(hideTimeoutId);
                    hideTimeoutId = null;
                }

                if (!that.isShow()) {
                    E_float.className = E_float.className.replace(/hide/g, '').trim();
                    that.hasMask && (E_mask.className = E_mask.className.replace(/hide/g, '').trim());

                    that._pos();

                    setTimeout(function () {
                        E_float.style.opacity = '1';
                        that.hasMask && (E_mask.style.opacity = '1');
                    }, 1);

                    showTimeoutId = setTimeout(function () {
                        that._cbShow();
                    }, 300);
                } else {
                    that._cbShow(true);
                }
            },

            _cbHide: function _cbHide() {
                var that = this,
                    opt = that._options,
                    onHide = opt.onHide;

                E_float.style.opacity = '0';
                E_mask.style.opacity = '0';

                if (!that.isHide()) {
                    E_float.className = E_float.className.replace(/hide|show/g, '').trim();
                    E_float.className += ' hide';
                    E_mask.className = E_mask.className.replace(/hide|show/g, '').trim();
                    E_mask.className += ' hide';
                }
                onHide && onHide.call(that);
            },
            // ruoli 添加timeout参数，防止点击弹出框，立即再弹出一个框，出现闪动
            hide: function hide(timeout) {
                var that = this;

                if (showTimeoutId) {
                    clearTimeout(showTimeoutId);
                    showTimeoutId = null;
                }

                if (hideTimeoutId) {
                    clearTimeout(hideTimeoutId);
                    hideTimeoutId = null;
                }

                if (!that.isHide()) {
                    E_float.className = E_float.className.replace(/show/g, '').trim();
                    E_mask.className = E_mask.className.replace(/show/g, '').trim();

                    setTimeout(function () {
                        E_float.style.opacity = '0';
                        E_mask.style.opacity = '0';
                    }, 1);

                    hideTimeoutId = setTimeout(function () {
                        that._cbHide();
                    }, timeout || 300);
                } else {
                    that._cbHide();
                }
            },

            flash: function flash(timeout) {
                var that = this,
                    opt = that._options;

                that.show();

                //opt.onShow = function() {
                flashTimeoutId = setTimeout(function () {
                    if (flashTimeoutId) {
                        that.hide();
                    }
                }, timeout);
                //};
            }
        });

        var notification = new function () {

            this.simple = function (text, bg, timeout) {
                if (arguments.length == 2) {
                    if (typeof arguments[1] == 'number') {
                        timeout = arguments[1];
                        bg = undefined;
                    }
                }

                var pop = new ModePop({
                    mode: 'msg',
                    text: text,
                    background: bg
                });

                pop.flash(timeout || 2000);
                return pop;
            };

            this.msg = function (text, options) {
                return new ModePop(_extend({
                    mode: 'msg',
                    text: text
                }, options || {}));
            };

            this.alert = function (text, content, callback, options) {

                if (typeof content === 'function') {
                    options = callback;
                    callback = content;
                    content = null;
                }

                return new ModePop(_extend({
                    mode: 'alert',
                    text: text,
                    content: content,
                    callback: callback
                }, options || {}));
            };

            this.confirm = function (text, content, callback, options) {
                return new ModePop(_extend({
                    mode: 'confirm',
                    text: text,
                    content: content,
                    callback: callback
                }, options || {}));
            };

            this.pop = function (options) {
                return new ModePop(options);
            };
        }();

        return notification;
    }(window);
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 45 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(178);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(182);
var defined = __webpack_require__(62);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 49 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": null,
    "options": {
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [{
        "name": "Result",
        "fields": [{
            "rule": "optional",
            "type": "Code",
            "name": "code",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "msg",
            "id": 2
        }, {
            "rule": "optional",
            "type": "google.protobuf.Any",
            "name": "data",
            "id": 3
        }]
    }, {
        "name": "google",
        "fields": [],
        "messages": [{
            "name": "protobuf",
            "fields": [],
            "options": {
                "csharp_namespace": "Google.Protobuf.WellKnownTypes",
                "go_package": "github.com/golang/protobuf/ptypes/any",
                "java_package": "com.google.protobuf",
                "java_outer_classname": "AnyProto",
                "java_multiple_files": true,
                "java_generate_equals_and_hash": true,
                "objc_class_prefix": "GPB"
            },
            "messages": [{
                "name": "Any",
                "fields": [{
                    "rule": "optional",
                    "type": "string",
                    "name": "type_url",
                    "id": 1
                }, {
                    "rule": "optional",
                    "type": "bytes",
                    "name": "value",
                    "id": 2
                }]
            }]
        }]
    }],
    "enums": [{
        "name": "Code",
        "values": [{
            "name": "DEFAULT",
            "id": 0
        }, {
            "name": "SC_SUCCESS",
            "id": 1
        }, {
            "name": "SC_THIRD_PARTY_ALREADY_BIND",
            "id": 256
        }, {
            "name": "SC_THIRD_CHECK_USER_NOT_REGISTER",
            "id": 257
        }, {
            "name": "SC_NEED_BIND_PHONE",
            "id": 258
        }, {
            "name": "SC_PARAMETER_INVALID",
            "id": 4096
        }, {
            "name": "SC_ADMIN_NO_PERMISSION",
            "id": 4352
        }, {
            "name": "SC_ACCOUTN_USER_TOKEN_NOTMATCH",
            "id": 8192
        }, {
            "name": "SC_ACCOUNT_IS_VISTOR",
            "id": 8194
        }, {
            "name": "SC_LOGINED_IN_OTHER_DEVICE",
            "id": 8193
        }, {
            "name": "SC_SMS_VERIFY_CODE_NOMOBILE",
            "id": 4097
        }, {
            "name": "SC_SMS_VERIFY_CODE_FAIL",
            "id": 4098
        }, {
            "name": "SC_SMS_VERIFY_CODE_NOTMATCH",
            "id": 4099
        }, {
            "name": "SC_ACCOUNT_MOBILE_PHONE_REPETITION",
            "id": 4100
        }, {
            "name": "SC_ACCOUNT_MOBILE_PHONE_ALLREADY_BIND",
            "id": 4101
        }, {
            "name": "SC_ACCOUTN_USER_NAME_FORBIDDEN",
            "id": 4102
        }, {
            "name": "SC_ACCOUTN_THIRD_CHECK_FAIL",
            "id": 4103
        }, {
            "name": "SC_ACCOUNT_USER_NAME_OVER_LONG",
            "id": 4104
        }, {
            "name": "SC_ACCOUNT_LIVE_CODE_OVER_LONG",
            "id": 4105
        }, {
            "name": "SC_ACCOUNT_LIVE_CODE_EMAIL_WHITE",
            "id": 4106
        }, {
            "name": "SC_ACCOUNT_LIVE_CODE_NOT_STANDARD",
            "id": 4112
        }, {
            "name": "SC_ACCOUNT_LIVE_CODE_EXIST",
            "id": 4113
        }, {
            "name": "SC_ACCOUNT_LIVE_UPDATE_FAIL",
            "id": 4114
        }, {
            "name": "SC_ACCOUNT_PASSWORD_ERROR",
            "id": 4115
        }, {
            "name": "SC_ACCOUNT_USER_NOT_EXIST",
            "id": 4116
        }, {
            "name": "SC_ACCOUNT_LIVE_CODE_TOO_SHORT",
            "id": 4117
        }, {
            "name": "SC_ACCOUNT_SIGNATURE_OVER_LONG",
            "id": 4118
        }, {
            "name": "SC_ACCOUTN_USER_FORBIDDEN",
            "id": 4119
        }, {
            "name": "SC_ACCOUNT_RANDOM_NOTEXIST",
            "id": 4120
        }, {
            "name": "SC_ACCOUNT_RANDOM_NOTSCAN",
            "id": 4121
        }, {
            "name": "SC_ACCOUNT_RANDOM_SCANNED",
            "id": 4128
        }, {
            "name": "SC_ACCOUNT_LIVE_CODE_NOLY_MODIFY_ONCE",
            "id": 4129
        }, {
            "name": "SC_ACCOUNT_USER_OR_PASSWORD_ERROR",
            "id": 4130
        }, {
            "name": "SC_EMAIL_SEND_OVER_LIMIT",
            "id": 4131
        }, {
            "name": "SC_EMAIL_VERIFY_INVALID",
            "id": 4132
        }, {
            "name": "SC_EMAIL_NOT_VERIFY",
            "id": 4133
        }, {
            "name": "SC_NEED_REGISTER",
            "id": 4134
        }, {
            "name": "SC_ACCOUNT_HAVE_NO_BIND_MOBILE",
            "id": 4135
        }, {
            "name": "SC_ACCOUNT_DID_FORBIDDEN",
            "id": 4136
        }, {
            "name": "SC_SMS_SEND_CODE_BEYOND_LIMIT",
            "id": 4137
        }, {
            "name": "SC_SENSITIVE_CONTENT",
            "id": 4609
        }, {
            "name": "SC_ACCOUNT_USER_USERNAME_IS_HIDDEN",
            "id": 4610
        }, {
            "name": "SC_MALL_GIFT_NOT_EXIST",
            "id": 12289
        }, {
            "name": "SC_MALL_TRANSACTION_REPEATED",
            "id": 12290
        }, {
            "name": "SC_MALL_MONEY_NOT_ENOUGH",
            "id": 12291
        }, {
            "name": "SC_MALL_TRANSACTION_NOT_EXIST",
            "id": 12292
        }, {
            "name": "SC_MALL_PRODUCT_NOT_AVAILABLE",
            "id": 12293
        }, {
            "name": "SC_MALL_ORDER_NOT_EXIST",
            "id": 12294
        }, {
            "name": "SC_MALL_UNIFIED_ORDER_FAIL",
            "id": 12295
        }, {
            "name": "SC_MALL_PAY_FAIL",
            "id": 12296
        }, {
            "name": "SC_MALL_PAY_QUERY_FAIL",
            "id": 12297
        }, {
            "name": "SC_MALL_IAP_VALIDATE_FAIL",
            "id": 12298
        }, {
            "name": "SC_MALL_ORDER_EXIST_NOT_FINISHED",
            "id": 12299
        }, {
            "name": "SC_MALL_NOT_BIND_WECHAT",
            "id": 12300
        }, {
            "name": "SC_MALL_EXCEED_WITHDRAW_TIMES",
            "id": 12301
        }, {
            "name": "SC_MALL_EXCEED_WITHDRAW_QUOTA",
            "id": 12302
        }, {
            "name": "SC_MALL_WITHDRAW_FAIL",
            "id": 12303
        }, {
            "name": "SC_MALL_WITHDRAW_LESS_THAN_MIN",
            "id": 12304
        }, {
            "name": "SC_MALL_WITHDRAW_GREATER_THAN_MAX",
            "id": 12305
        }, {
            "name": "SC_MALL_WITHDRAW_FREQ_LIMIT",
            "id": 12306
        }, {
            "name": "SC_MALL_WITHDRAW_SENDNUM_LIMIT",
            "id": 12307
        }, {
            "name": "SC_MALL_NOT_BIND_PAYPAL",
            "id": 12308
        }, {
            "name": "SC_MALL_IAB_VALIDATE_FAIL",
            "id": 12309
        }, {
            "name": "SC_MALL_BUY_GUARD_DIAMOND_LOW",
            "id": 12310
        }, {
            "name": "SC_MALL_TRANSLATE_NOT_SUPPORT",
            "id": 12311
        }, {
            "name": "SC_MALL_TRANSLATE_CLOSED",
            "id": 12312
        }, {
            "name": "SC_MALL_GIFT_SEND_VIP_LIMIT",
            "id": 12313
        }, {
            "name": "SC_MALL_GIFT_NOT_ALLOW",
            "id": 12320
        }, {
            "name": "SC_MALL_GIFT_NEED_RECHARGE",
            "id": 12321
        }, {
            "name": "SC_MALL_ACC_BILL_NOT_ENOUGH",
            "id": 12322
        }, {
            "name": "SC_MALL_USER_FROZEN",
            "id": 12323
        }, {
            "name": "SC_MALL_RECHARGE_REPEAT",
            "id": 12324
        }, {
            "name": "SC_MALL_RECHARGE_REWARD_REPEAT",
            "id": 12325
        }, {
            "name": "SC_MALL_RECHARGE_REWARD_INVALID",
            "id": 12326
        }, {
            "name": "SC_MALL_SHAREREDPACKET_TOTALAMOUNT_INVALID",
            "id": 12327
        }, {
            "name": "SC_MALL_SHAREREDPACKET_SPLITNUM_INVALID",
            "id": 12328
        }, {
            "name": "SC_MALL_SHAREREDPACKET_SPLITAMOUNT_INVALID",
            "id": 12329
        }, {
            "name": "SC_MALL_GOODS_NOT_EXIST",
            "id": 12336
        }, {
            "name": "SC_MALL_BROADCAST_NOT_OPEN",
            "id": 12337
        }, {
            "name": "SC_MALL_FIXEDCONTENT_NOT_EXIST",
            "id": 12338
        }, {
            "name": "SC_MALL_GIFT_GUARD_TOO_LOW",
            "id": 12339
        }, {
            "name": "SC_MALL_FIGHT_OVER",
            "id": 12340
        }, {
            "name": "SC_MALL_BIGBALL_OVER",
            "id": 12341
        }, {
            "name": "SC_MALL_PROP_LEFT_AMOUNT_NOT_ENOUGH",
            "id": 12342
        }, {
            "name": "SC_MALL_PROP_SAME_EXIST",
            "id": 12343
        }, {
            "name": "SC_MALL_PLAY_NOT_OPEN",
            "id": 12344
        }, {
            "name": "SC_MALL_MOUNT_CANNOTREPURCHASE",
            "id": 12345
        }, {
            "name": "SC_RANKING_VIP_INVISIBLE_LIMIT",
            "id": 14593
        }, {
            "name": "SC_RANKING_VIP_INVISIBLE_OFF",
            "id": 14594
        }, {
            "name": "SC_CONTACT_ALREADY_FRIEND",
            "id": 16385
        }, {
            "name": "SC_LIVE_ROOM_NOT_EXIST",
            "id": 20481
        }, {
            "name": "SC_LIVE_ROOM_DISABLED",
            "id": 20482
        }, {
            "name": "SC_LIVE_ROOM_NO_PERMISSION",
            "id": 20483
        }, {
            "name": "SC_LIVE_ROOM_USER_GRADE_NOT_ENOUGH",
            "id": 20484
        }, {
            "name": "SC_LIVE_ROOM_SPECIAL_NOT_CREATE",
            "id": 20485
        }, {
            "name": "SC_LIVE_ROOM_ADMIN_SHUTUP_FAIL",
            "id": 20486
        }, {
            "name": "SC_LIVE_ROOM_ADMIN_LIFTED_FAIL",
            "id": 20487
        }, {
            "name": "SC_LIVE_ROOM_ADMIN_SHUTUP_UIDS_ERROR",
            "id": 20488
        }, {
            "name": "SC_LIVE_ROOM_NO_TEL_AUTH",
            "id": 20489
        }, {
            "name": "SC_LIVE_ROOM_FORCED_OUT",
            "id": 20490
        }, {
            "name": "SC_LIVE_ROOM_POLICY_DISABLED",
            "id": 20491
        }, {
            "name": "SC_LIVE_ROOM_RID_UID_NOTMATCH",
            "id": 20492
        }, {
            "name": "SC_LIVE_ROOM_NO_REALNAME_AUTH",
            "id": 20496
        }, {
            "name": "SC_LIVE_ROOM_NOT_IN_MULTILIVE",
            "id": 20497
        }, {
            "name": "SC_LIVE_ROOM_PAY_FAILED",
            "id": 20498
        }, {
            "name": "SC_LIVE_ROOM_CANNOT_MULTILIVE",
            "id": 20499
        }, {
            "name": "SC_LIVE_ROOM_MULTILIVE_MEMBERS_LIMIT",
            "id": 20500
        }, {
            "name": "SC_LIVE_ROOM_MULTILIVE_CREATE_MEETINGROOM_FAILED",
            "id": 20501
        }, {
            "name": "SC_LIVE_ROOM_MULTILIVE_FINISH",
            "id": 20502
        }, {
            "name": "SC_LIVE_ROOM_IS_LIVING",
            "id": 20503
        }, {
            "name": "SC_LIVE_ROOM_PRIVATELIVE_NOT_ALLOW",
            "id": 20504
        }, {
            "name": "SC_LIVE_ROOM_CHARGE_NOT_ALLOW",
            "id": 20505
        }, {
            "name": "SC_LIVE_ROOM_CHARGE_BELOW_MIN",
            "id": 20506
        }, {
            "name": "SC_LIVE_ROOM_AUDIENCE_LIMIT_ALLOW",
            "id": 20507
        }, {
            "name": "SC_LIVE_ROOM_LIVE_NEED_CHARGE",
            "id": 20508
        }, {
            "name": "SC_LIVE_ROOM_NUMBER_REACHED_TOPLIMIT",
            "id": 20512
        }, {
            "name": "SC_LIVE_ROOM_VOICE_NOT_ALLOW",
            "id": 20513
        }, {
            "name": "SC_LIVE_ROOM_USER_NOT_ONLINE",
            "id": 20514
        }, {
            "name": "SC_LIVE_ROOM_APPLY_MULTILIVE_NOT_ALLOW",
            "id": 20515
        }, {
            "name": "SC_LIVE_ROOM_NO_MEMBER",
            "id": 20516
        }, {
            "name": "SC_LIVE_ROOM_NO_INVITE",
            "id": 20517
        }, {
            "name": "SC_LIVE_ROOM_MULTILIVE_FREEJOINTIME_EMPTY",
            "id": 20518
        }, {
            "name": "SC_LIVE_ROOM_MF_VIP_LIMIT",
            "id": 20519
        }, {
            "name": "SC_LIVE_ROOM_MF_COUNTRY_LIMIT",
            "id": 20520
        }, {
            "name": "SC_LIVE_ROOM_INVITE_LIMIT_DAILY",
            "id": 20521
        }, {
            "name": "SC_ACTIVITY_SEND_DIAMOND_TIME_END",
            "id": 24577
        }, {
            "name": "SC_ACTIVITY_SEND_DIAMOND_OVER_LIMIT",
            "id": 24578
        }, {
            "name": "SC_ACTIVITY_SEND_DIAMOND_ALREADY",
            "id": 24579
        }, {
            "name": "SC_ACTIVITY_NO_RECHARGE",
            "id": 24580
        }, {
            "name": "SC_ACTIVITY_NOT_CONDITIONS",
            "id": 24581
        }, {
            "name": "SC_SYSTEM_ERROR",
            "id": 16777215
        }, {
            "name": "SC_ZMXY_AUTH_BIND_SUCCESS",
            "id": 28673
        }, {
            "name": "SC_ZMXY_AUTH_HAS_BEEN_USEED",
            "id": 28674
        }, {
            "name": "SC_ZMXY_AUTH_HAS_BIND",
            "id": 28675
        }, {
            "name": "SC_ZMXY_AUTH_ERROR",
            "id": 28676
        }, {
            "name": "SC_REDPACKET_OVERDUE_ERROR",
            "id": 32769
        }, {
            "name": "SC_REDPACKET_DISTRIBUTED_ERROR",
            "id": 32770
        }, {
            "name": "SC_REDPACKET_REPEAT_ERROR",
            "id": 32771
        }, {
            "name": "SC_REDPACKET_DELAYTIME_ERROR",
            "id": 32772
        }, {
            "name": "SC_PERMISSIONUSE_NOT_ALLOW",
            "id": 36865
        }, {
            "name": "SC_PERMISSIONUSE_LOW_PERMISSION",
            "id": 36866
        }, {
            "name": "SC_PERMISSIONUSE_OVER_ROOMMAX",
            "id": 36867
        }, {
            "name": "SC_PERMISSIONUSE_OVER_DAYMAX",
            "id": 36868
        }, {
            "name": "SC_PERMISSIONUSE_OVER_ADD_LIMIT",
            "id": 36869
        }, {
            "name": "SC_PERMISSIONUSE_ERROR",
            "id": 36870
        }, {
            "name": "SC_PERMISSIONUSE_REPEAT_ERROR",
            "id": 36871
        }, {
            "name": "SC_ACTIVITY_EXCHANGE_REPEATED",
            "id": 65537
        }, {
            "name": "SC_ACTIVITY_POINT_NOT_ENOUGH",
            "id": 65538
        }, {
            "name": "SC_PACK_TRANSACTION_REPEATED",
            "id": 69633
        }, {
            "name": "SC_PACK_GIFT_NOT_AVAILABLE",
            "id": 69634
        }, {
            "name": "SC_PACK_GIFT_EXPIRE",
            "id": 69635
        }, {
            "name": "SC_PACK_TRANSACTION_NOT_EXIST",
            "id": 69636
        }, {
            "name": "SC_PACK_FULL",
            "id": 69637
        }, {
            "name": "SC_DYNAMIC_COMMENT_FREQUENCY_LIMITED",
            "id": 73729
        }, {
            "name": "SC_DYNAMIC_COMMENT_WORDS_OVER_LONG",
            "id": 73730
        }, {
            "name": "SC_DYNAMIC_NOT_EXIST_OR_DELETED",
            "id": 73731
        }, {
            "name": "SC_DYNAMIC_HAS_NO_RIGHT",
            "id": 73732
        }, {
            "name": "SC_DYNAMIC_IN_CALCULATION",
            "id": 73733
        }, {
            "name": "SC_DYNAMIC_EMPTY_NEED_GET_RECOMMEND_ANCHOR",
            "id": 73734
        }, {
            "name": "SC_DYNAMIC_LIMIT_FREQUENTLY_REPEAT_COMMENT",
            "id": 73735
        }, {
            "name": "SC_DYNAMIC_NOT_VIDEO_COMMENT",
            "id": 73736
        }, {
            "name": "SC_CHECKIN_ALREADY",
            "id": 77825
        }, {
            "name": "SC_FAN_GROUP_TITLE_CHANGE_POINT_NOT_ENOUGH",
            "id": 94465
        }, {
            "name": "SC_FAN_GROUP_NOT_EXIST",
            "id": 94466
        }, {
            "name": "SC_FAN_GROUP_NOT_FAN",
            "id": 94467
        }, {
            "name": "SC_FAN_GROUP_SELF_JOIN_ERROR",
            "id": 94468
        }, {
            "name": "SC_FAN_TASK_NOT_EXIST",
            "id": 94469
        }, {
            "name": "SC_FAN_TASK_TYPE_NOT_EXIST",
            "id": 94470
        }, {
            "name": "SC_FAN_TASK_MAXIMUM_TIME_REACHED",
            "id": 94471
        }, {
            "name": "SC_FAN_PERMISSION_NO",
            "id": 94472
        }, {
            "name": "SC_ACTIVITY_REWARD_ALREADY",
            "id": 81921
        }, {
            "name": "SC_ACTIVITY_REWARD_CANNOT",
            "id": 81922
        }, {
            "name": "SC_RANKING_GAME_NOTAUTHORITY",
            "id": 86017
        }, {
            "name": "IM_SYSTEM_ERROR",
            "id": 90113
        }, {
            "name": "IM_CREATE_PERMISSION_DENIED",
            "id": 90114
        }, {
            "name": "IM_BEYOND_GROUP_NUM_LIMIT",
            "id": 90115
        }, {
            "name": "IM_BEYOND_GROUP_USER_NUM_LIMIT",
            "id": 90116
        }, {
            "name": "IM_PERMISSION_DENIED",
            "id": 90117
        }, {
            "name": "IM_GROUP_INVALID",
            "id": 90118
        }, {
            "name": "IM_INVITE_INVALID",
            "id": 90119
        }, {
            "name": "SC_FOLLOW_YOU_ARE_IN_OTHERS_BLACKLIST",
            "id": 98305
        }, {
            "name": "SC_FOLLOW_ALREADY_REACH_MAX_FOLLOW",
            "id": 98306
        }, {
            "name": "SC_GIFTITEM_SAMENAME",
            "id": 98307
        }, {
            "name": "GIFTO_ACCOUNT_LOGING",
            "id": 1052673
        }, {
            "name": "GIFTO_ACCOUNT_ALREADY_ACTIVATE",
            "id": 1052674
        }, {
            "name": "GIFTO_ACCOUNT_WAIT_ACTIVATE",
            "id": 1052675
        }, {
            "name": "GIFTO_ACCOUNT_EXPIRE_ACTIVATE",
            "id": 1052676
        }, {
            "name": "GIFTO_ACCOUNT_NOT_BIND",
            "id": 1052677
        }, {
            "name": "GIFTO_EMAIL_VERIFY_INVALID",
            "id": 1052678
        }, {
            "name": "GIFTO_ACCOUNT_USER_OR_PASSWORD_ERROR",
            "id": 1052679
        }, {
            "name": "GIFTO_EMAIL_SEND_OVER_LIMIT",
            "id": 1052680
        }, {
            "name": "GIFTO_EMAIL_NOT_VERIFY",
            "id": 1052681
        }, {
            "name": "GIFTO_NOT_CURRENT_USER_BIND",
            "id": 1052682
        }, {
            "name": "GIFTO_ACCOUNT_PASSWORD_ERROR",
            "id": 1052683
        }, {
            "name": "GIFTO_KYC_NOT_SCUCCESS",
            "id": 1052684
        }, {
            "name": "GIFTO_ACCOUNT_NO_AUTHORITY",
            "id": 1052685
        }, {
            "name": "GIFTO_EMAIL_ALREADY_REGISTER",
            "id": 1052686
        }, {
            "name": "WALLET_JSON_NOT_VALID",
            "id": 1056769
        }, {
            "name": "WALLET_REQUEST_MISSING",
            "id": 1056770
        }, {
            "name": "WALLET_CURRENCY_NOT_SUPPORTED",
            "id": 1056771
        }, {
            "name": "WALLET_EXCEED_MAX_LENGRH",
            "id": 1056772
        }, {
            "name": "WALLET_INVALID_TOKEN",
            "id": 1056773
        }, {
            "name": "WALLET_METHOD_NOT_ALLOWED",
            "id": 1056774
        }, {
            "name": "WALLET_HAD_REPEAT_VALID",
            "id": 1056775
        }, {
            "name": "WALLET_MINIMUM_COIN_REQUIRED",
            "id": 1056776
        }, {
            "name": "WALLET_BALANCE_NOT_ENOUGH",
            "id": 1056777
        }, {
            "name": "WALLET_TRANSFER_FEE_TYPE_NOT_SUPPORTED",
            "id": 1056778
        }, {
            "name": "WALLET_TRANSFER_TYPE_NOT_SUPPORTED",
            "id": 1056779
        }, {
            "name": "WALLET_PASSPHRASE_NOT_CORRECT",
            "id": 1056780
        }, {
            "name": "WALLET_SENDER_IDENTITY_NOT_FOUNT",
            "id": 1056781
        }, {
            "name": "WALLET_RECEIVER_IDENTITY_NOT_FOUNT",
            "id": 1056782
        }, {
            "name": "WALLET_FOR_DEPOSITING",
            "id": 1056783
        }, {
            "name": "WALLET_OPEN_UCOINS_NOT_ENOUGH",
            "id": 1060865
        }, {
            "name": "WALLET_OPEN_TRANSACTION_REPEATED",
            "id": 1060866
        }, {
            "name": "WALLET_OPEN_TRANSACTION_NOT_EXIST",
            "id": 1060867
        }, {
            "name": "WALLET_OPEN_FAIL",
            "id": 1060868
        }, {
            "name": "WALLET_OPEN_TRANSACTION_NOT_END",
            "id": 1060869
        }, {
            "name": "WALLET_OPEN_TRANSACTION_DAY_LIMIT",
            "id": 1060870
        }, {
            "name": "WALLET_OPEN_TRANSACTION_MONTH_LIMIT",
            "id": 1060871
        }, {
            "name": "WALLET_OPEN_TRANSACTION_YEAR_LIMIT",
            "id": 1060872
        }, {
            "name": "WALLET_OPEN_TRANSACTION_FREQUENTLY",
            "id": 1060873
        }, {
            "name": "WALLET_OPEN_TRANSACTION_ONCHAIN_SHUT",
            "id": 1060874
        }, {
            "name": "WALLET_OPEN_PAYPASS_NOT_SETTING",
            "id": 1060875
        }, {
            "name": "WALLET_OPEN_USER_TRANSACTION_SHUT",
            "id": 1060876
        }, {
            "name": "WALLET_OPEN_USER_DEPOT_LOCKED",
            "id": 1060877
        }, {
            "name": "WALLET_OPEN_FIAT_PRODUCT_NOT_AVAILABLE",
            "id": 1060878
        }, {
            "name": "WALLET_OPEN_FIAT_PRODUCT_REFRESHED",
            "id": 1060879
        }, {
            "name": "WALLET_OPEN_UNIFIED_ORDER_FAIL",
            "id": 1060880
        }, {
            "name": "WALLET_OPEN_ORDER_NOT_EXIST",
            "id": 1060881
        }, {
            "name": "WALLET_OPEN_PAY_QUERY_FAIL",
            "id": 1060882
        }, {
            "name": "WALLET_OPEN_PAY_FAIL",
            "id": 1060883
        }, {
            "name": "WALLET_OPEN_FIAT_RECHARGE_DAY_LIMIT",
            "id": 1060884
        }, {
            "name": "WALLET_OPEN_UCOINS_EXCHANGE_REGION_CLOSE",
            "id": 1060885
        }, {
            "name": "WALLET_OPEN_UCOINS_HAS_EXCHANGE",
            "id": 1060886
        }, {
            "name": "WALLET_OPEN_UCOINS_MORE_MAX",
            "id": 1060887
        }, {
            "name": "WALLET_OPEN_UCOINS_LESS_MIN",
            "id": 1060888
        }, {
            "name": "WALLET_OPEN_USABLE_BALANCE_NOT_ENOUGH",
            "id": 1060889
        }, {
            "name": "GIFTO_MALL_REQUEST_SUCCESS",
            "id": 1064960
        }, {
            "name": "GIFTO_MALL_DUPLICATED_TRANSACTION",
            "id": 1064961
        }, {
            "name": "GIFTO_MALL_GTO_BALANCE_NOT_ENOUGH",
            "id": 1064962
        }, {
            "name": "GIFTO_MALL_PRARAMETER_INVALID",
            "id": 1064963
        }, {
            "name": "GIFTO_MALL_GIFT_NOT_EXIST",
            "id": 1064964
        }, {
            "name": "GIFTO_MALL_UNKNOWN_EXCEPTION",
            "id": 1064965
        }, {
            "name": "GIFTO_MALL_GIFT_SEND_VIP_LIMIT",
            "id": 1064966
        }, {
            "name": "GIFTO_MALL_GIFTO_RECEIVE_NOT_AUTHORITY",
            "id": 1064967
        }, {
            "name": "GREETING_CARDS_REQUEST_SUCCESS",
            "id": 1069056
        }, {
            "name": "GREETING_CARDS_NOT_GIFT",
            "id": 1069057
        }, {
            "name": "GREETING_CARDS_REQUEST_ERROR",
            "id": 1069058
        }, {
            "name": "GREETING_CARDS_GIFT_ID_ERROR",
            "id": 1069059
        }, {
            "name": "GREETING_CARDS_GIFT_ID_NULL",
            "id": 1069060
        }, {
            "name": "GREETING_CARDS_STATUS_NO_PASS",
            "id": 1069061
        }, {
            "name": "GREETING_CARDS_IP_COUNT_FULL",
            "id": 1069062
        }, {
            "name": "PK_USER_NOT_IN_PK",
            "id": 1073152
        }, {
            "name": "PK_USER_INCONVENIENT",
            "id": 1073153
        }, {
            "name": "PK_USER_OFFLINE",
            "id": 1073154
        }, {
            "name": "PK_SEND_MSG_FAIL",
            "id": 1073155
        }, {
            "name": "PK_USER_ALREADY_IN_INVITE",
            "id": 1073156
        }, {
            "name": "PK_USER_ALREADY_IN_MATCH_WAITING",
            "id": 1073157
        }, {
            "name": "PK_INVALID_USER",
            "id": 1073158
        }, {
            "name": "PK_INVITE_UUID_EXPIRED",
            "id": 1073159
        }]
    }]
}).build();
exports.default = _root;

/***/ }),
/* 50 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
// 落地页
var enterLandingPage = exports.enterLandingPage = '进入“落地页”';
var landingPageReviveGift = exports.landingPageReviveGift = '“开始收礼物吧”按钮';
var loginByFB = exports.loginByFB = '登录弹窗-“FB”';
var loginByTwitter = exports.loginByTwitter = '登录弹窗-“Twitter”';
var loginByGoogle = exports.loginByGoogle = '登录弹窗-“Google”';
var loginByQQ = exports.loginByQQ = '登录弹窗-“QQ”';
var loginByWeibo = exports.loginByWeibo = '登录弹窗-“Weibo”';
var loginByWeixin = exports.loginByWeixin = '登录弹窗-“WeChat”';
var loginByLine = exports.loginByLine = '登录弹窗-“Line”';

// 创建礼物
var enterCreateStepOne = exports.enterCreateStepOne = '到达创建第一步';
var createStepOneSave = exports.createStepOneSave = '创建第一步~保存礼物面板';
var enterCreateStepTwo = exports.enterCreateStepTwo = '到达创建第二步';
var createStepTwoCopy = exports.createStepTwoCopy = '创建第二步~复制链接';
var createStepTwoSeeAll = exports.createStepTwoSeeAll = '创建第二步~查看所有面板';
var enterCreateStepThree = exports.enterCreateStepThree = '到达创建第三步';
var createStepThreeYoutube = exports.createStepThreeYoutube = 'Youtube 按钮';
var createStepThreeInstagram = exports.createStepThreeInstagram = 'Instagram 按钮';
var createStepThreeFacebook = exports.createStepThreeFacebook = 'Facebook 按钮';
var createStepThreeCreateNew = exports.createStepThreeCreateNew = '创建第三步~“创建新的礼物面板”按钮';
var createStepThreeRevenue = exports.createStepThreeRevenue = '创建第三步~“查看收益”按钮';

// 送礼页面
var enterGiftoSendPage = exports.enterGiftoSendPage = '到达送礼页面';
var giftoBoardSendButton = exports.giftoBoardSendButton = '送礼页面~“发送”／“Send”按钮';
var giftoBoardRank = exports.giftoBoardRank = '送礼页面~左上角榜单';
var giftoBoardSendMore = exports.giftoBoardSendMore = '送礼页面~礼物批量赠送';
var giftoBoardRecharge = exports.giftoBoardRecharge = '送礼页面~“充值”／“Charge”按钮';
var giftoSendList = exports.giftoSendList = '查看面板的送礼流水';

// 个人主页
var enterProfilePage = exports.enterProfilePage = '到达个人主页';
var profilePageRevenue = exports.profilePageRevenue = '个人主页~查看收益';
var profilePageGIFTO = exports.profilePageGIFTO = '个人主页~查看GIFTO';

// 收益页面
var enterRevenuePage = exports.enterRevenuePage = '到达收益页面';
var revenuePageGiftoRank = exports.revenuePageGiftoRank = '收益页面~礼物榜单';
var revenuePageUserRank = exports.revenuePageUserRank = '收益页面~用户榜单';

// 项目列表
var enterDashboardPage = exports.enterDashboardPage = '到达项目列表页面';
var dashboardPageCreate = exports.dashboardPageCreate = '项目列表页面~创建礼物面板按钮';
var dashboardPageCopy = exports.dashboardPageCopy = '项目列表页面~复制链接按钮';
var dashboardPageMessage = exports.dashboardPageMessage = '项目列表页面~私信按钮';

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(27);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function statusChangeCallback(response) {

    if (response.status === 'connected') {
        window.FBOauthResponse = response.authResponse;
        // Logged into your app and Facebook.
        $.channel.emit('fbOauthSuccess', response.authResponse);
    } else if (response.status === 'not_authorized') {
        // The person is logged into Facebook, but not your app.
        // document.getElementById('status').innerHTML = 'Please log ' +
        //   'into this app.';
        // FB.login(checkLoginState);
    } else {
            // The person is not logged into Facebook, so we're not sure if
            // they are logged into this app or not.
            // FB.login(checkLoginState);
        }
}

// This function is called when someone finishes with the Login
// Button.  See the onlogin handler attached to it in the sample
// code below.
window.checkLoginState = function () {
    FB.getLoginStatus(function (response) {
        statusChangeCallback(response);
    });
};

window.fbAsyncInit = function () {
    // alert('sdk')
    $.channel.emit('fbsdkLoaded');

    FB.init({
        appId: _config2.default.upInfoInPlatform.fb.appid,
        cookie: true, // enable cookies to allow the server to access
        // the session
        xfbml: true, // parse social plugins on this page
        version: 'v2.5' // use graph api version 2.5
    });

    // Now that we've initialized the JavaScript SDK, we call
    // FB.getLoginStatus().  This function gets the state of the
    // person visiting this page and can return one of three states to
    // the callback you provide.  They can be:
    //
    // 1. Logged into your app ('connected')
    // 2. Logged into Facebook, but not your app ('not_authorized')
    // 3. Not logged into Facebook and can't tell if they are logged into
    //    your app or not.
    //
    // These three cases are handled in the callback function.

    FB.getLoginStatus(function (response) {
        statusChangeCallback(response);
    });
};

function testAPI() {
    FB.api('/me', function (response) {
        console.log(response);
    });
}

module.exports = {
    init: function init() {
        // Load the SDK asynchronously
        (function (d, s, id) {
            var js,
                fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s);js.id = id;
            js.src = "//connect.facebook.net/en_US/sdk.js";
            // TODO 加载失败了，需要处理一下
            js.onerror = function () {
                Uplib.loading.hide();
                UpSDK.emit('sdkLoadError', 'fb');
            };
            fjs.parentNode.insertBefore(js, fjs);
        })(document, 'script', 'facebook-jssdk');
    },
    checkLoginState: checkLoginState
};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.messages = exports.REQ_ERROR = exports.TIMEOUT = undefined;

var _messages;

var _lang = __webpack_require__(19);

var _lang2 = _interopRequireDefault(_lang);

var _cNotification = __webpack_require__(44);

var _cNotification2 = _interopRequireDefault(_cNotification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /**
                                                                                                                                                                                                                   * 基础错误在这里统一就处理了
                                                                                                                                                                                                                   * @type {{}}
                                                                                                                                                                                                                   */

//  外部引用的时候最好是使用常量名称对比，不要直接和值进行对比
var TIMEOUT = -1;
var REQ_ERROR = -2;

var messages = (_messages = {}, _defineProperty(_messages, TIMEOUT, _lang2.default.template('Session timeout.')), _defineProperty(_messages, REQ_ERROR, _lang2.default.template('Error.')), _defineProperty(_messages, 4096, _lang2.default.template('Invalid data.')), _defineProperty(_messages, 8192, _lang2.default.template('Expired userToken.')), _defineProperty(_messages, 16777215, _lang2.default.template('System error.')), _messages);

function errHandler(code) {
    messages[code] && _cNotification2.default.simple(messages[code] || code);
}

exports.TIMEOUT = TIMEOUT;
exports.REQ_ERROR = REQ_ERROR;
exports.messages = messages;
exports.default = errHandler;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(98);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NoPermission = function (_React$Component) {
    _inherits(NoPermission, _React$Component);

    function NoPermission() {
        _classCallCheck(this, NoPermission);

        return _possibleConstructorReturn(this, (NoPermission.__proto__ || Object.getPrototypeOf(NoPermission)).apply(this, arguments));
    }

    _createClass(NoPermission, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'no-permission' },
                this.props.text,
                this.props.children
            );
        }
    }]);

    return NoPermission;
}(_react2.default.Component);

NoPermission.defaultProps = {
    text: (window._lang || UG.lang).template('该地区暂未开放')
};
exports.default = NoPermission;

/***/ }),
/* 54 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__(28),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.13.1";


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(57);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(29);
var global = __webpack_require__(9);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(109) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 61 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 62 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(109);
var $export = __webpack_require__(114);
var redefine = __webpack_require__(30);
var hide = __webpack_require__(31);
var Iterators = __webpack_require__(36);
var $iterCreate = __webpack_require__(179);
var setToStringTag = __webpack_require__(65);
var getPrototypeOf = __webpack_require__(186);
var ITERATOR = __webpack_require__(3)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(59)('keys');
var uid = __webpack_require__(45);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(32).f;
var has = __webpack_require__(34);
var TAG = __webpack_require__(3)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(12);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(28),r=__webpack_require__(68);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
function vh(a,b){return"function"===typeof b?b(a):b}
function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
d)}}
var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
var ii={dehydrated:null,retryTime:0};
function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.13.1",
rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.13.1";


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(69);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(71);

__webpack_require__(80);

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(72);

__webpack_require__(73);

__webpack_require__(74);

__webpack_require__(75);

__webpack_require__(76);

__webpack_require__(78);

__webpack_require__(79);

__webpack_require__(40);

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Event center
 */
(function (global, factory) {

    // amd mode
    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof require === 'function' && (typeof module === 'undefined' ? 'undefined' : _typeof(module)) === "object" && module && module["exports"]) {
        // commonjs mode
        module.exports = factory();
    } else {
        // global mode
        global.events = factory();
    }
})(window, function () {

    ;(function (win, lib) {

        var Callbacks = function Callbacks(options) {
            options = Object.assign({}, options);

            var memory,
                // Last fire value (for non-forgettable lists)
            _fired,
                // Flag to know if list was already fired
            firing,
                // Flag to know if list is currently firing
            firingStart,
                // First callback to fire (used internally by add and fireWith)
            firingLength,
                // End of the loop when firing
            firingIndex,
                // Index of currently firing callback (modified by remove if needed)
            list = [],
                // Actual callback list
            stack = !options.once && [],
                // Stack of fire calls for repeatable lists
            fire = function fire(data) {
                memory = options.memory && data;
                _fired = true;
                firingIndex = firingStart || 0;
                firingStart = 0;
                firingLength = list.length;
                firing = true;
                for (; list && firingIndex < firingLength; ++firingIndex) {
                    if (list[firingIndex].apply(data[0], data[1]) === false && options.stopOnFalse) {
                        memory = false;
                        break;
                    }
                }
                firing = false;
                if (list) {
                    if (stack) stack.length && fire(stack.shift());else if (memory) list.length = 0;else Callbacks.disable();
                }
            },
                Callbacks = {
                list: list,
                add: function add() {
                    if (list) {
                        var start = list.length,
                            add = function add(args) {
                            args = Array.prototype.slice.call(args);
                            args.forEach(function (arg, _) {
                                if (typeof arg === "function") {
                                    if (!options.unique || !Callbacks.has(arg)) list.push(arg);
                                } else if (arg && arg.length && typeof arg !== 'string') add(arg);
                            });
                        };
                        add(arguments);
                        if (firing) firingLength = list.length;else if (memory) {
                            firingStart = start;
                            fire(memory);
                        }
                    }
                    return this;
                },
                remove: function remove() {
                    var args = Array.prototype.slice.call(arguments);
                    if (list) {
                        args.forEach(function (arg, _) {
                            var index;
                            while ((index = list.indexOf(arg, index)) > -1) {
                                list.splice(index, 1);
                                // Handle firing indexes
                                if (firing) {
                                    if (index <= firingLength) --firingLength;
                                    if (index <= firingIndex) --firingIndex;
                                }
                            }
                        });
                    }
                    return this;
                },
                has: function has(fn) {
                    return !!(list && (fn ? list.indexOf(fn) > -1 : list.length));
                },
                empty: function empty() {
                    firingLength = list.length = 0;
                    return this;
                },
                disable: function disable() {
                    list = stack = memory = undefined;
                    return this;
                },
                disabled: function disabled() {
                    return !list;
                },
                lock: function lock() {
                    stack = undefined;
                    if (!memory) Callbacks.disable();
                    return this;
                },
                locked: function locked() {
                    return !stack;
                },
                fireWith: function fireWith(context, args) {
                    if (list && (!_fired || stack)) {
                        args = args || [];
                        args = [context, args.slice ? args.slice() : args];
                        if (firing) stack.push(args);else fire(args);
                    }
                    return this;
                },
                fire: function fire() {
                    return Callbacks.fireWith(this, arguments);
                },
                fired: function fired() {
                    return !!_fired;
                }
            };

            return Callbacks;
        };
        var channelObj = {};

        // 统一事件机制
        var Events = {
            Event: Callbacks,
            /**
             * 添加事件监听
             * @param  {string}   name - 事件名称
             * @param  {function} callback - 事件回调
             */
            on: function on(name, callback) {
                var obj,
                    that = this;

                this.events = this.events || {};

                // 逗号隔开，支持多事件
                if (name && name.indexOf(',') != -1) {
                    return (name.split(',') || []).forEach(function (item) {
                        if (item) {
                            that.on(item, callback);
                        }
                    });
                }

                if (!this.global && name.indexOf('/') != -1) {
                    // 频道监听
                    if (name.split('/')[0] == 'channel') {
                        return that.channel.on(name.replace(/^channel\//gi, ''), callback);
                    }

                    obj = getObjectByNames(name, this);
                    this.events[name] = this.events[name] || [];
                    this.events[name].push(callback);
                    return obj ? obj.on(getEventName(name), callback) : this;
                } else {
                    obj = this.events[name] || (this.events[name] = this.Event());
                }

                // 如果设置为一起派发，则再次监听时，直接执行
                if (this._alwayEmitSource && this._alwayEmitSource[name]) {
                    return callback.apply(name, this._alwayEmitSource[name]);
                }
                obj.add(callback);

                return this;
            },
            /**
             * 移除事件监听
             * @param  {string}   name     事件名称
             * @param  {function} [callback] - 事件回调，为空时，移除所有回调
             */
            off: function off(name, callback) {
                var obj,
                    funs,
                    that = this;

                this.events = this.events || {};

                // 逗号隔开，支持多事件
                if (name && name.indexOf(',') != -1) {
                    return (name.split(',') || []).forEach(function (item) {
                        if (item) {
                            that.off(item, callback);
                        }
                    });
                }

                if (!this.global && name && name.indexOf('/') != -1) {
                    if (name.split('/')[0] == 'channel') {
                        return that.channel.off(name.replace(/^channel\//gi, ''), callback);
                    }

                    if (this.events[name]) {
                        obj = getObjectByNames(name, this);
                        if (callback) {
                            return obj ? obj.off(getEventName(name), callback) : this;
                        } else {
                            funs = this.events[name];
                            for (var i = 0; obj && funs && i < funs.length; i++) {
                                obj.off(getEventName(name), funs[i]);
                            }
                            this.events[name] = null;
                        }
                    }

                    return this;
                }

                if (name && callback && (obj = this.events[name])) {
                    obj.remove(callback);
                } else if (name && (obj = this.events[name])) {
                    obj.empty();
                } else {
                    // name不匹配的时候，会移除所有的事件
                    // for (name in this.events) {
                    //     if (this.events.hasOwnProperty(name) && this.events[name]) {
                    //         if (!this.global && name.indexOf('/') != -1) {
                    //             if (name.split('/')[0] == 'channel') {
                    //                 return this.channel.off(name.replace(/^channel\//gi, ''));
                    //             }
                    //             this.off(name);
                    //         } else {
                    //             this.events[name].empty();
                    //         }
                    //     }
                    // }
                }

                return this;
            },
            ///**
            // * 只监听一次事件
            // * @param name
            // * @param callback
            // */
            //once: function (name, callback) {
            //    var _callback;
            //
            //    this.on(name, _callback = function () {
            //        callback.apply(this, arguments);
            //        this.off(name, _callback);
            //    });
            //},
            /**
             * 默认派发事件
             * @return {object}
             */
            trigger: function trigger() {
                var name = arguments[0],
                    obj,
                    param,
                    that = this;

                this.events = this.events || {};
                param = Array.prototype.slice.call(arguments, 1);

                // 逗号隔开，支持多事件
                if (name && name.indexOf(',') != -1) {
                    return (name.split(',') || []).forEach(function (item) {
                        if (item) {
                            that.trigger.apply(this, [item].concat(param));
                        }
                    });
                }

                if (!this.global && name && name.indexOf('/') != -1) {
                    if (name.split('/')[0] == 'channel') {
                        return that.channel.trigger.apply(that.channel, [name.replace(/^channel\//gi, '')].concat(param));
                    }
                    obj = getObjectByNames(name, this);
                    name = getEventName(name);
                    return obj ? obj.trigger.apply(obj, [name].concat(param)) : this;
                }

                if (name && (obj = this.events[name])) {
                    obj.fire.apply(this, [].concat(param));
                }

                return {
                    event: obj,
                    always: function always() {
                        that._alwayEmitSource = that._alwayEmitSource || {};
                        that._alwayEmitSource[name] = [].concat(param);
                    }
                };
            },
            /**
             * 派发事件
             * @example
             *        this.emit('ready',args0,args1...);
             */
            emit: function emit() {
                return this.trigger.apply(this, arguments);
            }
        };

        /**
         * 获取context下的name属性
         * @private
         */
        function getObjectByNames(name, context) {
            var that, names, len;

            context = context || {};
            that = context;
            names = name.split('/');
            len = names.length;

            for (var i = 0; len > 1 && i < len - 1; i++) {
                if (that && that[names[i]]) {
                    that = that[names[i]];
                } else {
                    that = null;
                }
            }

            return that;
        }

        /**
         * 获取事件名称
         * @param  {String} name [description]
         * @return {String}
         */
        function getEventName(name) {
            var names = name.split('/');
            return names[names.length - 1];
        }

        // global single Event
        Events.channel = $.channel || ($.channel = Object.assign(channelObj, Events));
        Events.channel.global = Events.channel;

        lib.Events = Events;

        return Events;
    })(window, window.Uplib || (window.Uplib = {}));
});

/***/ }),
/* 73 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (win, lib) {
    var URLUtil = {
        scope: 'search',
        paramReg: /^(?:([A-Za-z]+):(\/{0,3}))?([0-9.\-A-Za-z]+\.[0-9A-Za-z]+)?(?::(\d+))?(?:\/([^?#]*))?(?:\?([^#]*))?(?:#(.*))?$/,

        names: ['url', 'scheme', 'slash', 'host', 'port', 'path', 'query', 'hash'],

        query: function query(name, scope) {
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"),
                scope = scope || this.scope,
                r = location[scope].substr(1).match(reg);
            if (r != null) {
                return decodeURIComponent(r[2]);
            }
            return null;
        },

        addParam: function addParam(url, data) {
            if (typeof data === 'undefined') {
                return;
            }

            var hashReg = /#.*$/gi,
                hashMatch = url.match(hashReg),
                hash = '';

            if (hashMatch) {
                hash = hashMatch[0];
            }

            // 去除hash值的url
            var preUrl = url.replace(hash, '');

            var searchReg = /\?(.*?)$/gi;
            var result = searchReg.exec(preUrl);
            var query, newUrl;
            if (result) {
                query = result[1].split('#')[0];
            }

            var id = !query ? '' : '&';

            return preUrl + (query && query.length > 0 ? '' : '?') + (id + $.param(data)) + hash;
        },

        delQuery: function delQuery(url, key) {
            var path = '',
                param = '',
                hash = '';
            if (url.indexOf('?') == -1) {
                path = url;
            } else {
                path = url.substr(0, url.indexOf('?'));
                param = url.substr(url.indexOf('?') + 1);
                if (param.indexOf('#') != -1) {
                    hash = param.substr(param.indexOf('#') + 1);
                    param = param.substr(0, param.indexOf('#'));
                }
            }
            var params = param.split('&');
            for (var i = params.length - 1; i >= 0; i--) {
                if (params[i].indexOf(key + '=') > -1) {
                    params.splice(i, 1);
                    break;
                }
            }

            return path + (params.join('&') ? '?' + params.join('&') : '') + (hash ? '#' + hash : '');
        },
        /**
         * 将URL query的字符串解析成对象
         */
        parseQuery: function parseQuery(query) {
            var ret = {},
                qs,
                q,
                _qs;
            if ((typeof query === 'undefined' ? 'undefined' : _typeof(query)) == 'object') {
                for (var p in query) {
                    if (query.hasOwnProperty(p) && query[p] !== null) {
                        ret[p] = query[p];
                    }
                }
            } else {
                qs = query.split('&');
                for (var i = 0; i < qs.length; i++) {
                    if ((q = qs[i]) && (_qs = q.split('=')) && _qs[0]) {
                        ret[_qs[0]] = _qs[1] ? decodeURIComponent(_qs[1]) : '';
                    }
                }
            }

            return ret;
        },
        /**
         * 将URL解析为对象
         * @name parse
         * @return {
         *      url: '',
         *      hash: '',
         *      query: '',
         *      host: ''
         *      ...
         * }
         */
        parse: function parse(url) {
            var results = this.paramReg.exec(url),
                names = this.names,
                ret = {},
                key;

            for (var i = 0, len = names.length; i < len; i += 1) {
                key = names[i];
                ret[key] = (key == 'path' ? '/' : '') + (results[i] || '');
            }

            return ret;
        },
        /**
         * 将对象解析为URL字符串
         */
        stringify: function stringify(data) {
            var ret = '';
            var names = this.names;
            for (var i = 1; i < names.length; i++) {
                var key = names[i],
                    value = data[key];
                if (typeof value != 'undefined') {
                    ret += function (key, value) {
                        if (key == 'scheme') {
                            return value + ':';
                        }
                        if (key == 'port') {
                            return value ? ':' + value : '';
                        }
                        if (key == 'host') {
                            return value;
                        }

                        if (key == 'query') {
                            return value ? '?' + value : '';
                        }
                        if (key == 'hash') {
                            return value ? '#' + value : '';
                        }

                        return value;
                    }(key, value);
                }
            }
            return ret;
        }
    };

    lib.url = URLUtil;
})(window, window.Uplib || (window.Uplib = {}));

/***/ }),
/* 74 */
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * 本地缓存组件
 * 本地存储的技术方案：
   1、localStorage
        只考虑localStorage的存储方式，不考虑cookie方式。原因：
        （1）cookie 存储上限只有 4KB，且会加重网络负担，cookie 会被发送到作用域之内的所有http请求，包括js请求，css请求，图片请求，很多异步的请求
        （2）localStorage 存储上线是5MB   
   2、组件规范
        （1）数据存储格式
            旧的游戏：prefix/env/ppuid/gameType/key
            新的游戏：prefix/env/openId/gameType/key
        （2）prefix
            key前缀。默认是ppcache
            如果同一款游戏，后期做推广，gameType或者用户openId(即appid)与自家版相同，推荐prefix改为package name
        （3）key
            存储数据的字段名
            推荐使用驼峰格式（首字母小写其他词首大写），如myFieldName
        （4）expires：-1
            有效期配置
            单位：毫秒
            -1  ：永久保存
            > 0 ：有设置有效期

 * 使用说明
    @method
        检测localstorage是否可用
            isEnable() // ==> true/false
        如果使用规范存储的字段格式，使用方法
            setCache(key, value, expires)
            getCache(key)
            removeCache(key)
        原生的自定义，存储的字段名，不遵循（prefix/env/XXX/gameType/key）格式；try()catch(e){}
            setItem(key, value, expires) // 设置；当存储到达上限之后，该方法不可用
            getItem(key)       // 获取
            removeItem(key)    // 清除
            getAll()           // 获取所有
            clear()            // 清除所有

 * @author 陈立英
 * @example 
 *      var cache = new Cache({
            prefix: 'knowme',
            gameType: 'knowme',
            uid: '123456'
        });

 */
;(function (win, lib) {
    var defaultConfig = {
        prefix: 'ppcache', // 数据存储 key 的前缀，默认是ppcache。
        gameType: '', // 游戏类型，例如knowme
        uid: '', // 用户信息，新游戏是openId, 旧游戏是ppuid
        data: {}, // 存储缓存数据 data: {data: value, expires: 0}
        expires: -1 // 有效期，默认则为永久，单位毫秒
    };

    var Cache = function () {
        function Cache(cfg) {
            _classCallCheck(this, Cache);

            this.option = Object.assign({}, defaultConfig, cfg);

            // 浏览器是否支持localStorage
            this.enable = false;

            this.isEnable();
        }

        _createClass(Cache, [{
            key: 'isEnable',
            value: function isEnable() {
                var name = '__localStorageTest__';
                try {
                    if ('localStorage' in win && win['localStorage'] && localStorage.setItem && localStorage.getItem) {

                        localStorage.setItem(name, name);

                        if (localStorage.getItem(name) == name) {
                            this.enable = true;
                        }
                        localStorage.removeItem(name);
                    }
                } catch (e) {}

                return this.enable;
            }

            /**
             * 设置本地缓存
             * @name set
             * @param key {String} 存储key
             * @param value {string| JSON Object} 存储内容。value会序列化
             * @param expires {Number} 单位毫秒 内容有效期设置，不设置则为永久缓存
             * @example     
             *      cache.set(key, value, expires);
             */

        }, {
            key: 'setCache',
            value: function setCache(key, value, expires) {
                var name = this.getLocalKey(key);
                this.setItem(name, value, expires);
            }
            /**
             * 获取本地缓存
             * @name get
             * @param {string| JSON Object} 数据字段名。
             * @example
             *      cache.get(key);
             */

        }, {
            key: 'getCache',
            value: function getCache(key) {
                var name = this.getLocalKey(key);
                return this.getItem(name);
            }
            /**
             * 移除本地缓存的数据'key'
             * @name remove
             */

        }, {
            key: 'removeCache',
            value: function removeCache(key) {
                var name = this.getLocalKey(key);
                this.removeItem(name);
            }
            /**
             * 获取本地缓存的key
             */

        }, {
            key: 'getLocalKey',
            value: function getLocalKey(key) {
                var prefix = this.option.prefix,
                    ret = [];
                var gameType = this.option.gameType || '';
                var uid = this.option.uid || '';
                var env = Uplib.url.query('env');

                if (!env || env == 'null') {
                    env = 'pro';
                }

                if (prefix !== '') {
                    ret.push(prefix);
                }

                if (env !== '') {
                    ret.push(env);
                }

                if (uid !== '') {
                    ret.push(uid);
                }

                if (gameType !== '') {
                    ret.push(gameType);
                }

                if (key !== '') {
                    ret.push(key);
                }

                return ret.join('/');
            }
            /**
             * 序列化工具方法
             * @name serialize
             */

        }, {
            key: 'serialize',
            value: function serialize(value) {
                return JSON.stringify(value);
            }
            /**
             * 反序列化工具方法
             * @name deserialize
             */

        }, {
            key: 'deserialize',
            value: function deserialize(value) {
                if (typeof value != 'string') {
                    return undefined;
                }
                try {
                    return JSON.parse(value);
                } catch (e) {
                    return value || undefined;
                }
            }
            /**
             * 判断key是否失效
             * @return {Boolean}  true 无效； false未失效
             */

        }, {
            key: 'isExpire',
            value: function isExpire(time) {
                if (time > 0) {
                    return new Date().getTime() > Number(time);
                } else {
                    return false;
                }
            }
            /**
             * 设置混存数据
             */

        }, {
            key: 'setItem',
            value: function setItem(key, value, expires) {
                var expires = expires || this.option.expires;
                var curStamp = +new Date();
                var newValue;
                try {
                    // 存储设置的本地数据
                    if (expires > 0) {
                        newValue = {
                            data: value,
                            expires: curStamp + expires
                        };
                    } else {
                        newValue = value;
                    }
                    newValue = this.serialize(newValue);
                    localStorage.setItem(key, newValue);
                } catch (e) {
                    // this.clear();
                }
            }
            /**
             * 获取缓存数据
             */

        }, {
            key: 'getItem',
            value: function getItem(key) {
                var ret = null;

                try {
                    var ret = localStorage.getItem(key);
                    var opt = this.deserialize(ret);
                    var isExpire = this.isExpire(opt.expires);
                    // 已经失效
                    if (isExpire) {
                        ret = null;
                        this.removeItem(key);
                    } else {
                        return opt.expires > 0 ? opt.data : opt;
                    }
                } catch (e) {}
            }
            /**
             * 清除全部数据
             */

        }, {
            key: 'clear',
            value: function clear() {
                try {
                    localStorage.clear();
                } catch (e) {}
            }
            /**
             * 移除数据key
             */

        }, {
            key: 'removeItem',
            value: function removeItem(key) {
                try {
                    localStorage.removeItem(key);
                } catch (e) {}
            }
            /**
             * 获得所有的本地缓存信息
             */

        }, {
            key: 'getAll',
            value: function getAll() {
                var ret = {};
                try {
                    for (var i = 0; i < localStorage.length; ++i) {
                        var key = localStorage.key(i);
                        ret[key] = this.getItem(key);
                    }
                } catch (e) {}
                return ret;
            }
        }]);

        return Cache;
    }();

    lib.Cache = Cache;
})(window, window.Uplib || (window.Uplib = {}));

/***/ }),
/* 75 */
/***/ (function(module, exports) {

/**
 * 全局模块
 */
;(function (win) {
    /**
     * 全局 UpSDK 命名空间
     */
    var U = win.UpSDK = Object.assign({}, Uplib.Events);
    /**
     * 全局 Uplib 命名空间
     */
    var lib = win.Uplib = win.Uplib || {};
    /**
     * 浏览器系统语言
     */
    var SYSTEM_LANGUAGE = function () {
        var systemLanguage = navigator.language || navigator.browserLanguage;

        var _systemLanguage = systemLanguage.toLowerCase();

        switch (_systemLanguage) {
            case 'ar':
                systemLanguage = 'ar-EG';
                break;
            case 'vi':
                systemLanguage = 'vi-VN';
                break;
            case 'en':
                systemLanguage = 'en-US';
                break;
            case 'ja':
                systemLanguage = 'ja-JP';
                break;
            case 'zh':
                systemLanguage = 'zh-CN';
                break;
            case 'ko':
                systemLanguage = 'ko-KR';
                break;
            default:
                break;
        }

        var arr = systemLanguage.split('-');

        if (arr.length > 1) {
            systemLanguage = arr[0] + '-' + arr[1].toUpperCase();
        } else {
            systemLanguage = 'en-US';
        }

        return systemLanguage;
    }();

    var cache = U.cache = new Uplib.Cache({
        prefix: 'uplive'
    });
    /**
     * 全局配置
     */
    U.config = {
        channel: 'universal-gifting-gifto',
        language: SYSTEM_LANGUAGE,
        systemLanguage: SYSTEM_LANGUAGE
    };

    U.setConfig = function (cfg) {
        U.config = Object.assign(U.config, cfg);
    };

    // 用户登录信息，有效期8小时
    U.writeLoginInfo = function (data) {
        cache.setCache('user', data, 8 * 3600 * 1000);
    };

    U.clearLoginInfo = function () {
        cache.removeCache('user');
    };
    /**
     * 判断登录
     */
    U.isLogin = function () {
        var user = cache.getCache('user');

        return !!(user && user.userToken);
    };
    /**
     * 获取用户登录信息
     */
    U.getUser = function (callback) {
        if (typeof callback == 'function') {
            U.onGetUserSuccess = callback;
        }

        if (U.isLogin()) {
            var user = U.getUserInfo();

            U.onGetUserSuccess(user);
        }
    };
    /**
     * 获取用户信息
     */
    U.getUserInfo = function () {
        return cache.getCache('user') || {};
    },
    /**
     *  获取usertoken,uid
      {
        uid: '',
        userToken: '',
        subscribe: '',
        username: '',
        avatar: '',
        countryCode: '',
        gender: '',
        grade: '',
        upliveCode: ''
      }
     */
    U.getUserToken = function () {
        var user = cache.getCache('user');

        return user.userToken;
    };
    /**
     * 监听授权获取用户成功
     */
    U.on('getUserSuccess', function (data) {
        U.onGetUserSuccess && U.onGetUserSuccess(data);
    });
})(window);

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var _lang = __webpack_require__(40);

var _lang2 = _interopRequireDefault(_lang);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

; /**
   * loading组件
   * @author zhenn
   * @time 2016-11-16
   */

(function (win, lib) {
    var template = ['<div class="J_Loading">', '<div class="g-app-loading">', '<i class="icon"></i>', '<p class="tip">{{text}}</p>', '</div>', '</div>', '<style type="text/css">', '.J_Loading {', 'position: fixed;', 'background: rgba(0, 0, 0, 0.8);', 'width: 100%;', 'height: 100%;', 'left: 0;', 'top: 0;', 'overflow: hidden;', 'z-index: 99999;', '}', '.J_Loading .g-app-loading {', 'width: 2.5rem;', 'height: 2.5rem;', 'border-radius: 0.3125rem;', 'background: rgba(255,255,255, .9);', 'position: absolute;', 'left: 50%;', 'top: 50%;', 'margin: -1.25rem 0 0 -1.25rem;', '}', '.J_Loading .g-app-loading .icon {', 'display: block;', 'width: 0.9375rem;', 'height: 0.9375rem;', 'margin: 0.46875rem auto 0;', 'background: url(data:image/gif;base64,R0lGODlhIAAgAPMLAMrKyo6Ojry8vKKiokZGRmNjY9vb2+bm5sHBwTAwMBgYGP///wAAAAAAAAAAAAAAACH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQFCgALACwAAAAAIAAgAAAE3XDJSelQo+rNZ1JJZRydJgSVolKAIJTUkSQFpSrT4SIwNScvyW2CcBl6k8CMMBkuDDskhTBDLZw7klQi+JGGUAGAEtYuBARCZlKoanS5onEySBMKQUBi3WntxhQFdndHPTsuZhQCgnZIYYUddQRBPZAwB1ZbmluHWQADAaGimp07oqeZSKUIB5+oqZuxHZYwtLNzJY+qh4lxh1J+LoATwS61lDo7kGGIRL1PwmRFZsmWfkdRZ82ayUHZzJtyhdnaAra3xlzpC92c2+Us64ZiivJPzx0HtHKyJTr4GyIAACH5BAUKAAsALAAAAAAYABcAAARycMlJaxI160kSqcGwiVRiUoSiaMRXntKgJmyLTCYtJWqgDa0CDhaYbRaFFim3MKgUpE3LxSyoXM1A4IbCUmSACUKrNUgMBMyRIiCHDuuNwe2Lb8aBsP2o3vvjBwgCg4R/C4KEhX+BiYOGj5CRkpNHensRACH5BAUKAAsALAEAAAAdAA4AAARucMlJpyA1670KKZnATQZSEShVJMkoBYE4oZgksPUIB8acSgSWy7bz5XBDyQBmWtAWB1ZCNjlsDEVnKsACTQIKxeAgQPQmy5impUyEFbxy2QoNAEYAwltRA8gFd0l7UxRkf0lgcFdlZ0MFjVdJHBEAIfkEBQoACwAsBwAAABkAEQAABGZwyblAADTrPcLI37YcRhacGUGIgoBNZ0Cp4tIKB4xKhRpqhptOthioCjVbq7SISVSr5EHY3NEyiYSAAlhqBAQmOJv4MmsFcgKZ3KijlG27mJ23Azm7fq9R+P8JP3p/hAp8C4UKgREAIfkEBQoACwAsDgAAABIAGAAABGbQDLOqvVgMvBDlyyBeQxCA4VgZ5gmKW9UiKFwhLZrG7feOAlOsMiAQUIDAwVIwEoYgQ9OpszgJBVq1YoRuv+BvYkw+VsnoxDlNEITDAd83oFC4vvV6wgsCEPIKZlsDCXl3W3QKbhEAIfkEBQoACwAsDgAAABIAHgAABH3woLOqvRgJhAG+mwAOw1eFFyma6El67FYBZGkubX2fMj2sp0DAYDIADUIhZ3cYJAO23XO4swCU1Ux2yyV4vwWg6UsmVMuEAndtoawHiQQ7HieIb4YCPaE2BRQwAgR0JgUKCmYXgyYHhwpRWX8KcmsJhwFrAo5sBIduXFAmEQAh+QQFCgALACwPAAEAEQAfAAAEeHDJucyhGAMhsj8c4mUIZ4yUEaJUeLEVB6TcS9kLGJ7oFs6oUA2mEvBgFaQSFWg6B0CPcxpgUqHLrFJAIAyU3W5hGSaMBglKIfylBBKJ8WTQlSjuEnii47krJnBmfXgSBHAjfhR6g38TBYcZiRh8GAkKaUoDCm1IEQAh+QQFCgALACwIAA4AGAASAAAEbHDJSesSOKNj+9Sa54EYJ56oKKQnEAQI2720IVPHQAeDLBC2hWEXkwAUgQ6BUEG8gguCQlFYJK6SJVM0mCo414RksKx6EtOkFSspLHuWwFQsCVO0HbQCvqZPlh1TW3VsE3wVOhUECYM3H34pEQAh+QQFCgALACwCABIAHQAOAAAEdXDJSatd5lJTtDWCkF2BogQehYThoSammVIAKwASESsE7gEB1+KwChlKpsRAYlBaBIHAcgISHAYm1KSQSKAIYEk0MLIIJ4JuIhdeIMazCaErby8GUUR80SXU/UxwM3MJAn8UeFopXR2HKmUehhUFBI17cYBxEQAh+QQFCgALACwAAA8AGQARAAAEZnAkReu6OOtbu9pgJnlfaJ7oeQQpmiRDCxLvK2dFnRSoIWw1wu8i3PgEgIzApiEQLoHoRUA9oJzPRZS1OCJOBWdMK51SDaGBkwctLw7U4Szb5l4A1JBTs9UYrGkaAwFjNxoAAUkbEQAh+QQFCgALACwBAAgAEQAYAAAEWVAoFZa9+Iap0sjgQnAKAYTYkJBotlFtZlRxbd94ru/oQBA2ROH3qxEJBUPL9ytcDoET6Pe5DAIBwULARc2wFq42hM2GuyBE+SImY5XnscvMRsvkcdwBcYgAACH5BAUKAAsALAAAAgAOAB0AAARvcMm5RqB4KkUy3orgTcGWjFOyXegAGmlHEVuRJgkhLoDCSgUcrgDzCAjCE2qBGywXh+dSUCBYr5mrVkahbrnS8A6FCAQAI4N57bGsB1FM2TxASwTxhTqAoAAEAkUeB4BjRoCCGQaFU4B5h3YoB4kRADs=) no-repeat center center;', 'background-size: 100% 100%;', '}', '.J_Loading .g-app-loading .tip {', 'text-align: center;', 'margin-top: 0.3125rem;', 'font-size: 0.375rem;', '}', '</style>'];

    lib.loading = {
        show: function show() {
            var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref$text = _ref.text,
                text = _ref$text === undefined ? _lang2.default.tpl('正在加载') : _ref$text;

            if (this.el) {
                return;
            }
            var html = template.join('').replace('{{text}}', text);

            var node = document.createElement('div');

            node.innerHTML = html;

            var el = this.el = node;

            document.body.appendChild(el);
        },
        hide: function hide() {
            if (this.el) {
                this.el.remove();
                this.el = null;
            }
        }
    };
})(window, window.Uplib || (window.Uplib = {}));

/***/ }),
/* 77 */
/***/ (function(module, exports) {

module.exports = {
    "areg": {
        "AD": "أندورا",
        "AE": "الإمارات العربية المتحدة",
        "AF": "أفغانستان",
        "AG": "أنتيغوا وبربودا",
        "AI": "أنغيلا",
        "AL": "ألبانيا",
        "AM": "أرمينيا",
        "AN": "جزر الأنتيل الهولندية",
        "AO": "أنغولا",
        "AQ": "القطب الجنوبي",
        "AR": "الأرجنتين",
        "AS": "ساموا الأمريكية",
        "AT": "النمسا",
        "AU": "أستراليا",
        "AW": "أروبا",
        "AZ": "أذربيجان",
        "BA": "البوسنة والهرسك",
        "BB": "بربادوس",
        "BD": "بنغلاديش",
        "BE": "بلجيكا",
        "BF": "بوركينا فاسو",
        "BG": "بلغاريا",
        "BH": "البحرين",
        "BI": "بوروندي",
        "BJ": "بنين",
        "BL": "سانت بارتيليمي",
        "BM": "برمودا",
        "BN": "بروناي",
        "BO": "بوليفيا",
        "BR": "البرازيل",
        "BS": "الباهاما",
        "BT": "بوتان",
        "BW": "بوتسوانا",
        "BY": "روسيا البيضاء",
        "BZ": "بليز",
        "CA": "كندا",
        "CC": "جزر كوكوس",
        "CD": "جمهورية الكونغو الديموقراطية",
        "CF": "جمهورية افريقيا الوسطى",
        "CG": "جمهورية الكونغو",
        "CH": "سويسرا",
        "CI": "ساحل العاج",
        "CK": "جزر كوك",
        "CL": "تشيلي",
        "CM": "الكاميرون",
        "CN": "الصين",
        "CO": "كولومبيا",
        "CR": "كوستا ريكا",
        "CU": "كوبا",
        "CV": "الرأس الأخضر",
        "CW": "كوراكاو",
        "CX": "جزيرة عيد الميلاد",
        "CY": "قبرص",
        "CZ": "جمهورية التشيك",
        "DE": "ألمانيا",
        "DJ": "جيبوتي",
        "DK": "الدنمارك",
        "DM": "دومينيكا",
        "DO": "جمهورية الدومنيكان",
        "DZ": "الجزائر",
        "EC": "الإكوادور",
        "EE": "استونيا",
        "EG": "مصر",
        "EH": "الصحراء الغربية",
        "ER": "إريتريا",
        "ES": "إسبانيا",
        "ET": "أثيوبيا",
        "FI": "فنلندا",
        "FJ": "فيجي",
        "FK": "جزر فوكلاند",
        "FM": "ميكرونيزيا",
        "FO": "جزر صناعية",
        "FR": "فرنسا",
        "GA": "الغابون",
        "GB": "المملكة المتحدة",
        "GD": "غرينادا",
        "GE": "جورجيا",
        "GG": "غيرنسي",
        "GH": "غانا",
        "GI": "جبل طارق",
        "GL": "الأرض الخضراء",
        "GM": "غامبيا",
        "GN": "غينيا",
        "GQ": "غينيا الإستوائية",
        "GR": "اليونان",
        "GT": "غواتيمالا",
        "GU": "غوام",
        "GW": "غينيا بيساو",
        "GY": "غيانا",
        "HK": "هونغ كونغ",
        "HN": "هندوراس",
        "HR": "كرواتيا",
        "HT": "هايتي",
        "HU": "هنغاريا",
        "ID": "أندونيسيا",
        "IE": "أيرلندا",
        "IL": "إسرائيل",
        "IM": "جزيرة آيل أوف مان",
        "IN": "الهند",
        "IO": "إقليم المحيط البريطاني الهندي",
        "IQ": "العراق",
        "IR": "إيران",
        "IS": "أيسلندا",
        "IT": "إيطاليا",
        "JE": "جيرسي",
        "JM": "جامايكا",
        "JO": "الأردن",
        "JP": "اليابان",
        "KE": "كينيا",
        "KG": "قرغيزستان",
        "KH": "كمبوديا",
        "KI": "كيريباس",
        "KM": "جزر القمر",
        "KN": "سانت كيتس ونيفيس",
        "KP": "كوريا الشمالية",
        "KR": "كوريا الجنوبية",
        "KW": "الكويت",
        "KY": "جزر كايمان",
        "KZ": "كازاخستان",
        "LA": "لاوس",
        "LB": "لبنان",
        "LC": "سانت لوسيا",
        "LI": "ليختنشتاين",
        "LK": "سيريلانكا",
        "LR": "ليبيريا",
        "LS": "ليسوتو",
        "LT": "ليتوانيا",
        "LU": "لوكسمبورغ",
        "LV": "لاتفيا",
        "LY": "ليبيا",
        "MA": "المغرب",
        "MC": "موناكو",
        "MD": "مولدوفا",
        "ME": "الجبل الأسود",
        "MF": "سانت مارتن",
        "MG": "مدغشقر",
        "MH": "جزر مارشال",
        "MK": "مقدونيا",
        "ML": "مالي",
        "MM": "ميانمار",
        "MN": "منغوليا",
        "MO": "ماكاو",
        "MP": "جزر مريانا الشمالية",
        "MR": "موريتانيا",
        "MS": "مونتسيرات",
        "MT": "مالطا",
        "MU": "موريشيوس",
        "MV": "جزر المالديف",
        "MW": "ملاوي",
        "MX": "المكسيك",
        "MY": "ماليزيا",
        "MZ": "موزمبيق",
        "NA": "ناميبيا",
        "NC": "كاليدونيا الجديدة",
        "NE": "النيجر",
        "NG": "نيجيريا",
        "NI": "نيكاراغوا",
        "NL": "هولندا",
        "NO": "النرويج",
        "NP": "نيبال",
        "NR": "ناورو",
        "NU": "نيوي",
        "NZ": "نيوزيلاندا",
        "OM": "سلطنة عمان",
        "PA": "بناما",
        "PE": "بيرو",
        "PF": "بولينيزيا الفرنسية",
        "PG": "بابوا غينيا الجديدة",
        "PH": "الفلبين",
        "PK": "باكستان",
        "PL": "بولندا",
        "PM": "سان بيار وميكلون",
        "PN": "بيتكيرن",
        "PR": "بورتوريكو",
        "PS": "فلسطين",
        "PT": "البرتغال",
        "PW": "بالاو",
        "PY": "باراغواي",
        "QA": "قطر",
        "RE": "جمع شمل",
        "RO": "رومانيا",
        "RS": "صربيا",
        "RU": "روسيا",
        "RW": "رواندا",
        "SA": "المملكة العربية السعودية",
        "SB": "جزر سليمان",
        "SC": "سيشيل",
        "SD": "سودان",
        "SE": "السويد",
        "SG": "سنغافورة",
        "SH": "سانت هيلانة",
        "SI": "سلوفينيا",
        "SJ": "سفالبارد وجان مايان",
        "SK": "سلوفاكيا",
        "SL": "سيرا ليون",
        "SM": "سان مارينو",
        "SN": "السنغال",
        "SO": "الصومال",
        "SR": "سورينام",
        "SS": "جنوب السودان",
        "ST": "ساو تومي وبرينسيبي",
        "SV": "السلفادور",
        "SX": "سانت مارتن",
        "SY": "سوريا",
        "SZ": "سوازيلاند",
        "TC": "جزر تركس وكايكوس",
        "TD": "تشاد",
        "TG": "توغو",
        "TH": "تايلاند",
        "TJ": "طاجيكستان",
        "TK": "توكيلاو",
        "TL": "تيمور الشرقية",
        "TM": "تركمانستان",
        "TN": "تونس",
        "TO": "تونغا",
        "TR": "تركيا",
        "TT": "ترينداد وتوباغو",
        "TV": "توفالو",
        "TW": "تايوان",
        "TZ": "تنزانيا",
        "UA": "أوكرانيا",
        "UG": "أوغندا",
        "US": "الولايات المتحدة",
        "UY": "أوروغواي",
        "UZ": "أوزبكستان",
        "VA": "الفاتيكان",
        "VC": "سانت فنسنت وجزر غرينادين",
        "VE": "فنزويلا",
        "VG": "جزر فيرجن البريطانية",
        "VI": "جزر العذراء الأمريكية",
        "VN": "فيتنام",
        "VU": "فانواتو",
        "WF": "واليس وفوتونا",
        "WS": "ساموا",
        "XK": "كوسوفو",
        "YE": "اليمن",
        "YT": "مايوت",
        "ZA": "جنوب أفريقيا",
        "ZM": "زامبيا",
        "ZW": "زيمبابوي",
        "其他登录方式": "طرق تسجيل دخول أُخرى",
        "加载中": "جارٍ التحميل...",
        "参数错误": "خطأ في الكود",
        "取消": "إلغاء",
        "国家/地区": "الدولة/المنطقة",
        "打开Up直播<br/>扫一扫登录": "فتح Uplive للبث المباشر <br/> قُم بالمسح لتسجيل الدخول",
        "提示": "تنبيه",
        "搜索": "بحث",
        "正在加载": "جارٍ التحميل",
        "正在登录": "جارٍ تسجيل الدخول .",
        "正在退出...": "جارٍ الخروج",
        "登录": "تسجيل الدخول",
        "登录代表你接受Up直播《服务条款及隐私政策》": "تسجيل الدخول يُعد موافقة على《<i> بنود الخدمة </i> و<em> سياسة الخصوصية </em>》",
        "确认": "تأكيد",
        "确认退出Up直播？": "هل تريد الخروج من Uplive ؟",
        "系统错误": "خطأ فى النظام",
        "网络连接有误, 请稍后再试": "خطأ في الشبكة، يرجى المحاولة بعد قليل",
        "获取用户信息失败, 请稍后再试": "فشل فى الحصول على معلومات المستخدم، من فضلك أنتظر قليلا ثم قُم بمحاولة مرة أخرى",
        "请稍侯，正在登录中...": "برجاء الانتظار، جارٍ تسجيل الدخول ...",
        "请输入手机号码": "إدخال رقم الهاتف",
        "请输入登录密码": "يٌرجى إدخال كلمة المرور لتسجيل الدخول",
        "选择国家或地区": "قم باختيار الدولة"
    },
    "enus": {
        "AD": "Andorra",
        "AE": "United Arab Emirates",
        "AF": "Afghanistan",
        "AG": "Antigua and Barbuda",
        "AI": "Anguilla",
        "AL": "Albania",
        "AM": "Armenia",
        "AN": "Netherlands Antilles",
        "AO": "Angola",
        "AQ": "Antarctica",
        "AR": "Argentina",
        "AS": "American Samoa",
        "AT": "Austria",
        "AU": "Australia",
        "AW": "Aruba",
        "AZ": "Azerbaijan",
        "BA": "Bosnia and Herzegovina",
        "BB": "Barbados",
        "BD": "Bangladesh",
        "BE": "Belgium",
        "BF": "Burkina Faso",
        "BG": "Bulgaria",
        "BH": "Bahrain",
        "BI": "Burundi",
        "BJ": "Benin",
        "BL": "Saint Barthelemy",
        "BM": "Bermuda",
        "BN": "Brunei",
        "BO": "Bolivia",
        "BR": "Brazil",
        "BS": "Bahamas",
        "BT": "Bhutan",
        "BW": "Botswana",
        "BY": "Belarus",
        "BZ": "Belize",
        "CA": "Canada",
        "CC": "Cocos Islands",
        "CD": "Democratic Republic of the Congo",
        "CF": "Central African Republic",
        "CG": "Republic of the Congo",
        "CH": "Switzerland",
        "CI": "Ivory Coast",
        "CK": "Cook Islands",
        "CL": "Chile",
        "CM": "Cameroon",
        "CN": "China",
        "CO": "Colombia",
        "CR": "Costa Rica",
        "CU": "Cuba",
        "CV": "Cape Verde",
        "CW": "Curacao",
        "CX": "Christmas Islands",
        "CY": "Cyprus",
        "CZ": "Czech Republic",
        "DE": "Germany",
        "DJ": "Djibouti",
        "DK": "Denmark",
        "DM": "Dominica",
        "DO": "Dominican Republic",
        "DZ": "Algeria",
        "EC": "Ecuador",
        "EE": "Estonia",
        "EG": "Egypt",
        "EH": "Western Sahara",
        "ER": "Eritrea",
        "ES": "Spain",
        "ET": "Ethiopia",
        "FI": "Finland",
        "FJ": "Fiji",
        "FK": "Falkland Islands",
        "FM": "Micronesia",
        "FO": "Faroe Islands",
        "FR": "France",
        "GA": "Gabon",
        "GB": "United Kingdom",
        "GD": "Grenada",
        "GE": "Georgia",
        "GG": "Guernsey",
        "GH": "Ghana",
        "GI": "Gibraltar",
        "GL": "Greenland",
        "GM": "Gambia",
        "GN": "Guinea",
        "GQ": "Equatorial Guinea",
        "GR": "Greece",
        "GT": "Guatemala",
        "GU": "Guam",
        "GW": "Guinea-Bissau",
        "GY": "Guyana",
        "HK": "Hong Kong",
        "HN": "Honduras",
        "HR": "Croatia",
        "HT": "Haiti",
        "HU": "Hungary",
        "ID": "Indonesia",
        "IE": "Ireland",
        "IL": "Israel",
        "IM": "Isle of Man",
        "IN": "India",
        "IO": "British Indian Ocean Territory",
        "IQ": "Iraq",
        "IR": "Iran",
        "IS": "Iceland",
        "IT": "Italy",
        "JE": "Jersey",
        "JM": "Jamaica",
        "JO": "Jordan",
        "JP": "Japan",
        "KE": "Kenya",
        "KG": "Kyrgyzstan",
        "KH": "Cambodia",
        "KI": "Kiribati",
        "KM": "Comoros",
        "KN": "Saint Kitts and Nevis",
        "KP": "North Korea",
        "KR": "South Korea",
        "KW": "Kuwait",
        "KY": "Cayman Islands",
        "KZ": "Kazakhstan",
        "LA": "Laos",
        "LB": "Lebanon",
        "LC": "Saint Lucia",
        "LI": "Liechtenstein",
        "LK": "Sri Lanka",
        "LR": "Liberia",
        "LS": "Lesotho",
        "LT": "Lithuania",
        "LU": "Luxembourg",
        "LV": "Latvia",
        "LY": "Libya",
        "MA": "Morocco",
        "MC": "Monaco",
        "MD": "Moldova",
        "ME": "Montenegro",
        "MF": "Saint Martin",
        "MG": "Madagascar",
        "MH": "Marshall Islands",
        "MK": "Macedonia",
        "ML": "Mali",
        "MM": "Myanmar",
        "MN": "Mongolia",
        "MO": "Macau",
        "MP": "Northern Mariana Islands",
        "MR": "Mauritania",
        "MS": "Montserrat",
        "MT": "Malta",
        "MU": "Mauritius",
        "MV": "Maldives",
        "MW": "Malawi",
        "MX": "Mexico",
        "MY": "Malaysia",
        "MZ": "Mozambique",
        "NA": "Namibia",
        "NC": "New Caledonia",
        "NE": "Niger",
        "NG": "Nigeria",
        "NI": "Nicaragua",
        "NL": "Netherlands",
        "NO": "Norway",
        "NP": "Nepal",
        "NR": "Nauru",
        "NU": "Niue",
        "NZ": "New Zealand",
        "OM": "Oman",
        "PA": "Panama",
        "PE": "Peru",
        "PF": "French Polynesia",
        "PG": "Papua New Guinea",
        "PH": "Philippines",
        "PK": "Pakistan",
        "PL": "Poland",
        "PM": "Saint Pierre and Miquelon",
        "PN": "Pitcairn",
        "PR": "Puerto Rico",
        "PS": "Palestine",
        "PT": "Portugal",
        "PW": "Palau",
        "PY": "Paraguay",
        "QA": "Qatar",
        "RE": "Reunion",
        "RO": "Romania",
        "RS": "Serbia",
        "RU": "Russia",
        "RW": "Rwanda",
        "SA": "Saudi Arabia",
        "SB": "Solomon Islands",
        "SC": "Seychelles",
        "SD": "Sudan",
        "SE": "Sweden",
        "SG": "Singapore",
        "SH": "Saint Helena",
        "SI": "Slovenia",
        "SJ": "Svalbard and Jan Mayen",
        "SK": "Slovakia",
        "SL": "Sierra Leone",
        "SM": "San Marino",
        "SN": "Senegal",
        "SO": "Somalia",
        "SR": "Suriname",
        "SS": "South Sudan",
        "ST": "Sao Tome and Principe",
        "SV": "El Salvador",
        "SX": "Sint Maarten",
        "SY": "Syria",
        "SZ": "Swaziland",
        "TC": "Turks and Caicos Islands",
        "TD": "Chad",
        "TG": "Togo",
        "TH": "Thailand",
        "TJ": "Tajikistan",
        "TK": "Tokelau",
        "TL": "East Timor",
        "TM": "Turkmenistan",
        "TN": "Tunisia",
        "TO": "Tonga",
        "TR": "Turkey",
        "TT": "Trinidad and Tobago",
        "TV": "Tuvalu",
        "TW": "Taiwan",
        "TZ": "Tanzania",
        "UA": "Ukraine",
        "UG": "Uganda",
        "US": "United States",
        "UY": "Uruguay",
        "UZ": "Uzbekistan",
        "VA": "Vatican",
        "VC": "Saint Vincent and the Grenadines",
        "VE": "Venezuela",
        "VG": "British Virgin Islands",
        "VI": "U.S. Virgin Islands",
        "VN": "Vietnam",
        "VU": "Vanuatu",
        "WF": "Wallis and Futuna",
        "WS": "Samoa",
        "XK": "Kosovo",
        "YE": "Yemen",
        "YT": "Mayotte",
        "ZA": "South Africa",
        "ZM": "Zambia",
        "ZW": "Zimbabwe",
        "其他登录方式": "Other login method",
        "加载中": "Loading…",
        "参数错误": "error",
        "取消": "Cancel",
        "国家/地区": "Country / Region",
        "打开Up直播<br/>扫一扫登录": "Open Up live <br/> and scan to log in",
        "提示": "Reminder",
        "搜索": "Search",
        "正在加载": "Loading",
        "正在登录": "Logging in",
        "正在退出...": "Logging out...",
        "登录": "Login",
        "登录代表你接受Up直播《服务条款及隐私政策》": "Logging in means you agree UP Live's 《<i>terms of service</i> and <em> privacy policy </em>》",
        "确认": "Confirm",
        "确认退出Up直播？": "Are you sure you want to exit Uplive ?",
        "系统错误": "System error",
        "网络连接有误, 请稍后再试": "Network issue, please try again later.",
        "获取用户信息失败, 请稍后再试": "Fail to load the data, please try later",
        "请稍侯，正在登录中...": "Logging in, please wait...",
        "请输入手机号码": "Enter phone number",
        "请输入登录密码": "Enter password",
        "选择国家或地区": "Select country or region"
    },
    "jajp": {
        "AD": "アンドラ",
        "AE": "アラブ首長国連邦",
        "AF": "アフガニスタン",
        "AG": "アンチグアバーブーダ",
        "AI": "アングィラ",
        "AL": "アルバニア",
        "AM": "アルメニア",
        "AN": "オランダ領アンティル",
        "AO": "アンゴラ",
        "AQ": "南極大陸",
        "AR": "アルゼンチン",
        "AS": "アメリカ領サモア",
        "AT": "オーストリア",
        "AU": "オーストラリア",
        "AW": "アルバ",
        "AZ": "アゼルバイジャン",
        "BA": "ボスニア・ヘルツェゴビナ",
        "BB": "バルバドス",
        "BD": "バングラデシュ",
        "BE": "ベルギー",
        "BF": "ブルキナファソ",
        "BG": "ブルガリア",
        "BH": "バーレーン",
        "BI": "ブルンジ",
        "BJ": "ベニン",
        "BL": "セントバーツ",
        "BM": "バミューダ",
        "BN": "ブルネイ",
        "BO": "ボリビア",
        "BR": "ブラジル",
        "BS": "バハマ",
        "BT": "ブータン",
        "BW": "ボツワナ",
        "BY": "ベラルーシ",
        "BZ": "ベリーズ",
        "CA": "カナダ",
        "CC": "ココス諸島",
        "CD": "コンゴ民主共和国",
        "CF": "中央アフリカ共和国",
        "CG": "コンゴ共和国",
        "CH": "スイス",
        "CI": "コー​​トジボワール",
        "CK": "クック諸島",
        "CL": "チリ",
        "CM": "カメルーン",
        "CN": "中国",
        "CO": "コロンビア",
        "CR": "コスタリカ",
        "CU": "キューバ",
        "CV": "カーボベルデ",
        "CW": "キュラソー",
        "CX": "クリスマス島",
        "CY": "キプロス",
        "CZ": "チェコ共和国",
        "DE": "ドイツ",
        "DJ": "ジブチ",
        "DK": "デンマーク",
        "DM": "ドミニカ",
        "DO": "ドミニカ共和国",
        "DZ": "アルジェリア",
        "EC": "エクアドル",
        "EE": "エストニア",
        "EG": "エジプト",
        "EH": "西サハラ",
        "ER": "エリトリア",
        "ES": "スペイン",
        "ET": "エチオピア",
        "FI": "フィンランド",
        "FJ": "フィジー",
        "FK": "フォークランド諸島",
        "FM": "ミクロネシア",
        "FO": "フェロー諸島",
        "FR": "フランス",
        "GA": "ガボン",
        "GB": "イギリス",
        "GD": "グレナダ",
        "GE": "ジョージア",
        "GG": "ガーンジー島",
        "GH": "ガーナ",
        "GI": "ジブラルタル",
        "GL": "グリーンランド",
        "GM": "ガンビア",
        "GN": "ギニア",
        "GQ": "赤道ギニア",
        "GR": "ギリシャ",
        "GT": "グアテマラ",
        "GU": "グアム",
        "GW": "ギニアビサウ",
        "GY": "ガイアナ",
        "HK": "香港",
        "HN": "ホンジュラス",
        "HR": "クロアチア",
        "HT": "ハイチ",
        "HU": "ハンガリー",
        "ID": "インドネシア",
        "IE": "アイルランド",
        "IL": "イスラエル",
        "IM": "マン島",
        "IN": "インド",
        "IO": "イギリス領インド洋地域",
        "IQ": "イラク",
        "IR": "イラン",
        "IS": "アイスランド",
        "IT": "イタリア",
        "JE": "ジャージー",
        "JM": "ジャマイカ",
        "JO": "ヨルダン",
        "JP": "日本",
        "KE": "ケニア",
        "KG": "キルギスタン",
        "KH": "カンボジア",
        "KI": "キリバス",
        "KM": "コモロ",
        "KN": "セントクリストファー・ネイビス",
        "KP": "北朝鮮",
        "KR": "韓国",
        "KW": "クウェート",
        "KY": "ケイマン諸島",
        "KZ": "カザフスタン",
        "LA": "ラオス",
        "LB": "レバノン",
        "LC": "セントルシア",
        "LI": "リヒテンシュタイン",
        "LK": "スリランカ",
        "LR": "リベリア",
        "LS": "レソト",
        "LT": "リトアニア",
        "LU": "ルクセンブルク",
        "LV": "ラトビア",
        "LY": "リビア",
        "MA": "モロッコ",
        "MC": "モナコ",
        "MD": "モルドバ",
        "ME": "モンテネグロ",
        "MF": "サンマルタン島",
        "MG": "マダガスカル",
        "MH": "マーシャル諸島",
        "MK": "マケドニア",
        "ML": "マリ",
        "MM": "ミャンマー",
        "MN": "モンゴル",
        "MO": "マカオ",
        "MP": "北マリアナ諸島",
        "MR": "モーリタニア",
        "MS": "モントセラト",
        "MT": "マルタ",
        "MU": "モーリシャス",
        "MV": "モルディブ",
        "MW": "マラウイ",
        "MX": "メキシコ",
        "MY": "マレーシア",
        "MZ": "モザンビーク",
        "NA": "ナミビア",
        "NC": "ニューカレドニア",
        "NE": "ニジェール",
        "NG": "ナイジェリア",
        "NI": "ニカラグア",
        "NL": "オランダ",
        "NO": "ノルウェー",
        "NP": "ネパール",
        "NR": "ナウル",
        "NU": "ニウエ",
        "NZ": "ニュージーランド",
        "OM": "オマーン",
        "PA": "パナマ",
        "PE": "ペルー",
        "PF": "フランス領ポリネシア",
        "PG": "パプアニューギニア",
        "PH": "フィリピン",
        "PK": "パキスタン",
        "PL": "ポーランド",
        "PM": "サンピエール島・ミクロン島",
        "PN": "ピトケアン",
        "PR": "プエルトリコ",
        "PS": "パレスチナ",
        "PT": "ポルトガル",
        "PW": "パラオ",
        "PY": "パラグアイ",
        "QA": "カタール",
        "RE": "再会",
        "RO": "ルーマニア",
        "RS": "セルビア",
        "RU": "ロシア",
        "RW": "ルワンダ",
        "SA": "サウジアラビア",
        "SB": "ソロモン諸島",
        "SC": "セイシェル",
        "SD": "スーダン",
        "SE": "スウェーデン",
        "SG": "シンガポール",
        "SH": "セントヘレナ",
        "SI": "スロベニア",
        "SJ": "スバールバル諸島ヤンマイエン島",
        "SK": "スロバキア",
        "SL": "シエラレオネ",
        "SM": "サン・マリノ",
        "SN": "セネガル",
        "SO": "ソマリア",
        "SR": "スリナム",
        "SS": "南スーダン",
        "ST": "サントメプリンシペ",
        "SV": "エルサルバドル",
        "SX": "シントマールテン島",
        "SY": "シリア",
        "SZ": "スワジランド",
        "TC": "タークス・カイコス諸島",
        "TD": "チャド",
        "TG": "行く",
        "TH": "タイ",
        "TJ": "タジキスタン",
        "TK": "トケラウ諸島",
        "TL": "東ティモール",
        "TM": "トルクメニスタン",
        "TN": "チュニジア",
        "TO": "トンガ",
        "TR": "トルコ",
        "TT": "トリニダード・トバゴ",
        "TV": "ツバル",
        "TW": "台湾",
        "TZ": "タンザニア",
        "UA": "ウクライナ",
        "UG": "ウガンダ",
        "US": "アメリカ",
        "UY": "ウルグアイ",
        "UZ": "ウズベキスタン",
        "VA": "バチカン",
        "VC": "セントビンセントおよびグレナディーン諸島",
        "VE": "ベネズエラ",
        "VG": "イギリス領バージン諸島",
        "VI": "米領バージン諸島",
        "VN": "ベトナム",
        "VU": "バヌアツ",
        "WF": "ワリー・エ・フトゥーナ",
        "WS": "サモア",
        "XK": "コソボ",
        "YE": "イエメン",
        "YT": "マヨット島",
        "ZA": "南アフリカ",
        "ZM": "ザンビア",
        "ZW": "ジンバブエ",
        "其他登录方式": "他のログイン方法でログインする",
        "加载中": "ローディング…",
        "参数错误": "パラメータエラー",
        "取消": "キャンセル",
        "国家/地区": "国/地域",
        "打开Up直播<br/>扫一扫登录": "Upliveを開き<br/>\nQRコードをスキャンしよう",
        "提示": "Tips",
        "搜索": "検索",
        "正在加载": "ローディング中",
        "正在登录": "ログイン中",
        "正在退出...": "終了中......",
        "登录": "登録",
        "登录代表你接受Up直播《服务条款及隐私政策》": "Upliveにログインすることで《<i>利用規約</i>及び<em>プライバシーポリシー</em>》を承諾したことになります",
        "确认": "確認",
        "确认退出Up直播？": "Upliveを終了しますか？",
        "系统错误": "システムエラー",
        "网络连接有误, 请稍后再试": "ネット接続エラーです。後でもう一度試してください。",
        "获取用户信息失败, 请稍后再试": "ユーザデータを獲得できませんでした、再度お試しください",
        "请稍侯，正在登录中...": "ログイン中、少々お待ちください",
        "请输入手机号码": "携帯番号を入力してください",
        "请输入登录密码": "ログインパスワードを入力してください",
        "选择国家或地区": "国、地域を選択"
    },
    "kokr": {
        "AD": "안도라",
        "AE": "아랍 에미리트",
        "AF": "아프가니스탄",
        "AG": "앤티가 바부 다",
        "AI": "앵 귈라",
        "AL": "알바니아",
        "AM": "아르메니아",
        "AN": "네덜란드 령 앤 틸리 스",
        "AO": "앙골라",
        "AQ": "남극 대륙",
        "AR": "아르헨티나",
        "AS": "사모아",
        "AT": "오스트리아",
        "AU": "호주",
        "AW": "아루바",
        "AZ": "아제르바이잔",
        "BA": "보스니아 헤르체고비나",
        "BB": "바베이도스",
        "BD": "방글라데시",
        "BE": "벨기에",
        "BF": "부르 키나 파소",
        "BG": "불가리아",
        "BH": "바레인",
        "BI": "부룬디",
        "BJ": "베냉",
        "BL": "세인트 Barthelemy",
        "BM": "버뮤다",
        "BN": "브루나이",
        "BO": "볼리비아",
        "BR": "브라질",
        "BS": "바하마",
        "BT": "부탄",
        "BW": "보츠와나",
        "BY": "벨라루스",
        "BZ": "벨리즈",
        "CA": "캐나다",
        "CC": "코코스 아일랜드",
        "CD": "콩고 민주 공화국",
        "CF": "중앙 아프리카 공화국",
        "CG": "콩고 민주 공화국",
        "CH": "스위스",
        "CI": "상아 해안",
        "CK": "쿡 제도",
        "CL": "칠레",
        "CM": "카메룬",
        "CN": "중국",
        "CO": "콜롬비아",
        "CR": "코스타리카",
        "CU": "쿠바",
        "CV": "카보 베르데",
        "CW": "쿠라 카오",
        "CX": "크리스마스 제도",
        "CY": "키프로스",
        "CZ": "체코 공화국",
        "DE": "독일",
        "DJ": "지부티",
        "DK": "덴마크",
        "DM": "도미니카",
        "DO": "도미니카 공화국",
        "DZ": "알제리",
        "EC": "에콰도르",
        "EE": "에스토니아",
        "EG": "이집트",
        "EH": "서부 사하라",
        "ER": "에리트레아",
        "ES": "스페인",
        "ET": "에티오피아",
        "FI": "핀란드",
        "FJ": "피지",
        "FK": "포클랜드 제도",
        "FM": "미크로네시아",
        "FO": "파로에 군도",
        "FR": "프랑스",
        "GA": "가봉",
        "GB": "영어",
        "GD": "그레나다",
        "GE": "그루지야",
        "GG": "영국 해협에있는 작은 섬",
        "GH": "가나",
        "GI": "지브롤터",
        "GL": "그린 랜드",
        "GM": "감비아",
        "GN": "기니",
        "GQ": "적도 기니",
        "GR": "그리스",
        "GT": "과테말라",
        "GU": "괌",
        "GW": "기니 비사우",
        "GY": "가이아나",
        "HK": "홍콩",
        "HN": "온두라스",
        "HR": "크로아티아",
        "HT": "아이티",
        "HU": "헝가리",
        "ID": "인도네시아",
        "IE": "아일랜드",
        "IL": "이스라엘",
        "IM": "아일 오브 맨",
        "IN": "인도",
        "IO": "영국령 인도양 지역",
        "IQ": "이라크",
        "IR": "이란",
        "IS": "아이슬란드",
        "IT": "이탈리아",
        "JE": "뉴저지",
        "JM": "자메이카",
        "JO": "요르단",
        "JP": "일본",
        "KE": "케냐",
        "KG": "키르기스스탄",
        "KH": "캄보디아",
        "KI": "키리바시",
        "KM": "코모로",
        "KN": "세인트 키츠 네비스",
        "KP": "북한",
        "KR": "한국",
        "KW": "쿠웨이트",
        "KY": "케이맨 제도",
        "KZ": "카자흐스탄",
        "LA": "라오스",
        "LB": "레바논",
        "LC": "세인트 루시아",
        "LI": "리히텐슈타인",
        "LK": "스리랑카",
        "LR": "라이베리아",
        "LS": "레소토",
        "LT": "리투아니아",
        "LU": "룩셈부르크",
        "LV": "라트비아",
        "LY": "리비아",
        "MA": "모로코",
        "MC": "모나코",
        "MD": "몰르 더바",
        "ME": "몬테네그로",
        "MF": "산 마르틴",
        "MG": "마다가스카르",
        "MH": "마샬 군도",
        "MK": "마케도니아",
        "ML": "말리",
        "MM": "미얀마",
        "MN": "몽골리아",
        "MO": "마카오",
        "MP": "북 마리아나 제도",
        "MR": "모리타니",
        "MS": "몬 세라",
        "MT": "몰타",
        "MU": "모리셔스",
        "MV": "몰디브",
        "MW": "말라위",
        "MX": "멕시코",
        "MY": "말레이시아",
        "MZ": "모잠비크",
        "NA": "나미비아",
        "NC": "뉴 칼레도니아",
        "NE": "니제르",
        "NG": "나이지리아",
        "NI": "니카라과",
        "NL": "네덜란드",
        "NO": "노르웨이",
        "NP": "네팔",
        "NR": "나우루어",
        "NU": "니우에",
        "NZ": "뉴질랜드",
        "OM": "오만",
        "PA": "파나마",
        "PE": "페루",
        "PF": "프랑스 령 폴리네시아의",
        "PG": "파푸아 뉴기니",
        "PH": "필리핀",
        "PK": "파키스탄",
        "PL": "폴란드",
        "PM": "생 피에르 미 클롱",
        "PN": "핏 케언",
        "PR": "푸에르토 리코",
        "PS": "팔레스타인",
        "PT": "포르투갈",
        "PW": "팔라우",
        "PY": "파라과이",
        "QA": "카타르",
        "RE": "재결합",
        "RO": "루마니아",
        "RS": "세르비아",
        "RU": "러시아",
        "RW": "르완다",
        "SA": "사우디 아라비아",
        "SB": "솔로몬 제도",
        "SC": "세이셸",
        "SD": "수단",
        "SE": "스웨덴",
        "SG": "싱가포르",
        "SH": "세인트 헬레나",
        "SI": "슬로베니아",
        "SJ": "스발 바르",
        "SK": "슬로바키아",
        "SL": "시에라 리온",
        "SM": "산 마리노",
        "SN": "세네갈",
        "SO": "소말리아",
        "SR": "수리남",
        "SS": "남 수단",
        "ST": "상투 메 프린시 페",
        "SV": "엘살바도르",
        "SX": "세인트 마틴",
        "SY": "시리아",
        "SZ": "스와질란드",
        "TC": "터크 스 케이 커스 제도",
        "TD": "차드",
        "TG": "토고",
        "TH": "태국",
        "TJ": "타지키스탄",
        "TK": "토켈 라우",
        "TL": "동 티모르",
        "TM": "투르크 메니스탄",
        "TN": "튀니지",
        "TO": "통가",
        "TR": "터키",
        "TT": "트리니다드 토바고",
        "TV": "투발루",
        "TW": "대만",
        "TZ": "탄자니아",
        "UA": "우크라이나",
        "UG": "우간다",
        "US": "미국",
        "UY": "우루과이",
        "UZ": "우즈베키스탄",
        "VA": "바티칸",
        "VC": "세인트 빈센트 그레나딘",
        "VE": "베네수엘라",
        "VG": "영국령 버진 아일랜드",
        "VI": "미국 버진 아일랜드",
        "VN": "베트남",
        "VU": "바누아투",
        "WF": "월리스 푸 투나",
        "WS": "사모아",
        "XK": "코소보",
        "YE": "예멘",
        "YT": "마 요트",
        "ZA": "남아프리카 공화국",
        "ZM": "잠비아",
        "ZW": "짐바브웨",
        "其他登录方式": "다른 방식으로 로그인",
        "加载中": "로딩중...",
        "参数错误": "데이터 오류",
        "取消": "취소",
        "国家/地区": "국가 및 지역",
        "打开Up直播<br/>扫一扫登录": "Uplive 실행 후 <br/>QR코드를 스캔하여 로그인하세요.",
        "提示": "알림",
        "搜索": "검색",
        "正在加载": "로딩중",
        "正在登录": "로그인 중...",
        "正在退出...": "로그아웃 중...",
        "登录": "로그인",
        "登录代表你接受Up直播《服务条款及隐私政策》": "로그인은 Uplive의 \"<i>방송서비스</i>와 <em>개인정보취급방침</em>\"에 대한 동의를 의미합니다.",
        "确认": "확인",
        "确认退出Up直播？": "로그아웃 하시겠습니까?",
        "系统错误": "시스템 오류",
        "网络连接有误, 请稍后再试": "인터넷 연결 오류! 잠시 후 다시 시도해주세요.",
        "获取用户信息失败, 请稍后再试": "개인정보 불러오기 실패! 잠시 후 다시 시도해주세요.  ",
        "请稍侯，正在登录中...": "로그인 중... 잠시만 기다려주세요.",
        "请输入手机号码": "핸드폰 번호를 입력해주세요.",
        "请输入登录密码": "비밀번호를 입력해주세요.",
        "选择国家或地区": "국가 및 지역 선택"
    },
    "msmy": {
        "AD": "Andorra",
        "AE": "United Arab Emirates",
        "AF": "Afghanistan",
        "AG": "Antigua dan Barbuda",
        "AI": "Anguilla",
        "AL": "Albania",
        "AM": "Armenia",
        "AN": "Antillen Belanda",
        "AO": "Angola",
        "AQ": "Antartika",
        "AR": "Argentina",
        "AS": "Samoa",
        "AT": "Austria",
        "AU": "Australia",
        "AW": "Aruba",
        "AZ": "Azerbaijan",
        "BA": "Bosnia dan Herzegovina",
        "BB": "Barbados",
        "BD": "Bangladesh",
        "BE": "Belgium",
        "BF": "Burkina Faso",
        "BG": "Bulgaria",
        "BH": "Bahrain",
        "BI": "Burundi",
        "BJ": "Benin",
        "BL": "Saint Barthelemy",
        "BM": "Bermuda",
        "BN": "Brunei",
        "BO": "Bolivia",
        "BR": "Brazil",
        "BS": "Bahamas",
        "BT": "Bhutan",
        "BW": "Botswana",
        "BY": "Belarus",
        "BZ": "Belize",
        "CA": "Kanada",
        "CC": "Kepulauan Cocos",
        "CD": "Republik Demokratik Congo",
        "CF": "Republik Afrika Tengah",
        "CG": "Republik Demokratik Congo",
        "CH": "Switzerland",
        "CI": "Ivory Coast",
        "CK": "Kepulauan Cook",
        "CL": "Chile",
        "CM": "Cameroon",
        "CN": "China",
        "CO": "Colombia",
        "CR": "Costa Rica",
        "CU": "Cuba",
        "CV": "Cape Verde",
        "CW": "Curacao",
        "CX": "Pulau Krismas",
        "CY": "Cyprus",
        "CZ": "Republik Czech",
        "DE": "Jerman",
        "DJ": "Djibouti",
        "DK": "Denmark",
        "DM": "Dominica",
        "DO": "Republik Dominican",
        "DZ": "Algeria",
        "EC": "Ecuador",
        "EE": "Estonia",
        "EG": "Mesir",
        "EH": "Sahara Barat",
        "ER": "Eritrea",
        "ES": "Sepanyol",
        "ET": "Ethiopia",
        "FI": "Finland",
        "FJ": "Fiji",
        "FK": "Kepulauan Falkland",
        "FM": "Micronesia",
        "FO": "Kepulauan Faroe",
        "FR": "Perancis",
        "GA": "Gabon",
        "GB": "English",
        "GD": "Grenada",
        "GE": "Georgia",
        "GG": "Guernsey",
        "GH": "Ghana",
        "GI": "Gibraltar",
        "GL": "Greenland",
        "GM": "Gambia",
        "GN": "Guinea",
        "GQ": "Guinea Khatulistiwa",
        "GR": "Greece",
        "GT": "Guatemala",
        "GU": "Guam",
        "GW": "Guinea-Bissau",
        "GY": "Guyana",
        "HK": "Hong Kong",
        "HN": "Honduras",
        "HR": "Croatia",
        "HT": "Haiti",
        "HU": "Hungary",
        "ID": "Indonesia",
        "IE": "Ireland",
        "IL": "Israel",
        "IM": "Isle of Man",
        "IN": "India",
        "IO": "British Indian Ocean Territory",
        "IQ": "Iraq",
        "IR": "Iran",
        "IS": "Iceland",
        "IT": "Italy",
        "JE": "New Jersey",
        "JM": "Jamaica",
        "JO": "Jordan",
        "JP": "Jepun",
        "KE": "Kenya",
        "KG": "Kyrgyzstan",
        "KH": "Kemboja",
        "KI": "Kiribati",
        "KM": "Comoros",
        "KN": "Saint Kitts dan Nevis",
        "KP": "Korea Utara",
        "KR": "Korea",
        "KW": "Kuwait",
        "KY": "Pulau Cayman",
        "KZ": "Kazakhstan",
        "LA": "Laos",
        "LB": "Lebanon",
        "LC": "Saint Lucia",
        "LI": "Liechtenstein",
        "LK": "Sri Lanka",
        "LR": "Liberia",
        "LS": "Lesotho",
        "LT": "Lithuania",
        "LU": "Luxembourg",
        "LV": "Latvia",
        "LY": "Libya",
        "MA": "Morocco",
        "MC": "Monaco",
        "MD": "Moldova",
        "ME": "Montenegro",
        "MF": "San Martin",
        "MG": "Madagascar",
        "MH": "Kepulauan Marshall",
        "MK": "Macedonia",
        "ML": "Mali",
        "MM": "Myanmar",
        "MN": "Mongolia",
        "MO": "Macao",
        "MP": "Kepulauan Mariana Utara",
        "MR": "Mauritania",
        "MS": "Montserrat",
        "MT": "Malta",
        "MU": "Mauritius",
        "MV": "Maldives",
        "MW": "Malawi",
        "MX": "Mexico",
        "MY": "Malaysia",
        "MZ": "Mozambique",
        "NA": "Namibia",
        "NC": "New Caledonia",
        "NE": "Niger",
        "NG": "Nigeria",
        "NI": "Nicaragua",
        "NL": "Belanda",
        "NO": "Norway",
        "NP": "Nepal",
        "NR": "Nauru",
        "NU": "Niue",
        "NZ": "New Zealand",
        "OM": "Oman",
        "PA": "Panama",
        "PE": "Peru",
        "PF": "Polynesia Perancis",
        "PG": "Papua New Guinea",
        "PH": "filipina",
        "PK": "pakistan",
        "PL": "Poland",
        "PM": "Saint Pierre dan Miquelon",
        "PN": "Pitcairn",
        "PR": "Puerto Rico",
        "PS": "Palestin",
        "PT": "Portugal",
        "PW": "Palau",
        "PY": "Paraguay",
        "QA": "Qatar",
        "RE": "Reunion",
        "RO": "Romania",
        "RS": "Serbia",
        "RU": "Rusia",
        "RW": "Rwanda",
        "SA": "Arab Saudi",
        "SB": "Kepulauan Solomon",
        "SC": "Seychelles",
        "SD": "Sudan",
        "SE": "Sweden",
        "SG": "Singapura",
        "SH": "St. Helena",
        "SI": "Slovenia",
        "SJ": "Svalbard",
        "SK": "Slovakia",
        "SL": "Sierra Leone",
        "SM": "San Marino",
        "SN": "Senegal",
        "SO": "Somalia",
        "SR": "Surinam",
        "SS": "South Sudan",
        "ST": "Sao Tome dan Principe",
        "SV": "El Salvador",
        "SX": "Sint Maarten",
        "SY": "Syria",
        "SZ": "Swaziland",
        "TC": "Kepulauan Turks dan Caicos",
        "TD": "Chad",
        "TG": "Togo",
        "TH": "Thailand",
        "TJ": "Tajikistan",
        "TK": "Tokelau",
        "TL": "Timor Timur",
        "TM": "Turkmenistan",
        "TN": "Tunisia",
        "TO": "Tonga",
        "TR": "Turki",
        "TT": "Trinidad dan Tobago",
        "TV": "Tuvalu",
        "TW": "Taiwan",
        "TZ": "Tanzania",
        "UA": "Ukraine",
        "UG": "Uganda",
        "US": "Amerika Syarikat",
        "UY": "Uruguay",
        "UZ": "Uzbekistan",
        "VA": "Holy See",
        "VC": "Saint Vincent dan Grenadines",
        "VE": "Venezuela",
        "VG": "Kepulauan British Virgin",
        "VI": "Amerika Syarikat Kepulauan Virgin",
        "VN": "Vietnam",
        "VU": "Vanuatu",
        "WF": "Wallis dan Futuna",
        "WS": "Samoa",
        "XK": "Kosovo",
        "YE": "Yaman",
        "YT": "Mayotte",
        "ZA": "Afrika Selatan",
        "ZM": "Zambia",
        "ZW": "Zimbabwe",
        "其他登录方式": "Log masuk lain",
        "加载中": "loading",
        "参数错误": "Ralat parameter",
        "取消": "batalkan",
        "国家/地区": "Negara / rantau",
        "打开Up直播<br/>扫一扫登录": "Terbuka untuk menyapu masuk",
        "提示": "Petua",
        "搜索": "Carian",
        "正在加载": "loading",
        "正在登录": "sedang log masuk",
        "正在退出...": "sedang keluar",
        "登录": "log masuk",
        "登录代表你接受Up直播《服务条款及隐私政策》": "Log masuk bagi pihak anda menerima <i>Dasar Privasi</i> dan <em>Dasar Privasi Sehingga Langsung</em>",
        "确认": "pastikan",
        "确认退出Up直播？": "pastikan anda keluar Uplive?",
        "系统错误": "Masalah system",
        "网络连接有误, 请稍后再试": "Sambungan rangkaian adalah salah, sila cuba lagi kemudian",
        "获取用户信息失败, 请稍后再试": "gagal dapatkan mesej pengguna,sila cuba kemudian",
        "请稍侯，正在登录中...": "Sila tunggu",
        "请输入手机号码": "sila masukkan nombor telefon",
        "请输入登录密码": "sila masukkan password log masuk",
        "选择国家或地区": "Pilih negara atau wilayah"
    },
    "vivn": {
        "AD": "Andorra",
        "AE": "Các Tiểu Vương Quốc Ả Rập Thống Nhất",
        "AF": "Afghanistan",
        "AG": "Antigua và Barbuda",
        "AI": "Anguilla",
        "AL": "Albania",
        "AM": "Armenia",
        "AN": "Antille thuộc Hà Lan",
        "AO": "Angola",
        "AQ": "Nam Cực",
        "AR": "Argentina",
        "AS": "American Samoa",
        "AT": "Áo",
        "AU": "Châu Úc",
        "AW": "Aruba",
        "AZ": "Azerbaijan",
        "BA": "Bosnia và Herzegovina",
        "BB": "Barbados",
        "BD": "Bangladesh",
        "BE": "Bỉ",
        "BF": "Burkina Faso",
        "BG": "Bulgaria",
        "BH": "Bahrain",
        "BI": "Burundi",
        "BJ": "Benin",
        "BL": "Saint Barthelemy",
        "BM": "Bermuda",
        "BN": "Brunei",
        "BO": "Bolivia",
        "BR": "Brazil",
        "BS": "Bahamas",
        "BT": "Bhutan",
        "BW": "Botswana",
        "BY": "Belarus",
        "BZ": "Belize",
        "CA": "Canada",
        "CC": "Quần đảo Cocos",
        "CD": "Cộng Hòa Dân Chủ Congo",
        "CF": "Cộng Hòa Trung Phi",
        "CG": "Cộng Hòa Congo",
        "CH": "Thụy sĩ",
        "CI": "Bờ Biển Ngà",
        "CK": "Quần đảo Cook",
        "CL": "Chile",
        "CM": "Cameroon",
        "CN": "Trung Quốc",
        "CO": "Colombia",
        "CR": "Costa Rica",
        "CU": "Cuba",
        "CV": "Cape Verde",
        "CW": "Curacao",
        "CX": "Christmas Islands",
        "CY": "Cyprus",
        "CZ": "Cộng Hòa Séc",
        "DE": "Đức",
        "DJ": "Djibouti",
        "DK": "Đan Mạch",
        "DM": "Dominica",
        "DO": "Cộng Hòa Dominica",
        "DZ": "Algeria",
        "EC": "Ecuador",
        "EE": "Estonia",
        "EG": "Ai Cập",
        "EH": "Tây Sahara",
        "ER": "Eritrea",
        "ES": "Tây Ban Nha",
        "ET": "Ethiopia",
        "FI": "Phần Lan",
        "FJ": "Fiji",
        "FK": "Quần đảo Falkland",
        "FM": "Micronesia",
        "FO": "Quần đảo Faroe",
        "FR": "Pháp",
        "GA": "Gabon",
        "GB": "Vương quốc Anh",
        "GD": "Grenada",
        "GE": "Georgia",
        "GG": "Guernsey",
        "GH": "Ghana",
        "GI": "Gibraltar",
        "GL": "Greenland",
        "GM": "Gambia",
        "GN": "Guinea",
        "GQ": "Equatorial Guinea",
        "GR": "Hy Lạp",
        "GT": "Guatemala",
        "GU": "Guam",
        "GW": "Guinea-Bissau",
        "GY": "Guyana",
        "HK": "Hồng Kông",
        "HN": "Honduras",
        "HR": "Croatia",
        "HT": "Haiti",
        "HU": "Hungary",
        "ID": "Indonesia",
        "IE": "Ireland",
        "IL": "Israel",
        "IM": "Isle of Man",
        "IN": "Ấn Độ",
        "IO": "Lãnh thổ Anh tại Ấn Độ Dương",
        "IQ": "Iraq",
        "IR": "Iran",
        "IS": "Iceland",
        "IT": "Ý",
        "JE": "Jersey",
        "JM": "Jamaica",
        "JO": "Jordan",
        "JP": "Nhật Bản",
        "KE": "Kenya",
        "KG": "Kyrgyzstan",
        "KH": "Campuchia",
        "KI": "Kiribati",
        "KM": "Comoros",
        "KN": "Saint Kitts và Nevis",
        "KP": "Bắc Triều Tiên",
        "KR": "Hàn Quốc",
        "KW": "Kuwait",
        "KY": "Quần đảo Cayman",
        "KZ": "Kazakhstan",
        "LA": "Lào",
        "LB": "Lebanon",
        "LC": "Saint Lucia",
        "LI": "Liechtenstein",
        "LK": "Sri Lanka",
        "LR": "Liberia",
        "LS": "Lesotho",
        "LT": "Lithuania",
        "LU": "Luxembourg",
        "LV": "Latvia",
        "LY": "Libya",
        "MA": "Morocco",
        "MC": "Monaco",
        "MD": "Moldova",
        "ME": "Montenegro",
        "MF": "Saint Martin",
        "MG": "Madagascar",
        "MH": "Đảo Marshall",
        "MK": "Macedonia",
        "ML": "Mali",
        "MM": "Myanmar",
        "MN": "Mông Cổ",
        "MO": "Macau",
        "MP": "Quần đảo Bắc Mariana",
        "MR": "Mauritania",
        "MS": "Montserrat",
        "MT": "Malta",
        "MU": "Mauritius",
        "MV": "Maldives",
        "MW": "Malawi",
        "MX": "Mexico",
        "MY": "Malaysia",
        "MZ": "Mozambique",
        "NA": "Namibia",
        "NC": "New Caledonia",
        "NE": "Niger",
        "NG": "Nigeria",
        "NI": "Nicaragua",
        "NL": "Hà Lan",
        "NO": "Na Uy",
        "NP": "Nepal",
        "NR": "Nauru",
        "NU": "Niue",
        "NZ": "New Zealand",
        "OM": "Oman",
        "PA": "Panama",
        "PE": "Peru",
        "PF": "French Polynesia",
        "PG": "Papua New Guinea",
        "PH": "Philippines",
        "PK": "Pakistan",
        "PL": "Ba Lan",
        "PM": "Saint Pierre và Miquelon",
        "PN": "Pitcairn",
        "PR": "Puerto Rico",
        "PS": "Palestine",
        "PT": "Bồ Đào Nha",
        "PW": "Palau",
        "PY": "Paraguay",
        "QA": "Qatar",
        "RE": "Reunion",
        "RO": "Romania",
        "RS": "Serbia",
        "RU": "Nga",
        "RW": "Rwanda",
        "SA": "Ả Rập Saudi",
        "SB": "Quần đảo Solomon",
        "SC": "Seychelles",
        "SD": "Sudan",
        "SE": "Thụy Điển",
        "SG": "Singapore",
        "SH": "Saint Helena",
        "SI": "Slovenia",
        "SJ": "Svalbard và Jan Mayen",
        "SK": "Slovakia",
        "SL": "Sierra Leone",
        "SM": "San Marino",
        "SN": "Senegal",
        "SO": "Somalia",
        "SR": "Suriname",
        "SS": "Nam Sudan",
        "ST": "Sao Tome và Principe",
        "SV": "El Salvador",
        "SX": "Sint Maarten",
        "SY": "Syria",
        "SZ": "Swaziland",
        "TC": "Quần đảo Turks và Caicos",
        "TD": "Chad",
        "TG": "Togo",
        "TH": "Thái Lan",
        "TJ": "Tajikistan",
        "TK": "Tokelau",
        "TL": "Đông Timor",
        "TM": "Turkmenistan",
        "TN": "Tunisia",
        "TO": "Tonga",
        "TR": "Turkey",
        "TT": "Trinidad và Tobago",
        "TV": "Tuvalu",
        "TW": "Đài Loan",
        "TZ": "Tanzania",
        "UA": "Ukraina",
        "UG": "Uganda",
        "US": "Hoa Kỳ",
        "UY": "Uruguay",
        "UZ": "Uzbekistan",
        "VA": "Vatican",
        "VC": "Saint Vincent và Grenadines",
        "VE": "Venezuela",
        "VG": "Quần đảo British Virgin",
        "VI": "Quần đảo Virgin Mỹ",
        "VN": "Việt Nam",
        "VU": "Vanuatu",
        "WF": "Wallis và Futuna",
        "WS": "Samoa",
        "XK": "Kosovo",
        "YE": "Yemen",
        "YT": "Mayotte",
        "ZA": "Nam Phi",
        "ZM": "Zambia",
        "ZW": "Zimbabwe",
        "其他登录方式": "Đăng nhập cách khác",
        "加载中": "Đang tải....",
        "参数错误": "lỗi",
        "取消": "Huỷ",
        "国家/地区": "Quốc gia/khu vực",
        "打开Up直播<br/>扫一扫登录": "Mở Uplive<br/>Đăng nhập ngay",
        "提示": "Nhắc nhở",
        "搜索": "Tìm Kiếm",
        "正在加载": "Loading",
        "正在登录": "Đang thực hiện đăng nhập...",
        "正在退出...": "Đăng xuất...",
        "登录": "Đăng nhập",
        "登录代表你接受Up直播《服务条款及隐私政策》": "Đăng nhập có nghĩa là bạn đồng ý với các <i>điều khoản </i>và <em>chính sách</em> của Uplive.",
        "确认": "Xác nhận",
        "确认退出Up直播？": "Bạn muốn thoát khỏi Uplive ?",
        "系统错误": "Lỗi hệ thống",
        "网络连接有误, 请稍后再试": "Mạng lỗi, xin thử lại sau",
        "获取用户信息失败, 请稍后再试": "Truy cập thông tin user thất bại, thử lại sau",
        "请稍侯，正在登录中...": "Đang đăng nhập...",
        "请输入手机号码": "Nhập số điện thoại",
        "请输入登录密码": "Hãy nhập mật khẩu đăng nhập",
        "选择国家或地区": "Tỉnh/Thành phố"
    },
    "zhcn": {
        "AD": "安道尔",
        "AE": "阿拉伯联合酋长国",
        "AF": "阿富汗",
        "AG": "安提瓜和巴布达",
        "AI": "安圭拉",
        "AL": "阿尔巴尼亚",
        "AM": "亚美尼亚",
        "AN": "荷属安的列斯",
        "AO": "安哥拉",
        "AQ": "南极洲",
        "AR": "阿根廷",
        "AS": "美属萨摩亚",
        "AT": "奥地利",
        "AU": "澳大利亚",
        "AW": "阿鲁巴",
        "AZ": "阿塞拜疆",
        "BA": "波斯尼亚和黑塞哥维那",
        "BB": "巴巴多斯",
        "BD": "孟加拉国",
        "BE": "比利时",
        "BF": "布基纳法索",
        "BG": "保加利亚",
        "BH": "巴林",
        "BI": "布隆迪",
        "BJ": "贝宁",
        "BL": "圣巴泰勒米",
        "BM": "百慕大",
        "BN": "文莱",
        "BO": "玻利维亚",
        "BR": "巴西",
        "BS": "巴哈马",
        "BT": "不丹",
        "BW": "博茨瓦纳",
        "BY": "白俄罗斯",
        "BZ": "伯利兹",
        "CA": "加拿大",
        "CC": "科科斯群岛",
        "CD": "刚果民主共和国",
        "CF": "中非共和国",
        "CG": "刚果民主共和国",
        "CH": "瑞士",
        "CI": "象牙海岸",
        "CK": "库克群岛",
        "CL": "智利",
        "CM": "喀麦隆",
        "CN": "中国",
        "CO": "哥伦比亚",
        "CR": "哥斯达黎加",
        "CU": "古巴",
        "CV": "佛得角",
        "CW": "库拉索",
        "CX": "圣诞岛",
        "CY": "塞浦路斯",
        "CZ": "捷克共和国",
        "DE": "德国",
        "DJ": "吉布提",
        "DK": "丹麦",
        "DM": "多米尼加",
        "DO": "多明尼加共和国",
        "DZ": "阿尔及利亚",
        "EC": "厄瓜多尔",
        "EE": "爱沙尼亚",
        "EG": "埃及",
        "EH": "西撒哈拉",
        "ER": "厄立特里亚",
        "ES": "西班牙",
        "ET": "埃塞俄比亚",
        "FI": "芬兰",
        "FJ": "斐",
        "FK": "福克兰群岛",
        "FM": "密克罗尼西亚",
        "FO": "法罗群岛",
        "FR": "法国",
        "GA": "加蓬",
        "GB": "英国",
        "GD": "格林纳达",
        "GE": "格鲁吉亚",
        "GG": "根西岛",
        "GH": "加纳",
        "GI": "直布罗陀",
        "GL": "格陵兰",
        "GM": "冈比亚",
        "GN": "几内亚",
        "GQ": "赤道几内亚",
        "GR": "希腊",
        "GT": "危地马拉",
        "GU": "关岛",
        "GW": "几内亚比绍",
        "GY": "圭亚那",
        "HK": "香港",
        "HN": "洪都拉斯",
        "HR": "克罗地亚",
        "HT": "海地",
        "HU": "匈牙利",
        "ID": "印度尼西亚",
        "IE": "爱尔兰",
        "IL": "以色列",
        "IM": "马恩岛",
        "IN": "印度",
        "IO": "英属印度洋领地",
        "IQ": "伊拉克",
        "IR": "伊朗",
        "IS": "冰岛",
        "IT": "意大利",
        "JE": "新泽西",
        "JM": "牙买加",
        "JO": "约旦",
        "JP": "日本",
        "KE": "肯尼亚",
        "KG": "吉尔吉斯斯坦",
        "KH": "柬埔寨",
        "KI": "基里巴斯",
        "KM": "科摩罗",
        "KN": "圣基茨和尼维斯",
        "KP": "北朝鲜",
        "KR": "韩国",
        "KW": "科威特",
        "KY": "开曼群岛",
        "KZ": "哈萨克斯坦",
        "LA": "老挝",
        "LB": "黎巴嫩",
        "LC": "圣卢西亚",
        "LI": "列支敦士登",
        "LK": "斯里兰卡",
        "LR": "利比里亚",
        "LS": "莱索托",
        "LT": "立陶宛",
        "LU": "卢森堡",
        "LV": "拉脱维亚",
        "LY": "利比亚",
        "MA": "摩洛哥",
        "MC": "摩纳哥",
        "MD": "摩尔多瓦",
        "ME": "黑山",
        "MF": "圣马丁",
        "MG": "马达加斯加",
        "MH": "马绍尔群岛",
        "MK": "马其顿",
        "ML": "马里",
        "MM": "缅甸",
        "MN": "蒙古",
        "MO": "澳门",
        "MP": "北马里亚纳群岛",
        "MR": "毛里塔尼亚",
        "MS": "蒙特塞拉特",
        "MT": "马耳他",
        "MU": "毛里求斯",
        "MV": "马尔代夫",
        "MW": "马拉维",
        "MX": "墨西哥",
        "MY": "马来西亚",
        "MZ": "莫桑比克",
        "NA": "纳米比亚",
        "NC": "新喀里多尼亚",
        "NE": "尼日尔",
        "NG": "尼日利亚",
        "NI": "尼加拉瓜",
        "NL": "荷兰",
        "NO": "挪威",
        "NP": "尼泊尔",
        "NR": "瑙鲁",
        "NU": "纽埃",
        "NZ": "新西兰",
        "OM": "阿曼",
        "PA": "巴拿马",
        "PE": "秘鲁",
        "PF": "法属波利尼西亚",
        "PG": "巴布亚新几内亚",
        "PH": "菲律宾",
        "PK": "巴基斯坦",
        "PL": "波兰",
        "PM": "圣皮埃尔和密克隆",
        "PN": "皮特凯恩",
        "PR": "波多黎各",
        "PS": "巴勒斯坦",
        "PT": "葡萄牙",
        "PW": "帕劳",
        "PY": "巴拉圭",
        "QA": "卡塔尔",
        "RE": "团圆",
        "RO": "罗马尼亚",
        "RS": "塞尔维亚",
        "RU": "俄国",
        "RW": "卢旺达",
        "SA": "沙特阿拉伯",
        "SB": "所罗门群岛",
        "SC": "塞舌尔",
        "SD": "苏丹",
        "SE": "瑞典",
        "SG": "新加坡",
        "SH": "圣赫勒拿",
        "SI": "斯洛文尼亚",
        "SJ": "斯瓦尔巴特",
        "SK": "斯洛伐克",
        "SL": "塞拉利昂",
        "SM": "圣马力诺",
        "SN": "塞内加尔",
        "SO": "索马里",
        "SR": "苏里南",
        "SS": "南苏丹",
        "ST": "圣多美和普林西比",
        "SV": "萨尔瓦多",
        "SX": "圣马丁岛",
        "SY": "叙利亚",
        "SZ": "斯威士兰",
        "TC": "特克斯和凯科斯群岛",
        "TD": "乍得",
        "TG": "多哥",
        "TH": "泰国",
        "TJ": "塔吉克斯坦",
        "TK": "托克劳",
        "TL": "东帝汶",
        "TM": "土库曼斯坦",
        "TN": "突尼斯",
        "TO": "汤加",
        "TR": "土耳其",
        "TT": "特立尼达和多巴哥",
        "TV": "图瓦卢",
        "TW": "台湾",
        "TZ": "坦桑尼亚",
        "UA": "乌克兰",
        "UG": "乌干达",
        "US": "美国",
        "UY": "乌拉圭",
        "UZ": "乌兹别克斯坦",
        "VA": "教廷",
        "VC": "圣文森特和格林纳丁斯",
        "VE": "委内瑞拉",
        "VG": "英属维尔京群岛",
        "VI": "美属维尔京群岛",
        "VN": "越南",
        "VU": "瓦努阿图",
        "WF": "瓦利斯和富图纳群岛",
        "WS": "萨摩亚",
        "XK": "科索沃",
        "YE": "也门",
        "YT": "马约特",
        "ZA": "南非",
        "ZM": "赞比亚",
        "ZW": "津巴布韦",
        "其他登录方式": "其他登录方式",
        "加载中": "加载中…",
        "参数错误": "参数错误",
        "取消": "取消",
        "国家/地区": "国家/地区",
        "打开Up直播<br/>扫一扫登录": "打开Uplive<br/>扫一扫登录",
        "提示": "提示",
        "搜索": "搜索",
        "正在加载": "正在加载",
        "正在登录": "正在登录",
        "正在退出...": "正在退出...",
        "登录": "登录",
        "登录代表你接受Up直播《服务条款及隐私政策》": "登录代表你接受Uplive《<i>服务条款</i>及<em>隐私政策</em>》",
        "确认": "确认",
        "确认退出Up直播？": "确认退出Uplive？",
        "系统错误": "系统错误",
        "网络连接有误, 请稍后再试": "网络连接有误, 请稍后再试",
        "获取用户信息失败, 请稍后再试": "获取用户信息失败, 请稍后再试",
        "请稍侯，正在登录中...": "请稍侯，正在登录中...",
        "请输入手机号码": "请输入手机号码",
        "请输入登录密码": "请输入登录密码",
        "选择国家或地区": "选择国家或地区"
    },
    "zhhk": {
        "AD": "安道​​爾",
        "AE": "阿拉伯聯合酋長國",
        "AF": "阿富汗",
        "AG": "安提瓜和巴布達",
        "AI": "安圭拉",
        "AL": "阿爾巴尼亞",
        "AM": "亞美尼亞",
        "AN": "荷屬安的列斯",
        "AO": "安哥拉",
        "AQ": "南極洲",
        "AR": "阿根廷",
        "AS": "美屬薩摩亞",
        "AT": "奧地利",
        "AU": "澳大利亞",
        "AW": "阿魯巴",
        "AZ": "阿塞拜疆",
        "BA": "波斯尼亞和黑塞哥維那",
        "BB": "巴巴多斯",
        "BD": "孟加拉國",
        "BE": "比利時",
        "BF": "布基納法索",
        "BG": "保加利亞",
        "BH": "巴林",
        "BI": "布隆迪",
        "BJ": "貝寧",
        "BL": "聖巴泰勒米",
        "BM": "百慕大",
        "BN": "文萊",
        "BO": "玻利維亞",
        "BR": "巴西",
        "BS": "巴哈馬",
        "BT": "不丹",
        "BW": "博茨瓦納",
        "BY": "白俄羅斯",
        "BZ": "伯利茲",
        "CA": "加拿大",
        "CC": "科科斯群島",
        "CD": "剛果民主共和國",
        "CF": "中非共和國",
        "CG": "剛果民主共和國",
        "CH": "瑞士",
        "CI": "象牙海岸",
        "CK": "庫克群島",
        "CL": "智利",
        "CM": "喀麥隆",
        "CN": "中國",
        "CO": "哥倫比亞",
        "CR": "哥斯達黎加",
        "CU": "古巴",
        "CV": "佛得角",
        "CW": "庫拉索",
        "CX": "聖誕島",
        "CY": "塞浦路斯",
        "CZ": "捷克共和國",
        "DE": "德國",
        "DJ": "吉布提",
        "DK": "丹麥",
        "DM": "多米尼加",
        "DO": "多明尼加共和國",
        "DZ": "阿爾及利亞",
        "EC": "厄瓜多爾",
        "EE": "愛沙尼亞",
        "EG": "埃及",
        "EH": "西撒哈拉",
        "ER": "厄立特里亞",
        "ES": "西班牙",
        "ET": "埃塞俄比亞",
        "FI": "芬蘭",
        "FJ": "斐",
        "FK": "福克蘭群島",
        "FM": "密克羅尼西亞",
        "FO": "法羅群島",
        "FR": "法國",
        "GA": "加蓬",
        "GB": "英國",
        "GD": "格林納達",
        "GE": "格魯吉亞",
        "GG": "根西島",
        "GH": "加納",
        "GI": "直布羅陀",
        "GL": "格陵蘭",
        "GM": "岡比亞",
        "GN": "幾內亞",
        "GQ": "赤道幾內亞",
        "GR": "希臘",
        "GT": "危地馬拉",
        "GU": "關島",
        "GW": "幾內亞比紹",
        "GY": "圭亞那",
        "HK": "香港",
        "HN": "洪都拉斯",
        "HR": "克羅地亞",
        "HT": "海地",
        "HU": "匈牙利",
        "ID": "印度尼西亞",
        "IE": "愛爾蘭",
        "IL": "以色列",
        "IM": "馬恩島",
        "IN": "印度",
        "IO": "英屬印度洋領地",
        "IQ": "伊拉克",
        "IR": "伊朗",
        "IS": "冰島",
        "IT": "意大利",
        "JE": "新澤西",
        "JM": "牙買加",
        "JO": "約旦",
        "JP": "日本",
        "KE": "肯尼亞",
        "KG": "吉爾吉斯斯坦",
        "KH": "柬埔寨",
        "KI": "基里巴斯",
        "KM": "科摩羅",
        "KN": "聖基茨和尼維斯",
        "KP": "北朝鮮",
        "KR": "韓國",
        "KW": "科威特",
        "KY": "開曼群島",
        "KZ": "哈薩克斯坦",
        "LA": "老撾",
        "LB": "黎巴嫩",
        "LC": "聖盧西亞",
        "LI": "列支敦士登",
        "LK": "斯里蘭卡",
        "LR": "利比里亞",
        "LS": "萊索托",
        "LT": "立陶宛",
        "LU": "盧森堡",
        "LV": "拉脫維亞",
        "LY": "利比亞",
        "MA": "摩洛哥",
        "MC": "摩納哥",
        "MD": "摩爾多瓦",
        "ME": "黑山",
        "MF": "聖馬丁",
        "MG": "馬達加斯加",
        "MH": "馬紹爾群島",
        "MK": "馬其頓",
        "ML": "馬里",
        "MM": "緬甸",
        "MN": "蒙古",
        "MO": "澳門",
        "MP": "北馬里亞納群島",
        "MR": "毛里塔尼亞",
        "MS": "蒙特塞拉特",
        "MT": "馬耳他",
        "MU": "毛里求斯",
        "MV": "馬爾代夫",
        "MW": "馬拉維",
        "MX": "墨西哥",
        "MY": "馬來西亞",
        "MZ": "莫桑比克",
        "NA": "納米比亞",
        "NC": "新喀裡多尼亞",
        "NE": "尼日爾",
        "NG": "尼日利亞",
        "NI": "尼加拉瓜",
        "NL": "荷蘭",
        "NO": "挪威",
        "NP": "尼泊爾",
        "NR": "瑙魯",
        "NU": "紐埃",
        "NZ": "新西蘭",
        "OM": "阿曼",
        "PA": "巴拿馬",
        "PE": "秘魯",
        "PF": "法屬波利尼西亞",
        "PG": "巴布亞新幾內亞",
        "PH": "菲律賓",
        "PK": "巴基斯坦",
        "PL": "波蘭",
        "PM": "聖皮埃爾和密克隆",
        "PN": "皮特凱恩",
        "PR": "波多黎各",
        "PS": "巴勒斯坦",
        "PT": "葡萄牙",
        "PW": "帕勞",
        "PY": "巴拉圭",
        "QA": "卡塔爾",
        "RE": "團圓",
        "RO": "羅馬尼亞",
        "RS": "塞爾維亞",
        "RU": "俄國",
        "RW": "盧旺達",
        "SA": "沙特阿拉伯",
        "SB": "所羅門群島",
        "SC": "塞舌爾",
        "SD": "蘇丹",
        "SE": "瑞典",
        "SG": "新加坡",
        "SH": "聖赫勒拿",
        "SI": "斯洛文尼亞",
        "SJ": "斯瓦爾巴特",
        "SK": "斯洛伐克",
        "SL": "塞拉利昂",
        "SM": "聖馬力諾",
        "SN": "塞內加爾",
        "SO": "索馬里",
        "SR": "蘇里南",
        "SS": "南蘇丹",
        "ST": "聖多美和普林西比",
        "SV": "薩爾瓦多",
        "SX": "聖馬丁島",
        "SY": "敘利亞",
        "SZ": "斯威士蘭",
        "TC": "特克斯和凱科斯群島",
        "TD": "乍得",
        "TG": "多哥",
        "TH": "泰國",
        "TJ": "塔吉克斯坦",
        "TK": "托克勞",
        "TL": "東帝汶",
        "TM": "土庫曼斯坦",
        "TN": "突尼斯",
        "TO": "湯加",
        "TR": "土耳其",
        "TT": "特立尼達和多巴哥",
        "TV": "圖瓦盧",
        "TW": "台灣",
        "TZ": "坦桑尼亞",
        "UA": "烏克蘭",
        "UG": "烏干達",
        "US": "美國",
        "UY": "烏拉圭",
        "UZ": "烏茲別克斯坦",
        "VA": "教廷",
        "VC": "聖文森特和格林納丁斯",
        "VE": "委內瑞拉",
        "VG": "英屬維爾京群島",
        "VI": "美屬維爾京群島",
        "VN": "越南",
        "VU": "瓦努阿圖",
        "WF": "瓦利斯和富圖納群島",
        "WS": "薩摩亞",
        "XK": "科索沃",
        "YE": "也門",
        "YT": "馬約特",
        "ZA": "南非",
        "ZM": "贊比亞",
        "ZW": "津巴布韋",
        "其他登录方式": "其他登錄方式",
        "加载中": "載入中...",
        "参数错误": "參數錯誤",
        "取消": "取消",
        "国家/地区": "國家/地區",
        "打开Up直播<br/>扫一扫登录": "打開Up直播<br/>掃QR Code登錄",
        "提示": "提示",
        "搜索": "搜尋",
        "正在加载": "正在載入",
        "正在登录": "登入中",
        "正在退出...": "退出中...",
        "登录": "登入",
        "登录代表你接受Up直播《服务条款及隐私政策》": "登入即代表您接受Up直播《<i>服務條款</i>及<em>隱私政策</em>》",
        "确认": "確定",
        "确认退出Up直播？": "確定退出 Uplive？",
        "系统错误": "系統錯誤",
        "网络连接有误, 请稍后再试": "網絡環境異常，請稍候再試",
        "获取用户信息失败, 请稍后再试": "獲取用戶訊息失敗，請稍後再試",
        "请稍侯，正在登录中...": "請稍候，正在登入中...",
        "请输入手机号码": "使用手機號碼登錄",
        "请输入登录密码": "請輸入登入密碼",
        "选择国家或地区": "選擇國家或地區"
    },
    "zhtw": {
        "AD": "安道​​爾",
        "AE": "阿拉伯聯合酋長國",
        "AF": "阿富汗",
        "AG": "安提瓜和巴布達",
        "AI": "安圭拉",
        "AL": "阿爾巴尼亞",
        "AM": "亞美尼亞",
        "AN": "荷屬安的列斯",
        "AO": "安哥拉",
        "AQ": "南極洲",
        "AR": "阿根廷",
        "AS": "美屬薩摩亞",
        "AT": "奧地利",
        "AU": "澳大利亞",
        "AW": "阿魯巴",
        "AZ": "阿塞拜疆",
        "BA": "波斯尼亞和黑塞哥維那",
        "BB": "巴巴多斯",
        "BD": "孟加拉國",
        "BE": "比利時",
        "BF": "布基納法索",
        "BG": "保加利亞",
        "BH": "巴林",
        "BI": "布隆迪",
        "BJ": "貝寧",
        "BL": "聖巴泰勒米",
        "BM": "百慕大",
        "BN": "文萊",
        "BO": "玻利維亞",
        "BR": "巴西",
        "BS": "巴哈馬",
        "BT": "不丹",
        "BW": "博茨瓦納",
        "BY": "白俄羅斯",
        "BZ": "伯利茲",
        "CA": "加拿大",
        "CC": "科科斯群島",
        "CD": "剛果民主共和國",
        "CF": "中非共和國",
        "CG": "剛果民主共和國",
        "CH": "瑞士",
        "CI": "象牙海岸",
        "CK": "庫克群島",
        "CL": "智利",
        "CM": "喀麥隆",
        "CN": "中國",
        "CO": "哥倫比亞",
        "CR": "哥斯達黎加",
        "CU": "古巴",
        "CV": "佛得角",
        "CW": "庫拉索",
        "CX": "聖誕島",
        "CY": "塞浦路斯",
        "CZ": "捷克共和國",
        "DE": "德國",
        "DJ": "吉布提",
        "DK": "丹麥",
        "DM": "多米尼加",
        "DO": "多明尼加共和國",
        "DZ": "阿爾及利亞",
        "EC": "厄瓜多爾",
        "EE": "愛沙尼亞",
        "EG": "埃及",
        "EH": "西撒哈拉",
        "ER": "厄立特里亞",
        "ES": "西班牙",
        "ET": "埃塞俄比亞",
        "FI": "芬蘭",
        "FJ": "斐",
        "FK": "福克蘭群島",
        "FM": "密克羅尼西亞",
        "FO": "法羅群島",
        "FR": "法國",
        "GA": "加蓬",
        "GB": "英國",
        "GD": "格林納達",
        "GE": "格魯吉亞",
        "GG": "根西島",
        "GH": "加納",
        "GI": "直布羅陀",
        "GL": "格陵蘭",
        "GM": "岡比亞",
        "GN": "幾內亞",
        "GQ": "赤道幾內亞",
        "GR": "希臘",
        "GT": "危地馬拉",
        "GU": "關島",
        "GW": "幾內亞比紹",
        "GY": "圭亞那",
        "HK": "香港",
        "HN": "洪都拉斯",
        "HR": "克羅地亞",
        "HT": "海地",
        "HU": "匈牙利",
        "ID": "印度尼西亞",
        "IE": "愛爾蘭",
        "IL": "以色列",
        "IM": "馬恩島",
        "IN": "印度",
        "IO": "英屬印度洋領地",
        "IQ": "伊拉克",
        "IR": "伊朗",
        "IS": "冰島",
        "IT": "意大利",
        "JE": "新澤西",
        "JM": "牙買加",
        "JO": "約旦",
        "JP": "日本",
        "KE": "肯尼亞",
        "KG": "吉爾吉斯斯坦",
        "KH": "柬埔寨",
        "KI": "基里巴斯",
        "KM": "科摩羅",
        "KN": "聖基茨和尼維斯",
        "KP": "北朝鮮",
        "KR": "韓國",
        "KW": "科威特",
        "KY": "開曼群島",
        "KZ": "哈薩克斯坦",
        "LA": "老撾",
        "LB": "黎巴嫩",
        "LC": "聖盧西亞",
        "LI": "列支敦士登",
        "LK": "斯里蘭卡",
        "LR": "利比里亞",
        "LS": "萊索托",
        "LT": "立陶宛",
        "LU": "盧森堡",
        "LV": "拉脫維亞",
        "LY": "利比亞",
        "MA": "摩洛哥",
        "MC": "摩納哥",
        "MD": "摩爾多瓦",
        "ME": "黑山",
        "MF": "聖馬丁",
        "MG": "馬達加斯加",
        "MH": "馬紹爾群島",
        "MK": "馬其頓",
        "ML": "馬里",
        "MM": "緬甸",
        "MN": "蒙古",
        "MO": "澳門",
        "MP": "北馬里亞納群島",
        "MR": "毛里塔尼亞",
        "MS": "蒙特塞拉特",
        "MT": "馬耳他",
        "MU": "毛里求斯",
        "MV": "馬爾代夫",
        "MW": "馬拉維",
        "MX": "墨西哥",
        "MY": "馬來西亞",
        "MZ": "莫桑比克",
        "NA": "納米比亞",
        "NC": "新喀裡多尼亞",
        "NE": "尼日爾",
        "NG": "尼日利亞",
        "NI": "尼加拉瓜",
        "NL": "荷蘭",
        "NO": "挪威",
        "NP": "尼泊爾",
        "NR": "瑙魯",
        "NU": "紐埃",
        "NZ": "新西蘭",
        "OM": "阿曼",
        "PA": "巴拿馬",
        "PE": "秘魯",
        "PF": "法屬波利尼西亞",
        "PG": "巴布亞新幾內亞",
        "PH": "菲律賓",
        "PK": "巴基斯坦",
        "PL": "波蘭",
        "PM": "聖皮埃爾和密克隆",
        "PN": "皮特凱恩",
        "PR": "波多黎各",
        "PS": "巴勒斯坦",
        "PT": "葡萄牙",
        "PW": "帕勞",
        "PY": "巴拉圭",
        "QA": "卡塔爾",
        "RE": "團圓",
        "RO": "羅馬尼亞",
        "RS": "塞爾維亞",
        "RU": "俄國",
        "RW": "盧旺達",
        "SA": "沙特阿拉伯",
        "SB": "所羅門群島",
        "SC": "塞舌爾",
        "SD": "蘇丹",
        "SE": "瑞典",
        "SG": "新加坡",
        "SH": "聖赫勒拿",
        "SI": "斯洛文尼亞",
        "SJ": "斯瓦爾巴特",
        "SK": "斯洛伐克",
        "SL": "塞拉利昂",
        "SM": "聖馬力諾",
        "SN": "塞內加爾",
        "SO": "索馬里",
        "SR": "蘇里南",
        "SS": "南蘇丹",
        "ST": "聖多美和普林西比",
        "SV": "薩爾瓦多",
        "SX": "聖馬丁島",
        "SY": "敘利亞",
        "SZ": "斯威士蘭",
        "TC": "特克斯和凱科斯群島",
        "TD": "乍得",
        "TG": "多哥",
        "TH": "泰國",
        "TJ": "塔吉克斯坦",
        "TK": "托克勞",
        "TL": "東帝汶",
        "TM": "土庫曼斯坦",
        "TN": "突尼斯",
        "TO": "湯加",
        "TR": "土耳其",
        "TT": "特立尼達和多巴哥",
        "TV": "圖瓦盧",
        "TW": "台灣",
        "TZ": "坦桑尼亞",
        "UA": "烏克蘭",
        "UG": "烏干達",
        "US": "美國",
        "UY": "烏拉圭",
        "UZ": "烏茲別克斯坦",
        "VA": "教廷",
        "VC": "聖文森特和格林納丁斯",
        "VE": "委內瑞拉",
        "VG": "英屬維爾京群島",
        "VI": "美屬維爾京群島",
        "VN": "越南",
        "VU": "瓦努阿圖",
        "WF": "瓦利斯和富圖納群島",
        "WS": "薩摩亞",
        "XK": "科索沃",
        "YE": "也門",
        "YT": "馬約特",
        "ZA": "南非",
        "ZM": "贊比亞",
        "ZW": "津巴布韋",
        "其他登录方式": "其他登入方式",
        "加载中": "載入中...",
        "参数错误": "參數錯誤",
        "取消": "取消",
        "国家/地区": "國家/地區",
        "打开Up直播<br/>扫一扫登录": "打開Up直播<br/>掃一掃登入",
        "提示": "提示",
        "搜索": "搜尋",
        "正在加载": "正在載入",
        "正在登录": "登入中",
        "正在退出...": "退出中...",
        "登录": "登入",
        "登录代表你接受Up直播《服务条款及隐私政策》": "登入即代表您接受Up直播《<i>服務條款</i>及<em>隱私政策</em>》",
        "确认": "確定",
        "确认退出Up直播？": "掰，咱們回頭見！",
        "系统错误": "系統錯誤",
        "网络连接有误, 请稍后再试": "網絡環境異常，請稍候再試",
        "获取用户信息失败, 请稍后再试": "獲取用戶訊息失敗，請稍後再試",
        "请稍侯，正在登录中...": "請稍候，正在登入中...",
        "请输入手机号码": "使用手機號碼登錄",
        "请输入登录密码": "請輸入登入密碼",
        "选择国家或地区": "選擇國家或地區"
    }
};

/***/ }),
/* 78 */
/***/ (function(module, exports) {

/**
 * H5与native协议 js文件
 */
(function (win, lib) {

    win.UpH5Native = win.UpH5Native || {};

    var apiStatus = {};
    var iframe = null;
    var urlPrefixCallAppInAndroid = 'uplivecn://goWindow'; // android调用外部协议
    var urlPrefixCallAppInIos = 'https://ios.upliveapps.com/goWindow'; // ios调用外部协议

    var native = {
        send: function send(url) {
            if (!iframe) {
                iframe = document.createElement('iframe');
                iframe.id = 'up_callapp_iframe_' + Date.now();
                iframe.frameborder = '0';
                iframe.style.cssText = 'display:none;border:0;width:0;height:0;';
                document.body.appendChild(iframe);
            }
            iframe.src = url;
        },
        sendUriScheme: function sendUriScheme(url) {
            window.location.href = url;
        },

        // 获得平台类型
        // weixin, weibo, qq, uplive，海外版本Android在URL Hash中添加标识 #pl=uplive
        getPlatform: function getPlatform() {
            var _ref = [navigator.userAgent, 'other'],
                ua = _ref[0],
                pl = _ref[1];


            if (ua.match(/uplive/i) || Uplib.url.query('pl', 'hash') == 'uplive') {
                pl = 'uplive';
            } else if (ua.match(/micromessenger/i)) {
                pl = 'wechat';
            } else if (ua.match(/qq/i)) {
                pl = 'qq';
            } else if (ua.match(/weibo/i)) {
                pl = 'weibo';
            } else if (ua.match(/renren/i)) {
                pl = 'renren';
            } else if (ua.indexOf("FBAN") > -1 || ua.indexOf("FBAV") > -1) {
                pl = 'fb';
            } else if (ua.match(/Line/i)) {
                pl = 'line';
            }

            return pl;
        },

        // 获得当前系统类型
        getSystem: function getSystem() {
            var ua = navigator.userAgent;
            return (/(iPhone|iPad|iPod|iOS)/i.test(ua) ? 'ios' : /[aA]ndroid/i.test(ua) ? 'android' : 'pc'
            );
        },


        // 系统语言
        getLanguage: function getLanguage() {
            var language = navigator.language || navigator.browserLanguage;

            if (language) {
                var arr = language.split('-');
                arr[1] = arr[1].toUpperCase();
                language = arr.join('-');
            }

            return language;
        },


        // 检查api是否可用
        checkAvail: function checkAvail() {
            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                apiname = _ref2.apiname,
                errtip = _ref2.errtip;

            setTimeout(function () {
                if (!apiStatus[apiname] && errtip) {
                    if (typeof errtip == 'function') {
                        errtip();
                    } else {
                        alert(errtip);
                    }
                }
            }, 3000);
        },


        /**
         * 获取配置信息
         * @param cfg {
         *      invalid 0 usertoken失效；1第一次获取
         *      complete: function(){}
         * }
         * 
         */
        getConfigs: function getConfigs() {
            var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref3$complete = _ref3.complete,
                complete = _ref3$complete === undefined ? function () {} : _ref3$complete,
                _ref3$invalid = _ref3.invalid,
                invalid = _ref3$invalid === undefined ? 0 : _ref3$invalid,
                _ref3$errtip = _ref3.errtip,
                errtip = _ref3$errtip === undefined ? '不支持' : _ref3$errtip;

            var self = this;
            var url = 'uplive://getConfigs?json=';
            var params = {
                invalid: invalid,
                receive: "UpH5Native['upliveapp_getConfigs']",
                jsCallback: 'UpH5Native.getConfigsComplete'
            };

            UpH5Native.getConfigsComplete = function (param) {
                // usertoken: "", uid: "", language: ""
                complete.call(self, JSON.parse(param));
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'getConfigs',
                errtip: errtip
            });
        },


        /**
         * 获取主播信息
         * @param cfg {
         *      complete: function(){}
         * }
         * 
         */
        getHostInfo: function getHostInfo() {
            var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref4$complete = _ref4.complete,
                complete = _ref4$complete === undefined ? function () {} : _ref4$complete,
                _ref4$errtip = _ref4.errtip,
                errtip = _ref4$errtip === undefined ? '不支持' : _ref4$errtip;

            var self = this;
            var url = 'uplive://getHostInfo?json=';
            var params = {
                receive: "UpH5Native['upliveapp_getHostInfo']",
                jsCallback: 'UpH5Native.getHostInfoComplete'
            };

            UpH5Native.getHostInfoComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'getHostInfo',
                errtip: errtip
            });
        },


        // 上报提现结果给客户端
        acceptAgreement: function acceptAgreement() {
            var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref5$errtip = _ref5.errtip,
                errtip = _ref5$errtip === undefined ? '不支持' : _ref5$errtip;

            var url = 'uplive://acceptAgreement?json=';
            var params = {
                receive: "UpH5Native['upliveapp_acceptAgreement']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'acceptAgreement',
                errtip: errtip
            });
        },

        /**
         * 跳转个人主页
         * @param cfg {
         *      uid: 10234, // {Number} 整型
         * }
         */
        profile: function profile() {
            var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref6$uid = _ref6.uid,
                uid = _ref6$uid === undefined ? 0 : _ref6$uid,
                _ref6$errtip = _ref6.errtip,
                errtip = _ref6$errtip === undefined ? '' : _ref6$errtip;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'profile',
                extend: {
                    uid: parseInt(uid, 10)
                },
                receive: "UpH5Native['upliveapp_profile']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'profile',
                errtip: errtip
            });
        },

        /**
         * 跳转到直播间
         * @param cfg {
         *      uid: 10234, // {Number} 整型
         *      roomid: 10234 {Number} 整型
         * }
         */
        goRoom: function goRoom() {
            var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref7$uid = _ref7.uid,
                uid = _ref7$uid === undefined ? 0 : _ref7$uid,
                _ref7$roomid = _ref7.roomid,
                roomid = _ref7$roomid === undefined ? 0 : _ref7$roomid,
                _ref7$errtip = _ref7.errtip,
                errtip = _ref7$errtip === undefined ? '' : _ref7$errtip;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'room',
                extend: {
                    uid: parseInt(uid, 10),
                    roomid: parseInt(roomid, 10)
                },
                receive: "UpH5Native['upliveapp_goRoom']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'goRoom',
                errtip: errtip
            });
        },
        goRank: function goRank() {
            var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref8$name = _ref8.name,
                name = _ref8$name === undefined ? 1 : _ref8$name,
                _ref8$errtip = _ref8.errtip,
                errtip = _ref8$errtip === undefined ? '' : _ref8$errtip;

            var url = 'uplive://goWindow?json=';
            var key = void 0;

            switch (parseInt(name, 10)) {
                case 1:
                    key = 'starank';
                    break;
                case 2:
                    key = 'hostrank';
                    break;
                case 3:
                    key = 'wealthrank';
                    break;
                default:
                    key = 'starank';
            }

            var params = {
                key: key,
                receive: "UpH5Native['upliveapp_goRank']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'goRank',
                errtip: errtip
            });
        },


        // 跳转充值界面
        gopay: function gopay() {
            var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref9$errtip = _ref9.errtip,
                errtip = _ref9$errtip === undefined ? '' : _ref9$errtip,
                _ref9$complete = _ref9.complete,
                complete = _ref9$complete === undefined ? function () {} : _ref9$complete;

            var self = this;
            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'pay',
                receive: "UpH5Native['upliveapp_gopay']",
                jsCallback: "UpH5Native['getGopayComplete']"
            };

            UpH5Native.getGopayComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'gopay',
                errtip: errtip
            });
        },


        // 上报提现结果给客户端
        reportCashResult: function reportCashResult() {
            var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref10$success = _ref10.success,
                success = _ref10$success === undefined ? 1 : _ref10$success,
                errtip = _ref10.errtip;

            var url = 'uplive://h5cash?json=';
            var params = {
                success: success,
                receive: "UpH5Native['upliveapp_reportCashResult']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'reportCashResult',
                errtip: errtip
            });
        },


        // 上报充值结果给客户端
        reportPayResult: function reportPayResult() {
            var _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref11$success = _ref11.success,
                success = _ref11$success === undefined ? 1 : _ref11$success,
                errtip = _ref11.errtip;

            var url = 'uplive://h5payment?json=';
            var params = {
                success: success,
                receive: "UpH5Native['upliveapp_reportPayResult']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'reportPayResult',
                errtip: errtip
            });
        },


        // 关闭webview
        closeWindow: function closeWindow() {
            var _ref12 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref12$errtip = _ref12.errtip,
                errtip = _ref12$errtip === undefined ? '' : _ref12$errtip;

            var url = 'uplive://closeWindow?json=';
            var params = {
                receive: "UpH5Native['upliveapp_closeWindow']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'closeWindow',
                errtip: errtip
            });
        },


        // 浏览器中打开
        openBrowser: function openBrowser() {
            var _ref13 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref13$url = _ref13.url,
                url = _ref13$url === undefined ? '' : _ref13$url,
                _ref13$errtip = _ref13.errtip,
                errtip = _ref13$errtip === undefined ? '' : _ref13$errtip;

            var _url = 'uplive://openBrowser?json=';
            var params = {
                receive: "UpH5Native['upliveapp_openBrowser']",
                url: url
            };

            this.send(_url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'openBrowser',
                errtip: errtip
            });
        },


        /**
         * 支付调用
         * @param data {object}
         *      - platform 支付平台
         *      - complete {function} 
         *      - params 参数
         * @return this
         */
        pay: function pay() {
            var _ref14 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref14$complete = _ref14.complete,
                complete = _ref14$complete === undefined ? function () {} : _ref14$complete,
                _ref14$platform = _ref14.platform,
                platform = _ref14$platform === undefined ? 'wxpay' : _ref14$platform,
                _ref14$productId = _ref14.productId,
                productId = _ref14$productId === undefined ? '' : _ref14$productId,
                _ref14$errtip = _ref14.errtip,
                errtip = _ref14$errtip === undefined ? '不支持支付' : _ref14$errtip;

            var self = this;
            var _url = 'uplive://payment?json=';
            var _params = {
                receive: "UpH5Native['upliveapp_pay']",
                platform: platform || 'wxpay',
                params: {
                    productId: productId
                },
                jsCallback: 'UpH5Native.payComplete'
            };

            UpH5Native.payComplete = function (param) {
                // 支付
                complete.call(self, JSON.parse(param));
            };

            this.send(_url + JSON.stringify(_params));
            this.checkAvail({
                apiname: 'pay',
                errtip: errtip
            });
        },


        // 客户端分享
        share: function share() {
            var _ref15 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref15$complete = _ref15.complete,
                complete = _ref15$complete === undefined ? function () {} : _ref15$complete,
                _ref15$title = _ref15.title,
                title = _ref15$title === undefined ? '分享标题' : _ref15$title,
                _ref15$url = _ref15.url,
                url = _ref15$url === undefined ? 'http://www.baidu.com' : _ref15$url,
                _ref15$imageUrl = _ref15.imageUrl,
                imageUrl = _ref15$imageUrl === undefined ? 'https://m.baidu.com/static/index/plus/plus_logo.png' : _ref15$imageUrl,
                _ref15$desc = _ref15.desc,
                desc = _ref15$desc === undefined ? '分享表述' : _ref15$desc,
                _ref15$platform = _ref15.platform,
                platform = _ref15$platform === undefined ? {} : _ref15$platform,
                _ref15$errtip = _ref15.errtip,
                errtip = _ref15$errtip === undefined ? '客户端不支持分享' : _ref15$errtip;

            var self = this;
            var _url = 'uplive://sharePage?json=';
            var pls = ['qq', 'qzone', 'wechat_friends', 'wechat_circle', 'sina', 'fb', 'tw'];
            var oauthtype = { 'fb': 'fb', 'tw': 'twitter', 'sina': 'weibo' };

            var params = {
                receive: "UpH5Native['upliveapp_share']",
                platform: {},
                jsCallback: 'UpH5Native.upliveShareComplete'
            };

            pls.forEach(function (item, i) {
                params.platform[item] = {
                    url: url,
                    title: title,
                    imageUrl: imageUrl,
                    desc: desc
                };
            });

            if (JSON.stringify(platform) != '{}') {
                params = Object.assign(true, params, {
                    platform: platform
                });
            }

            for (var i in params) {
                if (i == 'platform') {
                    for (var j in params[i]) {
                        for (var k in params[i][j]) {
                            if (k == 'title' || k == 'desc') {
                                params[i][j][k] = encodeURIComponent(params[i][j][k]);
                            }
                            if (k == 'url' && params[i][j][k] && oauthtype[j]) {
                                var _url2 = params[i][j][k];

                                params[i][j][k] = Uplib.url.addParam(_url2, {
                                    oauthtype: oauthtype[j]
                                });
                            }
                        }
                    }
                }
            }

            UpH5Native.upliveShareComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };
            this.send(_url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'share',
                errtip: errtip
            });
        },


        // 单渠道分享
        singleShare: function singleShare() {
            var _ref16 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref16$complete = _ref16.complete,
                complete = _ref16$complete === undefined ? function () {} : _ref16$complete,
                _ref16$title = _ref16.title,
                title = _ref16$title === undefined ? '分享标题' : _ref16$title,
                _ref16$url = _ref16.url,
                url = _ref16$url === undefined ? 'http://www.baidu.com' : _ref16$url,
                _ref16$imageUrl = _ref16.imageUrl,
                imageUrl = _ref16$imageUrl === undefined ? 'https://m.baidu.com/static/index/plus/plus_logo.png' : _ref16$imageUrl,
                _ref16$desc = _ref16.desc,
                desc = _ref16$desc === undefined ? '分享表述' : _ref16$desc,
                _ref16$type = _ref16.type,
                type = _ref16$type === undefined ? 'fb' : _ref16$type,
                _ref16$errtip = _ref16.errtip,
                errtip = _ref16$errtip === undefined ? '客户端不支持分享' : _ref16$errtip;

            var self = this;
            var system = this.getSystem();
            var _url = 'uplive://singleShare?json=';
            var pls = ['qq', 'qzone', 'wechat_friends', 'wechat_circle', 'sina', 'fb', 'tw'];
            var oauthtype = { 'fb': 'fb', 'tw': 'twitter', 'sina': 'weibo' };

            if (url && oauthtype[type]) {
                url = Uplib.url.addParam(url, {
                    oauthtype: oauthtype[type]
                });
            }
            if (type == 'sina') {
                desc += '>>' + url;
            }
            var params = {
                receive: "UpH5Native['upliveapp_singleShare']",
                platform: {
                    url: url,
                    title: system == 'ios' ? title : encodeURIComponent(title),
                    imageUrl: imageUrl,
                    desc: system == 'ios' ? desc : encodeURIComponent(desc)
                },
                type: type,
                jsCallback: 'UpH5Native.upliveSingleShareComplete'
            };

            UpH5Native.upliveSingleShareComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };

            this.send(_url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'singleShare',
                errtip: errtip
            });
        },


        // 游客登录
        login: function login() {
            var _ref17 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref17$complete = _ref17.complete,
                complete = _ref17$complete === undefined ? function () {} : _ref17$complete,
                _ref17$errtip = _ref17.errtip,
                errtip = _ref17$errtip === undefined ? '不支持登录' : _ref17$errtip;

            var self = this;
            var url = 'uplive://goLogin?json=';
            var params = {
                receive: "UpH5Native['upliveapp_login']",
                jsCallback: 'UpH5Native.loginComplete'
            };
            UpH5Native.loginComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };
            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'login',
                errtip: errtip
            });
        },


        // 刷新用户信息
        refreshProfile: function refreshProfile() {
            var _ref18 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref18$errtip = _ref18.errtip,
                errtip = _ref18$errtip === undefined ? '不支持刷新用户信息' : _ref18$errtip;

            var url = 'uplive://refreshProfile?json=';
            var params = {
                receive: "UpH5Native['upliveapp_refreshProfile']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'refreshProfile',
                errtip: errtip
            });
        },
        setTitle: function setTitle() {
            var _ref19 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref19$title = _ref19.title,
                title = _ref19$title === undefined ? '' : _ref19$title,
                _ref19$errtip = _ref19.errtip,
                errtip = _ref19$errtip === undefined ? function () {} : _ref19$errtip;

            var self = this;
            var _url = 'uplive://setTitle?json=';
            var _params = {
                receive: "UpH5Native['upliveapp_setTitle']",
                params: {
                    title: title
                }
            };

            this.send(_url + JSON.stringify(_params));
            this.checkAvail({
                apiname: 'setTitle',
                errtip: errtip
            });
        },
        goCashRecord: function goCashRecord() {
            var _ref20 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref20$errtip = _ref20.errtip,
                errtip = _ref20$errtip === undefined ? '不支持领取纪录' : _ref20$errtip;

            var url = 'uplive://goCashRecord?json=';
            var params = {
                receive: "UpH5Native['upliveapp_goCashRecord']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'goCashRecord',
                errtip: errtip
            });
        },
        bindMobilePhone: function bindMobilePhone() {
            var _ref21 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref21$complete = _ref21.complete,
                complete = _ref21$complete === undefined ? function () {} : _ref21$complete,
                _ref21$errtip = _ref21.errtip,
                errtip = _ref21$errtip === undefined ? '不支持手机绑定' : _ref21$errtip;

            var self = this;
            var url = 'uplive://bindMobilePhone?json=';
            var params = {
                receive: "UpH5Native['upliveapp_bindMobilePhone']",
                jsCallback: 'UpH5Native.bindMobilePhoneComplete'
            };
            UpH5Native.bindMobilePhoneComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };
            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'bindMobilePhone',
                errtip: errtip
            });
        },
        bindWechat: function bindWechat() {
            var _ref22 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref22$complete = _ref22.complete,
                complete = _ref22$complete === undefined ? function () {} : _ref22$complete,
                _ref22$errtip = _ref22.errtip,
                errtip = _ref22$errtip === undefined ? '不支持微信绑定' : _ref22$errtip;

            var self = this;
            var url = 'uplive://bindWechat?json=';
            var params = {
                receive: "UpH5Native['upliveapp_bindWechat']",
                jsCallback: 'UpH5Native.bindWechatComplete'
            };
            UpH5Native.bindWechatComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };
            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'bindWechat',
                errtip: errtip
            });
        }
    };

    var _loop = function _loop(i) {
        UpH5Native['upliveapp_' + i] = function () {
            apiStatus[i] = 1;
        };
    };

    for (var i in native) {
        _loop(i);
    }

    lib.native = native;
})(window, window.Uplib || (window.Uplib = {}));

/***/ }),
/* 79 */
/***/ (function(module, exports) {

;(function (win, lib) {
    var doc = win.document,
        body = doc.body,
        E_float,
        E_floatMsg,
        E_floatContent,
        E_floatOk,
        E_floatCancel,
        initDom = false,
        flashTimeoutId,
        showTimeoutId,
        hideTimeoutId,
        E_mask;

    E_mask = doc.createElement('div');
    E_mask.className = 'c-float-mask hide';

    E_float = doc.createElement('div');
    E_float.className = 'c-float-popWrap msgMode hide';
    E_float.innerHTML = ['<style type="text/css">', '.c-float-modePop{text-align:center}.c-float-modePop .warnMsg{color:#fff}.c-float-modePop button{padding:0.1875rem 0.28125rem 0.1875rem 0.28125rem;color:#157afb;background:-webkit-gradient(linear,left top,left bottom,color-stop(0,#404040),color-stop(100%,#2e2e2e));border:none}.c-float-shade{width:100%;display:block;position:absolute;z-index:99;background-color:#000;opacity:.5;top:0;left:0}.c-float-mask{position:fixed;top:0;left:0;bottom:0;right:0;height:100%;width:100%;z-index:9998;background:rgba(0,0,0,.7);opacity:0;-webkit-transition:opacity .3s linear 0s}.c-float-shade.hide{display:none}.c-float-mask.hide{display:none}.c-float-popWrap{width:90%; border-radius:0.25rem;-webkit-border-radius:0.25rem;z-index:9999;position:fixed;overflow:hidden;left:50%;top:50%; margin-left: -45%; -webkit-transition:opacity .3s linear 0s}.c-float-popWrap .c-float-modePop{background-color:rgba(0,0,0,.7);-webkit-border-radius:0.25rem;border-radius:0.25rem;overflow:hidden;padding:0.3125rem;}.c-float-popWrap .c-float-modePop .warnMsg{padding:0;font-size:0.46875rem;line-height:0.5625rem;color:#fff;font-weight:400}.c-float-popWrap .c-float-modePop .content{line-height:1.5}.c-float-popWrap.hide{display:none;-webkit-box-shadow:none}.c-float-popWrap.show{display:block}.c-float-popWrap.msgMode .c-float-modePop .content,.c-float-popWrap.msgMode .c-float-modePop .doBtn{display:none}.c-float-popWrap.alertMode .c-float-modePop .content{display:none}.c-float-popWrap.alertMode .c-float-modePop .doBtn .cancel{display:none}.c-float-popWrap.alertMode,.c-float-popWrap.confirmMode{width:90%;}.c-float-popWrap.alertMode .c-float-modePop,.c-float-popWrap.confirmMode .c-float-modePop{background:#fff;padding:0;color:#202325}.c-float-popWrap.alertMode .c-float-modePop .content,.c-float-popWrap.confirmMode .c-float-modePop .content{padding:0.3125rem;border-bottom:0.03125rem solid #d6d9dc}.c-float-popWrap.alertMode .c-float-modePop .warnMsg,.c-float-popWrap.confirmMode .c-float-modePop .warnMsg{padding:0.3125rem;display:-webkit-box;-webkit-box-align:center;-webkit-box-pack:center;text-align:center;font-weight:700}.c-float-popWrap.alertMode .c-float-modePop .doBtn,.c-float-popWrap.alertMode .c-float-modePop .warnMsg,.c-float-popWrap.confirmMode .c-float-modePop .doBtn,.c-float-popWrap.confirmMode .c-float-modePop .warnMsg{border-bottom:0.03125rem solid #d6d9dc;color:#202325}.c-float-popWrap.alertMode .c-float-modePop .doBtn,.c-float-popWrap.confirmMode .c-float-modePop .doBtn{border-bottom:none;display:-webkit-box;-webkit-box-align:center}.c-float-popWrap.alertMode .c-float-modePop .content,.c-float-popWrap.confirmMode .c-float-modePop .content{display:block;color:#202325;padding:0.3125rem;line-height:0.75rem;font-size:0.46875rem;text-align:left;font-weight:700}.c-float-modePop button{-webkit-box-flex:1;color:#157afb;background:#fff;height:1.25rem;font-size:0.5625rem;display:block}.c-float-modePop button.cancel{border-right:0.03125rem solid #b2b2b2}.c-float-modePop button.ok{font-weight:700}', '</style>', '<div class="c-float-modePop">', '<div class="warnMsg"></div>', '<div class="content"></div>', '<div class="doBtn">', '<button class="cancel">取消</button>', '<button class="ok">确定</button>', '</div>', '</div>'].join('');

    E_floatMsg = E_float.querySelector('.warnMsg');
    E_floatContent = E_float.querySelector('.content');
    E_floatOk = E_float.querySelector('.doBtn .ok');
    E_floatCancel = E_float.querySelector('.doBtn .cancel');

    E_floatMsg.addEventListener('click', function () {
        // alert(E_float.className);
    }, false);

    function _extend(a, b) {
        for (var k in b) {
            a[k] = b[k];
        }
        return a;
    }

    function successHandler(e) {
        this.callback && this.callback(e, true);
    }

    function failureHandler(e) {
        this.callback && this.callback(e, false);
    }

    function ModePop(options) {
        this._options = _extend({
            mode: 'msg',
            text: '网页提示',
            useTap: false
        }, options || {});

        this._init();
    }

    _extend(ModePop.prototype, {
        _init: function _init() {
            var that = this,
                opt = that._options,
                mode = opt.mode,
                text = opt.text,
                okText = opt.okText,
                cancelText = opt.cancelText,
                content = opt.content,
                callback = opt.callback,
                background = opt.background,
                clickEvent = opt.useTap ? 'touchend' : 'click';

            // set mode
            var classTxt = E_float.className;
            classTxt = classTxt.replace(/(msg|alert|confirm)Mode/i, mode + 'Mode');
            E_float.className = classTxt;

            // set background
            background && (E_float.style.background = background);

            // set text & content
            if (text) {
                E_floatMsg.innerHTML = text;
                E_floatMsg.style.display = 'block';
            } else {
                E_floatMsg.style.display = 'none';
            }

            if (content) {
                E_floatContent.innerHTML = content;
                E_floatContent.style.display = 'block';
            } else {
                E_floatContent.style.display = 'none';
            }

            E_floatOk.innerHTML = okText || '确定';
            E_floatCancel.innerHTML = cancelText || '取消';

            if (mode == 'alert' || mode == 'confirm') {
                this.hasMask = true;
            } else {
                this.hasMask = false;
            }

            // click event
            E_floatOk.removeEventListener('touchend', successHandler);
            E_floatOk.removeEventListener('click', successHandler);
            E_floatCancel.removeEventListener('touchend', successHandler);
            E_floatCancel.removeEventListener('click', successHandler);
            E_floatOk.addEventListener(clickEvent, successHandler, false);
            E_floatCancel.addEventListener(clickEvent, failureHandler, false);
            E_floatOk.callback = E_floatCancel.callback = function () {
                callback.apply(that, arguments);
            };

            if (!initDom) {
                initDom = true;
                doc.body.appendChild(E_mask);
                doc.body.appendChild(E_float);
                win.addEventListener('resize', function () {
                    setTimeout(function () {
                        that._pos();
                    }, 500);
                }, false);
            }
        },

        _pos: function _pos() {
            var rect = E_float.getBoundingClientRect(),
                eW = rect.width,
                eH = rect.height;

            E_float.style.marginLeft = -eW / 2 + 'px';
            E_float.style.marginTop = -eH / 2 + 'px';
        },

        isShow: function isShow() {
            return E_float.className.indexOf('show') > -1;
        },

        isHide: function isHide() {
            return E_float.className.indexOf('hide') > -1;
        },

        _cbShow: function _cbShow(pos) {
            var that = this,
                opt = that._options,
                onShow = opt.onShow;

            E_float.style.opacity = '1';
            that.hasMask && (E_mask.style.opacity = '1');
            that.hasMask && (E_mask.className = E_mask.className.replace(/hide/g, '').trim());

            if (!that.isShow()) {
                E_float.className += ' show';
                that.hasMask && (E_mask.className += ' show');
            }

            pos && that._pos();

            onShow && onShow.call(that);
        },

        show: function show() {
            var that = this;

            if (flashTimeoutId) {
                clearTimeout(flashTimeoutId);
                flashTimeoutId = null;
                this._cbHide();
            }

            if (showTimeoutId) {
                clearTimeout(showTimeoutId);
                showTimeoutId = null;
            }

            if (hideTimeoutId) {
                clearTimeout(hideTimeoutId);
                hideTimeoutId = null;
            }

            if (!that.isShow()) {
                E_float.className = E_float.className.replace(/hide/g, '').trim();
                that.hasMask && (E_mask.className = E_mask.className.replace(/hide/g, '').trim());

                that._pos();

                setTimeout(function () {
                    E_float.style.opacity = '1';
                    that.hasMask && (E_mask.style.opacity = '1');
                }, 1);

                showTimeoutId = setTimeout(function () {
                    that._cbShow();
                }, 300);
            } else {
                that._cbShow(true);
            }
        },

        _cbHide: function _cbHide() {
            var that = this,
                opt = that._options,
                onHide = opt.onHide;

            E_float.style.opacity = '0';
            E_mask.style.opacity = '0';

            if (!that.isHide()) {
                E_float.className = E_float.className.replace(/hide|show/g, '').trim();
                E_float.className += ' hide';
                E_mask.className = E_mask.className.replace(/hide|show/g, '').trim();
                E_mask.className += ' hide';
            }
            onHide && onHide.call(that);
        },
        // ruoli 添加timeout参数，防止点击弹出框，立即再弹出一个框，出现闪动
        hide: function hide(timeout) {
            var that = this;

            if (showTimeoutId) {
                clearTimeout(showTimeoutId);
                showTimeoutId = null;
            }

            if (hideTimeoutId) {
                clearTimeout(hideTimeoutId);
                hideTimeoutId = null;
            }

            if (!that.isHide()) {
                E_float.className = E_float.className.replace(/show/g, '').trim();
                E_mask.className = E_mask.className.replace(/show/g, '').trim();

                setTimeout(function () {
                    E_float.style.opacity = '0';
                    E_mask.style.opacity = '0';
                }, 1);

                hideTimeoutId = setTimeout(function () {
                    that._cbHide();
                }, timeout || 300);
            } else {
                that._cbHide();
            }
        },

        flash: function flash(timeout) {
            var that = this,
                opt = that._options;

            that.show();

            //opt.onShow = function() {
            flashTimeoutId = setTimeout(function () {
                if (flashTimeoutId) {
                    that.hide();
                }
            }, timeout);
            //};
        }
    });

    var notification = new function () {

        this.simple = function (text, bg, timeout) {
            if (arguments.length == 2) {
                if (typeof arguments[1] == 'number') {
                    timeout = arguments[1];
                    bg = undefined;
                }
            }

            var pop = new ModePop({
                mode: 'msg',
                text: text,
                background: bg
            });

            pop.flash(timeout || 2000);
            return pop;
        };

        this.msg = function (text, options) {
            return new ModePop(_extend({
                mode: 'msg',
                text: text
            }, options || {}));
        };

        this.alert = function (text, content, callback, options) {

            if (typeof content === 'function') {
                options = callback;
                callback = content;
                content = null;
            }

            return new ModePop(_extend({
                mode: 'alert',
                text: text,
                content: content,
                callback: callback
            }, options || {}));
        };

        this.confirm = function (text, content, callback, options) {
            return new ModePop(_extend({
                mode: 'confirm',
                text: text,
                content: content,
                callback: callback
            }, options || {}));
        };

        this.pop = function (options) {
            return new ModePop(options);
        };
    }();

    lib.notification = notification;
})(window, window.Uplib || (window.Uplib = {}));

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(81);

var _index = __webpack_require__(82);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var platform = Uplib.native.getPlatform();

var cache = UpSDK.cache;

var defaultCfg = {
	oauthtype: ''
};

var h5login = Object.assign({
	init: function init() {
		// 若是客户端
		if (platform == 'uplive') {
			Uplib.native.getConfigs({
				invalid: 0,
				complete: function complete(cfg) {
					var userToken = cfg.usertoken;
					var uid = cfg.uid;

					var user = {
						uid: uid,
						userToken: userToken
					};

					UpSDK.writeLoginInfo(user);
					UpSDK.emit('getUserSuccess', user);
				},
				errtip: function errtip() {
					// 不支持协议   
				}
			});
		} else {
			this.getSMDeviceId().done(function () {
				var auth = new _index2.default({
					oauthtype: defaultCfg.oauthtype
				});

				auth.init();
			});
		}
	},
	getSMDeviceId: function getSMDeviceId() {
		var defer = $.Deferred();
		// 无论是否使用游客，都产生一个smd（数美的deviceId）
		// 并且存储到本地
		var cacheDeviceId = cache.getCache('smDeviceId');

		if (!cacheDeviceId) {

			// 数美JS已经加载完成
			if (typeof SMSdk !== 'undefined') {
				window.smDeviceId = SMSdk.getDeviceId();
				cache.setCache('smDeviceId', window.smDeviceId);
				defer.resolve();
			} else {

				// 否则监听事件，等待sdk加载完成
				$.channel.on('smsdkLoaded', function () {
					window.smDeviceId = SMSdk.getDeviceId();
					cache.setCache('smDeviceId', smDeviceId);
					defer.resolve();
				});

				$.channel.on('smsdkLoadedError', function () {
					defer.resolve();
				});
			}
		} else {
			window.smDeviceId = cacheDeviceId;
			defer.resolve();
		}

		return defer;
	}
}, Uplib.Events);

var _init = function _init(options) {
	options = options || {};

	defaultCfg = Object.assign(defaultCfg, options);

	h5login.init();
};

var login = function login(cfg) {
	_init.apply(h5login, arguments);

	return h5login;
};

var bauthtype = cache.getCache('bizoauthtype');

if (bauthtype) {

	var oauthcode = Uplib.url.query('code') || Uplib.url.query('oauth_token');

	cache.removeCache('bizoauthtype');

	if (oauthcode) {
		login({
			oauthtype: bauthtype
		});
	}
}

UpSDK.login = login;

/***/ }),
/* 81 */
/***/ (function(module, exports) {

/**
 * 数美防刷
 */
var SM = Object.assign({
    init: function init() {
        var hostname = location.hostname;
        var apiHost = 'fp.fengkongcloud.com';

        if (hostname == 'm.upliveapps.com') {
            apiHost = 'fp-xjp.fengkongcloud.com';
        }

        (function () {
            window._smConf = {
                organization: '3kHDvmQMHMyhMkWHki4D', //需要修改为业务 organization
                staticHost: 'static.fengkongcloud.com',
                apiHost: apiHost
            };
            var sm = document.createElement("script");
            sm.src = ('https:' === document.location.protocol ? 'https:' : 'http:') + '//' + _smConf.staticHost + '/fpv2.js';
            var s = document.getElementsByTagName("script")[0];
            sm.onload = function () {
                $.channel.emit('smsdkLoaded');
            };
            sm.onerror = function () {
                $.channel.emit('smsdkLoadedError');
            };
            s.parentNode.insertBefore(sm, s);
        })();
    }
}, Uplib.Events);

SM.init();

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // css文件中不要使用import


var _index = __webpack_require__(41);

var _index2 = _interopRequireDefault(_index);

var _token = __webpack_require__(92);

var _token2 = _interopRequireDefault(_token);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var cache = UpSDK.cache;

var Auth = function () {
    function Auth(cfg) {
        _classCallCheck(this, Auth);

        cfg = cfg || {};
        this.code = Uplib.url.query('code');
        this.platform = Uplib.native.getPlatform();
        this.oauthtype = cfg.oauthtype || 'fb';
    }

    _createClass(Auth, [{
        key: 'init',
        value: function init() {

            Uplib.loading.show();

            var oauthPlatform = this.getOAuthPlatform();

            UpSDK.config.oauthtype = oauthPlatform;

            switch (oauthPlatform) {
                case 'wechat':
                    this.wechat();
                    break;
                case 'twitter':
                    this.twitter();
                    break;
                case 'weibo':
                    this.weibo();
                    break;
                case 'qq':
                    this.qq();
                    break;
                case 'google':
                    this.google();
                    break;
                case 'line':
                    this.line();
                    break;
                case 'facebook':
                default:
                    this.facebook();
            }
        }
    }, {
        key: 'getOAuthPlatform',
        value: function getOAuthPlatform() {
            // switch (this.platform) {
            //     case 'wechat':
            //     case 'twitter':
            //     case 'weibo':
            //     case 'facebook':
            //         result = this.platform;
            //         break;
            //     default:
            // switch (this.oauthtype) {
            //     case 'twitter':
            //     case 'weibo':
            //     case 'google':
            //     case 'wechat':
            //     case 'qq':
            //         result = this.oauthtype;
            //         break;
            //     case 'fb':
            //     default:
            //         if (domain == 'h5.upliveapp.com' || domain == 'uplive.appanda.cn') {
            //             result = 'qq';
            //         } else {
            //             result = 'facebook';
            //         }
            // }

            // }

            // return result;

            if (this.oauthtype === 'fb') {
                return 'facebook';
            }
            return this.oauthtype;
        }
    }, {
        key: 'wechat',
        value: function wechat() {
            if (!this.code) {
                _index2.default.jumpToSNS('wechat');
            } else {
                if (cache.getCache('isBackFromSNS')) {
                    cache.removeCache('isBackFromSNS');
                    _token2.default.get('wechat', this.code);
                } else {
                    _index2.default.jumpToSNS('wechat');
                }
            }
        }
    }, {
        key: 'twitter',
        value: function twitter() {

            var oauth_token = Uplib.url.query('oauth_token');
            // 当获取request_token成功后, 则继续跳转到twitter的oauth验证页面获取verifier
            $.channel.on('getTwitterOauthTokenSuccess', function (resp) {
                if (!resp || !resp.token) {
                    Uplib.notification.simple('get oauth_token fail');
                    return;
                }
                _index2.default.twitterJumpForCode(resp.token);
                cache.setCache('twitter', resp);
            });

            // 当url中不包含oauth_token时
            // 用户首次进入此授权登录页面, 先从java端获取request_token
            if (!oauth_token) {
                _index.twitter.getRequestToken();
            } else {
                // 反之, 已从twitter oauth页面返回并携带oauth_token
                // 此时可获取up usertoken
                if (cache.getCache('isBackFromSNS')) {
                    cache.removeCache('isBackFromSNS');
                    _token2.default.get('twitter', oauth_token, cache.getCache('twitter').tokenSecret, Uplib.url.query('oauth_verifier'));
                } else {
                    _index.twitter.getRequestToken();
                }
            }
        }
    }, {
        key: 'weibo',
        value: function weibo() {
            if (!this.code) {
                _index2.default.weiboJumpForCode();
            } else {
                if (cache.getCache('isBackFromSNS')) {
                    cache.removeCache('isBackFromSNS');
                    _token2.default.get('weibo', this.code);
                } else {
                    _index2.default.weiboJumpForCode();
                }
            }
        }
    }, {
        key: 'qq',
        value: function qq() {
            if (!this.code) {
                _index2.default.qqJumpForCode();
            } else {
                if (cache.getCache('isBackFromSNS')) {
                    cache.removeCache('isBackFromSNS');
                    _token2.default.get('qq', this.code);
                } else {
                    _index2.default.qqJumpForCode();
                }
            }
        }
    }, {
        key: 'line',
        value: function line() {
            var code = this.code;
            if (!code) {
                _index2.default.lineJumpForCode();
            } else {
                if (cache.getCache('isBackFromSNS')) {
                    cache.removeCache('isBackFromSNS');
                    //  现需要调用获取Token，有点像google的登录
                    var _code = Uplib.url.query('code');
                    var state = Uplib.url.query('state');
                    // 此处需要注册用户
                    _token2.default.get('line', _code, state);
                } else {
                    _index2.default.lineJumpForCode();
                }
            }
        }
    }, {
        key: 'facebook',
        value: function facebook() {
            //  说明已经登录过了
            if (window.FBOauthResponse) {
                _token2.default.get('facebook', window.FBOauthResponse.accessToken);
            } else {
                if (typeof window.FB !== 'undefined') {
                    // 自己调用登录
                    FB.login(function () {
                        checkLoginState();
                        if (window.FBOauthResponse) {
                            _token2.default.get('facebook', window.FBOauthResponse.accessToken);
                        }
                    });
                }
            }
        }
    }, {
        key: 'google',
        value: function google() {

            $.channel.on('authSuccess', function (data) {
                $.channel.off('authSuccess');
                var user = {
                    uid: data.uid,
                    userToken: data.userToken,
                    subscribe: data.subscribe,
                    username: data.username,
                    avatar: data.avatar,
                    countryCode: data.countryCode,
                    gender: data.gender,
                    grade: data.grade,
                    upliveCode: data.upliveCode
                };

                UpSDK.writeLoginInfo(user);

                if (!data.countryCode) {
                    _token2.default.setProfile(user);
                } else {
                    UpSDK.emit('getUserSuccess', user);
                }
            });

            _index.google.init();
        }
    }]);

    return Auth;
}();

exports.default = Auth;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _api = __webpack_require__(15);

var _webauthtwitterrequesttokenpro = __webpack_require__(84);

var _webauthtwitterrequesttokenpro2 = _interopRequireDefault(_webauthtwitterrequesttokenpro);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getRequestToken = function getRequestToken() {
    var baseUrl = Uplib.url.delQuery(location.href, 'oauth_token');

    baseUrl = Uplib.url.delQuery(baseUrl, 'oauth_verifier');
    baseUrl = Uplib.url.delQuery(baseUrl, 'code');

    (0, _api.userService)('/webauth/twitter/requesttoken/pro', _webauthtwitterrequesttokenpro2.default.WebAuth.TwitterRequestTokenPro)({
        callback: encodeURIComponent(baseUrl)
    }).then(function (resp) {
        $.channel.emit('getTwitterOauthTokenSuccess', resp);
    }).catch(function () {
        Uplib.notification.simple('request fail');
    });
};

exports.default = {
    getRequestToken: getRequestToken
};

/***/ }),
/* 84 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "WebAuth.TwitterRequestTokenPro",
    "options": {
        "objc_class_prefix": "WebAuthTwitterRequestTokenPro",
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [{
        "name": "Request",
        "fields": [{
            "rule": "optional",
            "type": "string",
            "name": "callback",
            "id": 1
        }]
    }, {
        "name": "Response",
        "fields": [{
            "rule": "optional",
            "type": "string",
            "name": "token",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "tokenSecret",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "callbackConfirmed",
            "id": 3
        }]
    }]
}).build();
exports.default = _root;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(27);

var _config2 = _interopRequireDefault(_config);

var _check = __webpack_require__(86);

var _check2 = _interopRequireDefault(_check);

var _register = __webpack_require__(88);

var _register2 = _interopRequireDefault(_register);

var _login = __webpack_require__(90);

var _login2 = _interopRequireDefault(_login);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * google测试环境无法使用
 * @author
 */
var _system = Uplib.native.getSystem();
var prefix = _system == 'pc' ? 'pcuplive' : 'uplive';

var cache = UpSDK.cache;

var bindType = 15;

var GoogleAuth = void 0;

function updateSigninStatus(isSignedIn) {
    // When signin status changes, this function is called.
    // If the signin status is changed to signedIn, we make an API call.
    console.warn('isSignedIn', isSignedIn);
    if (isSignedIn) {
        // 登录成功
        var GoogleUser = GoogleAuth.currentUser.get();

        var _GoogleUser$getAuthRe = GoogleUser.getAuthResponse(),
            access_token = _GoogleUser$getAuthRe.access_token;

        var profileData = GoogleUser.getBasicProfile();

        console.warn('profileData', profileData);

        $.channel.emit('glOauthSuccess', {
            access_token: access_token,
            profileData: profileData
        });
    } else {
        GoogleAuth.signIn();
    }
}

var google = Object.assign({
    init: function init() {
        var _this = this;

        Uplib.loading.show({
            text: Uplib.tpl('Loading')
        });

        if (gapi) {
            return this.startAuth();
        }

        var loadedsdk = false;
        (function (d, s, id, cb) {
            var element = d.getElementsByTagName(s)[0];
            var fjs = element;
            var js = element;
            js = d.createElement(s);
            js.id = id;
            js.src = '//apis.google.com/js/platform.js';
            fjs.parentNode.insertBefore(js, fjs);
            js.onload = cb;
            // TODO 加载失败了，需要处理一下
            js.onerror = function () {
                Uplib.loading.hide();
                UpSDK.emit('sdkLoadError', 'google');
            };
        })(document, 'script', 'google-login', function () {
            loadedsdk = true;
            _this.loadSdkTimer && clearTimeout(_this.loadSdkTimer);
            console.warn('google sdk loaded');
            _this.startAuth();
        });

        this.loadSdkTimer = setTimeout(function () {
            if (!loadedsdk) {
                Uplib.loading.hide();
                Uplib.notification.simple('Authorization failed');
                new Error('gapi.load Auth2 Timeout');
            }
        }, 3 * 1000);
    },
    startAuth: function startAuth() {
        var _this2 = this;

        try {
            gapi.load('auth2', function () {
                var client_id = _config2.default.upInfoInPlatform['google'].clientId;

                gapi.auth2.init({
                    client_id: client_id,
                    scope: 'profile email'
                }).then(function () {
                    console.warn('google sdk init');
                    GoogleAuth = gapi.auth2.getAuthInstance();

                    GoogleAuth.isSignedIn.listen(updateSigninStatus);

                    // Handle the initial sign-in state.
                    updateSigninStatus(GoogleAuth.isSignedIn.get());
                });
            });

            $.channel.on('glOauthSuccess', function (data) {
                $.channel.off('glOauthSuccess');
                Uplib.loading.hide();
                _this2.getGoogleInfo(data);
            });
        } catch (e) {
            Uplib.loading.hide();
            Uplib.notification.simple('Authorization failed');
        }
    },
    getGoogleInfo: function getGoogleInfo(data) {
        var _this3 = this;

        var isRegistered = this.checkRegistered(data);

        isRegistered.done(function (registered) {
            if (registered) {
                // 三方账号已绑定Up直播
                _this3.getProfileForRegister(data);
            } else {
                // 未绑定
                _this3.getProfileForNoRegister(data);
            }
        });

        isRegistered.fail(function () {
            // alert('dd');
        });
    },
    getProfileForNoRegister: function getProfileForNoRegister(data) {
        var _this4 = this;

        var registerPromise = this.register(data);

        registerPromise.done(function (data) {

            var loginPromise = _this4.login(data.uid, data.password);

            loginPromise.done(function (data) {
                console.log('用户信息', data);

                // 授权成功，真实用户
                cache.setCache('isRegisterRealUser', true);

                Uplib.loading.hide();

                $.channel.emit('authSuccess', data);
            });

            loginPromise.fail(function (dataWrap) {
                Uplib.loading.hide();

                if (dataWrap.code == 4119) {
                    Uplib.notification.simple('device forbidden');
                }
            });
        });

        registerPromise.fail(function (dataWrap) {
            Uplib.loading.hide();

            if (dataWrap.code == 4119) {
                Uplib.notification.simple('device forbidden');
            }
        });
    },
    getProfileForRegister: function getProfileForRegister(data) {
        var registerPromise = this.register(data);

        registerPromise.done(function (data) {
            console.log('用户信息', data);
            // 授权成功，真实用户
            cache.setCache('isRegisterRealUser', true);

            Uplib.loading.hide();

            $.channel.emit('authSuccess', data);
        });

        registerPromise.fail(function (dataWrap) {
            Uplib.loading.hide();

            if (dataWrap.code == 4119) {
                Uplib.notification.simple('device forbidden');
            }
        });
    },

    /*
     * 第三方账号是否已经绑定过UP直播
     */
    checkRegistered: function checkRegistered(data) {
        var promise = new _check2.default({
            bindType: bindType,
            thirdId: data.profileData.getId(),
            thirdToken: data.access_token
        }).promise;

        return promise;
    },
    register: function register(data) {
        var profileData = data.profileData,
            access_token = data.access_token;

        var promise = new _register2.default({
            bindType: bindType,
            thirdId: profileData.getId(),
            thirdToken: access_token,
            avatar: profileData.getImageUrl(),
            username: profileData.getName()
        }).promise;

        return promise;
    },
    login: function login(uid, password) {
        var promise = new _login2.default({
            loginType: 1,
            bindType: bindType,
            uid: uid,
            password: password
        }).promise;

        return promise;
    }
}, Uplib.Events);

module.exports = google;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 检测第三方账号是否已经绑定过
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */


var _public = __webpack_require__(7);

var _public2 = _interopRequireDefault(_public);

var _check = __webpack_require__(87);

var _check2 = _interopRequireDefault(_check);

var _pbajax = __webpack_require__(8);

var _pbajax2 = _interopRequireDefault(_pbajax);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var pbajax = new _pbajax2.default();

var ThirdCheck = function () {
    function ThirdCheck() {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, ThirdCheck);

        this.promise = this.check(data);
    }

    _createClass(ThirdCheck, [{
        key: 'check',
        value: function check(data) {
            var defer = $.Deferred();
            var _checkPb$ThirdParty$C = _check2.default.ThirdParty.Check,
                Request = _checkPb$ThirdParty$C.Request,
                Response = _checkPb$ThirdParty$C.Response;


            var businessData = new Request(data);

            var requestData = {
                service: 'service',
                api: '/third/party/check'
            };

            pbajax.do(requestData, businessData, function (res) {
                var dataWrap = _public2.default.Result.decode(res);
                var data = void 0;

                if (dataWrap.code == '256') {
                    // 已绑定过
                    defer.resolve(true);
                } else if (dataWrap.code == 1) {
                    // 未绑定过
                    defer.resolve(false);
                } else {
                    defer.reject();
                }
            }, function () {
                defer.reject();
            }, function () {
                defer.reject();
            });
            return defer.promise();
        }
    }]);

    return ThirdCheck;
}();

exports.default = ThirdCheck;

/***/ }),
/* 87 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": null,
    "options": {
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [{
        "name": "UserBalanceInfo",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "inBill",
            "id": 1
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "outDiamond",
            "id": 2
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "bill",
            "id": 3
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "diamond",
            "id": 4
        }]
    }, {
        "name": "ProfileInfo",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "uid",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "username",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "upliveCode",
            "id": 3
        }, {
            "rule": "optional",
            "type": "string",
            "name": "avatar",
            "id": 4
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "gender",
            "id": 5
        }, {
            "rule": "optional",
            "type": "string",
            "name": "setting",
            "id": 6
        }, {
            "rule": "optional",
            "type": "string",
            "name": "password",
            "id": 7
        }, {
            "rule": "optional",
            "type": "string",
            "name": "userToken",
            "id": 8
        }, {
            "rule": "optional",
            "type": "string",
            "name": "signature",
            "id": 9
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "grade",
            "id": 10
        }, {
            "rule": "optional",
            "type": "string",
            "name": "location",
            "id": 11
        }, {
            "rule": "optional",
            "type": "string",
            "name": "mobilePhone",
            "id": 12
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "fanTotal",
            "id": 13
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "followTotal",
            "id": 14
        }, {
            "rule": "optional",
            "type": "UserBalanceInfo",
            "name": "balance",
            "id": 15
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "chatroomid",
            "id": 16
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "followType",
            "id": 17
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "exp",
            "id": 18
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "currentExp",
            "id": 19
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "nextExp",
            "id": 20
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "officialAuth",
            "id": 21
        }, {
            "rule": "optional",
            "type": "string",
            "name": "officialAuthContent",
            "id": 22
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "qualityAuth",
            "id": 23
        }, {
            "rule": "optional",
            "type": "string",
            "name": "countryCode",
            "id": 25
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "admin",
            "id": 26
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "userRealNameAuth",
            "id": 27
        }, {
            "rule": "optional",
            "type": "string",
            "name": "acceptAgreement",
            "id": 28
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "upliveCodeStatus",
            "id": 29
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "subscribe",
            "id": 30
        }, {
            "rule": "repeated",
            "type": "Source",
            "name": "sources",
            "id": 31
        }]
    }, {
        "name": "Source",
        "fields": [{
            "rule": "optional",
            "type": "int32",
            "name": "bindType",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "openId",
            "id": 2
        }]
    }, {
        "name": "ThirdParty",
        "fields": [],
        "messages": [{
            "name": "Check",
            "fields": [],
            "options": {
                "objc_class_prefix": "ThirdPartyCheck",
                "java_package": "com.asiainno.uplive.proto"
            },
            "messages": [{
                "name": "Request",
                "fields": [{
                    "rule": "optional",
                    "type": "BindType",
                    "name": "bindType",
                    "id": 1
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "thirdId",
                    "id": 2
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "thirdToken",
                    "id": 3
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "extension",
                    "id": 4
                }]
            }, {
                "name": "Response",
                "fields": [{
                    "rule": "optional",
                    "type": "ProfileInfo",
                    "name": "profile",
                    "id": 1
                }]
            }]
        }]
    }],
    "enums": [{
        "name": "BindType",
        "values": [{
            "name": "DEFAULT_TYPE",
            "id": 0
        }, {
            "name": "MOBILE_PHONE",
            "id": 1
        }, {
            "name": "QQ",
            "id": 2
        }, {
            "name": "WEIXIN",
            "id": 3
        }, {
            "name": "FACEBOOK",
            "id": 4
        }, {
            "name": "SINA_WEIBO",
            "id": 5
        }, {
            "name": "RR",
            "id": 6
        }, {
            "name": "TENCENT_WANBA",
            "id": 7
        }, {
            "name": "KECHENGGEZI",
            "id": 8
        }, {
            "name": "DEVICE",
            "id": 9
        }, {
            "name": "GOOGLE",
            "id": 15
        }, {
            "name": "TWITTER",
            "id": 16
        }, {
            "name": "EMAIL",
            "id": 17
        }]
    }, {
        "name": "PushType",
        "values": [{
            "name": "DEFAULT_PUSHTYPE",
            "id": 0
        }, {
            "name": "BAIDU",
            "id": 1
        }, {
            "name": "IOS",
            "id": 2
        }, {
            "name": "JPUSH",
            "id": 3
        }, {
            "name": "XIAOMI",
            "id": 4
        }, {
            "name": "GETUI",
            "id": 5
        }, {
            "name": "GOOGLE_PUSH",
            "id": 6
        }, {
            "name": "SAMSUNG",
            "id": 7
        }, {
            "name": "MEIZU",
            "id": 8
        }, {
            "name": "HUAWEI",
            "id": 9
        }, {
            "name": "GOOGLE_FCM",
            "id": 10
        }]
    }]
}).build();

exports.default = _root;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _public = __webpack_require__(7);

var _public2 = _interopRequireDefault(_public);

var _register = __webpack_require__(89);

var _register2 = _interopRequireDefault(_register);

var _pbajax = __webpack_require__(8);

var _pbajax2 = _interopRequireDefault(_pbajax);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var pbajax = new _pbajax2.default();

var ThirdRegister = function () {
    function ThirdRegister() {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, ThirdRegister);

        this.promise = this.register(data);
    }

    _createClass(ThirdRegister, [{
        key: 'register',
        value: function register(data) {
            var self = this;
            var defer = $.Deferred();
            var _registerPb$ThirdChec = _register2.default.ThirdCheck.Register,
                Request = _registerPb$ThirdChec.Request,
                Response = _registerPb$ThirdChec.Response;

            var ua = window.navigator.userAgent;

            var businessData = new Request(data);

            var requestData = {
                service: 'service',
                api: '/third/check/register',
                header: {
                    'Accept-Language': 'zh-CN',
                    'UserAgent': ua
                }
            };

            pbajax.do(requestData, businessData, function (res) {
                var dataWrap = _public2.default.Result.decode(res);
                var data = void 0;

                if (dataWrap.code == 1) {
                    data = Response.decode(dataWrap.data.value);

                    var userInfo = Object.assign({}, data.profile, self.parseData(data.profile));

                    defer.resolve(userInfo);
                } else {
                    defer.reject(dataWrap);
                }
            }, function () {
                defer.reject();
            }, function () {
                defer.reject();
            });
            return defer.promise();
        }
        /*
         * 解析数据
         */

    }, {
        key: 'parseData',
        value: function parseData(data) {
            var balance = data.balance || {};

            return {
                uid: this.longToString(data.uid), // 用户UID
                balance: {
                    diamond: this.longToInt(balance.diamond),
                    bill: this.longToInt(balance.bill),
                    inBill: this.longToInt(balance.inBill),
                    outDiamond: this.longToInt(balance.outDiamond)
                },
                exp: this.longToInt(data.exp), // 用户经验值
                currentExp: this.longToInt(data.currentExp), //当前级的经验值
                nextExp: this.longToInt(data.nextExp), // 距离下一级还需要多少经验值
                chatroomid: this.longToString(data.chatroomid),
                officialAuth: data.officialAuth || 0 // 大V认证标识 1是 0否
            };
        }
    }, {
        key: 'longToString',
        value: function longToString(value) {
            return window.longToString(value);
        }
    }, {
        key: 'longToInt',
        value: function longToInt(value) {
            value = this.longToString(value);

            return parseInt(value, 10) || 0;
        }
    }]);

    return ThirdRegister;
}();

exports.default = ThirdRegister;

/***/ }),
/* 89 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": null,
    "options": {
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [{
        "name": "UserBalanceInfo",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "inBill",
            "id": 1
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "outDiamond",
            "id": 2
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "bill",
            "id": 3
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "diamond",
            "id": 4
        }]
    }, {
        "name": "ProfileInfo",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "uid",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "username",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "upliveCode",
            "id": 3
        }, {
            "rule": "optional",
            "type": "string",
            "name": "avatar",
            "id": 4
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "gender",
            "id": 5
        }, {
            "rule": "optional",
            "type": "string",
            "name": "setting",
            "id": 6
        }, {
            "rule": "optional",
            "type": "string",
            "name": "password",
            "id": 7
        }, {
            "rule": "optional",
            "type": "string",
            "name": "userToken",
            "id": 8
        }, {
            "rule": "optional",
            "type": "string",
            "name": "signature",
            "id": 9
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "grade",
            "id": 10
        }, {
            "rule": "optional",
            "type": "string",
            "name": "location",
            "id": 11
        }, {
            "rule": "optional",
            "type": "string",
            "name": "mobilePhone",
            "id": 12
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "fanTotal",
            "id": 13
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "followTotal",
            "id": 14
        }, {
            "rule": "optional",
            "type": "UserBalanceInfo",
            "name": "balance",
            "id": 15
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "chatroomid",
            "id": 16
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "followType",
            "id": 17
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "exp",
            "id": 18
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "currentExp",
            "id": 19
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "nextExp",
            "id": 20
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "officialAuth",
            "id": 21
        }, {
            "rule": "optional",
            "type": "string",
            "name": "officialAuthContent",
            "id": 22
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "qualityAuth",
            "id": 23
        }, {
            "rule": "optional",
            "type": "string",
            "name": "countryCode",
            "id": 25
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "admin",
            "id": 26
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "userRealNameAuth",
            "id": 27
        }, {
            "rule": "optional",
            "type": "string",
            "name": "acceptAgreement",
            "id": 28
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "upliveCodeStatus",
            "id": 29
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "subscribe",
            "id": 30
        }, {
            "rule": "repeated",
            "type": "Source",
            "name": "sources",
            "id": 31
        }]
    }, {
        "name": "Source",
        "fields": [{
            "rule": "optional",
            "type": "int32",
            "name": "bindType",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "openId",
            "id": 2
        }]
    }, {
        "name": "ThirdCheck",
        "fields": [],
        "messages": [{
            "name": "Register",
            "fields": [],
            "options": {
                "objc_class_prefix": "ThirdCheckRegister",
                "java_package": "com.asiainno.uplive.proto"
            },
            "messages": [{
                "name": "Request",
                "fields": [{
                    "rule": "optional",
                    "type": "BindType",
                    "name": "bindType",
                    "id": 1
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "thirdId",
                    "id": 2
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "thirdToken",
                    "id": 3
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "extension",
                    "id": 4
                }, {
                    "rule": "optional",
                    "type": "int32",
                    "name": "gender",
                    "id": 5
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "mobilePhone",
                    "id": 6
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "username",
                    "id": 7
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "signature",
                    "id": 8
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "avatar",
                    "id": 9
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "location",
                    "id": 10
                }, {
                    "rule": "optional",
                    "type": "PushType",
                    "name": "pushType",
                    "id": 11
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "pushToken",
                    "id": 12
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "deviceId",
                    "id": 13
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "smsCode",
                    "id": 14
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "countryCode",
                    "id": 16
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "password",
                    "id": 17
                }, {
                    "rule": "optional",
                    "type": "int32",
                    "name": "bind",
                    "id": 18
                }]
            }, {
                "name": "Response",
                "fields": [{
                    "rule": "optional",
                    "type": "ProfileInfo",
                    "name": "profile",
                    "id": 1
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "exmailCheckCode",
                    "id": 2
                }]
            }]
        }]
    }],
    "enums": [{
        "name": "BindType",
        "values": [{
            "name": "DEFAULT_TYPE",
            "id": 0
        }, {
            "name": "MOBILE_PHONE",
            "id": 1
        }, {
            "name": "QQ",
            "id": 2
        }, {
            "name": "WEIXIN",
            "id": 3
        }, {
            "name": "FACEBOOK",
            "id": 4
        }, {
            "name": "SINA_WEIBO",
            "id": 5
        }, {
            "name": "RR",
            "id": 6
        }, {
            "name": "TENCENT_WANBA",
            "id": 7
        }, {
            "name": "KECHENGGEZI",
            "id": 8
        }, {
            "name": "DEVICE",
            "id": 9
        }, {
            "name": "GOOGLE",
            "id": 15
        }, {
            "name": "TWITTER",
            "id": 16
        }, {
            "name": "EMAIL",
            "id": 17
        }]
    }, {
        "name": "PushType",
        "values": [{
            "name": "DEFAULT_PUSHTYPE",
            "id": 0
        }, {
            "name": "BAIDU",
            "id": 1
        }, {
            "name": "IOS",
            "id": 2
        }, {
            "name": "JPUSH",
            "id": 3
        }, {
            "name": "XIAOMI",
            "id": 4
        }, {
            "name": "GETUI",
            "id": 5
        }, {
            "name": "GOOGLE_PUSH",
            "id": 6
        }, {
            "name": "SAMSUNG",
            "id": 7
        }, {
            "name": "MEIZU",
            "id": 8
        }, {
            "name": "HUAWEI",
            "id": 9
        }, {
            "name": "GOOGLE_FCM",
            "id": 10
        }]
    }]
}).build();

exports.default = _root;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _public = __webpack_require__(7);

var _public2 = _interopRequireDefault(_public);

var _login = __webpack_require__(91);

var _login2 = _interopRequireDefault(_login);

var _pbajax = __webpack_require__(8);

var _pbajax2 = _interopRequireDefault(_pbajax);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var pbajax = new _pbajax2.default();

var UserLogin = function () {
    function UserLogin() {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, UserLogin);

        this.promise = this.login(data);
    }

    _createClass(UserLogin, [{
        key: 'login',
        value: function login(data) {
            var self = this;
            var defer = $.Deferred();
            var _loginPb$User$Login = _login2.default.User.Login,
                Request = _loginPb$User$Login.Request,
                Response = _loginPb$User$Login.Response;


            var businessData = new Request(data);

            var requestData = {
                https: 'true',
                service: 'safe', // java service name
                api: '/user/login' // java api
            };

            pbajax.do(requestData, businessData, function (res) {
                var dataWrap = _public2.default.Result.decode(res);
                var data = void 0;

                if (dataWrap.code == 1) {
                    // 未绑定过
                    data = Response.decode(dataWrap.data.value);

                    var userInfo = Object.assign({}, data.profile, self.parseData(data.profile));

                    defer.resolve(userInfo);
                } else {
                    defer.reject(dataWrap);
                }
            }, function () {
                defer.reject();
            }, function () {
                defer.reject();
            });

            return defer.promise();
        }
        /*
         * 解析数据
         */

    }, {
        key: 'parseData',
        value: function parseData(data) {
            var balance = data.balance || {};
            return {
                uid: this.longToString(data.uid), // 用户UID
                balance: {
                    diamond: this.longToInt(balance.diamond),
                    bill: this.longToInt(balance.bill),
                    inBill: this.longToInt(balance.inBill),
                    outDiamond: this.longToInt(balance.outDiamond)
                },
                exp: this.longToInt(data.exp), // 用户经验值
                currentExp: this.longToInt(data.currentExp), //当前级的经验值
                nextExp: this.longToInt(data.nextExp), // 距离下一级还需要多少经验值
                chatroomid: this.longToString(data.chatroomid),
                officialAuth: data.officialAuth || 0 // 大V认证标识 1是 0否
            };
        }
    }, {
        key: 'longToString',
        value: function longToString(value) {
            return window.longToString(value);
        }
    }, {
        key: 'longToInt',
        value: function longToInt(value) {
            value = this.longToString(value);

            return parseInt(value, 10) || 0;
        }
    }]);

    return UserLogin;
}();

exports.default = UserLogin;

/***/ }),
/* 91 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": null,
    "options": {
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [{
        "name": "UserBalanceInfo",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "inBill",
            "id": 1
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "outDiamond",
            "id": 2
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "bill",
            "id": 3
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "diamond",
            "id": 4
        }]
    }, {
        "name": "ProfileInfo",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "uid",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "username",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "upliveCode",
            "id": 3
        }, {
            "rule": "optional",
            "type": "string",
            "name": "avatar",
            "id": 4
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "gender",
            "id": 5
        }, {
            "rule": "optional",
            "type": "string",
            "name": "setting",
            "id": 6
        }, {
            "rule": "optional",
            "type": "string",
            "name": "password",
            "id": 7
        }, {
            "rule": "optional",
            "type": "string",
            "name": "userToken",
            "id": 8
        }, {
            "rule": "optional",
            "type": "string",
            "name": "signature",
            "id": 9
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "grade",
            "id": 10
        }, {
            "rule": "optional",
            "type": "string",
            "name": "location",
            "id": 11
        }, {
            "rule": "optional",
            "type": "string",
            "name": "mobilePhone",
            "id": 12
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "fanTotal",
            "id": 13
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "followTotal",
            "id": 14
        }, {
            "rule": "optional",
            "type": "UserBalanceInfo",
            "name": "balance",
            "id": 15
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "chatroomid",
            "id": 16
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "followType",
            "id": 17
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "exp",
            "id": 18
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "currentExp",
            "id": 19
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "nextExp",
            "id": 20
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "officialAuth",
            "id": 21
        }, {
            "rule": "optional",
            "type": "string",
            "name": "officialAuthContent",
            "id": 22
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "qualityAuth",
            "id": 23
        }, {
            "rule": "optional",
            "type": "string",
            "name": "countryCode",
            "id": 25
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "admin",
            "id": 26
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "userRealNameAuth",
            "id": 27
        }, {
            "rule": "optional",
            "type": "string",
            "name": "acceptAgreement",
            "id": 28
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "upliveCodeStatus",
            "id": 29
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "subscribe",
            "id": 30
        }, {
            "rule": "repeated",
            "type": "Source",
            "name": "sources",
            "id": 31
        }]
    }, {
        "name": "Source",
        "fields": [{
            "rule": "optional",
            "type": "int32",
            "name": "bindType",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "openId",
            "id": 2
        }]
    }, {
        "name": "User",
        "fields": [],
        "messages": [{
            "name": "Login",
            "fields": [],
            "options": {
                "objc_class_prefix": "UserLogin",
                "java_package": "com.asiainno.uplive.proto"
            },
            "messages": [{
                "name": "Request",
                "fields": [{
                    "rule": "optional",
                    "type": "int32",
                    "name": "loginType",
                    "id": 1
                }, {
                    "rule": "optional",
                    "type": "BindType",
                    "name": "bindType",
                    "id": 2
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "thirdId",
                    "id": 3
                }, {
                    "rule": "optional",
                    "type": "int64",
                    "name": "uid",
                    "id": 4
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "password",
                    "id": 5
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "location",
                    "id": 6
                }, {
                    "rule": "optional",
                    "type": "PushType",
                    "name": "pushType",
                    "id": 7
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "pushToken",
                    "id": 8
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "deviceId",
                    "id": 9
                }]
            }, {
                "name": "Response",
                "fields": [{
                    "rule": "optional",
                    "type": "ProfileInfo",
                    "name": "profile",
                    "id": 1
                }]
            }]
        }]
    }],
    "enums": [{
        "name": "BindType",
        "values": [{
            "name": "DEFAULT_TYPE",
            "id": 0
        }, {
            "name": "MOBILE_PHONE",
            "id": 1
        }, {
            "name": "QQ",
            "id": 2
        }, {
            "name": "WEIXIN",
            "id": 3
        }, {
            "name": "FACEBOOK",
            "id": 4
        }, {
            "name": "SINA_WEIBO",
            "id": 5
        }, {
            "name": "RR",
            "id": 6
        }, {
            "name": "TENCENT_WANBA",
            "id": 7
        }, {
            "name": "KECHENGGEZI",
            "id": 8
        }, {
            "name": "DEVICE",
            "id": 9
        }, {
            "name": "GOOGLE",
            "id": 15
        }, {
            "name": "TWITTER",
            "id": 16
        }, {
            "name": "EMAIL",
            "id": 17
        }]
    }, {
        "name": "PushType",
        "values": [{
            "name": "DEFAULT_PUSHTYPE",
            "id": 0
        }, {
            "name": "BAIDU",
            "id": 1
        }, {
            "name": "IOS",
            "id": 2
        }, {
            "name": "JPUSH",
            "id": 3
        }, {
            "name": "XIAOMI",
            "id": 4
        }, {
            "name": "GETUI",
            "id": 5
        }, {
            "name": "GOOGLE_PUSH",
            "id": 6
        }, {
            "name": "SAMSUNG",
            "id": 7
        }, {
            "name": "MEIZU",
            "id": 8
        }, {
            "name": "HUAWEI",
            "id": 9
        }, {
            "name": "GOOGLE_FCM",
            "id": 10
        }]
    }]
}).build();

exports.default = _root;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _index = __webpack_require__(93);

var _index2 = _interopRequireDefault(_index);

var _set = __webpack_require__(95);

var _set2 = _interopRequireDefault(_set);

var _api = __webpack_require__(15);

var _webauthauthpro = __webpack_require__(97);

var _webauthauthpro2 = _interopRequireDefault(_webauthauthpro);

var _index3 = __webpack_require__(41);

var _index4 = _interopRequireDefault(_index3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _system = Uplib.native.getSystem();
var feature = _system == 'pc' ? 9999 : 8888;
var deviceType = _system == 'pc' ? 'PC' : 'H5';
var version = _system == 'pc' ? '8.8.8' : '9.9.9';

var token = {
    // 获取up用户的usertoken
    get: function get(platform, code, tokenSecret, verifier) {
        var _this = this;

        this.platform = platform;
        var channel = UpSDK.config.channel || '';

        var opt = {
            authcode: code,
            feature: feature + '',
            channel: channel.substr(0, 20),
            // language: UpSDK.config.language,
            deviceType: deviceType,
            version: version
        };

        switch (platform) {
            case 'wechat':
                opt.type = 3;
                break;
            case 'facebook':
                opt.type = 4;
                break;
            case 'twitter':
                opt.type = 16;
                opt = Object.assign(opt, {
                    tokenSecret: tokenSecret,
                    verifier: verifier
                });
                break;
            case 'qq':
                opt.type = 2;
                opt.callback = encodeURIComponent(location.href);
                opt.state = 'test';
                break;
            case 'weibo':
                opt.type = 5;
                opt.callback = location.href;
                break;
            case 'line':
                opt.type = 19;
                // 外面传递的是就是state
                opt.state = tokenSecret;
                opt.callback = Uplib.url.delQuery(Uplib.url.delQuery(location.href, 'code'), 'state').replace(/#.*/, '');
                break;
            default:
                break;
        }

        if (window.smDeviceId) {
            opt.deviceId = window.smDeviceId;
        }

        (0, _api.userService)('/webauth/auth/pro', _webauthauthpro2.default.WebAuth.AuthPro)(opt).then(function (res) {
            // subscribe - 是否关注up小助手
            // uid
            // userToken
            _this.userData = res;
            _typeof(res.uid) === 'object' ? res.uid = longToString(res.uid) : res.uid;

            UpSDK.writeLoginInfo(res);

            var getProfileCount = 0;
            var _getProfile = function _getProfile(uid) {
                var profile = new _index2.default(uid);

                profile.promise.done(function (data) {
                    var countryCode = data.countryCode;

                    _this.userData = Object.assign({}, _this.userData, {
                        username: data.username,
                        avatar: data.avatar,
                        countryCode: data.countryCode,
                        gender: data.gender,
                        grade: data.grade,
                        upliveCode: data.upliveCode
                    });

                    if (!countryCode) {
                        _this.setProfile(_this.userData);
                    } else {
                        Uplib.loading.hide();
                        UpSDK.writeLoginInfo(_this.userData);
                        _this.back();
                    }
                }).fail(function (data) {
                    ++getProfileCount;

                    if (getProfileCount > 3) {
                        Uplib.loading.hide();
                        Uplib.notification.simple('Fail to get your personal information', 100 * 1000);
                    } else {
                        _getProfile(uid);
                    }
                });
            };

            Uplib.loading.show({
                text: 'loading'
            });

            _getProfile(res.uid);
        }).catch(function (res) {
            Uplib.loading.hide();
            if (res && res.code) {
                if (res.code === 'E000002' || res.code === 'E000003') {
                    if (platform === 'wechat') {
                        _index4.default.jumpToSNS(platform, 'snsapi_userinfo');
                    } else if (platform === 'weibo') {
                        _index4.default.jumpToSNS(platform);
                    } else if (platform === 'facebook') {
                        location.reload();
                    } else {
                        Uplib.notification.simple('system error');
                    }
                } else if (res.code === 'E000001' || res.code === 'E000004') {
                    $(document.body).empty();
                    Uplib.notification.simple('system error', 100 * 1000);
                } else if (res.code === 'E000005') {
                    $(document.body).empty();
                    Uplib.notification.simple('device forbidden', 100 * 1000);
                }
                return;
            }
            Uplib.notification.simple('system error');
        });
    },
    getDefaultCountryCode: function getDefaultCountryCode() {
        var systemLanguage = UpSDK.config.systemLanguage;

        return systemLanguage.split('-')[1].toUpperCase();
    },
    setProfile: function setProfile(userData) {
        var _this2 = this;

        var countryCode = this.getDefaultCountryCode();

        var setProfileCount = 0;

        var _setProfile = function _setProfile() {
            var profileset = new _set2.default({
                countryCode: countryCode
            });

            profileset.promise.then(function (data) {
                userData.countryCode = countryCode;
                UpSDK.writeLoginInfo(userData);
                Uplib.loading.hide();
                _this2.back();
            }, function () {
                ++setProfileCount;

                if (setProfileCount > 3) {
                    Uplib.loading.hide();
                    Uplib.notification.simple('Fail to set your country / region', 100 * 1000);
                } else {
                    _setProfile(countryCode);
                }
            });
        };

        _setProfile();
    },
    back: function back() {
        UpSDK.emit('getUserSuccess', UpSDK.getUserInfo());
    }
};

exports.default = token;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // import React, {Component} from 'react';


var _public = __webpack_require__(7);

var _public2 = _interopRequireDefault(_public);

var _index = __webpack_require__(94);

var _index2 = _interopRequireDefault(_index);

var _pbajax = __webpack_require__(8);

var _pbajax2 = _interopRequireDefault(_pbajax);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var pbajax = new _pbajax2.default();

var Profile = function () {
    function Profile(vuid) {
        _classCallCheck(this, Profile);

        // debugger;
        this.promise = this.getData({
            vuid: vuid
        });
    }

    _createClass(Profile, [{
        key: 'getData',
        value: function getData(data) {

            var self = this;
            var businessData = new _index2.default.Profile.Get.Request(data);
            var defer = $.Deferred();

            var ua = window.navigator.userAgent;

            pbajax.do({
                service: 'service',
                api: '/profile/get',
                header: {
                    userToken: UpSDK.getUserToken(),
                    UserAgent: ua
                }
            }, businessData, function (res) {

                var dataWrap = _public2.default.Result.decode(res);
                var data = void 0;

                if (dataWrap.code == 1) {
                    data = _index2.default.Profile.Get.Response.decode(dataWrap.data.value);
                    defer.resolve(data.profile);
                } else {
                    if (dataWrap.code == 8192) {}
                }
            }, function () {
                defer.reject();
            }, function () {
                defer.reject();
            });

            return defer.promise();
        }
    }]);

    return Profile;
}();

exports.default = Profile;

/***/ }),
/* 94 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": null,
    "options": {
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [{
        "name": "UserBalanceInfo",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "inBill",
            "id": 1
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "outDiamond",
            "id": 2
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "bill",
            "id": 3
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "diamond",
            "id": 4
        }]
    }, {
        "name": "ProfileInfo",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "uid",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "username",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "upliveCode",
            "id": 3
        }, {
            "rule": "optional",
            "type": "string",
            "name": "avatar",
            "id": 4
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "gender",
            "id": 5
        }, {
            "rule": "optional",
            "type": "string",
            "name": "setting",
            "id": 6
        }, {
            "rule": "optional",
            "type": "string",
            "name": "password",
            "id": 7
        }, {
            "rule": "optional",
            "type": "string",
            "name": "userToken",
            "id": 8
        }, {
            "rule": "optional",
            "type": "string",
            "name": "signature",
            "id": 9
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "grade",
            "id": 10
        }, {
            "rule": "optional",
            "type": "string",
            "name": "location",
            "id": 11
        }, {
            "rule": "optional",
            "type": "string",
            "name": "mobilePhone",
            "id": 12
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "fanTotal",
            "id": 13
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "followTotal",
            "id": 14
        }, {
            "rule": "optional",
            "type": "UserBalanceInfo",
            "name": "balance",
            "id": 15
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "chatroomid",
            "id": 16
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "followType",
            "id": 17
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "exp",
            "id": 18
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "currentExp",
            "id": 19
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "nextExp",
            "id": 20
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "officialAuth",
            "id": 21
        }, {
            "rule": "optional",
            "type": "string",
            "name": "officialAuthContent",
            "id": 22
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "qualityAuth",
            "id": 23
        }, {
            "rule": "optional",
            "type": "string",
            "name": "countryCode",
            "id": 25
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "admin",
            "id": 26
        }]
    }, {
        "name": "Profile",
        "fields": [],
        "messages": [{
            "name": "Get",
            "fields": [],
            "options": {
                "objc_class_prefix": "ProfileGet",
                "java_package": "com.asiainno.uplive.proto"
            },
            "messages": [{
                "name": "Request",
                "fields": [{
                    "rule": "optional",
                    "type": "int64",
                    "name": "vuid",
                    "id": 1
                }]
            }, {
                "name": "Response",
                "fields": [{
                    "rule": "optional",
                    "type": "ProfileInfo",
                    "name": "profile",
                    "id": 1
                }]
            }]
        }]
    }]
}).build();

exports.default = _root;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _public = __webpack_require__(7);

var _public2 = _interopRequireDefault(_public);

var _set = __webpack_require__(96);

var _set2 = _interopRequireDefault(_set);

var _pbajax = __webpack_require__(8);

var _pbajax2 = _interopRequireDefault(_pbajax);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var pbajax = new _pbajax2.default();

var ProfileSet = function () {
    function ProfileSet() {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, ProfileSet);

        this.promise = this.set(data);
    }

    _createClass(ProfileSet, [{
        key: 'set',
        value: function set(data) {
            var defer = $.Deferred();
            var businessData = new _set2.default.Profile.Set.Request(data);
            var ua = window.navigator.userAgent;

            var requestData = {
                service: 'service',
                api: '/profile/set',
                header: {
                    userToken: UpSDK.getUserToken(),
                    UserAgent: ua
                }
            };

            pbajax.do(requestData, businessData, function (res) {
                var dataWrap = _public2.default.Result.decode(res);
                var data = void 0;

                if (dataWrap.code == 1) {
                    defer.resolve(true);
                } else {
                    defer.reject();
                }
            }, function () {
                defer.reject();
            }, function () {
                defer.reject();
            });

            return defer.promise();
        }
    }]);

    return ProfileSet;
}();

exports.default = ProfileSet;

/***/ }),
/* 96 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": null,
    "options": {
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [{
        "name": "Profile",
        "fields": [],
        "messages": [{
            "name": "Set",
            "fields": [],
            "options": {
                "objc_class_prefix": "ProfileSet",
                "java_package": "com.asiainno.uplive.proto"
            },
            "messages": [{
                "name": "Request",
                "fields": [{
                    "rule": "optional",
                    "type": "string",
                    "name": "username",
                    "id": 1
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "setting",
                    "id": 2
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "upliveCode",
                    "id": 3
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "signature",
                    "id": 4
                }, {
                    "rule": "optional",
                    "type": "PushType",
                    "name": "pushType",
                    "id": 5
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "pushToken",
                    "id": 6
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "location",
                    "id": 7
                }, {
                    "rule": "optional",
                    "type": "int32",
                    "name": "gender",
                    "id": 8
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "language",
                    "id": 9
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "countryCode",
                    "id": 11
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "userRealNameAuthInfo",
                    "id": 12
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "acceptAgreement",
                    "id": 13
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "timeZone",
                    "id": 14
                }]
            }]
        }]
    }],
    "enums": [{
        "name": "BindType",
        "values": [{
            "name": "DEFAULT_TYPE",
            "id": 0
        }, {
            "name": "MOBILE_PHONE",
            "id": 1
        }, {
            "name": "QQ",
            "id": 2
        }, {
            "name": "WEIXIN",
            "id": 3
        }, {
            "name": "FACEBOOK",
            "id": 4
        }, {
            "name": "SINA_WEIBO",
            "id": 5
        }, {
            "name": "GOOGLE",
            "id": 15
        }, {
            "name": "TWITTER",
            "id": 16
        }, {
            "name": "EMAIL",
            "id": 17
        }]
    }, {
        "name": "PushType",
        "values": [{
            "name": "DEFAULT_PUSHTYPE",
            "id": 0
        }, {
            "name": "IOS",
            "id": 2
        }, {
            "name": "XIAOMI",
            "id": 4
        }, {
            "name": "GETUI",
            "id": 5
        }, {
            "name": "GOOGLE_PUSH",
            "id": 6
        }, {
            "name": "GOOGLE_FCM",
            "id": 10
        }]
    }]
}).build();
exports.default = _root;

/***/ }),
/* 97 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": null,
    "options": {
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [{
        "name": "WebAuth",
        "fields": [],
        "messages": [{
            "name": "AuthPro",
            "fields": [],
            "options": {
                "objc_class_prefix": "WebAuthAuthPro",
                "java_package": "com.asiainno.uplive.proto"
            },
            "messages": [{
                "name": "Request",
                "fields": [{
                    "rule": "optional",
                    "type": "string",
                    "name": "authcode",
                    "id": 1
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "feature",
                    "id": 2
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "channel",
                    "id": 3
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "deviceType",
                    "id": 4
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "version",
                    "id": 5
                }, {
                    "rule": "optional",
                    "type": "BindType",
                    "name": "type",
                    "id": 6
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "tokenSecret",
                    "id": 7
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "verifier",
                    "id": 8
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "callback",
                    "id": 9
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "state",
                    "id": 10
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "deviceId",
                    "id": 11
                }]
            }, {
                "name": "Response",
                "fields": [{
                    "rule": "optional",
                    "type": "int64",
                    "name": "uid",
                    "id": 1
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "userToken",
                    "id": 2
                }, {
                    "rule": "optional",
                    "type": "int32",
                    "name": "subscribe",
                    "id": 3
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "code",
                    "id": 4
                }]
            }]
        }]
    }],
    "enums": [{
        "name": "BindType",
        "values": [{
            "name": "DEFAULT_TYPE",
            "id": 0
        }, {
            "name": "MOBILE_PHONE",
            "id": 1
        }, {
            "name": "QQ",
            "id": 2
        }, {
            "name": "WEIXIN",
            "id": 3
        }, {
            "name": "FACEBOOK",
            "id": 4
        }, {
            "name": "SINA_WEIBO",
            "id": 5
        }, {
            "name": "RR",
            "id": 6
        }, {
            "name": "TENCENT_WANBA",
            "id": 7
        }, {
            "name": "KECHENGGEZI",
            "id": 8
        }, {
            "name": "DEVICE",
            "id": 9
        }, {
            "name": "GOOGLE",
            "id": 15
        }, {
            "name": "TWITTER",
            "id": 16
        }, {
            "name": "EMAIL",
            "id": 17
        }, {
            "name": "LINE_BIND",
            "id": 19
        }, {
            "name": "KAKAO",
            "id": 20
        }, {
            "name": "WEIXIN_MINI_PROGRAM",
            "id": 21
        }, {
            "name": "TELEGRAM",
            "id": 23
        }]
    }, {
        "name": "PushType",
        "values": [{
            "name": "DEFAULT_PUSHTYPE",
            "id": 0
        }, {
            "name": "BAIDU",
            "id": 1
        }, {
            "name": "IOS",
            "id": 2
        }, {
            "name": "JPUSH",
            "id": 3
        }, {
            "name": "XIAOMI",
            "id": 4
        }, {
            "name": "GETUI",
            "id": 5
        }, {
            "name": "GOOGLE_PUSH",
            "id": 6
        }, {
            "name": "SAMSUNG",
            "id": 7
        }, {
            "name": "MEIZU",
            "id": 8
        }, {
            "name": "HUAWEI",
            "id": 9
        }, {
            "name": "GOOGLE_FCM",
            "id": 10
        }]
    }, {
        "name": "LiveType",
        "values": [{
            "name": "PUBLIC_FREE",
            "id": 0
        }, {
            "name": "PUBLIC_CHARGE",
            "id": 1
        }, {
            "name": "PRIVATE_FREE",
            "id": 2
        }, {
            "name": "PRIVATE_CHARGE",
            "id": 3
        }]
    }]
}).build();
exports.default = _root;

/***/ }),
/* 98 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _cUpPbajax = __webpack_require__(43);

var _cUpPbajax2 = _interopRequireDefault(_cUpPbajax);

var _cPublicpb = __webpack_require__(129);

var _cPublicpb2 = _interopRequireDefault(_cPublicpb);

var _index = __webpack_require__(206);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pbajax = new _cUpPbajax2.default();
window.loginTimes = window.loginTimes || 0;

function getUserInfoByIdAndToken(uid, userToken) {
    var businessData = new _index2.default.Profile.Get.Request({ vuid: uid });
    return new Promise(function (resolve, reject) {
        pbajax.do({
            service: 'service',
            api: '/profile/get',
            header: { userToken: userToken }
        }, businessData, function (res) {
            var dataWrap = _cPublicpb2.default.Result.decode(res);
            var data = void 0;
            if (dataWrap.code === 1) {
                data = _index2.default.Profile.Get.Response.decode(dataWrap.data.value);
                resolve(data.profile);
            } else {
                reject(dataWrap.code);
            }
        }, reject, reject);
    });
}

function getUserInfo(uid) {
    return new Promise(function (resolve, reject) {
        getUserInfoByIdAndToken(uid, UG.getUser().userToken).then(resolve).catch(function (code) {
            if (code === 8192) {
                UG.router.replace('/login');
            } else {
                reject();
            }
        });
    });
}

function isValidUser(_ref) {
    var uid = _ref.uid,
        userToken = _ref.userToken;

    if (!uid || !userToken) {
        return Promise.resolve(false);
    }
    return new Promise(function (resolve) {
        getUserInfoByIdAndToken(uid, userToken).then(resolve).catch(function () {
            return resolve(false);
        });
    });
}

var Profile = {
    isValidUser: isValidUser,
    getUserInfo: getUserInfo,
    getUserInfoByIdAndToken: getUserInfoByIdAndToken
};

exports.default = Profile;

/***/ }),
/* 100 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": null,
    "options": {
        "objc_class_prefix": "GiftItemInfo",
        "java_package": "com.asiainno.uplive.proto.gift"
    },
    "messages": [{
        "name": "GiftItemInfo",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "itemId",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "itemName",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "itemDesc",
            "id": 3
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "updateTime",
            "id": 4
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "totalIncome",
            "id": 5
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "giftAmount",
            "id": 6
        }, {
            "rule": "repeated",
            "type": "Gift.ItemGiftList.GiftItemGiftList",
            "name": "giftList",
            "id": 7
        }, {
            "rule": "optional",
            "type": "string",
            "name": "gtoIncomes",
            "id": 8
        }]
    }, {
        "name": "Gift",
        "fields": [],
        "messages": [{
            "name": "ItemGiftList",
            "fields": [],
            "options": {
                "objc_class_prefix": "GiftItemGiftList",
                "java_package": "com.asiainno.uplive.proto.gift"
            },
            "messages": [{
                "name": "GiftItemGiftList",
                "fields": [{
                    "rule": "optional",
                    "type": "int32",
                    "name": "giftId",
                    "id": 1
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "name",
                    "id": 2
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "intro",
                    "id": 3
                }, {
                    "rule": "optional",
                    "type": "int32",
                    "name": "type",
                    "id": 4
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "url",
                    "id": 5
                }, {
                    "rule": "optional",
                    "type": "int32",
                    "name": "price",
                    "id": 6
                }, {
                    "rule": "optional",
                    "type": "int32",
                    "name": "experience",
                    "id": 7
                }, {
                    "rule": "optional",
                    "type": "bool",
                    "name": "canCombo",
                    "id": 8
                }, {
                    "rule": "optional",
                    "type": "int32",
                    "name": "version",
                    "id": 9
                }, {
                    "rule": "optional",
                    "type": "bool",
                    "name": "onLined",
                    "id": 10
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "countryCode",
                    "id": 11
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "language",
                    "id": 12
                }, {
                    "rule": "optional",
                    "type": "bool",
                    "name": "needLoad",
                    "id": 13
                }, {
                    "rule": "optional",
                    "type": "int32",
                    "name": "showType",
                    "id": 14
                }, {
                    "rule": "repeated",
                    "type": "GiftResourceInfo",
                    "name": "resources",
                    "id": 15
                }, {
                    "rule": "optional",
                    "type": "int32",
                    "name": "vipGrade",
                    "id": 16
                }, {
                    "rule": "optional",
                    "type": "int32",
                    "name": "playTimes",
                    "id": 17
                }, {
                    "rule": "optional",
                    "type": "int32",
                    "name": "produceType",
                    "id": 18
                }, {
                    "rule": "optional",
                    "type": "bool",
                    "name": "canSendToAllUsers",
                    "id": 19
                }, {
                    "rule": "optional",
                    "type": "int32",
                    "name": "timeLimit",
                    "id": 20
                }, {
                    "rule": "optional",
                    "type": "int32",
                    "name": "hostBill",
                    "id": 21
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "gtoPrice",
                    "id": 22
                }]
            }, {
                "name": "GiftResourceInfo",
                "fields": [{
                    "rule": "optional",
                    "type": "int32",
                    "name": "type",
                    "id": 1
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "url",
                    "id": 2
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "md5",
                    "id": 3
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "json",
                    "id": 4
                }]
            }]
        }, {
            "name": "ItemDetail",
            "fields": [],
            "options": {
                "objc_class_prefix": "GiftItemDetail",
                "java_package": "com.asiainno.uplive.proto.gift"
            },
            "messages": [{
                "name": "Request",
                "fields": [{
                    "rule": "optional",
                    "type": "int64",
                    "name": "itemId",
                    "id": 1
                }, {
                    "rule": "optional",
                    "type": "int64",
                    "name": "uid",
                    "id": 2
                }]
            }, {
                "name": "Response",
                "fields": [{
                    "rule": "optional",
                    "type": "GiftItemInfo",
                    "name": "itemInfos",
                    "id": 1
                }, {
                    "rule": "repeated",
                    "type": "AmountConfig",
                    "name": "amountConfigs",
                    "id": 2
                }]
            }, {
                "name": "AmountConfig",
                "fields": [{
                    "rule": "optional",
                    "type": "int32",
                    "name": "amount",
                    "id": 1
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "description",
                    "id": 2
                }]
            }]
        }]
    }]
}).build();
exports.default = _root;

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(16);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["createLocation"])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(103);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(58);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(157)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(107);
var test = {};
test[__webpack_require__(3)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(30)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(108);
var TAG = __webpack_require__(3)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 108 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 109 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(18) && !__webpack_require__(46)(function () {
  return Object.defineProperty(__webpack_require__(111)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(12);
var document = __webpack_require__(9).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(12);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(177)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(63)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var core = __webpack_require__(29);
var hide = __webpack_require__(31);
var redefine = __webpack_require__(30);
var ctx = __webpack_require__(47);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(33);
var dPs = __webpack_require__(180);
var enumBugKeys = __webpack_require__(118);
var IE_PROTO = __webpack_require__(64)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(111)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(185).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(181);
var enumBugKeys = __webpack_require__(118);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(61);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 118 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(188);
var getKeys = __webpack_require__(116);
var redefine = __webpack_require__(30);
var global = __webpack_require__(9);
var hide = __webpack_require__(31);
var Iterators = __webpack_require__(36);
var wks = __webpack_require__(3);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(32).f;
var create = __webpack_require__(115);
var redefineAll = __webpack_require__(122);
var ctx = __webpack_require__(47);
var anInstance = __webpack_require__(123);
var forOf = __webpack_require__(124);
var $iterDefine = __webpack_require__(63);
var step = __webpack_require__(120);
var setSpecies = __webpack_require__(194);
var DESCRIPTORS = __webpack_require__(18);
var fastKey = __webpack_require__(125).fastKey;
var validate = __webpack_require__(66);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(30);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(47);
var call = __webpack_require__(191);
var isArrayIter = __webpack_require__(192);
var anObject = __webpack_require__(33);
var toLength = __webpack_require__(117);
var getIterFn = __webpack_require__(193);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(45)('meta');
var isObject = __webpack_require__(12);
var has = __webpack_require__(34);
var setDesc = __webpack_require__(32).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(46)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(9);
var $export = __webpack_require__(114);
var redefine = __webpack_require__(30);
var redefineAll = __webpack_require__(122);
var meta = __webpack_require__(125);
var forOf = __webpack_require__(124);
var anInstance = __webpack_require__(123);
var isObject = __webpack_require__(12);
var fails = __webpack_require__(46);
var $iterDetect = __webpack_require__(195);
var setToStringTag = __webpack_require__(65);
var inheritIfRequired = __webpack_require__(196);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 127 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 128 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": null,
    "options": {
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [{
        "name": "Result",
        "fields": [{
            "rule": "optional",
            "type": "Code",
            "name": "code",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "msg",
            "id": 2
        }, {
            "rule": "optional",
            "type": "google.protobuf.Any",
            "name": "data",
            "id": 3
        }]
    }, {
        "name": "google",
        "fields": [],
        "messages": [{
            "name": "protobuf",
            "fields": [],
            "options": {
                "csharp_namespace": "Google.Protobuf.WellKnownTypes",
                "go_package": "github.com/golang/protobuf/ptypes/any",
                "java_package": "com.google.protobuf",
                "java_outer_classname": "AnyProto",
                "java_multiple_files": true,
                "java_generate_equals_and_hash": true,
                "objc_class_prefix": "GPB"
            },
            "messages": [{
                "name": "Any",
                "fields": [{
                    "rule": "optional",
                    "type": "string",
                    "name": "type_url",
                    "id": 1
                }, {
                    "rule": "optional",
                    "type": "bytes",
                    "name": "value",
                    "id": 2
                }]
            }]
        }]
    }],
    "enums": [{
        "name": "Code",
        "values": [{
            "name": "DEFAULT",
            "id": 0
        }, {
            "name": "SC_SUCCESS",
            "id": 1
        }, {
            "name": "SC_THIRD_PARTY_ALREADY_BIND",
            "id": 256
        }, {
            "name": "SC_THIRD_CHECK_USER_NOT_REGISTER",
            "id": 257
        }, {
            "name": "SC_NEED_BIND_PHONE",
            "id": 258
        }, {
            "name": "SC_PARAMETER_INVALID",
            "id": 4096
        }, {
            "name": "SC_ADMIN_NO_PERMISSION",
            "id": 4352
        }, {
            "name": "SC_ACCOUTN_USER_TOKEN_NOTMATCH",
            "id": 8192
        }, {
            "name": "SC_LOGINED_IN_OTHER_DEVICE",
            "id": 8193
        }, {
            "name": "SC_SMS_VERIFY_CODE_NOMOBILE",
            "id": 4097
        }, {
            "name": "SC_SMS_VERIFY_CODE_FAIL",
            "id": 4098
        }, {
            "name": "SC_SMS_VERIFY_CODE_NOTMATCH",
            "id": 4099
        }, {
            "name": "SC_ACCOUNT_MOBILE_PHONE_REPETITION",
            "id": 4100
        }, {
            "name": "SC_ACCOUNT_MOBILE_PHONE_ALLREADY_BIND",
            "id": 4101
        }, {
            "name": "SC_ACCOUTN_USER_NAME_FORBIDDEN",
            "id": 4102
        }, {
            "name": "SC_ACCOUTN_THIRD_CHECK_FAIL",
            "id": 4103
        }, {
            "name": "SC_ACCOUNT_USER_NAME_OVER_LONG",
            "id": 4104
        }, {
            "name": "SC_ACCOUNT_LIVE_CODE_OVER_LONG",
            "id": 4105
        }, {
            "name": "SC_ACCOUNT_LIVE_CODE_NOT_STANDARD",
            "id": 4112
        }, {
            "name": "SC_ACCOUNT_LIVE_CODE_EXIST",
            "id": 4113
        }, {
            "name": "SC_ACCOUNT_LIVE_UPDATE_FAIL",
            "id": 4114
        }, {
            "name": "SC_ACCOUNT_PASSWORD_ERROR",
            "id": 4115
        }, {
            "name": "SC_ACCOUNT_USER_NOT_EXIST",
            "id": 4116
        }, {
            "name": "SC_ACCOUNT_LIVE_CODE_TOO_SHORT",
            "id": 4117
        }, {
            "name": "SC_ACCOUNT_SIGNATURE_OVER_LONG",
            "id": 4118
        }, {
            "name": "SC_ACCOUTN_USER_FORBIDDEN",
            "id": 4119
        }, {
            "name": "SC_ACCOUNT_RANDOM_NOTEXIST",
            "id": 4120
        }, {
            "name": "SC_ACCOUNT_RANDOM_NOTSCAN",
            "id": 4121
        }, {
            "name": "SC_ACCOUNT_RANDOM_SCANNED",
            "id": 4128
        }, {
            "name": "SC_ACCOUNT_LIVE_CODE_NOLY_MODIFY_ONCE",
            "id": 4129
        }, {
            "name": "SC_ACCOUNT_USER_OR_PASSWORD_ERROR",
            "id": 4130
        }, {
            "name": "SC_EMAIL_SEND_OVER_LIMIT",
            "id": 4131
        }, {
            "name": "SC_EMAIL_VERIFY_INVALID",
            "id": 4132
        }, {
            "name": "SC_EMAIL_NOT_VERIFY",
            "id": 4133
        }, {
            "name": "SC_NEED_REGISTER",
            "id": 4134
        }, {
            "name": "SC_ACCOUNT_HAVE_NO_BIND_MOBILE",
            "id": 4135
        }, {
            "name": "SC_ACCOUNT_DID_FORBIDDEN",
            "id": 4136
        }, {
            "name": "SC_SMS_SEND_CODE_BEYOND_LIMIT",
            "id": 4137
        }, {
            "name": "SC_SENSITIVE_CONTENT",
            "id": 4609
        }, {
            "name": "SC_MALL_GIFT_NOT_EXIST",
            "id": 12289
        }, {
            "name": "SC_MALL_TRANSACTION_REPEATED",
            "id": 12290
        }, {
            "name": "SC_MALL_MONEY_NOT_ENOUGH",
            "id": 12291
        }, {
            "name": "SC_MALL_TRANSACTION_NOT_EXIST",
            "id": 12292
        }, {
            "name": "SC_MALL_PRODUCT_NOT_AVAILABLE",
            "id": 12293
        }, {
            "name": "SC_MALL_ORDER_NOT_EXIST",
            "id": 12294
        }, {
            "name": "SC_MALL_UNIFIED_ORDER_FAIL",
            "id": 12295
        }, {
            "name": "SC_MALL_PAY_FAIL",
            "id": 12296
        }, {
            "name": "SC_MALL_PAY_QUERY_FAIL",
            "id": 12297
        }, {
            "name": "SC_MALL_IAP_VALIDATE_FAIL",
            "id": 12298
        }, {
            "name": "SC_MALL_ORDER_EXIST_NOT_FINISHED",
            "id": 12299
        }, {
            "name": "SC_MALL_NOT_BIND_WECHAT",
            "id": 12300
        }, {
            "name": "SC_MALL_EXCEED_WITHDRAW_TIMES",
            "id": 12301
        }, {
            "name": "SC_MALL_EXCEED_WITHDRAW_QUOTA",
            "id": 12302
        }, {
            "name": "SC_MALL_WITHDRAW_FAIL",
            "id": 12303
        }, {
            "name": "SC_MALL_WITHDRAW_LESS_THAN_MIN",
            "id": 12304
        }, {
            "name": "SC_MALL_WITHDRAW_GREATER_THAN_MAX",
            "id": 12305
        }, {
            "name": "SC_MALL_WITHDRAW_FREQ_LIMIT",
            "id": 12306
        }, {
            "name": "SC_MALL_WITHDRAW_SENDNUM_LIMIT",
            "id": 12307
        }, {
            "name": "SC_MALL_NOT_BIND_PAYPAL",
            "id": 12308
        }, {
            "name": "SC_MALL_IAB_VALIDATE_FAIL",
            "id": 12309
        }, {
            "name": "SC_MALL_BUY_GUARD_DIAMOND_LOW",
            "id": 12310
        }, {
            "name": "SC_MALL_TRANSLATE_NOT_SUPPORT",
            "id": 12311
        }, {
            "name": "SC_MALL_TRANSLATE_CLOSED",
            "id": 12312
        }, {
            "name": "SC_MALL_GIFT_SEND_VIP_LIMIT",
            "id": 12313
        }, {
            "name": "SC_MALL_GIFT_NOT_ALLOW",
            "id": 12320
        }, {
            "name": "SC_MALL_GIFT_NEED_RECHARGE",
            "id": 12321
        }, {
            "name": "SC_MALL_ACC_BILL_NOT_ENOUGH",
            "id": 12322
        }, {
            "name": "SC_MALL_USER_FROZEN",
            "id": 12323
        }, {
            "name": "SC_MALL_RECHARGE_REPEAT",
            "id": 12324
        }, {
            "name": "SC_MALL_RECHARGE_REWARD_REPEAT",
            "id": 12325
        }, {
            "name": "SC_MALL_RECHARGE_REWARD_INVALID",
            "id": 12326
        }, {
            "name": "SC_MALL_SHAREREDPACKET_TOTALAMOUNT_INVALID",
            "id": 12327
        }, {
            "name": "SC_MALL_SHAREREDPACKET_SPLITNUM_INVALID",
            "id": 12328
        }, {
            "name": "SC_MALL_SHAREREDPACKET_SPLITAMOUNT_INVALID",
            "id": 12329
        }, {
            "name": "SC_MALL_GOODS_NOT_EXIST",
            "id": 12336
        }, {
            "name": "SC_MALL_BROADCAST_NOT_OPEN",
            "id": 12337
        }, {
            "name": "SC_MALL_FIXEDCONTENT_NOT_EXIST",
            "id": 12338
        }, {
            "name": "SC_RANKING_VIP_INVISIBLE_LIMIT",
            "id": 14593
        }, {
            "name": "SC_RANKING_VIP_INVISIBLE_OFF",
            "id": 14594
        }, {
            "name": "SC_CONTACT_ALREADY_FRIEND",
            "id": 16385
        }, {
            "name": "SC_LIVE_ROOM_NOT_EXIST",
            "id": 20481
        }, {
            "name": "SC_LIVE_ROOM_DISABLED",
            "id": 20482
        }, {
            "name": "SC_LIVE_ROOM_NO_PERMISSION",
            "id": 20483
        }, {
            "name": "SC_LIVE_ROOM_USER_GRADE_NOT_ENOUGH",
            "id": 20484
        }, {
            "name": "SC_LIVE_ROOM_SPECIAL_NOT_CREATE",
            "id": 20485
        }, {
            "name": "SC_LIVE_ROOM_ADMIN_SHUTUP_FAIL",
            "id": 20486
        }, {
            "name": "SC_LIVE_ROOM_ADMIN_LIFTED_FAIL",
            "id": 20487
        }, {
            "name": "SC_LIVE_ROOM_ADMIN_SHUTUP_UIDS_ERROR",
            "id": 20488
        }, {
            "name": "SC_LIVE_ROOM_NO_TEL_AUTH",
            "id": 20489
        }, {
            "name": "SC_LIVE_ROOM_FORCED_OUT",
            "id": 20490
        }, {
            "name": "SC_LIVE_ROOM_POLICY_DISABLED",
            "id": 20491
        }, {
            "name": "SC_LIVE_ROOM_RID_UID_NOTMATCH",
            "id": 20492
        }, {
            "name": "SC_LIVE_ROOM_NO_REALNAME_AUTH",
            "id": 20496
        }, {
            "name": "SC_LIVE_ROOM_NOT_IN_MULTILIVE",
            "id": 20497
        }, {
            "name": "SC_LIVE_ROOM_PAY_FAILED",
            "id": 20498
        }, {
            "name": "SC_LIVE_ROOM_CANNOT_MULTILIVE",
            "id": 20499
        }, {
            "name": "SC_LIVE_ROOM_MULTILIVE_MEMBERS_LIMIT",
            "id": 20500
        }, {
            "name": "SC_LIVE_ROOM_MULTILIVE_CREATE_MEETINGROOM_FAILED",
            "id": 20501
        }, {
            "name": "SC_LIVE_ROOM_MULTILIVE_FINISH",
            "id": 20502
        }, {
            "name": "SC_LIVE_ROOM_IS_LIVING",
            "id": 20503
        }, {
            "name": "SC_LIVE_ROOM_PRIVATELIVE_NOT_ALLOW",
            "id": 20504
        }, {
            "name": "SC_LIVE_ROOM_CHARGE_NOT_ALLOW",
            "id": 20505
        }, {
            "name": "SC_LIVE_ROOM_CHARGE_BELOW_MIN",
            "id": 20506
        }, {
            "name": "SC_LIVE_ROOM_AUDIENCE_LIMIT_ALLOW",
            "id": 20507
        }, {
            "name": "SC_LIVE_ROOM_LIVE_NEED_CHARGE",
            "id": 20508
        }, {
            "name": "SC_LIVE_ROOM_NUMBER_REACHED_TOPLIMIT",
            "id": 20512
        }, {
            "name": "SC_LIVE_ROOM_VOICE_NOT_ALLOW",
            "id": 20513
        }, {
            "name": "SC_LIVE_ROOM_USER_NOT_ONLINE",
            "id": 20514
        }, {
            "name": "SC_LIVE_ROOM_APPLY_MULTILIVE_NOT_ALLOW",
            "id": 20515
        }, {
            "name": "SC_ACTIVITY_SEND_DIAMOND_TIME_END",
            "id": 24577
        }, {
            "name": "SC_ACTIVITY_SEND_DIAMOND_OVER_LIMIT",
            "id": 24578
        }, {
            "name": "SC_ACTIVITY_SEND_DIAMOND_ALREADY",
            "id": 24579
        }, {
            "name": "SC_ACTIVITY_NO_RECHARGE",
            "id": 24580
        }, {
            "name": "SC_ACTIVITY_NOT_CONDITIONS",
            "id": 24581
        }, {
            "name": "SC_SYSTEM_ERROR",
            "id": 16777215
        }, {
            "name": "SC_ZMXY_AUTH_BIND_SUCCESS",
            "id": 28673
        }, {
            "name": "SC_ZMXY_AUTH_HAS_BEEN_USEED",
            "id": 28674
        }, {
            "name": "SC_ZMXY_AUTH_HAS_BIND",
            "id": 28675
        }, {
            "name": "SC_ZMXY_AUTH_ERROR",
            "id": 28676
        }, {
            "name": "SC_REDPACKET_OVERDUE_ERROR",
            "id": 32769
        }, {
            "name": "SC_REDPACKET_DISTRIBUTED_ERROR",
            "id": 32770
        }, {
            "name": "SC_REDPACKET_REPEAT_ERROR",
            "id": 32771
        }, {
            "name": "SC_PERMISSIONUSE_NOT_ALLOW",
            "id": 36865
        }, {
            "name": "SC_PERMISSIONUSE_LOW_PERMISSION",
            "id": 36866
        }, {
            "name": "SC_PERMISSIONUSE_OVER_ROOMMAX",
            "id": 36867
        }, {
            "name": "SC_PERMISSIONUSE_OVER_DAYMAX",
            "id": 36868
        }, {
            "name": "SC_PERMISSIONUSE_OVER_ADD_LIMIT",
            "id": 36869
        }, {
            "name": "SC_PERMISSIONUSE_ERROR",
            "id": 36870
        }, {
            "name": "SC_PERMISSIONUSE_REPEAT_ERROR",
            "id": 36871
        }, {
            "name": "SC_ACTIVITY_EXCHANGE_REPEATED",
            "id": 65537
        }, {
            "name": "SC_ACTIVITY_POINT_NOT_ENOUGH",
            "id": 65538
        }, {
            "name": "SC_PACK_TRANSACTION_REPEATED",
            "id": 69633
        }, {
            "name": "SC_PACK_GIFT_NOT_AVAILABLE",
            "id": 69634
        }, {
            "name": "SC_PACK_GIFT_EXPIRE",
            "id": 69635
        }, {
            "name": "SC_PACK_TRANSACTION_NOT_EXIST",
            "id": 69636
        }, {
            "name": "SC_PACK_FULL",
            "id": 69637
        }, {
            "name": "SC_DYNAMIC_COMMENT_FREQUENCY_LIMITED",
            "id": 73729
        }, {
            "name": "SC_DYNAMIC_COMMENT_WORDS_OVER_LONG",
            "id": 73730
        }, {
            "name": "SC_DYNAMIC_NOT_EXIST_OR_DELETED",
            "id": 73731
        }, {
            "name": "SC_DYNAMIC_HAS_NO_RIGHT",
            "id": 73732
        }, {
            "name": "SC_DYNAMIC_IN_CALCULATION",
            "id": 73733
        }, {
            "name": "SC_DYNAMIC_EMPTY_NEED_GET_RECOMMEND_ANCHOR",
            "id": 73734
        }, {
            "name": "SC_DYNAMIC_LIMIT_FREQUENTLY_REPEAT_COMMENT",
            "id": 73735
        }, {
            "name": "SC_DYNAMIC_NOT_VIDEO_COMMENT",
            "id": 73736
        }, {
            "name": "SC_CHECKIN_ALREADY",
            "id": 77825
        }, {
            "name": "SC_FAN_GROUP_TITLE_CHANGE_POINT_NOT_ENOUGH",
            "id": 94465
        }, {
            "name": "SC_FAN_GROUP_NOT_EXIST",
            "id": 94466
        }, {
            "name": "SC_FAN_GROUP_NOT_FAN",
            "id": 94467
        }, {
            "name": "SC_FAN_GROUP_SELF_JOIN_ERROR",
            "id": 94468
        }, {
            "name": "SC_FAN_TASK_NOT_EXIST",
            "id": 94469
        }, {
            "name": "SC_FAN_TASK_TYPE_NOT_EXIST",
            "id": 94470
        }, {
            "name": "SC_FAN_TASK_MAXIMUM_TIME_REACHED",
            "id": 94471
        }, {
            "name": "SC_FAN_PERMISSION_NO",
            "id": 94472
        }, {
            "name": "SC_ACTIVITY_REWARD_ALREADY",
            "id": 81921
        }, {
            "name": "SC_ACTIVITY_REWARD_CANNOT",
            "id": 81922
        }, {
            "name": "SC_RANKING_GAME_NOTAUTHORITY",
            "id": 86017
        }, {
            "name": "IM_SYSTEM_ERROR",
            "id": 90113
        }, {
            "name": "IM_CREATE_PERMISSION_DENIED",
            "id": 90114
        }, {
            "name": "IM_BEYOND_GROUP_NUM_LIMIT",
            "id": 90115
        }, {
            "name": "IM_BEYOND_GROUP_USER_NUM_LIMIT",
            "id": 90116
        }, {
            "name": "IM_PERMISSION_DENIED",
            "id": 90117
        }, {
            "name": "IM_GROUP_INVALID",
            "id": 90118
        }, {
            "name": "IM_INVITE_INVALID",
            "id": 90119
        }, {
            "name": "SC_FOLLOW_YOU_ARE_IN_OTHERS_BLACKLIST",
            "id": 98305
        }, {
            "name": "SC_FOLLOW_ALREADY_REACH_MAX_FOLLOW",
            "id": 98306
        }, {
            "name": "SC_GIFTITEM_SAMENAME",
            "id": 98307
        }]
    }]
}).build();

exports.default = _root;

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = TopbarNav;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(214);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 通用顶部导航
 *  title  title，可以不写
 *  children 孩子，配置右上角的工具
 *  leftTool 左侧工具的功能 ，可选项是  back ， close  null  不显示
 *  onBack 返回操作
 *  onClose 关闭操作
 *  {*}
 * @constructor
 */
function TopbarNav(props) {
    var title = props.title,
        children = props.children,
        _props$bordered = props.bordered,
        bordered = _props$bordered === undefined ? false : _props$bordered,
        _props$leftTool = props.leftTool,
        leftTool = _props$leftTool === undefined ? 'back' : _props$leftTool,
        _props$onBack = props.onBack,
        onBack = _props$onBack === undefined ? function () {
        window.history.back();
    } : _props$onBack,
        _props$onClose = props.onClose,
        onClose = _props$onClose === undefined ? function () {} : _props$onClose;

    var leftToolComp = _react2.default.createElement('div', { className: 'topbar-back', onClick: onBack });

    if (UG.isUplive) {
        leftToolComp = _react2.default.createElement(
            'div',
            { className: 'topbar-back', 'data-show': 'uplive', onClick: onBack },
            UG.lang.template('Previous page')
        );
    }

    if (leftTool === 'close') {
        leftToolComp = _react2.default.createElement('div', { className: 'topbar-close', onClick: onClose });
    }
    if (leftTool === 'null') {
        leftToolComp = _react2.default.createElement('div', { className: 'topbar-tool-null' });
    }

    return _react2.default.createElement(
        'div',
        { className: bordered ? 'topbar-nav bordered' : 'topbar-nav' },
        leftToolComp,
        _react2.default.createElement(
            'div',
            { className: 'topbar-title text-center' },
            UG.isUplive ? null : title
        ),
        _react2.default.createElement(
            'div',
            { className: 'topbar-tool' },
            children
        )
    );
}

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.GiftoIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactSvg = __webpack_require__(223);

var _reactSvg2 = _interopRequireDefault(_reactSvg);

__webpack_require__(227);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 使用SVG显示GIFTO的ICON
 * @param size
 * @param type 展示的形式
 * @param style
 * @constructor
 */
function GiftoIcon() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$size = _ref.size,
        size = _ref$size === undefined ? '0.625rem' : _ref$size,
        _ref$type = _ref.type,
        type = _ref$type === undefined ? 'normal' : _ref$type,
        _ref$style = _ref.style,
        style = _ref$style === undefined ? {} : _ref$style;

    //  所有的图标配置
    var svgList = {
        normal: '//g.cdn.pengpengla.com/oauthgame/html5/20180329/logo_1.svg', //  紫色的北京
        pink: '//g.cdn.pengpengla.com/oauthgame/html5/20180411/logo_pink.svg' //  粉色的背景
    };

    type = svgList[type] ? type : 'normal';

    return _react2.default.createElement(_reactSvg2.default, { className: 'gift-icon', style: _extends({ width: size, height: size }, style), path: svgList[type] });
}

exports.GiftoIcon = GiftoIcon;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(42);

var _reactDom2 = _interopRequireDefault(_reactDom);

__webpack_require__(208);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Modal(props) {
    var _props$title = props.title,
        title = _props$title === undefined ? '' : _props$title,
        _props$showHeader = props.showHeader,
        showHeader = _props$showHeader === undefined ? true : _props$showHeader,
        _props$showClose = props.showClose,
        showClose = _props$showClose === undefined ? true : _props$showClose,
        children = props.children,
        _props$onCloseClick = props.onCloseClick,
        onCloseClick = _props$onCloseClick === undefined ? function (e) {
        return e;
    } : _props$onCloseClick;


    var header = null,
        modalCls = 'modal animated bounceIn';
    if (showHeader) {
        header = _react2.default.createElement(
            'div',
            { className: 'modal-header' },
            _react2.default.createElement(
                'h3',
                { className: 'modal-title text-center' },
                title
            ),
            showClose ? _react2.default.createElement('span', { className: 'modal-close text-center', onClick: onCloseClick }) : null
        );
    }
    if (!title && showHeader) {
        //  content的padding需要减少一下
        modalCls = 'modal modal-empty-header animated bounceIn';
    }
    return _react2.default.createElement(
        'div',
        {
            className: 'modal-backdrop' },
        _react2.default.createElement(
            'div',
            { className: modalCls },
            header,
            _react2.default.createElement(
                'div',
                { className: 'modal-content' },
                children
            )
        )
    );
}

// 自动创建节点，显示的时候创建，不显示的时候直接销毁就OK
// 使用单例，防止页面由多个弹出框
// 全局存储的元素和react元素，重新打开的时候需要销毁之前的实例
var el = null,
    element = null;

/**
 * 此处需要优化
 * @param title 显示的title
 * @param children
 * @param showHeader 显示头部
 * @param extraClass 扩展的css类，用来扩展的
 * @param showClose 显示右上角的关闭按钮
 * @returns {function()}
 */
var create = function create(title, children) {
    var showHeader = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var extraClass = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    var showClose = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

    destroy();
    // 重新创建下el和element
    el = document.createElement('div');
    extraClass && el.classList.add(extraClass);
    document.body.appendChild(el);
    element = _reactDom2.default.render(_react2.default.createElement(
        Modal,
        { title: title, showHeader: showHeader, showClose: showClose, onCloseClick: destroy },
        children
    ), el);
    return destroy; //  执行返回的对象可以销毁这个框框
};

var createNoHeader = function createNoHeader(children) {
    var extraClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    return create('', children, false, extraClass);
};

var destroy = function destroy() {
    if (el) {
        var classList = el.querySelector('.modal').classList;
        classList.remove('bounceIn');
        classList.add('bounceOut');
    }
    if (element || el) {
        setTimeout(function () {
            if (element) {
                _reactDom2.default.unmountComponentAtNode(el);
                element = null;
            }
            if (el) {
                document.body.removeChild(el);
                el = null;
            }
        }, 250);
    }
};

//  监听esc键，关闭弹窗
var modalListen = window.modalListen;
if (!modalListen) {
    document.addEventListener('keyup', function (e) {
        if (e.keyCode === 27) {
            destroy();
        }
    });
    window.modalListen = true;
}

exports.default = {
    create: create,
    createNoHeader: createNoHeader,
    destroy: destroy
};

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! iScroll v5.2.0 ~ (c) 2008-2016 Matteo Spinelli ~ http://cubiq.org/license */
(function (window, document, Math) {
var rAF = window.requestAnimationFrame	||
	window.webkitRequestAnimationFrame	||
	window.mozRequestAnimationFrame		||
	window.oRequestAnimationFrame		||
	window.msRequestAnimationFrame		||
	function (callback) { window.setTimeout(callback, 1000 / 60); };

var utils = (function () {
	var me = {};

	var _elementStyle = document.createElement('div').style;
	var _vendor = (function () {
		var vendors = ['t', 'webkitT', 'MozT', 'msT', 'OT'],
			transform,
			i = 0,
			l = vendors.length;

		for ( ; i < l; i++ ) {
			transform = vendors[i] + 'ransform';
			if ( transform in _elementStyle ) return vendors[i].substr(0, vendors[i].length-1);
		}

		return false;
	})();

	function _prefixStyle (style) {
		if ( _vendor === false ) return false;
		if ( _vendor === '' ) return style;
		return _vendor + style.charAt(0).toUpperCase() + style.substr(1);
	}

	me.getTime = Date.now || function getTime () { return new Date().getTime(); };

	me.extend = function (target, obj) {
		for ( var i in obj ) {
			target[i] = obj[i];
		}
	};

	me.addEvent = function (el, type, fn, capture) {
		el.addEventListener(type, fn, !!capture);
	};

	me.removeEvent = function (el, type, fn, capture) {
		el.removeEventListener(type, fn, !!capture);
	};

	me.prefixPointerEvent = function (pointerEvent) {
		return window.MSPointerEvent ?
			'MSPointer' + pointerEvent.charAt(7).toUpperCase() + pointerEvent.substr(8):
			pointerEvent;
	};

	me.momentum = function (current, start, time, lowerMargin, wrapperSize, deceleration) {
		var distance = current - start,
			speed = Math.abs(distance) / time,
			destination,
			duration;

		deceleration = deceleration === undefined ? 0.0006 : deceleration;

		destination = current + ( speed * speed ) / ( 2 * deceleration ) * ( distance < 0 ? -1 : 1 );
		duration = speed / deceleration;

		if ( destination < lowerMargin ) {
			destination = wrapperSize ? lowerMargin - ( wrapperSize / 2.5 * ( speed / 8 ) ) : lowerMargin;
			distance = Math.abs(destination - current);
			duration = distance / speed;
		} else if ( destination > 0 ) {
			destination = wrapperSize ? wrapperSize / 2.5 * ( speed / 8 ) : 0;
			distance = Math.abs(current) + destination;
			duration = distance / speed;
		}

		return {
			destination: Math.round(destination),
			duration: duration
		};
	};

	var _transform = _prefixStyle('transform');

	me.extend(me, {
		hasTransform: _transform !== false,
		hasPerspective: _prefixStyle('perspective') in _elementStyle,
		hasTouch: 'ontouchstart' in window,
		hasPointer: !!(window.PointerEvent || window.MSPointerEvent), // IE10 is prefixed
		hasTransition: _prefixStyle('transition') in _elementStyle
	});

	/*
	This should find all Android browsers lower than build 535.19 (both stock browser and webview)
	- galaxy S2 is ok
    - 2.3.6 : `AppleWebKit/533.1 (KHTML, like Gecko) Version/4.0 Mobile Safari/533.1`
    - 4.0.4 : `AppleWebKit/534.30 (KHTML, like Gecko) Version/4.0 Mobile Safari/534.30`
   - galaxy S3 is badAndroid (stock brower, webview)
     `AppleWebKit/534.30 (KHTML, like Gecko) Version/4.0 Mobile Safari/534.30`
   - galaxy S4 is badAndroid (stock brower, webview)
     `AppleWebKit/534.30 (KHTML, like Gecko) Version/4.0 Mobile Safari/534.30`
   - galaxy S5 is OK
     `AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Mobile Safari/537.36 (Chrome/)`
   - galaxy S6 is OK
     `AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Mobile Safari/537.36 (Chrome/)`
  */
	me.isBadAndroid = (function() {
		var appVersion = window.navigator.appVersion;
		// Android browser is not a chrome browser.
		if (/Android/.test(appVersion) && !(/Chrome\/\d/.test(appVersion))) {
			var safariVersion = appVersion.match(/Safari\/(\d+.\d)/);
			if(safariVersion && typeof safariVersion === "object" && safariVersion.length >= 2) {
				return parseFloat(safariVersion[1]) < 535.19;
			} else {
				return true;
			}
		} else {
			return false;
		}
	})();

	me.extend(me.style = {}, {
		transform: _transform,
		transitionTimingFunction: _prefixStyle('transitionTimingFunction'),
		transitionDuration: _prefixStyle('transitionDuration'),
		transitionDelay: _prefixStyle('transitionDelay'),
		transformOrigin: _prefixStyle('transformOrigin')
	});

	me.hasClass = function (e, c) {
		var re = new RegExp("(^|\\s)" + c + "(\\s|$)");
		return re.test(e.className);
	};

	me.addClass = function (e, c) {
		if ( me.hasClass(e, c) ) {
			return;
		}

		var newclass = e.className.split(' ');
		newclass.push(c);
		e.className = newclass.join(' ');
	};

	me.removeClass = function (e, c) {
		if ( !me.hasClass(e, c) ) {
			return;
		}

		var re = new RegExp("(^|\\s)" + c + "(\\s|$)", 'g');
		e.className = e.className.replace(re, ' ');
	};

	me.offset = function (el) {
		var left = -el.offsetLeft,
			top = -el.offsetTop;

		// jshint -W084
		while (el = el.offsetParent) {
			left -= el.offsetLeft;
			top -= el.offsetTop;
		}
		// jshint +W084

		return {
			left: left,
			top: top
		};
	};

	me.preventDefaultException = function (el, exceptions) {
		for ( var i in exceptions ) {
			if ( exceptions[i].test(el[i]) ) {
				return true;
			}
		}

		return false;
	};

	me.extend(me.eventType = {}, {
		touchstart: 1,
		touchmove: 1,
		touchend: 1,

		mousedown: 2,
		mousemove: 2,
		mouseup: 2,

		pointerdown: 3,
		pointermove: 3,
		pointerup: 3,

		MSPointerDown: 3,
		MSPointerMove: 3,
		MSPointerUp: 3
	});

	me.extend(me.ease = {}, {
		quadratic: {
			style: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
			fn: function (k) {
				return k * ( 2 - k );
			}
		},
		circular: {
			style: 'cubic-bezier(0.1, 0.57, 0.1, 1)',	// Not properly "circular" but this looks better, it should be (0.075, 0.82, 0.165, 1)
			fn: function (k) {
				return Math.sqrt( 1 - ( --k * k ) );
			}
		},
		back: {
			style: 'cubic-bezier(0.175, 0.885, 0.32, 1.275)',
			fn: function (k) {
				var b = 4;
				return ( k = k - 1 ) * k * ( ( b + 1 ) * k + b ) + 1;
			}
		},
		bounce: {
			style: '',
			fn: function (k) {
				if ( ( k /= 1 ) < ( 1 / 2.75 ) ) {
					return 7.5625 * k * k;
				} else if ( k < ( 2 / 2.75 ) ) {
					return 7.5625 * ( k -= ( 1.5 / 2.75 ) ) * k + 0.75;
				} else if ( k < ( 2.5 / 2.75 ) ) {
					return 7.5625 * ( k -= ( 2.25 / 2.75 ) ) * k + 0.9375;
				} else {
					return 7.5625 * ( k -= ( 2.625 / 2.75 ) ) * k + 0.984375;
				}
			}
		},
		elastic: {
			style: '',
			fn: function (k) {
				var f = 0.22,
					e = 0.4;

				if ( k === 0 ) { return 0; }
				if ( k == 1 ) { return 1; }

				return ( e * Math.pow( 2, - 10 * k ) * Math.sin( ( k - f / 4 ) * ( 2 * Math.PI ) / f ) + 1 );
			}
		}
	});

	me.tap = function (e, eventName) {
		var ev = document.createEvent('Event');
		ev.initEvent(eventName, true, true);
		ev.pageX = e.pageX;
		ev.pageY = e.pageY;
		e.target.dispatchEvent(ev);
	};

	me.click = function (e) {
		var target = e.target,
			ev;

		if ( !(/(SELECT|INPUT|TEXTAREA)/i).test(target.tagName) ) {
			ev = document.createEvent('MouseEvents');
			ev.initMouseEvent('click', true, true, e.view, 1,
				target.screenX, target.screenY, target.clientX, target.clientY,
				e.ctrlKey, e.altKey, e.shiftKey, e.metaKey,
				0, null);

			ev._constructed = true;
			target.dispatchEvent(ev);
		}
	};

	return me;
})();
function IScroll (el, options) {
	this.wrapper = typeof el == 'string' ? document.querySelector(el) : el;
	this.scroller = this.wrapper.children[0];
	this.scrollerStyle = this.scroller.style;		// cache style for better performance

	this.options = {

		resizeScrollbars: true,

		mouseWheelSpeed: 20,

		snapThreshold: 0.334,

// INSERT POINT: OPTIONS
		disablePointer : !utils.hasPointer,
		disableTouch : utils.hasPointer || !utils.hasTouch,
		disableMouse : utils.hasPointer || utils.hasTouch,
		startX: 0,
		startY: 0,
		scrollY: true,
		directionLockThreshold: 5,
		momentum: true,

		bounce: true,
		bounceTime: 600,
		bounceEasing: '',

		preventDefault: true,
		preventDefaultException: { tagName: /^(INPUT|TEXTAREA|BUTTON|SELECT)$/ },

		HWCompositing: true,
		useTransition: true,
		useTransform: true,
		bindToWrapper: typeof window.onmousedown === "undefined"
	};

	for ( var i in options ) {
		this.options[i] = options[i];
	}

	// Normalize options
	this.translateZ = this.options.HWCompositing && utils.hasPerspective ? ' translateZ(0)' : '';

	this.options.useTransition = utils.hasTransition && this.options.useTransition;
	this.options.useTransform = utils.hasTransform && this.options.useTransform;

	this.options.eventPassthrough = this.options.eventPassthrough === true ? 'vertical' : this.options.eventPassthrough;
	this.options.preventDefault = !this.options.eventPassthrough && this.options.preventDefault;

	// If you want eventPassthrough I have to lock one of the axes
	this.options.scrollY = this.options.eventPassthrough == 'vertical' ? false : this.options.scrollY;
	this.options.scrollX = this.options.eventPassthrough == 'horizontal' ? false : this.options.scrollX;

	// With eventPassthrough we also need lockDirection mechanism
	this.options.freeScroll = this.options.freeScroll && !this.options.eventPassthrough;
	this.options.directionLockThreshold = this.options.eventPassthrough ? 0 : this.options.directionLockThreshold;

	this.options.bounceEasing = typeof this.options.bounceEasing == 'string' ? utils.ease[this.options.bounceEasing] || utils.ease.circular : this.options.bounceEasing;

	this.options.resizePolling = this.options.resizePolling === undefined ? 60 : this.options.resizePolling;

	if ( this.options.tap === true ) {
		this.options.tap = 'tap';
	}

	if ( this.options.shrinkScrollbars == 'scale' ) {
		this.options.useTransition = false;
	}

	this.options.invertWheelDirection = this.options.invertWheelDirection ? -1 : 1;

// INSERT POINT: NORMALIZATION

	// Some defaults
	this.x = 0;
	this.y = 0;
	this.directionX = 0;
	this.directionY = 0;
	this._events = {};

// INSERT POINT: DEFAULTS

	this._init();
	this.refresh();

	this.scrollTo(this.options.startX, this.options.startY);
	this.enable();
}

IScroll.prototype = {
	version: '5.2.0',

	_init: function () {
		this._initEvents();

		if ( this.options.scrollbars || this.options.indicators ) {
			this._initIndicators();
		}

		if ( this.options.mouseWheel ) {
			this._initWheel();
		}

		if ( this.options.snap ) {
			this._initSnap();
		}

		if ( this.options.keyBindings ) {
			this._initKeys();
		}

// INSERT POINT: _init

	},

	destroy: function () {
		this._initEvents(true);
		clearTimeout(this.resizeTimeout);
 		this.resizeTimeout = null;
		this._execEvent('destroy');
	},

	_transitionEnd: function (e) {
		if ( e.target != this.scroller || !this.isInTransition ) {
			return;
		}

		this._transitionTime();
		if ( !this.resetPosition(this.options.bounceTime) ) {
			this.isInTransition = false;
			this._execEvent('scrollEnd');
		}
	},

	_start: function (e) {
		// React to left mouse button only
		if ( utils.eventType[e.type] != 1 ) {
		  // for button property
		  // http://unixpapa.com/js/mouse.html
		  var button;
	    if (!e.which) {
	      /* IE case */
	      button = (e.button < 2) ? 0 :
	               ((e.button == 4) ? 1 : 2);
	    } else {
	      /* All others */
	      button = e.button;
	    }
			if ( button !== 0 ) {
				return;
			}
		}

		if ( !this.enabled || (this.initiated && utils.eventType[e.type] !== this.initiated) ) {
			return;
		}

		if ( this.options.preventDefault && !utils.isBadAndroid && !utils.preventDefaultException(e.target, this.options.preventDefaultException) ) {
			e.preventDefault();
		}

		var point = e.touches ? e.touches[0] : e,
			pos;

		this.initiated	= utils.eventType[e.type];
		this.moved		= false;
		this.distX		= 0;
		this.distY		= 0;
		this.directionX = 0;
		this.directionY = 0;
		this.directionLocked = 0;

		this.startTime = utils.getTime();

		if ( this.options.useTransition && this.isInTransition ) {
			this._transitionTime();
			this.isInTransition = false;
			pos = this.getComputedPosition();
			this._translate(Math.round(pos.x), Math.round(pos.y));
			this._execEvent('scrollEnd');
		} else if ( !this.options.useTransition && this.isAnimating ) {
			this.isAnimating = false;
			this._execEvent('scrollEnd');
		}

		this.startX    = this.x;
		this.startY    = this.y;
		this.absStartX = this.x;
		this.absStartY = this.y;
		this.pointX    = point.pageX;
		this.pointY    = point.pageY;

		this._execEvent('beforeScrollStart');
	},

	_move: function (e) {
		if ( !this.enabled || utils.eventType[e.type] !== this.initiated ) {
			return;
		}

		if ( this.options.preventDefault ) {	// increases performance on Android? TODO: check!
			e.preventDefault();
		}

		var point		= e.touches ? e.touches[0] : e,
			deltaX		= point.pageX - this.pointX,
			deltaY		= point.pageY - this.pointY,
			timestamp	= utils.getTime(),
			newX, newY,
			absDistX, absDistY;

		this.pointX		= point.pageX;
		this.pointY		= point.pageY;

		this.distX		+= deltaX;
		this.distY		+= deltaY;
		absDistX		= Math.abs(this.distX);
		absDistY		= Math.abs(this.distY);

		// We need to move at least 10 pixels for the scrolling to initiate
		if ( timestamp - this.endTime > 300 && (absDistX < 10 && absDistY < 10) ) {
			return;
		}

		// If you are scrolling in one direction lock the other
		if ( !this.directionLocked && !this.options.freeScroll ) {
			if ( absDistX > absDistY + this.options.directionLockThreshold ) {
				this.directionLocked = 'h';		// lock horizontally
			} else if ( absDistY >= absDistX + this.options.directionLockThreshold ) {
				this.directionLocked = 'v';		// lock vertically
			} else {
				this.directionLocked = 'n';		// no lock
			}
		}

		if ( this.directionLocked == 'h' ) {
			if ( this.options.eventPassthrough == 'vertical' ) {
				e.preventDefault();
			} else if ( this.options.eventPassthrough == 'horizontal' ) {
				this.initiated = false;
				return;
			}

			deltaY = 0;
		} else if ( this.directionLocked == 'v' ) {
			if ( this.options.eventPassthrough == 'horizontal' ) {
				e.preventDefault();
			} else if ( this.options.eventPassthrough == 'vertical' ) {
				this.initiated = false;
				return;
			}

			deltaX = 0;
		}

		deltaX = this.hasHorizontalScroll ? deltaX : 0;
		deltaY = this.hasVerticalScroll ? deltaY : 0;

		newX = this.x + deltaX;
		newY = this.y + deltaY;

		// Slow down if outside of the boundaries
		if ( newX > 0 || newX < this.maxScrollX ) {
			newX = this.options.bounce ? this.x + deltaX / 3 : newX > 0 ? 0 : this.maxScrollX;
		}
		if ( newY > 0 || newY < this.maxScrollY ) {
			newY = this.options.bounce ? this.y + deltaY / 3 : newY > 0 ? 0 : this.maxScrollY;
		}

		this.directionX = deltaX > 0 ? -1 : deltaX < 0 ? 1 : 0;
		this.directionY = deltaY > 0 ? -1 : deltaY < 0 ? 1 : 0;

		if ( !this.moved ) {
			this._execEvent('scrollStart');
		}

		this.moved = true;

		this._translate(newX, newY);

/* REPLACE START: _move */

		if ( timestamp - this.startTime > 300 ) {
			this.startTime = timestamp;
			this.startX = this.x;
			this.startY = this.y;
		}

/* REPLACE END: _move */

	},

	_end: function (e) {
		if ( !this.enabled || utils.eventType[e.type] !== this.initiated ) {
			return;
		}

		if ( this.options.preventDefault && !utils.preventDefaultException(e.target, this.options.preventDefaultException) ) {
			e.preventDefault();
		}

		var point = e.changedTouches ? e.changedTouches[0] : e,
			momentumX,
			momentumY,
			duration = utils.getTime() - this.startTime,
			newX = Math.round(this.x),
			newY = Math.round(this.y),
			distanceX = Math.abs(newX - this.startX),
			distanceY = Math.abs(newY - this.startY),
			time = 0,
			easing = '';

		this.isInTransition = 0;
		this.initiated = 0;
		this.endTime = utils.getTime();

		// reset if we are outside of the boundaries
		if ( this.resetPosition(this.options.bounceTime) ) {
			return;
		}

		this.scrollTo(newX, newY);	// ensures that the last position is rounded

		// we scrolled less than 10 pixels
		if ( !this.moved ) {
			if ( this.options.tap ) {
				utils.tap(e, this.options.tap);
			}

			if ( this.options.click ) {
				utils.click(e);
			}

			this._execEvent('scrollCancel');
			return;
		}

		if ( this._events.flick && duration < 200 && distanceX < 100 && distanceY < 100 ) {
			this._execEvent('flick');
			return;
		}

		// start momentum animation if needed
		if ( this.options.momentum && duration < 300 ) {
			momentumX = this.hasHorizontalScroll ? utils.momentum(this.x, this.startX, duration, this.maxScrollX, this.options.bounce ? this.wrapperWidth : 0, this.options.deceleration) : { destination: newX, duration: 0 };
			momentumY = this.hasVerticalScroll ? utils.momentum(this.y, this.startY, duration, this.maxScrollY, this.options.bounce ? this.wrapperHeight : 0, this.options.deceleration) : { destination: newY, duration: 0 };
			newX = momentumX.destination;
			newY = momentumY.destination;
			time = Math.max(momentumX.duration, momentumY.duration);
			this.isInTransition = 1;
		}


		if ( this.options.snap ) {
			var snap = this._nearestSnap(newX, newY);
			this.currentPage = snap;
			time = this.options.snapSpeed || Math.max(
					Math.max(
						Math.min(Math.abs(newX - snap.x), 1000),
						Math.min(Math.abs(newY - snap.y), 1000)
					), 300);
			newX = snap.x;
			newY = snap.y;

			this.directionX = 0;
			this.directionY = 0;
			easing = this.options.bounceEasing;
		}

// INSERT POINT: _end

		if ( newX != this.x || newY != this.y ) {
			// change easing function when scroller goes out of the boundaries
			if ( newX > 0 || newX < this.maxScrollX || newY > 0 || newY < this.maxScrollY ) {
				easing = utils.ease.quadratic;
			}

			this.scrollTo(newX, newY, time, easing);
			return;
		}

		this._execEvent('scrollEnd');
	},

	_resize: function () {
		var that = this;

		clearTimeout(this.resizeTimeout);

		this.resizeTimeout = setTimeout(function () {
			that.refresh();
		}, this.options.resizePolling);
	},

	resetPosition: function (time) {
		var x = this.x,
			y = this.y;

		time = time || 0;

		if ( !this.hasHorizontalScroll || this.x > 0 ) {
			x = 0;
		} else if ( this.x < this.maxScrollX ) {
			x = this.maxScrollX;
		}

		if ( !this.hasVerticalScroll || this.y > 0 ) {
			y = 0;
		} else if ( this.y < this.maxScrollY ) {
			y = this.maxScrollY;
		}

		if ( x == this.x && y == this.y ) {
			return false;
		}

		this.scrollTo(x, y, time, this.options.bounceEasing);

		return true;
	},

	disable: function () {
		this.enabled = false;
	},

	enable: function () {
		this.enabled = true;
	},

	refresh: function () {
		var rf = this.wrapper.offsetHeight;		// Force reflow

		this.wrapperWidth	= this.wrapper.clientWidth;
		this.wrapperHeight	= this.wrapper.clientHeight;

/* REPLACE START: refresh */

		this.scrollerWidth	= this.scroller.offsetWidth;
		this.scrollerHeight	= this.scroller.offsetHeight;

		this.maxScrollX		= this.wrapperWidth - this.scrollerWidth;
		this.maxScrollY		= this.wrapperHeight - this.scrollerHeight;

/* REPLACE END: refresh */

		this.hasHorizontalScroll	= this.options.scrollX && this.maxScrollX < 0;
		this.hasVerticalScroll		= this.options.scrollY && this.maxScrollY < 0;

		if ( !this.hasHorizontalScroll ) {
			this.maxScrollX = 0;
			this.scrollerWidth = this.wrapperWidth;
		}

		if ( !this.hasVerticalScroll ) {
			this.maxScrollY = 0;
			this.scrollerHeight = this.wrapperHeight;
		}

		this.endTime = 0;
		this.directionX = 0;
		this.directionY = 0;

		this.wrapperOffset = utils.offset(this.wrapper);

		this._execEvent('refresh');

		this.resetPosition();

// INSERT POINT: _refresh

	},

	on: function (type, fn) {
		if ( !this._events[type] ) {
			this._events[type] = [];
		}

		this._events[type].push(fn);
	},

	off: function (type, fn) {
		if ( !this._events[type] ) {
			return;
		}

		var index = this._events[type].indexOf(fn);

		if ( index > -1 ) {
			this._events[type].splice(index, 1);
		}
	},

	_execEvent: function (type) {
		if ( !this._events[type] ) {
			return;
		}

		var i = 0,
			l = this._events[type].length;

		if ( !l ) {
			return;
		}

		for ( ; i < l; i++ ) {
			this._events[type][i].apply(this, [].slice.call(arguments, 1));
		}
	},

	scrollBy: function (x, y, time, easing) {
		x = this.x + x;
		y = this.y + y;
		time = time || 0;

		this.scrollTo(x, y, time, easing);
	},

	scrollTo: function (x, y, time, easing) {
		easing = easing || utils.ease.circular;

		this.isInTransition = this.options.useTransition && time > 0;
		var transitionType = this.options.useTransition && easing.style;
		if ( !time || transitionType ) {
				if(transitionType) {
					this._transitionTimingFunction(easing.style);
					this._transitionTime(time);
				}
			this._translate(x, y);
		} else {
			this._animate(x, y, time, easing.fn);
		}
	},

	scrollToElement: function (el, time, offsetX, offsetY, easing) {
		el = el.nodeType ? el : this.scroller.querySelector(el);

		if ( !el ) {
			return;
		}

		var pos = utils.offset(el);

		pos.left -= this.wrapperOffset.left;
		pos.top  -= this.wrapperOffset.top;

		// if offsetX/Y are true we center the element to the screen
		if ( offsetX === true ) {
			offsetX = Math.round(el.offsetWidth / 2 - this.wrapper.offsetWidth / 2);
		}
		if ( offsetY === true ) {
			offsetY = Math.round(el.offsetHeight / 2 - this.wrapper.offsetHeight / 2);
		}

		pos.left -= offsetX || 0;
		pos.top  -= offsetY || 0;

		pos.left = pos.left > 0 ? 0 : pos.left < this.maxScrollX ? this.maxScrollX : pos.left;
		pos.top  = pos.top  > 0 ? 0 : pos.top  < this.maxScrollY ? this.maxScrollY : pos.top;

		time = time === undefined || time === null || time === 'auto' ? Math.max(Math.abs(this.x-pos.left), Math.abs(this.y-pos.top)) : time;

		this.scrollTo(pos.left, pos.top, time, easing);
	},

	_transitionTime: function (time) {
		time = time || 0;

		var durationProp = utils.style.transitionDuration;
		this.scrollerStyle[durationProp] = time + 'ms';

		if ( !time && utils.isBadAndroid ) {
			this.scrollerStyle[durationProp] = '0.0001ms';
			// remove 0.0001ms
			var self = this;
			rAF(function() {
				if(self.scrollerStyle[durationProp] === '0.0001ms') {
					self.scrollerStyle[durationProp] = '0s';
				}
			});
		}


		if ( this.indicators ) {
			for ( var i = this.indicators.length; i--; ) {
				this.indicators[i].transitionTime(time);
			}
		}


// INSERT POINT: _transitionTime

	},

	_transitionTimingFunction: function (easing) {
		this.scrollerStyle[utils.style.transitionTimingFunction] = easing;


		if ( this.indicators ) {
			for ( var i = this.indicators.length; i--; ) {
				this.indicators[i].transitionTimingFunction(easing);
			}
		}


// INSERT POINT: _transitionTimingFunction

	},

	_translate: function (x, y) {
		if ( this.options.useTransform ) {

/* REPLACE START: _translate */

			this.scrollerStyle[utils.style.transform] = 'translate(' + x + 'px,' + y + 'px)' + this.translateZ;

/* REPLACE END: _translate */

		} else {
			x = Math.round(x);
			y = Math.round(y);
			this.scrollerStyle.left = x + 'px';
			this.scrollerStyle.top = y + 'px';
		}

		this.x = x;
		this.y = y;


	if ( this.indicators ) {
		for ( var i = this.indicators.length; i--; ) {
			this.indicators[i].updatePosition();
		}
	}


// INSERT POINT: _translate

	},

	_initEvents: function (remove) {
		var eventType = remove ? utils.removeEvent : utils.addEvent,
			target = this.options.bindToWrapper ? this.wrapper : window;

		eventType(window, 'orientationchange', this);
		eventType(window, 'resize', this);

		if ( this.options.click ) {
			eventType(this.wrapper, 'click', this, true);
		}

		if ( !this.options.disableMouse ) {
			eventType(this.wrapper, 'mousedown', this);
			eventType(target, 'mousemove', this);
			eventType(target, 'mousecancel', this);
			eventType(target, 'mouseup', this);
		}

		if ( utils.hasPointer && !this.options.disablePointer ) {
			eventType(this.wrapper, utils.prefixPointerEvent('pointerdown'), this);
			eventType(target, utils.prefixPointerEvent('pointermove'), this);
			eventType(target, utils.prefixPointerEvent('pointercancel'), this);
			eventType(target, utils.prefixPointerEvent('pointerup'), this);
		}

		if ( utils.hasTouch && !this.options.disableTouch ) {
			eventType(this.wrapper, 'touchstart', this);
			eventType(target, 'touchmove', this);
			eventType(target, 'touchcancel', this);
			eventType(target, 'touchend', this);
		}

		eventType(this.scroller, 'transitionend', this);
		eventType(this.scroller, 'webkitTransitionEnd', this);
		eventType(this.scroller, 'oTransitionEnd', this);
		eventType(this.scroller, 'MSTransitionEnd', this);
	},

	getComputedPosition: function () {
		var matrix = window.getComputedStyle(this.scroller, null),
			x, y;

		if ( this.options.useTransform ) {
			matrix = matrix[utils.style.transform].split(')')[0].split(', ');
			x = +(matrix[12] || matrix[4]);
			y = +(matrix[13] || matrix[5]);
		} else {
			x = +matrix.left.replace(/[^-\d.]/g, '');
			y = +matrix.top.replace(/[^-\d.]/g, '');
		}

		return { x: x, y: y };
	},
	_initIndicators: function () {
		var interactive = this.options.interactiveScrollbars,
			customStyle = typeof this.options.scrollbars != 'string',
			indicators = [],
			indicator;

		var that = this;

		this.indicators = [];

		if ( this.options.scrollbars ) {
			// Vertical scrollbar
			if ( this.options.scrollY ) {
				indicator = {
					el: createDefaultScrollbar('v', interactive, this.options.scrollbars),
					interactive: interactive,
					defaultScrollbars: true,
					customStyle: customStyle,
					resize: this.options.resizeScrollbars,
					shrink: this.options.shrinkScrollbars,
					fade: this.options.fadeScrollbars,
					listenX: false
				};

				this.wrapper.appendChild(indicator.el);
				indicators.push(indicator);
			}

			// Horizontal scrollbar
			if ( this.options.scrollX ) {
				indicator = {
					el: createDefaultScrollbar('h', interactive, this.options.scrollbars),
					interactive: interactive,
					defaultScrollbars: true,
					customStyle: customStyle,
					resize: this.options.resizeScrollbars,
					shrink: this.options.shrinkScrollbars,
					fade: this.options.fadeScrollbars,
					listenY: false
				};

				this.wrapper.appendChild(indicator.el);
				indicators.push(indicator);
			}
		}

		if ( this.options.indicators ) {
			// TODO: check concat compatibility
			indicators = indicators.concat(this.options.indicators);
		}

		for ( var i = indicators.length; i--; ) {
			this.indicators.push( new Indicator(this, indicators[i]) );
		}

		// TODO: check if we can use array.map (wide compatibility and performance issues)
		function _indicatorsMap (fn) {
			if (that.indicators) {
				for ( var i = that.indicators.length; i--; ) {
					fn.call(that.indicators[i]);
				}
			}
		}

		if ( this.options.fadeScrollbars ) {
			this.on('scrollEnd', function () {
				_indicatorsMap(function () {
					this.fade();
				});
			});

			this.on('scrollCancel', function () {
				_indicatorsMap(function () {
					this.fade();
				});
			});

			this.on('scrollStart', function () {
				_indicatorsMap(function () {
					this.fade(1);
				});
			});

			this.on('beforeScrollStart', function () {
				_indicatorsMap(function () {
					this.fade(1, true);
				});
			});
		}


		this.on('refresh', function () {
			_indicatorsMap(function () {
				this.refresh();
			});
		});

		this.on('destroy', function () {
			_indicatorsMap(function () {
				this.destroy();
			});

			delete this.indicators;
		});
	},

	_initWheel: function () {
		utils.addEvent(this.wrapper, 'wheel', this);
		utils.addEvent(this.wrapper, 'mousewheel', this);
		utils.addEvent(this.wrapper, 'DOMMouseScroll', this);

		this.on('destroy', function () {
			clearTimeout(this.wheelTimeout);
			this.wheelTimeout = null;
			utils.removeEvent(this.wrapper, 'wheel', this);
			utils.removeEvent(this.wrapper, 'mousewheel', this);
			utils.removeEvent(this.wrapper, 'DOMMouseScroll', this);
		});
	},

	_wheel: function (e) {
		if ( !this.enabled ) {
			return;
		}

		e.preventDefault();

		var wheelDeltaX, wheelDeltaY,
			newX, newY,
			that = this;

		if ( this.wheelTimeout === undefined ) {
			that._execEvent('scrollStart');
		}

		// Execute the scrollEnd event after 400ms the wheel stopped scrolling
		clearTimeout(this.wheelTimeout);
		this.wheelTimeout = setTimeout(function () {
			if(!that.options.snap) {
				that._execEvent('scrollEnd');
			}
			that.wheelTimeout = undefined;
		}, 400);

		if ( 'deltaX' in e ) {
			if (e.deltaMode === 1) {
				wheelDeltaX = -e.deltaX * this.options.mouseWheelSpeed;
				wheelDeltaY = -e.deltaY * this.options.mouseWheelSpeed;
			} else {
				wheelDeltaX = -e.deltaX;
				wheelDeltaY = -e.deltaY;
			}
		} else if ( 'wheelDeltaX' in e ) {
			wheelDeltaX = e.wheelDeltaX / 120 * this.options.mouseWheelSpeed;
			wheelDeltaY = e.wheelDeltaY / 120 * this.options.mouseWheelSpeed;
		} else if ( 'wheelDelta' in e ) {
			wheelDeltaX = wheelDeltaY = e.wheelDelta / 120 * this.options.mouseWheelSpeed;
		} else if ( 'detail' in e ) {
			wheelDeltaX = wheelDeltaY = -e.detail / 3 * this.options.mouseWheelSpeed;
		} else {
			return;
		}

		wheelDeltaX *= this.options.invertWheelDirection;
		wheelDeltaY *= this.options.invertWheelDirection;

		if ( !this.hasVerticalScroll ) {
			wheelDeltaX = wheelDeltaY;
			wheelDeltaY = 0;
		}

		if ( this.options.snap ) {
			newX = this.currentPage.pageX;
			newY = this.currentPage.pageY;

			if ( wheelDeltaX > 0 ) {
				newX--;
			} else if ( wheelDeltaX < 0 ) {
				newX++;
			}

			if ( wheelDeltaY > 0 ) {
				newY--;
			} else if ( wheelDeltaY < 0 ) {
				newY++;
			}

			this.goToPage(newX, newY);

			return;
		}

		newX = this.x + Math.round(this.hasHorizontalScroll ? wheelDeltaX : 0);
		newY = this.y + Math.round(this.hasVerticalScroll ? wheelDeltaY : 0);

		this.directionX = wheelDeltaX > 0 ? -1 : wheelDeltaX < 0 ? 1 : 0;
		this.directionY = wheelDeltaY > 0 ? -1 : wheelDeltaY < 0 ? 1 : 0;

		if ( newX > 0 ) {
			newX = 0;
		} else if ( newX < this.maxScrollX ) {
			newX = this.maxScrollX;
		}

		if ( newY > 0 ) {
			newY = 0;
		} else if ( newY < this.maxScrollY ) {
			newY = this.maxScrollY;
		}

		this.scrollTo(newX, newY, 0);

// INSERT POINT: _wheel
	},

	_initSnap: function () {
		this.currentPage = {};

		if ( typeof this.options.snap == 'string' ) {
			this.options.snap = this.scroller.querySelectorAll(this.options.snap);
		}

		this.on('refresh', function () {
			var i = 0, l,
				m = 0, n,
				cx, cy,
				x = 0, y,
				stepX = this.options.snapStepX || this.wrapperWidth,
				stepY = this.options.snapStepY || this.wrapperHeight,
				el;

			this.pages = [];

			if ( !this.wrapperWidth || !this.wrapperHeight || !this.scrollerWidth || !this.scrollerHeight ) {
				return;
			}

			if ( this.options.snap === true ) {
				cx = Math.round( stepX / 2 );
				cy = Math.round( stepY / 2 );

				while ( x > -this.scrollerWidth ) {
					this.pages[i] = [];
					l = 0;
					y = 0;

					while ( y > -this.scrollerHeight ) {
						this.pages[i][l] = {
							x: Math.max(x, this.maxScrollX),
							y: Math.max(y, this.maxScrollY),
							width: stepX,
							height: stepY,
							cx: x - cx,
							cy: y - cy
						};

						y -= stepY;
						l++;
					}

					x -= stepX;
					i++;
				}
			} else {
				el = this.options.snap;
				l = el.length;
				n = -1;

				for ( ; i < l; i++ ) {
					if ( i === 0 || el[i].offsetLeft <= el[i-1].offsetLeft ) {
						m = 0;
						n++;
					}

					if ( !this.pages[m] ) {
						this.pages[m] = [];
					}

					x = Math.max(-el[i].offsetLeft, this.maxScrollX);
					y = Math.max(-el[i].offsetTop, this.maxScrollY);
					cx = x - Math.round(el[i].offsetWidth / 2);
					cy = y - Math.round(el[i].offsetHeight / 2);

					this.pages[m][n] = {
						x: x,
						y: y,
						width: el[i].offsetWidth,
						height: el[i].offsetHeight,
						cx: cx,
						cy: cy
					};

					if ( x > this.maxScrollX ) {
						m++;
					}
				}
			}

			this.goToPage(this.currentPage.pageX || 0, this.currentPage.pageY || 0, 0);

			// Update snap threshold if needed
			if ( this.options.snapThreshold % 1 === 0 ) {
				this.snapThresholdX = this.options.snapThreshold;
				this.snapThresholdY = this.options.snapThreshold;
			} else {
				this.snapThresholdX = Math.round(this.pages[this.currentPage.pageX][this.currentPage.pageY].width * this.options.snapThreshold);
				this.snapThresholdY = Math.round(this.pages[this.currentPage.pageX][this.currentPage.pageY].height * this.options.snapThreshold);
			}
		});

		this.on('flick', function () {
			var time = this.options.snapSpeed || Math.max(
					Math.max(
						Math.min(Math.abs(this.x - this.startX), 1000),
						Math.min(Math.abs(this.y - this.startY), 1000)
					), 300);

			this.goToPage(
				this.currentPage.pageX + this.directionX,
				this.currentPage.pageY + this.directionY,
				time
			);
		});
	},

	_nearestSnap: function (x, y) {
		if ( !this.pages.length ) {
			return { x: 0, y: 0, pageX: 0, pageY: 0 };
		}

		var i = 0,
			l = this.pages.length,
			m = 0;

		// Check if we exceeded the snap threshold
		if ( Math.abs(x - this.absStartX) < this.snapThresholdX &&
			Math.abs(y - this.absStartY) < this.snapThresholdY ) {
			return this.currentPage;
		}

		if ( x > 0 ) {
			x = 0;
		} else if ( x < this.maxScrollX ) {
			x = this.maxScrollX;
		}

		if ( y > 0 ) {
			y = 0;
		} else if ( y < this.maxScrollY ) {
			y = this.maxScrollY;
		}

		for ( ; i < l; i++ ) {
			if ( x >= this.pages[i][0].cx ) {
				x = this.pages[i][0].x;
				break;
			}
		}

		l = this.pages[i].length;

		for ( ; m < l; m++ ) {
			if ( y >= this.pages[0][m].cy ) {
				y = this.pages[0][m].y;
				break;
			}
		}

		if ( i == this.currentPage.pageX ) {
			i += this.directionX;

			if ( i < 0 ) {
				i = 0;
			} else if ( i >= this.pages.length ) {
				i = this.pages.length - 1;
			}

			x = this.pages[i][0].x;
		}

		if ( m == this.currentPage.pageY ) {
			m += this.directionY;

			if ( m < 0 ) {
				m = 0;
			} else if ( m >= this.pages[0].length ) {
				m = this.pages[0].length - 1;
			}

			y = this.pages[0][m].y;
		}

		return {
			x: x,
			y: y,
			pageX: i,
			pageY: m
		};
	},

	goToPage: function (x, y, time, easing) {
		easing = easing || this.options.bounceEasing;

		if ( x >= this.pages.length ) {
			x = this.pages.length - 1;
		} else if ( x < 0 ) {
			x = 0;
		}

		if ( y >= this.pages[x].length ) {
			y = this.pages[x].length - 1;
		} else if ( y < 0 ) {
			y = 0;
		}

		var posX = this.pages[x][y].x,
			posY = this.pages[x][y].y;

		time = time === undefined ? this.options.snapSpeed || Math.max(
			Math.max(
				Math.min(Math.abs(posX - this.x), 1000),
				Math.min(Math.abs(posY - this.y), 1000)
			), 300) : time;

		this.currentPage = {
			x: posX,
			y: posY,
			pageX: x,
			pageY: y
		};

		this.scrollTo(posX, posY, time, easing);
	},

	next: function (time, easing) {
		var x = this.currentPage.pageX,
			y = this.currentPage.pageY;

		x++;

		if ( x >= this.pages.length && this.hasVerticalScroll ) {
			x = 0;
			y++;
		}

		this.goToPage(x, y, time, easing);
	},

	prev: function (time, easing) {
		var x = this.currentPage.pageX,
			y = this.currentPage.pageY;

		x--;

		if ( x < 0 && this.hasVerticalScroll ) {
			x = 0;
			y--;
		}

		this.goToPage(x, y, time, easing);
	},

	_initKeys: function (e) {
		// default key bindings
		var keys = {
			pageUp: 33,
			pageDown: 34,
			end: 35,
			home: 36,
			left: 37,
			up: 38,
			right: 39,
			down: 40
		};
		var i;

		// if you give me characters I give you keycode
		if ( typeof this.options.keyBindings == 'object' ) {
			for ( i in this.options.keyBindings ) {
				if ( typeof this.options.keyBindings[i] == 'string' ) {
					this.options.keyBindings[i] = this.options.keyBindings[i].toUpperCase().charCodeAt(0);
				}
			}
		} else {
			this.options.keyBindings = {};
		}

		for ( i in keys ) {
			this.options.keyBindings[i] = this.options.keyBindings[i] || keys[i];
		}

		utils.addEvent(window, 'keydown', this);

		this.on('destroy', function () {
			utils.removeEvent(window, 'keydown', this);
		});
	},

	_key: function (e) {
		if ( !this.enabled ) {
			return;
		}

		var snap = this.options.snap,	// we are using this alot, better to cache it
			newX = snap ? this.currentPage.pageX : this.x,
			newY = snap ? this.currentPage.pageY : this.y,
			now = utils.getTime(),
			prevTime = this.keyTime || 0,
			acceleration = 0.250,
			pos;

		if ( this.options.useTransition && this.isInTransition ) {
			pos = this.getComputedPosition();

			this._translate(Math.round(pos.x), Math.round(pos.y));
			this.isInTransition = false;
		}

		this.keyAcceleration = now - prevTime < 200 ? Math.min(this.keyAcceleration + acceleration, 50) : 0;

		switch ( e.keyCode ) {
			case this.options.keyBindings.pageUp:
				if ( this.hasHorizontalScroll && !this.hasVerticalScroll ) {
					newX += snap ? 1 : this.wrapperWidth;
				} else {
					newY += snap ? 1 : this.wrapperHeight;
				}
				break;
			case this.options.keyBindings.pageDown:
				if ( this.hasHorizontalScroll && !this.hasVerticalScroll ) {
					newX -= snap ? 1 : this.wrapperWidth;
				} else {
					newY -= snap ? 1 : this.wrapperHeight;
				}
				break;
			case this.options.keyBindings.end:
				newX = snap ? this.pages.length-1 : this.maxScrollX;
				newY = snap ? this.pages[0].length-1 : this.maxScrollY;
				break;
			case this.options.keyBindings.home:
				newX = 0;
				newY = 0;
				break;
			case this.options.keyBindings.left:
				newX += snap ? -1 : 5 + this.keyAcceleration>>0;
				break;
			case this.options.keyBindings.up:
				newY += snap ? 1 : 5 + this.keyAcceleration>>0;
				break;
			case this.options.keyBindings.right:
				newX -= snap ? -1 : 5 + this.keyAcceleration>>0;
				break;
			case this.options.keyBindings.down:
				newY -= snap ? 1 : 5 + this.keyAcceleration>>0;
				break;
			default:
				return;
		}

		if ( snap ) {
			this.goToPage(newX, newY);
			return;
		}

		if ( newX > 0 ) {
			newX = 0;
			this.keyAcceleration = 0;
		} else if ( newX < this.maxScrollX ) {
			newX = this.maxScrollX;
			this.keyAcceleration = 0;
		}

		if ( newY > 0 ) {
			newY = 0;
			this.keyAcceleration = 0;
		} else if ( newY < this.maxScrollY ) {
			newY = this.maxScrollY;
			this.keyAcceleration = 0;
		}

		this.scrollTo(newX, newY, 0);

		this.keyTime = now;
	},

	_animate: function (destX, destY, duration, easingFn) {
		var that = this,
			startX = this.x,
			startY = this.y,
			startTime = utils.getTime(),
			destTime = startTime + duration;

		function step () {
			var now = utils.getTime(),
				newX, newY,
				easing;

			if ( now >= destTime ) {
				that.isAnimating = false;
				that._translate(destX, destY);

				if ( !that.resetPosition(that.options.bounceTime) ) {
					that._execEvent('scrollEnd');
				}

				return;
			}

			now = ( now - startTime ) / duration;
			easing = easingFn(now);
			newX = ( destX - startX ) * easing + startX;
			newY = ( destY - startY ) * easing + startY;
			that._translate(newX, newY);

			if ( that.isAnimating ) {
				rAF(step);
			}
		}

		this.isAnimating = true;
		step();
	},
	handleEvent: function (e) {
		switch ( e.type ) {
			case 'touchstart':
			case 'pointerdown':
			case 'MSPointerDown':
			case 'mousedown':
				this._start(e);
				break;
			case 'touchmove':
			case 'pointermove':
			case 'MSPointerMove':
			case 'mousemove':
				this._move(e);
				break;
			case 'touchend':
			case 'pointerup':
			case 'MSPointerUp':
			case 'mouseup':
			case 'touchcancel':
			case 'pointercancel':
			case 'MSPointerCancel':
			case 'mousecancel':
				this._end(e);
				break;
			case 'orientationchange':
			case 'resize':
				this._resize();
				break;
			case 'transitionend':
			case 'webkitTransitionEnd':
			case 'oTransitionEnd':
			case 'MSTransitionEnd':
				this._transitionEnd(e);
				break;
			case 'wheel':
			case 'DOMMouseScroll':
			case 'mousewheel':
				this._wheel(e);
				break;
			case 'keydown':
				this._key(e);
				break;
			case 'click':
				if ( this.enabled && !e._constructed ) {
					e.preventDefault();
					e.stopPropagation();
				}
				break;
		}
	}
};
function createDefaultScrollbar (direction, interactive, type) {
	var scrollbar = document.createElement('div'),
		indicator = document.createElement('div');

	if ( type === true ) {
		scrollbar.style.cssText = 'position:absolute;z-index:9999';
		indicator.style.cssText = '-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:absolute;background:rgba(0,0,0,0.5);border:0.03125rem solid rgba(255,255,255,0.9);border-radius:0.09375rem';
	}

	indicator.className = 'iScrollIndicator';

	if ( direction == 'h' ) {
		if ( type === true ) {
			scrollbar.style.cssText += ';height:0.21875rem;left:0.0625rem;right:0.0625rem;bottom:0';
			indicator.style.height = '100%';
		}
		scrollbar.className = 'iScrollHorizontalScrollbar';
	} else {
		if ( type === true ) {
			scrollbar.style.cssText += ';width:0.21875rem;bottom:0.0625rem;top:0.0625rem;right:0.03125rem';
			indicator.style.width = '100%';
		}
		scrollbar.className = 'iScrollVerticalScrollbar';
	}

	scrollbar.style.cssText += ';overflow:hidden';

	if ( !interactive ) {
		scrollbar.style.pointerEvents = 'none';
	}

	scrollbar.appendChild(indicator);

	return scrollbar;
}

function Indicator (scroller, options) {
	this.wrapper = typeof options.el == 'string' ? document.querySelector(options.el) : options.el;
	this.wrapperStyle = this.wrapper.style;
	this.indicator = this.wrapper.children[0];
	this.indicatorStyle = this.indicator.style;
	this.scroller = scroller;

	this.options = {
		listenX: true,
		listenY: true,
		interactive: false,
		resize: true,
		defaultScrollbars: false,
		shrink: false,
		fade: false,
		speedRatioX: 0,
		speedRatioY: 0
	};

	for ( var i in options ) {
		this.options[i] = options[i];
	}

	this.sizeRatioX = 1;
	this.sizeRatioY = 1;
	this.maxPosX = 0;
	this.maxPosY = 0;

	if ( this.options.interactive ) {
		if ( !this.options.disableTouch ) {
			utils.addEvent(this.indicator, 'touchstart', this);
			utils.addEvent(window, 'touchend', this);
		}
		if ( !this.options.disablePointer ) {
			utils.addEvent(this.indicator, utils.prefixPointerEvent('pointerdown'), this);
			utils.addEvent(window, utils.prefixPointerEvent('pointerup'), this);
		}
		if ( !this.options.disableMouse ) {
			utils.addEvent(this.indicator, 'mousedown', this);
			utils.addEvent(window, 'mouseup', this);
		}
	}

	if ( this.options.fade ) {
		this.wrapperStyle[utils.style.transform] = this.scroller.translateZ;
		var durationProp = utils.style.transitionDuration;
		this.wrapperStyle[durationProp] = utils.isBadAndroid ? '0.0001ms' : '0ms';
		// remove 0.0001ms
		var self = this;
		if(utils.isBadAndroid) {
			rAF(function() {
				if(self.wrapperStyle[durationProp] === '0.0001ms') {
					self.wrapperStyle[durationProp] = '0s';
				}
			});
		}
		this.wrapperStyle.opacity = '0';
	}
}

Indicator.prototype = {
	handleEvent: function (e) {
		switch ( e.type ) {
			case 'touchstart':
			case 'pointerdown':
			case 'MSPointerDown':
			case 'mousedown':
				this._start(e);
				break;
			case 'touchmove':
			case 'pointermove':
			case 'MSPointerMove':
			case 'mousemove':
				this._move(e);
				break;
			case 'touchend':
			case 'pointerup':
			case 'MSPointerUp':
			case 'mouseup':
			case 'touchcancel':
			case 'pointercancel':
			case 'MSPointerCancel':
			case 'mousecancel':
				this._end(e);
				break;
		}
	},

	destroy: function () {
		if ( this.options.fadeScrollbars ) {
			clearTimeout(this.fadeTimeout);
			this.fadeTimeout = null;
		}
		if ( this.options.interactive ) {
			utils.removeEvent(this.indicator, 'touchstart', this);
			utils.removeEvent(this.indicator, utils.prefixPointerEvent('pointerdown'), this);
			utils.removeEvent(this.indicator, 'mousedown', this);

			utils.removeEvent(window, 'touchmove', this);
			utils.removeEvent(window, utils.prefixPointerEvent('pointermove'), this);
			utils.removeEvent(window, 'mousemove', this);

			utils.removeEvent(window, 'touchend', this);
			utils.removeEvent(window, utils.prefixPointerEvent('pointerup'), this);
			utils.removeEvent(window, 'mouseup', this);
		}

		if ( this.options.defaultScrollbars ) {
			this.wrapper.parentNode.removeChild(this.wrapper);
		}
	},

	_start: function (e) {
		var point = e.touches ? e.touches[0] : e;

		e.preventDefault();
		e.stopPropagation();

		this.transitionTime();

		this.initiated = true;
		this.moved = false;
		this.lastPointX	= point.pageX;
		this.lastPointY	= point.pageY;

		this.startTime	= utils.getTime();

		if ( !this.options.disableTouch ) {
			utils.addEvent(window, 'touchmove', this);
		}
		if ( !this.options.disablePointer ) {
			utils.addEvent(window, utils.prefixPointerEvent('pointermove'), this);
		}
		if ( !this.options.disableMouse ) {
			utils.addEvent(window, 'mousemove', this);
		}

		this.scroller._execEvent('beforeScrollStart');
	},

	_move: function (e) {
		var point = e.touches ? e.touches[0] : e,
			deltaX, deltaY,
			newX, newY,
			timestamp = utils.getTime();

		if ( !this.moved ) {
			this.scroller._execEvent('scrollStart');
		}

		this.moved = true;

		deltaX = point.pageX - this.lastPointX;
		this.lastPointX = point.pageX;

		deltaY = point.pageY - this.lastPointY;
		this.lastPointY = point.pageY;

		newX = this.x + deltaX;
		newY = this.y + deltaY;

		this._pos(newX, newY);

// INSERT POINT: indicator._move

		e.preventDefault();
		e.stopPropagation();
	},

	_end: function (e) {
		if ( !this.initiated ) {
			return;
		}

		this.initiated = false;

		e.preventDefault();
		e.stopPropagation();

		utils.removeEvent(window, 'touchmove', this);
		utils.removeEvent(window, utils.prefixPointerEvent('pointermove'), this);
		utils.removeEvent(window, 'mousemove', this);

		if ( this.scroller.options.snap ) {
			var snap = this.scroller._nearestSnap(this.scroller.x, this.scroller.y);

			var time = this.options.snapSpeed || Math.max(
					Math.max(
						Math.min(Math.abs(this.scroller.x - snap.x), 1000),
						Math.min(Math.abs(this.scroller.y - snap.y), 1000)
					), 300);

			if ( this.scroller.x != snap.x || this.scroller.y != snap.y ) {
				this.scroller.directionX = 0;
				this.scroller.directionY = 0;
				this.scroller.currentPage = snap;
				this.scroller.scrollTo(snap.x, snap.y, time, this.scroller.options.bounceEasing);
			}
		}

		if ( this.moved ) {
			this.scroller._execEvent('scrollEnd');
		}
	},

	transitionTime: function (time) {
		time = time || 0;
		var durationProp = utils.style.transitionDuration;
		this.indicatorStyle[durationProp] = time + 'ms';

		if ( !time && utils.isBadAndroid ) {
			this.indicatorStyle[durationProp] = '0.0001ms';
			// remove 0.0001ms
			var self = this;
			rAF(function() {
				if(self.indicatorStyle[durationProp] === '0.0001ms') {
					self.indicatorStyle[durationProp] = '0s';
				}
			});
		}
	},

	transitionTimingFunction: function (easing) {
		this.indicatorStyle[utils.style.transitionTimingFunction] = easing;
	},

	refresh: function () {
		this.transitionTime();

		if ( this.options.listenX && !this.options.listenY ) {
			this.indicatorStyle.display = this.scroller.hasHorizontalScroll ? 'block' : 'none';
		} else if ( this.options.listenY && !this.options.listenX ) {
			this.indicatorStyle.display = this.scroller.hasVerticalScroll ? 'block' : 'none';
		} else {
			this.indicatorStyle.display = this.scroller.hasHorizontalScroll || this.scroller.hasVerticalScroll ? 'block' : 'none';
		}

		if ( this.scroller.hasHorizontalScroll && this.scroller.hasVerticalScroll ) {
			utils.addClass(this.wrapper, 'iScrollBothScrollbars');
			utils.removeClass(this.wrapper, 'iScrollLoneScrollbar');

			if ( this.options.defaultScrollbars && this.options.customStyle ) {
				if ( this.options.listenX ) {
					this.wrapper.style.right = '0.25rem';
				} else {
					this.wrapper.style.bottom = '0.25rem';
				}
			}
		} else {
			utils.removeClass(this.wrapper, 'iScrollBothScrollbars');
			utils.addClass(this.wrapper, 'iScrollLoneScrollbar');

			if ( this.options.defaultScrollbars && this.options.customStyle ) {
				if ( this.options.listenX ) {
					this.wrapper.style.right = '0.0625rem';
				} else {
					this.wrapper.style.bottom = '0.0625rem';
				}
			}
		}

		var r = this.wrapper.offsetHeight;	// force refresh

		if ( this.options.listenX ) {
			this.wrapperWidth = this.wrapper.clientWidth;
			if ( this.options.resize ) {
				this.indicatorWidth = Math.max(Math.round(this.wrapperWidth * this.wrapperWidth / (this.scroller.scrollerWidth || this.wrapperWidth || 1)), 8);
				this.indicatorStyle.width = this.indicatorWidth + 'px';
			} else {
				this.indicatorWidth = this.indicator.clientWidth;
			}

			this.maxPosX = this.wrapperWidth - this.indicatorWidth;

			if ( this.options.shrink == 'clip' ) {
				this.minBoundaryX = -this.indicatorWidth + 8;
				this.maxBoundaryX = this.wrapperWidth - 8;
			} else {
				this.minBoundaryX = 0;
				this.maxBoundaryX = this.maxPosX;
			}

			this.sizeRatioX = this.options.speedRatioX || (this.scroller.maxScrollX && (this.maxPosX / this.scroller.maxScrollX));
		}

		if ( this.options.listenY ) {
			this.wrapperHeight = this.wrapper.clientHeight;
			if ( this.options.resize ) {
				this.indicatorHeight = Math.max(Math.round(this.wrapperHeight * this.wrapperHeight / (this.scroller.scrollerHeight || this.wrapperHeight || 1)), 8);
				this.indicatorStyle.height = this.indicatorHeight + 'px';
			} else {
				this.indicatorHeight = this.indicator.clientHeight;
			}

			this.maxPosY = this.wrapperHeight - this.indicatorHeight;

			if ( this.options.shrink == 'clip' ) {
				this.minBoundaryY = -this.indicatorHeight + 8;
				this.maxBoundaryY = this.wrapperHeight - 8;
			} else {
				this.minBoundaryY = 0;
				this.maxBoundaryY = this.maxPosY;
			}

			this.maxPosY = this.wrapperHeight - this.indicatorHeight;
			this.sizeRatioY = this.options.speedRatioY || (this.scroller.maxScrollY && (this.maxPosY / this.scroller.maxScrollY));
		}

		this.updatePosition();
	},

	updatePosition: function () {
		var x = this.options.listenX && Math.round(this.sizeRatioX * this.scroller.x) || 0,
			y = this.options.listenY && Math.round(this.sizeRatioY * this.scroller.y) || 0;

		if ( !this.options.ignoreBoundaries ) {
			if ( x < this.minBoundaryX ) {
				if ( this.options.shrink == 'scale' ) {
					this.width = Math.max(this.indicatorWidth + x, 8);
					this.indicatorStyle.width = this.width + 'px';
				}
				x = this.minBoundaryX;
			} else if ( x > this.maxBoundaryX ) {
				if ( this.options.shrink == 'scale' ) {
					this.width = Math.max(this.indicatorWidth - (x - this.maxPosX), 8);
					this.indicatorStyle.width = this.width + 'px';
					x = this.maxPosX + this.indicatorWidth - this.width;
				} else {
					x = this.maxBoundaryX;
				}
			} else if ( this.options.shrink == 'scale' && this.width != this.indicatorWidth ) {
				this.width = this.indicatorWidth;
				this.indicatorStyle.width = this.width + 'px';
			}

			if ( y < this.minBoundaryY ) {
				if ( this.options.shrink == 'scale' ) {
					this.height = Math.max(this.indicatorHeight + y * 3, 8);
					this.indicatorStyle.height = this.height + 'px';
				}
				y = this.minBoundaryY;
			} else if ( y > this.maxBoundaryY ) {
				if ( this.options.shrink == 'scale' ) {
					this.height = Math.max(this.indicatorHeight - (y - this.maxPosY) * 3, 8);
					this.indicatorStyle.height = this.height + 'px';
					y = this.maxPosY + this.indicatorHeight - this.height;
				} else {
					y = this.maxBoundaryY;
				}
			} else if ( this.options.shrink == 'scale' && this.height != this.indicatorHeight ) {
				this.height = this.indicatorHeight;
				this.indicatorStyle.height = this.height + 'px';
			}
		}

		this.x = x;
		this.y = y;

		if ( this.scroller.options.useTransform ) {
			this.indicatorStyle[utils.style.transform] = 'translate(' + x + 'px,' + y + 'px)' + this.scroller.translateZ;
		} else {
			this.indicatorStyle.left = x + 'px';
			this.indicatorStyle.top = y + 'px';
		}
	},

	_pos: function (x, y) {
		if ( x < 0 ) {
			x = 0;
		} else if ( x > this.maxPosX ) {
			x = this.maxPosX;
		}

		if ( y < 0 ) {
			y = 0;
		} else if ( y > this.maxPosY ) {
			y = this.maxPosY;
		}

		x = this.options.listenX ? Math.round(x / this.sizeRatioX) : this.scroller.x;
		y = this.options.listenY ? Math.round(y / this.sizeRatioY) : this.scroller.y;

		this.scroller.scrollTo(x, y);
	},

	fade: function (val, hold) {
		if ( hold && !this.visible ) {
			return;
		}

		clearTimeout(this.fadeTimeout);
		this.fadeTimeout = null;

		var time = val ? 250 : 500,
			delay = val ? 0 : 300;

		val = val ? '1' : '0';

		this.wrapperStyle[utils.style.transitionDuration] = time + 'ms';

		this.fadeTimeout = setTimeout((function (val) {
			this.wrapperStyle.opacity = val;
			this.visible = +val;
		}).bind(this, val), delay);
	}
};

IScroll.utils = utils;

if ( typeof module != 'undefined' && module.exports ) {
	module.exports = IScroll;
} else if ( true ) {
        !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () { return IScroll; }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else {
	window.IScroll = IScroll;
}

})(window, document, Math);


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(229), __webpack_require__(231), __webpack_require__(232)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module, require('./clipboard-action'), require('tiny-emitter'), require('good-listener'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.clipboardAction, global.tinyEmitter, global.goodListener);
        global.clipboard = mod.exports;
    }
})(this, function (module, _clipboardAction, _tinyEmitter, _goodListener) {
    'use strict';

    var _clipboardAction2 = _interopRequireDefault(_clipboardAction);

    var _tinyEmitter2 = _interopRequireDefault(_tinyEmitter);

    var _goodListener2 = _interopRequireDefault(_goodListener);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    function _possibleConstructorReturn(self, call) {
        if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var Clipboard = function (_Emitter) {
        _inherits(Clipboard, _Emitter);

        /**
         * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
         * @param {Object} options
         */
        function Clipboard(trigger, options) {
            _classCallCheck(this, Clipboard);

            var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this));

            _this.resolveOptions(options);
            _this.listenClick(trigger);
            return _this;
        }

        /**
         * Defines if attributes would be resolved using internal setter functions
         * or custom functions that were passed in the constructor.
         * @param {Object} options
         */


        _createClass(Clipboard, [{
            key: 'resolveOptions',
            value: function resolveOptions() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
                this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
                this.text = typeof options.text === 'function' ? options.text : this.defaultText;
                this.container = _typeof(options.container) === 'object' ? options.container : document.body;
            }
        }, {
            key: 'listenClick',
            value: function listenClick(trigger) {
                var _this2 = this;

                this.listener = (0, _goodListener2.default)(trigger, 'click', function (e) {
                    return _this2.onClick(e);
                });
            }
        }, {
            key: 'onClick',
            value: function onClick(e) {
                var trigger = e.delegateTarget || e.currentTarget;

                if (this.clipboardAction) {
                    this.clipboardAction = null;
                }

                this.clipboardAction = new _clipboardAction2.default({
                    action: this.action(trigger),
                    target: this.target(trigger),
                    text: this.text(trigger),
                    container: this.container,
                    trigger: trigger,
                    emitter: this
                });
            }
        }, {
            key: 'defaultAction',
            value: function defaultAction(trigger) {
                return getAttributeValue('action', trigger);
            }
        }, {
            key: 'defaultTarget',
            value: function defaultTarget(trigger) {
                var selector = getAttributeValue('target', trigger);

                if (selector) {
                    return document.querySelector(selector);
                }
            }
        }, {
            key: 'defaultText',
            value: function defaultText(trigger) {
                return getAttributeValue('text', trigger);
            }
        }, {
            key: 'destroy',
            value: function destroy() {
                this.listener.destroy();

                if (this.clipboardAction) {
                    this.clipboardAction.destroy();
                    this.clipboardAction = null;
                }
            }
        }], [{
            key: 'isSupported',
            value: function isSupported() {
                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['copy', 'cut'];

                var actions = typeof action === 'string' ? [action] : action;
                var support = !!document.queryCommandSupported;

                actions.forEach(function (action) {
                    support = support && !!document.queryCommandSupported(action);
                });

                return support;
            }
        }]);

        return Clipboard;
    }(_tinyEmitter2.default);

    /**
     * Helper function to retrieve attribute value.
     * @param {String} suffix
     * @param {Element} element
     */
    function getAttributeValue(suffix, element) {
        var attribute = 'data-clipboard-' + suffix;

        if (!element.hasAttribute(attribute)) {
            return;
        }

        return element.getAttribute(attribute);
    }

    module.exports = Clipboard;
});

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e92255e07db5ae199cc343161aaa16aa.png";

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(145);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BrowserRouter", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(153);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "HashRouter", function() { return __WEBPACK_IMPORTED_MODULE_1__HashRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(101);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(154);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MemoryRouter", function() { return __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(156);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NavLink", function() { return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(158);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Prompt", function() { return __WEBPACK_IMPORTED_MODULE_5__Prompt__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(160);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Redirect", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(102);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(56);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return __WEBPACK_IMPORTED_MODULE_8__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(162);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StaticRouter", function() { return __WEBPACK_IMPORTED_MODULE_9__StaticRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(164);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Switch", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(166);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "generatePath", function() { return __WEBPACK_IMPORTED_MODULE_11__generatePath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(167);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "matchPath", function() { return __WEBPACK_IMPORTED_MODULE_12__matchPath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(168);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withRouter", function() { return __WEBPACK_IMPORTED_MODULE_13__withRouter__["a"]; });





























/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {



/**
 * @author ximan
 * https://github.com/ximan/dropload
 */
__webpack_require__(128);(function ($) {
    'use strict';

    var win = window;
    var doc = document;
    var $win = $(win);
    var $doc = $(doc);
    var defaults = {
        scrollArea: win, // 滑动区域
        domUp: { // 上方DOM
            domClass: 'dropload-up',
            domRefresh: '<div class="dropload-refresh">↓下拉刷新</div>',
            domUpdate: '<div class="dropload-update">↑释放更新</div>',
            domLoad: '<div class="dropload-load"><span class="loading"></span>加载中...</div>'
        },
        domDown: { // 下方DOM
            domClass: 'dropload-down',
            domRefresh: '<div class="dropload-refresh">↑上拉加载更多</div>',
            domLoad: '<div class="dropload-load"><span class="loading"></span>加载中...</div>',
            domNoData: '<div class="dropload-noData">暂无数据</div>'
        },
        autoLoad: true, // 自动加载
        distance: 50, // 拉动距离
        threshold: '', // 提前加载距离
        loadUpFn: '', // 上方function
        loadDownFn: '' // 下方function
    };
    $.fn.dropload = function (options) {
        return new DropLoad(this, options);
    };
    $.fn.dropload.setDefaults = function (options) {
        defaults = $.extend(true, defaults, options);
    };
    var DropLoad = function DropLoad(element, options) {
        var me = this;
        me.$element = element;
        // 上方是否插入DOM
        me.upInsertDOM = false;
        // loading状态
        me.loading = false;
        // 是否锁定
        me.isLockUp = false;
        me.isLockDown = false;
        // 是否有数据
        me.isData = true;
        me._scrollTop = 0;
        me._threshold = 0;
        me.init(options);
    };

    // 初始化
    DropLoad.prototype.init = function (options) {
        var me = this;
        me.opts = $.extend(true, {}, defaults, options);

        // 如果加载下方，事先在下方插入DOM
        if (me.opts.loadDownFn !== '') {
            me.$element.append('<div class="' + me.opts.domDown.domClass + '">' + me.opts.domDown.domRefresh + '</div>');
            me.$domDown = $('.' + me.opts.domDown.domClass);
        }

        // 计算提前加载距离
        if (!!me.$domDown && me.opts.threshold === '') {
            // 默认滑到加载区2/3处时加载
            me._threshold = Math.floor(me.$domDown.height() * 1 / 3);
        } else {
            me._threshold = me.opts.threshold;
        }

        // 判断滚动区域
        if (me.opts.scrollArea === win) {
            me.$scrollArea = $win;
            // 获取文档高度
            me._scrollContentHeight = $doc.height();
            // 获取win显示区高度  —— 这里有坑
            me._scrollWindowHeight = doc.documentElement.clientHeight;
        } else {
            me.$scrollArea = me.opts.scrollArea;
            me._scrollContentHeight = me.$element[0].scrollHeight;
            me._scrollWindowHeight = me.$element.height();
        }
        fnAutoLoad(me);

        me._resize = function () {
            clearTimeout(me.timer);
            me.timer = setTimeout(function () {
                if (me.opts.scrollArea === win) {
                    // 重新获取win显示区高度
                    me._scrollWindowHeight = win.innerHeight;
                } else {
                    me._scrollWindowHeight = me.$element.height();
                }
                fnAutoLoad(me);
            }, 150);
        };

        me._touchstart = function (e) {
            if (!me.loading) {
                fnTouches(e);
                fnTouchstart(e, me);
            }
        };

        me._touchmove = function (e) {
            if (!me.loading) {
                fnTouches(e, me);
                fnTouchmove(e, me);
            }
        };

        me._touchend = function () {
            if (!me.loading) {
                fnTouchend(me);
            }
        };

        me._scroll = function () {
            me._scrollTop = me.$scrollArea.scrollTop();

            // 滚动页面触发加载数据
            if (me.opts.loadDownFn !== '' && !me.loading && !me.isLockDown && me._scrollContentHeight - me._threshold <= me._scrollWindowHeight + me._scrollTop) {
                loadDown(me);
            }
        };

        // 窗口调整
        $win.on('resize', me._resize);
        // 绑定触摸
        me.$element.on('touchstart', me._touchstart);
        me.$element.on('touchmove', me._touchmove);
        me.$element.on('touchend', me._touchend);
        // 加载下方
        me.$scrollArea.on('scroll', me._scroll);
    };

    // touches
    function fnTouches(e) {
        if (!e.touches) {
            e.touches = e.originalEvent.touches;
        }
    }

    // touchstart
    function fnTouchstart(e, me) {
        me._startY = e.touches[0].pageY;
        // 记住触摸时的scrolltop值
        me.touchScrollTop = me.$scrollArea.scrollTop();
    }

    // touchmove
    function fnTouchmove(e, me) {
        me._curY = e.touches[0].pageY;
        me._moveY = me._curY - me._startY;

        if (me._moveY > 0) {
            me.direction = 'down';
        } else if (me._moveY < 0) {
            me.direction = 'up';
        }

        var _absMoveY = Math.abs(me._moveY);

        // 加载上方
        if (me.opts.loadUpFn !== '' && me.touchScrollTop <= 0 && me.direction === 'down' && !me.isLockUp) {
            e.preventDefault();

            me.$domUp = $('.' + me.opts.domUp.domClass);
            // 如果加载区没有DOM
            if (!me.upInsertDOM) {
                me.$element.prepend('<div class="' + me.opts.domUp.domClass + '"></div>');
                me.upInsertDOM = true;
            }

            fnTransition(me.$domUp, 0);

            // 下拉
            if (_absMoveY <= me.opts.distance) {
                me._offsetY = _absMoveY;
                // todo：move时会不断清空、增加dom，有可能影响性能，下同
                me.$domUp.html(me.opts.domUp.domRefresh);
                // 指定距离 < 下拉距离 < 指定距离*2
            } else if (_absMoveY > me.opts.distance && _absMoveY <= me.opts.distance * 2) {
                me._offsetY = me.opts.distance + (_absMoveY - me.opts.distance) * 0.5;
                me.$domUp.html(me.opts.domUp.domUpdate);
                // 下拉距离 > 指定距离*2
            } else {
                me._offsetY = me.opts.distance + me.opts.distance * 0.5 + (_absMoveY - me.opts.distance * 2) * 0.2;
            }

            me.$domUp.css({ 'height': me._offsetY });
        }
    }

    // touchend
    function fnTouchend(me) {
        var _absMoveY = Math.abs(me._moveY);
        if (me.opts.loadUpFn !== '' && me.touchScrollTop <= 0 && me.direction === 'down' && !me.isLockUp) {
            fnTransition(me.$domUp, 300);

            if (_absMoveY > me.opts.distance) {
                me.$domUp.css({ 'height': me.$domUp.children().height() });
                me.$domUp.html(me.opts.domUp.domLoad);
                me.loading = true;
                me.opts.loadUpFn(me);
            } else {
                me.$domUp.css({ 'height': '0' }).on('webkitTransitionEnd mozTransitionEnd transitionend', function () {
                    me.upInsertDOM = false;
                    $(this).remove();
                });
            }
            me._moveY = 0;
        }
    }

    // 如果文档高度不大于窗口高度，数据较少，自动加载下方数据
    function fnAutoLoad(me) {
        if (me.opts.loadDownFn !== '' && me.opts.autoLoad) {
            if (me._scrollContentHeight - me._threshold <= me._scrollWindowHeight) {
                loadDown(me);
            }
        }
    }

    // 重新获取文档高度
    function fnRecoverContentHeight(me) {
        if (me.opts.scrollArea === win) {
            me._scrollContentHeight = $doc.height();
        } else {
            me._scrollContentHeight = me.$element[0].scrollHeight;
        }
    }

    // 加载下方
    function loadDown(me) {
        me.direction = 'up';
        me.$domDown.html(me.opts.domDown.domLoad);
        me.loading = true;
        me.opts.loadDownFn(me);
    }

    // 锁定
    DropLoad.prototype.lock = function (direction) {
        var me = this;
        // 如果不指定方向
        if (direction === undefined) {
            // 如果操作方向向上
            if (me.direction === 'up') {
                me.isLockDown = true;
                // 如果操作方向向下
            } else if (me.direction === 'down') {
                me.isLockUp = true;
            } else {
                me.isLockUp = true;
                me.isLockDown = true;
            }
            // 如果指定锁上方
        } else if (direction === 'up') {
            me.isLockUp = true;
            // 如果指定锁下方
        } else if (direction === 'down') {
            me.isLockDown = true;
            // 为了解决DEMO5中tab效果bug，因为滑动到下面，再滑上去点tab，direction=down，所以有bug
            me.direction = 'up';
        }
    };

    // 解锁
    DropLoad.prototype.unlock = function () {
        var me = this;
        // 简单粗暴解锁
        me.isLockUp = false;
        me.isLockDown = false;
        // 为了解决DEMO5中tab效果bug，因为滑动到下面，再滑上去点tab，direction=down，所以有bug
        me.direction = 'up';
    };

    // 无数据
    DropLoad.prototype.noData = function (flag) {
        var me = this;
        if (flag === undefined || flag === true) {
            me.isData = false;
        } else if (flag === false) {
            me.isData = true;
        }
    };

    // 重置
    DropLoad.prototype.resetload = function () {
        var me = this;
        if (me.direction === 'down' && me.upInsertDOM) {
            me.$domUp.css({ 'height': '0' }).on('webkitTransitionEnd mozTransitionEnd transitionend', function () {
                me.loading = false;
                me.upInsertDOM = false;
                $(this).remove();
                fnRecoverContentHeight(me);
            });
        } else if (me.direction === 'up') {
            me.loading = false;
            // 如果有数据
            if (me.isData) {
                // 加载区修改样式
                me.$domDown.html(me.opts.domDown.domRefresh);
                fnRecoverContentHeight(me);
                fnAutoLoad(me);
            } else {
                // 如果没数据
                me.$domDown.html(me.opts.domDown.domNoData);
            }
        }
    };

    /**
     * 销毁组件，在react中很重要
     */
    DropLoad.prototype.destroy = function () {
        var me = this;
        me.opts = null;
        // 窗口调整
        $win.off('resize', me._resize);
        // 绑定触摸
        me.$element.off('touchstart', me._touchstart);
        me.$element.off('touchmove', me._touchmove);
        me.$element.off('touchend', me._touchend);
        // 加载下方
        me.$scrollArea.off('scroll', me._scroll);
        me = null;
    };

    // css过渡
    function fnTransition(dom, num) {
        dom.css({
            '-webkit-transition': 'all ' + num + 'ms',
            'transition': 'all ' + num + 'ms'
        });
    }
})(window.Zepto || window.jQuery || window.$);

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(219);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @description 礼物项的组件
 *
 * 需要支持的以下的配置
 * 1、礼物的图片
 * 2、礼物的名称
 * 3、礼物所值的钻石数量
 * 4、是否是选中的状态（可以通过外部修改）
 * 5、礼物选中的事件
 * 6、礼物是否支持选中，不支持就不显示checkbox
 */
var GiftItem = function (_React$Component) {
    _inherits(GiftItem, _React$Component);

    function GiftItem(props) {
        _classCallCheck(this, GiftItem);

        var _this = _possibleConstructorReturn(this, (GiftItem.__proto__ || Object.getPrototypeOf(GiftItem)).call(this, props));

        _this.itemClick = function () {
            var selected = _this.state.selected;
            var _this$props = _this.props,
                id = _this$props.id,
                onSelect = _this$props.onSelect;

            _this.setState({ selected: !selected });
            onSelect(id, !selected);
        };

        _this.state = {
            selected: _this.props.selected
        };
        return _this;
    }

    _createClass(GiftItem, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref, state) {
            var selected = _ref.selected;

            if (selected !== undefined) {
                this.setState({ selected: selected });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                name = _props.name,
                image = _props.image,
                selectable = _props.selectable,
                children = _props.children,
                vipGrade = _props.vipGrade;
            var selected = this.state.selected;

            return _react2.default.createElement(
                'div',
                { className: 'gift-item text-center', onClick: this.itemClick },
                _react2.default.createElement(
                    'div',
                    { className: 'gift-image' },
                    _react2.default.createElement('img', { src: image })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'gift-name ellipsis' },
                    name
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'gift-worth' },
                    children
                ),
                selectable ? _react2.default.createElement('div', { className: selected ? 'gift-check' : 'gift-uncheck' }) : null,
                _react2.default.createElement(
                    'div',
                    { className: 'vipflag' + (vipGrade ? '' : ' hidden') },
                    _react2.default.createElement(
                        'span',
                        null,
                        'VIP',
                        vipGrade
                    )
                )
            );
        }
    }]);

    return GiftItem;
}(_react2.default.Component);

GiftItem.defaultProps = {
    id: 0,
    name: ' ',
    image: '',
    selected: false,
    selectable: false,
    vipGrade: null,
    onSelect: function onSelect(id, result) {
        //  result存储的是选中和反选的情况
        console.log(id, result);
    }
};
exports.default = GiftItem;

/***/ }),
/* 139 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": null,
    "options": {
        "objc_class_prefix": "GiftItemInfo",
        "java_package": "com.asiainno.uplive.proto.gift"
    },
    "messages": [{
        "name": "GiftItemInfo",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "itemId",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "itemName",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "itemDesc",
            "id": 3
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "updateTime",
            "id": 4
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "totalIncome",
            "id": 5
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "giftAmount",
            "id": 6
        }, {
            "rule": "repeated",
            "type": "Gift.ItemGiftList.GiftItemGiftList",
            "name": "giftList",
            "id": 7
        }, {
            "rule": "optional",
            "type": "string",
            "name": "gtoIncomes",
            "id": 8
        }]
    }, {
        "name": "Gift",
        "fields": [],
        "messages": [{
            "name": "ItemGiftList",
            "fields": [],
            "options": {
                "objc_class_prefix": "GiftItemGiftList",
                "java_package": "com.asiainno.uplive.proto.gift"
            },
            "messages": [{
                "name": "GiftItemGiftList",
                "fields": [{
                    "rule": "optional",
                    "type": "int32",
                    "name": "giftId",
                    "id": 1
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "name",
                    "id": 2
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "intro",
                    "id": 3
                }, {
                    "rule": "optional",
                    "type": "int32",
                    "name": "type",
                    "id": 4
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "url",
                    "id": 5
                }, {
                    "rule": "optional",
                    "type": "int32",
                    "name": "price",
                    "id": 6
                }, {
                    "rule": "optional",
                    "type": "int32",
                    "name": "experience",
                    "id": 7
                }, {
                    "rule": "optional",
                    "type": "bool",
                    "name": "canCombo",
                    "id": 8
                }, {
                    "rule": "optional",
                    "type": "int32",
                    "name": "version",
                    "id": 9
                }, {
                    "rule": "optional",
                    "type": "bool",
                    "name": "onLined",
                    "id": 10
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "countryCode",
                    "id": 11
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "language",
                    "id": 12
                }, {
                    "rule": "optional",
                    "type": "bool",
                    "name": "needLoad",
                    "id": 13
                }, {
                    "rule": "optional",
                    "type": "int32",
                    "name": "showType",
                    "id": 14
                }, {
                    "rule": "repeated",
                    "type": "GiftResourceInfo",
                    "name": "resources",
                    "id": 15
                }, {
                    "rule": "optional",
                    "type": "int32",
                    "name": "vipGrade",
                    "id": 16
                }, {
                    "rule": "optional",
                    "type": "int32",
                    "name": "playTimes",
                    "id": 17
                }, {
                    "rule": "optional",
                    "type": "int32",
                    "name": "produceType",
                    "id": 18
                }, {
                    "rule": "optional",
                    "type": "bool",
                    "name": "canSendToAllUsers",
                    "id": 19
                }, {
                    "rule": "optional",
                    "type": "int32",
                    "name": "timeLimit",
                    "id": 20
                }, {
                    "rule": "optional",
                    "type": "int32",
                    "name": "hostBill",
                    "id": 21
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "gtoPrice",
                    "id": 22
                }]
            }, {
                "name": "GiftResourceInfo",
                "fields": [{
                    "rule": "optional",
                    "type": "int32",
                    "name": "type",
                    "id": 1
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "url",
                    "id": 2
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "md5",
                    "id": 3
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "json",
                    "id": 4
                }]
            }]
        }, {
            "name": "ItemList",
            "fields": [],
            "options": {
                "objc_class_prefix": "GiftItemList",
                "java_package": "com.asiainno.uplive.proto.gift"
            },
            "messages": [{
                "name": "Request",
                "fields": [{
                    "rule": "optional",
                    "type": "int32",
                    "name": "pageSize",
                    "id": 1
                }, {
                    "rule": "optional",
                    "type": "int32",
                    "name": "pageNum",
                    "id": 2
                }, {
                    "rule": "optional",
                    "type": "int32",
                    "name": "itemType",
                    "id": 3
                }]
            }, {
                "name": "Response",
                "fields": [{
                    "rule": "optional",
                    "type": "int32",
                    "name": "totalItem",
                    "id": 1
                }, {
                    "rule": "repeated",
                    "type": "GiftItemInfo",
                    "name": "itemInfos",
                    "id": 2
                }]
            }]
        }]
    }]
}).build();
exports.default = _root;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _index = __webpack_require__(246);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(19);

var _index4 = _interopRequireDefault(_index3);

var _cUrl = __webpack_require__(1);

var _cUrl2 = _interopRequireDefault(_cUrl);

var _api = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var visitor = {
    register: function register() {

        var _lang = _index4.default.type;
        var countryCode = _lang.split('-')[1].toUpperCase();

        return new Promise(function (resolve, reject) {
            (0, _api.safeAjax)({
                config: {
                    api: '/visitor/register/h5'
                },
                params: {
                    countryCode: countryCode,
                    deviceId: _cUrl2.default.query('deviceId')
                },
                pbObj: _index2.default.Visitor.RegisterH5
            }).then(function (data) {
                // cache.setCache('user', {
                //     uid: longToString(data.profile.uid),
                //     userToken: data.profile.userToken,
                //     subscribe: data.profile.subscribe
                // });
                //
                // cache.setCache('isVisitor', true);
                // $.channel.emit('registerVisitorSuccess');
                resolve(data.profile);
            }).catch(reject);
        });
    }
};

exports.default = visitor;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(142);


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * 用户侧送礼物入口
                                                                                                                                                                                                                                                                   * @author zhenn
                                                                                                                                                                                                                                                                   * @createTime 2017-12-18
                                                                                                                                                                                                                                                                   */

// 多语言文档：https://docs.google.com/spreadsheets/d/1de-Gbi1Bc-sg9Nx0YnPil4vvpWps0AdfMNOiRQDqUpI/edit#gid=0

// 登陆相关的API

// 适配域名


//  上拉加载，下拉刷新

// import './lib/mbase';


__webpack_require__(54);

__webpack_require__(143);

__webpack_require__(144);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(136);

var _cFastclick = __webpack_require__(171);

var _cFastclick2 = _interopRequireDefault(_cFastclick);

__webpack_require__(172);

__webpack_require__(173);

__webpack_require__(174);

__webpack_require__(70);

__webpack_require__(210);

__webpack_require__(137);

__webpack_require__(128);

var _ga = __webpack_require__(211);

var _ga2 = _interopRequireDefault(_ga);

var _views = __webpack_require__(212);

var _login = __webpack_require__(247);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

window.GA = _ga2.default;
_cFastclick2.default.attach(document.body);
try {
    UG.native.setTitle(UG.lang.template('Universal Gifting'));
} catch (e) {
    console.log(e);
}
document.title = UG.lang.template('Universal Gifting');

$.fn.dropload.setDefaults({
    scrollArea: window,
    threshold: 100,
    domDown: { // 下方DOM
        domClass: 'dropload-down',
        domRefresh: '<div class="dropload-refresh">\u2191' + UG.lang.template('Swipe up to load more') + '</div>',
        domLoad: '<div class="dropload-load"><span class="loading"></span>' + UG.lang.template('Loading...') + '</div>',
        domNoData: '<div class="dropload-noData">' + UG.lang.template('No more data') + '</div>'
    }
});

UpSDK.setConfig({
    channel: 'ugift2-gifto',
    language: UG.lang.type
});

var create = function create(type, Component) {
    return function (props) {
        var isLogin = (0, _login.isLogined)();
        console.log('开始渲染路由。。。。。。。。。。。login ===> ', isLogin);
        switch (type) {
            case 'singlechat':
                return _react2.default.createElement(_views.SingleChat, _extends({}, props, { key: props.match.params.uid }));
            case 'profile':
                return _react2.default.createElement(_views.Profile, _extends({}, props, { key: props.match.params.userId }));
            case 'createitem':
                return _react2.default.createElement(_views.CreateGiftItem, _extends({}, props, { key: props.match.params.step }));
        }

        if (!isLogin && ['project'].indexOf(type) !== -1) {
            return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/login' });
        } else {
            return _react2.default.createElement(Component, props);
        }
    };
};

var getConfirmation = function getConfirmation(message, back) {
    var _JSON$parse = JSON.parse(message),
        msg = _JSON$parse.msg,
        href = _JSON$parse.href;

    UG.confirm({
        title: UG.lang.template('Confirm'),
        content: msg,
        okClick: function okClick(des) {
            des();
            back(true);
        },
        cancelClick: function cancelClick(des) {
            des();
            //  虽然阻止了回退，但是历史也变了，这个是不允许的，所以需要加一下这个
            history.pushState(null, null, href);
            back(false);
        }
    });
};

var App = function (_Component) {
    _inherits(App, _Component);

    function App() {
        _classCallCheck(this, App);

        return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
    }

    _createClass(App, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var hash = UG.cache.getCache('redirectHash');
            var currentHash = location.hash.substring(1);
            UG.cache.removeCache('redirectHash');

            if (hash && !/undefined/i.test(hash) && hash !== currentHash) {
                UG.router.replace(hash);
            } else {
                if (currentHash && currentHash.indexOf('pl=uplive') !== -1) {
                    UG.router.replace('/');
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _reactRouterDom.HashRouter,
                { getUserConfirmation: getConfirmation },
                _react2.default.createElement(
                    _reactRouterDom.Switch,
                    null,
                    _react2.default.createElement(_reactRouterDom.Route, { path: '/', exact: true, render: create('project', _views.Project) }),
                    _react2.default.createElement(_reactRouterDom.Route, { path: '/gift', component: _views.Gift }),
                    _react2.default.createElement(_reactRouterDom.Route, { path: '/login', component: _views.Login }),
                    _react2.default.createElement(_reactRouterDom.Route, { path: '/wallet', component: _views.Wallet }),
                    _react2.default.createElement(_reactRouterDom.Route, { path: '/im', exact: true, component: _views.IMS }),
                    _react2.default.createElement(_reactRouterDom.Route, { path: '/im/singlechat/:uid', render: create('singlechat') }),
                    _react2.default.createElement(_reactRouterDom.Route, { path: '/im/friendlist', component: _views.FriendListView }),
                    _react2.default.createElement(_reactRouterDom.Route, { path: '/im/friendapply', component: _views.FriendApply }),
                    _react2.default.createElement(_reactRouterDom.Route, { path: '/leaderboard/:id/:userId', component: _views.LeaderBoard }),
                    _react2.default.createElement(_reactRouterDom.Route, { path: '/profile/:userId', render: create('profile') }),
                    _react2.default.createElement(_reactRouterDom.Route, { path: '/photoedit', component: _views.PhotoEdit }),
                    _react2.default.createElement(_reactRouterDom.Route, { path: '/alipayredirect', component: _views.AlipayRedirect }),
                    _react2.default.createElement(_reactRouterDom.Route, { path: '/wxpayredirect', component: _views.WxpayRedirect }),
                    _react2.default.createElement(_reactRouterDom.Route, { path: '/land', component: _views.Land }),
                    _react2.default.createElement(_reactRouterDom.Route, { path: '/project', exact: true, render: create('project', _views.Project) }),
                    _react2.default.createElement(_reactRouterDom.Route, { path: '/project/detail/:id', component: _views.ProjectDetail }),
                    _react2.default.createElement(_reactRouterDom.Route, { path: '/createitem/:step/:id', render: create('createitem') }),
                    _react2.default.createElement(_reactRouterDom.Route, { path: '/createitem/:step', render: create('createitem') }),
                    _react2.default.createElement(_reactRouterDom.Route, { path: '/earnings/:userId', render: create('earnings', _views.Earnings) }),
                    _react2.default.createElement(_reactRouterDom.Route, { path: '/blockchain', component: _views.BlockChainView }),
                    _react2.default.createElement(_reactRouterDom.Route, { path: '/giftshow/:gmid', component: _views.GiftShowView })
                )
            );
        }
    }]);

    return App;
}(_react.Component);

// alert(navigator.appVersion);
// alert(navigator.vendor);


$('#wrap').css('min-height', $(window).height());

$(window).on('resize', function () {
    $('#wrap').css('min-height', $(window).height());
});

(0, _login.loginInit)(App, _views.NoPermission);
// TODO  test login on dev
// http://m.upliveapps.com/ugift2/gifto.html?env=dev#/
// UpSDK.on('getUserSuccess', (data) => {
//     // data 将授权信息直接带回去就可以了
//     console.log(data);
// });
// if (location.href.indexOf('code') < 0) {
//     UpSDK.login({
//         oauthtype: 'line'
//     });
// }

/***/ }),
/* 143 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 144 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(56);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["createBrowserHistory"])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(147);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);


/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return (
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(function(item, index) {
        return valueEqual(item, b[index]);
      })
    );
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = valueOf(a);
    var bValue = valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(Object.assign({}, a, b)).every(function(key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);


/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (warning);


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    throw new Error(prefix + ": " + (message || ''));
}

/* harmony default export */ __webpack_exports__["a"] = (invariant);


/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(56);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["createHashHistory"])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (HashRouter);

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(155);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(57);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["createMemoryHistory"])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(101);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 157 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(159);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(161);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(105);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["createLocation"])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["createLocation"])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["locationsAreEqual"])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(163);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(57);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["createPath"])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["createLocation"])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["createLocation"])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["createLocation"])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(165);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(58);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(105);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(58);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(169);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(103);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 171 */
/***/ (function(module, exports) {



;(function () {
	'use strict';

	/**
  * @preserve FastClick: polyfill to remove click delays on browsers with touch UIs.
  *
  * @codingstandard ftlabs-jsv2
  * @copyright The Financial Times Limited [All Rights Reserved]
  * @license MIT License (see LICENSE.txt)
  */

	/*jslint browser:true, node:true*/
	/*global define, Event, Node*/

	/**
  * Instantiate fast-clicking listeners on the specified layer.
  *
  * @constructor
  * @param {Element} layer The layer to listen on
  * @param {Object} [options={}] The options to override the defaults
  */

	function FastClick(layer, options) {
		var oldOnClick;

		options = options || {};

		/**
   * Whether a click is currently being tracked.
   *
   * @type boolean
   */
		this.trackingClick = false;

		/**
   * Timestamp for when click tracking started.
   *
   * @type number
   */
		this.trackingClickStart = 0;

		/**
   * The element being tracked for a click.
   *
   * @type EventTarget
   */
		this.targetElement = null;

		/**
   * X-coordinate of touch start event.
   *
   * @type number
   */
		this.touchStartX = 0;

		/**
   * Y-coordinate of touch start event.
   *
   * @type number
   */
		this.touchStartY = 0;

		/**
   * ID of the last touch, retrieved from Touch.identifier.
   *
   * @type number
   */
		this.lastTouchIdentifier = 0;

		/**
   * Touchmove boundary, beyond which a click will be cancelled.
   *
   * @type number
   */
		this.touchBoundary = options.touchBoundary || 10;

		/**
   * The FastClick layer.
   *
   * @type Element
   */
		this.layer = layer;

		/**
   * The minimum time between tap(touchstart and touchend) events
   *
   * @type number
   */
		this.tapDelay = options.tapDelay || 200;

		/**
   * The maximum time for a tap
   *
   * @type number
   */
		this.tapTimeout = options.tapTimeout || 700;

		if (FastClick.notNeeded(layer)) {
			return;
		}

		// Some old versions of Android don't have Function.prototype.bind
		function bind(method, context) {
			return function () {
				return method.apply(context, arguments);
			};
		}

		var methods = ['onMouse', 'onClick', 'onTouchStart', 'onTouchMove', 'onTouchEnd', 'onTouchCancel'];
		var context = this;
		for (var i = 0, l = methods.length; i < l; i++) {
			context[methods[i]] = bind(context[methods[i]], context);
		}

		// Set up event handlers as required
		if (deviceIsAndroid) {
			layer.addEventListener('mouseover', this.onMouse, true);
			layer.addEventListener('mousedown', this.onMouse, true);
			layer.addEventListener('mouseup', this.onMouse, true);
		}

		layer.addEventListener('click', this.onClick, true);
		layer.addEventListener('touchstart', this.onTouchStart, false);
		layer.addEventListener('touchmove', this.onTouchMove, false);
		layer.addEventListener('touchend', this.onTouchEnd, false);
		layer.addEventListener('touchcancel', this.onTouchCancel, false);

		// Hack is required for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
		// which is how FastClick normally stops click events bubbling to callbacks registered on the FastClick
		// layer when they are cancelled.
		if (!Event.prototype.stopImmediatePropagation) {
			layer.removeEventListener = function (type, callback, capture) {
				var rmv = Node.prototype.removeEventListener;
				if (type === 'click') {
					rmv.call(layer, type, callback.hijacked || callback, capture);
				} else {
					rmv.call(layer, type, callback, capture);
				}
			};

			layer.addEventListener = function (type, callback, capture) {
				var adv = Node.prototype.addEventListener;
				if (type === 'click') {
					adv.call(layer, type, callback.hijacked || (callback.hijacked = function (event) {
						if (!event.propagationStopped) {
							callback(event);
						}
					}), capture);
				} else {
					adv.call(layer, type, callback, capture);
				}
			};
		}

		// If a handler is already declared in the element's onclick attribute, it will be fired before
		// FastClick's onClick handler. Fix this by pulling out the user-defined handler function and
		// adding it as listener.
		if (typeof layer.onclick === 'function') {

			// Android browser on at least 3.2 requires a new reference to the function in layer.onclick
			// - the old one won't work if passed to addEventListener directly.
			oldOnClick = layer.onclick;
			layer.addEventListener('click', function (event) {
				oldOnClick(event);
			}, false);
			layer.onclick = null;
		}
	}

	/**
 * Windows Phone 8.1 fakes user agent string to look like Android and iPhone.
 *
 * @type boolean
 */
	var deviceIsWindowsPhone = navigator.userAgent.indexOf("Windows Phone") >= 0;

	/**
  * Android requires exceptions.
  *
  * @type boolean
  */
	var deviceIsAndroid = navigator.userAgent.indexOf('Android') > 0 && !deviceIsWindowsPhone;

	/**
  * iOS requires exceptions.
  *
  * @type boolean
  */
	var deviceIsIOS = /iP(ad|hone|od)/.test(navigator.userAgent) && !deviceIsWindowsPhone;

	/**
  * iOS 4 requires an exception for select elements.
  *
  * @type boolean
  */
	var deviceIsIOS4 = deviceIsIOS && /OS 4_\d(_\d)?/.test(navigator.userAgent);

	/**
  * iOS 6.0-7.* requires the target element to be manually derived
  *
  * @type boolean
  */
	var deviceIsIOSWithBadTarget = deviceIsIOS && /OS [6-7]_\d/.test(navigator.userAgent);

	/**
  * BlackBerry requires exceptions.
  *
  * @type boolean
  */
	var deviceIsBlackBerry10 = navigator.userAgent.indexOf('BB10') > 0;

	/**
  * Determine whether a given element requires a native click.
  *
  * @param {EventTarget|Element} target Target DOM element
  * @returns {boolean} Returns true if the element needs a native click
  */
	FastClick.prototype.needsClick = function (target) {
		switch (target.nodeName.toLowerCase()) {

			// Don't send a synthetic click to disabled inputs (issue #62)
			case 'button':
			case 'select':
			case 'textarea':
				if (target.disabled) {
					return true;
				}

				break;
			case 'input':

				// File inputs need real clicks on iOS 6 due to a browser bug (issue #68)
				if (deviceIsIOS && target.type === 'file' || target.disabled) {
					return true;
				}

				break;
			case 'label':
			case 'iframe': // iOS8 homescreen apps can prevent events bubbling into frames
			case 'video':
				return true;
		}

		return (/\bneedsclick\b/.test(target.className)
		);
	};

	/**
  * Determine whether a given element requires a call to focus to simulate click into element.
  *
  * @param {EventTarget|Element} target Target DOM element
  * @returns {boolean} Returns true if the element requires a call to focus to simulate native click.
  */
	FastClick.prototype.needsFocus = function (target) {
		switch (target.nodeName.toLowerCase()) {
			case 'textarea':
				return true;
			case 'select':
				return !deviceIsAndroid;
			case 'input':
				switch (target.type) {
					case 'button':
					case 'checkbox':
					case 'file':
					case 'image':
					case 'radio':
					case 'submit':
						return false;
				}

				// No point in attempting to focus disabled inputs
				return !target.disabled && !target.readOnly;
			default:
				return (/\bneedsfocus\b/.test(target.className)
				);
		}
	};

	/**
  * Send a click event to the specified element.
  *
  * @param {EventTarget|Element} targetElement
  * @param {Event} event
  */
	FastClick.prototype.sendClick = function (targetElement, event) {
		var clickEvent, touch;

		// On some Android devices activeElement needs to be blurred otherwise the synthetic click will have no effect (#24)
		if (document.activeElement && document.activeElement !== targetElement) {
			document.activeElement.blur();
		}

		touch = event.changedTouches[0];

		// Synthesise a click event, with an extra attribute so it can be tracked
		clickEvent = document.createEvent('MouseEvents');
		clickEvent.initMouseEvent(this.determineEventType(targetElement), true, true, window, 1, touch.screenX, touch.screenY, touch.clientX, touch.clientY, false, false, false, false, 0, null);
		clickEvent.forwardedTouchEvent = true;
		targetElement.dispatchEvent(clickEvent);
	};

	FastClick.prototype.determineEventType = function (targetElement) {

		//Issue #159: Android Chrome Select Box does not open with a synthetic click event
		if (deviceIsAndroid && targetElement.tagName.toLowerCase() === 'select') {
			return 'mousedown';
		}

		return 'click';
	};

	/**
  * @param {EventTarget|Element} targetElement
  */
	FastClick.prototype.focus = function (targetElement) {
		var length;

		// Issue #160: on iOS 7, some input elements (e.g. date datetime month) throw a vague TypeError on setSelectionRange. These elements don't have an integer value for the selectionStart and selectionEnd properties, but unfortunately that can't be used for detection because accessing the properties also throws a TypeError. Just check the type instead. Filed as Apple bug #15122724.
		if (deviceIsIOS && targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
			length = targetElement.value.length;
			targetElement.setSelectionRange(length, length);
		} else {
			targetElement.focus();
		}
	};

	/**
  * Check whether the given target element is a child of a scrollable layer and if so, set a flag on it.
  *
  * @param {EventTarget|Element} targetElement
  */
	FastClick.prototype.updateScrollParent = function (targetElement) {
		var scrollParent, parentElement;

		scrollParent = targetElement.fastClickScrollParent;

		// Attempt to discover whether the target element is contained within a scrollable layer. Re-check if the
		// target element was moved to another parent.
		if (!scrollParent || !scrollParent.contains(targetElement)) {
			parentElement = targetElement;
			do {
				if (parentElement.scrollHeight > parentElement.offsetHeight) {
					scrollParent = parentElement;
					targetElement.fastClickScrollParent = parentElement;
					break;
				}

				parentElement = parentElement.parentElement;
			} while (parentElement);
		}

		// Always update the scroll top tracker if possible.
		if (scrollParent) {
			scrollParent.fastClickLastScrollTop = scrollParent.scrollTop;
		}
	};

	/**
  * @param {EventTarget} targetElement
  * @returns {Element|EventTarget}
  */
	FastClick.prototype.getTargetElementFromEventTarget = function (eventTarget) {

		// On some older browsers (notably Safari on iOS 4.1 - see issue #56) the event target may be a text node.
		if (eventTarget.nodeType === Node.TEXT_NODE) {
			return eventTarget.parentNode;
		}

		return eventTarget;
	};

	/**
  * On touch start, record the position and scroll offset.
  *
  * @param {Event} event
  * @returns {boolean}
  */
	FastClick.prototype.onTouchStart = function (event) {
		var targetElement, touch, selection;

		// Ignore multiple touches, otherwise pinch-to-zoom is prevented if both fingers are on the FastClick element (issue #111).
		if (event.targetTouches.length > 1) {
			return true;
		}

		targetElement = this.getTargetElementFromEventTarget(event.target);
		touch = event.targetTouches[0];

		if (deviceIsIOS) {

			// Only trusted events will deselect text on iOS (issue #49)
			selection = window.getSelection();
			if (selection.rangeCount && !selection.isCollapsed) {
				return true;
			}

			if (!deviceIsIOS4) {

				// Weird things happen on iOS when an alert or confirm dialog is opened from a click event callback (issue #23):
				// when the user next taps anywhere else on the page, new touchstart and touchend events are dispatched
				// with the same identifier as the touch event that previously triggered the click that triggered the alert.
				// Sadly, there is an issue on iOS 4 that causes some normal touch events to have the same identifier as an
				// immediately preceeding touch event (issue #52), so this fix is unavailable on that platform.
				// Issue 120: touch.identifier is 0 when Chrome dev tools 'Emulate touch events' is set with an iOS device UA string,
				// which causes all touch events to be ignored. As this block only applies to iOS, and iOS identifiers are always long,
				// random integers, it's safe to to continue if the identifier is 0 here.
				if (touch.identifier && touch.identifier === this.lastTouchIdentifier) {
					event.preventDefault();
					return false;
				}

				this.lastTouchIdentifier = touch.identifier;

				// If the target element is a child of a scrollable layer (using -webkit-overflow-scrolling: touch) and:
				// 1) the user does a fling scroll on the scrollable layer
				// 2) the user stops the fling scroll with another tap
				// then the event.target of the last 'touchend' event will be the element that was under the user's finger
				// when the fling scroll was started, causing FastClick to send a click event to that layer - unless a check
				// is made to ensure that a parent layer was not scrolled before sending a synthetic click (issue #42).
				this.updateScrollParent(targetElement);
			}
		}

		this.trackingClick = true;
		this.trackingClickStart = event.timeStamp;
		this.targetElement = targetElement;

		this.touchStartX = touch.pageX;
		this.touchStartY = touch.pageY;

		// Prevent phantom clicks on fast double-tap (issue #36)
		if (event.timeStamp - this.lastClickTime < this.tapDelay) {
			event.preventDefault();
		}

		return true;
	};

	/**
  * Based on a touchmove event object, check whether the touch has moved past a boundary since it started.
  *
  * @param {Event} event
  * @returns {boolean}
  */
	FastClick.prototype.touchHasMoved = function (event) {
		var touch = event.changedTouches[0],
		    boundary = this.touchBoundary;

		if (Math.abs(touch.pageX - this.touchStartX) > boundary || Math.abs(touch.pageY - this.touchStartY) > boundary) {
			return true;
		}

		return false;
	};

	/**
  * Update the last position.
  *
  * @param {Event} event
  * @returns {boolean}
  */
	FastClick.prototype.onTouchMove = function (event) {
		if (!this.trackingClick) {
			return true;
		}

		// If the touch has moved, cancel the click tracking
		if (this.targetElement !== this.getTargetElementFromEventTarget(event.target) || this.touchHasMoved(event)) {
			this.trackingClick = false;
			this.targetElement = null;
		}

		return true;
	};

	/**
  * Attempt to find the labelled control for the given label element.
  *
  * @param {EventTarget|HTMLLabelElement} labelElement
  * @returns {Element|null}
  */
	FastClick.prototype.findControl = function (labelElement) {

		// Fast path for newer browsers supporting the HTML5 control attribute
		if (labelElement.control !== undefined) {
			return labelElement.control;
		}

		// All browsers under test that support touch events also support the HTML5 htmlFor attribute
		if (labelElement.htmlFor) {
			return document.getElementById(labelElement.htmlFor);
		}

		// If no for attribute exists, attempt to retrieve the first labellable descendant element
		// the list of which is defined here: http://www.w3.org/TR/html5/forms.html#category-label
		return labelElement.querySelector('button, input:not([type=hidden]), keygen, meter, output, progress, select, textarea');
	};

	/**
  * On touch end, determine whether to send a click event at once.
  *
  * @param {Event} event
  * @returns {boolean}
  */
	FastClick.prototype.onTouchEnd = function (event) {
		var forElement,
		    trackingClickStart,
		    targetTagName,
		    scrollParent,
		    touch,
		    targetElement = this.targetElement;

		if (!this.trackingClick) {
			return true;
		}

		// Prevent phantom clicks on fast double-tap (issue #36)
		if (event.timeStamp - this.lastClickTime < this.tapDelay) {
			this.cancelNextClick = true;
			return true;
		}

		if (event.timeStamp - this.trackingClickStart > this.tapTimeout) {
			return true;
		}

		// Reset to prevent wrong click cancel on input (issue #156).
		this.cancelNextClick = false;

		this.lastClickTime = event.timeStamp;

		trackingClickStart = this.trackingClickStart;
		this.trackingClick = false;
		this.trackingClickStart = 0;

		// On some iOS devices, the targetElement supplied with the event is invalid if the layer
		// is performing a transition or scroll, and has to be re-detected manually. Note that
		// for this to function correctly, it must be called *after* the event target is checked!
		// See issue #57; also filed as rdar://13048589 .
		if (deviceIsIOSWithBadTarget) {
			touch = event.changedTouches[0];

			// In certain cases arguments of elementFromPoint can be negative, so prevent setting targetElement to null
			targetElement = document.elementFromPoint(touch.pageX - window.pageXOffset, touch.pageY - window.pageYOffset) || targetElement;
			targetElement.fastClickScrollParent = this.targetElement.fastClickScrollParent;
		}

		targetTagName = targetElement.tagName.toLowerCase();
		if (targetTagName === 'label') {
			forElement = this.findControl(targetElement);
			if (forElement) {
				this.focus(targetElement);
				if (deviceIsAndroid) {
					return false;
				}

				targetElement = forElement;
			}
		} else if (this.needsFocus(targetElement)) {

			// Case 1: If the touch started a while ago (best guess is 100ms based on tests for issue #36) then focus will be triggered anyway. Return early and unset the target element reference so that the subsequent click will be allowed through.
			// Case 2: Without this exception for input elements tapped when the document is contained in an iframe, then any inputted text won't be visible even though the value attribute is updated as the user types (issue #37).
			if (event.timeStamp - trackingClickStart > 100 || deviceIsIOS && window.top !== window && targetTagName === 'input') {
				this.targetElement = null;
				return false;
			}

			this.focus(targetElement);
			this.sendClick(targetElement, event);

			// Select elements need the event to go through on iOS 4, otherwise the selector menu won't open.
			// Also this breaks opening selects when VoiceOver is active on iOS6, iOS7 (and possibly others)
			if (!deviceIsIOS || targetTagName !== 'select') {
				this.targetElement = null;
				event.preventDefault();
			}

			return false;
		}

		if (deviceIsIOS && !deviceIsIOS4) {

			// Don't send a synthetic click event if the target element is contained within a parent layer that was scrolled
			// and this tap is being used to stop the scrolling (usually initiated by a fling - issue #42).
			scrollParent = targetElement.fastClickScrollParent;
			if (scrollParent && scrollParent.fastClickLastScrollTop !== scrollParent.scrollTop) {
				return true;
			}
		}

		// Prevent the actual click from going though - unless the target node is marked as requiring
		// real clicks or if it is in the whitelist in which case only non-programmatic clicks are permitted.
		if (!this.needsClick(targetElement)) {
			event.preventDefault();
			this.sendClick(targetElement, event);
		}

		return false;
	};

	/**
  * On touch cancel, stop tracking the click.
  *
  * @returns {void}
  */
	FastClick.prototype.onTouchCancel = function () {
		this.trackingClick = false;
		this.targetElement = null;
	};

	/**
  * Determine mouse events which should be permitted.
  *
  * @param {Event} event
  * @returns {boolean}
  */
	FastClick.prototype.onMouse = function (event) {

		// If a target element was never set (because a touch event was never fired) allow the event
		if (!this.targetElement) {
			return true;
		}

		if (event.forwardedTouchEvent) {
			return true;
		}

		// Programmatically generated events targeting a specific element should be permitted
		if (!event.cancelable) {
			return true;
		}

		// Derive and check the target element to see whether the mouse event needs to be permitted;
		// unless explicitly enabled, prevent non-touch click events from triggering actions,
		// to prevent ghost/doubleclicks.
		if (!this.needsClick(this.targetElement) || this.cancelNextClick) {

			// Prevent any user-added listeners declared on FastClick element from being fired.
			if (event.stopImmediatePropagation) {
				event.stopImmediatePropagation();
			} else {

				// Part of the hack for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
				event.propagationStopped = true;
			}

			// Cancel the event
			event.stopPropagation();
			event.preventDefault();

			return false;
		}

		// If the mouse event is permitted, return true for the action to go through.
		return true;
	};

	/**
  * On actual clicks, determine whether this is a touch-generated click, a click action occurring
  * naturally after a delay after a touch (which needs to be cancelled to avoid duplication), or
  * an actual click which should be permitted.
  *
  * @param {Event} event
  * @returns {boolean}
  */
	FastClick.prototype.onClick = function (event) {
		var permitted;

		// It's possible for another FastClick-like library delivered with third-party code to fire a click event before FastClick does (issue #44). In that case, set the click-tracking flag back to false and return early. This will cause onTouchEnd to return early.
		if (this.trackingClick) {
			this.targetElement = null;
			this.trackingClick = false;
			return true;
		}

		// Very odd behaviour on iOS (issue #18): if a submit element is present inside a form and the user hits enter in the iOS simulator or clicks the Go button on the pop-up OS keyboard the a kind of 'fake' click event will be triggered with the submit-type input element as the target.
		if (event.target.type === 'submit' && event.detail === 0) {
			return true;
		}

		permitted = this.onMouse(event);

		// Only unset targetElement if the click is not permitted. This will ensure that the check for !targetElement in onMouse fails and the browser's click doesn't go through.
		if (!permitted) {
			this.targetElement = null;
		}

		// If clicks are permitted, return true for the action to go through.
		return permitted;
	};

	/**
  * Remove all FastClick's event listeners.
  *
  * @returns {void}
  */
	FastClick.prototype.destroy = function () {
		var layer = this.layer;

		if (deviceIsAndroid) {
			layer.removeEventListener('mouseover', this.onMouse, true);
			layer.removeEventListener('mousedown', this.onMouse, true);
			layer.removeEventListener('mouseup', this.onMouse, true);
		}

		layer.removeEventListener('click', this.onClick, true);
		layer.removeEventListener('touchstart', this.onTouchStart, false);
		layer.removeEventListener('touchmove', this.onTouchMove, false);
		layer.removeEventListener('touchend', this.onTouchEnd, false);
		layer.removeEventListener('touchcancel', this.onTouchCancel, false);
	};

	/**
  * Check whether FastClick is needed.
  *
  * @param {Element} layer The layer to listen on
  */
	FastClick.notNeeded = function (layer) {
		var metaViewport;
		var chromeVersion;
		var blackberryVersion;
		var firefoxVersion;

		// Devices that don't support touch don't need FastClick
		if (typeof window.ontouchstart === 'undefined') {
			return true;
		}

		// Chrome version - zero for other browsers
		chromeVersion = +(/Chrome\/([0-9]+)/.exec(navigator.userAgent) || [, 0])[1];

		if (chromeVersion) {

			if (deviceIsAndroid) {
				metaViewport = document.querySelector('meta[name=viewport]');

				if (metaViewport) {
					// Chrome on Android with user-scalable="no" doesn't need FastClick (issue #89)
					if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
						return true;
					}
					// Chrome 32 and above with width=device-width or less don't need FastClick
					if (chromeVersion > 31 && document.documentElement.scrollWidth <= window.outerWidth) {
						return true;
					}
				}

				// Chrome desktop doesn't need FastClick (issue #15)
			} else {
				return true;
			}
		}

		if (deviceIsBlackBerry10) {
			blackberryVersion = navigator.userAgent.match(/Version\/([0-9]*)\.([0-9]*)/);

			// BlackBerry 10.3+ does not require Fastclick library.
			// https://github.com/ftlabs/fastclick/issues/251
			if (blackberryVersion[1] >= 10 && blackberryVersion[2] >= 3) {
				metaViewport = document.querySelector('meta[name=viewport]');

				if (metaViewport) {
					// user-scalable=no eliminates click delay.
					if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
						return true;
					}
					// width=device-width (or less than device-width) eliminates click delay.
					if (document.documentElement.scrollWidth <= window.outerWidth) {
						return true;
					}
				}
			}
		}

		// IE10 with -ms-touch-action: none or manipulation, which disables double-tap-to-zoom (issue #97)
		if (layer.style.msTouchAction === 'none' || layer.style.touchAction === 'manipulation') {
			return true;
		}

		// Firefox version - zero for other browsers
		firefoxVersion = +(/Firefox\/([0-9]+)/.exec(navigator.userAgent) || [, 0])[1];

		if (firefoxVersion >= 27) {
			// Firefox 27+ does not have tap delay if the content is not zoomable - https://bugzilla.mozilla.org/show_bug.cgi?id=922896

			metaViewport = document.querySelector('meta[name=viewport]');
			if (metaViewport && (metaViewport.content.indexOf('user-scalable=no') !== -1 || document.documentElement.scrollWidth <= window.outerWidth)) {
				return true;
			}
		}

		// IE11: prefixed -ms-touch-action is no longer supported and it's recomended to use non-prefixed version
		// http://msdn.microsoft.com/en-us/library/windows/apps/Hh767313.aspx
		if (layer.style.touchAction === 'none' || layer.style.touchAction === 'manipulation') {
			return true;
		}

		return false;
	};

	/**
  * Factory method for creating a FastClick object
  *
  * @param {Element} layer The layer to listen on
  * @param {Object} [options={}] The options to override the defaults
  */
	FastClick.attach = function (layer, options) {
		return new FastClick(layer, options);
	};

	window.FastClick = FastClick;

	module.exports = FastClick;
	// if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) {

	// 	// AMD. Register as an anonymous module.
	// 	define(function() {
	// 		return FastClick;
	// 	});
	// } else if (typeof module !== 'undefined' && module.exports) {
	// 	module.exports = FastClick.attach;
	// 	module.exports.FastClick = FastClick;
	// } else {
	// 	window.FastClick = FastClick;
	// }
})();

/***/ }),
/* 172 */
/***/ (function(module, exports) {

if (typeof Object.assign != 'function') {
  Object.assign = function (target) {
    'use strict';

    if (target == null) {
      throw new TypeError('Cannot convert undefined or null to object');
    }

    target = Object(target);
    for (var index = 1; index < arguments.length; index++) {
      var source = arguments[index];
      if (source != null) {
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
    }
    return target;
  };
}

/***/ }),
/* 173 */
/***/ (function(module, exports) {

//////////////////////////////////////////////////////////////////////////////
// the status constants
var PENDING = 0,
    FULFILLED = 1,
    REJECTED = 2;

//////////////////////////////////////////////////////////////////////////////
// Some utils
function isFunction(obj) {
    return typeof obj === "function";
}

function isThenable(obj) {
    return obj && isFunction(obj.then);
}

function checkArray(obj) {
    if (!Array.isArray(obj)) {
        throw new TypeError(obj + " is not array");
    }
}

//////////////////////////////////////////////////////////////////////////////
function resolve(value) {
    if (this._status !== PENDING) {
        return;
    }

    this._v = value;
    this._status = FULFILLED;

    var fn;
    while (fn = this._resolves.shift()) {
        fn.call(this, value);
    }
}

function reject(reason) {
    if (this._status !== PENDING) {
        return;
    }

    this._v = reason;
    this._status = REJECTED;

    var fn;
    while (fn = this._rejects.shift()) {
        fn.call(this, reason);
    }
}

//////////////////////////////////////////////////////////////////////////////
// The constructor function
function Promise(fn) {
    if (!isFunction(fn)) {
        throw new TypeError("Promise argument error:" + fn.toString());
    }

    this._status = PENDING;
    this._resolves = [];
    this._rejects = [];
    this._v = undefined;

    fn(resolve.bind(this), reject.bind(this));
}

//////////////////////////////////////////////////////////////////////////////
// The most important function for Promise is `then`

// `resolve` have different rules against `reject`:
// `resolve` will always trigger the `resolve` of next Promise, while
// `reject` may trigger the `reject` or `resolve` of next Promise.

function resolveWrapper(nRes, nRej, pResFn) {
    return function (value) {
        if (!isFunction(pResFn)) {
            return nRes(value);
        }

        try {
            var ret = pResFn(value);
            if (isThenable(ret)) {
                ret.then(nRes, nRej);
            } else {
                nRes(ret);
            }
        } catch (e) {
            nRej(e);
        }
    };
}

function rejectWrapper(nRes, nRej, pRejFn) {
    return function (reason) {
        if (!isFunction(pRejFn)) {
            return nRej(reason);
        }

        try {
            var ret = pRejFn(reason);
            if (isThenable(ret)) {
                ret.then(nRes, nRej);
            } else {
                nRes(ret);
            }
        } catch (e) {
            nRej(e);
        }
    };
}

function thenHandler(nRes, nRej, pResFn, pRejFn, pP) {
    var rsFn = resolveWrapper(nRes, nRej, pResFn);
    var rjFn = rejectWrapper(nRes, nRej, pRejFn);

    switch (pP._status) {
        case PENDING:
            pP._resolves.push(rsFn);
            pP._rejects.push(rjFn);
            break;
        case FULFILLED:
            rsFn(pP._v);
            break;
        case REJECTED:
            rjFn(pP._v);
            break;
        default:
            throw new Error("invalid status:" + pP._status);
    }
}

Promise.prototype.then = function (resFn, rejFn) {
    var pP = this;
    return new Promise(function (res, rej) {
        return thenHandler(res, rej, resFn, rejFn, pP);
    });
};

//////////////////////////////////////////////////////////////////////////////
// Some utils
Promise.prototype.catch = function (reason) {
    return this.then(null, reason);
};
Promise.resolve = function (value) {
    return new Promise(function (res, _) {
        return res(value);
    });
};
Promise.reject = function (reason) {
    return new Promise(function (_, rej) {
        return rej(reason);
    });
};

//////////////////////////////////////////////////////////////////////////////
// Promise.all
function handleAll(promises, resolve, reject) {
    // all promises share the same `count` and `result`.
    var count = promises.length;
    var result = [];

    function handle(i) {
        return function (value) {
            result[i] = value;
            if (--count === 0) {
                resolve(result);
            }
        };
    }
    promises.forEach(function (p, i) {
        return p.then(handle(i), reject);
    });
}

Promise.all = function (promises) {
    checkArray(promises);
    return new Promise(function (res, rej) {
        return handleAll(promises, res, rej);
    });
};

//////////////////////////////////////////////////////////////////////////////
// Promise.race
Promise.race = function (promises) {
    checkArray(promises);
    return new Promise(function (res, rej) {
        return promises.forEach(function (p) {
            return p.then(res, rej);
        });
    });
};

if (typeof window.Promise != 'function') {
    window.Promise = Promise;
}

//////////////////////////////////////////////////////////////////////////////
// For nodejs
module.exports = Promise;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var _map = __webpack_require__(175);

var _map2 = _interopRequireDefault(_map);

var _set = __webpack_require__(200);

var _set2 = _interopRequireDefault(_set);

var _bluebird = __webpack_require__(202);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _history = __webpack_require__(16);

var _lang = __webpack_require__(19);

var _lang2 = _interopRequireDefault(_lang);

var _cUrl = __webpack_require__(1);

var _cUrl2 = _interopRequireDefault(_cUrl);

var _cCache = __webpack_require__(10);

var _cCache2 = _interopRequireDefault(_cCache);

var _cLoading = __webpack_require__(205);

var _cLoading2 = _interopRequireDefault(_cLoading);

var _cNotification = __webpack_require__(44);

var _cNotification2 = _interopRequireDefault(_cNotification);

var _cUpNative = __webpack_require__(21);

var _cUpNative2 = _interopRequireDefault(_cUpNative);

var _profile = __webpack_require__(99);

var _profile2 = _interopRequireDefault(_profile);

var _dialog = __webpack_require__(207);

var _dialog2 = _interopRequireDefault(_dialog);

var _resultresponse = __webpack_require__(49);

var _resultresponse2 = _interopRequireDefault(_resultresponse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UG = {
    // auth,
    cache: new _cCache2.default({
        prefix: 'uplive'
    }), // 全局缓存对象
    lang: _lang2.default,
    router: (0, _history.createHashHistory)(),
    clientType: 'h5uplive_universalgift', // 充值跟踪字段
    userChannel: 'h5_universalGifting',
    getGlobalUA: function getGlobalUA() {
        // 用户注册渠道，用于跟踪用户数据（登录、充值等等）
        var channel = this.userChannel;
        var UserAgent = 'H5/' + channel + ' version/9.9.9';
        if (window.smDeviceId) {
            UserAgent += ' smd/' + window.smDeviceId;
        }
        return UserAgent;
    },
    getLoginUserProfile: function getLoginUserProfile(success, fail) {

        var user = this.getUser();
        var failCount = 0;

        var getUserProfile = function getUserProfile() {
            var promise = _profile2.default.getUserInfo(user.uid);

            promise.then(function (msg) {

                msg.uid = longToString(msg.uid);
                msg.balance = msg.balance || {};
                msg.balance.bill = msg.balance.bill ? longToString(msg.balance.bill) : 0;
                msg.balance.diamond = msg.balance.diamond ? longToString(msg.balance.diamond) : 0;
                msg.balance.inBill = msg.balance.inBill ? longToString(msg.balance.inBill) : 0;
                msg.balance.outDiamond = msg.balance.outDiamond ? longToString(msg.balance.outDiamond) : 0;

                success(msg);
            }).catch(function () {
                failCount++;
                if (failCount === 3) {
                    fail();
                } else {
                    getUserProfile();
                }
            });
        };

        getUserProfile();
    },


    // 从local中获取登录成功的用户信息，含uid和usertoken
    getUser: function getUser() {
        return this.cache.getCache('user') || {};
    },
    clearUser: function clearUser() {
        this.cache.removeCache('user');
    },


    // 存储完整的用户信息（从profile中获取）
    loginUserInfo: null,

    setTitle: function setTitle(title) {
        // 这个title需要设置对应的网页的title
        document.title = title;
        // IOS
        _cUpNative2.default.setTitle({
            title: title,
            errtip: function errtip() {
                console.log('不支持该协议');
            }
        });
    },

    native: _cUpNative2.default,
    platform: _cUpNative2.default.getPlatform(),
    isUplive: _cUpNative2.default.getPlatform() === 'uplive' || localStorage.getItem('isUplive'),
    isStage: _cUrl2.default.query('env') === 'stage',
    isVistor: function isVistor() {
        return UG.getUser().isVisitor;
    }
}; /**
    * 挂载全局的一些配置/调用入口等
    * @author zhenn
    * @createTime 2017-10-23
    */

if (UG.isUplive) {
    localStorage.setItem('isUplive', true);
}

// 弹出一个提示窗
UG.confirm = _dialog2.default.confirm;
// toast
UG.simple = _cNotification2.default.simple;
// 正在加载
UG.loading = function (content) {
    return _cLoading2.default.show({ text: content });
};
//  里面绑定了this ： UG.loaded = Loading.hide 无效
UG.loaded = function () {
    return _cLoading2.default.hide();
};

/**
 * 加一个切换页面加载数据延迟1000ms的方法，因为加载总是很快的，如果太快就不显示loading了
 * @param msg 显示的加载的文本
 * @param timeout 延时时长
 * @returns {Function}
 */
UG.initLoading = function (msg) {
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;

    var out = setTimeout(function () {
        UG.loading(msg);
        clearTimeout(out);
        out = null;
    }, timeout);
    return function () {
        out ? clearTimeout(out) : UG.loaded();
    };
};

/**
 * Iscroll 在安卓和ios上点击事件有问题，在配置项必须加上click
 * {
 *  click: UG.iScrollClick()
 * }
 * @returns {boolean}
 */
UG.iScrollClick = function () {
    if (/iPhone|iPad|iPod|Macintosh/i.test(navigator.userAgent)) return false;
    if (/Chrome/i.test(navigator.userAgent)) return (/Android/i.test(navigator.userAgent)
    );
    if (/Silk/i.test(navigator.userAgent)) return false;
    if (/Android/i.test(navigator.userAgent)) {
        var s = navigator.userAgent.substr(navigator.userAgent.indexOf('Android') + 8, 3);
        return !(parseFloat(s[0] + s[3]) < 44);
    }
};

UG.isIOS = /iPhone|iPad|iPod/i.test(window.navigator.userAgent);
// 系统版本号
UG.osVersion = function () {
    var ua = navigator.userAgent;
    var osVersion = ua.match(/(?:OS|Android)[\/\s](\d+[._]\d+(?:[._]\d+)?)/i);

    if (osVersion) {
        osVersion = (osVersion[1] || '0.0.0').replace(/\_/g, '.');
    } else {
        osVersion = '0.0.0';
    }
    return osVersion;
}();

UG.compareVersion = function (v1, v2) {
    v1 = v1.toString().split('.');
    v2 = v2.toString().split('.');

    for (var i = 0; i < v1.length || i < v2.length; i++) {
        var n1 = parseInt(v1[i], 10),
            n2 = parseInt(v2[i], 10);

        if (window.isNaN(n1)) {
            n1 = 0;
        }
        if (window.isNaN(n2)) {
            n2 = 0;
        }
        if (n1 < n2) {
            return -1;
        } else if (n1 > n2) {
            return 1;
        }
    }
    return 0;
};
/**
 * IOS9不支持剪切板要做特殊处理
 * @returns {boolean}
 */
UG.isIOS9 = function () {
    var ua = navigator.userAgent;
    return ua.indexOf('iPhone OS 9') !== -1;
};

/**
 * 保留小数点
 * @param {Number} num
 * @param {Number} no
 * @returns {number}
 */
UG.toNumFixed = function (num) {
    var no = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;

    return parseFloat(Number(num).toFixed(no));
};

// 是否支持blob和download属性
UG.supportBlobAndDownload = 'download' in document.createElement('a') && 'toBlob' in document.createElement('canvas');

window.UG = UG;
window.Map = _map2.default;
window.Set = _set2.default;
window.Code = _resultresponse2.default.Code;
window.Promise = _bluebird2.default;
if (true) {
    window.alert = function (msg) {
        return msg;
    };
}

// 防止有些浏览器不支持
console.groupCollapsed = console.groupCollapsed || console.log;
console.groupEnd = console.groupEnd || function (a) {
    return a;
};

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(106);
__webpack_require__(113);
__webpack_require__(119);
__webpack_require__(190);
module.exports = __webpack_require__(29).Map;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(59)('native-function-to-string', Function.toString);


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(61);
var defined = __webpack_require__(62);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 178 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(115);
var descriptor = __webpack_require__(60);
var setToStringTag = __webpack_require__(65);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(31)(IteratorPrototype, __webpack_require__(3)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(32);
var anObject = __webpack_require__(33);
var getKeys = __webpack_require__(116);

module.exports = __webpack_require__(18) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(34);
var toIObject = __webpack_require__(48);
var arrayIndexOf = __webpack_require__(183)(false);
var IE_PROTO = __webpack_require__(64)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(108);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(48);
var toLength = __webpack_require__(117);
var toAbsoluteIndex = __webpack_require__(184);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(61);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(9).document;
module.exports = document && document.documentElement;


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(34);
var toObject = __webpack_require__(187);
var IE_PROTO = __webpack_require__(64)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(62);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(189);
var step = __webpack_require__(120);
var Iterators = __webpack_require__(36);
var toIObject = __webpack_require__(48);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(63)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(3)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(31)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(121);
var validate = __webpack_require__(66);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(126)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(33);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(36);
var ITERATOR = __webpack_require__(3)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(107);
var ITERATOR = __webpack_require__(3)('iterator');
var Iterators = __webpack_require__(36);
module.exports = __webpack_require__(29).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(9);
var dP = __webpack_require__(32);
var DESCRIPTORS = __webpack_require__(18);
var SPECIES = __webpack_require__(3)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(3)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(12);
var setPrototypeOf = __webpack_require__(197).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(12);
var anObject = __webpack_require__(33);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(47)(Function.call, __webpack_require__(198).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(199);
var createDesc = __webpack_require__(60);
var toIObject = __webpack_require__(48);
var toPrimitive = __webpack_require__(112);
var has = __webpack_require__(34);
var IE8_DOM_DEFINE = __webpack_require__(110);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(18) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 199 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(106);
__webpack_require__(113);
__webpack_require__(119);
__webpack_require__(201);
module.exports = __webpack_require__(29).Set;


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(121);
var validate = __webpack_require__(66);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(126)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global, setImmediate) {/* @preserve
 * The MIT License (MIT)
 * 
 * Copyright (c) 2013-2018 Petka Antonov
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 * 
 */
/**
 * bluebird build version 3.7.2
 * Features enabled: core, race, call_get, generators, map, nodeify, promisify, props, reduce, settle, some, using, timers, filter, any, each
*/
!function(t){if(true)module.exports=t();else if("function"==typeof define&&define.amd)define([],t);else{var e;"undefined"!=typeof window?e=window:"undefined"!=typeof global?e=global:"undefined"!=typeof self&&(e=self),e.Promise=t()}}(function(){var t,e,n;return function r(t,e,n){function i(s,a){if(!e[s]){if(!t[s]){var c="function"==typeof _dereq_&&_dereq_;if(!a&&c)return c(s,!0);if(o)return o(s,!0);var u=new Error("Cannot find module '"+s+"'");throw u.code="MODULE_NOT_FOUND",u}var l=e[s]={exports:{}};t[s][0].call(l.exports,function(e){var n=t[s][1][e];return i(n?n:e)},l,l.exports,r,t,e,n)}return e[s].exports}for(var o="function"==typeof _dereq_&&_dereq_,s=0;s<n.length;s++)i(n[s]);return i}({1:[function(t,e,n){"use strict";e.exports=function(t){function e(t){var e=new n(t),r=e.promise();return e.setHowMany(1),e.setUnwrap(),e.init(),r}var n=t._SomePromiseArray;t.any=function(t){return e(t)},t.prototype.any=function(){return e(this)}}},{}],2:[function(t,e,n){"use strict";function r(){this._customScheduler=!1,this._isTickUsed=!1,this._lateQueue=new f(16),this._normalQueue=new f(16),this._haveDrainedQueues=!1;var t=this;this.drainQueues=function(){t._drainQueues()},this._schedule=p}function i(t,e,n){this._lateQueue.push(t,e,n),this._queueTick()}function o(t,e,n){this._normalQueue.push(t,e,n),this._queueTick()}function s(t){this._normalQueue._pushOne(t),this._queueTick()}function a(t){for(;t.length()>0;)c(t)}function c(t){var e=t.shift();if("function"!=typeof e)e._settlePromises();else{var n=t.shift(),r=t.shift();e.call(n,r)}}var u;try{throw new Error}catch(l){u=l}var p=t("./schedule"),f=t("./queue");r.prototype.setScheduler=function(t){var e=this._schedule;return this._schedule=t,this._customScheduler=!0,e},r.prototype.hasCustomScheduler=function(){return this._customScheduler},r.prototype.haveItemsQueued=function(){return this._isTickUsed||this._haveDrainedQueues},r.prototype.fatalError=function(t,e){e?(process.stderr.write("Fatal "+(t instanceof Error?t.stack:t)+"\n"),process.exit(2)):this.throwLater(t)},r.prototype.throwLater=function(t,e){if(1===arguments.length&&(e=t,t=function(){throw e}),"undefined"!=typeof setTimeout)setTimeout(function(){t(e)},0);else try{this._schedule(function(){t(e)})}catch(n){throw new Error("No async scheduler available\n\n    See http://goo.gl/MqrFmX\n")}},r.prototype.invokeLater=i,r.prototype.invoke=o,r.prototype.settlePromises=s,r.prototype._drainQueues=function(){a(this._normalQueue),this._reset(),this._haveDrainedQueues=!0,a(this._lateQueue)},r.prototype._queueTick=function(){this._isTickUsed||(this._isTickUsed=!0,this._schedule(this.drainQueues))},r.prototype._reset=function(){this._isTickUsed=!1},e.exports=r,e.exports.firstLineError=u},{"./queue":26,"./schedule":29}],3:[function(t,e,n){"use strict";e.exports=function(t,e,n,r){var i=!1,o=function(t,e){this._reject(e)},s=function(t,e){e.promiseRejectionQueued=!0,e.bindingPromise._then(o,o,null,this,t)},a=function(t,e){0===(50397184&this._bitField)&&this._resolveCallback(e.target)},c=function(t,e){e.promiseRejectionQueued||this._reject(t)};t.prototype.bind=function(o){i||(i=!0,t.prototype._propagateFrom=r.propagateFromFunction(),t.prototype._boundValue=r.boundValueFunction());var u=n(o),l=new t(e);l._propagateFrom(this,1);var p=this._target();if(l._setBoundTo(u),u instanceof t){var f={promiseRejectionQueued:!1,promise:l,target:p,bindingPromise:u};p._then(e,s,void 0,l,f),u._then(a,c,void 0,l,f),l._setOnCancel(u)}else l._resolveCallback(p);return l},t.prototype._setBoundTo=function(t){void 0!==t?(this._bitField=2097152|this._bitField,this._boundTo=t):this._bitField=-2097153&this._bitField},t.prototype._isBound=function(){return 2097152===(2097152&this._bitField)},t.bind=function(e,n){return t.resolve(n).bind(e)}}},{}],4:[function(t,e,n){"use strict";function r(){try{Promise===o&&(Promise=i)}catch(t){}return o}var i;"undefined"!=typeof Promise&&(i=Promise);var o=t("./promise")();o.noConflict=r,e.exports=o},{"./promise":22}],5:[function(t,e,n){"use strict";var r=Object.create;if(r){var i=r(null),o=r(null);i[" size"]=o[" size"]=0}e.exports=function(e){function n(t,n){var r;if(null!=t&&(r=t[n]),"function"!=typeof r){var i="Object "+a.classString(t)+" has no method '"+a.toString(n)+"'";throw new e.TypeError(i)}return r}function r(t){var e=this.pop(),r=n(t,e);return r.apply(t,this)}function i(t){return t[this]}function o(t){var e=+this;return 0>e&&(e=Math.max(0,e+t.length)),t[e]}var s,a=t("./util"),c=a.canEvaluate;a.isIdentifier;e.prototype.call=function(t){var e=[].slice.call(arguments,1);return e.push(t),this._then(r,void 0,void 0,e,void 0)},e.prototype.get=function(t){var e,n="number"==typeof t;if(n)e=o;else if(c){var r=s(t);e=null!==r?r:i}else e=i;return this._then(e,void 0,void 0,t,void 0)}}},{"./util":36}],6:[function(t,e,n){"use strict";e.exports=function(e,n,r,i){var o=t("./util"),s=o.tryCatch,a=o.errorObj,c=e._async;e.prototype["break"]=e.prototype.cancel=function(){if(!i.cancellation())return this._warn("cancellation is disabled");for(var t=this,e=t;t._isCancellable();){if(!t._cancelBy(e)){e._isFollowing()?e._followee().cancel():e._cancelBranched();break}var n=t._cancellationParent;if(null==n||!n._isCancellable()){t._isFollowing()?t._followee().cancel():t._cancelBranched();break}t._isFollowing()&&t._followee().cancel(),t._setWillBeCancelled(),e=t,t=n}},e.prototype._branchHasCancelled=function(){this._branchesRemainingToCancel--},e.prototype._enoughBranchesHaveCancelled=function(){return void 0===this._branchesRemainingToCancel||this._branchesRemainingToCancel<=0},e.prototype._cancelBy=function(t){return t===this?(this._branchesRemainingToCancel=0,this._invokeOnCancel(),!0):(this._branchHasCancelled(),this._enoughBranchesHaveCancelled()?(this._invokeOnCancel(),!0):!1)},e.prototype._cancelBranched=function(){this._enoughBranchesHaveCancelled()&&this._cancel()},e.prototype._cancel=function(){this._isCancellable()&&(this._setCancelled(),c.invoke(this._cancelPromises,this,void 0))},e.prototype._cancelPromises=function(){this._length()>0&&this._settlePromises()},e.prototype._unsetOnCancel=function(){this._onCancelField=void 0},e.prototype._isCancellable=function(){return this.isPending()&&!this._isCancelled()},e.prototype.isCancellable=function(){return this.isPending()&&!this.isCancelled()},e.prototype._doInvokeOnCancel=function(t,e){if(o.isArray(t))for(var n=0;n<t.length;++n)this._doInvokeOnCancel(t[n],e);else if(void 0!==t)if("function"==typeof t){if(!e){var r=s(t).call(this._boundValue());r===a&&(this._attachExtraTrace(r.e),c.throwLater(r.e))}}else t._resultCancelled(this)},e.prototype._invokeOnCancel=function(){var t=this._onCancel();this._unsetOnCancel(),c.invoke(this._doInvokeOnCancel,this,t)},e.prototype._invokeInternalOnCancel=function(){this._isCancellable()&&(this._doInvokeOnCancel(this._onCancel(),!0),this._unsetOnCancel())},e.prototype._resultCancelled=function(){this.cancel()}}},{"./util":36}],7:[function(t,e,n){"use strict";e.exports=function(e){function n(t,n,a){return function(c){var u=a._boundValue();t:for(var l=0;l<t.length;++l){var p=t[l];if(p===Error||null!=p&&p.prototype instanceof Error){if(c instanceof p)return o(n).call(u,c)}else if("function"==typeof p){var f=o(p).call(u,c);if(f===s)return f;if(f)return o(n).call(u,c)}else if(r.isObject(c)){for(var h=i(p),_=0;_<h.length;++_){var d=h[_];if(p[d]!=c[d])continue t}return o(n).call(u,c)}}return e}}var r=t("./util"),i=t("./es5").keys,o=r.tryCatch,s=r.errorObj;return n}},{"./es5":13,"./util":36}],8:[function(t,e,n){"use strict";e.exports=function(t){function e(){this._trace=new e.CapturedTrace(r())}function n(){return i?new e:void 0}function r(){var t=o.length-1;return t>=0?o[t]:void 0}var i=!1,o=[];return t.prototype._promiseCreated=function(){},t.prototype._pushContext=function(){},t.prototype._popContext=function(){return null},t._peekContext=t.prototype._peekContext=function(){},e.prototype._pushContext=function(){void 0!==this._trace&&(this._trace._promiseCreated=null,o.push(this._trace))},e.prototype._popContext=function(){if(void 0!==this._trace){var t=o.pop(),e=t._promiseCreated;return t._promiseCreated=null,e}return null},e.CapturedTrace=null,e.create=n,e.deactivateLongStackTraces=function(){},e.activateLongStackTraces=function(){var n=t.prototype._pushContext,o=t.prototype._popContext,s=t._peekContext,a=t.prototype._peekContext,c=t.prototype._promiseCreated;e.deactivateLongStackTraces=function(){t.prototype._pushContext=n,t.prototype._popContext=o,t._peekContext=s,t.prototype._peekContext=a,t.prototype._promiseCreated=c,i=!1},i=!0,t.prototype._pushContext=e.prototype._pushContext,t.prototype._popContext=e.prototype._popContext,t._peekContext=t.prototype._peekContext=r,t.prototype._promiseCreated=function(){var t=this._peekContext();t&&null==t._promiseCreated&&(t._promiseCreated=this)}},e}},{}],9:[function(t,e,n){"use strict";e.exports=function(e,n,r,i){function o(t,e){return{promise:e}}function s(){return!1}function a(t,e,n){var r=this;try{t(e,n,function(t){if("function"!=typeof t)throw new TypeError("onCancel must be a function, got: "+B.toString(t));r._attachCancellationCallback(t)})}catch(i){return i}}function c(t){if(!this._isCancellable())return this;var e=this._onCancel();void 0!==e?B.isArray(e)?e.push(t):this._setOnCancel([e,t]):this._setOnCancel(t)}function u(){return this._onCancelField}function l(t){this._onCancelField=t}function p(){this._cancellationParent=void 0,this._onCancelField=void 0}function f(t,e){if(0!==(1&e)){this._cancellationParent=t;var n=t._branchesRemainingToCancel;void 0===n&&(n=0),t._branchesRemainingToCancel=n+1}0!==(2&e)&&t._isBound()&&this._setBoundTo(t._boundTo)}function h(t,e){0!==(2&e)&&t._isBound()&&this._setBoundTo(t._boundTo)}function _(){var t=this._boundTo;return void 0!==t&&t instanceof e?t.isFulfilled()?t.value():void 0:t}function d(){this._trace=new V(this._peekContext())}function v(t,e){if(q(t)){var n=this._trace;if(void 0!==n&&e&&(n=n._parent),void 0!==n)n.attachExtraTrace(t);else if(!t.__stackCleaned__){var r=F(t);B.notEnumerableProp(t,"stack",r.message+"\n"+r.stack.join("\n")),B.notEnumerableProp(t,"__stackCleaned__",!0)}}}function y(){this._trace=void 0}function g(t,e,n,r,i){if(void 0===t&&null!==e&&Z){if(void 0!==i&&i._returnedNonUndefined())return;if(0===(65535&r._bitField))return;n&&(n+=" ");var o="",s="";if(e._trace){for(var a=e._trace.stack.split("\n"),c=k(a),u=c.length-1;u>=0;--u){var l=c[u];if(!Q.test(l)){var p=l.match(G);p&&(o="at "+p[1]+":"+p[2]+":"+p[3]+" ");break}}if(c.length>0)for(var f=c[0],u=0;u<a.length;++u)if(a[u]===f){u>0&&(s="\n"+a[u-1]);break}}var h="a promise was created in a "+n+"handler "+o+"but was not returned from it, see http://goo.gl/rRqMUw"+s;r._warn(h,!0,e)}}function m(t,e){var n=t+" is deprecated and will be removed in a future version.";return e&&(n+=" Use "+e+" instead."),b(n)}function b(t,n,r){if(lt.warnings){var i,o=new U(t);if(n)r._attachExtraTrace(o);else if(lt.longStackTraces&&(i=e._peekContext()))i.attachExtraTrace(o);else{var s=F(o);o.stack=s.message+"\n"+s.stack.join("\n")}ot("warning",o)||x(o,"",!0)}}function w(t,e){for(var n=0;n<e.length-1;++n)e[n].push("From previous event:"),e[n]=e[n].join("\n");return n<e.length&&(e[n]=e[n].join("\n")),t+"\n"+e.join("\n")}function C(t){for(var e=0;e<t.length;++e)(0===t[e].length||e+1<t.length&&t[e][0]===t[e+1][0])&&(t.splice(e,1),e--)}function j(t){for(var e=t[0],n=1;n<t.length;++n){for(var r=t[n],i=e.length-1,o=e[i],s=-1,a=r.length-1;a>=0;--a)if(r[a]===o){s=a;break}for(var a=s;a>=0;--a){var c=r[a];if(e[i]!==c)break;e.pop(),i--}e=r}}function k(t){for(var e=[],n=0;n<t.length;++n){var r=t[n],i="    (No stack trace)"===r||z.test(r),o=i&&at(r);i&&!o&&(W&&" "!==r.charAt(0)&&(r="    "+r),e.push(r))}return e}function E(t){for(var e=t.stack.replace(/\s+$/g,"").split("\n"),n=0;n<e.length;++n){var r=e[n];if("    (No stack trace)"===r||z.test(r))break}return n>0&&"SyntaxError"!=t.name&&(e=e.slice(n)),e}function F(t){var e=t.stack,n=t.toString();return e="string"==typeof e&&e.length>0?E(t):["    (No stack trace)"],{message:n,stack:"SyntaxError"==t.name?e:k(e)}}function x(t,e,n){if("undefined"!=typeof console){var r;if(B.isObject(t)){var i=t.stack;r=e+X(i,t)}else r=e+String(t);"function"==typeof I?I(r,n):("function"==typeof console.log||"object"==typeof console.log)&&console.log(r)}}function T(t,e,n,r){var i=!1;try{"function"==typeof e&&(i=!0,"rejectionHandled"===t?e(r):e(n,r))}catch(o){N.throwLater(o)}"unhandledRejection"===t?ot(t,n,r)||i||x(n,"Unhandled rejection "):ot(t,r)}function P(t){var e;if("function"==typeof t)e="[function "+(t.name||"anonymous")+"]";else{e=t&&"function"==typeof t.toString?t.toString():B.toString(t);var n=/\[object [a-zA-Z0-9$_]+\]/;if(n.test(e))try{var r=JSON.stringify(t);e=r}catch(i){}0===e.length&&(e="(empty array)")}return"(<"+R(e)+">, no stack trace)"}function R(t){var e=41;return t.length<e?t:t.substr(0,e-3)+"..."}function S(){return"function"==typeof ut}function O(t){var e=t.match(ct);return e?{fileName:e[1],line:parseInt(e[2],10)}:void 0}function A(t,e){if(S()){for(var n,r,i=(t.stack||"").split("\n"),o=(e.stack||"").split("\n"),s=-1,a=-1,c=0;c<i.length;++c){var u=O(i[c]);if(u){n=u.fileName,s=u.line;break}}for(var c=0;c<o.length;++c){var u=O(o[c]);if(u){r=u.fileName,a=u.line;break}}0>s||0>a||!n||!r||n!==r||s>=a||(at=function(t){if($.test(t))return!0;var e=O(t);return e&&e.fileName===n&&s<=e.line&&e.line<=a?!0:!1})}}function V(t){this._parent=t,this._promisesCreated=0;var e=this._length=1+(void 0===t?0:t._length);ut(this,V),e>32&&this.uncycle()}var H,D,I,L,N=e._async,U=t("./errors").Warning,B=t("./util"),M=t("./es5"),q=B.canAttachTrace,$=/[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/,Q=/\((?:timers\.js):\d+:\d+\)/,G=/[\/<\(](.+?):(\d+):(\d+)\)?\s*$/,z=null,X=null,W=!1,K=!(0==B.env("BLUEBIRD_DEBUG")||!B.env("BLUEBIRD_DEBUG")&&"development"!==B.env("NODE_ENV")),J=!(0==B.env("BLUEBIRD_WARNINGS")||!K&&!B.env("BLUEBIRD_WARNINGS")),Y=!(0==B.env("BLUEBIRD_LONG_STACK_TRACES")||!K&&!B.env("BLUEBIRD_LONG_STACK_TRACES")),Z=0!=B.env("BLUEBIRD_W_FORGOTTEN_RETURN")&&(J||!!B.env("BLUEBIRD_W_FORGOTTEN_RETURN"));!function(){function t(){for(var t=0;t<r.length;++t)r[t]._notifyUnhandledRejection();n()}function n(){r.length=0}var r=[];L=function(e){r.push(e),setTimeout(t,1)},M.defineProperty(e,"_unhandledRejectionCheck",{value:t}),M.defineProperty(e,"_unhandledRejectionClear",{value:n})}(),e.prototype.suppressUnhandledRejections=function(){var t=this._target();t._bitField=-1048577&t._bitField|524288},e.prototype._ensurePossibleRejectionHandled=function(){0===(524288&this._bitField)&&(this._setRejectionIsUnhandled(),L(this))},e.prototype._notifyUnhandledRejectionIsHandled=function(){T("rejectionHandled",H,void 0,this)},e.prototype._setReturnedNonUndefined=function(){this._bitField=268435456|this._bitField},e.prototype._returnedNonUndefined=function(){return 0!==(268435456&this._bitField)},e.prototype._notifyUnhandledRejection=function(){if(this._isRejectionUnhandled()){var t=this._settledValue();this._setUnhandledRejectionIsNotified(),T("unhandledRejection",D,t,this)}},e.prototype._setUnhandledRejectionIsNotified=function(){this._bitField=262144|this._bitField},e.prototype._unsetUnhandledRejectionIsNotified=function(){this._bitField=-262145&this._bitField},e.prototype._isUnhandledRejectionNotified=function(){return(262144&this._bitField)>0},e.prototype._setRejectionIsUnhandled=function(){this._bitField=1048576|this._bitField},e.prototype._unsetRejectionIsUnhandled=function(){this._bitField=-1048577&this._bitField,this._isUnhandledRejectionNotified()&&(this._unsetUnhandledRejectionIsNotified(),this._notifyUnhandledRejectionIsHandled())},e.prototype._isRejectionUnhandled=function(){return(1048576&this._bitField)>0},e.prototype._warn=function(t,e,n){return b(t,e,n||this)},e.onPossiblyUnhandledRejection=function(t){var n=e._getContext();D=B.contextBind(n,t)},e.onUnhandledRejectionHandled=function(t){var n=e._getContext();H=B.contextBind(n,t)};var tt=function(){};e.longStackTraces=function(){if(N.haveItemsQueued()&&!lt.longStackTraces)throw new Error("cannot enable long stack traces after promises have been created\n\n    See http://goo.gl/MqrFmX\n");if(!lt.longStackTraces&&S()){var t=e.prototype._captureStackTrace,r=e.prototype._attachExtraTrace,i=e.prototype._dereferenceTrace;lt.longStackTraces=!0,tt=function(){if(N.haveItemsQueued()&&!lt.longStackTraces)throw new Error("cannot enable long stack traces after promises have been created\n\n    See http://goo.gl/MqrFmX\n");e.prototype._captureStackTrace=t,e.prototype._attachExtraTrace=r,e.prototype._dereferenceTrace=i,n.deactivateLongStackTraces(),lt.longStackTraces=!1},e.prototype._captureStackTrace=d,e.prototype._attachExtraTrace=v,e.prototype._dereferenceTrace=y,n.activateLongStackTraces()}},e.hasLongStackTraces=function(){return lt.longStackTraces&&S()};var et={unhandledrejection:{before:function(){var t=B.global.onunhandledrejection;return B.global.onunhandledrejection=null,t},after:function(t){B.global.onunhandledrejection=t}},rejectionhandled:{before:function(){var t=B.global.onrejectionhandled;return B.global.onrejectionhandled=null,t},after:function(t){B.global.onrejectionhandled=t}}},nt=function(){var t=function(t,e){if(!t)return!B.global.dispatchEvent(e);var n;try{return n=t.before(),!B.global.dispatchEvent(e)}finally{t.after(n)}};try{if("function"==typeof CustomEvent){var e=new CustomEvent("CustomEvent");return B.global.dispatchEvent(e),function(e,n){e=e.toLowerCase();var r={detail:n,cancelable:!0},i=new CustomEvent(e,r);return M.defineProperty(i,"promise",{value:n.promise}),M.defineProperty(i,"reason",{value:n.reason}),t(et[e],i)}}if("function"==typeof Event){var e=new Event("CustomEvent");return B.global.dispatchEvent(e),function(e,n){e=e.toLowerCase();var r=new Event(e,{cancelable:!0});return r.detail=n,M.defineProperty(r,"promise",{value:n.promise}),M.defineProperty(r,"reason",{value:n.reason}),t(et[e],r)}}var e=document.createEvent("CustomEvent");return e.initCustomEvent("testingtheevent",!1,!0,{}),B.global.dispatchEvent(e),function(e,n){e=e.toLowerCase();var r=document.createEvent("CustomEvent");return r.initCustomEvent(e,!1,!0,n),t(et[e],r)}}catch(n){}return function(){return!1}}(),rt=function(){return B.isNode?function(){return process.emit.apply(process,arguments)}:B.global?function(t){var e="on"+t.toLowerCase(),n=B.global[e];return n?(n.apply(B.global,[].slice.call(arguments,1)),!0):!1}:function(){return!1}}(),it={promiseCreated:o,promiseFulfilled:o,promiseRejected:o,promiseResolved:o,promiseCancelled:o,promiseChained:function(t,e,n){return{promise:e,child:n}},warning:function(t,e){return{warning:e}},unhandledRejection:function(t,e,n){return{reason:e,promise:n}},rejectionHandled:o},ot=function(t){var e=!1;try{e=rt.apply(null,arguments)}catch(n){N.throwLater(n),e=!0}var r=!1;try{r=nt(t,it[t].apply(null,arguments))}catch(n){N.throwLater(n),r=!0}return r||e};e.config=function(t){if(t=Object(t),"longStackTraces"in t&&(t.longStackTraces?e.longStackTraces():!t.longStackTraces&&e.hasLongStackTraces()&&tt()),"warnings"in t){var n=t.warnings;lt.warnings=!!n,Z=lt.warnings,B.isObject(n)&&"wForgottenReturn"in n&&(Z=!!n.wForgottenReturn)}if("cancellation"in t&&t.cancellation&&!lt.cancellation){if(N.haveItemsQueued())throw new Error("cannot enable cancellation after promises are in use");e.prototype._clearCancellationData=p,e.prototype._propagateFrom=f,e.prototype._onCancel=u,e.prototype._setOnCancel=l,e.prototype._attachCancellationCallback=c,e.prototype._execute=a,st=f,lt.cancellation=!0}if("monitoring"in t&&(t.monitoring&&!lt.monitoring?(lt.monitoring=!0,e.prototype._fireEvent=ot):!t.monitoring&&lt.monitoring&&(lt.monitoring=!1,e.prototype._fireEvent=s)),"asyncHooks"in t&&B.nodeSupportsAsyncResource){var o=lt.asyncHooks,h=!!t.asyncHooks;o!==h&&(lt.asyncHooks=h,h?r():i())}return e},e.prototype._fireEvent=s,e.prototype._execute=function(t,e,n){try{t(e,n)}catch(r){return r}},e.prototype._onCancel=function(){},e.prototype._setOnCancel=function(t){},e.prototype._attachCancellationCallback=function(t){},e.prototype._captureStackTrace=function(){},e.prototype._attachExtraTrace=function(){},e.prototype._dereferenceTrace=function(){},e.prototype._clearCancellationData=function(){},e.prototype._propagateFrom=function(t,e){};var st=h,at=function(){return!1},ct=/[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;B.inherits(V,Error),n.CapturedTrace=V,V.prototype.uncycle=function(){var t=this._length;if(!(2>t)){for(var e=[],n={},r=0,i=this;void 0!==i;++r)e.push(i),i=i._parent;t=this._length=r;for(var r=t-1;r>=0;--r){var o=e[r].stack;void 0===n[o]&&(n[o]=r)}for(var r=0;t>r;++r){var s=e[r].stack,a=n[s];if(void 0!==a&&a!==r){a>0&&(e[a-1]._parent=void 0,e[a-1]._length=1),e[r]._parent=void 0,e[r]._length=1;var c=r>0?e[r-1]:this;t-1>a?(c._parent=e[a+1],c._parent.uncycle(),c._length=c._parent._length+1):(c._parent=void 0,c._length=1);for(var u=c._length+1,l=r-2;l>=0;--l)e[l]._length=u,u++;return}}}},V.prototype.attachExtraTrace=function(t){if(!t.__stackCleaned__){this.uncycle();for(var e=F(t),n=e.message,r=[e.stack],i=this;void 0!==i;)r.push(k(i.stack.split("\n"))),i=i._parent;j(r),C(r),B.notEnumerableProp(t,"stack",w(n,r)),B.notEnumerableProp(t,"__stackCleaned__",!0)}};var ut=function(){var t=/^\s*at\s*/,e=function(t,e){return"string"==typeof t?t:void 0!==e.name&&void 0!==e.message?e.toString():P(e)};if("number"==typeof Error.stackTraceLimit&&"function"==typeof Error.captureStackTrace){Error.stackTraceLimit+=6,z=t,X=e;var n=Error.captureStackTrace;return at=function(t){return $.test(t)},function(t,e){Error.stackTraceLimit+=6,n(t,e),Error.stackTraceLimit-=6}}var r=new Error;if("string"==typeof r.stack&&r.stack.split("\n")[0].indexOf("stackDetection@")>=0)return z=/@/,X=e,W=!0,function(t){t.stack=(new Error).stack};var i;try{throw new Error}catch(o){i="stack"in o}return"stack"in r||!i||"number"!=typeof Error.stackTraceLimit?(X=function(t,e){return"string"==typeof t?t:"object"!=typeof e&&"function"!=typeof e||void 0===e.name||void 0===e.message?P(e):e.toString()},null):(z=t,X=e,function(t){Error.stackTraceLimit+=6;try{throw new Error}catch(e){t.stack=e.stack}Error.stackTraceLimit-=6})}([]);"undefined"!=typeof console&&"undefined"!=typeof console.warn&&(I=function(t){console.warn(t)},B.isNode&&process.stderr.isTTY?I=function(t,e){var n=e?"[33m":"[31m";console.warn(n+t+"[0m\n")}:B.isNode||"string"!=typeof(new Error).stack||(I=function(t,e){console.warn("%c"+t,e?"color: darkorange":"color: red")}));var lt={warnings:J,longStackTraces:!1,cancellation:!1,monitoring:!1,asyncHooks:!1};return Y&&e.longStackTraces(),{asyncHooks:function(){return lt.asyncHooks},longStackTraces:function(){return lt.longStackTraces},warnings:function(){return lt.warnings},cancellation:function(){return lt.cancellation},monitoring:function(){return lt.monitoring},propagateFromFunction:function(){return st},boundValueFunction:function(){return _},checkForgottenReturns:g,setBounds:A,warn:b,deprecated:m,CapturedTrace:V,fireDomEvent:nt,fireGlobalEvent:rt}}},{"./errors":12,"./es5":13,"./util":36}],10:[function(t,e,n){"use strict";e.exports=function(t){function e(){return this.value}function n(){throw this.reason}t.prototype["return"]=t.prototype.thenReturn=function(n){return n instanceof t&&n.suppressUnhandledRejections(),this._then(e,void 0,void 0,{value:n},void 0)},t.prototype["throw"]=t.prototype.thenThrow=function(t){return this._then(n,void 0,void 0,{reason:t},void 0)},t.prototype.catchThrow=function(t){if(arguments.length<=1)return this._then(void 0,n,void 0,{reason:t},void 0);var e=arguments[1],r=function(){throw e};return this.caught(t,r)},t.prototype.catchReturn=function(n){if(arguments.length<=1)return n instanceof t&&n.suppressUnhandledRejections(),this._then(void 0,e,void 0,{value:n},void 0);var r=arguments[1];r instanceof t&&r.suppressUnhandledRejections();var i=function(){return r};return this.caught(n,i)}}},{}],11:[function(t,e,n){"use strict";e.exports=function(t,e){function n(){return o(this)}function r(t,n){return i(t,n,e,e)}var i=t.reduce,o=t.all;t.prototype.each=function(t){return i(this,t,e,0)._then(n,void 0,void 0,this,void 0)},t.prototype.mapSeries=function(t){return i(this,t,e,e)},t.each=function(t,r){return i(t,r,e,0)._then(n,void 0,void 0,t,void 0)},t.mapSeries=r}},{}],12:[function(t,e,n){"use strict";function r(t,e){function n(r){return this instanceof n?(p(this,"message","string"==typeof r?r:e),p(this,"name",t),void(Error.captureStackTrace?Error.captureStackTrace(this,this.constructor):Error.call(this))):new n(r)}return l(n,Error),n}function i(t){return this instanceof i?(p(this,"name","OperationalError"),p(this,"message",t),this.cause=t,this.isOperational=!0,void(t instanceof Error?(p(this,"message",t.message),p(this,"stack",t.stack)):Error.captureStackTrace&&Error.captureStackTrace(this,this.constructor))):new i(t)}var o,s,a=t("./es5"),c=a.freeze,u=t("./util"),l=u.inherits,p=u.notEnumerableProp,f=r("Warning","warning"),h=r("CancellationError","cancellation error"),_=r("TimeoutError","timeout error"),d=r("AggregateError","aggregate error");try{o=TypeError,s=RangeError}catch(v){o=r("TypeError","type error"),s=r("RangeError","range error")}for(var y="join pop push shift unshift slice filter forEach some every map indexOf lastIndexOf reduce reduceRight sort reverse".split(" "),g=0;g<y.length;++g)"function"==typeof Array.prototype[y[g]]&&(d.prototype[y[g]]=Array.prototype[y[g]]);a.defineProperty(d.prototype,"length",{value:0,configurable:!1,writable:!0,enumerable:!0}),d.prototype.isOperational=!0;var m=0;d.prototype.toString=function(){var t=Array(4*m+1).join(" "),e="\n"+t+"AggregateError of:\n";m++,t=Array(4*m+1).join(" ");for(var n=0;n<this.length;++n){for(var r=this[n]===this?"[Circular AggregateError]":this[n]+"",i=r.split("\n"),o=0;o<i.length;++o)i[o]=t+i[o];r=i.join("\n"),e+=r+"\n"}return m--,e},l(i,Error);var b=Error.__BluebirdErrorTypes__;b||(b=c({CancellationError:h,TimeoutError:_,OperationalError:i,RejectionError:i,AggregateError:d}),a.defineProperty(Error,"__BluebirdErrorTypes__",{value:b,writable:!1,enumerable:!1,configurable:!1})),e.exports={Error:Error,TypeError:o,RangeError:s,CancellationError:b.CancellationError,OperationalError:b.OperationalError,TimeoutError:b.TimeoutError,AggregateError:b.AggregateError,Warning:f}},{"./es5":13,"./util":36}],13:[function(t,e,n){var r=function(){"use strict";return void 0===this}();if(r)e.exports={freeze:Object.freeze,defineProperty:Object.defineProperty,getDescriptor:Object.getOwnPropertyDescriptor,keys:Object.keys,names:Object.getOwnPropertyNames,getPrototypeOf:Object.getPrototypeOf,isArray:Array.isArray,isES5:r,propertyIsWritable:function(t,e){var n=Object.getOwnPropertyDescriptor(t,e);return!(n&&!n.writable&&!n.set)}};else{var i={}.hasOwnProperty,o={}.toString,s={}.constructor.prototype,a=function(t){var e=[];for(var n in t)i.call(t,n)&&e.push(n);return e},c=function(t,e){return{value:t[e]}},u=function(t,e,n){return t[e]=n.value,t},l=function(t){return t},p=function(t){try{return Object(t).constructor.prototype}catch(e){return s}},f=function(t){try{return"[object Array]"===o.call(t)}catch(e){return!1}};e.exports={isArray:f,keys:a,names:a,defineProperty:u,getDescriptor:c,freeze:l,getPrototypeOf:p,isES5:r,propertyIsWritable:function(){return!0}}}},{}],14:[function(t,e,n){"use strict";e.exports=function(t,e){var n=t.map;t.prototype.filter=function(t,r){return n(this,t,r,e)},t.filter=function(t,r,i){return n(t,r,i,e)}}},{}],15:[function(t,e,n){"use strict";e.exports=function(e,n,r){function i(t,e,n){this.promise=t,this.type=e,this.handler=n,this.called=!1,this.cancelPromise=null}function o(t){this.finallyHandler=t}function s(t,e){return null!=t.cancelPromise?(arguments.length>1?t.cancelPromise._reject(e):t.cancelPromise._cancel(),t.cancelPromise=null,!0):!1}function a(){return u.call(this,this.promise._target()._settledValue())}function c(t){return s(this,t)?void 0:(f.e=t,f)}function u(t){var i=this.promise,u=this.handler;if(!this.called){this.called=!0;var l=this.isFinallyHandler()?u.call(i._boundValue()):u.call(i._boundValue(),t);if(l===r)return l;if(void 0!==l){i._setReturnedNonUndefined();var h=n(l,i);if(h instanceof e){if(null!=this.cancelPromise){if(h._isCancelled()){var _=new p("late cancellation observer");return i._attachExtraTrace(_),f.e=_,f}h.isPending()&&h._attachCancellationCallback(new o(this))}return h._then(a,c,void 0,this,void 0)}}}return i.isRejected()?(s(this),f.e=t,f):(s(this),t)}var l=t("./util"),p=e.CancellationError,f=l.errorObj,h=t("./catch_filter")(r);return i.prototype.isFinallyHandler=function(){return 0===this.type},o.prototype._resultCancelled=function(){s(this.finallyHandler)},e.prototype._passThrough=function(t,e,n,r){return"function"!=typeof t?this.then():this._then(n,r,void 0,new i(this,e,t),void 0)},e.prototype.lastly=e.prototype["finally"]=function(t){return this._passThrough(t,0,u,u)},e.prototype.tap=function(t){return this._passThrough(t,1,u)},e.prototype.tapCatch=function(t){var n=arguments.length;if(1===n)return this._passThrough(t,1,void 0,u);var r,i=new Array(n-1),o=0;for(r=0;n-1>r;++r){var s=arguments[r];if(!l.isObject(s))return e.reject(new TypeError("tapCatch statement predicate: expecting an object but got "+l.classString(s)));i[o++]=s}i.length=o;var a=arguments[r];return this._passThrough(h(i,a,this),1,void 0,u)},i}},{"./catch_filter":7,"./util":36}],16:[function(t,e,n){"use strict";e.exports=function(e,n,r,i,o,s){function a(t,n,r){for(var o=0;o<n.length;++o){r._pushContext();var s=h(n[o])(t);if(r._popContext(),s===f){r._pushContext();var a=e.reject(f.e);return r._popContext(),a}var c=i(s,r);if(c instanceof e)return c}return null}function c(t,n,i,o){if(s.cancellation()){var a=new e(r),c=this._finallyPromise=new e(r);this._promise=a.lastly(function(){return c}),a._captureStackTrace(),a._setOnCancel(this)}else{var u=this._promise=new e(r);u._captureStackTrace()}this._stack=o,this._generatorFunction=t,this._receiver=n,this._generator=void 0,this._yieldHandlers="function"==typeof i?[i].concat(_):_,this._yieldedPromise=null,this._cancellationPhase=!1}var u=t("./errors"),l=u.TypeError,p=t("./util"),f=p.errorObj,h=p.tryCatch,_=[];p.inherits(c,o),c.prototype._isResolved=function(){return null===this._promise},c.prototype._cleanup=function(){this._promise=this._generator=null,s.cancellation()&&null!==this._finallyPromise&&(this._finallyPromise._fulfill(),this._finallyPromise=null)},c.prototype._promiseCancelled=function(){if(!this._isResolved()){var t,n="undefined"!=typeof this._generator["return"];if(n)this._promise._pushContext(),t=h(this._generator["return"]).call(this._generator,void 0),this._promise._popContext();else{var r=new e.CancellationError("generator .return() sentinel");e.coroutine.returnSentinel=r,this._promise._attachExtraTrace(r),this._promise._pushContext(),t=h(this._generator["throw"]).call(this._generator,r),this._promise._popContext()}this._cancellationPhase=!0,this._yieldedPromise=null,this._continue(t)}},c.prototype._promiseFulfilled=function(t){this._yieldedPromise=null,this._promise._pushContext();var e=h(this._generator.next).call(this._generator,t);this._promise._popContext(),this._continue(e)},c.prototype._promiseRejected=function(t){this._yieldedPromise=null,this._promise._attachExtraTrace(t),this._promise._pushContext();var e=h(this._generator["throw"]).call(this._generator,t);this._promise._popContext(),this._continue(e)},c.prototype._resultCancelled=function(){if(this._yieldedPromise instanceof e){var t=this._yieldedPromise;this._yieldedPromise=null,t.cancel()}},c.prototype.promise=function(){return this._promise},c.prototype._run=function(){this._generator=this._generatorFunction.call(this._receiver),this._receiver=this._generatorFunction=void 0,this._promiseFulfilled(void 0)},c.prototype._continue=function(t){var n=this._promise;if(t===f)return this._cleanup(),this._cancellationPhase?n.cancel():n._rejectCallback(t.e,!1);var r=t.value;if(t.done===!0)return this._cleanup(),this._cancellationPhase?n.cancel():n._resolveCallback(r);
var o=i(r,this._promise);if(!(o instanceof e)&&(o=a(o,this._yieldHandlers,this._promise),null===o))return void this._promiseRejected(new l("A value %s was yielded that could not be treated as a promise\n\n    See http://goo.gl/MqrFmX\n\n".replace("%s",String(r))+"From coroutine:\n"+this._stack.split("\n").slice(1,-7).join("\n")));o=o._target();var s=o._bitField;0===(50397184&s)?(this._yieldedPromise=o,o._proxy(this,null)):0!==(33554432&s)?e._async.invoke(this._promiseFulfilled,this,o._value()):0!==(16777216&s)?e._async.invoke(this._promiseRejected,this,o._reason()):this._promiseCancelled()},e.coroutine=function(t,e){if("function"!=typeof t)throw new l("generatorFunction must be a function\n\n    See http://goo.gl/MqrFmX\n");var n=Object(e).yieldHandler,r=c,i=(new Error).stack;return function(){var e=t.apply(this,arguments),o=new r(void 0,void 0,n,i),s=o.promise();return o._generator=e,o._promiseFulfilled(void 0),s}},e.coroutine.addYieldHandler=function(t){if("function"!=typeof t)throw new l("expecting a function but got "+p.classString(t));_.push(t)},e.spawn=function(t){if(s.deprecated("Promise.spawn()","Promise.coroutine()"),"function"!=typeof t)return n("generatorFunction must be a function\n\n    See http://goo.gl/MqrFmX\n");var r=new c(t,this),i=r.promise();return r._run(e.spawn),i}}},{"./errors":12,"./util":36}],17:[function(t,e,n){"use strict";e.exports=function(e,n,r,i,o){var s=t("./util");s.canEvaluate,s.tryCatch,s.errorObj;e.join=function(){var t,e=arguments.length-1;if(e>0&&"function"==typeof arguments[e]){t=arguments[e];var r}var i=[].slice.call(arguments);t&&i.pop();var r=new n(i).promise();return void 0!==t?r.spread(t):r}}},{"./util":36}],18:[function(t,e,n){"use strict";e.exports=function(e,n,r,i,o,s){function a(t,n,r,i){this.constructor$(t),this._promise._captureStackTrace();var s=e._getContext();if(this._callback=u.contextBind(s,n),this._preservedValues=i===o?new Array(this.length()):null,this._limit=r,this._inFlight=0,this._queue=[],f.invoke(this._asyncInit,this,void 0),u.isArray(t))for(var a=0;a<t.length;++a){var c=t[a];c instanceof e&&c.suppressUnhandledRejections()}}function c(t,n,i,o){if("function"!=typeof n)return r("expecting a function but got "+u.classString(n));var s=0;if(void 0!==i){if("object"!=typeof i||null===i)return e.reject(new TypeError("options argument must be an object but it is "+u.classString(i)));if("number"!=typeof i.concurrency)return e.reject(new TypeError("'concurrency' must be a number but it is "+u.classString(i.concurrency)));s=i.concurrency}return s="number"==typeof s&&isFinite(s)&&s>=1?s:0,new a(t,n,s,o).promise()}var u=t("./util"),l=u.tryCatch,p=u.errorObj,f=e._async;u.inherits(a,n),a.prototype._asyncInit=function(){this._init$(void 0,-2)},a.prototype._init=function(){},a.prototype._promiseFulfilled=function(t,n){var r=this._values,o=this.length(),a=this._preservedValues,c=this._limit;if(0>n){if(n=-1*n-1,r[n]=t,c>=1&&(this._inFlight--,this._drainQueue(),this._isResolved()))return!0}else{if(c>=1&&this._inFlight>=c)return r[n]=t,this._queue.push(n),!1;null!==a&&(a[n]=t);var u=this._promise,f=this._callback,h=u._boundValue();u._pushContext();var _=l(f).call(h,t,n,o),d=u._popContext();if(s.checkForgottenReturns(_,d,null!==a?"Promise.filter":"Promise.map",u),_===p)return this._reject(_.e),!0;var v=i(_,this._promise);if(v instanceof e){v=v._target();var y=v._bitField;if(0===(50397184&y))return c>=1&&this._inFlight++,r[n]=v,v._proxy(this,-1*(n+1)),!1;if(0===(33554432&y))return 0!==(16777216&y)?(this._reject(v._reason()),!0):(this._cancel(),!0);_=v._value()}r[n]=_}var g=++this._totalResolved;return g>=o?(null!==a?this._filter(r,a):this._resolve(r),!0):!1},a.prototype._drainQueue=function(){for(var t=this._queue,e=this._limit,n=this._values;t.length>0&&this._inFlight<e;){if(this._isResolved())return;var r=t.pop();this._promiseFulfilled(n[r],r)}},a.prototype._filter=function(t,e){for(var n=e.length,r=new Array(n),i=0,o=0;n>o;++o)t[o]&&(r[i++]=e[o]);r.length=i,this._resolve(r)},a.prototype.preservedValues=function(){return this._preservedValues},e.prototype.map=function(t,e){return c(this,t,e,null)},e.map=function(t,e,n,r){return c(t,e,n,r)}}},{"./util":36}],19:[function(t,e,n){"use strict";e.exports=function(e,n,r,i,o){var s=t("./util"),a=s.tryCatch;e.method=function(t){if("function"!=typeof t)throw new e.TypeError("expecting a function but got "+s.classString(t));return function(){var r=new e(n);r._captureStackTrace(),r._pushContext();var i=a(t).apply(this,arguments),s=r._popContext();return o.checkForgottenReturns(i,s,"Promise.method",r),r._resolveFromSyncValue(i),r}},e.attempt=e["try"]=function(t){if("function"!=typeof t)return i("expecting a function but got "+s.classString(t));var r=new e(n);r._captureStackTrace(),r._pushContext();var c;if(arguments.length>1){o.deprecated("calling Promise.try with more than 1 argument");var u=arguments[1],l=arguments[2];c=s.isArray(u)?a(t).apply(l,u):a(t).call(l,u)}else c=a(t)();var p=r._popContext();return o.checkForgottenReturns(c,p,"Promise.try",r),r._resolveFromSyncValue(c),r},e.prototype._resolveFromSyncValue=function(t){t===s.errorObj?this._rejectCallback(t.e,!1):this._resolveCallback(t,!0)}}},{"./util":36}],20:[function(t,e,n){"use strict";function r(t){return t instanceof Error&&l.getPrototypeOf(t)===Error.prototype}function i(t){var e;if(r(t)){e=new u(t),e.name=t.name,e.message=t.message,e.stack=t.stack;for(var n=l.keys(t),i=0;i<n.length;++i){var o=n[i];p.test(o)||(e[o]=t[o])}return e}return s.markAsOriginatingFromRejection(t),t}function o(t,e){return function(n,r){if(null!==t){if(n){var o=i(a(n));t._attachExtraTrace(o),t._reject(o)}else if(e){var s=[].slice.call(arguments,1);t._fulfill(s)}else t._fulfill(r);t=null}}}var s=t("./util"),a=s.maybeWrapAsError,c=t("./errors"),u=c.OperationalError,l=t("./es5"),p=/^(?:name|message|stack|cause)$/;e.exports=o},{"./errors":12,"./es5":13,"./util":36}],21:[function(t,e,n){"use strict";e.exports=function(e){function n(t,e){var n=this;if(!o.isArray(t))return r.call(n,t,e);var i=a(e).apply(n._boundValue(),[null].concat(t));i===c&&s.throwLater(i.e)}function r(t,e){var n=this,r=n._boundValue(),i=void 0===t?a(e).call(r,null):a(e).call(r,null,t);i===c&&s.throwLater(i.e)}function i(t,e){var n=this;if(!t){var r=new Error(t+"");r.cause=t,t=r}var i=a(e).call(n._boundValue(),t);i===c&&s.throwLater(i.e)}var o=t("./util"),s=e._async,a=o.tryCatch,c=o.errorObj;e.prototype.asCallback=e.prototype.nodeify=function(t,e){if("function"==typeof t){var o=r;void 0!==e&&Object(e).spread&&(o=n),this._then(o,i,void 0,this,t)}return this}}},{"./util":36}],22:[function(t,e,n){"use strict";e.exports=function(){function n(){}function r(t,e){if(null==t||t.constructor!==i)throw new E("the promise constructor cannot be invoked directly\n\n    See http://goo.gl/MqrFmX\n");if("function"!=typeof e)throw new E("expecting a function but got "+f.classString(e))}function i(t){t!==x&&r(this,t),this._bitField=0,this._fulfillmentHandler0=void 0,this._rejectionHandler0=void 0,this._promise0=void 0,this._receiver0=void 0,this._resolveFromExecutor(t),this._promiseCreated(),this._fireEvent("promiseCreated",this)}function o(t){this.promise._resolveCallback(t)}function s(t){this.promise._rejectCallback(t,!1)}function a(t){var e=new i(x);e._fulfillmentHandler0=t,e._rejectionHandler0=t,e._promise0=t,e._receiver0=t}var c=function(){return new E("circular promise resolution chain\n\n    See http://goo.gl/MqrFmX\n")},u=function(){return new i.PromiseInspection(this._target())},l=function(t){return i.reject(new E(t))},p={},f=t("./util");f.setReflectHandler(u);var h=function(){var t=process.domain;return void 0===t?null:t},_=function(){return null},d=function(){return{domain:h(),async:null}},v=f.isNode&&f.nodeSupportsAsyncResource?t("async_hooks").AsyncResource:null,y=function(){return{domain:h(),async:new v("Bluebird::Promise")}},g=f.isNode?d:_;f.notEnumerableProp(i,"_getContext",g);var m=function(){g=y,f.notEnumerableProp(i,"_getContext",y)},b=function(){g=d,f.notEnumerableProp(i,"_getContext",d)},w=t("./es5"),C=t("./async"),j=new C;w.defineProperty(i,"_async",{value:j});var k=t("./errors"),E=i.TypeError=k.TypeError;i.RangeError=k.RangeError;var F=i.CancellationError=k.CancellationError;i.TimeoutError=k.TimeoutError,i.OperationalError=k.OperationalError,i.RejectionError=k.OperationalError,i.AggregateError=k.AggregateError;var x=function(){},T={},P={},R=t("./thenables")(i,x),S=t("./promise_array")(i,x,R,l,n),O=t("./context")(i),A=O.create,V=t("./debuggability")(i,O,m,b),H=(V.CapturedTrace,t("./finally")(i,R,P)),D=t("./catch_filter")(P),I=t("./nodeback"),L=f.errorObj,N=f.tryCatch;return i.prototype.toString=function(){return"[object Promise]"},i.prototype.caught=i.prototype["catch"]=function(t){var e=arguments.length;if(e>1){var n,r=new Array(e-1),i=0;for(n=0;e-1>n;++n){var o=arguments[n];if(!f.isObject(o))return l("Catch statement predicate: expecting an object but got "+f.classString(o));r[i++]=o}if(r.length=i,t=arguments[n],"function"!=typeof t)throw new E("The last argument to .catch() must be a function, got "+f.toString(t));return this.then(void 0,D(r,t,this))}return this.then(void 0,t)},i.prototype.reflect=function(){return this._then(u,u,void 0,this,void 0)},i.prototype.then=function(t,e){if(V.warnings()&&arguments.length>0&&"function"!=typeof t&&"function"!=typeof e){var n=".then() only accepts functions but was passed: "+f.classString(t);arguments.length>1&&(n+=", "+f.classString(e)),this._warn(n)}return this._then(t,e,void 0,void 0,void 0)},i.prototype.done=function(t,e){var n=this._then(t,e,void 0,void 0,void 0);n._setIsFinal()},i.prototype.spread=function(t){return"function"!=typeof t?l("expecting a function but got "+f.classString(t)):this.all()._then(t,void 0,void 0,T,void 0)},i.prototype.toJSON=function(){var t={isFulfilled:!1,isRejected:!1,fulfillmentValue:void 0,rejectionReason:void 0};return this.isFulfilled()?(t.fulfillmentValue=this.value(),t.isFulfilled=!0):this.isRejected()&&(t.rejectionReason=this.reason(),t.isRejected=!0),t},i.prototype.all=function(){return arguments.length>0&&this._warn(".all() was passed arguments but it does not take any"),new S(this).promise()},i.prototype.error=function(t){return this.caught(f.originatesFromRejection,t)},i.getNewLibraryCopy=e.exports,i.is=function(t){return t instanceof i},i.fromNode=i.fromCallback=function(t){var e=new i(x);e._captureStackTrace();var n=arguments.length>1?!!Object(arguments[1]).multiArgs:!1,r=N(t)(I(e,n));return r===L&&e._rejectCallback(r.e,!0),e._isFateSealed()||e._setAsyncGuaranteed(),e},i.all=function(t){return new S(t).promise()},i.cast=function(t){var e=R(t);return e instanceof i||(e=new i(x),e._captureStackTrace(),e._setFulfilled(),e._rejectionHandler0=t),e},i.resolve=i.fulfilled=i.cast,i.reject=i.rejected=function(t){var e=new i(x);return e._captureStackTrace(),e._rejectCallback(t,!0),e},i.setScheduler=function(t){if("function"!=typeof t)throw new E("expecting a function but got "+f.classString(t));return j.setScheduler(t)},i.prototype._then=function(t,e,n,r,o){var s=void 0!==o,a=s?o:new i(x),c=this._target(),u=c._bitField;s||(a._propagateFrom(this,3),a._captureStackTrace(),void 0===r&&0!==(2097152&this._bitField)&&(r=0!==(50397184&u)?this._boundValue():c===this?void 0:this._boundTo),this._fireEvent("promiseChained",this,a));var l=g();if(0!==(50397184&u)){var p,h,_=c._settlePromiseCtx;0!==(33554432&u)?(h=c._rejectionHandler0,p=t):0!==(16777216&u)?(h=c._fulfillmentHandler0,p=e,c._unsetRejectionIsUnhandled()):(_=c._settlePromiseLateCancellationObserver,h=new F("late cancellation observer"),c._attachExtraTrace(h),p=e),j.invoke(_,c,{handler:f.contextBind(l,p),promise:a,receiver:r,value:h})}else c._addCallbacks(t,e,a,r,l);return a},i.prototype._length=function(){return 65535&this._bitField},i.prototype._isFateSealed=function(){return 0!==(117506048&this._bitField)},i.prototype._isFollowing=function(){return 67108864===(67108864&this._bitField)},i.prototype._setLength=function(t){this._bitField=-65536&this._bitField|65535&t},i.prototype._setFulfilled=function(){this._bitField=33554432|this._bitField,this._fireEvent("promiseFulfilled",this)},i.prototype._setRejected=function(){this._bitField=16777216|this._bitField,this._fireEvent("promiseRejected",this)},i.prototype._setFollowing=function(){this._bitField=67108864|this._bitField,this._fireEvent("promiseResolved",this)},i.prototype._setIsFinal=function(){this._bitField=4194304|this._bitField},i.prototype._isFinal=function(){return(4194304&this._bitField)>0},i.prototype._unsetCancelled=function(){this._bitField=-65537&this._bitField},i.prototype._setCancelled=function(){this._bitField=65536|this._bitField,this._fireEvent("promiseCancelled",this)},i.prototype._setWillBeCancelled=function(){this._bitField=8388608|this._bitField},i.prototype._setAsyncGuaranteed=function(){if(!j.hasCustomScheduler()){var t=this._bitField;this._bitField=t|(536870912&t)>>2^134217728}},i.prototype._setNoAsyncGuarantee=function(){this._bitField=-134217729&(536870912|this._bitField)},i.prototype._receiverAt=function(t){var e=0===t?this._receiver0:this[4*t-4+3];return e===p?void 0:void 0===e&&this._isBound()?this._boundValue():e},i.prototype._promiseAt=function(t){return this[4*t-4+2]},i.prototype._fulfillmentHandlerAt=function(t){return this[4*t-4+0]},i.prototype._rejectionHandlerAt=function(t){return this[4*t-4+1]},i.prototype._boundValue=function(){},i.prototype._migrateCallback0=function(t){var e=(t._bitField,t._fulfillmentHandler0),n=t._rejectionHandler0,r=t._promise0,i=t._receiverAt(0);void 0===i&&(i=p),this._addCallbacks(e,n,r,i,null)},i.prototype._migrateCallbackAt=function(t,e){var n=t._fulfillmentHandlerAt(e),r=t._rejectionHandlerAt(e),i=t._promiseAt(e),o=t._receiverAt(e);void 0===o&&(o=p),this._addCallbacks(n,r,i,o,null)},i.prototype._addCallbacks=function(t,e,n,r,i){var o=this._length();if(o>=65531&&(o=0,this._setLength(0)),0===o)this._promise0=n,this._receiver0=r,"function"==typeof t&&(this._fulfillmentHandler0=f.contextBind(i,t)),"function"==typeof e&&(this._rejectionHandler0=f.contextBind(i,e));else{var s=4*o-4;this[s+2]=n,this[s+3]=r,"function"==typeof t&&(this[s+0]=f.contextBind(i,t)),"function"==typeof e&&(this[s+1]=f.contextBind(i,e))}return this._setLength(o+1),o},i.prototype._proxy=function(t,e){this._addCallbacks(void 0,void 0,e,t,null)},i.prototype._resolveCallback=function(t,e){if(0===(117506048&this._bitField)){if(t===this)return this._rejectCallback(c(),!1);var n=R(t,this);if(!(n instanceof i))return this._fulfill(t);e&&this._propagateFrom(n,2);var r=n._target();if(r===this)return void this._reject(c());var o=r._bitField;if(0===(50397184&o)){var s=this._length();s>0&&r._migrateCallback0(this);for(var a=1;s>a;++a)r._migrateCallbackAt(this,a);this._setFollowing(),this._setLength(0),this._setFollowee(n)}else if(0!==(33554432&o))this._fulfill(r._value());else if(0!==(16777216&o))this._reject(r._reason());else{var u=new F("late cancellation observer");r._attachExtraTrace(u),this._reject(u)}}},i.prototype._rejectCallback=function(t,e,n){var r=f.ensureErrorObject(t),i=r===t;if(!i&&!n&&V.warnings()){var o="a promise was rejected with a non-error: "+f.classString(t);this._warn(o,!0)}this._attachExtraTrace(r,e?i:!1),this._reject(t)},i.prototype._resolveFromExecutor=function(t){if(t!==x){var e=this;this._captureStackTrace(),this._pushContext();var n=!0,r=this._execute(t,function(t){e._resolveCallback(t)},function(t){e._rejectCallback(t,n)});n=!1,this._popContext(),void 0!==r&&e._rejectCallback(r,!0)}},i.prototype._settlePromiseFromHandler=function(t,e,n,r){var i=r._bitField;if(0===(65536&i)){r._pushContext();var o;e===T?n&&"number"==typeof n.length?o=N(t).apply(this._boundValue(),n):(o=L,o.e=new E("cannot .spread() a non-array: "+f.classString(n))):o=N(t).call(e,n);var s=r._popContext();i=r._bitField,0===(65536&i)&&(o===P?r._reject(n):o===L?r._rejectCallback(o.e,!1):(V.checkForgottenReturns(o,s,"",r,this),r._resolveCallback(o)))}},i.prototype._target=function(){for(var t=this;t._isFollowing();)t=t._followee();return t},i.prototype._followee=function(){return this._rejectionHandler0},i.prototype._setFollowee=function(t){this._rejectionHandler0=t},i.prototype._settlePromise=function(t,e,r,o){var s=t instanceof i,a=this._bitField,c=0!==(134217728&a);0!==(65536&a)?(s&&t._invokeInternalOnCancel(),r instanceof H&&r.isFinallyHandler()?(r.cancelPromise=t,N(e).call(r,o)===L&&t._reject(L.e)):e===u?t._fulfill(u.call(r)):r instanceof n?r._promiseCancelled(t):s||t instanceof S?t._cancel():r.cancel()):"function"==typeof e?s?(c&&t._setAsyncGuaranteed(),this._settlePromiseFromHandler(e,r,o,t)):e.call(r,o,t):r instanceof n?r._isResolved()||(0!==(33554432&a)?r._promiseFulfilled(o,t):r._promiseRejected(o,t)):s&&(c&&t._setAsyncGuaranteed(),0!==(33554432&a)?t._fulfill(o):t._reject(o))},i.prototype._settlePromiseLateCancellationObserver=function(t){var e=t.handler,n=t.promise,r=t.receiver,o=t.value;"function"==typeof e?n instanceof i?this._settlePromiseFromHandler(e,r,o,n):e.call(r,o,n):n instanceof i&&n._reject(o)},i.prototype._settlePromiseCtx=function(t){this._settlePromise(t.promise,t.handler,t.receiver,t.value)},i.prototype._settlePromise0=function(t,e,n){var r=this._promise0,i=this._receiverAt(0);this._promise0=void 0,this._receiver0=void 0,this._settlePromise(r,t,i,e)},i.prototype._clearCallbackDataAtIndex=function(t){var e=4*t-4;this[e+2]=this[e+3]=this[e+0]=this[e+1]=void 0},i.prototype._fulfill=function(t){var e=this._bitField;if(!((117506048&e)>>>16)){if(t===this){var n=c();return this._attachExtraTrace(n),this._reject(n)}this._setFulfilled(),this._rejectionHandler0=t,(65535&e)>0&&(0!==(134217728&e)?this._settlePromises():j.settlePromises(this),this._dereferenceTrace())}},i.prototype._reject=function(t){var e=this._bitField;if(!((117506048&e)>>>16))return this._setRejected(),this._fulfillmentHandler0=t,this._isFinal()?j.fatalError(t,f.isNode):void((65535&e)>0?j.settlePromises(this):this._ensurePossibleRejectionHandled())},i.prototype._fulfillPromises=function(t,e){for(var n=1;t>n;n++){var r=this._fulfillmentHandlerAt(n),i=this._promiseAt(n),o=this._receiverAt(n);this._clearCallbackDataAtIndex(n),this._settlePromise(i,r,o,e)}},i.prototype._rejectPromises=function(t,e){for(var n=1;t>n;n++){var r=this._rejectionHandlerAt(n),i=this._promiseAt(n),o=this._receiverAt(n);this._clearCallbackDataAtIndex(n),this._settlePromise(i,r,o,e)}},i.prototype._settlePromises=function(){var t=this._bitField,e=65535&t;if(e>0){if(0!==(16842752&t)){var n=this._fulfillmentHandler0;this._settlePromise0(this._rejectionHandler0,n,t),this._rejectPromises(e,n)}else{var r=this._rejectionHandler0;this._settlePromise0(this._fulfillmentHandler0,r,t),this._fulfillPromises(e,r)}this._setLength(0)}this._clearCancellationData()},i.prototype._settledValue=function(){var t=this._bitField;return 0!==(33554432&t)?this._rejectionHandler0:0!==(16777216&t)?this._fulfillmentHandler0:void 0},"undefined"!=typeof Symbol&&Symbol.toStringTag&&w.defineProperty(i.prototype,Symbol.toStringTag,{get:function(){return"Object"}}),i.defer=i.pending=function(){V.deprecated("Promise.defer","new Promise");var t=new i(x);return{promise:t,resolve:o,reject:s}},f.notEnumerableProp(i,"_makeSelfResolutionError",c),t("./method")(i,x,R,l,V),t("./bind")(i,x,R,V),t("./cancel")(i,S,l,V),t("./direct_resolve")(i),t("./synchronous_inspection")(i),t("./join")(i,S,R,x,j),i.Promise=i,i.version="3.7.2",t("./call_get.js")(i),t("./generators.js")(i,l,x,R,n,V),t("./map.js")(i,S,l,R,x,V),t("./nodeify.js")(i),t("./promisify.js")(i,x),t("./props.js")(i,S,R,l),t("./race.js")(i,x,R,l),t("./reduce.js")(i,S,l,R,x,V),t("./settle.js")(i,S,V),t("./some.js")(i,S,l),t("./timers.js")(i,x,V),t("./using.js")(i,l,R,A,x,V),t("./any.js")(i),t("./each.js")(i,x),t("./filter.js")(i,x),f.toFastProperties(i),f.toFastProperties(i.prototype),a({a:1}),a({b:2}),a({c:3}),a(1),a(function(){}),a(void 0),a(!1),a(new i(x)),V.setBounds(C.firstLineError,f.lastLineError),i}},{"./any.js":1,"./async":2,"./bind":3,"./call_get.js":5,"./cancel":6,"./catch_filter":7,"./context":8,"./debuggability":9,"./direct_resolve":10,"./each.js":11,"./errors":12,"./es5":13,"./filter.js":14,"./finally":15,"./generators.js":16,"./join":17,"./map.js":18,"./method":19,"./nodeback":20,"./nodeify.js":21,"./promise_array":23,"./promisify.js":24,"./props.js":25,"./race.js":27,"./reduce.js":28,"./settle.js":30,"./some.js":31,"./synchronous_inspection":32,"./thenables":33,"./timers.js":34,"./using.js":35,"./util":36,async_hooks:void 0}],23:[function(t,e,n){"use strict";e.exports=function(e,n,r,i,o){function s(t){switch(t){case-2:return[];case-3:return{};case-6:return new Map}}function a(t){var r=this._promise=new e(n);t instanceof e&&(r._propagateFrom(t,3),t.suppressUnhandledRejections()),r._setOnCancel(this),this._values=t,this._length=0,this._totalResolved=0,this._init(void 0,-2)}var c=t("./util");c.isArray;return c.inherits(a,o),a.prototype.length=function(){return this._length},a.prototype.promise=function(){return this._promise},a.prototype._init=function u(t,n){var o=r(this._values,this._promise);if(o instanceof e){o=o._target();var a=o._bitField;if(this._values=o,0===(50397184&a))return this._promise._setAsyncGuaranteed(),o._then(u,this._reject,void 0,this,n);if(0===(33554432&a))return 0!==(16777216&a)?this._reject(o._reason()):this._cancel();o=o._value()}if(o=c.asArray(o),null===o){var l=i("expecting an array or an iterable object but got "+c.classString(o)).reason();return void this._promise._rejectCallback(l,!1)}return 0===o.length?void(-5===n?this._resolveEmptyArray():this._resolve(s(n))):void this._iterate(o)},a.prototype._iterate=function(t){var n=this.getActualLength(t.length);this._length=n,this._values=this.shouldCopyValues()?new Array(n):this._values;for(var i=this._promise,o=!1,s=null,a=0;n>a;++a){var c=r(t[a],i);c instanceof e?(c=c._target(),s=c._bitField):s=null,o?null!==s&&c.suppressUnhandledRejections():null!==s?0===(50397184&s)?(c._proxy(this,a),this._values[a]=c):o=0!==(33554432&s)?this._promiseFulfilled(c._value(),a):0!==(16777216&s)?this._promiseRejected(c._reason(),a):this._promiseCancelled(a):o=this._promiseFulfilled(c,a)}o||i._setAsyncGuaranteed()},a.prototype._isResolved=function(){return null===this._values},a.prototype._resolve=function(t){this._values=null,this._promise._fulfill(t)},a.prototype._cancel=function(){!this._isResolved()&&this._promise._isCancellable()&&(this._values=null,this._promise._cancel())},a.prototype._reject=function(t){this._values=null,this._promise._rejectCallback(t,!1)},a.prototype._promiseFulfilled=function(t,e){this._values[e]=t;var n=++this._totalResolved;return n>=this._length?(this._resolve(this._values),!0):!1},a.prototype._promiseCancelled=function(){return this._cancel(),!0},a.prototype._promiseRejected=function(t){return this._totalResolved++,this._reject(t),!0},a.prototype._resultCancelled=function(){if(!this._isResolved()){var t=this._values;if(this._cancel(),t instanceof e)t.cancel();else for(var n=0;n<t.length;++n)t[n]instanceof e&&t[n].cancel()}},a.prototype.shouldCopyValues=function(){return!0},a.prototype.getActualLength=function(t){return t},a}},{"./util":36}],24:[function(t,e,n){"use strict";e.exports=function(e,n){function r(t){return!C.test(t)}function i(t){try{return t.__isPromisified__===!0}catch(e){return!1}}function o(t,e,n){var r=h.getDataPropertyOrDefault(t,e+n,b);return r?i(r):!1}function s(t,e,n){for(var r=0;r<t.length;r+=2){var i=t[r];if(n.test(i))for(var o=i.replace(n,""),s=0;s<t.length;s+=2)if(t[s]===o)throw new g("Cannot promisify an API that has normal methods with '%s'-suffix\n\n    See http://goo.gl/MqrFmX\n".replace("%s",e))}}function a(t,e,n,r){for(var a=h.inheritedDataKeys(t),c=[],u=0;u<a.length;++u){var l=a[u],p=t[l],f=r===j?!0:j(l,p,t);"function"!=typeof p||i(p)||o(t,l,e)||!r(l,p,t,f)||c.push(l,p)}return s(c,e,n),c}function c(t,r,i,o,s,a){function c(){var i=r;r===f&&(i=this);var o=new e(n);o._captureStackTrace();var s="string"==typeof l&&this!==u?this[l]:t,c=_(o,a);try{s.apply(i,d(arguments,c))}catch(p){o._rejectCallback(v(p),!0,!0)}return o._isFateSealed()||o._setAsyncGuaranteed(),o}var u=function(){return this}(),l=t;return"string"==typeof l&&(t=o),h.notEnumerableProp(c,"__isPromisified__",!0),c}function u(t,e,n,r,i){for(var o=new RegExp(k(e)+"$"),s=a(t,e,o,n),c=0,u=s.length;u>c;c+=2){var l=s[c],p=s[c+1],_=l+e;if(r===E)t[_]=E(l,f,l,p,e,i);else{var d=r(p,function(){return E(l,f,l,p,e,i)});h.notEnumerableProp(d,"__isPromisified__",!0),t[_]=d}}return h.toFastProperties(t),t}function l(t,e,n){return E(t,e,void 0,t,null,n)}var p,f={},h=t("./util"),_=t("./nodeback"),d=h.withAppended,v=h.maybeWrapAsError,y=h.canEvaluate,g=t("./errors").TypeError,m="Async",b={__isPromisified__:!0},w=["arity","length","name","arguments","caller","callee","prototype","__isPromisified__"],C=new RegExp("^(?:"+w.join("|")+")$"),j=function(t){return h.isIdentifier(t)&&"_"!==t.charAt(0)&&"constructor"!==t},k=function(t){return t.replace(/([$])/,"\\$")},E=y?p:c;e.promisify=function(t,e){if("function"!=typeof t)throw new g("expecting a function but got "+h.classString(t));if(i(t))return t;e=Object(e);var n=void 0===e.context?f:e.context,o=!!e.multiArgs,s=l(t,n,o);return h.copyDescriptors(t,s,r),s},e.promisifyAll=function(t,e){if("function"!=typeof t&&"object"!=typeof t)throw new g("the target of promisifyAll must be an object or a function\n\n    See http://goo.gl/MqrFmX\n");e=Object(e);var n=!!e.multiArgs,r=e.suffix;"string"!=typeof r&&(r=m);var i=e.filter;"function"!=typeof i&&(i=j);var o=e.promisifier;if("function"!=typeof o&&(o=E),!h.isIdentifier(r))throw new RangeError("suffix must be a valid identifier\n\n    See http://goo.gl/MqrFmX\n");for(var s=h.inheritedDataKeys(t),a=0;a<s.length;++a){var c=t[s[a]];"constructor"!==s[a]&&h.isClass(c)&&(u(c.prototype,r,i,o,n),u(c,r,i,o,n))}return u(t,r,i,o,n)}}},{"./errors":12,"./nodeback":20,"./util":36}],25:[function(t,e,n){"use strict";e.exports=function(e,n,r,i){function o(t){var e,n=!1;if(void 0!==a&&t instanceof a)e=p(t),n=!0;else{var r=l.keys(t),i=r.length;e=new Array(2*i);for(var o=0;i>o;++o){var s=r[o];e[o]=t[s],e[o+i]=s}}this.constructor$(e),this._isMap=n,this._init$(void 0,n?-6:-3)}function s(t){var n,s=r(t);return u(s)?(n=s instanceof e?s._then(e.props,void 0,void 0,void 0,void 0):new o(s).promise(),s instanceof e&&n._propagateFrom(s,2),n):i("cannot await properties of a non-object\n\n    See http://goo.gl/MqrFmX\n")}var a,c=t("./util"),u=c.isObject,l=t("./es5");"function"==typeof Map&&(a=Map);var p=function(){function t(t,r){this[e]=t,this[e+n]=r,e++}var e=0,n=0;return function(r){n=r.size,e=0;var i=new Array(2*r.size);return r.forEach(t,i),i}}(),f=function(t){for(var e=new a,n=t.length/2|0,r=0;n>r;++r){var i=t[n+r],o=t[r];e.set(i,o)}return e};c.inherits(o,n),o.prototype._init=function(){},o.prototype._promiseFulfilled=function(t,e){this._values[e]=t;var n=++this._totalResolved;if(n>=this._length){var r;if(this._isMap)r=f(this._values);else{r={};for(var i=this.length(),o=0,s=this.length();s>o;++o)r[this._values[o+i]]=this._values[o]}return this._resolve(r),!0}return!1},o.prototype.shouldCopyValues=function(){return!1},o.prototype.getActualLength=function(t){return t>>1},e.prototype.props=function(){return s(this)},e.props=function(t){return s(t)}}},{"./es5":13,"./util":36}],26:[function(t,e,n){"use strict";function r(t,e,n,r,i){for(var o=0;i>o;++o)n[o+r]=t[o+e],t[o+e]=void 0}function i(t){this._capacity=t,this._length=0,this._front=0}i.prototype._willBeOverCapacity=function(t){return this._capacity<t},i.prototype._pushOne=function(t){var e=this.length();this._checkCapacity(e+1);var n=this._front+e&this._capacity-1;this[n]=t,this._length=e+1},i.prototype.push=function(t,e,n){var r=this.length()+3;if(this._willBeOverCapacity(r))return this._pushOne(t),this._pushOne(e),void this._pushOne(n);var i=this._front+r-3;this._checkCapacity(r);var o=this._capacity-1;this[i+0&o]=t,this[i+1&o]=e,this[i+2&o]=n,this._length=r},i.prototype.shift=function(){var t=this._front,e=this[t];return this[t]=void 0,this._front=t+1&this._capacity-1,this._length--,e},i.prototype.length=function(){return this._length},i.prototype._checkCapacity=function(t){this._capacity<t&&this._resizeTo(this._capacity<<1)},i.prototype._resizeTo=function(t){var e=this._capacity;this._capacity=t;var n=this._front,i=this._length,o=n+i&e-1;r(this,0,this,e,o)},e.exports=i},{}],27:[function(t,e,n){"use strict";e.exports=function(e,n,r,i){function o(t,o){var c=r(t);if(c instanceof e)return a(c);if(t=s.asArray(t),null===t)return i("expecting an array or an iterable object but got "+s.classString(t));var u=new e(n);void 0!==o&&u._propagateFrom(o,3);for(var l=u._fulfill,p=u._reject,f=0,h=t.length;h>f;++f){var _=t[f];(void 0!==_||f in t)&&e.cast(_)._then(l,p,void 0,u,null)}return u}var s=t("./util"),a=function(t){return t.then(function(e){return o(e,t)})};e.race=function(t){return o(t,void 0)},e.prototype.race=function(){return o(this,void 0)}}},{"./util":36}],28:[function(t,e,n){"use strict";e.exports=function(e,n,r,i,o,s){function a(t,n,r,i){this.constructor$(t);var s=e._getContext();this._fn=f.contextBind(s,n),void 0!==r&&(r=e.resolve(r),r._attachCancellationCallback(this)),this._initialValue=r,this._currentCancellable=null,i===o?this._eachValues=Array(this._length):0===i?this._eachValues=null:this._eachValues=void 0,this._promise._captureStackTrace(),this._init$(void 0,-5)}function c(t,e){this.isFulfilled()?e._resolve(t):e._reject(t)}function u(t,e,n,i){if("function"!=typeof e)return r("expecting a function but got "+f.classString(e));var o=new a(t,e,n,i);return o.promise()}function l(t){this.accum=t,this.array._gotAccum(t);var n=i(this.value,this.array._promise);return n instanceof e?(this.array._currentCancellable=n,n._then(p,void 0,void 0,this,void 0)):p.call(this,n)}function p(t){var n=this.array,r=n._promise,i=h(n._fn);r._pushContext();var o;o=void 0!==n._eachValues?i.call(r._boundValue(),t,this.index,this.length):i.call(r._boundValue(),this.accum,t,this.index,this.length),o instanceof e&&(n._currentCancellable=o);var a=r._popContext();return s.checkForgottenReturns(o,a,void 0!==n._eachValues?"Promise.each":"Promise.reduce",r),o}var f=t("./util"),h=f.tryCatch;f.inherits(a,n),a.prototype._gotAccum=function(t){void 0!==this._eachValues&&null!==this._eachValues&&t!==o&&this._eachValues.push(t)},a.prototype._eachComplete=function(t){return null!==this._eachValues&&this._eachValues.push(t),this._eachValues},a.prototype._init=function(){},a.prototype._resolveEmptyArray=function(){this._resolve(void 0!==this._eachValues?this._eachValues:this._initialValue)},a.prototype.shouldCopyValues=function(){return!1},a.prototype._resolve=function(t){this._promise._resolveCallback(t),this._values=null},a.prototype._resultCancelled=function(t){return t===this._initialValue?this._cancel():void(this._isResolved()||(this._resultCancelled$(),this._currentCancellable instanceof e&&this._currentCancellable.cancel(),this._initialValue instanceof e&&this._initialValue.cancel()))},a.prototype._iterate=function(t){this._values=t;var n,r,i=t.length;void 0!==this._initialValue?(n=this._initialValue,r=0):(n=e.resolve(t[0]),r=1),this._currentCancellable=n;for(var o=r;i>o;++o){var s=t[o];s instanceof e&&s.suppressUnhandledRejections()}if(!n.isRejected())for(;i>r;++r){var a={accum:null,value:t[r],index:r,length:i,array:this};n=n._then(l,void 0,void 0,a,void 0),0===(127&r)&&n._setNoAsyncGuarantee()}void 0!==this._eachValues&&(n=n._then(this._eachComplete,void 0,void 0,this,void 0)),n._then(c,c,void 0,n,this)},e.prototype.reduce=function(t,e){return u(this,t,e,null)},e.reduce=function(t,e,n,r){return u(t,e,n,r)}}},{"./util":36}],29:[function(t,e,n){"use strict";var r,i=t("./util"),o=function(){throw new Error("No async scheduler available\n\n    See http://goo.gl/MqrFmX\n")},s=i.getNativePromise();if(i.isNode&&"undefined"==typeof MutationObserver){var a=global.setImmediate,c=process.nextTick;r=i.isRecentNode?function(t){a.call(global,t)}:function(t){c.call(process,t)}}else if("function"==typeof s&&"function"==typeof s.resolve){
var u=s.resolve();r=function(t){u.then(t)}}else r="undefined"!=typeof MutationObserver&&("undefined"==typeof window||!window.navigator||!window.navigator.standalone&&!window.cordova)&&"classList"in document.documentElement?function(){var t=document.createElement("div"),e={attributes:!0},n=!1,r=document.createElement("div"),i=new MutationObserver(function(){t.classList.toggle("foo"),n=!1});i.observe(r,e);var o=function(){n||(n=!0,r.classList.toggle("foo"))};return function(n){var r=new MutationObserver(function(){r.disconnect(),n()});r.observe(t,e),o()}}():"undefined"!=typeof setImmediate?function(t){setImmediate(t)}:"undefined"!=typeof setTimeout?function(t){setTimeout(t,0)}:o;e.exports=r},{"./util":36}],30:[function(t,e,n){"use strict";e.exports=function(e,n,r){function i(t){this.constructor$(t)}var o=e.PromiseInspection,s=t("./util");s.inherits(i,n),i.prototype._promiseResolved=function(t,e){this._values[t]=e;var n=++this._totalResolved;return n>=this._length?(this._resolve(this._values),!0):!1},i.prototype._promiseFulfilled=function(t,e){var n=new o;return n._bitField=33554432,n._settledValueField=t,this._promiseResolved(e,n)},i.prototype._promiseRejected=function(t,e){var n=new o;return n._bitField=16777216,n._settledValueField=t,this._promiseResolved(e,n)},e.settle=function(t){return r.deprecated(".settle()",".reflect()"),new i(t).promise()},e.allSettled=function(t){return new i(t).promise()},e.prototype.settle=function(){return e.settle(this)}}},{"./util":36}],31:[function(t,e,n){"use strict";e.exports=function(e,n,r){function i(t){this.constructor$(t),this._howMany=0,this._unwrap=!1,this._initialized=!1}function o(t,e){if((0|e)!==e||0>e)return r("expecting a positive integer\n\n    See http://goo.gl/MqrFmX\n");var n=new i(t),o=n.promise();return n.setHowMany(e),n.init(),o}var s=t("./util"),a=t("./errors").RangeError,c=t("./errors").AggregateError,u=s.isArray,l={};s.inherits(i,n),i.prototype._init=function(){if(this._initialized){if(0===this._howMany)return void this._resolve([]);this._init$(void 0,-5);var t=u(this._values);!this._isResolved()&&t&&this._howMany>this._canPossiblyFulfill()&&this._reject(this._getRangeError(this.length()))}},i.prototype.init=function(){this._initialized=!0,this._init()},i.prototype.setUnwrap=function(){this._unwrap=!0},i.prototype.howMany=function(){return this._howMany},i.prototype.setHowMany=function(t){this._howMany=t},i.prototype._promiseFulfilled=function(t){return this._addFulfilled(t),this._fulfilled()===this.howMany()?(this._values.length=this.howMany(),1===this.howMany()&&this._unwrap?this._resolve(this._values[0]):this._resolve(this._values),!0):!1},i.prototype._promiseRejected=function(t){return this._addRejected(t),this._checkOutcome()},i.prototype._promiseCancelled=function(){return this._values instanceof e||null==this._values?this._cancel():(this._addRejected(l),this._checkOutcome())},i.prototype._checkOutcome=function(){if(this.howMany()>this._canPossiblyFulfill()){for(var t=new c,e=this.length();e<this._values.length;++e)this._values[e]!==l&&t.push(this._values[e]);return t.length>0?this._reject(t):this._cancel(),!0}return!1},i.prototype._fulfilled=function(){return this._totalResolved},i.prototype._rejected=function(){return this._values.length-this.length()},i.prototype._addRejected=function(t){this._values.push(t)},i.prototype._addFulfilled=function(t){this._values[this._totalResolved++]=t},i.prototype._canPossiblyFulfill=function(){return this.length()-this._rejected()},i.prototype._getRangeError=function(t){var e="Input array must contain at least "+this._howMany+" items but contains only "+t+" items";return new a(e)},i.prototype._resolveEmptyArray=function(){this._reject(this._getRangeError(0))},e.some=function(t,e){return o(t,e)},e.prototype.some=function(t){return o(this,t)},e._SomePromiseArray=i}},{"./errors":12,"./util":36}],32:[function(t,e,n){"use strict";e.exports=function(t){function e(t){void 0!==t?(t=t._target(),this._bitField=t._bitField,this._settledValueField=t._isFateSealed()?t._settledValue():void 0):(this._bitField=0,this._settledValueField=void 0)}e.prototype._settledValue=function(){return this._settledValueField};var n=e.prototype.value=function(){if(!this.isFulfilled())throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\n\n    See http://goo.gl/MqrFmX\n");return this._settledValue()},r=e.prototype.error=e.prototype.reason=function(){if(!this.isRejected())throw new TypeError("cannot get rejection reason of a non-rejected promise\n\n    See http://goo.gl/MqrFmX\n");return this._settledValue()},i=e.prototype.isFulfilled=function(){return 0!==(33554432&this._bitField)},o=e.prototype.isRejected=function(){return 0!==(16777216&this._bitField)},s=e.prototype.isPending=function(){return 0===(50397184&this._bitField)},a=e.prototype.isResolved=function(){return 0!==(50331648&this._bitField)};e.prototype.isCancelled=function(){return 0!==(8454144&this._bitField)},t.prototype.__isCancelled=function(){return 65536===(65536&this._bitField)},t.prototype._isCancelled=function(){return this._target().__isCancelled()},t.prototype.isCancelled=function(){return 0!==(8454144&this._target()._bitField)},t.prototype.isPending=function(){return s.call(this._target())},t.prototype.isRejected=function(){return o.call(this._target())},t.prototype.isFulfilled=function(){return i.call(this._target())},t.prototype.isResolved=function(){return a.call(this._target())},t.prototype.value=function(){return n.call(this._target())},t.prototype.reason=function(){var t=this._target();return t._unsetRejectionIsUnhandled(),r.call(t)},t.prototype._value=function(){return this._settledValue()},t.prototype._reason=function(){return this._unsetRejectionIsUnhandled(),this._settledValue()},t.PromiseInspection=e}},{}],33:[function(t,e,n){"use strict";e.exports=function(e,n){function r(t,r){if(l(t)){if(t instanceof e)return t;var i=o(t);if(i===u){r&&r._pushContext();var c=e.reject(i.e);return r&&r._popContext(),c}if("function"==typeof i){if(s(t)){var c=new e(n);return t._then(c._fulfill,c._reject,void 0,c,null),c}return a(t,i,r)}}return t}function i(t){return t.then}function o(t){try{return i(t)}catch(e){return u.e=e,u}}function s(t){try{return p.call(t,"_promise0")}catch(e){return!1}}function a(t,r,i){function o(t){a&&(a._resolveCallback(t),a=null)}function s(t){a&&(a._rejectCallback(t,p,!0),a=null)}var a=new e(n),l=a;i&&i._pushContext(),a._captureStackTrace(),i&&i._popContext();var p=!0,f=c.tryCatch(r).call(t,o,s);return p=!1,a&&f===u&&(a._rejectCallback(f.e,!0,!0),a=null),l}var c=t("./util"),u=c.errorObj,l=c.isObject,p={}.hasOwnProperty;return r}},{"./util":36}],34:[function(t,e,n){"use strict";e.exports=function(e,n,r){function i(t){this.handle=t}function o(t){return clearTimeout(this.handle),t}function s(t){throw clearTimeout(this.handle),t}var a=t("./util"),c=e.TimeoutError;i.prototype._resultCancelled=function(){clearTimeout(this.handle)};var u=function(t){return l(+this).thenReturn(t)},l=e.delay=function(t,o){var s,a;return void 0!==o?(s=e.resolve(o)._then(u,null,null,t,void 0),r.cancellation()&&o instanceof e&&s._setOnCancel(o)):(s=new e(n),a=setTimeout(function(){s._fulfill()},+t),r.cancellation()&&s._setOnCancel(new i(a)),s._captureStackTrace()),s._setAsyncGuaranteed(),s};e.prototype.delay=function(t){return l(t,this)};var p=function(t,e,n){var r;r="string"!=typeof e?e instanceof Error?e:new c("operation timed out"):new c(e),a.markAsOriginatingFromRejection(r),t._attachExtraTrace(r),t._reject(r),null!=n&&n.cancel()};e.prototype.timeout=function(t,e){t=+t;var n,a,c=new i(setTimeout(function(){n.isPending()&&p(n,e,a)},t));return r.cancellation()?(a=this.then(),n=a._then(o,s,void 0,c,void 0),n._setOnCancel(c)):n=this._then(o,s,void 0,c,void 0),n}}},{"./util":36}],35:[function(t,e,n){"use strict";e.exports=function(e,n,r,i,o,s){function a(t){setTimeout(function(){throw t},0)}function c(t){var e=r(t);return e!==t&&"function"==typeof t._isDisposable&&"function"==typeof t._getDisposer&&t._isDisposable()&&e._setDisposable(t._getDisposer()),e}function u(t,n){function i(){if(s>=u)return l._fulfill();var o=c(t[s++]);if(o instanceof e&&o._isDisposable()){try{o=r(o._getDisposer().tryDispose(n),t.promise)}catch(p){return a(p)}if(o instanceof e)return o._then(i,a,null,null,null)}i()}var s=0,u=t.length,l=new e(o);return i(),l}function l(t,e,n){this._data=t,this._promise=e,this._context=n}function p(t,e,n){this.constructor$(t,e,n)}function f(t){return l.isDisposer(t)?(this.resources[this.index]._setDisposable(t),t.promise()):t}function h(t){this.length=t,this.promise=null,this[t-1]=null}var _=t("./util"),d=t("./errors").TypeError,v=t("./util").inherits,y=_.errorObj,g=_.tryCatch,m={};l.prototype.data=function(){return this._data},l.prototype.promise=function(){return this._promise},l.prototype.resource=function(){return this.promise().isFulfilled()?this.promise().value():m},l.prototype.tryDispose=function(t){var e=this.resource(),n=this._context;void 0!==n&&n._pushContext();var r=e!==m?this.doDispose(e,t):null;return void 0!==n&&n._popContext(),this._promise._unsetDisposable(),this._data=null,r},l.isDisposer=function(t){return null!=t&&"function"==typeof t.resource&&"function"==typeof t.tryDispose},v(p,l),p.prototype.doDispose=function(t,e){var n=this.data();return n.call(t,t,e)},h.prototype._resultCancelled=function(){for(var t=this.length,n=0;t>n;++n){var r=this[n];r instanceof e&&r.cancel()}},e.using=function(){var t=arguments.length;if(2>t)return n("you must pass at least 2 arguments to Promise.using");var i=arguments[t-1];if("function"!=typeof i)return n("expecting a function but got "+_.classString(i));var o,a=!0;2===t&&Array.isArray(arguments[0])?(o=arguments[0],t=o.length,a=!1):(o=arguments,t--);for(var c=new h(t),p=0;t>p;++p){var d=o[p];if(l.isDisposer(d)){var v=d;d=d.promise(),d._setDisposable(v)}else{var m=r(d);m instanceof e&&(d=m._then(f,null,null,{resources:c,index:p},void 0))}c[p]=d}for(var b=new Array(c.length),p=0;p<b.length;++p)b[p]=e.resolve(c[p]).reflect();var w=e.all(b).then(function(t){for(var e=0;e<t.length;++e){var n=t[e];if(n.isRejected())return y.e=n.error(),y;if(!n.isFulfilled())return void w.cancel();t[e]=n.value()}C._pushContext(),i=g(i);var r=a?i.apply(void 0,t):i(t),o=C._popContext();return s.checkForgottenReturns(r,o,"Promise.using",C),r}),C=w.lastly(function(){var t=new e.PromiseInspection(w);return u(c,t)});return c.promise=C,C._setOnCancel(c),C},e.prototype._setDisposable=function(t){this._bitField=131072|this._bitField,this._disposer=t},e.prototype._isDisposable=function(){return(131072&this._bitField)>0},e.prototype._getDisposer=function(){return this._disposer},e.prototype._unsetDisposable=function(){this._bitField=-131073&this._bitField,this._disposer=void 0},e.prototype.disposer=function(t){if("function"==typeof t)return new p(t,this,i());throw new d}}},{"./errors":12,"./util":36}],36:[function(t,e,n){"use strict";function r(){try{var t=P;return P=null,t.apply(this,arguments)}catch(e){return T.e=e,T}}function i(t){return P=t,r}function o(t){return null==t||t===!0||t===!1||"string"==typeof t||"number"==typeof t}function s(t){return"function"==typeof t||"object"==typeof t&&null!==t}function a(t){return o(t)?new Error(v(t)):t}function c(t,e){var n,r=t.length,i=new Array(r+1);for(n=0;r>n;++n)i[n]=t[n];return i[n]=e,i}function u(t,e,n){if(!F.isES5)return{}.hasOwnProperty.call(t,e)?t[e]:void 0;var r=Object.getOwnPropertyDescriptor(t,e);return null!=r?null==r.get&&null==r.set?r.value:n:void 0}function l(t,e,n){if(o(t))return t;var r={value:n,configurable:!0,enumerable:!1,writable:!0};return F.defineProperty(t,e,r),t}function p(t){throw t}function f(t){try{if("function"==typeof t){var e=F.names(t.prototype),n=F.isES5&&e.length>1,r=e.length>0&&!(1===e.length&&"constructor"===e[0]),i=A.test(t+"")&&F.names(t).length>0;if(n||r||i)return!0}return!1}catch(o){return!1}}function h(t){function e(){}function n(){return typeof r.foo}e.prototype=t;var r=new e;return n(),n(),t}function _(t){return V.test(t)}function d(t,e,n){for(var r=new Array(t),i=0;t>i;++i)r[i]=e+i+n;return r}function v(t){try{return t+""}catch(e){return"[no string representation]"}}function y(t){return t instanceof Error||null!==t&&"object"==typeof t&&"string"==typeof t.message&&"string"==typeof t.name}function g(t){try{l(t,"isOperational",!0)}catch(e){}}function m(t){return null==t?!1:t instanceof Error.__BluebirdErrorTypes__.OperationalError||t.isOperational===!0}function b(t){return y(t)&&F.propertyIsWritable(t,"stack")}function w(t){return{}.toString.call(t)}function C(t,e,n){for(var r=F.names(t),i=0;i<r.length;++i){var o=r[i];if(n(o))try{F.defineProperty(e,o,F.getDescriptor(t,o))}catch(s){}}}function j(t){return N?process.env[t]:void 0}function k(){if("function"==typeof Promise)try{var t=new Promise(function(){});if("[object Promise]"===w(t))return Promise}catch(e){}}function E(t,e){if(null===t||"function"!=typeof e||e===U)return e;null!==t.domain&&(e=t.domain.bind(e));var n=t.async;if(null!==n){var r=e;e=function(){var t=new Array(2).concat([].slice.call(arguments));return t[0]=r,t[1]=this,n.runInAsyncScope.apply(n,t)}}return e}var F=t("./es5"),x="undefined"==typeof navigator,T={e:{}},P,R="undefined"!=typeof self?self:"undefined"!=typeof window?window:"undefined"!=typeof global?global:void 0!==this?this:null,S=function(t,e){function n(){this.constructor=t,this.constructor$=e;for(var n in e.prototype)r.call(e.prototype,n)&&"$"!==n.charAt(n.length-1)&&(this[n+"$"]=e.prototype[n])}var r={}.hasOwnProperty;return n.prototype=e.prototype,t.prototype=new n,t.prototype},O=function(){var t=[Array.prototype,Object.prototype,Function.prototype],e=function(e){for(var n=0;n<t.length;++n)if(t[n]===e)return!0;return!1};if(F.isES5){var n=Object.getOwnPropertyNames;return function(t){for(var r=[],i=Object.create(null);null!=t&&!e(t);){var o;try{o=n(t)}catch(s){return r}for(var a=0;a<o.length;++a){var c=o[a];if(!i[c]){i[c]=!0;var u=Object.getOwnPropertyDescriptor(t,c);null!=u&&null==u.get&&null==u.set&&r.push(c)}}t=F.getPrototypeOf(t)}return r}}var r={}.hasOwnProperty;return function(n){if(e(n))return[];var i=[];t:for(var o in n)if(r.call(n,o))i.push(o);else{for(var s=0;s<t.length;++s)if(r.call(t[s],o))continue t;i.push(o)}return i}}(),A=/this\s*\.\s*\S+\s*=/,V=/^[a-z$_][a-z$_0-9]*$/i,H=function(){return"stack"in new Error?function(t){return b(t)?t:new Error(v(t))}:function(t){if(b(t))return t;try{throw new Error(v(t))}catch(e){return e}}}(),D=function(t){return F.isArray(t)?t:null};if("undefined"!=typeof Symbol&&Symbol.iterator){var I="function"==typeof Array.from?function(t){return Array.from(t)}:function(t){for(var e,n=[],r=t[Symbol.iterator]();!(e=r.next()).done;)n.push(e.value);return n};D=function(t){return F.isArray(t)?t:null!=t&&"function"==typeof t[Symbol.iterator]?I(t):null}}var L="undefined"!=typeof process&&"[object process]"===w(process).toLowerCase(),N="undefined"!=typeof process&&"undefined"!=typeof process.env,U,B={setReflectHandler:function(t){U=t},isClass:f,isIdentifier:_,inheritedDataKeys:O,getDataPropertyOrDefault:u,thrower:p,isArray:F.isArray,asArray:D,notEnumerableProp:l,isPrimitive:o,isObject:s,isError:y,canEvaluate:x,errorObj:T,tryCatch:i,inherits:S,withAppended:c,maybeWrapAsError:a,toFastProperties:h,filledRange:d,toString:v,canAttachTrace:b,ensureErrorObject:H,originatesFromRejection:m,markAsOriginatingFromRejection:g,classString:w,copyDescriptors:C,isNode:L,hasEnvVariables:N,env:j,global:R,getNativePromise:k,contextBind:E};B.isRecentNode=B.isNode&&function(){var t;return process.versions&&process.versions.node?t=process.versions.node.split(".").map(Number):process.version&&(t=process.version.split(".").map(Number)),0===t[0]&&t[1]>10||t[0]>0}(),B.nodeSupportsAsyncResource=B.isNode&&function(){var e=!1;try{var n=t("async_hooks").AsyncResource;e="function"==typeof n.prototype.runInAsyncScope}catch(r){e=!1}return e}(),B.isNode&&B.toFastProperties(process);try{throw new Error}catch(M){B.lastLineError=M}e.exports=B},{"./es5":13,async_hooks:void 0}]},{},[4])(4)}),"undefined"!=typeof window&&null!==window?window.P=window.Promise:"undefined"!=typeof self&&null!==self&&(self.P=self.Promise);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(127), __webpack_require__(13), __webpack_require__(203).setImmediate))

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(204);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13), __webpack_require__(127)))

/***/ }),
/* 205 */
/***/ (function(module, exports) {



Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * loading组件
 * @author zhenn
 * @time 2016-11-16
 */

var template = ['<div>', '<div class="J_Loading">', '<div class="g-app-loading">', '<i class="icon"></i>', '<p class="tip">{{text}}</p>', '</div>', '</div>', '<style type="text/css">', '.J_Loading {', 'position: fixed;', 'background: rgba(0, 0, 0, 0.8);', 'width: 100%;', 'height: 100%;', 'left: 0;', 'top: 0;', 'overflow: hidden;', 'z-index: 99999;', '}', '.J_Loading .g-app-loading {', 'width: 2.5rem;', 'height: 2.5rem;', 'border-radius: 0.3125rem;', 'background: rgba(255,255,255, .9);', 'position: absolute;', 'left: 50%;', 'top: 50%;', 'margin: -1.25rem 0 0 -1.25rem;', '}', '.J_Loading .g-app-loading .icon {', 'display: block;', 'width: 0.9375rem;', 'height: 0.9375rem;', 'margin: 0.46875rem auto 0;', 'background: url(data:image/gif;base64,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) no-repeat center center;', 'background-size: 100% 100%;', '}', '.J_Loading .g-app-loading .tip {', 'text-align: center;', 'margin-top: 0.3125rem;', 'font-size: 0.375rem;', '}', '</style>', '</div>'];

exports.default = {
    show: function show() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$text = _ref.text,
            text = _ref$text === undefined ? '正在加载' : _ref$text;

        if (this.el) {
            return;
        }
        var el = this.el = $(template.join('').replace('{{text}}', text));
        $(document.body).append(el);
    },
    hide: function hide() {
        if (this.el) {
            this.el.remove();
            this.el = null;
        }
    }
};

/***/ }),
/* 206 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": null,
    "options": {
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [{
        "name": "UserBalanceInfo",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "inBill",
            "id": 1
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "outDiamond",
            "id": 2
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "bill",
            "id": 3
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "diamond",
            "id": 4
        }]
    }, {
        "name": "ProfileInfo",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "uid",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "username",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "upliveCode",
            "id": 3
        }, {
            "rule": "optional",
            "type": "string",
            "name": "avatar",
            "id": 4
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "gender",
            "id": 5
        }, {
            "rule": "optional",
            "type": "string",
            "name": "setting",
            "id": 6
        }, {
            "rule": "optional",
            "type": "string",
            "name": "password",
            "id": 7
        }, {
            "rule": "optional",
            "type": "string",
            "name": "userToken",
            "id": 8
        }, {
            "rule": "optional",
            "type": "string",
            "name": "signature",
            "id": 9
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "grade",
            "id": 10
        }, {
            "rule": "optional",
            "type": "string",
            "name": "location",
            "id": 11
        }, {
            "rule": "optional",
            "type": "string",
            "name": "mobilePhone",
            "id": 12
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "fanTotal",
            "id": 13
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "followTotal",
            "id": 14
        }, {
            "rule": "optional",
            "type": "UserBalanceInfo",
            "name": "balance",
            "id": 15
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "chatroomid",
            "id": 16
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "followType",
            "id": 17
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "exp",
            "id": 18
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "currentExp",
            "id": 19
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "nextExp",
            "id": 20
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "officialAuth",
            "id": 21
        }, {
            "rule": "optional",
            "type": "string",
            "name": "officialAuthContent",
            "id": 22
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "qualityAuth",
            "id": 23
        }, {
            "rule": "optional",
            "type": "string",
            "name": "countryCode",
            "id": 25
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "admin",
            "id": 26
        }]
    }, {
        "name": "Profile",
        "fields": [],
        "messages": [{
            "name": "Get",
            "fields": [],
            "options": {
                "objc_class_prefix": "ProfileGet",
                "java_package": "com.asiainno.uplive.proto"
            },
            "messages": [{
                "name": "Request",
                "fields": [{
                    "rule": "optional",
                    "type": "int64",
                    "name": "vuid",
                    "id": 1
                }]
            }, {
                "name": "Response",
                "fields": [{
                    "rule": "optional",
                    "type": "ProfileInfo",
                    "name": "profile",
                    "id": 1
                }]
            }]
        }]
    }]
}).build();

exports.default = _root;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _modal = __webpack_require__(132);

var _modal2 = _interopRequireDefault(_modal);

__webpack_require__(209);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _dialog = null;
// 销毁组件
var destroy = function destroy() {
    if (_dialog) {
        _dialog();
        _dialog = null;
    }
};
// 显示一个confirm
var confirm = function confirm(props) {
    //  保证只有一个实例
    destroy();
    var _props$title = props.title,
        title = _props$title === undefined ? '' : _props$title,
        _props$content = props.content,
        content = _props$content === undefined ? '' : _props$content,
        _props$showOk = props.showOk,
        showOk = _props$showOk === undefined ? true : _props$showOk,
        _props$showCancel = props.showCancel,
        showCancel = _props$showCancel === undefined ? true : _props$showCancel,
        _props$okText = props.okText,
        okText = _props$okText === undefined ? UG.lang.template('Confirm') : _props$okText,
        _props$cancelText = props.cancelText,
        cancelText = _props$cancelText === undefined ? UG.lang.template('Cancel') : _props$cancelText,
        _props$okClick = props.okClick,
        okClick = _props$okClick === undefined ? destroy : _props$okClick,
        _props$cancelClick = props.cancelClick,
        cancelClick = _props$cancelClick === undefined ? destroy : _props$cancelClick;


    var buttons = [];
    if (showCancel) {
        buttons.push(_react2.default.createElement(
            'div',
            {
                key: 'cancel',
                className: 'btn-cancel',
                onClick: cancelClick.bind(null, destroy) },
            cancelText
        ));
    }
    if (showOk) {
        buttons.push(_react2.default.createElement(
            'div',
            {
                key: 'ok',
                className: 'btn-ok',
                onClick: okClick.bind(null, destroy) },
            okText
        ));
    }
    //  一般会有两个按钮，只有一个按钮目前没有用到，用到的时候需要特殊处理下
    var contentComp = _react2.default.createElement(
        'div',
        { className: 'dialog' },
        _react2.default.createElement(
            'h3',
            { className: 'dialog-title text-center' },
            title
        ),
        _react2.default.createElement(
            'div',
            { className: 'dialog-content text-center' },
            content
        ),
        _react2.default.createElement(
            'div',
            { className: 'dialog-buttons' },
            buttons
        )
    );

    _dialog = _modal2.default.createNoHeader(contentComp, 'dialog-extra');

    return _dialog;
};
exports.default = { confirm: confirm };

/***/ }),
/* 208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 210 */
/***/ (function(module, exports) {

(function () {
    var platform = UG.platform;
    var domain = document.domain;
    // 国内域名和国外域名
    var inlandHost = 'h5.upliveapp.com';
    var foreignHost = 'm.upliveapps.com';
    // 是国内还是国外
    var isInland = domain === inlandHost;
    var isForeign = domain === foreignHost;
    var href = location.href;

    // m域名在微信/qq/微博无法登录问题。
    // 判断页面若在微信中打开，则先跳转到h5域名下，然后再登录，QQ、微博同理。
    // 相反，h5域名网址若在FB中打开，则先跳转到m域名，然后执行登录。
    if (['wechat', 'qq', 'weibo', 'renren'].indexOf(platform) !== -1 && isForeign) {
        location.replace(href.replace(foreignHost, inlandHost));
    } else if (['fb'].indexOf(platform) !== -1 && isInland) {
        location.replace(href.replace(inlandHost, foreignHost));
    }
})();

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
//  初始化google analysis
var IS_INLAND = document.domain === 'h5.upliveapp.com';
if (!IS_INLAND) {
    (function (i, s, o, g, r, a, m) {
        i['GoogleAnalyticsObject'] = r;
        i[r] = i[r] || function () {
            (i[r].q = i[r].q || []).push(arguments);
        }, i[r].l = 1 * new Date();
        a = s.createElement(o), m = s.getElementsByTagName(o)[0];
        a.async = 1;
        a.onload = function () {
            $.channel.emit('analyticsSeedLoaded');
        };
        a.src = g;
        m.parentNode.insertBefore(a, m);
    })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
    ga('create', 'UA-80499728-13', 'auto');
}

//  初始化mixpanel
(function (e, a) {
    if (!a.__SV) {
        var b = window;
        try {
            var c,
                l,
                i,
                j = b.location,
                g = j.hash;
            c = function c(a, b) {
                return (l = a.match(RegExp(b + "=([^&]*)"))) ? l[1] : null;
            };
            g && c(g, "state") && (i = JSON.parse(decodeURIComponent(c(g, "state"))), "mpeditor" === i.action && (b.sessionStorage.setItem("_mpcehash", g), history.replaceState(i.desiredHash || "", e.title, j.pathname + j.search)));
        } catch (m) {}
        var k, h;
        window.mixpanel = a;
        a._i = [];
        a.init = function (b, c, f) {
            function e(b, a) {
                var c = a.split(".");
                2 == c.length && (b = b[c[0]], a = c[1]);
                b[a] = function () {
                    b.push([a].concat(Array.prototype.slice.call(arguments, 0)));
                };
            }

            var d = a;
            "undefined" !== typeof f ? d = a[f] = [] : f = "mixpanel";
            d.people = d.people || [];
            d.toString = function (b) {
                var a = "mixpanel";
                "mixpanel" !== f && (a += "." + f);
                b || (a += " (stub)");
                return a;
            };
            d.people.toString = function () {
                return d.toString(1) + ".people (stub)";
            };
            k = "disable time_event track track_pageview track_links track_forms register register_once alias unregister identify name_tag set_config reset opt_in_tracking opt_out_tracking has_opted_in_tracking has_opted_out_tracking clear_opt_in_out_tracking people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user".split(" ");
            for (h = 0; h < k.length; h++) {
                e(d, k[h]);
            }a._i.push([b, c, f]);
        };
        a.__SV = 1.2;
        b = e.createElement("script");
        b.type = "text/javascript";
        b.async = !0;
        b.src = "undefined" !== typeof MIXPANEL_CUSTOM_LIB_URL ? MIXPANEL_CUSTOM_LIB_URL : "file:" === e.location.protocol && "//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js".match(/^\/\//) ? "https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js" : "//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js";
        b.onload = function () {
            $.channel.emit('mixpanelLoaded');
        };
        c = e.getElementsByTagName("script")[0];
        c.parentNode.insertBefore(b, c);
    }
})(document, window.mixpanel || []);

//  全局GA
var GA = {
    // 用于存放JS尚未加载的缓存事件列表
    // js加载完成后，依次发送到对应服务
    cacheList: [],
    add: function add(obj, data) {
        //  国内用户只会用到gio
        if (IS_INLAND && window.minpanelReady || !IS_INLAND && window.gaReady && window.minpanelReady) {
            this._add(obj, data);
        } else {
            this.cacheList.push({ name: obj, data: data });
        }
    },
    _add: function _add(obj, data) {
        if (!true || UG.isStage) {
            return;
        }
        var name = typeof obj === 'string' ? obj : obj.eventName;
        if (window.gaReady) {
            ga('send', {
                hitType: 'event',
                eventCategory: name,
                eventAction: 'click'
            });
        }
        try {
            mixpanel.track(name, data || {});
        } catch (err) {
            //  gio 没有配置对应的字段
            console.error('' + err);
        }
    },
    addPreviousCache: function addPreviousCache() {
        var _this = this;

        //  国内
        if (IS_INLAND && window.minpanelReady || !IS_INLAND && window.gaReady && window.minpanelReady) {
            this.cacheList.forEach(function (_ref, index) {
                var name = _ref.name,
                    data = _ref.data;

                _this._add(name, data);
            });
            this.cacheList = [];
        }
    }
};

// google
$.channel.on('analyticsSeedLoaded', function () {
    window.gaReady = true;
    console.log('analyticsSeedLoaded');
    GA.addPreviousCache();
});

$.channel.on('mixpanelLoaded', function () {
    window.minpanelReady = true;
    // TODO
    mixpanel.init("b5b2d95c83c6b7f5d7c260a855639506");
    console.log('mixpanelLoaded');
    GA.addPreviousCache();
});
window.GA = GA;
exports.default = GA;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WxpayRedirect = exports.NoPermission = exports.AlipayRedirect = exports.CreateGiftItem = exports.GiftShowView = exports.BlockChainView = exports.FriendApply = exports.FriendListView = exports.SingleChat = exports.IMS = exports.LeaderBoard = exports.Gift = exports.Wallet = exports.Profile = exports.Earnings = exports.PhotoEdit = exports.ProjectDetail = exports.Project = exports.Land = exports.Login = undefined;

var _createItem = __webpack_require__(213);

var _createItem2 = _interopRequireDefault(_createItem);

var _alipayRedirect = __webpack_require__(242);

var _alipayRedirect2 = _interopRequireDefault(_alipayRedirect);

var _wechatRedirect = __webpack_require__(243);

var _wechatRedirect2 = _interopRequireDefault(_wechatRedirect);

var _noperm = __webpack_require__(53);

var _noperm2 = _interopRequireDefault(_noperm);

var _async = __webpack_require__(245);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 登录

// 没有权限访问

// 支付宝跳转中间页面
var Login = exports.Login = (0, _async.asyncComponent)(function () {
  return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 259));
});
// 落地页

// 微信跳转中间页面
// 创建礼物面板
var Land = exports.Land = (0, _async.asyncComponent)(function () {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 260));
});
// 礼物面板列表
var Project = exports.Project = (0, _async.asyncComponent)(function () {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 261));
});
// 项目收入详情
var ProjectDetail = exports.ProjectDetail = (0, _async.asyncComponent)(function () {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 262));
});
// 修改头像
var PhotoEdit = exports.PhotoEdit = (0, _async.asyncComponent)(function () {
  return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 263));
});
// 个人收入
var Earnings = exports.Earnings = (0, _async.asyncComponent)(function () {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 264));
});
// 个人信息
var Profile = exports.Profile = (0, _async.asyncComponent)(function () {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 265));
});
var Wallet = exports.Wallet = (0, _async.asyncComponent)(function () {
  return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 266));
});

// 送礼物的页面
var Gift = exports.Gift = (0, _async.asyncComponent)(function () {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 267));
});
// 单个项目排行榜
var LeaderBoard = exports.LeaderBoard = (0, _async.asyncComponent)(function () {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 268));
});

// IM相关
var IMS = exports.IMS = (0, _async.asyncComponent)(function () {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 269));
});
var SingleChat = exports.SingleChat = (0, _async.asyncComponent)(function () {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 270));
});
var FriendListView = exports.FriendListView = (0, _async.asyncComponent)(function () {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 271));
});
var FriendApply = exports.FriendApply = (0, _async.asyncComponent)(function () {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 272));
});

// 礼物上链的操作
var BlockChainView = exports.BlockChainView = (0, _async.asyncComponent)(function () {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 273));
});
var GiftShowView = exports.GiftShowView = (0, _async.asyncComponent)(function () {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 274));
});

exports.CreateGiftItem = _createItem2.default;
exports.AlipayRedirect = _alipayRedirect2.default;
exports.NoPermission = _noperm2.default;
exports.WxpayRedirect = _wechatRedirect2.default;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _topbarNav = __webpack_require__(130);

var _topbarNav2 = _interopRequireDefault(_topbarNav);

var _stepNav = __webpack_require__(215);

var _stepNav2 = _interopRequireDefault(_stepNav);

var _step = __webpack_require__(218);

var _step2 = _interopRequireDefault(_step);

var _step3 = __webpack_require__(228);

var _step4 = _interopRequireDefault(_step3);

var _step5 = __webpack_require__(237);

var _step6 = _interopRequireDefault(_step5);

var _giftitemadd = __webpack_require__(239);

var _giftitemadd2 = _interopRequireDefault(_giftitemadd);

var _giftitemedit = __webpack_require__(240);

var _giftitemedit2 = _interopRequireDefault(_giftitemedit);

var _config = __webpack_require__(35);

__webpack_require__(241);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 主播端的着陆页
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author zhenn
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @createTime 2017-10-23
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

// 三个step对应的页面

// import ProjectListPb from '../../pb/giftitemlist.pb';


// { itemName, itemDesc, giftList }
var addProject = (0, _config.giftService)('/gift/item/add', _giftitemadd2.default.Gift.ItemAdd);
var editProject = (0, _config.giftService)('/gift/item/edit', _giftitemedit2.default.Gift.ItemEdit);
// const getProjectList = giftService('/gift/item/list', ProjectListPb.Gift.ItemList);

var CreateItem = function (_React$Component) {
    _inherits(CreateItem, _React$Component);

    function CreateItem(props) {
        _classCallCheck(this, CreateItem);

        var _this = _possibleConstructorReturn(this, (CreateItem.__proto__ || Object.getPrototypeOf(CreateItem)).call(this, props));

        _this.onCommitInfo = function (data, callback) {
            var itemId = data.itemId,
                itemName = data.itemName,
                itemDesc = data.itemDesc,
                giftList = data.giftList;

            var me = _this;
            if (!itemId) {
                addProject({ itemName: itemName, itemDesc: itemDesc, giftList: giftList, itemType: 2 }).then(function (data) {
                    callback && callback();
                    if (!data || !data.itemId) {
                        return UG.simple(UG.lang.template('Dashboard failed to create.'));
                    }
                    var itemId = longToString(data.itemId);
                    me.setState({ itemId: itemId, itemName: itemName, itemDesc: itemDesc, selected: giftList });
                    UG.simple(UG.lang.template('Dashboard created!'));
                    UG.router.push('/createitem/2/' + itemId);
                }).catch(function (err) {
                    callback && callback();
                    if (Number(err) === 98307) {
                        return UG.simple(UG.lang.template('This name has been used'));
                    }
                    UG.simple(UG.lang.template('Dashboard failed to create.'));
                    console.log(err);
                });
            } else {
                // itemId, itemName, itemDesc, giftIdList
                editProject({ itemId: itemId, itemName: itemName, itemDesc: itemDesc, giftList: giftList }).then(function (data) {
                    callback && callback();
                    //   修改成功以后不会有任何的返回值
                    me.setState({ itemId: itemId, itemName: itemName, itemDesc: itemDesc, selected: giftList });
                    UG.simple(UG.lang.template('Dashboard updated!'));
                    UG.router.push('/createitem/2/' + itemId);
                }).catch(function (err) {
                    callback && callback();
                    UG.simple(UG.lang.template('Dashboard failed to update;('));
                    console.log(err);
                });
            }
        };

        _this.onBack = function () {
            var step = _this.state.step;

            UG.router.push('/createitem/' + (step - 1) + '/' + _this.props.match.params.id);
        };

        _this.onNextToComplete = function () {
            UG.router.push('/createitem/3/' + _this.props.match.params.id);
        };

        _this.goToProjectList = function () {
            UG.router.push('/project');
        };

        _this.goToCreateProject = function () {
            UG.router.push('/createitem/1');
        };

        var match = props.match;

        _this.state = {
            step: Number(match.params.step),
            itemId: match.params.id,
            //  存储所有第一步保存的信息，在第二部的时候展示
            itemName: '',
            itemDesc: '',
            selected: [],
            //  显示在tabnav左边的工具
            leftTool: 'close',
            giftList: []
        };
        return _this;
    }

    _createClass(CreateItem, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props$match$params = this.props.match.params,
                id = _props$match$params.id,
                step = _props$match$params.step;
            //  第一步没有传id，就检查项目列表，确认是否显示关闭按钮，这个后面需要放到step1
            // if (Number(step) === 1) {
            //     if (!id) {
            //         this.checkProjectLength();
            //     }
            // }
        }

        //  第一步提交信息


        //  第二步，第三步后退


        //  第二部分copy链接，或者是下一步的按钮


        //  如果项目的列表长度为0 ，就显示创建的页面
        // checkProjectLength() {
        //     getProjectList({ pageNum: 1, pageSize: 20 })
        //         .then(data => {
        //             if (!data || data.length === 0) {
        //                 this.setState({ leftTool: 'null' });
        //             }
        //         })
        //         .catch(err => {
        //             console.log(err);
        //             this.setState({ leftTool: 'null' });
        //         });
        // }

    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                step = _state.step,
                itemId = _state.itemId,
                giftList = _state.giftList,
                leftTool = _state.leftTool;

            var stepComp = _react2.default.createElement(_step2.default, {
                id: itemId,
                onCommit: this.onCommitInfo,
                giftList: giftList });
            if (step === 2) {
                stepComp = _react2.default.createElement(_step4.default, {
                    id: itemId,
                    onEdit: this.onBack,
                    onNext: this.onNextToComplete,
                    onSeeAll: UG.router.push.bind(null, '/project') });
            } else if (step === 3) {
                stepComp = _react2.default.createElement(_step6.default, {
                    onCreateMore: this.goToCreateProject,
                    onCheckRevenue: this.goToProjectList });
            }

            return _react2.default.createElement(
                'div',
                { className: 'create-item' },
                _react2.default.createElement(_topbarNav2.default, {
                    bordered: true,
                    onClose: this.goToProjectList,
                    onBack: this.onBack,
                    leftTool: step === 1 ? leftTool : 'back',
                    title: UG.lang.template('Create Dashboard') }),
                _react2.default.createElement(_stepNav2.default, { step: step }),
                stepComp
            );
        }
    }]);

    return CreateItem;
}(_react2.default.Component);

exports.default = CreateItem;

/***/ }),
/* 214 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = StepNav;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(216);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 步骤导航
 * @param step 现在到第几步了
 * @returns {*}
 * @constructor
 */
function StepNav(_ref) {
    var _ref$step = _ref.step,
        step = _ref$step === undefined ? 1 : _ref$step;

    // 每个步骤有3中状态，没有到这一步骤时，使用默认的class。
    // 是当前步骤时添加ci-step-current
    // 切换到下一步添加ci-step-pass
    // 中间的分割线有经过和没有经过两种状态，class分别是默认和ci-step-divide-active

    // 第1步  #step1 class="ci-step-current"
    // 第2步  #step1 class="ci-step-pass"
    //       #step2 class="ci-step-current"
    // 第3步  #step1 class="ci-step-pass"
    //       #step2 class="ci-step-pass"
    //       #step3 class="ci-step-current"
    var step1Cls = 'ci-step-current',
        step2Cls = '',
        step3Cls = '';
    if (step === 2) {
        step1Cls = 'ci-step-pass';
        step2Cls = 'ci-step-current';
    } else if (step === 3) {
        step1Cls = 'ci-step-pass';
        step2Cls = 'ci-step-pass';
        step3Cls = 'ci-step-current';
    }
    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            'div',
            { className: 'ci-step' },
            _react2.default.createElement(
                'div',
                { id: 'step1', className: step1Cls },
                '1'
            ),
            _react2.default.createElement('div', { className: 'ci-step-divide ' + (step > 1 ? 'ci-step-divide-active' : '') }),
            _react2.default.createElement(
                'div',
                { id: 'step2', className: step2Cls },
                ' 2'
            ),
            _react2.default.createElement('div', { className: 'ci-step-divide ' + (step > 2 ? 'ci-step-divide-active' : '') }),
            _react2.default.createElement(
                'div',
                { id: 'step3', className: step3Cls },
                _react2.default.createElement('img', { src: __webpack_require__(217) })
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'ci-step-desc text-center' },
            _react2.default.createElement(
                'div',
                { style: { display: step === 1 ? 'block' : 'none' } },
                UG.lang.template('Step 1: Pick gifts for your new gift dashboard first.')
            ),
            _react2.default.createElement(
                'div',
                { style: { display: step === 2 ? 'block' : 'none' } },
                UG.lang.template('Step 2: Copy your new gift dashboard’s link.')
            ),
            _react2.default.createElement(
                'div',
                { style: { display: step === 3 ? 'block' : 'none' } },
                UG.lang.template('Step 3: Paste your new dashboard link under your creative content.')
            )
        )
    );
}

/***/ }),
/* 216 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 217 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAVCAYAAAC33pUlAAAAtklEQVRIib3WwQkCMRBG4T9gGdvJsuVYgtbj3QIsQ+96tAMLeB7WgRDcJJvZ7IPcBj4IDEwA1LGjpJuktyQJ6PVOzD2BAeiGGWS9gGEPCOADjHtB09bfeM5BW2JFaCusCkqxCbgAhx5QjE2/IYBrJbgKMmyMIKsEroYMG5i3PG0JbIIMWwM2QzFWA7qgFMuBDy/0D8uBLmgJK4FNUA5bApuhEpaCLqgGM/DuhQAFqLpBgiT3sfIFB++JPUO081AAAAAASUVORK5CYII="

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _iscroll = __webpack_require__(133);

var _iscroll2 = _interopRequireDefault(_iscroll);

var _giftItem = __webpack_require__(138);

var _giftItem2 = _interopRequireDefault(_giftItem);

var _giftitemdetail = __webpack_require__(100);

var _giftitemdetail2 = _interopRequireDefault(_giftitemdetail);

var _giftomallgiftlist = __webpack_require__(220);

var _giftomallgiftlist2 = _interopRequireDefault(_giftomallgiftlist);

var _config = __webpack_require__(35);

__webpack_require__(222);

var _giftoIcon = __webpack_require__(131);

var _gaConfig = __webpack_require__(50);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getProjectById = (0, _config.giftService)('/gift/item/detail', _giftitemdetail2.default.Gift.ItemDetail);
var getGiftList = (0, _config.giftMallService)('/gifto/mall/gift/list', _giftomallgiftlist2.default.Gifto.Mall.GiftList);

var Step1 = function (_React$Component) {
    _inherits(Step1, _React$Component);

    function Step1(props) {
        _classCallCheck(this, Step1);

        var _this = _possibleConstructorReturn(this, (Step1.__proto__ || Object.getPrototypeOf(Step1)).call(this, props));

        _this.onCommit = function () {
            var _this$state = _this.state,
                itemId = _this$state.itemId,
                itemName = _this$state.itemName,
                itemDesc = _this$state.itemDesc,
                giftList = _this$state.giftList;

            if (!itemName) {
                // 项目名称不能为空
                return UG.simple(UG.lang.template('Please name your dashboard.'));
            }
            if (itemName.length > 30) {
                return UG.simple(UG.lang.template('Limit of Name is 30 characters.'));
            }
            if (itemDesc && itemDesc.length > 120) {
                return UG.simple(UG.lang.template('Limit is Description is 120 characters.'));
            }
            if (!giftList || giftList.length < 1) {
                return UG.simple(UG.lang.template('建议至少选择3~5礼物'));
            }
            if (giftList.length > 50) {
                return UG.simple(UG.lang.template('50 gifts in one Gift Dashboard only.'));
            }
            UG.loading(UG.lang.template('Loading...'));
            GA.add(_gaConfig.createStepOneSave);
            _this.props.onCommit({
                itemId: itemId,
                itemName: itemName,
                itemDesc: itemDesc,
                //  需要将id包装成 {giftId:id}的对象
                giftList: giftList.map(function (item) {
                    return { giftId: item };
                })
            }, function () {
                UG.loaded();
            });
        };

        _this.onSelectItem = function (id, result) {
            var list = _this.state.giftList.concat();
            if (result) {
                if (list.indexOf(id) === -1) {
                    list.push(id);
                }
            } else {
                var index = list.indexOf(id);
                if (index > -1) {
                    list.splice(index, 1);
                }
            }
            _this.setState({ giftList: list });
        };

        _this.removeFocus = function () {
            //  如果不加这个，点击iscroll区域不会导致其他的文本框失去焦点，会导致每点击一次iscroll区域，手机端就会弹出键盘
            $('input,textarea').blur();
        };

        _this.state = {
            showClose: true, // 没有项目的时候就不显示关闭按钮
            giftItemList: [], //  所有的礼物列表
            giftList: [],
            itemName: '',
            itemDesc: '',
            itemId: props.id
        };
        return _this;
    }

    _createClass(Step1, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.state.itemId) {
                this.fetchProjectDetail(this.state.itemId);
            }
            this.fetchGiftList();
            GA.add(_gaConfig.enterCreateStepOne);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(props, state) {
            this._scroll && this._scroll.refresh();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this._scroll) {
                this._scroll.destroy();
                this._scroll = null;
            }
        }
    }, {
        key: 'fetchProjectDetail',
        value: function fetchProjectDetail(itemId) {
            var _this2 = this;

            UG.loading(UG.lang.template('Loading...'));
            getProjectById({ itemId: itemId, uid: UG.getUser().uid }).then(function (_ref) {
                var itemInfos = _ref.itemInfos;
                var itemName = itemInfos.itemName,
                    itemDesc = itemInfos.itemDesc,
                    giftList = itemInfos.giftList;
                //  选中的礼物ids

                _this2.setState({
                    itemId: itemId,
                    itemName: itemName,
                    itemDesc: itemDesc,
                    giftList: giftList.map(function (item) {
                        return item.giftId;
                    })
                });
            }).finally(function () {
                UG.loaded();
            });
        }
    }, {
        key: 'fetchGiftList',
        value: function fetchGiftList() {
            var _this3 = this;

            UG.loading(UG.lang.template('Loading...'));
            getGiftList({ scene: 5 }).then(function (_ref2) {
                var gifts = _ref2.gifts,
                    amountConfigs = _ref2.amountConfigs;

                _this3.setState({
                    // 只显示online的礼物
                    giftItemList: gifts.filter(function (item) {
                        return item.onLined && [12, 1].indexOf(item.type) !== -1;
                    })
                }, function () {
                    _this3._scroll = new _iscroll2.default('#ci-scroll-wrapper', {
                        mouseWheel: true,
                        click: UG.iScrollClick(),
                        tap: true
                    });
                });
            }).catch(function (err) {
                console.log(err);
            }).finally(function () {
                UG.loaded();
            });
        }
    }, {
        key: 'setInputValue',
        value: function setInputValue(which, event) {
            this.setState(_defineProperty({}, which, event.target.value));
        }

        /**
         * 选中一个礼物触发这个事件
         * @param id 礼物id
         * @param result 选中状态
         */

    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var _state = this.state,
                itemName = _state.itemName,
                itemDesc = _state.itemDesc,
                giftItemList = _state.giftItemList;

            return _react2.default.createElement(
                'div',
                { className: 'ci-step1' },
                _react2.default.createElement(
                    'div',
                    { className: 'ci-title-block' },
                    _react2.default.createElement(
                        'p',
                        null,
                        UG.lang.template('Gifts')
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { id: 'ci-scroll-wrapper', onClick: this.removeFocus },
                    _react2.default.createElement(
                        'div',
                        { className: 'ci-step1-gift-list' },
                        giftItemList && giftItemList.length ? giftItemList.map(function (item, index) {
                            var image = '';
                            if (item.resources.length) {
                                item.resources.forEach(function (item) {
                                    if (item.type === 3) {
                                        image = item.url;
                                    }
                                });
                            }
                            return _react2.default.createElement(
                                _giftItem2.default,
                                {
                                    key: index,
                                    id: item.giftId,
                                    image: image,
                                    name: item.name,
                                    selectable: true,
                                    selected: _this4.state.giftList.indexOf(item.giftId) !== -1,
                                    vipGrade: item.vipGrade,
                                    onSelect: _this4.onSelectItem },
                                _react2.default.createElement(_giftoIcon.GiftoIcon, { size: '0.4375rem' }),
                                _react2.default.createElement(
                                    'div',
                                    null,
                                    Number(item.price) || 0
                                )
                            );
                        }) : _react2.default.createElement(
                            'div',
                            { className: 'no-gift' },
                            UG.lang.template('没有找到匹配的礼物')
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'ci-title-block' },
                    _react2.default.createElement(
                        'p',
                        null,
                        UG.lang.template('Name this Dashboard')
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'ci-step1-input' },
                    _react2.default.createElement('input', {
                        type: 'text',
                        value: itemName,
                        onChange: this.setInputValue.bind(this, 'itemName'),
                        placeholder: UG.lang.template('Enter project name') })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'ci-title-block' },
                    _react2.default.createElement(
                        'p',
                        null,
                        UG.lang.template('Description')
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'ci-step1-input' },
                    _react2.default.createElement('textarea', {
                        value: itemDesc,
                        onChange: this.setInputValue.bind(this, 'itemDesc'),
                        placeholder: UG.lang.template('Describe this dashboard') })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'text-center' },
                    _react2.default.createElement(
                        'button',
                        { type: 'button', className: 'btn-cus btn-lg', onClick: this.onCommit },
                        UG.lang.template('Save Dashboard')
                    )
                )
            );
        }
    }]);

    return Step1;
}(_react2.default.Component);

Step1.defaultProps = {
    //  如果上面传进来的了id，就需要请求这个项目的数据，填充表单，以备修改
    id: null,
    giftList: [],
    onCommit: function onCommit(data) {
        console.log(data);
    }
};
exports.default = Step1;

/***/ }),
/* 219 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 220 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "Gifto.Mall.GiftList",
    "options": {
        "objc_class_prefix": "GiftoMallGiftList",
        "java_package": "com.asiainno.uplive.proto.gift"
    },
    "messages": [{
        "name": "Request",
        "fields": [{
            "rule": "optional",
            "type": "int32",
            "name": "scene",
            "id": 1
        }]
    }, {
        "name": "Response",
        "fields": [{
            "rule": "repeated",
            "type": "GiftInfo",
            "name": "gifts",
            "id": 1
        }, {
            "rule": "repeated",
            "type": "BatchSendConfig",
            "name": "batchSendConfigs",
            "id": 2
        }]
    }, {
        "name": "GiftInfo",
        "fields": [{
            "rule": "optional",
            "type": "int32",
            "name": "giftId",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "name",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "intro",
            "id": 3
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "type",
            "id": 4
        }, {
            "rule": "optional",
            "type": "string",
            "name": "url",
            "id": 5
        }, {
            "rule": "optional",
            "type": "string",
            "name": "price",
            "id": 6
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "experience",
            "id": 7
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "version",
            "id": 8
        }, {
            "rule": "optional",
            "type": "bool",
            "name": "onLined",
            "id": 9
        }, {
            "rule": "optional",
            "type": "string",
            "name": "countryCode",
            "id": 10
        }, {
            "rule": "optional",
            "type": "string",
            "name": "language",
            "id": 11
        }, {
            "rule": "optional",
            "type": "bool",
            "name": "needLoad",
            "id": 12
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "showType",
            "id": 13
        }, {
            "rule": "repeated",
            "type": "GiftResourceInfo",
            "name": "resources",
            "id": 14
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "vipGrade",
            "id": 15
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "playTimes",
            "id": 16
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "produceType",
            "id": 17
        }, {
            "rule": "optional",
            "type": "bool",
            "name": "canSendToAllUsers",
            "id": 18
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "timeLimit",
            "id": 19
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "hostBill",
            "id": 20
        }]
    }, {
        "name": "GiftResourceInfo",
        "fields": [{
            "rule": "optional",
            "type": "int32",
            "name": "type",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "url",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "md5",
            "id": 3
        }, {
            "rule": "optional",
            "type": "string",
            "name": "json",
            "id": 4
        }]
    }, {
        "name": "BatchSendConfig",
        "fields": [{
            "rule": "optional",
            "type": "int32",
            "name": "number",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "description",
            "id": 2
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "effectLevel",
            "id": 3
        }]
    }]
}).build();
exports.default = _root;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;

/**
 * @return env: {
        device: { // 设备
            val: 1,
            name: 'android',
            isAndroid: true/false
            isIOS: true/false,
            isOther: true/false
        }, 
        platform: { // SNS平台
            val: 1,
            name: 'pengpeng',
            isPengpeng: true/false
            isIOS: true/false,
            ...
        },
        env: '' // 当前开发环境：pro/stage
    }
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {

    var Url = __webpack_require__(1);

    var ua = window.navigator.userAgent;
    var Env = {
        platform: {},
        device: {},
        env: 'pro'
    };

    // $('#wrap').html(ua)
    //  当前设备
    if (ua.match(/pengpeng/i)) {
        // 碰碰
        Env.platform = {
            val: 2001,
            name: 'pengpeng',
            isPengpeng: true
        };
    } else if (ua.match(/uplive/i) || Url.query('pl', 'hash') == 'uplive' || localStorage.getItem('__inuplive__') || Url.query('pl') == 'uplive') {
        Env.platform = {
            val: 2002,
            name: 'uplive',
            isUplive: true
        };
    } else if (ua.match(/duobao/i)) {
        Env.platform = {
            val: 2003,
            name: 'duobao',
            isDuobao: true
        };
    } else if (ua.match(/micromessenger/i)) {
        // 微信
        Env.platform = {
            val: 1,
            name: 'wechat',
            isWeixin: true
        };
    } else if (ua.match(/qq\//i) || ua.match(/and_sq_/i)) {
        // QQ
        Env.platform = {
            val: 4001,
            name: 'qq',
            isQQ: true
        };
    } else if (ua.match(/weibo/i)) {
        // 微博
        Env.platform = {
            val: 8001,
            name: 'weibo',
            isWeibo: true
        };
    } else if (ua.match(/[Tt]witter/i)) {
        // twitter
        Env.platform = {
            val: 2,
            name: 'twitter',
            isTwitter: true
        };
    } else if (ua.match(/FB_IAB/i)) {
        // facebook
        Env.platform = {
            val: 3,
            name: 'facebook',
            isFacebook: true
        };
    } else if (ua.match(/Line/i)) {
        Env.platform = {
            val: 4,
            name: 'line',
            isLine: true
        };
    } else {
        Env.platform = {
            val: 0,
            name: 'unknown',
            isOther: true
        };
    }
    // 当前社交环境
    if (Env.platform.isPengpeng) {
        if (ua.match(/android/i)) {
            Env.device = {
                val: 1,
                name: 'android',
                isAndroid: true
            };
        } else {
            Env.device = {
                val: 2,
                name: 'ios',
                isIOS: true
            };
        }
    } else {
        if (ua.match(/android/i)) {
            Env.device = {
                val: 1,
                name: 'android',
                isAndroid: true
            };
        } else if (ua.match(/iphone|ipad|itouch/i)) {
            Env.device = {
                val: 2,
                name: 'ios',
                isIOS: true
            };
        } else {
            Env.device = {
                val: 3,
                name: 'unknown',
                isOther: true
            };
        }
    }

    // 当前开发环境
    var _env = Url.query('env');

    if (!_env || _env == 'null') {
        Env.env = 'pro';
    } else {
        Env.env = _env;
    }

    module.exports = Env;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 222 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _server = __webpack_require__(224);

var _server2 = _interopRequireDefault(_server);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// See: https://github.com/webpack/react-starter/issues/37
var isBrowser = typeof window !== 'undefined';
var SVGInjector = isBrowser ? __webpack_require__(226) : undefined;

var ReactSVG = function (_React$Component) {
  _inherits(ReactSVG, _React$Component);

  function ReactSVG() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ReactSVG);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReactSVG.__proto__ || Object.getPrototypeOf(ReactSVG)).call.apply(_ref, [this].concat(args))), _this), _this.refCallback = function (container) {
      if (!container) {
        _this.removeSVG();
        return;
      }

      _this.container = container;
      _this.renderSVG();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ReactSVG, [{
    key: 'renderSVG',
    value: function renderSVG() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      if (this.container instanceof Node) {
        var each = props.callback,
            className = props.className,
            evalScripts = props.evalScripts,
            path = props.path,
            style = props.style;


        var div = document.createElement('div');
        div.innerHTML = _server2.default.renderToStaticMarkup(_react2.default.createElement(
          'div',
          null,
          _react2.default.createElement('div', { className: className, 'data-src': path, style: style })
        ));

        var wrapper = this.container.appendChild(div.firstChild);

        SVGInjector(wrapper.firstChild, {
          evalScripts: evalScripts,
          each: each
        });
      }
    }
  }, {
    key: 'removeSVG',
    value: function removeSVG() {
      if (this.container instanceof Node && this.container.firstChild instanceof Node) {
        this.container.removeChild(this.container.firstChild);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.removeSVG();
      this.renderSVG(nextProps);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('div', { ref: this.refCallback, className: this.props.wrapperClassName });
    }
  }]);

  return ReactSVG;
}(_react2.default.Component);

ReactSVG.defaultProps = {
  callback: function callback() {},
  className: null,
  evalScripts: 'never',
  style: {},
  wrapperClassName: null
};
ReactSVG.propTypes = {
  callback: _propTypes2.default.func,
  className: _propTypes2.default.string,
  evalScripts: _propTypes2.default.oneOf(['always', 'once', 'never']),
  path: _propTypes2.default.string.isRequired,
  style: _propTypes2.default.object,
  wrapperClassName: _propTypes2.default.string
};
exports.default = ReactSVG;
module.exports = exports['default'];

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(225);
} else {
  module.exports = require('./cjs/react-dom-server.browser.development.js');
}


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var k=__webpack_require__(28),l=__webpack_require__(0);function q(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var t="function"===typeof Symbol&&Symbol.for,aa=t?Symbol.for("react.portal"):60106,u=t?Symbol.for("react.fragment"):60107,ba=t?Symbol.for("react.strict_mode"):60108,ca=t?Symbol.for("react.profiler"):60114,v=t?Symbol.for("react.provider"):60109,da=t?Symbol.for("react.context"):60110,ea=t?Symbol.for("react.concurrent_mode"):60111,fa=t?Symbol.for("react.forward_ref"):60112,B=t?Symbol.for("react.suspense"):60113,ha=t?Symbol.for("react.suspense_list"):60120,ia=t?Symbol.for("react.memo"):60115,ja=t?Symbol.for("react.lazy"):
60116,ka=t?Symbol.for("react.block"):60121,la=t?Symbol.for("react.fundamental"):60117,ma=t?Symbol.for("react.scope"):60119;function na(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(c){0===a._status&&(c=c.default,a._status=1,a._result=c)},function(c){0===a._status&&(a._status=2,a._result=c)})}}
function C(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case u:return"Fragment";case aa:return"Portal";case ca:return"Profiler";case ba:return"StrictMode";case B:return"Suspense";case ha:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case da:return"Context.Consumer";case v:return"Context.Provider";case fa:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":"ForwardRef");
case ia:return C(a.type);case ka:return C(a.render);case ja:if(a=1===a._status?a._result:null)return C(a)}return null}var D=l.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;D.hasOwnProperty("ReactCurrentDispatcher")||(D.ReactCurrentDispatcher={current:null});D.hasOwnProperty("ReactCurrentBatchConfig")||(D.ReactCurrentBatchConfig={suspense:null});var oa={};function E(a,b){for(var c=a._threadCount|0;c<=b;c++)a[c]=a._currentValue2,a._threadCount=c+1}
function pa(a,b,c,d){if(d&&(d=a.contextType,"object"===typeof d&&null!==d))return E(d,c),d[c];if(a=a.contextTypes){c={};for(var f in a)c[f]=b[f];b=c}else b=oa;return b}for(var F=new Uint16Array(16),H=0;15>H;H++)F[H]=H+1;F[15]=0;
var qa=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,ra=Object.prototype.hasOwnProperty,sa={},ta={};
function ua(a){if(ra.call(ta,a))return!0;if(ra.call(sa,a))return!1;if(qa.test(a))return ta[a]=!0;sa[a]=!0;return!1}function va(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function wa(a,b,c,d){if(null===b||"undefined"===typeof b||va(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function J(a,b,c,d,f,g){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=f;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=g}var K={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){K[a]=new J(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];K[b]=new J(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){K[a]=new J(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){K[a]=new J(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){K[a]=new J(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){K[a]=new J(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){K[a]=new J(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){K[a]=new J(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){K[a]=new J(a,5,!1,a.toLowerCase(),null,!1)});var L=/[\-:]([a-z])/g;function M(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(L,
M);K[b]=new J(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(L,M);K[b]=new J(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(L,M);K[b]=new J(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){K[a]=new J(a,1,!1,a.toLowerCase(),null,!1)});
K.xlinkHref=new J("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){K[a]=new J(a,1,!1,a.toLowerCase(),null,!0)});var xa=/["'&<>]/;
function N(a){if("boolean"===typeof a||"number"===typeof a)return""+a;a=""+a;var b=xa.exec(a);if(b){var c="",d,f=0;for(d=b.index;d<a.length;d++){switch(a.charCodeAt(d)){case 34:b="&quot;";break;case 38:b="&amp;";break;case 39:b="&#x27;";break;case 60:b="&lt;";break;case 62:b="&gt;";break;default:continue}f!==d&&(c+=a.substring(f,d));f=d+1;c+=b}a=f!==d?c+a.substring(f,d):c}return a}
function ya(a,b){var c=K.hasOwnProperty(a)?K[a]:null;var d;if(d="style"!==a)d=null!==c?0===c.type:!(2<a.length)||"o"!==a[0]&&"O"!==a[0]||"n"!==a[1]&&"N"!==a[1]?!1:!0;if(d||wa(a,b,c,!1))return"";if(null!==c){a=c.attributeName;d=c.type;if(3===d||4===d&&!0===b)return a+'=""';c.sanitizeURL&&(b=""+b);return a+'="'+(N(b)+'"')}return ua(a)?a+'="'+(N(b)+'"'):""}function za(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}
var Aa="function"===typeof Object.is?Object.is:za,O=null,P=null,Q=null,R=!1,S=!1,U=null,V=0;function W(){if(null===O)throw Error(q(321));return O}function Ba(){if(0<V)throw Error(q(312));return{memoizedState:null,queue:null,next:null}}function Ca(){null===Q?null===P?(R=!1,P=Q=Ba()):(R=!0,Q=P):null===Q.next?(R=!1,Q=Q.next=Ba()):(R=!0,Q=Q.next);return Q}function Da(a,b,c,d){for(;S;)S=!1,V+=1,Q=null,c=a(b,d);P=O=null;V=0;Q=U=null;return c}function Ea(a,b){return"function"===typeof b?b(a):b}
function Fa(a,b,c){O=W();Q=Ca();if(R){var d=Q.queue;b=d.dispatch;if(null!==U&&(c=U.get(d),void 0!==c)){U.delete(d);d=Q.memoizedState;do d=a(d,c.action),c=c.next;while(null!==c);Q.memoizedState=d;return[d,b]}return[Q.memoizedState,b]}a=a===Ea?"function"===typeof b?b():b:void 0!==c?c(b):b;Q.memoizedState=a;a=Q.queue={last:null,dispatch:null};a=a.dispatch=Ga.bind(null,O,a);return[Q.memoizedState,a]}
function Ga(a,b,c){if(!(25>V))throw Error(q(301));if(a===O)if(S=!0,a={action:c,next:null},null===U&&(U=new Map),c=U.get(b),void 0===c)U.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}}function Ha(){}
var X=0,Ia={readContext:function(a){var b=X;E(a,b);return a[b]},useContext:function(a){W();var b=X;E(a,b);return a[b]},useMemo:function(a,b){O=W();Q=Ca();b=void 0===b?null:b;if(null!==Q){var c=Q.memoizedState;if(null!==c&&null!==b){a:{var d=c[1];if(null===d)d=!1;else{for(var f=0;f<d.length&&f<b.length;f++)if(!Aa(b[f],d[f])){d=!1;break a}d=!0}}if(d)return c[0]}}a=a();Q.memoizedState=[a,b];return a},useReducer:Fa,useRef:function(a){O=W();Q=Ca();var b=Q.memoizedState;return null===b?(a={current:a},Q.memoizedState=
a):b},useState:function(a){return Fa(Ea,a)},useLayoutEffect:function(){},useCallback:function(a){return a},useImperativeHandle:Ha,useEffect:Ha,useDebugValue:Ha,useResponder:function(a,b){return{props:b,responder:a}},useDeferredValue:function(a){W();return a},useTransition:function(){W();return[function(a){a()},!1]}},Ja={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Ka(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}
var La={area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0},Ma=k({menuitem:!0},La),Y={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,
gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Na=["Webkit","ms","Moz","O"];Object.keys(Y).forEach(function(a){Na.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Y[b]=Y[a]})});
var Oa=/([A-Z])/g,Pa=/^ms-/,Z=l.Children.toArray,Qa=D.ReactCurrentDispatcher,Ra={listing:!0,pre:!0,textarea:!0},Sa=/^[a-zA-Z][a-zA-Z:_\.\-\d]*$/,Ta={},Ua={};function Va(a){if(void 0===a||null===a)return a;var b="";l.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}var Wa=Object.prototype.hasOwnProperty,Xa={children:null,dangerouslySetInnerHTML:null,suppressContentEditableWarning:null,suppressHydrationWarning:null};function Ya(a,b){if(void 0===a)throw Error(q(152,C(b)||"Component"));}
function Za(a,b,c){function d(d,g){var e=g.prototype&&g.prototype.isReactComponent,f=pa(g,b,c,e),x=[],h=!1,m={isMounted:function(){return!1},enqueueForceUpdate:function(){if(null===x)return null},enqueueReplaceState:function(a,c){h=!0;x=[c]},enqueueSetState:function(a,c){if(null===x)return null;x.push(c)}};if(e){if(e=new g(d.props,f,m),"function"===typeof g.getDerivedStateFromProps){var w=g.getDerivedStateFromProps.call(null,d.props,e.state);null!=w&&(e.state=k({},e.state,w))}}else if(O={},e=g(d.props,
f,m),e=Da(g,d.props,e,f),null==e||null==e.render){a=e;Ya(a,g);return}e.props=d.props;e.context=f;e.updater=m;m=e.state;void 0===m&&(e.state=m=null);if("function"===typeof e.UNSAFE_componentWillMount||"function"===typeof e.componentWillMount)if("function"===typeof e.componentWillMount&&"function"!==typeof g.getDerivedStateFromProps&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&"function"!==typeof g.getDerivedStateFromProps&&e.UNSAFE_componentWillMount(),x.length){m=x;var r=
h;x=null;h=!1;if(r&&1===m.length)e.state=m[0];else{w=r?m[0]:e.state;var y=!0;for(r=r?1:0;r<m.length;r++){var p=m[r];p="function"===typeof p?p.call(e,w,d.props,f):p;null!=p&&(y?(y=!1,w=k({},w,p)):k(w,p))}e.state=w}}else x=null;a=e.render();Ya(a,g);if("function"===typeof e.getChildContext&&(d=g.childContextTypes,"object"===typeof d)){var A=e.getChildContext();for(var T in A)if(!(T in d))throw Error(q(108,C(g)||"Unknown",T));}A&&(b=k({},b,A))}for(;l.isValidElement(a);){var f=a,g=f.type;if("function"!==
typeof g)break;d(f,g)}return{child:a,context:b}}
var $a=function(){function a(a,b){l.isValidElement(a)?a.type!==u?a=[a]:(a=a.props.children,a=l.isValidElement(a)?[a]:Z(a)):a=Z(a);a={type:null,domNamespace:Ja.html,children:a,childIndex:0,context:oa,footer:""};var c=F[0];if(0===c){var g=F;c=g.length;var d=2*c;if(!(65536>=d))throw Error(q(304));var h=new Uint16Array(d);h.set(g);F=h;F[0]=c+1;for(g=c;g<d-1;g++)F[g]=g+1;F[d-1]=0}else F[0]=F[c];this.threadID=c;this.stack=[a];this.exhausted=!1;this.currentSelectValue=null;this.previousWasTextNode=!1;this.makeStaticMarkup=
b;this.suspenseDepth=0;this.contextIndex=-1;this.contextStack=[];this.contextValueStack=[]}var b=a.prototype;b.destroy=function(){if(!this.exhausted){this.exhausted=!0;this.clearProviders();var a=this.threadID;F[a]=F[0];F[0]=a}};b.pushProvider=function(a){var c=++this.contextIndex,b=a.type._context,g=this.threadID;E(b,g);var x=b[g];this.contextStack[c]=b;this.contextValueStack[c]=x;b[g]=a.props.value};b.popProvider=function(){var a=this.contextIndex,b=this.contextStack[a],f=this.contextValueStack[a];
this.contextStack[a]=null;this.contextValueStack[a]=null;this.contextIndex--;b[this.threadID]=f};b.clearProviders=function(){for(var a=this.contextIndex;0<=a;a--)this.contextStack[a][this.threadID]=this.contextValueStack[a]};b.read=function(a){if(this.exhausted)return null;var b=X;X=this.threadID;var c=Qa.current;Qa.current=Ia;try{for(var g=[""],x=!1;g[0].length<a;){if(0===this.stack.length){this.exhausted=!0;var h=this.threadID;F[h]=F[0];F[0]=h;break}var e=this.stack[this.stack.length-1];if(x||e.childIndex>=
e.children.length){var I=e.footer;""!==I&&(this.previousWasTextNode=!1);this.stack.pop();if("select"===e.type)this.currentSelectValue=null;else if(null!=e.type&&null!=e.type.type&&e.type.type.$$typeof===v)this.popProvider(e.type);else if(e.type===B){this.suspenseDepth--;var G=g.pop();if(x){x=!1;var n=e.fallbackFrame;if(!n)throw Error(q(303));this.stack.push(n);g[this.suspenseDepth]+="\x3c!--$!--\x3e";continue}else g[this.suspenseDepth]+=G}g[this.suspenseDepth]+=I}else{var m=e.children[e.childIndex++],
w="";try{w+=this.render(m,e.context,e.domNamespace)}catch(r){if(null!=r&&"function"===typeof r.then)throw Error(q(294));throw r;}finally{}g.length<=this.suspenseDepth&&g.push("");g[this.suspenseDepth]+=w}}return g[0]}finally{Qa.current=c,X=b}};b.render=function(a,b,f){if("string"===typeof a||"number"===typeof a){f=""+a;if(""===f)return"";if(this.makeStaticMarkup)return N(f);if(this.previousWasTextNode)return"\x3c!-- --\x3e"+N(f);this.previousWasTextNode=!0;return N(f)}b=Za(a,b,this.threadID);a=b.child;
b=b.context;if(null===a||!1===a)return"";if(!l.isValidElement(a)){if(null!=a&&null!=a.$$typeof){f=a.$$typeof;if(f===aa)throw Error(q(257));throw Error(q(258,f.toString()));}a=Z(a);this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""});return""}var c=a.type;if("string"===typeof c)return this.renderDOM(a,b,f);switch(c){case ba:case ea:case ca:case ha:case u:return a=Z(a.props.children),this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""}),
"";case B:throw Error(q(294));}if("object"===typeof c&&null!==c)switch(c.$$typeof){case fa:O={};var d=c.render(a.props,a.ref);d=Da(c.render,a.props,d,a.ref);d=Z(d);this.stack.push({type:null,domNamespace:f,children:d,childIndex:0,context:b,footer:""});return"";case ia:return a=[l.createElement(c.type,k({ref:a.ref},a.props))],this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""}),"";case v:return c=Z(a.props.children),f={type:a,domNamespace:f,children:c,childIndex:0,
context:b,footer:""},this.pushProvider(a),this.stack.push(f),"";case da:c=a.type;d=a.props;var h=this.threadID;E(c,h);c=Z(d.children(c[h]));this.stack.push({type:a,domNamespace:f,children:c,childIndex:0,context:b,footer:""});return"";case la:throw Error(q(338));case ja:switch(c=a.type,na(c),c._status){case 1:return a=[l.createElement(c._result,k({ref:a.ref},a.props))],this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""}),"";case 2:throw c._result;default:throw Error(q(295));
}case ma:throw Error(q(343));}throw Error(q(130,null==c?c:typeof c,""));};b.renderDOM=function(a,b,f){var c=a.type.toLowerCase();f===Ja.html&&Ka(c);if(!Ta.hasOwnProperty(c)){if(!Sa.test(c))throw Error(q(65,c));Ta[c]=!0}var d=a.props;if("input"===c)d=k({type:void 0},d,{defaultChecked:void 0,defaultValue:void 0,value:null!=d.value?d.value:d.defaultValue,checked:null!=d.checked?d.checked:d.defaultChecked});else if("textarea"===c){var h=d.value;if(null==h){h=d.defaultValue;var e=d.children;if(null!=e){if(null!=
h)throw Error(q(92));if(Array.isArray(e)){if(!(1>=e.length))throw Error(q(93));e=e[0]}h=""+e}null==h&&(h="")}d=k({},d,{value:void 0,children:""+h})}else if("select"===c)this.currentSelectValue=null!=d.value?d.value:d.defaultValue,d=k({},d,{value:void 0});else if("option"===c){e=this.currentSelectValue;var I=Va(d.children);if(null!=e){var G=null!=d.value?d.value+"":I;h=!1;if(Array.isArray(e))for(var n=0;n<e.length;n++){if(""+e[n]===G){h=!0;break}}else h=""+e===G;d=k({selected:void 0,children:void 0},
d,{selected:h,children:I})}}if(h=d){if(Ma[c]&&(null!=h.children||null!=h.dangerouslySetInnerHTML))throw Error(q(137,c,""));if(null!=h.dangerouslySetInnerHTML){if(null!=h.children)throw Error(q(60));if(!("object"===typeof h.dangerouslySetInnerHTML&&"__html"in h.dangerouslySetInnerHTML))throw Error(q(61));}if(null!=h.style&&"object"!==typeof h.style)throw Error(q(62,""));}h=d;e=this.makeStaticMarkup;I=1===this.stack.length;G="<"+a.type;for(z in h)if(Wa.call(h,z)){var m=h[z];if(null!=m){if("style"===
z){n=void 0;var w="",r="";for(n in m)if(m.hasOwnProperty(n)){var y=0===n.indexOf("--"),p=m[n];if(null!=p){if(y)var A=n;else if(A=n,Ua.hasOwnProperty(A))A=Ua[A];else{var T=A.replace(Oa,"-$1").toLowerCase().replace(Pa,"-ms-");A=Ua[A]=T}w+=r+A+":";r=n;y=null==p||"boolean"===typeof p||""===p?"":y||"number"!==typeof p||0===p||Y.hasOwnProperty(r)&&Y[r]?(""+p).trim():p+"px";w+=y;r=";"}}m=w||null}n=null;b:if(y=c,p=h,-1===y.indexOf("-"))y="string"===typeof p.is;else switch(y){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":y=
!1;break b;default:y=!0}y?Xa.hasOwnProperty(z)||(n=z,n=ua(n)&&null!=m?n+'="'+(N(m)+'"'):""):n=ya(z,m);n&&(G+=" "+n)}}e||I&&(G+=' data-reactroot=""');var z=G;h="";La.hasOwnProperty(c)?z+="/>":(z+=">",h="</"+a.type+">");a:{e=d.dangerouslySetInnerHTML;if(null!=e){if(null!=e.__html){e=e.__html;break a}}else if(e=d.children,"string"===typeof e||"number"===typeof e){e=N(e);break a}e=null}null!=e?(d=[],Ra.hasOwnProperty(c)&&"\n"===e.charAt(0)&&(z+="\n"),z+=e):d=Z(d.children);a=a.type;f=null==f||"http://www.w3.org/1999/xhtml"===
f?Ka(a):"http://www.w3.org/2000/svg"===f&&"foreignObject"===a?"http://www.w3.org/1999/xhtml":f;this.stack.push({domNamespace:f,type:c,children:d,childIndex:0,context:b,footer:h});this.previousWasTextNode=!1;return z};return a}(),ab={renderToString:function(a){a=new $a(a,!1);try{return a.read(Infinity)}finally{a.destroy()}},renderToStaticMarkup:function(a){a=new $a(a,!0);try{return a.read(Infinity)}finally{a.destroy()}},renderToNodeStream:function(){throw Error(q(207));},renderToStaticNodeStream:function(){throw Error(q(208));
},version:"16.13.1"};module.exports=ab.default||ab;


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * SVGInjector v1.1.3 - Fast, caching, dynamic inline SVG DOM injection library
 * https://github.com/iconic/SVGInjector
 *
 * Copyright (c) 2014-2015 Waybury <hello@waybury.com>
 * @license MIT
 */

(function (window, document) {

  'use strict';

  // Environment
  var isLocal = window.location.protocol === 'file:';
  var hasSvgSupport = document.implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#BasicStructure', '1.1');

  function uniqueClasses(list) {
    list = list.split(' ');

    var hash = {};
    var i = list.length;
    var out = [];

    while (i--) {
      if (!hash.hasOwnProperty(list[i])) {
        hash[list[i]] = 1;
        out.unshift(list[i]);
      }
    }

    return out.join(' ');
  }

  /**
   * cache (or polyfill for <= IE8) Array.forEach()
   * source: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach
   */
  var forEach = Array.prototype.forEach || function (fn, scope) {
    if (this === void 0 || this === null || typeof fn !== 'function') {
      throw new TypeError();
    }

    /* jshint bitwise: false */
    var i, len = this.length >>> 0;
    /* jshint bitwise: true */

    for (i = 0; i < len; ++i) {
      if (i in this) {
        fn.call(scope, this[i], i, this);
      }
    }
  };

  // SVG Cache
  var svgCache = {};

  var injectCount = 0;
  var injectedElements = [];

  // Request Queue
  var requestQueue = [];

  // Script running status
  var ranScripts = {};

  var cloneSvg = function (sourceSvg) {
    return sourceSvg.cloneNode(true);
  };

  var queueRequest = function (url, callback) {
    requestQueue[url] = requestQueue[url] || [];
    requestQueue[url].push(callback);
  };

  var processRequestQueue = function (url) {
    for (var i = 0, len = requestQueue[url].length; i < len; i++) {
      // Make these calls async so we avoid blocking the page/renderer
      /* jshint loopfunc: true */
      (function (index) {
        setTimeout(function () {
          requestQueue[url][index](cloneSvg(svgCache[url]));
        }, 0);
      })(i);
      /* jshint loopfunc: false */
    }
  };

  var loadSvg = function (url, callback) {
    if (svgCache[url] !== undefined) {
      if (svgCache[url] instanceof SVGSVGElement) {
        // We already have it in cache, so use it
        callback(cloneSvg(svgCache[url]));
      }
      else {
        // We don't have it in cache yet, but we are loading it, so queue this request
        queueRequest(url, callback);
      }
    }
    else {

      if (!window.XMLHttpRequest) {
        callback('Browser does not support XMLHttpRequest');
        return false;
      }

      // Seed the cache to indicate we are loading this URL already
      svgCache[url] = {};
      queueRequest(url, callback);

      var httpRequest = new XMLHttpRequest();

      httpRequest.onreadystatechange = function () {
        // readyState 4 = complete
        if (httpRequest.readyState === 4) {

          // Handle status
          if (httpRequest.status === 404 || httpRequest.responseXML === null) {
            callback('Unable to load SVG file: ' + url);

            if (isLocal) callback('Note: SVG injection ajax calls do not work locally without adjusting security setting in your browser. Or consider using a local webserver.');

            callback();
            return false;
          }

          // 200 success from server, or 0 when using file:// protocol locally
          if (httpRequest.status === 200 || (isLocal && httpRequest.status === 0)) {

            /* globals Document */
            if (httpRequest.responseXML instanceof Document) {
              // Cache it
              svgCache[url] = httpRequest.responseXML.documentElement;
            }
            /* globals -Document */

            // IE9 doesn't create a responseXML Document object from loaded SVG,
            // and throws a "DOM Exception: HIERARCHY_REQUEST_ERR (3)" error when injected.
            //
            // So, we'll just create our own manually via the DOMParser using
            // the the raw XML responseText.
            //
            // :NOTE: IE8 and older doesn't have DOMParser, but they can't do SVG either, so...
            else if (DOMParser && (DOMParser instanceof Function)) {
              var xmlDoc;
              try {
                var parser = new DOMParser();
                xmlDoc = parser.parseFromString(httpRequest.responseText, 'text/xml');
              }
              catch (e) {
                xmlDoc = undefined;
              }

              if (!xmlDoc || xmlDoc.getElementsByTagName('parsererror').length) {
                callback('Unable to parse SVG file: ' + url);
                return false;
              }
              else {
                // Cache it
                svgCache[url] = xmlDoc.documentElement;
              }
            }

            // We've loaded a new asset, so process any requests waiting for it
            processRequestQueue(url);
          }
          else {
            callback('There was a problem injecting the SVG: ' + httpRequest.status + ' ' + httpRequest.statusText);
            return false;
          }
        }
      };

      httpRequest.open('GET', url);

      // Treat and parse the response as XML, even if the
      // server sends us a different mimetype
      if (httpRequest.overrideMimeType) httpRequest.overrideMimeType('text/xml');

      httpRequest.send();
    }
  };

  // Inject a single element
  var injectElement = function (el, evalScripts, pngFallback, callback) {

    // Grab the src or data-src attribute
    var imgUrl = el.getAttribute('data-src') || el.getAttribute('src');

    // We can only inject SVG
    if (!(/\.svg/i).test(imgUrl)) {
      callback('Attempted to inject a file with a non-svg extension: ' + imgUrl);
      return;
    }

    // If we don't have SVG support try to fall back to a png,
    // either defined per-element via data-fallback or data-png,
    // or globally via the pngFallback directory setting
    if (!hasSvgSupport) {
      var perElementFallback = el.getAttribute('data-fallback') || el.getAttribute('data-png');

      // Per-element specific PNG fallback defined, so use that
      if (perElementFallback) {
        el.setAttribute('src', perElementFallback);
        callback(null);
      }
      // Global PNG fallback directoriy defined, use the same-named PNG
      else if (pngFallback) {
        el.setAttribute('src', pngFallback + '/' + imgUrl.split('/').pop().replace('.svg', '.png'));
        callback(null);
      }
      // um...
      else {
        callback('This browser does not support SVG and no PNG fallback was defined.');
      }

      return;
    }

    // Make sure we aren't already in the process of injecting this element to
    // avoid a race condition if multiple injections for the same element are run.
    // :NOTE: Using indexOf() only _after_ we check for SVG support and bail,
    // so no need for IE8 indexOf() polyfill
    if (injectedElements.indexOf(el) !== -1) {
      return;
    }

    // Remember the request to inject this element, in case other injection
    // calls are also trying to replace this element before we finish
    injectedElements.push(el);

    // Try to avoid loading the orginal image src if possible.
    el.setAttribute('src', '');

    // Load it up
    loadSvg(imgUrl, function (svg) {

      if (typeof svg === 'undefined' || typeof svg === 'string') {
        callback(svg);
        return false;
      }

      var imgId = el.getAttribute('id');
      if (imgId) {
        svg.setAttribute('id', imgId);
      }

      var imgTitle = el.getAttribute('title');
      if (imgTitle) {
        svg.setAttribute('title', imgTitle);
      }

      // Concat the SVG classes + 'injected-svg' + the img classes
      var classMerge = [].concat(svg.getAttribute('class') || [], 'injected-svg', el.getAttribute('class') || []).join(' ');
      svg.setAttribute('class', uniqueClasses(classMerge));

      var imgStyle = el.getAttribute('style');
      if (imgStyle) {
        svg.setAttribute('style', imgStyle);
      }

      // Copy all the data elements to the svg
      var imgData = [].filter.call(el.attributes, function (at) {
        return (/^data-\w[\w\-]*$/).test(at.name);
      });
      forEach.call(imgData, function (dataAttr) {
        if (dataAttr.name && dataAttr.value) {
          svg.setAttribute(dataAttr.name, dataAttr.value);
        }
      });

      // Make sure any internally referenced clipPath ids and their
      // clip-path references are unique.
      //
      // This addresses the issue of having multiple instances of the
      // same SVG on a page and only the first clipPath id is referenced.
      //
      // Browsers often shortcut the SVG Spec and don't use clipPaths
      // contained in parent elements that are hidden, so if you hide the first
      // SVG instance on the page, then all other instances lose their clipping.
      // Reference: https://bugzilla.mozilla.org/show_bug.cgi?id=376027

      // Handle all defs elements that have iri capable attributes as defined by w3c: http://www.w3.org/TR/SVG/linking.html#processingIRI
      // Mapping IRI addressable elements to the properties that can reference them:
      var iriElementsAndProperties = {
        'clipPath': ['clip-path'],
        'color-profile': ['color-profile'],
        'cursor': ['cursor'],
        'filter': ['filter'],
        'linearGradient': ['fill', 'stroke'],
        'marker': ['marker', 'marker-start', 'marker-mid', 'marker-end'],
        'mask': ['mask'],
        'pattern': ['fill', 'stroke'],
        'radialGradient': ['fill', 'stroke']
      };

      var element, elementDefs, properties, currentId, newId;
      Object.keys(iriElementsAndProperties).forEach(function (key) {
        element = key;
        properties = iriElementsAndProperties[key];

        elementDefs = svg.querySelectorAll('defs ' + element + '[id]');
        for (var i = 0, elementsLen = elementDefs.length; i < elementsLen; i++) {
          currentId = elementDefs[i].id;
          newId = currentId + '-' + injectCount;

          // All of the properties that can reference this element type
          var referencingElements;
          forEach.call(properties, function (property) {
            // :NOTE: using a substring match attr selector here to deal with IE "adding extra quotes in url() attrs"
            referencingElements = svg.querySelectorAll('[' + property + '*="' + currentId + '"]');
            for (var j = 0, referencingElementLen = referencingElements.length; j < referencingElementLen; j++) {
              referencingElements[j].setAttribute(property, 'url(#' + newId + ')');
            }
          });

          elementDefs[i].id = newId;
        }
      });

      // Remove any unwanted/invalid namespaces that might have been added by SVG editing tools
      svg.removeAttribute('xmlns:a');

      // Post page load injected SVGs don't automatically have their script
      // elements run, so we'll need to make that happen, if requested

      // Find then prune the scripts
      var scripts = svg.querySelectorAll('script');
      var scriptsToEval = [];
      var script, scriptType;

      for (var k = 0, scriptsLen = scripts.length; k < scriptsLen; k++) {
        scriptType = scripts[k].getAttribute('type');

        // Only process javascript types.
        // SVG defaults to 'application/ecmascript' for unset types
        if (!scriptType || scriptType === 'application/ecmascript' || scriptType === 'application/javascript') {

          // innerText for IE, textContent for other browsers
          script = scripts[k].innerText || scripts[k].textContent;

          // Stash
          scriptsToEval.push(script);

          // Tidy up and remove the script element since we don't need it anymore
          svg.removeChild(scripts[k]);
        }
      }

      // Run/Eval the scripts if needed
      if (scriptsToEval.length > 0 && (evalScripts === 'always' || (evalScripts === 'once' && !ranScripts[imgUrl]))) {
        for (var l = 0, scriptsToEvalLen = scriptsToEval.length; l < scriptsToEvalLen; l++) {

          // :NOTE: Yup, this is a form of eval, but it is being used to eval code
          // the caller has explictely asked to be loaded, and the code is in a caller
          // defined SVG file... not raw user input.
          //
          // Also, the code is evaluated in a closure and not in the global scope.
          // If you need to put something in global scope, use 'window'
          new Function(scriptsToEval[l])(window); // jshint ignore:line
        }

        // Remember we already ran scripts for this svg
        ranScripts[imgUrl] = true;
      }

      // :WORKAROUND:
      // IE doesn't evaluate <style> tags in SVGs that are dynamically added to the page.
      // This trick will trigger IE to read and use any existing SVG <style> tags.
      //
      // Reference: https://github.com/iconic/SVGInjector/issues/23
      var styleTags = svg.querySelectorAll('style');
      forEach.call(styleTags, function (styleTag) {
        styleTag.textContent += '';
      });

      // Replace the image with the svg
      el.parentNode.replaceChild(svg, el);

      // Now that we no longer need it, drop references
      // to the original element so it can be GC'd
      delete injectedElements[injectedElements.indexOf(el)];
      el = null;

      // Increment the injected count
      injectCount++;

      callback(svg);
    });
  };

  /**
   * SVGInjector
   *
   * Replace the given elements with their full inline SVG DOM elements.
   *
   * :NOTE: We are using get/setAttribute with SVG because the SVG DOM spec differs from HTML DOM and
   * can return other unexpected object types when trying to directly access svg properties.
   * ex: "className" returns a SVGAnimatedString with the class value found in the "baseVal" property,
   * instead of simple string like with HTML Elements.
   *
   * @param {mixes} Array of or single DOM element
   * @param {object} options
   * @param {function} callback
   * @return {object} Instance of SVGInjector
   */
  var SVGInjector = function (elements, options, done) {

    // Options & defaults
    options = options || {};

    // Should we run the scripts blocks found in the SVG
    // 'always' - Run them every time
    // 'once' - Only run scripts once for each SVG
    // [false|'never'] - Ignore scripts
    var evalScripts = options.evalScripts || 'always';

    // Location of fallback pngs, if desired
    var pngFallback = options.pngFallback || false;

    // Callback to run during each SVG injection, returning the SVG injected
    var eachCallback = options.each;

    // Do the injection...
    if (elements.length !== undefined) {
      var elementsLoaded = 0;
      forEach.call(elements, function (element) {
        injectElement(element, evalScripts, pngFallback, function (svg) {
          if (eachCallback && typeof eachCallback === 'function') eachCallback(svg);
          if (done && elements.length === ++elementsLoaded) done(elementsLoaded);
        });
      });
    }
    else {
      if (elements) {
        injectElement(elements, evalScripts, pngFallback, function (svg) {
          if (eachCallback && typeof eachCallback === 'function') eachCallback(svg);
          if (done) done(1);
          elements = null;
        });
      }
      else {
        if (done) done(0);
      }
    }
  };

  /* global module, exports: true, define */
  // Node.js or CommonJS
  if (typeof module === 'object' && typeof module.exports === 'object') {
    module.exports = exports = SVGInjector;
  }
  // AMD support
  else if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return SVGInjector;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Otherwise, attach to window as global
  else if (typeof window === 'object') {
    window.SVGInjector = SVGInjector;
  }
  /* global -module, -exports, -define */

}(window, document));


/***/ }),
/* 227 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _clipboard = __webpack_require__(134);

var _clipboard2 = _interopRequireDefault(_clipboard);

var _cUrl = __webpack_require__(1);

var _cUrl2 = _interopRequireDefault(_cUrl);

var _config = __webpack_require__(35);

var _giftitemdetail = __webpack_require__(100);

var _giftitemdetail2 = _interopRequireDefault(_giftitemdetail);

__webpack_require__(236);

var _gaConfig = __webpack_require__(50);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getProjectById = (0, _config.giftService)('/gift/item/detail', _giftitemdetail2.default.Gift.ItemDetail);

var Step2 = function (_React$Component) {
    _inherits(Step2, _React$Component);

    function Step2(props) {
        _classCallCheck(this, Step2);

        var _this = _possibleConstructorReturn(this, (Step2.__proto__ || Object.getPrototypeOf(Step2)).call(this, props));

        var queryObj = _cUrl2.default.parseQuery(_cUrl2.default.parse(location.href).query),
            queryResult = {};

        //  只获取路径上传递的语言和env参数，其他参数直接忽略
        Object.keys(queryObj).forEach(function (item) {
            if (['lang', 'env'].indexOf(item) !== -1) {
                queryResult[item] = queryObj[item];
            }
        });

        queryResult.hostid = UG.getUser().uid;
        queryResult.itemid = props.id;
        var url = _config.config.publishUrl + '?' + $.param(queryResult) + '#/gift';

        _this.state = {
            itemId: props.id,
            itemName: '',
            showNext: false,
            shareUrl: url
        };
        return _this;
    }

    _createClass(Step2, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.initClipboard();
            this.fetchProjectInfo();
            GA.add(_gaConfig.enterCreateStepTwo);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            //  防止多次初始化
            this.clip && this.clip.destroy();
        }
    }, {
        key: 'initClipboard',
        value: function initClipboard() {
            var _this2 = this;

            var onNext = this.props.onNext;
            var shareUrl = this.state.shareUrl;
            // 初始化剪切板插件

            var clip = this.clip = new _clipboard2.default('#ci-copy-link', {
                text: function text() {
                    return shareUrl;
                }
            });

            clip.on('success', function () {
                UG.simple(UG.lang.template('Copied Successfully!'));
                //  延迟跳转
                GA.add(_gaConfig.createStepTwoCopy);
                setTimeout(onNext, 1000);
            });
            clip.on('error', function () {
                UG.simple(UG.lang.template('Copied failed. Please select the link and copy.'));
                //  延迟，防止直接就跳转到下一步了
                setTimeout(function () {
                    _this2.setState({ showNext: true });
                }, 300);
            });
        }
    }, {
        key: 'fetchProjectInfo',
        value: function fetchProjectInfo() {
            var _this3 = this;

            getProjectById({ itemId: this.props.id, uid: UG.getUser().uid }).then(function (_ref) {
                var itemInfos = _ref.itemInfos;
                var itemName = itemInfos.itemName;

                _this3.setState({ itemName: itemName });
            }).catch(function (err) {
                console.log('出现了错误了');
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                image = _props.image,
                onSeeAll = _props.onSeeAll,
                onEdit = _props.onEdit,
                onNext = _props.onNext;
            var _state = this.state,
                showNext = _state.showNext,
                itemName = _state.itemName,
                shareUrl = _state.shareUrl;

            var editClick = function editClick() {
                onEdit();
            };
            var seeAll = function seeAll() {
                GA.add(_gaConfig.createStepTwoSeeAll);
                onSeeAll();
            };
            return _react2.default.createElement(
                'div',
                { className: 'ci-step2' },
                _react2.default.createElement(
                    'div',
                    { className: 'ci-step2-info text-center' },
                    _react2.default.createElement('img', { src: image }),
                    _react2.default.createElement(
                        'p',
                        { className: 'ci-step2-uname ellipsis' },
                        itemName
                    ),
                    _react2.default.createElement('i', { className: 'ci-step2-edit', onClick: editClick })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'ci-step2-share text-center' },
                    _react2.default.createElement('input', { type: 'text', defaultValue: shareUrl })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'text-center' },
                    showNext ? _react2.default.createElement(
                        'button',
                        { type: 'button', className: 'btn-cus btn-lg', onClick: onNext },
                        UG.lang.template('Next Step')
                    ) : _react2.default.createElement(
                        'button',
                        { type: 'button', className: 'btn-cus btn-lg', id: 'ci-copy-link' },
                        UG.lang.template('Copy link')
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'ci-step2-link-all', onClick: seeAll },
                        UG.lang.template('See all >')
                    )
                )
            );
        }
    }]);

    return Step2;
}(_react2.default.Component);

Step2.defaultProps = {
    id: null, //  如果有id，就需要显示当前id的项目名称
    image: __webpack_require__(135),
    onSeeAll: function onSeeAll() {
        //  查看所有
    },
    onNext: function onNext() {
        // 会跳转到下一步的
    },
    onEdit: function onEdit() {
        // 点击了图像上的修改按钮
    }
};
exports.default = Step2;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(230)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module, require('select'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.select);
        global.clipboardAction = mod.exports;
    }
})(this, function (module, _select) {
    'use strict';

    var _select2 = _interopRequireDefault(_select);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    var ClipboardAction = function () {
        /**
         * @param {Object} options
         */
        function ClipboardAction(options) {
            _classCallCheck(this, ClipboardAction);

            this.resolveOptions(options);
            this.initSelection();
        }

        /**
         * Defines base properties passed from constructor.
         * @param {Object} options
         */


        _createClass(ClipboardAction, [{
            key: 'resolveOptions',
            value: function resolveOptions() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                this.action = options.action;
                this.container = options.container;
                this.emitter = options.emitter;
                this.target = options.target;
                this.text = options.text;
                this.trigger = options.trigger;

                this.selectedText = '';
            }
        }, {
            key: 'initSelection',
            value: function initSelection() {
                if (this.text) {
                    this.selectFake();
                } else if (this.target) {
                    this.selectTarget();
                }
            }
        }, {
            key: 'selectFake',
            value: function selectFake() {
                var _this = this;

                var isRTL = document.documentElement.getAttribute('dir') == 'rtl';

                this.removeFake();

                this.fakeHandlerCallback = function () {
                    return _this.removeFake();
                };
                this.fakeHandler = this.container.addEventListener('click', this.fakeHandlerCallback) || true;

                this.fakeElem = document.createElement('textarea');
                // Prevent zooming on iOS
                this.fakeElem.style.fontSize = '12pt';
                // Reset box model
                this.fakeElem.style.border = '0';
                this.fakeElem.style.padding = '0';
                this.fakeElem.style.margin = '0';
                // Move element out of screen horizontally
                this.fakeElem.style.position = 'absolute';
                this.fakeElem.style[isRTL ? 'right' : 'left'] = '-312.46875rem';
                // Move element to the same position vertically
                var yPosition = window.pageYOffset || document.documentElement.scrollTop;
                this.fakeElem.style.top = yPosition + 'px';

                this.fakeElem.setAttribute('readonly', '');
                this.fakeElem.value = this.text;

                this.container.appendChild(this.fakeElem);

                this.selectedText = (0, _select2.default)(this.fakeElem);
                this.copyText();
            }
        }, {
            key: 'removeFake',
            value: function removeFake() {
                if (this.fakeHandler) {
                    this.container.removeEventListener('click', this.fakeHandlerCallback);
                    this.fakeHandler = null;
                    this.fakeHandlerCallback = null;
                }

                if (this.fakeElem) {
                    this.container.removeChild(this.fakeElem);
                    this.fakeElem = null;
                }
            }
        }, {
            key: 'selectTarget',
            value: function selectTarget() {
                this.selectedText = (0, _select2.default)(this.target);
                this.copyText();
            }
        }, {
            key: 'copyText',
            value: function copyText() {
                var succeeded = void 0;

                try {
                    succeeded = document.execCommand(this.action);
                } catch (err) {
                    succeeded = false;
                }

                this.handleResult(succeeded);
            }
        }, {
            key: 'handleResult',
            value: function handleResult(succeeded) {
                this.emitter.emit(succeeded ? 'success' : 'error', {
                    action: this.action,
                    text: this.selectedText,
                    trigger: this.trigger,
                    clearSelection: this.clearSelection.bind(this)
                });
            }
        }, {
            key: 'clearSelection',
            value: function clearSelection() {
                if (this.trigger) {
                    this.trigger.focus();
                }

                window.getSelection().removeAllRanges();
            }
        }, {
            key: 'destroy',
            value: function destroy() {
                this.removeFake();
            }
        }, {
            key: 'action',
            set: function set() {
                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'copy';

                this._action = action;

                if (this._action !== 'copy' && this._action !== 'cut') {
                    throw new Error('Invalid "action" value, use either "copy" or "cut"');
                }
            },
            get: function get() {
                return this._action;
            }
        }, {
            key: 'target',
            set: function set(target) {
                if (target !== undefined) {
                    if (target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && target.nodeType === 1) {
                        if (this.action === 'copy' && target.hasAttribute('disabled')) {
                            throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                        }

                        if (this.action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {
                            throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
                        }

                        this._target = target;
                    } else {
                        throw new Error('Invalid "target" value, use a valid Element');
                    }
                }
            },
            get: function get() {
                return this._target;
            }
        }]);

        return ClipboardAction;
    }();

    module.exports = ClipboardAction;
});

/***/ }),
/* 230 */
/***/ (function(module, exports) {

function select(element) {
    var selectedText;

    if (element.nodeName === 'SELECT') {
        element.focus();

        selectedText = element.value;
    }
    else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
        var isReadOnly = element.hasAttribute('readonly');

        if (!isReadOnly) {
            element.setAttribute('readonly', '');
        }

        element.select();
        element.setSelectionRange(0, element.value.length);

        if (!isReadOnly) {
            element.removeAttribute('readonly');
        }

        selectedText = element.value;
    }
    else {
        if (element.hasAttribute('contenteditable')) {
            element.focus();
        }

        var selection = window.getSelection();
        var range = document.createRange();

        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);

        selectedText = selection.toString();
    }

    return selectedText;
}

module.exports = select;


/***/ }),
/* 231 */
/***/ (function(module, exports) {

function E () {
  // Keep this empty so it's easier to inherit from
  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}

E.prototype = {
  on: function (name, callback, ctx) {
    var e = this.e || (this.e = {});

    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx: ctx
    });

    return this;
  },

  once: function (name, callback, ctx) {
    var self = this;
    function listener () {
      self.off(name, listener);
      callback.apply(ctx, arguments);
    };

    listener._ = callback
    return this.on(name, listener, ctx);
  },

  emit: function (name) {
    var data = [].slice.call(arguments, 1);
    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    var i = 0;
    var len = evtArr.length;

    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data);
    }

    return this;
  },

  off: function (name, callback) {
    var e = this.e || (this.e = {});
    var evts = e[name];
    var liveEvents = [];

    if (evts && callback) {
      for (var i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
          liveEvents.push(evts[i]);
      }
    }

    // Remove event from queue to prevent memory leak
    // Suggested by https://github.com/lazd
    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

    (liveEvents.length)
      ? e[name] = liveEvents
      : delete e[name];

    return this;
  }
};

module.exports = E;
module.exports.TinyEmitter = E;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var is = __webpack_require__(233);
var delegate = __webpack_require__(234);

/**
 * Validates all params and calls the right
 * listener function based on its target type.
 *
 * @param {String|HTMLElement|HTMLCollection|NodeList} target
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listen(target, type, callback) {
    if (!target && !type && !callback) {
        throw new Error('Missing required arguments');
    }

    if (!is.string(type)) {
        throw new TypeError('Second argument must be a String');
    }

    if (!is.fn(callback)) {
        throw new TypeError('Third argument must be a Function');
    }

    if (is.node(target)) {
        return listenNode(target, type, callback);
    }
    else if (is.nodeList(target)) {
        return listenNodeList(target, type, callback);
    }
    else if (is.string(target)) {
        return listenSelector(target, type, callback);
    }
    else {
        throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
    }
}

/**
 * Adds an event listener to a HTML element
 * and returns a remove listener function.
 *
 * @param {HTMLElement} node
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNode(node, type, callback) {
    node.addEventListener(type, callback);

    return {
        destroy: function() {
            node.removeEventListener(type, callback);
        }
    }
}

/**
 * Add an event listener to a list of HTML elements
 * and returns a remove listener function.
 *
 * @param {NodeList|HTMLCollection} nodeList
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNodeList(nodeList, type, callback) {
    Array.prototype.forEach.call(nodeList, function(node) {
        node.addEventListener(type, callback);
    });

    return {
        destroy: function() {
            Array.prototype.forEach.call(nodeList, function(node) {
                node.removeEventListener(type, callback);
            });
        }
    }
}

/**
 * Add an event listener to a selector
 * and returns a remove listener function.
 *
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenSelector(selector, type, callback) {
    return delegate(document.body, selector, type, callback);
}

module.exports = listen;


/***/ }),
/* 233 */
/***/ (function(module, exports) {

/**
 * Check if argument is a HTML element.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.node = function(value) {
    return value !== undefined
        && value instanceof HTMLElement
        && value.nodeType === 1;
};

/**
 * Check if argument is a list of HTML elements.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.nodeList = function(value) {
    var type = Object.prototype.toString.call(value);

    return value !== undefined
        && (type === '[object NodeList]' || type === '[object HTMLCollection]')
        && ('length' in value)
        && (value.length === 0 || exports.node(value[0]));
};

/**
 * Check if argument is a string.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.string = function(value) {
    return typeof value === 'string'
        || value instanceof String;
};

/**
 * Check if argument is a function.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.fn = function(value) {
    var type = Object.prototype.toString.call(value);

    return type === '[object Function]';
};


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

var closest = __webpack_require__(235);

/**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function _delegate(element, selector, type, callback, useCapture) {
    var listenerFn = listener.apply(this, arguments);

    element.addEventListener(type, listenerFn, useCapture);

    return {
        destroy: function() {
            element.removeEventListener(type, listenerFn, useCapture);
        }
    }
}

/**
 * Delegates event to a selector.
 *
 * @param {Element|String|Array} [elements]
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function delegate(elements, selector, type, callback, useCapture) {
    // Handle the regular Element usage
    if (typeof elements.addEventListener === 'function') {
        return _delegate.apply(null, arguments);
    }

    // Handle Element-less usage, it defaults to global delegation
    if (typeof type === 'function') {
        // Use `document` as the first parameter, then apply arguments
        // This is a short way to .unshift `arguments` without running into deoptimizations
        return _delegate.bind(null, document).apply(null, arguments);
    }

    // Handle Selector-based usage
    if (typeof elements === 'string') {
        elements = document.querySelectorAll(elements);
    }

    // Handle Array-like based usage
    return Array.prototype.map.call(elements, function (element) {
        return _delegate(element, selector, type, callback, useCapture);
    });
}

/**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */
function listener(element, selector, type, callback) {
    return function(e) {
        e.delegateTarget = closest(e.target, selector);

        if (e.delegateTarget) {
            callback.call(element, e);
        }
    }
}

module.exports = delegate;


/***/ }),
/* 235 */
/***/ (function(module, exports) {

var DOCUMENT_NODE_TYPE = 9;

/**
 * A polyfill for Element.matches()
 */
if (typeof Element !== 'undefined' && !Element.prototype.matches) {
    var proto = Element.prototype;

    proto.matches = proto.matchesSelector ||
                    proto.mozMatchesSelector ||
                    proto.msMatchesSelector ||
                    proto.oMatchesSelector ||
                    proto.webkitMatchesSelector;
}

/**
 * Finds the closest parent that matches a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @return {Function}
 */
function closest (element, selector) {
    while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
        if (typeof element.matches === 'function' &&
            element.matches(selector)) {
          return element;
        }
        element = element.parentNode;
    }
}

module.exports = closest;


/***/ }),
/* 236 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = Step3;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _config = __webpack_require__(35);

__webpack_require__(238);

var _gaConfig = __webpack_require__(50);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Step3(props) {
    GA.add(_gaConfig.enterCreateStepThree);
    var _props$onCreateMore = props.onCreateMore,
        onCreateMore = _props$onCreateMore === undefined ? function () {
        console.log('onCreateMore');
    } : _props$onCreateMore,
        _props$onCheckRevenue = props.onCheckRevenue,
        onCheckRevenue = _props$onCheckRevenue === undefined ? function () {
        console.log('onCheckRevenue');
    } : _props$onCheckRevenue;


    var createMore = function createMore() {
        GA.add(_gaConfig.createStepThreeCreateNew);
        onCreateMore();
    };

    var revenueClick = function revenueClick() {
        GA.add(_gaConfig.createStepThreeRevenue);
        onCheckRevenue();
    };

    var goToUrl = function goToUrl(url) {
        return function () {
            switch (url) {
                case _config.urls.youtube:
                    GA.add(_gaConfig.createStepThreeYoutube);
                    break;
                case _config.urls.instagram:
                    GA.add(_gaConfig.createStepThreeInstagram);
                    break;
                case _config.urls.facebook:
                    GA.add(_gaConfig.createStepThreeFacebook);
                    break;
                default:
                    break;
            }
            location.href = url;
        };
    };

    return _react2.default.createElement(
        'div',
        { className: 'ci-step3' },
        _react2.default.createElement(
            'div',
            { className: 'ci3-vendor' },
            _react2.default.createElement(
                'div',
                { id: 'ci3-youtube', onClick: goToUrl(_config.urls.youtube) },
                'Youtube'
            ),
            _react2.default.createElement(
                'div',
                { id: 'ci3-instagram', onClick: goToUrl(_config.urls.instagram) },
                'Instagram'
            ),
            _react2.default.createElement(
                'div',
                { id: 'ci3-facebook', onClick: goToUrl(_config.urls.facebook) },
                'Facebook'
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'ci3-buttons text-center' },
            _react2.default.createElement(
                'button',
                { type: 'button', className: 'btn-cus btn-lg', onClick: createMore },
                UG.lang.template('Create more dashboards')
            ),
            _react2.default.createElement(
                'button',
                { type: 'button', className: 'btn-cus btn-lg', onClick: revenueClick },
                UG.lang.template('Check revenue')
            )
        )
    );
}

/***/ }),
/* 238 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 239 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "Gift",
    "messages": [{
        "name": "ItemGiftList",
        "fields": [],
        "options": {
            "objc_class_prefix": "GiftItemGiftList",
            "java_package": "com.asiainno.uplive.proto.gift"
        },
        "messages": [{
            "name": "GiftItemGiftList",
            "fields": [{
                "rule": "optional",
                "type": "int32",
                "name": "giftId",
                "id": 1
            }, {
                "rule": "optional",
                "type": "string",
                "name": "name",
                "id": 2
            }, {
                "rule": "optional",
                "type": "string",
                "name": "intro",
                "id": 3
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "type",
                "id": 4
            }, {
                "rule": "optional",
                "type": "string",
                "name": "url",
                "id": 5
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "price",
                "id": 6
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "experience",
                "id": 7
            }, {
                "rule": "optional",
                "type": "bool",
                "name": "canCombo",
                "id": 8
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "version",
                "id": 9
            }, {
                "rule": "optional",
                "type": "bool",
                "name": "onLined",
                "id": 10
            }, {
                "rule": "optional",
                "type": "string",
                "name": "countryCode",
                "id": 11
            }, {
                "rule": "optional",
                "type": "string",
                "name": "language",
                "id": 12
            }, {
                "rule": "optional",
                "type": "bool",
                "name": "needLoad",
                "id": 13
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "showType",
                "id": 14
            }, {
                "rule": "repeated",
                "type": "GiftResourceInfo",
                "name": "resources",
                "id": 15
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "vipGrade",
                "id": 16
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "playTimes",
                "id": 17
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "produceType",
                "id": 18
            }, {
                "rule": "optional",
                "type": "bool",
                "name": "canSendToAllUsers",
                "id": 19
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "timeLimit",
                "id": 20
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "hostBill",
                "id": 21
            }, {
                "rule": "optional",
                "type": "string",
                "name": "gtoPrice",
                "id": 22
            }]
        }, {
            "name": "GiftResourceInfo",
            "fields": [{
                "rule": "optional",
                "type": "int32",
                "name": "type",
                "id": 1
            }, {
                "rule": "optional",
                "type": "string",
                "name": "url",
                "id": 2
            }, {
                "rule": "optional",
                "type": "string",
                "name": "md5",
                "id": 3
            }, {
                "rule": "optional",
                "type": "string",
                "name": "json",
                "id": 4
            }]
        }]
    }, {
        "name": "ItemAdd",
        "fields": [],
        "options": {
            "objc_class_prefix": "GiftItemAdd",
            "java_package": "com.asiainno.uplive.proto.gift"
        },
        "messages": [{
            "name": "Request",
            "fields": [{
                "rule": "optional",
                "type": "string",
                "name": "itemName",
                "id": 1
            }, {
                "rule": "optional",
                "type": "string",
                "name": "itemDesc",
                "id": 2
            }, {
                "rule": "repeated",
                "type": "ItemGiftList.GiftItemGiftList",
                "name": "giftList",
                "id": 3
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "itemType",
                "id": 4
            }]
        }, {
            "name": "Response",
            "fields": [{
                "rule": "optional",
                "type": "int64",
                "name": "itemId",
                "id": 1
            }]
        }]
    }]
}).build();
exports.default = _root;

/***/ }),
/* 240 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "Gift",
    "messages": [{
        "name": "ItemGiftList",
        "fields": [],
        "options": {
            "objc_class_prefix": "GiftItemGiftList",
            "java_package": "com.asiainno.uplive.proto.gift"
        },
        "messages": [{
            "name": "GiftItemGiftList",
            "fields": [{
                "rule": "optional",
                "type": "int32",
                "name": "giftId",
                "id": 1
            }, {
                "rule": "optional",
                "type": "string",
                "name": "name",
                "id": 2
            }, {
                "rule": "optional",
                "type": "string",
                "name": "intro",
                "id": 3
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "type",
                "id": 4
            }, {
                "rule": "optional",
                "type": "string",
                "name": "url",
                "id": 5
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "price",
                "id": 6
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "experience",
                "id": 7
            }, {
                "rule": "optional",
                "type": "bool",
                "name": "canCombo",
                "id": 8
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "version",
                "id": 9
            }, {
                "rule": "optional",
                "type": "bool",
                "name": "onLined",
                "id": 10
            }, {
                "rule": "optional",
                "type": "string",
                "name": "countryCode",
                "id": 11
            }, {
                "rule": "optional",
                "type": "string",
                "name": "language",
                "id": 12
            }, {
                "rule": "optional",
                "type": "bool",
                "name": "needLoad",
                "id": 13
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "showType",
                "id": 14
            }, {
                "rule": "repeated",
                "type": "GiftResourceInfo",
                "name": "resources",
                "id": 15
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "vipGrade",
                "id": 16
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "playTimes",
                "id": 17
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "produceType",
                "id": 18
            }, {
                "rule": "optional",
                "type": "bool",
                "name": "canSendToAllUsers",
                "id": 19
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "timeLimit",
                "id": 20
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "hostBill",
                "id": 21
            }, {
                "rule": "optional",
                "type": "string",
                "name": "gtoPrice",
                "id": 22
            }]
        }, {
            "name": "GiftResourceInfo",
            "fields": [{
                "rule": "optional",
                "type": "int32",
                "name": "type",
                "id": 1
            }, {
                "rule": "optional",
                "type": "string",
                "name": "url",
                "id": 2
            }, {
                "rule": "optional",
                "type": "string",
                "name": "md5",
                "id": 3
            }, {
                "rule": "optional",
                "type": "string",
                "name": "json",
                "id": 4
            }]
        }]
    }, {
        "name": "ItemEdit",
        "fields": [],
        "options": {
            "objc_class_prefix": "GiftItemEdit",
            "java_package": "com.asiainno.uplive.proto.gift"
        },
        "messages": [{
            "name": "Request",
            "fields": [{
                "rule": "optional",
                "type": "int64",
                "name": "itemId",
                "id": 1
            }, {
                "rule": "optional",
                "type": "string",
                "name": "itemName",
                "id": 2
            }, {
                "rule": "optional",
                "type": "string",
                "name": "itemDesc",
                "id": 3
            }, {
                "rule": "repeated",
                "type": "ItemGiftList.GiftItemGiftList",
                "name": "giftList",
                "id": 4
            }]
        }, {
            "name": "Response",
            "fields": []
        }]
    }]
}).build();
exports.default = _root;

/***/ }),
/* 241 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // 支付宝的跳转中间页面


var AlipayRedirect = function (_React$Component) {
    _inherits(AlipayRedirect, _React$Component);

    function AlipayRedirect() {
        _classCallCheck(this, AlipayRedirect);

        return _possibleConstructorReturn(this, (AlipayRedirect.__proto__ || Object.getPrototypeOf(AlipayRedirect)).apply(this, arguments));
    }

    _createClass(AlipayRedirect, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            // window.open('', '_self').close();
            location.replace(this.props.location.query.redirectUrl);
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement('div', null);
        }
    }]);

    return AlipayRedirect;
}(_react2.default.Component);

exports.default = AlipayRedirect;

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _cUrl = __webpack_require__(1);

var _cUrl2 = _interopRequireDefault(_cUrl);

__webpack_require__(244);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // 支付宝的跳转中间页面


var WxpayRedirect = function (_React$Component) {
    _inherits(WxpayRedirect, _React$Component);

    function WxpayRedirect(props) {
        _classCallCheck(this, WxpayRedirect);

        var _this = _possibleConstructorReturn(this, (WxpayRedirect.__proto__ || Object.getPrototypeOf(WxpayRedirect)).call(this, props));

        _this.state = {
            message: ''
        };
        return _this;
    }

    _createClass(WxpayRedirect, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var tradeStatus = _cUrl2.default.query('tradeStatus');
            var message = '';

            switch (tradeStatus) {
                case 'A00I':
                    message = UG.lang.template('Payment cancelled.');
                    break;
                case 'A001':
                    // 订单支付成功
                    message = UG.lang.template('Payment has been processed.');
                    break;
                default:
                    message = UG.lang.template('Payment failed.');
            }
            this.setState({ message: message });
        }
    }, {
        key: 'goBack',
        value: function goBack() {
            var url = UG.cache.getCache('wxRechargeRedirect');
            UG.cache.removeCache('wxRechargeRedirect');
            if (url) {
                location.replace(url);
            } else {
                location.replace('/gift.html');
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var message = this.state.message;

            return _react2.default.createElement(
                'div',
                { className: 'wechat-redirect' },
                _react2.default.createElement('img', { src: 'http://h.cdn.pengpengla.com/up/uplive/6.0.7/assets/9ff9ad36c846893c14ac9748358527ff.png' }),
                _react2.default.createElement(
                    'div',
                    null,
                    message
                ),
                _react2.default.createElement(
                    'button',
                    { type: 'button', className: 'btn-cus btn-lg', onClick: this.goBack },
                    UG.lang.template('Confirm')
                )
            );
        }
    }]);

    return WxpayRedirect;
}(_react2.default.Component);

exports.default = WxpayRedirect;

/***/ }),
/* 244 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.asyncComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * 异步加载模块
 * @param loadComponent
 */
var asyncComponent = exports.asyncComponent = function asyncComponent(loadComponent) {
    return function (_React$Component) {
        _inherits(AsyncComponent, _React$Component);

        function AsyncComponent(props) {
            _classCallCheck(this, AsyncComponent);

            var _this = _possibleConstructorReturn(this, (AsyncComponent.__proto__ || Object.getPrototypeOf(AsyncComponent)).call(this, props));

            _this.state = {
                Component: null
            };
            return _this;
        }

        _createClass(AsyncComponent, [{
            key: 'componentWillMount',
            value: function componentWillMount() {
                var _this2 = this;

                if (this.hasLoadedComponent()) {
                    return;
                }

                loadComponent()
                //  取到module的default作为组件，因为我们导出组件的时候使用的是 export default
                //  export default = (const default = Module ; export default )  所以导出的名称是default
                .then(function (module) {
                    return module.default;
                }).then(function (Component) {
                    // 授权处理
                    _this2.setState({ Component: Component });
                }).catch(function (err) {
                    console.error('Cannot load component in <AsyncComponent />');
                    throw err;
                });
            }
        }, {
            key: 'hasLoadedComponent',
            value: function hasLoadedComponent() {
                return this.state.Component !== null;
            }
        }, {
            key: 'render',
            value: function render() {
                var Component = this.state.Component;

                return Component ? _react2.default.createElement(Component, this.props) : null;
            }
        }]);

        return AsyncComponent;
    }(_react2.default.Component);
};

/***/ }),
/* 246 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": null,
    "options": {
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [{
        "name": "UserBalanceInfo",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "inBill",
            "id": 1
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "outDiamond",
            "id": 2
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "bill",
            "id": 3
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "diamond",
            "id": 4
        }]
    }, {
        "name": "ProfileInfo",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "uid",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "username",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "upliveCode",
            "id": 3
        }, {
            "rule": "optional",
            "type": "string",
            "name": "avatar",
            "id": 4
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "gender",
            "id": 5
        }, {
            "rule": "optional",
            "type": "string",
            "name": "setting",
            "id": 6
        }, {
            "rule": "optional",
            "type": "string",
            "name": "password",
            "id": 7
        }, {
            "rule": "optional",
            "type": "string",
            "name": "userToken",
            "id": 8
        }, {
            "rule": "optional",
            "type": "string",
            "name": "signature",
            "id": 9
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "grade",
            "id": 10
        }, {
            "rule": "optional",
            "type": "string",
            "name": "location",
            "id": 11
        }, {
            "rule": "optional",
            "type": "string",
            "name": "mobilePhone",
            "id": 12
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "fanTotal",
            "id": 13
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "followTotal",
            "id": 14
        }, {
            "rule": "optional",
            "type": "UserBalanceInfo",
            "name": "balance",
            "id": 15
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "chatroomid",
            "id": 16
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "followType",
            "id": 17
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "exp",
            "id": 18
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "currentExp",
            "id": 19
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "nextExp",
            "id": 20
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "officialAuth",
            "id": 21
        }, {
            "rule": "optional",
            "type": "string",
            "name": "officialAuthContent",
            "id": 22
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "qualityAuth",
            "id": 23
        }, {
            "rule": "optional",
            "type": "string",
            "name": "countryCode",
            "id": 25
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "admin",
            "id": 26
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "userRealNameAuth",
            "id": 27
        }, {
            "rule": "optional",
            "type": "string",
            "name": "acceptAgreement",
            "id": 28
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "upliveCodeStatus",
            "id": 29
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "subscribe",
            "id": 30
        }, {
            "rule": "repeated",
            "type": "Source",
            "name": "sources",
            "id": 31
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "dynamicCount",
            "id": 32
        }]
    }, {
        "name": "Source",
        "fields": [{
            "rule": "optional",
            "type": "int32",
            "name": "bindType",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "openId",
            "id": 2
        }]
    }, {
        "name": "Visitor",
        "fields": [],
        "messages": [{
            "name": "RegisterH5",
            "fields": [],
            "options": {
                "objc_class_prefix": "VisitorRegisterH5",
                "java_package": "com.asiainno.uplive.proto"
            },
            "messages": [{
                "name": "Request",
                "fields": [{
                    "rule": "optional",
                    "type": "string",
                    "name": "location",
                    "id": 1
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "countryCode",
                    "id": 2
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "selectLanguage",
                    "id": 3
                }, {
                    "rule": "optional",
                    "type": "BindType",
                    "name": "source",
                    "id": 4
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "deviceId",
                    "id": 5
                }]
            }, {
                "name": "Response",
                "fields": [{
                    "rule": "optional",
                    "type": "ProfileInfo",
                    "name": "profile",
                    "id": 1
                }, {
                    "rule": "optional",
                    "type": "int64",
                    "name": "watchTime",
                    "id": 2
                }]
            }]
        }]
    }],
    "enums": [{
        "name": "BindType",
        "values": [{
            "name": "DEFAULT_TYPE",
            "id": 0
        }, {
            "name": "MOBILE_PHONE",
            "id": 1
        }, {
            "name": "QQ",
            "id": 2
        }, {
            "name": "WEIXIN",
            "id": 3
        }, {
            "name": "FACEBOOK",
            "id": 4
        }, {
            "name": "SINA_WEIBO",
            "id": 5
        }, {
            "name": "RR",
            "id": 6
        }, {
            "name": "TENCENT_WANBA",
            "id": 7
        }, {
            "name": "KECHENGGEZI",
            "id": 8
        }, {
            "name": "DEVICE",
            "id": 9
        }, {
            "name": "GOOGLE",
            "id": 15
        }, {
            "name": "TWITTER",
            "id": 16
        }, {
            "name": "EMAIL",
            "id": 17
        }]
    }, {
        "name": "PushType",
        "values": [{
            "name": "DEFAULT_PUSHTYPE",
            "id": 0
        }, {
            "name": "BAIDU",
            "id": 1
        }, {
            "name": "IOS",
            "id": 2
        }, {
            "name": "JPUSH",
            "id": 3
        }, {
            "name": "XIAOMI",
            "id": 4
        }, {
            "name": "GETUI",
            "id": 5
        }, {
            "name": "GOOGLE_PUSH",
            "id": 6
        }, {
            "name": "SAMSUNG",
            "id": 7
        }, {
            "name": "MEIZU",
            "id": 8
        }, {
            "name": "HUAWEI",
            "id": 9
        }, {
            "name": "GOOGLE_FCM",
            "id": 10
        }]
    }]
}).build();

exports.default = _root;

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isLogined = exports.loginInit = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(42);

var _cUpNative = __webpack_require__(21);

var _cUpNative2 = _interopRequireDefault(_cUpNative);

var _visitor = __webpack_require__(140);

var _visitor2 = _interopRequireDefault(_visitor);

var _profile = __webpack_require__(99);

var _profile2 = _interopRequireDefault(_profile);

var _sm = __webpack_require__(248);

var _sm2 = _interopRequireDefault(_sm);

var _config = __webpack_require__(35);

var _giftitemlist = __webpack_require__(139);

var _giftitemlist2 = _interopRequireDefault(_giftitemlist);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_sm2.default.init();

// window.addEventListener('message', function (e) {
//     console.log(e);
// });
var getProjectList = (0, _config.giftService)('/gift/item/list', _giftitemlist2.default.Gift.ItemList);

function registerVistor(cb) {
    _visitor2.default.register().then(function (data) {
        UG.cache.setCache('user', {
            uid: longToString(data.uid),
            userToken: data.userToken,
            subscribe: data.subscribe,
            isVisitor: true
        });
        //  在GIFTO里面需要判断是不是登录状态的
        cb();
    });
}

function bindIm() {
    if (window.imBound) {
        return;
    }
    // 注释不可省略，否则不能显示文件名称
    __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 258)).then(function (module) {
        var notice = function notice() {
            $.channel.emit('newMessageReceive');
        };
        window.imcommon = module.default;
        window.imcommon.im.on('message', notice);
        window.imBound = true;
        setTimeout(notice, 1000);
    }).catch(function (err) {
        console.log(err);
    });
}

function loginInit(App, NoPermission) {
    var goHome = function goHome() {
        getProjectList({ pageSize: 1, pageNum: 1, itemType: 2 }).then(function (_ref) {
            var itemInfos = _ref.itemInfos,
                totalItem = _ref.totalItem;

            if (itemInfos && itemInfos.length > 0) {
                UG.router.replace('/');
            } else {
                UG.router.replace('/createitem/1');
            }
        }).catch(function () {
            UG.router.replace('/createitem/1');
        });
    };
    // 获取数美deviceid是应用初始化的前置条件
    _sm2.default.getSMDeviceId().done(function () {
        var appMain = function appMain(msg) {
            // UG.getLoginUserProfile((msg) => {
            // 获取当前用户成功回调
            UG.loginUserInfo = msg;

            if (!UG.isVistor()) {
                // 绑定IM
                bindIm();

                var beforeLoginHash = UG.cache.getCache('beforeLoginHash');

                // 除了送礼页面过来的，其他的全部跳转到项目列表页面
                if (beforeLoginHash) {

                    // 先删除在说吧
                    UG.cache.removeCache('beforeLoginHash');

                    if (beforeLoginHash === '#/gift') {
                        location.hash = beforeLoginHash;
                    } else {
                        // 检查一下用户有没有创建项目
                        goHome();
                    }
                } else if (location.hash === '#/login') {
                    // 检查一下用户有没有创建项目
                    goHome();
                }
            }

            if (UG.isUplive) {
                if (['HK', 'TW', 'WF', 'KR'].indexOf(msg.countryCode) !== -1) {
                    (0, _reactDom.render)(_react2.default.createElement(App, null), $('#wrap')[0]);
                } else {
                    (0, _reactDom.render)(_react2.default.createElement(NoPermission, null), $('#wrap')[0]);
                }
            } else {
                (0, _reactDom.render)(_react2.default.createElement(App, null), $('#wrap')[0]);
            }
        };
        //  如果是Uplive，直接通过协议取userToken等信息
        if (UG.isUplive) {
            return _cUpNative2.default.getConfigs({
                complete: function complete(data) {
                    UG.cache.setCache('user', {
                        uid: data.uid,
                        subscribe: 0,
                        userToken: data.usertoken,
                        isVisitor: false
                    }, 8 * 3600 * 1000);
                    // 开始获取数据，并开始渲染页面了
                    _profile2.default.getUserInfoByIdAndToken(data.uid, data.usertoken).then(appMain).catch(function (err) {
                        return console.log(err);
                    });
                }
            });
        } else {
            // 这些页面是访客可以访问的
            var isLoginUrl = location.hash === '#/login';
            var isAllowUrl = /\/(profile|gift|land|giftshow)\/?/.test(location.hash);
            var isVistor = UG.isVistor();
            // todo
            _profile2.default.isValidUser(UG.getUser()).then(function (userInfo) {
                // 成功获取到了信息
                if (userInfo) {
                    if (isVistor && isAllowUrl) {
                        (0, _reactDom.render)(_react2.default.createElement(App, null), $('#wrap')[0]);
                    } else if (isVistor) {
                        UG.router.push('/login');
                        (0, _reactDom.render)(_react2.default.createElement(App, null), $('#wrap')[0]);
                    } else {
                        if (isLoginUrl) {
                            UG.router.replace('/');
                        }
                        appMain(userInfo);
                    }
                } else {
                    // 没有登录
                    // 先注册一个访客，保证接口是可以访问的
                    registerVistor(function () {
                        //  在GIFTO里面需要判断是不是登录状态的
                        if (isAllowUrl) {
                            (0, _reactDom.render)(_react2.default.createElement(App, null), $('#wrap')[0]);
                        } else {
                            if (!isLoginUrl) {
                                UG.router.push('/login');
                            }
                            (0, _reactDom.render)(_react2.default.createElement(App, null), $('#wrap')[0]);
                        }
                    });
                }
            });
        }

        UpSDK.on('getUserSuccess', function (data) {
            // 有isVisitor说明是取到的系统的缓存
            console.log('授权成功了', data);
            UG.cache.setCache('user', {
                uid: data.uid,
                userToken: data.userToken,
                subscribe: data.subscribe,
                isVisitor: false
            });
            // 加载数据并渲染页面
            _profile2.default.getUserInfoByIdAndToken(data.uid, data.userToken).then(appMain);
        });

        window.onpageshow = function (event) {
            if (event.persisted) {
                window.location.reload();
            }
        };
    });
}

function isLogined() {
    return !UG.isVistor() || UG.isUplive;
}

exports.loginInit = loginInit;
exports.isLogined = isLogined;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _events = __webpack_require__(249);

var _events2 = _interopRequireDefault(_events);

var _cCache = __webpack_require__(10);

var _cCache2 = _interopRequireDefault(_cCache);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 数美防刷
var cache = new _cCache2.default({
    prefix: 'ug'
});

var SM = Object.assign({
    init: function init() {
        var hostname = location.hostname;
        var apiHost = 'fp.fengkongcloud.com';
        if (hostname == 'm.upliveapps.com') {
            apiHost = 'fp-xjp.fengkongcloud.com';
        }
        (function () {
            window._smConf = {
                organization: '3kHDvmQMHMyhMkWHki4D', //需要修改为业务 organization
                staticHost: 'static.fengkongcloud.com',
                apiHost: apiHost
            };
            var sm = document.createElement("script");
            sm.src = ('https:' === document.location.protocol ? 'https:' : 'http:') + '//' + _smConf.staticHost + '/fpv2.js';
            var s = document.getElementsByTagName("script")[0];
            sm.onload = function () {
                $.channel.emit('smsdkLoaded');
            };
            sm.onerror = function () {
                $.channel.emit('smsdkLoadedError');
            };
            s.parentNode.insertBefore(sm, s);
        })();
    },
    getSMDeviceId: function getSMDeviceId() {

        var defer = $.Deferred();
        // 无论是否使用游客，都产生一个smd（数美的deviceId）
        // 并且存储到本地
        var cacheDeviceId = cache.getCache('smDeviceId');

        if (!cacheDeviceId) {

            // 数美JS已经加载完成
            if (typeof SMSdk !== 'undefined') {
                window.smDeviceId = SMSdk.getDeviceId();
                cache.setCache('smDeviceId', window.smDeviceId);
                defer.resolve();
            } else {

                // 否则监听事件，等待sdk加载完成
                $.channel.on('smsdkLoaded', function () {
                    window.smDeviceId = SMSdk.getDeviceId();
                    cache.setCache('smDeviceId', smDeviceId);
                    defer.resolve();
                });

                $.channel.on('smsdkLoadedError', function () {
                    defer.resolve();
                });
            }
        } else {
            window.smDeviceId = cacheDeviceId;
            defer.resolve();
        }

        return defer;
    }
}, _events2.default);

exports.default = SM;

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Event center
 */
(function (global, factory) {

    // amd mode
    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof require === 'function' && (typeof module === 'undefined' ? 'undefined' : _typeof(module)) === "object" && module && module["exports"]) {
        // commonjs mode
        module.exports = factory();
    } else {
        // global mode
        global.events = factory();
    }
})(window, function () {

    var Callbacks = function Callbacks(options) {
        options = $.extend({}, options);

        var memory,
            // Last fire value (for non-forgettable lists)
        _fired,
            // Flag to know if list was already fired
        firing,
            // Flag to know if list is currently firing
        firingStart,
            // First callback to fire (used internally by add and fireWith)
        firingLength,
            // End of the loop when firing
        firingIndex,
            // Index of currently firing callback (modified by remove if needed)
        list = [],
            // Actual callback list
        stack = !options.once && [],
            // Stack of fire calls for repeatable lists
        fire = function fire(data) {
            memory = options.memory && data;
            _fired = true;
            firingIndex = firingStart || 0;
            firingStart = 0;
            firingLength = list.length;
            firing = true;
            for (; list && firingIndex < firingLength; ++firingIndex) {
                if (list[firingIndex].apply(data[0], data[1]) === false && options.stopOnFalse) {
                    memory = false;
                    break;
                }
            }
            firing = false;
            if (list) {
                if (stack) stack.length && fire(stack.shift());else if (memory) list.length = 0;else Callbacks.disable();
            }
        },
            Callbacks = {
            list: list,
            add: function add() {
                if (list) {
                    var start = list.length,
                        add = function add(args) {
                        args = Array.prototype.slice.call(args);
                        args.forEach(function (arg, _) {
                            if (typeof arg === "function") {
                                if (!options.unique || !Callbacks.has(arg)) list.push(arg);
                            } else if (arg && arg.length && typeof arg !== 'string') add(arg);
                        });
                    };
                    add(arguments);
                    if (firing) firingLength = list.length;else if (memory) {
                        firingStart = start;
                        fire(memory);
                    }
                }
                return this;
            },
            remove: function remove() {
                var args = Array.prototype.slice.call(arguments);
                if (list) {
                    args.forEach(function (arg, _) {
                        var index;
                        while ((index = list.indexOf(arg, index)) > -1) {
                            list.splice(index, 1);
                            // Handle firing indexes
                            if (firing) {
                                if (index <= firingLength) --firingLength;
                                if (index <= firingIndex) --firingIndex;
                            }
                        }
                    });
                }
                return this;
            },
            has: function has(fn) {
                return !!(list && (fn ? list.indexOf(fn) > -1 : list.length));
            },
            empty: function empty() {
                firingLength = list.length = 0;
                return this;
            },
            disable: function disable() {
                list = stack = memory = undefined;
                return this;
            },
            disabled: function disabled() {
                return !list;
            },
            lock: function lock() {
                stack = undefined;
                if (!memory) Callbacks.disable();
                return this;
            },
            locked: function locked() {
                return !stack;
            },
            fireWith: function fireWith(context, args) {
                if (list && (!_fired || stack)) {
                    args = args || [];
                    args = [context, args.slice ? args.slice() : args];
                    if (firing) stack.push(args);else fire(args);
                }
                return this;
            },
            fire: function fire() {
                return Callbacks.fireWith(this, arguments);
            },
            fired: function fired() {
                return !!_fired;
            }
        };

        return Callbacks;
    };
    var channelObj = {};

    // 统一事件机制
    var Events = {
        Event: Callbacks,
        /**
         * 添加事件监听
         * @param  {string}   name - 事件名称
         * @param  {function} callback - 事件回调
         */
        on: function on(name, callback) {
            var obj,
                that = this;

            this.events = this.events || {};

            // 逗号隔开，支持多事件
            if (name && name.indexOf(',') != -1) {
                return (name.split(',') || []).forEach(function (item) {
                    if (item) {
                        that.on(item, callback);
                    }
                });
            }

            if (!this.global && name.indexOf('/') != -1) {
                // 频道监听
                if (name.split('/')[0] == 'channel') {
                    return that.channel.on(name.replace(/^channel\//gi, ''), callback);
                }

                obj = getObjectByNames(name, this);
                this.events[name] = this.events[name] || [];
                this.events[name].push(callback);
                return obj ? obj.on(getEventName(name), callback) : this;
            } else {
                obj = this.events[name] || (this.events[name] = this.Event());
            }

            // 如果设置为一起派发，则再次监听时，直接执行
            if (this._alwayEmitSource && this._alwayEmitSource[name]) {
                return callback.apply(name, this._alwayEmitSource[name]);
            }
            obj.add(callback);

            return this;
        },
        /**
         * 移除事件监听
         * @param  {string}   name     事件名称
         * @param  {function} [callback] - 事件回调，为空时，移除所有回调
         */
        off: function off(name, callback) {
            var obj,
                funs,
                that = this;

            this.events = this.events || {};

            // 逗号隔开，支持多事件
            if (name && name.indexOf(',') != -1) {
                return (name.split(',') || []).forEach(function (item) {
                    if (item) {
                        that.off(item, callback);
                    }
                });
            }

            if (!this.global && name && name.indexOf('/') != -1) {
                if (name.split('/')[0] == 'channel') {
                    return that.channel.off(name.replace(/^channel\//gi, ''), callback);
                }

                if (this.events[name]) {
                    obj = getObjectByNames(name, this);
                    if (callback) {
                        return obj ? obj.off(getEventName(name), callback) : this;
                    } else {
                        funs = this.events[name];
                        for (var i = 0; obj && funs && i < funs.length; i++) {
                            obj.off(getEventName(name), funs[i]);
                        }
                        this.events[name] = null;
                    }
                }

                return this;
            }

            if (name && callback && (obj = this.events[name])) {
                obj.remove(callback);
            } else if (name && (obj = this.events[name])) {
                obj.empty();
            } else {

                for (name in this.events) {
                    if (this.events.hasOwnProperty(name) && this.events[name]) {
                        if (!this.global && name.indexOf('/') != -1) {
                            if (name.split('/')[0] == 'channel') {
                                return this.channel.off(name.replace(/^channel\//gi, ''));
                            }
                            this.off(name);
                        } else {
                            this.events[name].empty();
                        }
                    }
                }
            }

            return this;
        },
        ///**
        // * 只监听一次事件
        // * @param name
        // * @param callback
        // */
        //once: function (name, callback) {
        //    var _callback;
        //
        //    this.on(name, _callback = function () {
        //        callback.apply(this, arguments);
        //        this.off(name, _callback);
        //    });
        //},
        /**
         * 默认派发事件
         * @return {object}
         */
        trigger: function trigger() {
            var name = arguments[0],
                obj,
                param,
                that = this;

            this.events = this.events || {};
            param = Array.prototype.slice.call(arguments, 1);

            // 逗号隔开，支持多事件
            if (name && name.indexOf(',') != -1) {
                return (name.split(',') || []).forEach(function (item) {
                    if (item) {
                        that.trigger.apply(this, [item].concat(param));
                    }
                });
            }

            if (!this.global && name && name.indexOf('/') != -1) {
                if (name.split('/')[0] == 'channel') {
                    return that.channel.trigger.apply(that.channel, [name.replace(/^channel\//gi, '')].concat(param));
                }
                obj = getObjectByNames(name, this);
                name = getEventName(name);
                return obj ? obj.trigger.apply(obj, [name].concat(param)) : this;
            }

            if (name && (obj = this.events[name])) {
                obj.fire.apply(this, [].concat(param));
            }

            return {
                event: obj,
                always: function always() {
                    that._alwayEmitSource = that._alwayEmitSource || {};
                    that._alwayEmitSource[name] = [].concat(param);
                }
            };
        },
        /**
         * 派发事件
         * @example
         *        this.emit('ready',args0,args1...);
         */
        emit: function emit() {
            return this.trigger.apply(this, arguments);
        }
    };

    /**
     * 获取context下的name属性
     * @private
     */
    function getObjectByNames(name, context) {
        var that, names, len;

        context = context || {};
        that = context;
        names = name.split('/');
        len = names.length;

        for (var i = 0; len > 1 && i < len - 1; i++) {
            if (that && that[names[i]]) {
                that = that[names[i]];
            } else {
                that = null;
            }
        }

        return that;
    }

    /**
     * 获取事件名称
     * @param  {String} name [description]
     * @return {String}
     */
    function getEventName(name) {
        var names = name.split('/');
        return names[names.length - 1];
    }

    // global single Event
    Events.channel = $.channel || ($.channel = $.extend(channelObj, Events));
    Events.channel.global = Events.channel;

    return Events;
});

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// gifto.js